const countriesAndCities = [
	{
		value: 'Afghanistan',
		label: 'Afghanistan',
		type: 'country',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Kabul',
		label: 'Kabul, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Achin',
		label: 'Achin, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: '´Ali Khayl',
		label: '´Ali Khayl, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qandahar',
		label: 'Qandahar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Mazar-e Sharif',
		label: 'Mazar-e Sharif, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Balkh',
		label: 'Balkh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Anar Darreh',
		label: 'Anar Darreh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Asha',
		label: 'Asha, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Baghrami',
		label: 'Baghrami, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Asmar',
		label: 'Asmar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Jalalabad',
		label: 'Jalalabad, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Chahar Burjak',
		label: 'Chahar Burjak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Baghran',
		label: 'Baghran, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qal´eh-ye Panjeh',
		label: 'Qal´eh-ye Panjeh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Aybak',
		label: 'Aybak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Charikar',
		label: 'Charikar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Herat',
		label: 'Herat, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Mehtar Lam',
		label: 'Mehtar Lam, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Baglan',
		label: 'Baglan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Bamiyan',
		label: 'Bamiyan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Kuhestan',
		label: 'Kuhestan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Baraki Barak',
		label: 'Baraki Barak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Chiras',
		label: 'Chiras, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tir Pol',
		label: 'Tir Pol, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Nuristan',
		label: 'Nuristan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Karukh',
		label: 'Karukh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Zendejan',
		label: 'Zendejan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Andarab',
		label: 'Andarab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Mahmud-e Raqi',
		label: 'Mahmud-e Raqi, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qarabagh',
		label: 'Qarabagh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tagaw Bay',
		label: 'Tagaw Bay, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Bala Morghab',
		label: 'Bala Morghab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Azraw',
		label: 'Azraw, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tawraghudi',
		label: 'Tawraghudi, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Batsawul',
		label: 'Batsawul, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qarqin',
		label: 'Qarqin, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Dasht-e Archa',
		label: 'Dasht-e Archa, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Eshkamesh',
		label: 'Eshkamesh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Faizabad',
		label: 'Faizabad, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qal´eh-ye Naw',
		label: 'Qal´eh-ye Naw, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qunduz',
		label: 'Qunduz, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Ghardez',
		label: 'Ghardez, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Chaghcharan',
		label: 'Chaghcharan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Khanabad',
		label: 'Khanabad, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Maymanah',
		label: 'Maymanah, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Pol-e Khumri',
		label: 'Pol-e Khumri, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Kholm',
		label: 'Kholm, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Gazni',
		label: 'Gazni, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Shibarghan',
		label: 'Shibarghan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Paghman',
		label: 'Paghman, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Farah',
		label: 'Farah, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Andkhvoy',
		label: 'Andkhvoy, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Lashkar Gah',
		label: 'Lashkar Gah, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Maydanshahr',
		label: 'Maydanshahr, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Taloqan',
		label: 'Taloqan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qalat-e Ghilzay',
		label: 'Qalat-e Ghilzay, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Zaranj',
		label: 'Zaranj, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Hazart Imam',
		label: 'Hazart Imam, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Ghurian',
		label: 'Ghurian, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qal´eh-ye Zal',
		label: 'Qal´eh-ye Zal, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Pol-e Alam',
		label: 'Pol-e Alam, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Sarawbi',
		label: 'Sarawbi, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qil Qal´eh',
		label: 'Qil Qal´eh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Zarghun Shahr',
		label: 'Zarghun Shahr, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Chah Ab',
		label: 'Chah Ab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Nader Shah Kawt',
		label: 'Nader Shah Kawt, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Khawst',
		label: 'Khawst, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Sabzevar',
		label: 'Sabzevar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Chakhansur',
		label: 'Chakhansur, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Qarchi Gak',
		label: 'Qarchi Gak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Aqchah',
		label: 'Aqchah, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Orgun',
		label: 'Orgun, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tarin Kawt',
		label: 'Tarin Kawt, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Khwajeh Ghar',
		label: 'Khwajeh Ghar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Emam Saheb',
		label: 'Emam Saheb, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Khash',
		label: 'Khash, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Mirabad',
		label: 'Mirabad, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Rudbar',
		label: 'Rudbar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Sang-e Charak',
		label: 'Sang-e Charak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Uruzgan',
		label: 'Uruzgan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Marghi',
		label: 'Marghi, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Taywarah',
		label: 'Taywarah, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tokzar',
		label: 'Tokzar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Zareh Sharan',
		label: 'Zareh Sharan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Taghab',
		label: 'Taghab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Jabal-os-Saraj',
		label: 'Jabal-os-Saraj, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Khandud',
		label: 'Khandud, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Sar-e Pul',
		label: 'Sar-e Pul, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Rostaq',
		label: 'Rostaq, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Darwishan',
		label: 'Darwishan, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Shahrak',
		label: 'Shahrak, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Kushk',
		label: 'Kushk, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Gardan Diwal',
		label: 'Gardan Diwal, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Deh Shu',
		label: 'Deh Shu, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Dawlatabad',
		label: 'Dawlatabad, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Eshkashem',
		label: 'Eshkashem, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Sangin',
		label: 'Sangin, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Shulgara',
		label: 'Shulgara, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Awbeh',
		label: 'Awbeh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Lar Gerd',
		label: 'Lar Gerd, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Eslam Qal´eh',
		label: 'Eslam Qal´eh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Gereshk',
		label: 'Gereshk, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Panjab',
		label: 'Panjab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Yangi Qal´eh',
		label: 'Yangi Qal´eh, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Mir Bachchekut',
		label: 'Mir Bachchekut, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Farkhar',
		label: 'Farkhar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Nahrin',
		label: 'Nahrin, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Hugyani',
		label: 'Hugyani, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Gaz Ab',
		label: 'Gaz Ab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Deh Rawud',
		label: 'Deh Rawud, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Tash Gozar',
		label: 'Tash Gozar, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Dahaneh-ye Ghawri',
		label: 'Dahaneh-ye Ghawri, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Darzi Ab',
		label: 'Darzi Ab, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Jurm',
		label: 'Jurm, Afghanistan',
		type: 'city',
		flagClass: 'fi fi-af',
		isPopular: false,
	},
	{
		value: 'Åland Islands',
		label: 'Åland Islands',
		type: 'country',
		flagClass: 'fi fi-ax',
		isPopular: false,
	},
	{
		value: 'Albania',
		label: 'Albania',
		type: 'country',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Germany',
		label: 'Germany',
		type: 'country',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Munich',
		label: 'Munich, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: true,
	},
	{
		value: 'Tiranë',
		label: 'Tiranë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Bajram Curri',
		label: 'Bajram Curri, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Elbasan',
		label: 'Elbasan, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Durrës',
		label: 'Durrës, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Vlorë',
		label: 'Vlorë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Shkodër',
		label: 'Shkodër, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Korçë',
		label: 'Korçë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Fier',
		label: 'Fier, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Sarandë',
		label: 'Sarandë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Bilisht',
		label: 'Bilisht, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Rubik',
		label: 'Rubik, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Klos',
		label: 'Klos, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Berat',
		label: 'Berat, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Krujë',
		label: 'Krujë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Tepelenë',
		label: 'Tepelenë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Ballsh',
		label: 'Ballsh, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Pukë',
		label: 'Pukë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Vorë',
		label: 'Vorë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Leskovik',
		label: 'Leskovik, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Lushnjë',
		label: 'Lushnjë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kavajë',
		label: 'Kavajë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Gjirokastër',
		label: 'Gjirokastër, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kukës',
		label: 'Kukës, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Lezhë',
		label: 'Lezhë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Burrel',
		label: 'Burrel, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Çorovodë',
		label: 'Çorovodë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Shijak',
		label: 'Shijak, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Librazhd',
		label: 'Librazhd, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Gramsh',
		label: 'Gramsh, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Përmet',
		label: 'Përmet, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Memaliaj',
		label: 'Memaliaj, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Rrogozhinë',
		label: 'Rrogozhinë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Urë Vajgurore',
		label: 'Urë Vajgurore, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Himarë',
		label: 'Himarë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Delvinë',
		label: 'Delvinë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Koplik',
		label: 'Koplik, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Maliq',
		label: 'Maliq, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Përrenjas',
		label: 'Përrenjas, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Krumë',
		label: 'Krumë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Libohovë',
		label: 'Libohovë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Orikum',
		label: 'Orikum, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Fushë-Arrëz',
		label: 'Fushë-Arrëz, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Shëngjin',
		label: 'Shëngjin, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Milot',
		label: 'Milot, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Konispol',
		label: 'Konispol, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Këlcyrë',
		label: 'Këlcyrë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Krastë',
		label: 'Krastë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kërrabë',
		label: 'Kërrabë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kurbnesh',
		label: 'Kurbnesh, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Fierzë',
		label: 'Fierzë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Ulzë',
		label: 'Ulzë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Pogradec',
		label: 'Pogradec, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Laç',
		label: 'Laç, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Nuevo Ideal',
		label: 'Nuevo Ideal, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kuçovë',
		label: 'Kuçovë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Dibrë',
		label: 'Dibrë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Cërrik',
		label: 'Cërrik, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Poliçan',
		label: 'Poliçan, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Bulqizë',
		label: 'Bulqizë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Fushë-Krujë',
		label: 'Fushë-Krujë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Kamzë',
		label: 'Kamzë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Mirditë',
		label: 'Mirditë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Mamurras',
		label: 'Mamurras, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Ersekë',
		label: 'Ersekë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Peqin',
		label: 'Peqin, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Selenicë',
		label: 'Selenicë, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Roskovec',
		label: 'Roskovec, Albania',
		type: 'city',
		flagClass: 'fi fi-al',
		isPopular: false,
	},
	{
		value: 'Algeria',
		label: 'Algeria',
		type: 'country',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Jaza´ir',
		label: 'al-Jaza´ir, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: "'Ayn Arnat",
		label: "'Ayn Arnat, Algeria",
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wahran',
		label: 'Wahran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Satif',
		label: 'Satif, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Annabah',
		label: 'Annabah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Biskrah',
		label: 'Biskrah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Abadlah',
		label: '´Abadlah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Batnah',
		label: 'Batnah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tizi Wazu',
		label: 'Tizi Wazu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Jijili',
		label: 'Jijili, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tiyarat',
		label: 'Tiyarat, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Mustaghanam',
		label: 'Mustaghanam, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tilimsan',
		label: 'Tilimsan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ghardayah',
		label: 'Ghardayah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Milah',
		label: 'Milah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Akbu',
		label: 'Akbu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Aris',
		label: '´Aris, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Blidah',
		label: 'Blidah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bijayah',
		label: 'Bijayah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi ban-al-´Abbas',
		label: 'Sidi ban-al-´Abbas, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tibissah',
		label: 'Tibissah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sakikdah',
		label: 'Sakikdah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bab Azwar',
		label: 'Bab Azwar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bir Murad Rais',
		label: 'Bir Murad Rais, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ziralda',
		label: 'Ziralda, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'at-Tarif',
		label: 'at-Tarif, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ghalizan',
		label: 'Ghalizan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Buirah',
		label: 'Buirah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Aghrib',
		label: 'Aghrib, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tighzirt',
		label: 'Tighzirt, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Biya',
		label: '´Ayn Biya, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: "Sayda'",
		label: "Sayda', Algeria",
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Hajirah',
		label: 'al-Hajirah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Didush Murad',
		label: 'Didush Murad, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Aghwat',
		label: 'al-Aghwat, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Bayda',
		label: '´Ayn Bayda, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Khurub',
		label: 'al-Khurub, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Firence',
		label: 'Firence, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: true,
	},
	{
		value: 'Firindah',
		label: 'Firindah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Amjaz Adshish',
		label: 'Amjaz Adshish, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hassi Mas´ud',
		label: 'Hassi Mas´ud, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ramadan Jamal',
		label: 'Ramadan Jamal, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hassi al-Raml',
		label: 'Hassi al-Raml, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ghazawat',
		label: 'Ghazawat, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Hajar',
		label: 'al-Hajar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bughni',
		label: 'Bughni, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Farjiwah',
		label: 'Farjiwah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Mazunah',
		label: 'Mazunah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Dar-al-Bayda',
		label: 'Dar-al-Bayda, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Qustantinah',
		label: 'Qustantinah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Ali',
		label: 'Sidi Ali, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Jilfah',
		label: 'Jilfah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Buni',
		label: 'al-Buni, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Midyah',
		label: 'Midyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Warqla',
		label: 'Warqla, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Khanshalah',
		label: 'Khanshalah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Samara',
		label: '´Ayn Samara, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Wad',
		label: 'al-Wad, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Fil Fila',
		label: 'Fil Fila, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Masilah',
		label: 'Masilah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Tadalas',
		label: '´Ayn Tadalas, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Mars-al-Kabir',
		label: 'Mars-al-Kabir, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Miliyah',
		label: 'al-Miliyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Marad',
		label: 'Bani Marad, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Arba´a',
		label: 'al-Arba´a, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Adrar',
		label: 'Adrar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Mazaghran',
		label: 'Mazaghran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tibazah',
		label: 'Tibazah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bufarik',
		label: 'Bufarik, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Aflu',
		label: 'Aflu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bughar',
		label: 'Bughar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hammam Righa',
		label: 'Hammam Righa, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Malilah',
		label: '´Ayn Malilah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tamanghasat',
		label: 'Tamanghasat, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Birkhadam',
		label: 'Birkhadam, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Arzu',
		label: 'Arzu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Lakhdariyah',
		label: 'Lakhdariyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tisamsilt',
		label: 'Tisamsilt, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Azfun',
		label: 'Azfun, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Qasr Shillalah',
		label: 'Qasr Shillalah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Dariyan',
		label: 'Dariyan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Ansur',
		label: 'al-Ansur, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Winzah',
		label: 'Winzah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Shiragha',
		label: 'Shiragha, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sharshar',
		label: 'Sharshar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hajut',
		label: 'Hajut, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ilizi',
		label: 'Ilizi, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Daflah',
		label: '´Ayn Daflah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Binyan',
		label: '´Ayn Binyan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Saf',
		label: 'Bani Saf, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Matlili',
		label: 'Matlili, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Milyanah',
		label: 'Milyanah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wadi Zinati',
		label: 'Wadi Zinati, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Qal´ah',
		label: 'al-Qal´ah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tajananah',
		label: 'Tajananah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Maklah',
		label: 'Maklah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sibdu',
		label: 'Sibdu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bumardas',
		label: 'Bumardas, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Mansurah',
		label: 'al-Mansurah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bu Nura',
		label: 'Bu Nura, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hassi Bu Nif',
		label: 'Hassi Bu Nif, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Amriyah',
		label: 'al-Amriyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'ar-Ruwibah',
		label: 'ar-Ruwibah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sabra',
		label: 'Sabra, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hammam Dhala´a',
		label: 'Hammam Dhala´a, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Talagh',
		label: 'Talagh, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hamman Awlad ´Ali',
		label: 'Hamman Awlad ´Ali, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Jidiwiyah',
		label: 'Jidiwiyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Karkira',
		label: 'Karkira, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sawlah',
		label: 'Sawlah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Dhahab',
		label: '´Ayn Dhahab, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Naghaus',
		label: 'Naghaus, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Qamar',
		label: 'Qamar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn-al-Hajal',
		label: '´Ayn-al-Hajal, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Madawrush',
		label: 'Madawrush, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Makuda',
		label: 'Makuda, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tinyah',
		label: 'Tinyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Miskyanah',
		label: 'Miskyanah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Shiffa',
		label: 'Shiffa, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Kirshah',
		label: '´Ayn Kirshah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn-al-Milh',
		label: '´Ayn-al-Milh, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Amizur',
		label: 'Amizur, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Fariha',
		label: 'Fariha, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Maghra',
		label: 'Maghra, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Abyad Sidi Shaykh',
		label: 'al-Abyad Sidi Shaykh, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wadhiyah',
		label: 'Wadhiyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Maqran',
		label: 'Maqran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Issar',
		label: 'Issar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Awlad Salam',
		label: 'Awlad Salam, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ban Mahdi',
		label: 'Ban Mahdi, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Tamu',
		label: 'Bani Tamu, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Birin',
		label: 'Birin, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Amran',
		label: 'Sidi Amran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Thizi Natlata',
		label: 'Thizi Natlata, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wadi Sali',
		label: 'Wadi Sali, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Abid',
		label: '´Ayn Abid, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Hassi Halifa',
		label: 'Hassi Halifa, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Shamini',
		label: 'Shamini, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Shillalah',
		label: 'Shillalah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi ash-Shami',
		label: 'Sidi ash-Shami, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Awlad Haddaj',
		label: 'Awlad Haddaj, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Barbasha',
		label: 'Barbasha, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tamalus',
		label: 'Tamalus, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tirmirtin',
		label: 'Tirmirtin, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tinduf',
		label: 'Tinduf, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sa´abat',
		label: 'Sa´abat, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn-al-Khabira',
		label: '´Ayn-al-Khabira, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Ab´adiyah',
		label: 'al-Ab´adiyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tazmalt',
		label: 'Tazmalt, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bu Hanafis',
		label: 'Bu Hanafis, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bu Qadir',
		label: 'Bu Qadir, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Zaribat-al-Wad',
		label: 'Zaribat-al-Wad, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Birrahhal',
		label: 'Birrahhal, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Amran',
		label: 'Bani Amran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bujima',
		label: 'Bujima, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Dar Shiyukh',
		label: 'Dar Shiyukh, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ma´adid',
		label: 'Ma´adid, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Zahana',
		label: 'Zahana, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tadma´it',
		label: 'Tadma´it, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Mastar',
		label: 'Bani Mastar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ruwashad',
		label: 'Ruwashad, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Qazzan',
		label: '´Ayn Qazzan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Salah Bay',
		label: 'Salah Bay, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Marwan',
		label: 'Sidi Marwan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Targhah',
		label: 'Targhah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wadi al-Allagh',
		label: 'Wadi al-Allagh, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Malah',
		label: 'al-Malah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tizi Ghanif',
		label: 'Tizi Ghanif, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Wanugha',
		label: 'Wanugha, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Arba´a Tash',
		label: 'al-Arba´a Tash, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Dabilah',
		label: 'Dabilah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'ash-Shalif',
		label: 'ash-Shalif, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Farrawn',
		label: 'Farrawn, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Rubbah',
		label: 'Rubbah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Maran',
		label: '´Ayn Maran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bashshar',
		label: 'Bashshar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Nasiriyah',
		label: 'Nasiriyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Burj Bu Arririj',
		label: 'Burj Bu Arririj, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sadduk',
		label: 'Sadduk, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Tamasin',
		label: 'Tamasin, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-Ashir',
		label: 'al-Ashir, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Amir ´Abd-al-Qadar',
		label: 'Amir ´Abd-al-Qadar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Suq Ahras',
		label: 'Suq Ahras, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Ammi Mussa',
		label: 'Ammi Mussa, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bu Khanifiyah',
		label: 'Bu Khanifiyah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Ukaskah',
		label: 'Sidi Ukaskah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Qalmah',
		label: 'Qalmah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: "Ra's-al-´Ayun",
		label: "Ra's-al-´Ayun, Algeria",
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'al-´Ulmah',
		label: 'al-´Ulmah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Burj-al-Kiffan',
		label: 'Burj-al-Kiffan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Abu al-Hassan',
		label: 'Abu al-Hassan, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bu Sa´adah',
		label: 'Bu Sa´adah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Bani Sikran',
		label: 'Bani Sikran, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Baraki Barak',
		label: 'Baraki Barak, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Bubkar',
		label: 'Sidi Bubkar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn Wissarah',
		label: '´Ayn Wissarah, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Sidi Muhammad Ban ´Ali',
		label: 'Sidi Muhammad Ban ´Ali, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Umm-al-Bawaghi',
		label: 'Umm-al-Bawaghi, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: '´Ayn-al-Ibil',
		label: '´Ayn-al-Ibil, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Awlad Mussa',
		label: 'Awlad Mussa, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'Muaskar',
		label: 'Muaskar, Algeria',
		type: 'city',
		flagClass: 'fi fi-dz',
		isPopular: false,
	},
	{
		value: 'American Samoa',
		label: 'American Samoa',
		type: 'country',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Afono',
		label: 'Afono, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Pago Pago',
		label: 'Pago Pago, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Tafuna',
		label: 'Tafuna, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Leone',
		label: 'Leone, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Fagasa',
		label: 'Fagasa, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Alao',
		label: 'Alao, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Nu'uuli",
		label: "Nu'uuli, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Ili'ili",
		label: "Ili'ili, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Pava'ia'i",
		label: "Pava'ia'i, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Faleniu',
		label: 'Faleniu, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Aoloau',
		label: 'Aoloau, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Taputimu',
		label: 'Taputimu, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Vatia',
		label: 'Vatia, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Leloaloa',
		label: 'Leloaloa, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Amouli',
		label: 'Amouli, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Aoa',
		label: 'Aoa, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Faga'itua",
		label: "Faga'itua, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Aunu'u",
		label: "Aunu'u, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Tula',
		label: 'Tula, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Aua',
		label: 'Aua, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Fagatogo',
		label: 'Fagatogo, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Mapusagafou',
		label: 'Mapusagafou, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Vaitogi',
		label: 'Vaitogi, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Malaeimi',
		label: 'Malaeimi, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Vailoatai',
		label: 'Vailoatai, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Faga'alu",
		label: "Faga'alu, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Lauli'i",
		label: "Lauli'i, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Futiga',
		label: 'Futiga, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Utulei',
		label: 'Utulei, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Malaeloa-Ituau',
		label: 'Malaeloa-Ituau, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Malaeloa-Aitulagi',
		label: 'Malaeloa-Aitulagi, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Mesepa',
		label: 'Mesepa, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Alofau',
		label: 'Alofau, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: "Atu'u",
		label: "Atu'u, American Samoa",
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Ofu',
		label: 'Ofu, American Samoa',
		type: 'city',
		flagClass: 'fi fi-as',
		isPopular: false,
	},
	{
		value: 'Andorra',
		label: 'Andorra',
		type: 'country',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Andorra la Vella',
		label: 'Andorra la Vella, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Les Escaldes',
		label: 'Les Escaldes, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Canillo',
		label: 'Canillo, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Encamp',
		label: 'Encamp, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Sant Julià de Lòria',
		label: 'Sant Julià de Lòria, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'La Massana',
		label: 'La Massana, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Ordino',
		label: 'Ordino, Andorra',
		type: 'city',
		flagClass: 'fi fi-ad',
		isPopular: false,
	},
	{
		value: 'Angola',
		label: 'Angola',
		type: 'country',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Luanda',
		label: 'Luanda, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Benguela',
		label: 'Benguela, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Bié',
		label: 'Bié, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Cabinda',
		label: 'Cabinda, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Caxito',
		label: 'Caxito, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Caála',
		label: 'Caála, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Huambo',
		label: 'Huambo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Namibe',
		label: 'Namibe, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Lubango',
		label: 'Lubango, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Uíge',
		label: 'Uíge, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Lucapa',
		label: 'Lucapa, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Waku-Kungo',
		label: 'Waku-Kungo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Sumbe',
		label: 'Sumbe, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: "N'dalatando",
		label: "N'dalatando, Angola",
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Longonjo',
		label: 'Longonjo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Catabola',
		label: 'Catabola, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Camacupa',
		label: 'Camacupa, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Lumeje',
		label: 'Lumeje, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Caconda',
		label: 'Caconda, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Lobito',
		label: 'Lobito, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Malanje',
		label: 'Malanje, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: "M'banza-Kongo",
		label: "M'banza-Kongo, Angola",
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Saurimo',
		label: 'Saurimo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Chissamba',
		label: 'Chissamba, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Soyo',
		label: 'Soyo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Menongue',
		label: 'Menongue, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Caluquembe',
		label: 'Caluquembe, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Catumbela',
		label: 'Catumbela, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Luena',
		label: 'Luena, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Luau',
		label: 'Luau, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Catchiungo',
		label: 'Catchiungo, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Leúa',
		label: 'Leúa, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: "N'zeto",
		label: "N'zeto, Angola",
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Camabatela',
		label: 'Camabatela, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Cazaje',
		label: 'Cazaje, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Ondjiva',
		label: 'Ondjiva, Angola',
		type: 'city',
		flagClass: 'fi fi-ao',
		isPopular: false,
	},
	{
		value: 'Anguilla',
		label: 'Anguilla',
		type: 'country',
		flagClass: 'fi fi-ai',
		isPopular: false,
	},
	{
		value: 'The Valley',
		label: 'The Valley, Anguilla',
		type: 'city',
		flagClass: 'fi fi-ai',
		isPopular: false,
	},
	{
		value: 'Sandy Ground',
		label: 'Sandy Ground, Anguilla',
		type: 'city',
		flagClass: 'fi fi-ai',
		isPopular: false,
	},
	{
		value: 'Antarctica',
		label: 'Antarctica',
		type: 'country',
		flagClass: 'fi fi-aq',
		isPopular: false,
	},
	{
		value: 'South Pole',
		label: 'South Pole, Antarctica',
		type: 'city',
		flagClass: 'fi fi-aq',
		isPopular: false,
	},
	{
		value: 'Antigua and Barbuda',
		label: 'Antigua and Barbuda',
		type: 'country',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: "Saint John's",
		label: "Saint John's, Antigua and Barbuda",
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'All Saints',
		label: 'All Saints, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'English Harbour',
		label: 'English Harbour, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Bolands',
		label: 'Bolands, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Willikies',
		label: 'Willikies, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Old Road',
		label: 'Old Road, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Freetown',
		label: 'Freetown, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Cedar Grove',
		label: 'Cedar Grove, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Carlisle',
		label: 'Carlisle, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Falmouth',
		label: 'Falmouth, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Liberta',
		label: 'Liberta, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Parham',
		label: 'Parham, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Jennings',
		label: 'Jennings, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Codrington',
		label: 'Codrington, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Swetes',
		label: 'Swetes, Antigua and Barbuda',
		type: 'city',
		flagClass: 'fi fi-ag',
		isPopular: false,
	},
	{
		value: 'Argentina',
		label: 'Argentina',
		type: 'country',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Buenos Aires',
		label: 'Buenos Aires, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Córdoba',
		label: 'Córdoba, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Santa Fé',
		label: 'Santa Fé, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Aguacaliente',
		label: 'Aguacaliente, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Mendoza',
		label: 'Mendoza, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Mar del Plata',
		label: 'Mar del Plata, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'La Plata',
		label: 'La Plata, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Bahía Blanca',
		label: 'Bahía Blanca, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Tucumán',
		label: 'Tucumán, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'El Rosario',
		label: 'El Rosario, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Carlos de Bariloche',
		label: 'San Carlos de Bariloche, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Ushuaia',
		label: 'Ushuaia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Comodoro Rivadavia',
		label: 'Comodoro Rivadavia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Neuquén',
		label: 'Neuquén, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Corrientes',
		label: 'Corrientes, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Río Gallegos',
		label: 'Río Gallegos, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Paraná',
		label: 'Paraná, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Jujuy',
		label: 'Jujuy, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Campana',
		label: 'Campana, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Juan',
		label: 'San Juan, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Resistencia',
		label: 'Resistencia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Posadas',
		label: 'Posadas, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Catamarca',
		label: 'Catamarca, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Tandil',
		label: 'Tandil, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Río Cuarto',
		label: 'Río Cuarto, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Trelew',
		label: 'Trelew, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Necochea',
		label: 'Necochea, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Rafaela',
		label: 'Rafaela, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'General Roca',
		label: 'General Roca, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Formosa',
		label: 'Formosa, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Zárate',
		label: 'Zárate, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Viedma',
		label: 'Viedma, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Puerto Madryn',
		label: 'Puerto Madryn, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Concepción del Uruguay',
		label: 'Concepción del Uruguay, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Azul',
		label: 'Azul, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Venado Tuerto',
		label: 'Venado Tuerto, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Chacabuco',
		label: 'Chacabuco, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Pergamino',
		label: 'Pergamino, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Tres Arroyos',
		label: 'Tres Arroyos, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Alta Gracia',
		label: 'Alta Gracia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Rawson',
		label: 'Rawson, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Mercedes',
		label: 'Mercedes, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Villa María',
		label: 'Villa María, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Chivilcoy',
		label: 'Chivilcoy, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Ramón de la Nueva Orán',
		label: 'San Ramón de la Nueva Orán, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Nueve de Julio',
		label: 'Nueve de Julio, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Santiago del Estero',
		label: 'Santiago del Estero, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Concórdia',
		label: 'Concórdia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'La Rioja',
		label: 'La Rioja, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Rafael',
		label: 'San Rafael, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Gualeguaychú',
		label: 'Gualeguaychú, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Luján',
		label: 'Luján, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Villa Carlos Paz',
		label: 'Villa Carlos Paz, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'General Pico',
		label: 'General Pico, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Chiautzingo',
		label: 'Chiautzingo, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Rozavlea',
		label: 'Rozavlea, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Goya',
		label: 'Goya, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Punta Alta',
		label: 'Punta Alta, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Tartagal',
		label: 'Tartagal, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Río Tercero',
		label: 'Río Tercero, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Constitución',
		label: 'Constitución, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Bell Ville',
		label: 'Bell Ville, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Gualeguay',
		label: 'Gualeguay, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Veinticinco de Mayo',
		label: 'Veinticinco de Mayo, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Azcatepec',
		label: 'Azcatepec, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Reconquista',
		label: 'Reconquista, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Olavarría',
		label: 'Olavarría, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Vicente',
		label: 'San Vicente, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Junín',
		label: 'Junín, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Rivadavia',
		label: 'Rivadavia, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Eldorado',
		label: 'Eldorado, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Cutral Có',
		label: 'Cutral Có, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Oberá',
		label: 'Oberá, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Libertador General San Martín',
		label: 'Libertador General San Martín, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Lincoln',
		label: 'Lincoln, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Ingeniero Maschwitz',
		label: 'Ingeniero Maschwitz, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Salta',
		label: 'Salta, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Rosario',
		label: 'Rosario, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Huamantla',
		label: 'Huamantla, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Presidencia Roque Sáenz Peña',
		label: 'Presidencia Roque Sáenz Peña, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Dolores',
		label: 'Dolores, Argentina',
		type: 'city',
		flagClass: 'fi fi-ar',
		isPopular: false,
	},
	{
		value: 'Armenia',
		label: 'Armenia',
		type: 'country',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Yerevan',
		label: 'Yerevan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Abovyan',
		label: 'Abovyan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Hrazdan',
		label: 'Hrazdan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Ararat',
		label: 'Ararat, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Gyumri',
		label: 'Gyumri, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Vanadzor',
		label: 'Vanadzor, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Armavir',
		label: 'Armavir, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Stepanavan',
		label: 'Stepanavan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Ijevan',
		label: 'Ijevan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Sisian',
		label: 'Sisian, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Masis',
		label: 'Masis, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Jermuk',
		label: 'Jermuk, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Tsaghkadzor',
		label: 'Tsaghkadzor, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Arzni',
		label: 'Arzni, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Dar´a',
		label: 'Dar´a, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Kapan',
		label: 'Kapan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Gavar',
		label: 'Gavar, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Artashat',
		label: 'Artashat, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Charentsavan',
		label: 'Charentsavan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Sevan',
		label: 'Sevan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Alaverdi',
		label: 'Alaverdi, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Artik',
		label: 'Artik, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Goris',
		label: 'Goris, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Dilijan',
		label: 'Dilijan, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Vardenis',
		label: 'Vardenis, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Kajaran',
		label: 'Kajaran, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Spitak',
		label: 'Spitak, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Yegheknadzor',
		label: 'Yegheknadzor, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Ashtarak',
		label: 'Ashtarak, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Varanda',
		label: 'Varanda, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Tashir',
		label: 'Tashir, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Angeghakot',
		label: 'Angeghakot, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Nubarashen',
		label: 'Nubarashen, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Talin',
		label: 'Talin, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Meghri',
		label: 'Meghri, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Akhtala',
		label: 'Akhtala, Armenia',
		type: 'city',
		flagClass: 'fi fi-am',
		isPopular: false,
	},
	{
		value: 'Aruba',
		label: 'Aruba',
		type: 'country',
		flagClass: 'fi fi-aw',
		isPopular: false,
	},
	{
		value: 'Oranjestad',
		label: 'Oranjestad, Aruba',
		type: 'city',
		flagClass: 'fi fi-aw',
		isPopular: false,
	},
	{
		value: 'Buenos Aires',
		label: 'Buenos Aires, Aruba',
		type: 'city',
		flagClass: 'fi fi-aw',
		isPopular: false,
	},
	{
		value: 'Melbourne',
		label: 'Melbourne, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Brisbane',
		label: 'Brisbane, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Perth',
		label: 'Perth, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Adelaide',
		label: 'Adelaide, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gold Coast',
		label: 'Gold Coast, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Canberra',
		label: 'Canberra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Newcastle',
		label: 'Newcastle, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Hobart',
		label: 'Hobart, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Sunshine Coast',
		label: 'Sunshine Coast, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Geelong',
		label: 'Geelong, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Launceston',
		label: 'Launceston, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wollongong',
		label: 'Wollongong, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Toowoomba',
		label: 'Toowoomba, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cairns',
		label: 'Cairns, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Townsville',
		label: 'Townsville, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Albury-Wodonga',
		label: 'Albury-Wodonga, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ballarat',
		label: 'Ballarat, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Hervey Bay',
		label: 'Hervey Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Rockhampton',
		label: 'Rockhampton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Byron Bay',
		label: 'Byron Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bendigo',
		label: 'Bendigo, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Coffs Harbour',
		label: 'Coffs Harbour, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bundaberg',
		label: 'Bundaberg, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mackay',
		label: 'Mackay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Caboolture',
		label: 'Caboolture, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mandurah',
		label: 'Mandurah, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wagga Wagga',
		label: 'Wagga Wagga, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Maroochydore-Mooloolaba',
		label: 'Maroochydore-Mooloolaba, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bunbury',
		label: 'Bunbury, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Port Macquarie',
		label: 'Port Macquarie, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cranbourne',
		label: 'Cranbourne, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Somerville',
		label: 'Somerville, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bathurst',
		label: 'Bathurst, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Shepparton-Mooroopna',
		label: 'Shepparton-Mooroopna, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Katoomba-Wentworth Falls',
		label: 'Katoomba-Wentworth Falls, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lismore',
		label: 'Lismore, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Melton',
		label: 'Melton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Armidale',
		label: 'Armidale, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Victoria Point',
		label: 'Victoria Point, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Caloundra',
		label: 'Caloundra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Richmond-Windsor',
		label: 'Richmond-Windsor, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Dubbo',
		label: 'Dubbo, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Queanbeyan',
		label: 'Queanbeyan, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Alice Springs',
		label: 'Alice Springs, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Morayfield',
		label: 'Morayfield, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Pakenham',
		label: 'Pakenham, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Burnie-Devonport',
		label: 'Burnie-Devonport, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mildura',
		label: 'Mildura, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Albany',
		label: 'Albany, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Tamworth',
		label: 'Tamworth, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gympie',
		label: 'Gympie, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Murwillumbah',
		label: 'Murwillumbah, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Sunbury',
		label: 'Sunbury, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Coolum Beach',
		label: 'Coolum Beach, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wangaratta',
		label: 'Wangaratta, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mount Barker',
		label: 'Mount Barker, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Buderim',
		label: 'Buderim, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gladstone',
		label: 'Gladstone, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Geraldton',
		label: 'Geraldton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bowral',
		label: 'Bowral, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Burpengary',
		label: 'Burpengary, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Warrnambool',
		label: 'Warrnambool, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Deception Bay',
		label: 'Deception Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Healesville',
		label: 'Healesville, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ballina',
		label: 'Ballina, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Sale',
		label: 'Sale, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bairnsdale',
		label: 'Bairnsdale, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Batemans Bay',
		label: 'Batemans Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Taree',
		label: 'Taree, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Grafton',
		label: 'Grafton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Nambour',
		label: 'Nambour, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cessnock',
		label: 'Cessnock, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Tewantin-Noosa',
		label: 'Tewantin-Noosa, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Traralgon',
		label: 'Traralgon, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Griffith',
		label: 'Griffith, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Warragul',
		label: 'Warragul, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kingaroy',
		label: 'Kingaroy, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kwinana',
		label: 'Kwinana, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Warwick',
		label: 'Warwick, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Australind',
		label: 'Australind, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mount Gambier',
		label: 'Mount Gambier, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cairns Northern Beaches',
		label: 'Cairns Northern Beaches, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gawler',
		label: 'Gawler, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Craigieburn',
		label: 'Craigieburn, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Casino',
		label: 'Casino, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Hastings',
		label: 'Hastings, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kalgoorlie-Boulder',
		label: 'Kalgoorlie-Boulder, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Nerang',
		label: 'Nerang, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Morwell',
		label: 'Morwell, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Castlemaine',
		label: 'Castlemaine, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Shoalhaven',
		label: 'Shoalhaven, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Forster-Tuncurry',
		label: 'Forster-Tuncurry, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Singleton',
		label: 'Singleton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kiama',
		label: 'Kiama, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lithgow',
		label: 'Lithgow, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Broome',
		label: 'Broome, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bacchus Marsh',
		label: 'Bacchus Marsh, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Dalby',
		label: 'Dalby, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lawson-Hazelbrook',
		label: 'Lawson-Hazelbrook, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Emerald',
		label: 'Emerald, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Benalla',
		label: 'Benalla, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Nambucca Heads',
		label: 'Nambucca Heads, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gatton',
		label: 'Gatton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Goulburn',
		label: 'Goulburn, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Helensvale',
		label: 'Helensvale, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Horsham',
		label: 'Horsham, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Yeppoon',
		label: 'Yeppoon, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Nelson Bay',
		label: 'Nelson Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Victor Harbor',
		label: 'Victor Harbor, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Young',
		label: 'Young, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Torquay',
		label: 'Torquay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mount Isa',
		label: 'Mount Isa, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Port Hedland',
		label: 'Port Hedland, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Busselton',
		label: 'Busselton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ayr',
		label: 'Ayr, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cooma',
		label: 'Cooma, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ararat',
		label: 'Ararat, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Northam',
		label: 'Northam, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Roma',
		label: 'Roma, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Howard Springs',
		label: 'Howard Springs, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Moe-Yallourn',
		label: 'Moe-Yallourn, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Echuca-Moama',
		label: 'Echuca-Moama, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Raymond Terrace',
		label: 'Raymond Terrace, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Muswellbrook',
		label: 'Muswellbrook, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kempsey',
		label: 'Kempsey, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mudgee',
		label: 'Mudgee, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Crib Point',
		label: 'Crib Point, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Atherton',
		label: 'Atherton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Portland',
		label: 'Portland, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ulladulla',
		label: 'Ulladulla, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lakes Entrance',
		label: 'Lakes Entrance, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'New Norfolk',
		label: 'New Norfolk, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Whyalla',
		label: 'Whyalla, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Sawtell',
		label: 'Sawtell, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Karratha',
		label: 'Karratha, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Katherine',
		label: 'Katherine, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Innisfail',
		label: 'Innisfail, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Hamilton',
		label: 'Hamilton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cowra',
		label: 'Cowra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wangi-Rathmines',
		label: 'Wangi-Rathmines, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Biloela',
		label: 'Biloela, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Humpty Doo-MacMinns Lagoon',
		label: 'Humpty Doo-MacMinns Lagoon, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kurri Kurri',
		label: 'Kurri Kurri, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kingston-Blackmans Bay',
		label: 'Kingston-Blackmans Bay, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bongaree',
		label: 'Bongaree, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Colac',
		label: 'Colac, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Gunnedah',
		label: 'Gunnedah, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Glenn Innes',
		label: 'Glenn Innes, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wonthaggi',
		label: 'Wonthaggi, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Yarrawonga-Mulwala',
		label: 'Yarrawonga-Mulwala, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Crafers-Bridgewater',
		label: 'Crafers-Bridgewater, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Port Augusta',
		label: 'Port Augusta, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Murray Bridge',
		label: 'Murray Bridge, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ocean Grove-Barwon Heads',
		label: 'Ocean Grove-Barwon Heads, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Swan Hill',
		label: 'Swan Hill, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bavigne',
		label: 'Bavigne, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Charters Towers',
		label: 'Charters Towers, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Espérance',
		label: 'Espérance, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lara',
		label: 'Lara, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mareeba',
		label: 'Mareeba, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Moranbah',
		label: 'Moranbah, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Clifton Springs',
		label: 'Clifton Springs, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Moss Vale',
		label: 'Moss Vale, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Tumut',
		label: 'Tumut, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Medowie',
		label: 'Medowie, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Wellington',
		label: 'Wellington, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Yulara',
		label: 'Yulara, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Avarua',
		label: 'Avarua, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kawana Waters',
		label: 'Kawana Waters, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Port Pirie',
		label: 'Port Pirie, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Parkes',
		label: 'Parkes, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Inverell',
		label: 'Inverell, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Moree',
		label: 'Moree, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ulverstone',
		label: 'Ulverstone, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Forbes',
		label: 'Forbes, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Collie',
		label: 'Collie, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Bridgewater-Gagebrook',
		label: 'Bridgewater-Gagebrook, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Leeton',
		label: 'Leeton, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Blackwater',
		label: 'Blackwater, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Mittagong',
		label: 'Mittagong, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Kununurra',
		label: 'Kununurra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Tennant Creek',
		label: 'Tennant Creek, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Port Keats',
		label: 'Port Keats, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Coonawarra',
		label: 'Coonawarra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Deniliquin',
		label: 'Deniliquin, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Carnarvon',
		label: 'Carnarvon, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Narrabri',
		label: 'Narrabri, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Stawell',
		label: 'Stawell, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Cootamundra',
		label: 'Cootamundra, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Camden Haven',
		label: 'Camden Haven, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Corowa-Wahgunyah',
		label: 'Corowa-Wahgunyah, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Leopold',
		label: 'Leopold, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Lemon Tree Passage',
		label: 'Lemon Tree Passage, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Ingham',
		label: 'Ingham, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Maningrida',
		label: 'Maningrida, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Alyangula',
		label: 'Alyangula, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Galiwinku',
		label: 'Galiwinku, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Milingimbi',
		label: 'Milingimbi, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Renmark',
		label: 'Renmark, Australia',
		type: 'city',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Innsbruck',
		label: 'Innsbruck, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Graz',
		label: 'Graz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Linz',
		label: 'Linz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Salzburg',
		label: 'Salzburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Absam',
		label: 'Absam, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Klagenfurt',
		label: 'Klagenfurt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wiener Neustadt',
		label: 'Wiener Neustadt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Villach',
		label: 'Villach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bregenz',
		label: 'Bregenz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Pölten',
		label: 'Sankt Pölten, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Feldkirch',
		label: 'Feldkirch, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Klosterneuburg',
		label: 'Klosterneuburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Baden',
		label: 'Baden, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bludenz',
		label: 'Bludenz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Zell am See',
		label: 'Zell am See, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wels',
		label: 'Wels, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Dornbirn',
		label: 'Dornbirn, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mödling',
		label: 'Mödling, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kufstein',
		label: 'Kufstein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Tulln',
		label: 'Tulln, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wiener Neudorf',
		label: 'Wiener Neudorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Lienz',
		label: 'Lienz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Velden am Wörthersee',
		label: 'Velden am Wörthersee, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Zwettl',
		label: 'Zwettl, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Eisenstadt',
		label: 'Eisenstadt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bischofshofen',
		label: 'Bischofshofen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Laa',
		label: 'Laa, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Gastein',
		label: 'Bad Gastein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Fürstenfeld',
		label: 'Fürstenfeld, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Nenzing',
		label: 'Nenzing, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hainburg',
		label: 'Hainburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Leoben',
		label: 'Leoben, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wolfsberg',
		label: 'Wolfsberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Krems',
		label: 'Krems, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Stockerau',
		label: 'Stockerau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hollabrunn',
		label: 'Hollabrunn, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Götzis',
		label: 'Götzis, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Voitsberg',
		label: 'Voitsberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Altmünster',
		label: 'Altmünster, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Berndorf',
		label: 'Berndorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wolfurt',
		label: 'Wolfurt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Zeltweg',
		label: 'Zeltweg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Freistadt',
		label: 'Freistadt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mattersburg',
		label: 'Mattersburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Pressbaum',
		label: 'Pressbaum, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Pinkafeld',
		label: 'Pinkafeld, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Feldbach',
		label: 'Feldbach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Fischamend',
		label: 'Fischamend, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Saalfelden',
		label: 'Saalfelden, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ansfelden',
		label: 'Ansfelden, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Ischl',
		label: 'Bad Ischl, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Feldkirchen',
		label: 'Feldkirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hohenems',
		label: 'Hohenems, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Perchtoldsdorf',
		label: 'Perchtoldsdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bruck an der Mur',
		label: 'Bruck an der Mur, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Veit',
		label: 'Sankt Veit, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ried',
		label: 'Ried, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hall',
		label: 'Hall, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Völkermarkt',
		label: 'Völkermarkt, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Rankweil',
		label: 'Rankweil, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Neunkirchen',
		label: 'Neunkirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Korneuburg',
		label: 'Korneuburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wals-Siezenheim',
		label: 'Wals-Siezenheim, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Enns',
		label: 'Enns, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mistelbach',
		label: 'Mistelbach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Johann im Pongau',
		label: 'Sankt Johann im Pongau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Weiz',
		label: 'Weiz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Imst',
		label: 'Imst, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ebreichsdorf',
		label: 'Ebreichsdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Rum',
		label: 'Rum, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Perg',
		label: 'Perg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Liezen',
		label: 'Liezen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Arnoldstein',
		label: 'Arnoldstein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Leibnitz',
		label: 'Leibnitz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Jenbach',
		label: 'Jenbach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Völs',
		label: 'Völs, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Hofgastein',
		label: 'Bad Hofgastein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Haelen',
		label: 'Haelen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hartberg',
		label: 'Hartberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Eisenerz',
		label: 'Eisenerz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gloggnitz',
		label: 'Gloggnitz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Tamsweg',
		label: 'Tamsweg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mittersill',
		label: 'Mittersill, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Neusiedl am See',
		label: 'Neusiedl am See, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Abtenau',
		label: 'Abtenau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Melk',
		label: 'Melk, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Purgstall',
		label: 'Purgstall, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Aussee',
		label: 'Bad Aussee, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Feldkirchen an der Donau',
		label: 'Feldkirchen an der Donau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gleisdorf',
		label: 'Gleisdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ebbs',
		label: 'Ebbs, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bergheim',
		label: 'Bergheim, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Sankt Leonhard',
		label: 'Bad Sankt Leonhard, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Hall',
		label: 'Bad Hall, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bruck an der Großglocknerstraße',
		label: 'Bruck an der Großglocknerstraße, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Jakob',
		label: 'Sankt Jakob, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Fügen',
		label: 'Fügen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Großpetersdorf',
		label: 'Großpetersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Steyr',
		label: 'Steyr, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Traun',
		label: 'Traun, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Lustenau',
		label: 'Lustenau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hallein',
		label: 'Hallein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Braunau',
		label: 'Braunau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Traiskirchen',
		label: 'Traiskirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Spittal',
		label: 'Spittal, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ternitz',
		label: 'Ternitz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Telfs',
		label: 'Telfs, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gmunden',
		label: 'Gmunden, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Schwaz',
		label: 'Schwaz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Knittelfeld',
		label: 'Knittelfeld, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Vöcklabruck',
		label: 'Vöcklabruck, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Waidhofen',
		label: 'Waidhofen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hard',
		label: 'Hard, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Marchtrenk',
		label: 'Marchtrenk, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Vöslau',
		label: 'Bad Vöslau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wörgl',
		label: 'Wörgl, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Andrä',
		label: 'Sankt Andrä, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Köflach',
		label: 'Köflach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Judenburg',
		label: 'Judenburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mürzzuschlag',
		label: 'Mürzzuschlag, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Seekirchen',
		label: 'Seekirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Laakirchen',
		label: 'Laakirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Valentin',
		label: 'Sankt Valentin, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Lauterach',
		label: 'Lauterach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kitzbühel',
		label: 'Kitzbühel, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gerasdorf',
		label: 'Gerasdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Guntramsdorf',
		label: 'Guntramsdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sierning',
		label: 'Sierning, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Fohnsdorf',
		label: 'Fohnsdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ebensee',
		label: 'Ebensee, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Groß-Enzersdorf',
		label: 'Groß-Enzersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Trofaiach',
		label: 'Trofaiach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gänserndorf',
		label: 'Gänserndorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Finkenstein',
		label: 'Finkenstein, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Maria Enzersdorf',
		label: 'Maria Enzersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Johann in Tirol',
		label: 'Sankt Johann in Tirol, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Purkersdorf',
		label: 'Purkersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Deutschlandsberg',
		label: 'Deutschlandsberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Mariazell',
		label: 'Mariazell, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Engerwitzdorf',
		label: 'Engerwitzdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Herzogenburg',
		label: 'Herzogenburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bad Goisern',
		label: 'Bad Goisern, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ferlach',
		label: 'Ferlach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ebenthal',
		label: 'Ebenthal, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Landeck',
		label: 'Landeck, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Langenzersdorf',
		label: 'Langenzersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Neulengbach',
		label: 'Neulengbach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Vorchdorf',
		label: 'Vorchdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wattens',
		label: 'Wattens, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hermagor',
		label: 'Hermagor, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Bruck an der Leitha',
		label: 'Bruck an der Leitha, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Höchst',
		label: 'Höchst, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Strasshof',
		label: 'Strasshof, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Deutsch-Wagram',
		label: 'Deutsch-Wagram, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Langenlois',
		label: 'Langenlois, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sieghartskirchen',
		label: 'Sieghartskirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Straßwalchen',
		label: 'Straßwalchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Garsten',
		label: 'Garsten, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kottingbrunn',
		label: 'Kottingbrunn, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wilhelmsburg',
		label: 'Wilhelmsburg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Grödig',
		label: 'Grödig, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kuchl',
		label: 'Kuchl, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Oberwart',
		label: 'Oberwart, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Andrä-Wördern',
		label: 'Sankt Andrä-Wördern, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gratkorn',
		label: 'Gratkorn, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Radentheim',
		label: 'Radentheim, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kremsmünster',
		label: 'Kremsmünster, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Frohnleiten',
		label: 'Frohnleiten, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Zirl',
		label: 'Zirl, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hörbranz',
		label: 'Hörbranz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Wolkersdorf',
		label: 'Wolkersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Frastanz',
		label: 'Frastanz, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Paternion',
		label: 'Paternion, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Asten',
		label: 'Asten, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gallneukirchen',
		label: 'Gallneukirchen, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Pasching',
		label: 'Pasching, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Seeboden',
		label: 'Seeboden, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Eberndorf',
		label: 'Eberndorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Pottendorf',
		label: 'Pottendorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Gmünd',
		label: 'Gmünd, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Micheldorf',
		label: 'Micheldorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Altach',
		label: 'Altach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Kindberg',
		label: 'Kindberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Reutte',
		label: 'Reutte, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Schrems',
		label: 'Schrems, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Timelkam',
		label: 'Timelkam, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Poysdorf',
		label: 'Poysdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Traismauer',
		label: 'Traismauer, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Zistersdorf',
		label: 'Zistersdorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Oberndorf',
		label: 'Oberndorf, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Sankt Florian',
		label: 'Sankt Florian, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Ybbs',
		label: 'Ybbs, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Himberg',
		label: 'Himberg, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Regau',
		label: 'Regau, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Friesach',
		label: 'Friesach, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Rottenmann',
		label: 'Rottenmann, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hopfgarten',
		label: 'Hopfgarten, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Hörsching',
		label: 'Hörsching, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Axams',
		label: 'Axams, Austria',
		type: 'city',
		flagClass: 'fi fi-at',
		isPopular: false,
	},
	{
		value: 'Azerbaijan',
		label: 'Azerbaijan',
		type: 'country',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Baki',
		label: 'Baki, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agcabädi',
		label: 'Agcabädi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sumqayit',
		label: 'Sumqayit, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Balaxani',
		label: 'Balaxani, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bas Göynük',
		label: 'Bas Göynük, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bidzhov',
		label: 'Bidzhov, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Cäbrayil',
		label: 'Cäbrayil, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Gäncä',
		label: 'Gäncä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bakixanov',
		label: 'Bakixanov, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Säki',
		label: 'Säki, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Yevlax',
		label: 'Yevlax, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Mastaga',
		label: 'Mastaga, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Buzovna',
		label: 'Buzovna, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Quba',
		label: 'Quba, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Siyäzän',
		label: 'Siyäzän, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Däväçi',
		label: 'Däväçi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Ucar',
		label: 'Ucar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Saatli',
		label: 'Saatli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Suraxani',
		label: 'Suraxani, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Laçin',
		label: 'Laçin, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xocavänd',
		label: 'Xocavänd, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Böyük Dähnä',
		label: 'Böyük Dähnä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sigirli',
		label: 'Sigirli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Naftalan',
		label: 'Naftalan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kälbäcär',
		label: 'Kälbäcär, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Safaraliyev',
		label: 'Safaraliyev, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Slavjanka',
		label: 'Slavjanka, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Varanda',
		label: 'Varanda, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Zängilän',
		label: 'Zängilän, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Ivanovka',
		label: 'Ivanovka, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Danaçi',
		label: 'Danaçi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Juzhno-Sahalinsk',
		label: 'Juzhno-Sahalinsk, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Puta',
		label: 'Puta, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qazanbulaq',
		label: 'Qazanbulaq, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kizilgacili',
		label: 'Kizilgacili, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Zirya',
		label: 'Zirya, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Goranboy',
		label: 'Goranboy, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Särur',
		label: 'Särur, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Oguz',
		label: 'Oguz, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Dälimämmädli',
		label: 'Dälimämmädli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Istisu',
		label: 'Istisu, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Mingäçevir',
		label: 'Mingäçevir, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Äli Bayramli',
		label: 'Äli Bayramli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Naxçivan',
		label: 'Naxçivan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xankändi',
		label: 'Xankändi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qarasuxur',
		label: 'Qarasuxur, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Länkäran',
		label: 'Länkäran, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Räsulzadä',
		label: 'Räsulzadä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Biläcäri',
		label: 'Biläcäri, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Hövsan',
		label: 'Hövsan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Göyçay',
		label: 'Göyçay, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bärdä',
		label: 'Bärdä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Salyan',
		label: 'Salyan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xaçmaz',
		label: 'Xaçmaz, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xirdalan',
		label: 'Xirdalan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agdam',
		label: 'Agdam, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sämkir',
		label: 'Sämkir, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Cälilabad',
		label: 'Cälilabad, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Imisli',
		label: 'Imisli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qarasu',
		label: 'Qarasu, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Samaxi',
		label: 'Samaxi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Lökbatan',
		label: 'Lökbatan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qazimämmäd',
		label: 'Qazimämmäd, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bina',
		label: 'Bina, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agdas',
		label: 'Agdas, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Beyläqan',
		label: 'Beyläqan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qazax',
		label: 'Qazax, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Biläsuvar',
		label: 'Biläsuvar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sabirabad',
		label: 'Sabirabad, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sabunçu',
		label: 'Sabunçu, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Zaqatala',
		label: 'Zaqatala, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Daskäsän',
		label: 'Daskäsän, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xanlar',
		label: 'Xanlar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Füzuli',
		label: 'Füzuli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kürdämir',
		label: 'Kürdämir, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Susa',
		label: 'Susa, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Masalli',
		label: 'Masalli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sanqaçal',
		label: 'Sanqaçal, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agsu',
		label: 'Agsu, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Neftçala',
		label: 'Neftçala, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qusar',
		label: 'Qusar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Tovuz',
		label: 'Tovuz, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qäbälä',
		label: 'Qäbälä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qaracämirli',
		label: 'Qaracämirli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Artyom',
		label: 'Artyom, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Astara',
		label: 'Astara, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Tärtär',
		label: 'Tärtär, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Amircan',
		label: 'Amircan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qax',
		label: 'Qax, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Ismayilli',
		label: 'Ismayilli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Xudat',
		label: 'Xudat, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Göytäpä',
		label: 'Göytäpä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agstafa',
		label: 'Agstafa, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Haci Zeynalabdin',
		label: 'Haci Zeynalabdin, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kizilavar',
		label: 'Kizilavar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Arçivan',
		label: 'Arçivan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Ordubad',
		label: 'Ordubad, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Älät',
		label: 'Älät, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Katex',
		label: 'Katex, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Vladikavkaz',
		label: 'Vladikavkaz, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Asagi Ayipli',
		label: 'Asagi Ayipli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Culfa',
		label: 'Culfa, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Qobustan',
		label: 'Qobustan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kovlar',
		label: 'Kovlar, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Port-Iliç',
		label: 'Port-Iliç, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Sädäräk',
		label: 'Sädäräk, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Zägam',
		label: 'Zägam, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Çardaxli',
		label: 'Çardaxli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Dälilär',
		label: 'Dälilär, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Mäxdili',
		label: 'Mäxdili, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Zärdab',
		label: 'Zärdab, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Agdärä',
		label: 'Agdärä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Das Salaxli',
		label: 'Das Salaxli, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Tapkarakoyunlu',
		label: 'Tapkarakoyunlu, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Balakän',
		label: 'Balakän, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Kubalybalaoglan',
		label: 'Kubalybalaoglan, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bilqäx',
		label: 'Bilqäx, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Çarxi',
		label: 'Çarxi, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Märäzä',
		label: 'Märäzä, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Gädäbäy',
		label: 'Gädäbäy, Azerbaijan',
		type: 'city',
		flagClass: 'fi fi-az',
		isPopular: false,
	},
	{
		value: 'Bahamas',
		label: 'Bahamas',
		type: 'country',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Nassau',
		label: 'Nassau, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Freeport',
		label: 'Freeport, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Albert Town',
		label: 'Albert Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Marsh Harbour',
		label: 'Marsh Harbour, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Andros Town',
		label: 'Andros Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'George Town',
		label: 'George Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Rock Sound',
		label: 'Rock Sound, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Pirates Well',
		label: 'Pirates Well, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Freetown',
		label: 'Freetown, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'High Rock',
		label: 'High Rock, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Clarence Town',
		label: 'Clarence Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Dunmore Town',
		label: 'Dunmore Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Great Harbour',
		label: 'Great Harbour, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Nicholls Town',
		label: 'Nicholls Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Sweeting Cay',
		label: 'Sweeting Cay, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Cockburn Town',
		label: 'Cockburn Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Colonel Hill',
		label: 'Colonel Hill, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Coopers Town',
		label: 'Coopers Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: "Arthur's Town",
		label: "Arthur's Town, Bahamas",
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Alice Town',
		label: 'Alice Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Matthew Town',
		label: 'Matthew Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Snug Corner',
		label: 'Snug Corner, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Duncan Town',
		label: 'Duncan Town, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Port Nelson',
		label: 'Port Nelson, Bahamas',
		type: 'city',
		flagClass: 'fi fi-bs',
		isPopular: false,
	},
	{
		value: 'Bahrain',
		label: 'Bahrain',
		type: 'country',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'al-Manamah',
		label: 'al-Manamah, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'al-Muharraq',
		label: 'al-Muharraq, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: '´Îsa',
		label: '´Îsa, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'ar-Rifa´a',
		label: 'ar-Rifa´a, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'Jidd Hafs',
		label: 'Jidd Hafs, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'Sitrah',
		label: 'Sitrah, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'Hidd',
		label: 'Hidd, Bahrain',
		type: 'city',
		flagClass: 'fi fi-bh',
		isPopular: false,
	},
	{
		value: 'Bangladesh',
		label: 'Bangladesh',
		type: 'country',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Dhaka',
		label: 'Dhaka, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chattagam',
		label: 'Chattagam, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Abhaynagar',
		label: 'Abhaynagar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Silhat',
		label: 'Silhat, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Khulna',
		label: 'Khulna, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gazipur',
		label: 'Gazipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rajshahi',
		label: 'Rajshahi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Narayanganj',
		label: 'Narayanganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rangpur',
		label: 'Rangpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Maimansingh',
		label: 'Maimansingh, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chuadanga',
		label: 'Chuadanga, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Feni',
		label: 'Feni, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Raipur',
		label: 'Raipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Barisal',
		label: 'Barisal, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Tungi',
		label: 'Tungi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jessor',
		label: 'Jessor, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Brahman Bariya',
		label: 'Brahman Bariya, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Dinajpur',
		label: 'Dinajpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kushtiya',
		label: 'Kushtiya, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bagar Hat',
		label: 'Bagar Hat, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Narsingdi',
		label: 'Narsingdi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Pabna',
		label: 'Pabna, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nawabganj',
		label: 'Nawabganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Tangayal',
		label: 'Tangayal, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Faridpur',
		label: 'Faridpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kishorganj',
		label: 'Kishorganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jaipur Hat',
		label: 'Jaipur Hat, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Maulvi Bazar',
		label: 'Maulvi Bazar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bera',
		label: 'Bera, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bheramara',
		label: 'Bheramara, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Dhamar',
		label: 'Dhamar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bogora',
		label: 'Bogora, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chandpur',
		label: 'Chandpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Begamganj',
		label: 'Begamganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Noakhali',
		label: 'Noakhali, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Satkhira',
		label: 'Satkhira, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Thakurgaon',
		label: 'Thakurgaon, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Lakshmipur',
		label: 'Lakshmipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jhalakati',
		label: 'Jhalakati, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Meherpur',
		label: 'Meherpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gopalganj',
		label: 'Gopalganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nalitabari',
		label: 'Nalitabari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Mirzapur',
		label: 'Mirzapur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bandarban',
		label: 'Bandarban, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Dhamrai',
		label: 'Dhamrai, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Komilla',
		label: 'Komilla, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jamalpur',
		label: 'Jamalpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Koks Bazar',
		label: 'Koks Bazar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ishurdi',
		label: 'Ishurdi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kaunia',
		label: 'Kaunia, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nator',
		label: 'Nator, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sherpur',
		label: 'Sherpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bhola',
		label: 'Bhola, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jhanaydah',
		label: 'Jhanaydah, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Habiganj',
		label: 'Habiganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Laksham',
		label: 'Laksham, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sunamganj',
		label: 'Sunamganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rajbari',
		label: 'Rajbari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rangamati',
		label: 'Rangamati, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Pirojpur',
		label: 'Pirojpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nageshwari',
		label: 'Nageshwari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Naral',
		label: 'Naral, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Adamighi',
		label: 'Adamighi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Parbatipur',
		label: 'Parbatipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kaliganj',
		label: 'Kaliganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sri Mangal',
		label: 'Sri Mangal, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nilphamari',
		label: 'Nilphamari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kotchandpur',
		label: 'Kotchandpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Barguna',
		label: 'Barguna, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bajitpur',
		label: 'Bajitpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chhatak',
		label: 'Chhatak, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bhandaria',
		label: 'Bhandaria, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bochanganj',
		label: 'Bochanganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kutubdia',
		label: 'Kutubdia, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Naugaon',
		label: 'Naugaon, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sirajganj',
		label: 'Sirajganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sa´idpur',
		label: 'Sa´idpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gaybanda',
		label: 'Gaybanda, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Munshiganj',
		label: 'Munshiganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bhairab Bazar',
		label: 'Bhairab Bazar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Shahjadpur',
		label: 'Shahjadpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kurigram',
		label: 'Kurigram, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rupganj',
		label: 'Rupganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ramgati',
		label: 'Ramgati, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Boalkhali',
		label: 'Boalkhali, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Alamdanga',
		label: 'Alamdanga, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sarishabari',
		label: 'Sarishabari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Mungla',
		label: 'Mungla, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Madaripur',
		label: 'Madaripur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Manikganj',
		label: 'Manikganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Fulbaria',
		label: 'Fulbaria, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Patuakhali',
		label: 'Patuakhali, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gopalpur',
		label: 'Gopalpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kaptai',
		label: 'Kaptai, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Netrakona',
		label: 'Netrakona, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Lalmanir Hat',
		label: 'Lalmanir Hat, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Damurhuda',
		label: 'Damurhuda, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sarail',
		label: 'Sarail, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Breaza',
		label: 'Breaza, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sandip',
		label: 'Sandip, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Satkaniya',
		label: 'Satkaniya, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ramganj',
		label: 'Ramganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Palang',
		label: 'Palang, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gurudaspur',
		label: 'Gurudaspur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chilmari',
		label: 'Chilmari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nesarabad',
		label: 'Nesarabad, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Patiya',
		label: 'Patiya, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Tungi Para',
		label: 'Tungi Para, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Hajiganj',
		label: 'Hajiganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Char Fasson',
		label: 'Char Fasson, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gomastapur',
		label: 'Gomastapur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Panchagarh',
		label: 'Panchagarh, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Fatikchhari',
		label: 'Fatikchhari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ramu',
		label: 'Ramu, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Burhanuddin',
		label: 'Burhanuddin, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Shibganj',
		label: 'Shibganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Roypura',
		label: 'Roypura, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Trishal',
		label: 'Trishal, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gaurnadi',
		label: 'Gaurnadi, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bhanga',
		label: 'Bhanga, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Jhikargachha',
		label: 'Jhikargachha, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Dohar',
		label: 'Dohar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Lalmohan',
		label: 'Lalmohan, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Mehendiganj',
		label: 'Mehendiganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nalchiti',
		label: 'Nalchiti, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Teknaf',
		label: 'Teknaf, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Khagrachari',
		label: 'Khagrachari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Kalia',
		label: 'Kalia, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Phultala',
		label: 'Phultala, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Pangsha',
		label: 'Pangsha, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Gafargaon',
		label: 'Gafargaon, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Shailkupa',
		label: 'Shailkupa, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Rangunia',
		label: 'Rangunia, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sakhipur',
		label: 'Sakhipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Sarankhola',
		label: 'Sarankhola, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Fulbari',
		label: 'Fulbari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Senbagh',
		label: 'Senbagh, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Fakirhat',
		label: 'Fakirhat, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Chhagalnaiya',
		label: 'Chhagalnaiya, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Badarganj',
		label: 'Badarganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Baniachang',
		label: 'Baniachang, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ulipur',
		label: 'Ulipur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Char Bhadrasan',
		label: 'Char Bhadrasan, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Pirganj',
		label: 'Pirganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Bhaluka',
		label: 'Bhaluka, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Morrelganj',
		label: 'Morrelganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Nabinagar',
		label: 'Nabinagar, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ramgarh',
		label: 'Ramgarh, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Mathbaria',
		label: 'Mathbaria, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Keshabpur',
		label: 'Keshabpur, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Lohagara',
		label: 'Lohagara, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Itna',
		label: 'Itna, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Ishwarganj',
		label: 'Ishwarganj, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Raozan',
		label: 'Raozan, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Muktagachha',
		label: 'Muktagachha, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Manikchhari',
		label: 'Manikchhari, Bangladesh',
		type: 'city',
		flagClass: 'fi fi-bd',
		isPopular: false,
	},
	{
		value: 'Barbados',
		label: 'Barbados',
		type: 'country',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Bridgetown',
		label: 'Bridgetown, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Bathsheba',
		label: 'Bathsheba, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Oistins',
		label: 'Oistins, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Speightstown',
		label: 'Speightstown, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Holetown',
		label: 'Holetown, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Crab Hill',
		label: 'Crab Hill, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Greenland',
		label: 'Greenland, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Hillaby',
		label: 'Hillaby, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Crane',
		label: 'Crane, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Bulkeley',
		label: 'Bulkeley, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Blackmans',
		label: 'Blackmans, Barbados',
		type: 'city',
		flagClass: 'fi fi-bb',
		isPopular: false,
	},
	{
		value: 'Belarus',
		label: 'Belarus',
		type: 'country',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Minsk',
		label: 'Minsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Ashmjany',
		label: 'Ashmjany, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Homjel'",
		label: "Homjel', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Vicebsk',
		label: 'Vicebsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Hrodna',
		label: 'Hrodna, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Hancavichy',
		label: 'Hancavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Orsha',
		label: 'Orsha, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Viljejka',
		label: 'Viljejka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Pruzhany',
		label: 'Pruzhany, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Byhau',
		label: 'Byhau, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Dobrush',
		label: 'Dobrush, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Haradok',
		label: 'Haradok, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Drahichyn',
		label: 'Drahichyn, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Chausy',
		label: 'Chausy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Chèrven'",
		label: "Chèrven', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Talachyn',
		label: 'Talachyn, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kleck',
		label: 'Kleck, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Mjory',
		label: 'Mjory, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Mahiljow',
		label: 'Mahiljow, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Mazyr',
		label: 'Mazyr, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Lida',
		label: 'Lida, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Polack',
		label: 'Polack, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Svetlahorsk',
		label: 'Svetlahorsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Dzerzhyns'k",
		label: "Dzerzhyns'k, Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Marjina Horka',
		label: 'Marjina Horka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Luninjec',
		label: 'Luninjec, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Pastavy',
		label: 'Pastavy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Ljepjel'",
		label: "Ljepjel', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Klimavichy',
		label: 'Klimavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Hlybokaje',
		label: 'Hlybokaje, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Ivacevichy',
		label: 'Ivacevichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Hojniki',
		label: 'Hojniki, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Masty',
		label: 'Masty, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Zhytkavichy',
		label: 'Zhytkavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Shchuchyn',
		label: 'Shchuchyn, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kascjukovka',
		label: 'Kascjukovka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Shklov',
		label: 'Shklov, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Njasvizh',
		label: 'Njasvizh, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Novalukoml'",
		label: "Novalukoml', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Ivanava',
		label: 'Ivanava, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Smaljavichy',
		label: 'Smaljavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Stovbcy',
		label: 'Stovbcy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Baran'",
		label: "Baran', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kascjukovichy',
		label: 'Kascjukovichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Bjarèzina',
		label: 'Bjarèzina, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Pjetrykav',
		label: 'Pjetrykav, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Mstislav',
		label: 'Mstislav, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Narovlja',
		label: 'Narovlja, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Chashniki',
		label: 'Chashniki, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Ljuban'",
		label: "Ljuban', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Staryja Darohi',
		label: 'Staryja Darohi, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Braslav',
		label: 'Braslav, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Zhabinka',
		label: 'Zhabinka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Skidel'",
		label: "Skidel', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Bjeloozersk',
		label: 'Bjeloozersk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Ljahavichy',
		label: 'Ljahavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Valozhyn',
		label: 'Valozhyn, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Stolin',
		label: 'Stolin, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Zaslavje',
		label: 'Zaslavje, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Vjetka',
		label: 'Vjetka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Dubrovna',
		label: 'Dubrovna, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Chechersk',
		label: 'Chechersk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Malaryta',
		label: 'Malaryta, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Jel'sk",
		label: "Jel'sk, Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Kapyl'",
		label: "Kapyl', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Buda Kosheljovo',
		label: 'Buda Kosheljovo, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Senno',
		label: 'Senno, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Cherikov',
		label: 'Cherikov, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Berjozovka',
		label: 'Berjozovka, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Mikashevichy',
		label: 'Mikashevichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kamjenec',
		label: 'Kamjenec, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Slaeuharad',
		label: 'Slaeuharad, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'David-Haradok',
		label: 'David-Haradok, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Verhnjadzvimsk',
		label: 'Verhnjadzvimsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Dokshicy',
		label: 'Dokshicy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Vasilevichy',
		label: 'Vasilevichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Vysokoje',
		label: 'Vysokoje, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kosava',
		label: 'Kosava, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Dishna',
		label: 'Dishna, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Brèst',
		label: 'Brèst, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Babrujsk',
		label: 'Babrujsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Baranavichy',
		label: 'Baranavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Barisaw',
		label: 'Barisaw, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Pinsk',
		label: 'Pinsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Salihorsk',
		label: 'Salihorsk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Navapolack',
		label: 'Navapolack, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Maladzechna',
		label: 'Maladzechna, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Rèchyca',
		label: 'Rèchyca, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Zhlobin',
		label: 'Zhlobin, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Sluck',
		label: 'Sluck, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Zhodzina',
		label: 'Zhodzina, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Rahachow',
		label: 'Rahachow, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Slonim',
		label: 'Slonim, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kobryn',
		label: 'Kobryn, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Vawkavysk',
		label: 'Vawkavysk, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Kalinkavichy',
		label: 'Kalinkavichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: "Smarhon'",
		label: "Smarhon', Belarus",
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Asipovichy',
		label: 'Asipovichy, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Horki',
		label: 'Horki, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Krychaw',
		label: 'Krychaw, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Bjaroza',
		label: 'Bjaroza, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Navahrudak',
		label: 'Navahrudak, Belarus',
		type: 'city',
		flagClass: 'fi fi-by',
		isPopular: false,
	},
	{
		value: 'Antwerpen',
		label: 'Antwerpen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Brussels',
		label: 'Brussels, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Gent',
		label: 'Gent, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Leuven',
		label: 'Leuven, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Aalst',
		label: 'Aalst, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Genk',
		label: 'Genk, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Mechelen',
		label: 'Mechelen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Liège',
		label: 'Liège, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Brugge',
		label: 'Brugge, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Mons',
		label: 'Mons, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kortrijk',
		label: 'Kortrijk, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Oostende',
		label: 'Oostende, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Niklaas',
		label: 'Sint-Niklaas, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Namur',
		label: 'Namur, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Turnhout',
		label: 'Turnhout, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Charleroi',
		label: 'Charleroi, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ottignies-Louvain-la-Neuve',
		label: 'Ottignies-Louvain-la-Neuve, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Tervuren',
		label: 'Tervuren, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Truiden',
		label: 'Sint-Truiden, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Waterloo',
		label: 'Waterloo, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Roeselare',
		label: 'Roeselare, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Beringen',
		label: 'Beringen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Asse',
		label: 'Asse, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Arlon',
		label: 'Arlon, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Diepenbeek',
		label: 'Diepenbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Dendermonde',
		label: 'Dendermonde, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Grimbergen',
		label: 'Grimbergen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Tongeren',
		label: 'Tongeren, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kontich',
		label: 'Kontich, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Tournai',
		label: 'Tournai, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Brecht',
		label: 'Brecht, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Overijse',
		label: 'Overijse, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Diest',
		label: 'Diest, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Huy',
		label: 'Huy, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Leopoldsburg',
		label: 'Leopoldsburg, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'La Louvière',
		label: 'La Louvière, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Dilbeek',
		label: 'Dilbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Geel',
		label: 'Geel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Heusden-Zolder',
		label: 'Heusden-Zolder, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Izegem',
		label: 'Izegem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lanaken',
		label: 'Lanaken, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lubbeek',
		label: 'Lubbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Vilvoorde',
		label: 'Vilvoorde, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Halle',
		label: 'Halle, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wavre',
		label: 'Wavre, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Tienen',
		label: 'Tienen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Bilzen',
		label: 'Bilzen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Aarschot',
		label: 'Aarschot, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Rixensart',
		label: 'Rixensart, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lochristi',
		label: 'Lochristi, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Erpe-Mere',
		label: 'Erpe-Mere, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Meise',
		label: 'Meise, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zwijndrecht',
		label: 'Zwijndrecht, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kortenberg',
		label: 'Kortenberg, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lede',
		label: 'Lede, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lummen',
		label: 'Lummen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Arendonk',
		label: 'Arendonk, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Waregem',
		label: 'Waregem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Deinze',
		label: 'Deinze, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Avelgem',
		label: 'Avelgem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wetteren',
		label: 'Wetteren, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Willebroek',
		label: 'Willebroek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zele',
		label: 'Zele, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zoersel',
		label: 'Zoersel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Schilde',
		label: 'Schilde, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zonhoven',
		label: 'Zonhoven, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Essen',
		label: 'Essen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Stekene',
		label: 'Stekene, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Neerpelt',
		label: 'Neerpelt, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Diksmuide',
		label: 'Diksmuide, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Moerbeke',
		label: 'Moerbeke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Bredene',
		label: 'Bredene, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Aartselaar',
		label: 'Aartselaar, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Büllingen',
		label: 'Büllingen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lasne',
		label: 'Lasne, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Jodoigne',
		label: 'Jodoigne, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Seraing',
		label: 'Seraing, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Enghien',
		label: 'Enghien, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Hechtel-Eksel',
		label: 'Hechtel-Eksel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Heist-op-den-Berg',
		label: 'Heist-op-den-Berg, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Maasmechelen',
		label: 'Maasmechelen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ieper',
		label: 'Ieper, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ninove',
		label: 'Ninove, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Knokke-Heist',
		label: 'Knokke-Heist, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Steenokkerzeel',
		label: 'Steenokkerzeel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Nieuwpoort',
		label: 'Nieuwpoort, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lier',
		label: 'Lier, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Chaumont-Gistoux',
		label: 'Chaumont-Gistoux, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Binche',
		label: 'Binche, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Mol',
		label: 'Mol, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Geraardsbergen',
		label: 'Geraardsbergen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lommel',
		label: 'Lommel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Pieters-Leeuw',
		label: 'Sint-Pieters-Leeuw, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Houthalen-Helchteren',
		label: 'Houthalen-Helchteren, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zaventem',
		label: 'Zaventem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ardooie',
		label: 'Ardooie, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Temse',
		label: 'Temse, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Huldenberg',
		label: 'Huldenberg, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Hamme',
		label: 'Hamme, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kapelle-op-den-Bos',
		label: 'Kapelle-op-den-Bos, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Maldegem',
		label: 'Maldegem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Edegem',
		label: 'Edegem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Dessel',
		label: 'Dessel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Herenthout',
		label: 'Herenthout, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Chaudfontaine',
		label: 'Chaudfontaine, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Koekelare',
		label: 'Koekelare, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Koksijde',
		label: 'Koksijde, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kortessem',
		label: 'Kortessem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lint',
		label: 'Lint, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Braine-le-Comte',
		label: 'Braine-le-Comte, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Poperinge',
		label: 'Poperinge, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Eeklo',
		label: 'Eeklo, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Torhout',
		label: 'Torhout, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Aalter',
		label: 'Aalter, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Antoing',
		label: 'Antoing, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Dilsen-Stokkem',
		label: 'Dilsen-Stokkem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Genesius-Rode',
		label: 'Sint-Genesius-Rode, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wuustwezel',
		label: 'Wuustwezel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kalmthout',
		label: 'Kalmthout, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Heers',
		label: 'Heers, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Péruwelz',
		label: 'Péruwelz, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lierde',
		label: 'Lierde, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Beerse',
		label: 'Beerse, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Puurs',
		label: 'Puurs, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Riemst',
		label: 'Riemst, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Peer',
		label: 'Peer, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lille',
		label: 'Lille, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Walhain',
		label: 'Walhain, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kruibeke',
		label: 'Kruibeke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Rotselaar',
		label: 'Rotselaar, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Limbourg',
		label: 'Limbourg, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ternat',
		label: 'Ternat, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Hamont-Achel',
		label: 'Hamont-Achel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wezembeek-Oppem',
		label: 'Wezembeek-Oppem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Waremme',
		label: 'Waremme, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wingene',
		label: 'Wingene, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Aubel',
		label: 'Aubel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Keerbergen',
		label: 'Keerbergen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Boechout',
		label: 'Boechout, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Brugelette',
		label: 'Brugelette, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Herk-de-Stad',
		label: 'Herk-de-Stad, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Gistel',
		label: 'Gistel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Brasschaat',
		label: 'Brasschaat, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lokeren',
		label: 'Lokeren, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Profondeville',
		label: 'Profondeville, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Melle',
		label: 'Melle, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Borsbeek',
		label: 'Borsbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ath',
		label: 'Ath, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Herentals',
		label: 'Herentals, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Opglabbeek',
		label: 'Opglabbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Mortsel',
		label: 'Mortsel, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zottegem',
		label: 'Zottegem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Nivelles',
		label: 'Nivelles, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Villers-la-Ville',
		label: 'Villers-la-Ville, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zwevegem',
		label: 'Zwevegem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Holsbeek',
		label: 'Holsbeek, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Fleurus',
		label: 'Fleurus, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Westerlo',
		label: 'Westerlo, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Grace-Hollogne',
		label: 'Grace-Hollogne, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lennik',
		label: 'Lennik, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Merelbeke',
		label: 'Merelbeke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Halen',
		label: 'Halen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Oostkamp',
		label: 'Oostkamp, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Gembloux',
		label: 'Gembloux, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Beauraing',
		label: 'Beauraing, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Juprelle',
		label: 'Juprelle, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Nijlen',
		label: 'Nijlen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'La Bruyère',
		label: 'La Bruyère, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Merksplas',
		label: 'Merksplas, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Boussu',
		label: 'Boussu, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Yvoir',
		label: 'Yvoir, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Bornem',
		label: 'Bornem, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Silly',
		label: 'Silly, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Jalhay',
		label: 'Jalhay, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Gingelom',
		label: 'Gingelom, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Herent',
		label: 'Herent, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Quaregnon',
		label: 'Quaregnon, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Trooz',
		label: 'Trooz, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zwalm',
		label: 'Zwalm, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Morlanwelz',
		label: 'Morlanwelz, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Amands',
		label: 'Sint-Amands, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kortenaken',
		label: 'Kortenaken, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Kasterlee',
		label: 'Kasterlee, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Oostrozebeke',
		label: 'Oostrozebeke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Vorselaar',
		label: 'Vorselaar, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Eupen',
		label: 'Eupen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Ranst',
		label: 'Ranst, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Floreffe',
		label: 'Floreffe, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'La Hulpe',
		label: 'La Hulpe, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Lessines',
		label: 'Lessines, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wachtebeke',
		label: 'Wachtebeke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Sint-Gillis-Waas',
		label: 'Sint-Gillis-Waas, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Wellen',
		label: 'Wellen, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Zutendaal',
		label: 'Zutendaal, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Haaltert',
		label: 'Haaltert, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Stavelot',
		label: 'Stavelot, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: "Fontaine-l'Evêque",
		label: "Fontaine-l'Evêque, Belgium",
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Middelkerke',
		label: 'Middelkerke, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Dour',
		label: 'Dour, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Herne',
		label: 'Herne, Belgium',
		type: 'city',
		flagClass: 'fi fi-be',
		isPopular: false,
	},
	{
		value: 'Belize',
		label: 'Belize',
		type: 'country',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Belize',
		label: 'Belize, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Belmopan',
		label: 'Belmopan, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Orange Walk',
		label: 'Orange Walk, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Benque Viejo',
		label: 'Benque Viejo, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Punta Gorda',
		label: 'Punta Gorda, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Corozal',
		label: 'Corozal, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Dangriga',
		label: 'Dangriga, Belize',
		type: 'city',
		flagClass: 'fi fi-bz',
		isPopular: false,
	},
	{
		value: 'Benin',
		label: 'Benin',
		type: 'country',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Cotonou',
		label: 'Cotonou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Abomey',
		label: 'Abomey, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Porto Novo',
		label: 'Porto Novo, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Ouidah',
		label: 'Ouidah, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Nikki',
		label: 'Nikki, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Parakou',
		label: 'Parakou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Djougou',
		label: 'Djougou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Natitingou',
		label: 'Natitingou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Lokossa',
		label: 'Lokossa, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Kouandé',
		label: 'Kouandé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Savalou',
		label: 'Savalou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Savé',
		label: 'Savé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Malanville',
		label: 'Malanville, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Dogbo',
		label: 'Dogbo, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Allada',
		label: 'Allada, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Kétou',
		label: 'Kétou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Batia',
		label: 'Batia, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Zagnanado',
		label: 'Zagnanado, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Athiémé',
		label: 'Athiémé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Tanguiété',
		label: 'Tanguiété, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Boukombé',
		label: 'Boukombé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Bohicon',
		label: 'Bohicon, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Kandi',
		label: 'Kandi, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Cové',
		label: 'Cové, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Sakété',
		label: 'Sakété, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Pobé',
		label: 'Pobé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Comé',
		label: 'Comé, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Aplahoué',
		label: 'Aplahoué, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Dassa',
		label: 'Dassa, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Bembéréké',
		label: 'Bembéréké, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Tchaourou',
		label: 'Tchaourou, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Grand Popo',
		label: 'Grand Popo, Benin',
		type: 'city',
		flagClass: 'fi fi-bj',
		isPopular: false,
	},
	{
		value: 'Bermuda',
		label: 'Bermuda',
		type: 'country',
		flagClass: 'fi fi-bm',
		isPopular: false,
	},
	{
		value: 'Hamilton',
		label: 'Hamilton, Bermuda',
		type: 'city',
		flagClass: 'fi fi-bm',
		isPopular: false,
	},
	{
		value: 'Sfantu Gheorghe',
		label: 'Sfantu Gheorghe, Bermuda',
		type: 'city',
		flagClass: 'fi fi-bm',
		isPopular: false,
	},
	{
		value: 'Southampton',
		label: 'Southampton, Bermuda',
		type: 'city',
		flagClass: 'fi fi-bm',
		isPopular: false,
	},
	{
		value: 'Bhutan',
		label: 'Bhutan',
		type: 'country',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Chhukha',
		label: 'Chhukha, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Timphu',
		label: 'Timphu, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Phuntsholing',
		label: 'Phuntsholing, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Ha',
		label: 'Ha, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Punakha',
		label: 'Punakha, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Tongsa',
		label: 'Tongsa, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Samdrup Jongkhar',
		label: 'Samdrup Jongkhar, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Wangdiphodrang',
		label: 'Wangdiphodrang, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Damphu',
		label: 'Damphu, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Gasa',
		label: 'Gasa, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Samchi',
		label: 'Samchi, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Geylegphug',
		label: 'Geylegphug, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Rinpung',
		label: 'Rinpung, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Tashigang',
		label: 'Tashigang, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Taga Dzong',
		label: 'Taga Dzong, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Lhuntshi',
		label: 'Lhuntshi, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Jakar',
		label: 'Jakar, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Pemagatsel',
		label: 'Pemagatsel, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Mongar',
		label: 'Mongar, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Shemgang',
		label: 'Shemgang, Bhutan',
		type: 'city',
		flagClass: 'fi fi-bt',
		isPopular: false,
	},
	{
		value: 'Bolivia, Plurinational State of',
		label: 'Bolivia, Plurinational State of',
		type: 'country',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'La Paz',
		label: 'La Paz, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Cochabamba',
		label: 'Cochabamba, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Oruro',
		label: 'Oruro, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'A Guarda',
		label: 'A Guarda, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Potosí',
		label: 'Potosí, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Montero',
		label: 'Montero, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Trinidad',
		label: 'Trinidad, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Riberalta',
		label: 'Riberalta, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Cobija',
		label: 'Cobija, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Villamontes',
		label: 'Villamontes, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Puerto Suárez',
		label: 'Puerto Suárez, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santa Fe',
		label: 'Santa Fe, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santiago de Huari',
		label: 'Santiago de Huari, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Abapó',
		label: 'Abapó, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'El Alto',
		label: 'El Alto, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Sucre',
		label: 'Sucre, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Tarija',
		label: 'Tarija, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Yacuíba',
		label: 'Yacuíba, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Guayaramerín',
		label: 'Guayaramerín, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Llallagua',
		label: 'Llallagua, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Villazón',
		label: 'Villazón, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Camiri',
		label: 'Camiri, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Bermejo',
		label: 'Bermejo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Tupiza',
		label: 'Tupiza, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Warnes',
		label: 'Warnes, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Borja',
		label: 'San Borja, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Huanuni',
		label: 'Huanuni, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Cotoca',
		label: 'Cotoca, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Yapacaní',
		label: 'Yapacaní, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Punata',
		label: 'Punata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Mineros',
		label: 'Mineros, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Ascensión',
		label: 'Ascensión, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Caranavi',
		label: 'Caranavi, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'El Torno',
		label: 'El Torno, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Portachuelo',
		label: 'Portachuelo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Uyuni',
		label: 'Uyuni, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'El Carmen',
		label: 'El Carmen, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Roboré',
		label: 'Roboré, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Patacamaya',
		label: 'Patacamaya, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Rurrenabaque',
		label: 'Rurrenabaque, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Puerto Quijarro',
		label: 'Puerto Quijarro, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Valle Grande',
		label: 'Valle Grande, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Challapata',
		label: 'Challapata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Achacachi',
		label: 'Achacachi, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Cliza',
		label: 'Cliza, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Aiquile',
		label: 'Aiquile, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Monteagudo',
		label: 'Monteagudo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Pailón',
		label: 'Pailón, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Kino',
		label: 'Kino, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Julián',
		label: 'San Julián, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Los Reyes',
		label: 'Los Reyes, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Tarata',
		label: 'Tarata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Uncía',
		label: 'Uncía, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Javier',
		label: 'San Javier, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Matías',
		label: 'San Matías, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'La Bélgica',
		label: 'La Bélgica, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Apaseo el Grande',
		label: 'Apaseo el Grande, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Capinota',
		label: 'Capinota, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Camargo',
		label: 'Camargo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Caracollo',
		label: 'Caracollo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Betanzos',
		label: 'Betanzos, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Copacabana',
		label: 'Copacabana, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Okinawa',
		label: 'Okinawa, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Comarapa',
		label: 'Comarapa, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Colquiri',
		label: 'Colquiri, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Chimoré',
		label: 'Chimoré, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Guanay',
		label: 'Guanay, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Mairana',
		label: 'Mairana, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Buena Vista',
		label: 'Buena Vista, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Colomi',
		label: 'Colomi, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Agustín Saavedra',
		label: 'Agustín Saavedra, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Arani',
		label: 'Arani, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Joaquín',
		label: 'San Joaquín, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Jorochito',
		label: 'Jorochito, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Juan',
		label: 'San Juan, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Sipe Sipe',
		label: 'Sipe Sipe, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Lahuachaca',
		label: 'Lahuachaca, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Limoncito',
		label: 'Limoncito, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Samaipata',
		label: 'Samaipata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Urubichá',
		label: 'Urubichá, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Boyuibe',
		label: 'Boyuibe, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Villa Serano',
		label: 'Villa Serano, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Chiautzingo',
		label: 'Chiautzingo, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Padilla',
		label: 'Padilla, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Charagua',
		label: 'Charagua, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Chulumani',
		label: 'Chulumani, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Irpa Irpa',
		label: 'Irpa Irpa, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Los Negros',
		label: 'Los Negros, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Mizque',
		label: 'Mizque, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Tipuani',
		label: 'Tipuani, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Emilio Carranza',
		label: 'Emilio Carranza, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Eucaliptus',
		label: 'Eucaliptus, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Mapiri',
		label: 'Mapiri, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Entre Ríos',
		label: 'Entre Ríos, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Quime',
		label: 'Quime, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Tarabuco',
		label: 'Tarabuco, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Puerto Pailas',
		label: 'Puerto Pailas, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Machacamarca',
		label: 'Machacamarca, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Coroico',
		label: 'Coroico, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Coripata',
		label: 'Coripata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'La Angostura',
		label: 'La Angostura, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Santa Rita',
		label: 'Santa Rita, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Sorata',
		label: 'Sorata, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'San Rafael',
		label: 'San Rafael, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Atocha',
		label: 'Atocha, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Poopó',
		label: 'Poopó, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Colquechaca',
		label: 'Colquechaca, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Viloco',
		label: 'Viloco, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Totoral',
		label: 'Totoral, Bolivia, Plurinational State of',
		type: 'city',
		flagClass: 'fi fi-bo',
		isPopular: false,
	},
	{
		value: 'Bonaire, Sint Eustatius and Saba',
		label: 'Bonaire, Sint Eustatius and Saba',
		type: 'country',
		flagClass: 'fi fi-bq',
		isPopular: false,
	},
	{
		value: 'Bosnia and Herzegovina',
		label: 'Bosnia and Herzegovina',
		type: 'country',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Sarajevo',
		label: 'Sarajevo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Banja Luka',
		label: 'Banja Luka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zenica',
		label: 'Zenica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Tuzla',
		label: 'Tuzla, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mostar',
		label: 'Mostar, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanska Dubica',
		label: 'Bosanska Dubica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bihac',
		label: 'Bihac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Brchko',
		label: 'Brchko, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Doboj',
		label: 'Doboj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bijeljina',
		label: 'Bijeljina, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Cazin',
		label: 'Cazin, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Velika Kladusha',
		label: 'Velika Kladusha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zavidovici',
		label: 'Zavidovici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanski Novi',
		label: 'Bosanski Novi, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kladanj',
		label: 'Kladanj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Janja',
		label: 'Janja, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Pecigrad',
		label: 'Pecigrad, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Prijedor',
		label: 'Prijedor, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Travnik',
		label: 'Travnik, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gorazhde',
		label: 'Gorazhde, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanska Krupa',
		label: 'Bosanska Krupa, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Focha',
		label: 'Focha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gradachac',
		label: 'Gradachac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanska Gradishka',
		label: 'Bosanska Gradishka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Lukavac',
		label: 'Lukavac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kakanj',
		label: 'Kakanj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Chapljina',
		label: 'Chapljina, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Prnjavor',
		label: 'Prnjavor, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Teslic',
		label: 'Teslic, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Modricha',
		label: 'Modricha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosansko Grahovo',
		label: 'Bosansko Grahovo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Poshusje',
		label: 'Poshusje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Busovacha',
		label: 'Busovacha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gornja Koprivna',
		label: 'Gornja Koprivna, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Svodna',
		label: 'Svodna, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Priboj',
		label: 'Priboj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Drinovci',
		label: 'Drinovci, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ilici',
		label: 'Ilici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Pjanici',
		label: 'Pjanici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Olovo',
		label: 'Olovo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Srebrenica',
		label: 'Srebrenica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Stanari',
		label: 'Stanari, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Obudovac',
		label: 'Obudovac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bugojno',
		label: 'Bugojno, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Trebinje',
		label: 'Trebinje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Visoko',
		label: 'Visoko, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Konjic',
		label: 'Konjic, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Grachanica',
		label: 'Grachanica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Široki Brijeg',
		label: 'Široki Brijeg, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Sanski Most',
		label: 'Sanski Most, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mrkonjic Grad',
		label: 'Mrkonjic Grad, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zhivinice',
		label: 'Zhivinice, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bileca',
		label: 'Bileca, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Livno',
		label: 'Livno, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Derventa',
		label: 'Derventa, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Odzhak',
		label: 'Odzhak, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanski Brod',
		label: 'Bosanski Brod, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Novi Travnik',
		label: 'Novi Travnik, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Shipovo',
		label: 'Shipovo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Jajce',
		label: 'Jajce, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Stijena',
		label: 'Stijena, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Prozor',
		label: 'Prozor, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zvornik',
		label: 'Zvornik, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ljubushki',
		label: 'Ljubushki, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Todorovo',
		label: 'Todorovo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vogoshca',
		label: 'Vogoshca, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Lishtica',
		label: 'Lishtica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Potoci',
		label: 'Potoci, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donji Vakuf',
		label: 'Donji Vakuf, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zhepche',
		label: 'Zhepche, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Sokolac',
		label: 'Sokolac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kiseljak',
		label: 'Kiseljak, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mionica',
		label: 'Mionica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vitez',
		label: 'Vitez, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kljuch',
		label: 'Kljuch, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Milici',
		label: 'Milici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Fojnica',
		label: 'Fojnica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Banovici',
		label: 'Banovici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Maglaj',
		label: 'Maglaj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Stolac',
		label: 'Stolac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Trn',
		label: 'Trn, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Hadzhici',
		label: 'Hadzhici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Pale',
		label: 'Pale, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Tomislavgrad',
		label: 'Tomislavgrad, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Visegrád',
		label: 'Visegrád, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Teshanj',
		label: 'Teshanj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Varesh',
		label: 'Varesh, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Nevesinje',
		label: 'Nevesinje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Srbac',
		label: 'Srbac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Buzhim',
		label: 'Buzhim, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Divichani',
		label: 'Divichani, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Hajdarevici',
		label: 'Hajdarevici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Knezhevo',
		label: 'Knezhevo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Djurdjevik',
		label: 'Djurdjevik, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gornji Vakuf',
		label: 'Gornji Vakuf, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Chelinac',
		label: 'Chelinac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vrnograch',
		label: 'Vrnograch, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ilijash',
		label: 'Ilijash, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Srebrenik',
		label: 'Srebrenik, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Trzhachka Rashtela',
		label: 'Trzhachka Rashtela, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Otoka',
		label: 'Otoka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Podzvizd',
		label: 'Podzvizd, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kotor Varosh',
		label: 'Kotor Varosh, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Laktashi',
		label: 'Laktashi, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Tojshici',
		label: 'Tojshici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Varoshka Rijeka',
		label: 'Varoshka Rijeka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gostovici',
		label: 'Gostovici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gromiljak',
		label: 'Gromiljak, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kovachi',
		label: 'Kovachi, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Jablanica',
		label: 'Jablanica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Omarska',
		label: 'Omarska, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Sanica',
		label: 'Sanica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Rogatica',
		label: 'Rogatica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Shekovici',
		label: 'Shekovici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mala Kladusha',
		label: 'Mala Kladusha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kalenderovci',
		label: 'Kalenderovci, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Crnici',
		label: 'Crnici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zheljezno Polje',
		label: 'Zheljezno Polje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bratunac',
		label: 'Bratunac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Podhum',
		label: 'Podhum, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Chitluk',
		label: 'Chitluk, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Teshanjka',
		label: 'Teshanjka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Blatnica',
		label: 'Blatnica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donja Mahala',
		label: 'Donja Mahala, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donja Orahovica',
		label: 'Donja Orahovica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vlasenica',
		label: 'Vlasenica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ostrozhac',
		label: 'Ostrozhac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Rodoch',
		label: 'Rodoch, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Jelah',
		label: 'Jelah, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Turbe',
		label: 'Turbe, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Coralici',
		label: 'Coralici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Velagici',
		label: 'Velagici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanska Kostajnica',
		label: 'Bosanska Kostajnica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mahale',
		label: 'Mahale, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Pazaric',
		label: 'Pazaric, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gornja Tuzla',
		label: 'Gornja Tuzla, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Maslovare',
		label: 'Maslovare, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Solina',
		label: 'Solina, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Kachuni',
		label: 'Kachuni, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Shturlic',
		label: 'Shturlic, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Shumatac',
		label: 'Shumatac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zborishte',
		label: 'Zborishte, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Velika Obarska',
		label: 'Velika Obarska, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Blagaj',
		label: 'Blagaj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Stupari',
		label: 'Stupari, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ustikolina',
		label: 'Ustikolina, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Batkovici',
		label: 'Batkovici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gornje Dubrave',
		label: 'Gornje Dubrave, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gornje Zhivinice',
		label: 'Gornje Zhivinice, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Knezhica',
		label: 'Knezhica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Glamoch',
		label: 'Glamoch, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Grude',
		label: 'Grude, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bila Tserkva',
		label: 'Bila Tserkva, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bosanski Shamac',
		label: 'Bosanski Shamac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Novi Sheher',
		label: 'Novi Sheher, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Lamovita',
		label: 'Lamovita, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Chajniche',
		label: 'Chajniche, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vitína',
		label: 'Vitína, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Jezerski',
		label: 'Jezerski, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Liskovac',
		label: 'Liskovac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Orguz',
		label: 'Orguz, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Stjepan Polje',
		label: 'Stjepan Polje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Han Pjesak',
		label: 'Han Pjesak, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Podvelezh',
		label: 'Podvelezh, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Tolisha',
		label: 'Tolisha, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Zabrishce',
		label: 'Zabrishce, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Hotonj',
		label: 'Hotonj, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Ljubinje',
		label: 'Ljubinje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Sladna',
		label: 'Sladna, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Izachic',
		label: 'Izachic, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Moshtre',
		label: 'Moshtre, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Breza',
		label: 'Breza, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Lukavica',
		label: 'Lukavica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Maglajani',
		label: 'Maglajani, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Pajic Polje',
		label: 'Pajic Polje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Radishici',
		label: 'Radishici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Brestovsko',
		label: 'Brestovsko, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Bronzani Majdan',
		label: 'Bronzani Majdan, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Cim',
		label: 'Cim, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Dobrinje',
		label: 'Dobrinje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gacko',
		label: 'Gacko, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Gnojnica',
		label: 'Gnojnica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Mramor',
		label: 'Mramor, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Careva Cuprija',
		label: 'Careva Cuprija, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Drezhnica',
		label: 'Drezhnica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Orashac',
		label: 'Orashac, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Orashje',
		label: 'Orashje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Oshtra Luka',
		label: 'Oshtra Luka, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Vidoshi',
		label: 'Vidoshi, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donja Dubica',
		label: 'Donja Dubica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Dubravica',
		label: 'Dubravica, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Lokvine',
		label: 'Lokvine, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Podbrdo',
		label: 'Podbrdo, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Chechava',
		label: 'Chechava, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Maleshici',
		label: 'Maleshici, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Barice',
		label: 'Barice, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donja Medjidja',
		label: 'Donja Medjidja, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Donje Dubrave',
		label: 'Donje Dubrave, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Polje',
		label: 'Polje, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Rumboci',
		label: 'Rumboci, Bosnia and Herzegovina',
		type: 'city',
		flagClass: 'fi fi-ba',
		isPopular: false,
	},
	{
		value: 'Botswana',
		label: 'Botswana',
		type: 'country',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Gaborone',
		label: 'Gaborone, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Francistown',
		label: 'Francistown, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Artisia',
		label: 'Artisia, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Selibe Phikwe',
		label: 'Selibe Phikwe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Maun',
		label: 'Maun, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kanye',
		label: 'Kanye, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mogoditshane',
		label: 'Mogoditshane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tutume',
		label: 'Tutume, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Gabane',
		label: 'Gabane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Molepolole',
		label: 'Molepolole, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Serowe',
		label: 'Serowe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tonota',
		label: 'Tonota, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Jwaneng',
		label: 'Jwaneng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Shoshong',
		label: 'Shoshong, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tati',
		label: 'Tati, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lentsweletau',
		label: 'Lentsweletau, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mathangwane',
		label: 'Mathangwane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Hukuntsi',
		label: 'Hukuntsi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Sefophe',
		label: 'Sefophe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kang',
		label: 'Kang, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Moiyabana',
		label: 'Moiyabana, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ramotswa Station-Taung',
		label: 'Ramotswa Station-Taung, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ellisras',
		label: 'Ellisras, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Pandamatenga',
		label: 'Pandamatenga, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tshesebe',
		label: 'Tshesebe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Rakhuna',
		label: 'Rakhuna, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dekar',
		label: 'Dekar, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kalakamati',
		label: 'Kalakamati, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mahalapye',
		label: 'Mahalapye, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mochudi',
		label: 'Mochudi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lobatse',
		label: 'Lobatse, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Palapye',
		label: 'Palapye, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tlokweng',
		label: 'Tlokweng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ramotswa',
		label: 'Ramotswa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Thamaga',
		label: 'Thamaga, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Moshupa',
		label: 'Moshupa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Letlhakane',
		label: 'Letlhakane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bobonong',
		label: 'Bobonong, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mmadinare',
		label: 'Mmadinare, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ghanzi',
		label: 'Ghanzi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Orapa',
		label: 'Orapa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kasane',
		label: 'Kasane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tsabong',
		label: 'Tsabong, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Gumare',
		label: 'Gumare, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Letlhakeng',
		label: 'Letlhakeng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kopong',
		label: 'Kopong, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Maitengwe',
		label: 'Maitengwe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Otse',
		label: 'Otse, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tsienyane',
		label: 'Tsienyane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Shakawe',
		label: 'Shakawe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Natá',
		label: 'Natá, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Metsimotlhaba',
		label: 'Metsimotlhaba, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Gweta',
		label: 'Gweta, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bokaa',
		label: 'Bokaa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mmopane',
		label: 'Mmopane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ramokgonami',
		label: 'Ramokgonami, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mogoditshane Botswana Defence Force',
		label: 'Mogoditshane Botswana Defence Force, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Manyana',
		label: 'Manyana, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Maunatlala',
		label: 'Maunatlala, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Masunga',
		label: 'Masunga, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mopipi',
		label: 'Mopipi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Pitsane',
		label: 'Pitsane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Chadibe',
		label: 'Chadibe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Sowa',
		label: 'Sowa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Sebina',
		label: 'Sebina, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Radisele',
		label: 'Radisele, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mandunyane',
		label: 'Mandunyane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lecheng',
		label: 'Lecheng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mookane',
		label: 'Mookane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ratholo',
		label: 'Ratholo, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Serule',
		label: 'Serule, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kalamare',
		label: 'Kalamare, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Shashe Mooke',
		label: 'Shashe Mooke, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Machaneng',
		label: 'Machaneng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Khakhea',
		label: 'Khakhea, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mmathubudukwane',
		label: 'Mmathubudukwane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Werda',
		label: 'Werda, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dukwi',
		label: 'Dukwi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Khudumelapye',
		label: 'Khudumelapye, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mathathane',
		label: 'Mathathane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mabeleapudi',
		label: 'Mabeleapudi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mogapi',
		label: 'Mogapi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mokobeng',
		label: 'Mokobeng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tobane',
		label: 'Tobane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tsamaya',
		label: 'Tsamaya, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kobojango',
		label: 'Kobojango, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lehututu',
		label: 'Lehututu, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mosetse',
		label: 'Mosetse, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mabule',
		label: 'Mabule, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Makwate',
		label: 'Makwate, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Nokaneng',
		label: 'Nokaneng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Takatokwane',
		label: 'Takatokwane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Ramokgwebana',
		label: 'Ramokgwebana, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Sehithwa',
		label: 'Sehithwa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Nkoyaphiri',
		label: 'Nkoyaphiri, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Matsiloje',
		label: 'Matsiloje, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mogapinyana',
		label: 'Mogapinyana, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Gaphatshwa',
		label: 'Gaphatshwa, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kudumatse',
		label: 'Kudumatse, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lokgwabe',
		label: 'Lokgwabe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Seolwane',
		label: 'Seolwane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tsao',
		label: 'Tsao, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Mohembo West',
		label: 'Mohembo West, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Pilikwe',
		label: 'Pilikwe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Topisi',
		label: 'Topisi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Maape',
		label: 'Maape, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Pilane',
		label: 'Pilane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Magotlhawane',
		label: 'Magotlhawane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Matlhakola',
		label: 'Matlhakola, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Makaleng',
		label: 'Makaleng, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dibete',
		label: 'Dibete, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dinokwe',
		label: 'Dinokwe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Sekoma',
		label: 'Sekoma, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dutlwe',
		label: 'Dutlwe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tamasane',
		label: 'Tamasane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Makobo',
		label: 'Makobo, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Maokane',
		label: 'Maokane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Botlhapatlou',
		label: 'Botlhapatlou, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Kachikau',
		label: 'Kachikau, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Tshane',
		label: 'Tshane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Birsk',
		label: 'Birsk, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Dumadumane',
		label: 'Dumadumane, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Boatlaname',
		label: 'Boatlaname, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Lephepe',
		label: 'Lephepe, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bonwapitse',
		label: 'Bonwapitse, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bokspits',
		label: 'Bokspits, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bogogobo',
		label: 'Bogogobo, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Makalamabedi',
		label: 'Makalamabedi, Botswana',
		type: 'city',
		flagClass: 'fi fi-bw',
		isPopular: false,
	},
	{
		value: 'Bouvet Island',
		label: 'Bouvet Island',
		type: 'country',
		flagClass: 'fi fi-bv',
		isPopular: false,
	},
	{
		value: 'Brazil',
		label: 'Brazil',
		type: 'country',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Paulo',
		label: 'São Paulo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Rio de Janeiro',
		label: 'Rio de Janeiro, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Porto Alegre',
		label: 'Porto Alegre, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Brasília',
		label: 'Brasília, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Abadiania',
		label: 'Abadiania, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Florianópolis',
		label: 'Florianópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Curitiba',
		label: 'Curitiba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Belo Horizonte',
		label: 'Belo Horizonte, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Recife',
		label: 'Recife, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Fortaleza',
		label: 'Fortaleza, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Salvador',
		label: 'Salvador, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Manaus',
		label: 'Manaus, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Joinville',
		label: 'Joinville, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Goiania',
		label: 'Goiania, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Campinas',
		label: 'Campinas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Santos',
		label: 'Santos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Niterói',
		label: 'Niterói, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cuiabá',
		label: 'Cuiabá, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Maringá',
		label: 'Maringá, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Vitória',
		label: 'Vitória, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'João Pessoa',
		label: 'João Pessoa, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São José dos Campos',
		label: 'São José dos Campos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Londrina',
		label: 'Londrina, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Blumenau',
		label: 'Blumenau, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Criciúma',
		label: 'Criciúma, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Natal',
		label: 'Natal, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Bernardo do Campo',
		label: 'São Bernardo do Campo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Maceió',
		label: 'Maceió, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Porto Velho',
		label: 'Porto Velho, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Uberlandia',
		label: 'Uberlandia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Paraná',
		label: 'Paraná, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cascavel',
		label: 'Cascavel, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Campo Grande',
		label: 'Campo Grande, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Goiana',
		label: 'Goiana, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Vila Velha',
		label: 'Vila Velha, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Juiz de Fora',
		label: 'Juiz de Fora, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Bauru',
		label: 'Bauru, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Volta Redonda',
		label: 'Volta Redonda, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ribeirão Preto',
		label: 'Ribeirão Preto, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Santo André',
		label: 'Santo André, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Chapecó',
		label: 'Chapecó, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ipatinga',
		label: 'Ipatinga, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Americana',
		label: 'Americana, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Belém de São Francisco',
		label: 'Belém de São Francisco, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Tubarão',
		label: 'Tubarão, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São José do Rio Preto',
		label: 'São José do Rio Preto, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São José',
		label: 'São José, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Campina Grande',
		label: 'Campina Grande, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Anápolis',
		label: 'Anápolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Itajaí',
		label: 'Itajaí, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Limeira',
		label: 'Limeira, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Novo Hamburgo',
		label: 'Novo Hamburgo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Campos',
		label: 'Campos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Balneário Camboriú',
		label: 'Balneário Camboriú, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Piracicaba',
		label: 'Piracicaba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Jaraguá do Sul',
		label: 'Jaraguá do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Sorocaba',
		label: 'Sorocaba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Aracaju',
		label: 'Aracaju, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Rondonópolis',
		label: 'Rondonópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Caetano do Sul',
		label: 'São Caetano do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Macaé',
		label: 'Macaé, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Foz do Iguaçu',
		label: 'Foz do Iguaçu, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Teresina',
		label: 'Teresina, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Río Claro',
		label: 'Río Claro, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Campo Murão',
		label: 'Campo Murão, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ponta Grossa',
		label: 'Ponta Grossa, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: "Santa Bárbara d'Oeste",
		label: "Santa Bárbara d'Oeste, Brazil",
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Luís',
		label: 'São Luís, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Marília',
		label: 'Marília, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Rio do Sul',
		label: 'Rio do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Paraibano',
		label: 'Paraibano, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Espírito Santo do Pinhal',
		label: 'Espírito Santo do Pinhal, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Osasco',
		label: 'Osasco, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Presidente Prudente',
		label: 'Presidente Prudente, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Timbó',
		label: 'Timbó, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Goiás',
		label: 'Goiás, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Governador Valadares',
		label: 'Governador Valadares, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cachoeiro de Itapemirim',
		label: 'Cachoeiro de Itapemirim, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Lages',
		label: 'Lages, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Palhoça',
		label: 'Palhoça, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Olinda',
		label: 'Olinda, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Pato Branco',
		label: 'Pato Branco, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guarapuava',
		label: 'Guarapuava, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guarulhos',
		label: 'Guarulhos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ananindeua',
		label: 'Ananindeua, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Caxias do Sul',
		label: 'Caxias do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Pelotas',
		label: 'Pelotas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Petrópolis',
		label: 'Petrópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Taguatinga',
		label: 'Taguatinga, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Jacareí',
		label: 'Jacareí, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Xanxerê',
		label: 'Xanxerê, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Barra Mansa',
		label: 'Barra Mansa, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Palmas',
		label: 'Palmas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Nova Friburgo',
		label: 'Nova Friburgo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Braço do Norte',
		label: 'Braço do Norte, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Indaial',
		label: 'Indaial, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Jundiaí',
		label: 'Jundiaí, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Uberaba',
		label: 'Uberaba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Vitória da Conquista',
		label: 'Vitória da Conquista, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Barueri',
		label: 'Barueri, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Carlos',
		label: 'São Carlos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Rio Grande',
		label: 'Rio Grande, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Araraquara',
		label: 'Araraquara, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ceará-Mirim',
		label: 'Ceará-Mirim, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Biguaçu',
		label: 'Biguaçu, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cabo Frio',
		label: 'Cabo Frio, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Içara',
		label: 'Içara, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Araranguá',
		label: 'Araranguá, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Toledo',
		label: 'Toledo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Feira de Santana',
		label: 'Feira de Santana, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Canoas',
		label: 'Canoas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Franca',
		label: 'Franca, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Capivari',
		label: 'Capivari, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Taubaté',
		label: 'Taubaté, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Xique-Xique',
		label: 'Xique-Xique, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Francisco Beltrão',
		label: 'Francisco Beltrão, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ji-Paraná',
		label: 'Ji-Paraná, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Coronel Fabriciano',
		label: 'Coronel Fabriciano, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Orléans',
		label: 'Orléans, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Timóteo',
		label: 'Timóteo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Taboão da Serra',
		label: 'Taboão da Serra, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Santarém',
		label: 'Santarém, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Teresópolis',
		label: 'Teresópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Itapema',
		label: 'Itapema, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Primavera do Leste',
		label: 'Primavera do Leste, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Umuarama',
		label: 'Umuarama, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Brusque',
		label: 'Brusque, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Gonçalo',
		label: 'São Gonçalo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Imbituba',
		label: 'Imbituba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guará',
		label: 'Guará, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cáceres',
		label: 'Cáceres, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Sumaré',
		label: 'Sumaré, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Itaboraí',
		label: 'Itaboraí, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Paranaíba',
		label: 'Paranaíba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Tangará da Serra',
		label: 'Tangará da Serra, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Concórdia',
		label: 'Concórdia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Brasiléia',
		label: 'Brasiléia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guaramirim',
		label: 'Guaramirim, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cubatão',
		label: 'Cubatão, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Varginha',
		label: 'Varginha, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Botucatu',
		label: 'Botucatu, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Atibaia',
		label: 'Atibaia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Araras',
		label: 'Araras, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guaratinguetá',
		label: 'Guaratinguetá, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Santa Cruz do Sul',
		label: 'Santa Cruz do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Ourinhos',
		label: 'Ourinhos, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Porto Seguro',
		label: 'Porto Seguro, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Duque de Caxias',
		label: 'Duque de Caxias, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Moji das Cruzes',
		label: 'Moji das Cruzes, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Montes Claros',
		label: 'Montes Claros, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Guarujá',
		label: 'Guarujá, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Río Branco',
		label: 'Río Branco, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Boa Vista',
		label: 'Boa Vista, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Várzea Grande',
		label: 'Várzea Grande, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Aparecida',
		label: 'Aparecida, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Caruaru',
		label: 'Caruaru, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Francisco do Sul',
		label: 'São Francisco do Sul, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Divinópolis',
		label: 'Divinópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Indaiatuba',
		label: 'Indaiatuba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Dourados',
		label: 'Dourados, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Manga',
		label: 'Manga, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Angra dos Reis',
		label: 'Angra dos Reis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Itu',
		label: 'Itu, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Pomerode',
		label: 'Pomerode, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Mogi Guaçu',
		label: 'Mogi Guaçu, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Bragança Paulista',
		label: 'Bragança Paulista, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Alagoinhas',
		label: 'Alagoinhas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Teixeira de Freitas',
		label: 'Teixeira de Freitas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Catanduva',
		label: 'Catanduva, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Cosmópolis',
		label: 'Cosmópolis, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Linhares',
		label: 'Linhares, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Birigui',
		label: 'Birigui, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Jaboatão',
		label: 'Jaboatão, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Penha',
		label: 'Penha, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Aparecida de Goiania',
		label: 'Aparecida de Goiania, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Paulista',
		label: 'Paulista, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Lins',
		label: 'Lins, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Viçosa',
		label: 'Viçosa, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Gravataí',
		label: 'Gravataí, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São Leopoldo',
		label: 'São Leopoldo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Mandaguari',
		label: 'Mandaguari, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Peruíbe',
		label: 'Peruíbe, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Araçatuba',
		label: 'Araçatuba, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Zé Doca',
		label: 'Zé Doca, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Poços de Caldas',
		label: 'Poços de Caldas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Barra do Garças',
		label: 'Barra do Garças, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Vinhedo',
		label: 'Vinhedo, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Alagoinha',
		label: 'Alagoinha, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Itapetininga',
		label: 'Itapetininga, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Taquaritinga',
		label: 'Taquaritinga, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Patos de Minas',
		label: 'Patos de Minas, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Rolandia',
		label: 'Rolandia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Jaru',
		label: 'Jaru, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Goianésia',
		label: 'Goianésia, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Resende',
		label: 'Resende, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Xaxim',
		label: 'Xaxim, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Mafra',
		label: 'Mafra, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'São João de Meriti',
		label: 'São João de Meriti, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Lorena',
		label: 'Lorena, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'Diadema',
		label: 'Diadema, Brazil',
		type: 'city',
		flagClass: 'fi fi-br',
		isPopular: false,
	},
	{
		value: 'British Indian Ocean Territory',
		label: 'British Indian Ocean Territory',
		type: 'country',
		flagClass: 'fi fi-io',
		isPopular: false,
	},
	{
		value: 'Brunei Darussalam',
		label: 'Brunei Darussalam',
		type: 'country',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Bandar Seri Begawan',
		label: 'Bandar Seri Begawan, Brunei Darussalam',
		type: 'city',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Kuala Belait',
		label: 'Kuala Belait, Brunei Darussalam',
		type: 'city',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Seria',
		label: 'Seria, Brunei Darussalam',
		type: 'city',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Tutong',
		label: 'Tutong, Brunei Darussalam',
		type: 'city',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Bangar',
		label: 'Bangar, Brunei Darussalam',
		type: 'city',
		flagClass: 'fi fi-bn',
		isPopular: false,
	},
	{
		value: 'Bulgaria',
		label: 'Bulgaria',
		type: 'country',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sofia',
		label: 'Sofia, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Varna',
		label: 'Varna, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Plovdiv',
		label: 'Plovdiv, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ruse',
		label: 'Ruse, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ahtopol',
		label: 'Ahtopol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Stara Zagora',
		label: 'Stara Zagora, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pleven',
		label: 'Pleven, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Burgas',
		label: 'Burgas, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Shumen',
		label: 'Shumen, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Jambol',
		label: 'Jambol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Veliko Tarnovo',
		label: 'Veliko Tarnovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pazardzhik',
		label: 'Pazardzhik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Lovech',
		label: 'Lovech, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sliven',
		label: 'Sliven, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Blagoevgrad',
		label: 'Blagoevgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Gabrovo',
		label: 'Gabrovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Vidin',
		label: 'Vidin, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Montana',
		label: 'Montana, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bansko',
		label: 'Bansko, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Beloslav',
		label: 'Beloslav, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Carevo',
		label: 'Carevo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dobrich',
		label: 'Dobrich, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Vraca',
		label: 'Vraca, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kazanlak',
		label: 'Kazanlak, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Razgrad',
		label: 'Razgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Gorna Orjahovica',
		label: 'Gorna Orjahovica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Velingrad',
		label: 'Velingrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sevlievo',
		label: 'Sevlievo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ajtos',
		label: 'Ajtos, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Novi Pazar',
		label: 'Novi Pazar, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Elhovo',
		label: 'Elhovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Zlatograd',
		label: 'Zlatograd, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'General-Toshevo',
		label: 'General-Toshevo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Simitli',
		label: 'Simitli, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Belogradchik',
		label: 'Belogradchik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Belovo',
		label: 'Belovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Batanovci',
		label: 'Batanovci, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pernik',
		label: 'Pernik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Haskovo',
		label: 'Haskovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Asenovgrad',
		label: 'Asenovgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kjustendil',
		label: 'Kjustendil, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dupnica',
		label: 'Dupnica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Svishtov',
		label: 'Svishtov, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Samokov',
		label: 'Samokov, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Botevgrad',
		label: 'Botevgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Karnobat',
		label: 'Karnobat, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Chirpan',
		label: 'Chirpan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Cherven Brjag',
		label: 'Cherven Brjag, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Razlog',
		label: 'Razlog, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ihtiman',
		label: 'Ihtiman, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Balchik',
		label: 'Balchik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sopot',
		label: 'Sopot, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Trjavna',
		label: 'Trjavna, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ljaskovec',
		label: 'Ljaskovec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Krichim',
		label: 'Krichim, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pirdop',
		label: 'Pirdop, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dulovo',
		label: 'Dulovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Straldzha',
		label: 'Straldzha, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Elena',
		label: 'Elena, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Orjahovo',
		label: 'Orjahovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pravec',
		label: 'Pravec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Nedelino',
		label: 'Nedelino, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dragoman',
		label: 'Dragoman, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Opaka',
		label: 'Opaka, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Plachkovci',
		label: 'Plachkovci, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Brezovo',
		label: 'Brezovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kaolinovo',
		label: 'Kaolinovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dimitrovgrad',
		label: 'Dimitrovgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kardzhali',
		label: 'Kardzhali, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Silistra',
		label: 'Silistra, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Targovishte',
		label: 'Targovishte, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Smoljan',
		label: 'Smoljan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Petrich',
		label: 'Petrich, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Lom',
		label: 'Lom, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Leibnitz',
		label: 'Leibnitz, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Karlovo',
		label: 'Karlovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Nova Zagora',
		label: 'Nova Zagora, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Trojan',
		label: 'Trojan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Harmanli',
		label: 'Harmanli, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Peshtera',
		label: 'Peshtera, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Goce Delchev',
		label: 'Goce Delchev, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Panagjurishte',
		label: 'Panagjurishte, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Popovo',
		label: 'Popovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Svilengrad',
		label: 'Svilengrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Rakovski',
		label: 'Rakovski, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Radomir',
		label: 'Radomir, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Parvomaj',
		label: 'Parvomaj, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Berkovica',
		label: 'Berkovica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kozloduj',
		label: 'Kozloduj, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bjala Slatina',
		label: 'Bjala Slatina, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Provadija',
		label: 'Provadija, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Novi Iskar',
		label: 'Novi Iskar, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Radnevo',
		label: 'Radnevo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pomorie',
		label: 'Pomorie, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Knezha',
		label: 'Knezha, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Pavlikeni',
		label: 'Pavlikeni, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Stambolijski',
		label: 'Stambolijski, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Levski',
		label: 'Levski, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Mezdra',
		label: 'Mezdra, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Teteven',
		label: 'Teteven, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kavarna',
		label: 'Kavarna, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kostinbrod',
		label: 'Kostinbrod, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Etropole',
		label: 'Etropole, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Tutrakan',
		label: 'Tutrakan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bjala',
		label: 'Bjala, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Isperih',
		label: 'Isperih, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Lukovit',
		label: 'Lukovit, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kostenec',
		label: 'Kostenec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Belene',
		label: 'Belene, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sredec',
		label: 'Sredec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Galabovo',
		label: 'Galabovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kubrat',
		label: 'Kubrat, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Veliki Preslav',
		label: 'Veliki Preslav, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Septemvri',
		label: 'Septemvri, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Drjanovo',
		label: 'Drjanovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Omurtag',
		label: 'Omurtag, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bankja',
		label: 'Bankja, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Hisarja',
		label: 'Hisarja, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Devnja',
		label: 'Devnja, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Momchilgrad',
		label: 'Momchilgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Rakitovo',
		label: 'Rakitovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Slivnica',
		label: 'Slivnica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ljubimec',
		label: 'Ljubimec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Maricá',
		label: 'Maricá, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bobovdol',
		label: 'Bobovdol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Madan',
		label: 'Madan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Tervel',
		label: 'Tervel, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kotel',
		label: 'Kotel, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Devin',
		label: 'Devin, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Svoge',
		label: 'Svoge, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dolni Chiflik',
		label: 'Dolni Chiflik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Varshec',
		label: 'Varshec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Tvardica',
		label: 'Tvardica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Saedinenie',
		label: 'Saedinenie, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Topolovgrad',
		label: 'Topolovgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Jakoruda',
		label: 'Jakoruda, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Nesebar',
		label: 'Nesebar, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Chepelare',
		label: 'Chepelare, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Krumovgrad',
		label: 'Krumovgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Perushtica',
		label: 'Perushtica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Strazhica',
		label: 'Strazhica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Trashtenik',
		label: 'Trashtenik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kameno',
		label: 'Kameno, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kojnare',
		label: 'Kojnare, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dolni Dabnik',
		label: 'Dolni Dabnik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Polski Trambesh',
		label: 'Polski Trambesh, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Zlatica',
		label: 'Zlatica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dalgopol',
		label: 'Dalgopol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Valchedram',
		label: 'Valchedram, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Vetovo',
		label: 'Vetovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Strelcha',
		label: 'Strelcha, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Elin Pelin',
		label: 'Elin Pelin, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bracigovo',
		label: 'Bracigovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Godech',
		label: 'Godech, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Slavjanovo',
		label: 'Slavjanovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Debelec',
		label: 'Debelec, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dolna Banja',
		label: 'Dolna Banja, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dve Mogili',
		label: 'Dve Mogili, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ivajlovgrad',
		label: 'Ivajlovgrad, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: "Nikopol'",
		label: "Nikopol', Bulgaria",
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Suvorovo',
		label: 'Suvorovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Letnica',
		label: 'Letnica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Smjadovo',
		label: 'Smjadovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Car Kalojan',
		label: 'Car Kalojan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sapareva Banja',
		label: 'Sapareva Banja, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Breznik',
		label: 'Breznik, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Rudozem',
		label: 'Rudozem, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ardino',
		label: 'Ardino, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Mizija',
		label: 'Mizija, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Batak',
		label: 'Batak, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Iskar',
		label: 'Iskar, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Shivachevo',
		label: 'Shivachevo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bozhurishte',
		label: 'Bozhurishte, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Shabla',
		label: 'Shabla, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kula',
		label: 'Kula, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Guljanci',
		label: 'Guljanci, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kalofer',
		label: 'Kalofer, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kresna',
		label: 'Kresna, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Krivodol',
		label: 'Krivodol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Zavet',
		label: 'Zavet, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Maglizh',
		label: 'Maglizh, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sozopol',
		label: 'Sozopol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Aprilci',
		label: 'Aprilci, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dolna Mitropolija',
		label: 'Dolna Mitropolija, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dolna Orjahovica',
		label: 'Dolna Orjahovica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Sungurlare',
		label: 'Sungurlare, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Kaspichan',
		label: 'Kaspichan, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Valchi Dol',
		label: 'Valchi Dol, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Varbica',
		label: 'Varbica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Belica',
		label: 'Belica, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Roman',
		label: 'Roman, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Ugarchin',
		label: 'Ugarchin, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bjala Cherkva',
		label: 'Bjala Cherkva, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Buhovo',
		label: 'Buhovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Dunavci',
		label: 'Dunavci, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Rila',
		label: 'Rila, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Bregovo',
		label: 'Bregovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Gurkovo',
		label: 'Gurkovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Hadzhidimovo',
		label: 'Hadzhidimovo, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Laki',
		label: 'Laki, Bulgaria',
		type: 'city',
		flagClass: 'fi fi-bg',
		isPopular: false,
	},
	{
		value: 'Burkina Faso',
		label: 'Burkina Faso',
		type: 'country',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Ouagadougou',
		label: 'Ouagadougou, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Aribinda',
		label: 'Aribinda, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Bobo Dioulasso',
		label: 'Bobo Dioulasso, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Dori',
		label: 'Dori, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Koudougou',
		label: 'Koudougou, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Kaya',
		label: 'Kaya, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Yako',
		label: 'Yako, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Koloko',
		label: 'Koloko, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Békuy',
		label: 'Békuy, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Ouahigouya',
		label: 'Ouahigouya, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Banfora',
		label: 'Banfora, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Dédougou',
		label: 'Dédougou, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Tenkodogo',
		label: 'Tenkodogo, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: "Fada N'gourma",
		label: "Fada N'gourma, Burkina Faso",
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Réo',
		label: 'Réo, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Houndé',
		label: 'Houndé, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Djibo',
		label: 'Djibo, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Léo',
		label: 'Léo, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Po',
		label: 'Po, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Kongoussi',
		label: 'Kongoussi, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Koupéla',
		label: 'Koupéla, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Zorgo',
		label: 'Zorgo, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Kombissiri',
		label: 'Kombissiri, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Orodara',
		label: 'Orodara, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Boussé',
		label: 'Boussé, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Tougan',
		label: 'Tougan, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Nouna',
		label: 'Nouna, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Manga',
		label: 'Manga, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Borama',
		label: 'Borama, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Boulsa',
		label: 'Boulsa, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Diébougou',
		label: 'Diébougou, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Ziniaré',
		label: 'Ziniaré, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Sindou',
		label: 'Sindou, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Gourcy',
		label: 'Gourcy, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Kantchari',
		label: 'Kantchari, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Bogandé',
		label: 'Bogandé, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Garango',
		label: 'Garango, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Kamthi',
		label: 'Kamthi, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Loropéni',
		label: 'Loropéni, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Louta',
		label: 'Louta, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Gao',
		label: 'Gao, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Gaoua',
		label: 'Gaoua, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Koalla',
		label: 'Koalla, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Pa',
		label: 'Pa, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Dano',
		label: 'Dano, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Gorom-Gorom',
		label: 'Gorom-Gorom, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Diapaga',
		label: 'Diapaga, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Pama',
		label: 'Pama, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Gayéri',
		label: 'Gayéri, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Batié',
		label: 'Batié, Burkina Faso',
		type: 'city',
		flagClass: 'fi fi-bf',
		isPopular: false,
	},
	{
		value: 'Burundi',
		label: 'Burundi',
		type: 'country',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Bujumbura',
		label: 'Bujumbura, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Bubanza',
		label: 'Bubanza, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Cibitoke',
		label: 'Cibitoke, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Kirundo',
		label: 'Kirundo, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Gitega',
		label: 'Gitega, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Ruyigi',
		label: 'Ruyigi, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Karuzi',
		label: 'Karuzi, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Cankuzo',
		label: 'Cankuzo, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Muyinga',
		label: 'Muyinga, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Ngozi',
		label: 'Ngozi, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Kayanza',
		label: 'Kayanza, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Bururi',
		label: 'Bururi, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Rutana',
		label: 'Rutana, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Muramvya',
		label: 'Muramvya, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Makamba',
		label: 'Makamba, Burundi',
		type: 'city',
		flagClass: 'fi fi-bi',
		isPopular: false,
	},
	{
		value: 'Cabo Verde',
		label: 'Cabo Verde',
		type: 'country',
		flagClass: 'fi fi-cv',
		isPopular: false,
	},
	{
		value: 'Cambodia',
		label: 'Cambodia',
		type: 'country',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Phnom Penh',
		label: 'Phnom Penh, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Banlung',
		label: 'Banlung, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Siem Reap',
		label: 'Siem Reap, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kampot',
		label: 'Kampot, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Bat Dambang',
		label: 'Bat Dambang, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Preah Sihanouk',
		label: 'Preah Sihanouk, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kampóng Spoeu',
		label: 'Kampóng Spoeu, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Prey Veaeng',
		label: 'Prey Veaeng, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kampóng Cham',
		label: 'Kampóng Cham, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kandal',
		label: 'Kandal, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Pousat',
		label: 'Pousat, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Phumi Samraong',
		label: 'Phumi Samraong, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Svay Rieng',
		label: 'Svay Rieng, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Senmonorom',
		label: 'Senmonorom, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Phumi Takaev',
		label: 'Phumi Takaev, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kampóng Chhnang',
		label: 'Kampóng Chhnang, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Sisophon',
		label: 'Sisophon, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Krachéh',
		label: 'Krachéh, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Kampóng Thum',
		label: 'Kampóng Thum, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Dong Tong',
		label: 'Dong Tong, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Krong Kaeb',
		label: 'Krong Kaeb, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Stueng Traeng',
		label: 'Stueng Traeng, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Krong Pailin',
		label: 'Krong Pailin, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Tbeng Mean Chey',
		label: 'Tbeng Mean Chey, Cambodia',
		type: 'city',
		flagClass: 'fi fi-kh',
		isPopular: false,
	},
	{
		value: 'Cameroon',
		label: 'Cameroon',
		type: 'country',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Douala',
		label: 'Douala, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Yaoundé',
		label: 'Yaoundé, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bamenda',
		label: 'Bamenda, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Buéa',
		label: 'Buéa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Abong Mbang',
		label: 'Abong Mbang, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Kribi',
		label: 'Kribi, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Tiko',
		label: 'Tiko, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Kumba',
		label: 'Kumba, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bafoussam',
		label: 'Bafoussam, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Kumbo',
		label: 'Kumbo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Garoua',
		label: 'Garoua, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Edéa',
		label: 'Edéa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Muyuka',
		label: 'Muyuka, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bana',
		label: 'Bana, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mbalmayo',
		label: 'Mbalmayo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mamfé',
		label: 'Mamfé, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Ngaoundéré',
		label: 'Ngaoundéré, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Nkongsamba',
		label: 'Nkongsamba, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Kaélé',
		label: 'Kaélé, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bafang',
		label: 'Bafang, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Lomié',
		label: 'Lomié, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Wum',
		label: 'Wum, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Idenao',
		label: 'Idenao, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Obala',
		label: 'Obala, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Djoum',
		label: 'Djoum, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Monatélé',
		label: 'Monatélé, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Lolodorf',
		label: 'Lolodorf, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mbengwi',
		label: 'Mbengwi, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Limbe',
		label: 'Limbe, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Kousséri',
		label: 'Kousséri, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Maroua',
		label: 'Maroua, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mokolo',
		label: 'Mokolo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bertoua',
		label: 'Bertoua, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Loum',
		label: 'Loum, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Foumban',
		label: 'Foumban, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Garoafa',
		label: 'Garoafa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Ebolowa',
		label: 'Ebolowa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Djang',
		label: 'Djang, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bafia',
		label: 'Bafia, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Yokadouma',
		label: 'Yokadouma, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Guider',
		label: 'Guider, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mbouda',
		label: 'Mbouda, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Sangmélima',
		label: 'Sangmélima, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Yagoua',
		label: 'Yagoua, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mbanga',
		label: 'Mbanga, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Moloundou',
		label: 'Moloundou, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Yabassi',
		label: 'Yabassi, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bangangte',
		label: 'Bangangte, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Akonolinga',
		label: 'Akonolinga, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Foumbot',
		label: 'Foumbot, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Banyo',
		label: 'Banyo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Dibombari',
		label: 'Dibombari, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Eséka',
		label: 'Eséka, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bogo',
		label: 'Bogo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Nanga Eboko',
		label: 'Nanga Eboko, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Manjo',
		label: 'Manjo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Batouri',
		label: 'Batouri, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Meiganga',
		label: 'Meiganga, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Njinikom',
		label: 'Njinikom, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Nkambe',
		label: 'Nkambe, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mindif',
		label: 'Mindif, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bafut',
		label: 'Bafut, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Colón',
		label: 'Colón, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bali',
		label: 'Bali, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bonabéri',
		label: 'Bonabéri, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mvangué',
		label: 'Mvangué, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Lagdo',
		label: 'Lagdo, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Bétaré Oya',
		label: 'Bétaré Oya, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Figuif',
		label: 'Figuif, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Tcholliré',
		label: 'Tcholliré, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Akom',
		label: 'Akom, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mfou',
		label: 'Mfou, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Tibati',
		label: 'Tibati, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Mme',
		label: 'Mme, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Fontem',
		label: 'Fontem, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Saa',
		label: 'Saa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Ombésa',
		label: 'Ombésa, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Doumé',
		label: 'Doumé, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Istanbul',
		label: 'Istanbul, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Rey Bouba',
		label: 'Rey Bouba, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Ambam',
		label: 'Ambam, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Méri',
		label: 'Méri, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Tignère',
		label: 'Tignère, Cameroon',
		type: 'city',
		flagClass: 'fi fi-cm',
		isPopular: false,
	},
	{
		value: 'Canada',
		label: 'Canada',
		type: 'country',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Toronto',
		label: 'Toronto, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Vancouver',
		label: 'Vancouver, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Calgary',
		label: 'Calgary, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Montréal',
		label: 'Montréal, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Ottawa',
		label: 'Ottawa, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Edmonton',
		label: 'Edmonton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'North York',
		label: 'North York, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Mississauga',
		label: 'Mississauga, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Winnipeg',
		label: 'Winnipeg, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Burnaby',
		label: 'Burnaby, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Surrey',
		label: 'Surrey, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Scarborough',
		label: 'Scarborough, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Etobicoke',
		label: 'Etobicoke, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Brampton',
		label: 'Brampton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Halifax',
		label: 'Halifax, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Richmond',
		label: 'Richmond, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Burlington',
		label: 'Burlington, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Oakville',
		label: 'Oakville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'North Vancouver',
		label: 'North Vancouver, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Coquitlam',
		label: 'Coquitlam, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Hamilton',
		label: 'Hamilton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Waterloo',
		label: 'Waterloo, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Oshawa',
		label: 'Oshawa, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Richmond Hill',
		label: 'Richmond Hill, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kitchener',
		label: 'Kitchener, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Markham',
		label: 'Markham, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'York',
		label: 'York, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Maple Ridge',
		label: 'Maple Ridge, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kelowna',
		label: 'Kelowna, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Nepean',
		label: 'Nepean, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saskatoon',
		label: 'Saskatoon, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'East York',
		label: 'East York, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'New Westminster',
		label: 'New Westminster, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Thornhill',
		label: 'Thornhill, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Langley',
		label: 'Langley, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Guelph',
		label: 'Guelph, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Whitby',
		label: 'Whitby, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Barrie',
		label: 'Barrie, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Peterborough',
		label: 'Peterborough, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Abbotsford',
		label: 'Abbotsford, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Fredericton',
		label: 'Fredericton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Gatineau',
		label: 'Gatineau, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Nanaimo',
		label: 'Nanaimo, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Pickering',
		label: 'Pickering, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Fort McMurray',
		label: 'Fort McMurray, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Regina',
		label: 'Regina, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Delta',
		label: 'Delta, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'St Catharines',
		label: 'St Catharines, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Ajax',
		label: 'Ajax, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kanata',
		label: 'Kanata, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Port Coquitlam',
		label: 'Port Coquitlam, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Windsor',
		label: 'Windsor, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Laval',
		label: 'Laval, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sherwood Park',
		label: 'Sherwood Park, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Red Deer',
		label: 'Red Deer, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Chilliwack',
		label: 'Chilliwack, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Orangeville',
		label: 'Orangeville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cambridge',
		label: 'Cambridge, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Orléans',
		label: 'Orléans, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Airdrie',
		label: 'Airdrie, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Moncton',
		label: 'Moncton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Dartmouth',
		label: 'Dartmouth, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Newmarket',
		label: 'Newmarket, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Port Moody',
		label: 'Port Moody, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'West Vancouver',
		label: 'West Vancouver, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'St Albert',
		label: 'St Albert, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Verdun',
		label: 'Verdun, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Woodbridge',
		label: 'Woodbridge, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint-Laurent',
		label: 'Saint-Laurent, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Gloucester',
		label: 'Gloucester, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kamloops',
		label: 'Kamloops, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lethbridge',
		label: 'Lethbridge, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'White Rock',
		label: 'White Rock, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Aurora',
		label: 'Aurora, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kingston',
		label: 'Kingston, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Brantford',
		label: 'Brantford, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Dollard-des-Ormeaux',
		label: 'Dollard-des-Ormeaux, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Pitt Meadows',
		label: 'Pitt Meadows, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Pierrefonds',
		label: 'Pierrefonds, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lasalle',
		label: 'Lasalle, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Pointe-Claire',
		label: 'Pointe-Claire, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Québec',
		label: 'Québec, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Brossard',
		label: 'Brossard, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Milton',
		label: 'Milton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Niagara Falls',
		label: 'Niagara Falls, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Vernon',
		label: 'Vernon, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Grande Prairie',
		label: 'Grande Prairie, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Mission',
		label: 'Mission, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint John',
		label: 'Saint John, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Bowmanville',
		label: 'Bowmanville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Westmount',
		label: 'Westmount, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sudbury',
		label: 'Sudbury, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Georgetown',
		label: 'Georgetown, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Côte Saint-Luc',
		label: 'Côte Saint-Luc, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Concord',
		label: 'Concord, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint-Léonard',
		label: 'Saint-Léonard, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Stoney Creek',
		label: 'Stoney Creek, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Leduc',
		label: 'Leduc, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Longueuil',
		label: 'Longueuil, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Duncan',
		label: 'Duncan, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lachine',
		label: 'Lachine, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Dorval',
		label: 'Dorval, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Maple',
		label: 'Maple, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Kirkland',
		label: 'Kirkland, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Stittsville',
		label: 'Stittsville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Okotoks',
		label: 'Okotoks, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Dundas',
		label: 'Dundas, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Prince George',
		label: 'Prince George, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sarnia',
		label: 'Sarnia, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: "St. John's",
		label: "St. John's, Canada",
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Aldergrove',
		label: 'Aldergrove, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Spruce Grove',
		label: 'Spruce Grove, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Penticton',
		label: 'Penticton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Medicine Hat',
		label: 'Medicine Hat, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Thunder Bay',
		label: 'Thunder Bay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Outremont',
		label: 'Outremont, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Canmore',
		label: 'Canmore, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Beaconsfield',
		label: 'Beaconsfield, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Welland',
		label: 'Welland, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Campbell River',
		label: 'Campbell River, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Courtice',
		label: 'Courtice, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Riverview',
		label: 'Riverview, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Vanier',
		label: 'Vanier, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Courtenay',
		label: 'Courtenay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Belleville',
		label: 'Belleville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Bolton',
		label: 'Bolton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'North Bay',
		label: 'North Bay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Charlottetown',
		label: 'Charlottetown, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Grimsby',
		label: 'Grimsby, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lower Sackville',
		label: 'Lower Sackville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Westbank',
		label: 'Westbank, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Brandon',
		label: 'Brandon, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cornwall',
		label: 'Cornwall, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint-Hubert',
		label: 'Saint-Hubert, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Stony Plain',
		label: 'Stony Plain, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Beaumont',
		label: 'Beaumont, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Vaudreuil-Dorion',
		label: 'Vaudreuil-Dorion, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sooke',
		label: 'Sooke, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Orillia',
		label: 'Orillia, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cochrane',
		label: 'Cochrane, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sherbrooke',
		label: 'Sherbrooke, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Montréal-Nord',
		label: 'Montréal-Nord, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Comox',
		label: 'Comox, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Dieppe',
		label: 'Dieppe, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Whistler',
		label: 'Whistler, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Salt Spring Island',
		label: 'Salt Spring Island, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Stratford',
		label: 'Stratford, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cobourg',
		label: 'Cobourg, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Terrace',
		label: 'Terrace, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Ancaster',
		label: 'Ancaster, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint-Lazare',
		label: 'Saint-Lazare, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Thorold',
		label: 'Thorold, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Keswick',
		label: 'Keswick, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Chestermere',
		label: 'Chestermere, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cantley',
		label: 'Cantley, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Châteauguay',
		label: 'Châteauguay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Innisfil',
		label: 'Innisfil, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Nelson',
		label: 'Nelson, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Montréal-Ouest',
		label: 'Montréal-Ouest, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Mont-Royal',
		label: 'Mont-Royal, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'St Thomas',
		label: 'St Thomas, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Qualicum Beach',
		label: 'Qualicum Beach, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Moose Jaw',
		label: 'Moose Jaw, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Bradford',
		label: 'Bradford, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Quesnel',
		label: 'Quesnel, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Holland Landing',
		label: 'Holland Landing, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sidney',
		label: 'Sidney, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Bedford',
		label: 'Bedford, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Stouffville',
		label: 'Stouffville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Waterdown',
		label: 'Waterdown, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Woodstock',
		label: 'Woodstock, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Anjou',
		label: 'Anjou, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Fort Saskatchewan',
		label: 'Fort Saskatchewan, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Camrose',
		label: 'Camrose, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Yellowknife',
		label: 'Yellowknife, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Mill Bay',
		label: 'Mill Bay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Pembroke',
		label: 'Pembroke, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Beamsville',
		label: 'Beamsville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Chatham',
		label: 'Chatham, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Sault Ste Marie',
		label: 'Sault Ste Marie, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Saint-Lambert',
		label: 'Saint-Lambert, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Port Alberni',
		label: 'Port Alberni, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Powell River',
		label: 'Powell River, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Truro',
		label: 'Truro, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Uxbridge',
		label: 'Uxbridge, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Squamish',
		label: 'Squamish, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lakefield',
		label: 'Lakefield, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Lindsay',
		label: 'Lindsay, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Greenfield Park',
		label: 'Greenfield Park, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Whitehorse',
		label: 'Whitehorse, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'High River',
		label: 'High River, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Morinville',
		label: 'Morinville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Strathmore',
		label: 'Strathmore, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Shawnigan Lake',
		label: 'Shawnigan Lake, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Parksville',
		label: 'Parksville, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Edson',
		label: 'Edson, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Trenton',
		label: 'Trenton, Canada',
		type: 'city',
		flagClass: 'fi fi-ca',
		isPopular: false,
	},
	{
		value: 'Cayman Islands',
		label: 'Cayman Islands',
		type: 'country',
		flagClass: 'fi fi-ky',
		isPopular: false,
	},
	{
		value: 'George Town',
		label: 'George Town, Cayman Islands',
		type: 'city',
		flagClass: 'fi fi-ky',
		isPopular: false,
	},
	{
		value: 'Bodden Town',
		label: 'Bodden Town, Cayman Islands',
		type: 'city',
		flagClass: 'fi fi-ky',
		isPopular: false,
	},
	{
		value: 'West Bay',
		label: 'West Bay, Cayman Islands',
		type: 'city',
		flagClass: 'fi fi-ky',
		isPopular: false,
	},
	{
		value: 'Central African Republic',
		label: 'Central African Republic',
		type: 'country',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Alindao',
		label: 'Alindao, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Kembé',
		label: 'Kembé, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bangui',
		label: 'Bangui, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Carnot',
		label: 'Carnot, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bouar',
		label: 'Bouar, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Kaga-Bandoro',
		label: 'Kaga-Bandoro, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bocaranga',
		label: 'Bocaranga, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Gambo',
		label: 'Gambo, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Zemio',
		label: 'Zemio, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Boali',
		label: 'Boali, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Obo',
		label: 'Obo, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Berbérati',
		label: 'Berbérati, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bambari',
		label: 'Bambari, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bossangoa',
		label: 'Bossangoa, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bria',
		label: 'Bria, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bimbo',
		label: 'Bimbo, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Nola',
		label: 'Nola, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bozoum',
		label: 'Bozoum, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bangassou',
		label: 'Bangassou, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Mbaiki',
		label: 'Mbaiki, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Sibut',
		label: 'Sibut, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Rafaï',
		label: 'Rafaï, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Ippy',
		label: 'Ippy, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bossembélé',
		label: 'Bossembélé, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Paoua',
		label: 'Paoua, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Batangafo',
		label: 'Batangafo, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Boda',
		label: 'Boda, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Kabo',
		label: 'Kabo, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Bouca',
		label: 'Bouca, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Dekoa',
		label: 'Dekoa, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Grimari',
		label: 'Grimari, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Ndélé',
		label: 'Ndélé, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Damara',
		label: 'Damara, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Baboua',
		label: 'Baboua, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Yakolé',
		label: 'Yakolé, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Ouango',
		label: 'Ouango, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Gamboula',
		label: 'Gamboula, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Baoro',
		label: 'Baoro, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Kouango',
		label: 'Kouango, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Mongoumba',
		label: 'Mongoumba, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Mobaye',
		label: 'Mobaye, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Birao',
		label: 'Birao, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Ouadda',
		label: 'Ouadda, Central African Republic',
		type: 'city',
		flagClass: 'fi fi-cf',
		isPopular: false,
	},
	{
		value: 'Chad',
		label: 'Chad',
		type: 'country',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: "N'Djaména",
		label: "N'Djaména, Chad",
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Abéché',
		label: 'Abéché, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Sarh',
		label: 'Sarh, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bénoy',
		label: 'Bénoy, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Å',
		label: 'Å, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Moundou',
		label: 'Moundou, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Kélo',
		label: 'Kélo, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Koumra',
		label: 'Koumra, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Pala',
		label: 'Pala, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Am Timan',
		label: 'Am Timan, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bongor',
		label: 'Bongor, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Mongo',
		label: 'Mongo, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Doba',
		label: 'Doba, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Ati',
		label: 'Ati, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Laï',
		label: 'Laï, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Oum Hadjer',
		label: 'Oum Hadjer, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bitkine',
		label: 'Bitkine, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Mahón',
		label: 'Mahón, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Massaguet',
		label: 'Massaguet, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Dourbali',
		label: 'Dourbali, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Léré',
		label: 'Léré, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Kyabé',
		label: 'Kyabé, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Daga',
		label: 'Daga, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Moussoro',
		label: 'Moussoro, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Béré',
		label: 'Béré, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bokoro',
		label: 'Bokoro, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bousso',
		label: 'Bousso, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Faya',
		label: 'Faya, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Fianga',
		label: 'Fianga, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bébidjia',
		label: 'Bébidjia, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Ngama',
		label: 'Ngama, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Adré',
		label: 'Adré, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Guélengdeng',
		label: 'Guélengdeng, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Moïssala',
		label: 'Moïssala, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Biltine',
		label: 'Biltine, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bol',
		label: 'Bol, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Goundi',
		label: 'Goundi, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Gounou Gaya',
		label: 'Gounou Gaya, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Beinamar',
		label: 'Beinamar, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Baïbokoum',
		label: 'Baïbokoum, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Melfi',
		label: 'Melfi, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Béboto',
		label: 'Béboto, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Mangueigne',
		label: 'Mangueigne, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Massenya',
		label: 'Massenya, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: "Fada N'gourma",
		label: "Fada N'gourma, Chad",
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Abou Deia',
		label: 'Abou Deia, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Am Dam',
		label: 'Am Dam, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Bardaï',
		label: 'Bardaï, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Rig-Rig',
		label: 'Rig-Rig, Chad',
		type: 'city',
		flagClass: 'fi fi-td',
		isPopular: false,
	},
	{
		value: 'Chile',
		label: 'Chile',
		type: 'country',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Temuco',
		label: 'Temuco, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Valparaíso',
		label: 'Valparaíso, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Viña del Mar',
		label: 'Viña del Mar, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Antofagasta',
		label: 'Antofagasta, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Iquique',
		label: 'Iquique, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Arica',
		label: 'Arica, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Chillán',
		label: 'Chillán, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Talca',
		label: 'Talca, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Rancagua',
		label: 'Rancagua, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Ancud',
		label: 'Ancud, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Valdivia',
		label: 'Valdivia, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Puerto Montt',
		label: 'Puerto Montt, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Puente Alto',
		label: 'Puente Alto, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Osorno',
		label: 'Osorno, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'La Serena',
		label: 'La Serena, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Talcahuano',
		label: 'Talcahuano, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Quilpué',
		label: 'Quilpué, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Punta Arenas',
		label: 'Punta Arenas, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Villa Alemana',
		label: 'Villa Alemana, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Coquimbo',
		label: 'Coquimbo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Los Ángeles',
		label: 'Los Ángeles, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Calama',
		label: 'Calama, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Copiapó',
		label: 'Copiapó, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Linares',
		label: 'Linares, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Curicó',
		label: 'Curicó, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Coronel',
		label: 'Coronel, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Puerto Varas',
		label: 'Puerto Varas, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Bernardo Viento',
		label: 'San Bernardo Viento, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Talagante',
		label: 'Talagante, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Chiguayante',
		label: 'Chiguayante, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Quillota',
		label: 'Quillota, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Los Andes',
		label: 'Los Andes, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Castro',
		label: 'Castro, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Angol',
		label: 'Angol, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Melipilla',
		label: 'Melipilla, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Coihaique',
		label: 'Coihaique, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Fernando',
		label: 'San Fernando, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'La Unión',
		label: 'La Unión, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Tomé',
		label: 'Tomé, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Villarica',
		label: 'Villarica, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Peñaflor',
		label: 'Peñaflor, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Ovalle',
		label: 'Ovalle, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Felipe',
		label: 'San Felipe, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Calera',
		label: 'Calera, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Pedro de la Paz',
		label: 'San Pedro de la Paz, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Rengo',
		label: 'Rengo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Curanilahue',
		label: 'Curanilahue, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Cañete',
		label: 'Cañete, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Illapel',
		label: 'Illapel, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Padre Hurtado',
		label: 'Padre Hurtado, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Machalí',
		label: 'Machalí, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Buin',
		label: 'Buin, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Limache',
		label: 'Limache, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Concón',
		label: 'Concón, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Carahue',
		label: 'Carahue, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Colina',
		label: 'Colina, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Vallenar',
		label: 'Vallenar, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Cauquenes',
		label: 'Cauquenes, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Isla de Maipo',
		label: 'Isla de Maipo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Collipulli',
		label: 'Collipulli, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Padre las Casas',
		label: 'Padre las Casas, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Constitución',
		label: 'Constitución, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Penco',
		label: 'Penco, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Arauco',
		label: 'Arauco, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Javier',
		label: 'San Javier, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Salamanca',
		label: 'Salamanca, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Taltal',
		label: 'Taltal, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Paine',
		label: 'Paine, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Lota',
		label: 'Lota, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Vicente',
		label: 'San Vicente, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Río Bueno',
		label: 'Río Bueno, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Lautaro',
		label: 'Lautaro, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Graneros',
		label: 'Graneros, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Freire',
		label: 'Freire, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Tocopilla',
		label: 'Tocopilla, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Coihueco',
		label: 'Coihueco, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Bulnes',
		label: 'Bulnes, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Traiguén',
		label: 'Traiguén, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Nueva Imperial',
		label: 'Nueva Imperial, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Panguipulli',
		label: 'Panguipulli, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Chimbarongo',
		label: 'Chimbarongo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'La Ligua',
		label: 'La Ligua, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Longaví',
		label: 'Longaví, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'El Monte',
		label: 'El Monte, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Puerto Aisén',
		label: 'Puerto Aisén, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Lebu',
		label: 'Lebu, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Vicuña',
		label: 'Vicuña, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Loncoche',
		label: 'Loncoche, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Vilcún',
		label: 'Vilcún, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Pitrufquén',
		label: 'Pitrufquén, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Yumbel',
		label: 'Yumbel, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Purranque',
		label: 'Purranque, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Cabildo',
		label: 'Cabildo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Diego de Almagro',
		label: 'Diego de Almagro, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Lampa',
		label: 'Lampa, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Hidalgo',
		label: 'Hidalgo, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'San Clemente',
		label: 'San Clemente, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Calbuco',
		label: 'Calbuco, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Nacimiento',
		label: 'Nacimiento, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Cabrero',
		label: 'Cabrero, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Laja',
		label: 'Laja, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Llaillay',
		label: 'Llaillay, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Molina',
		label: 'Molina, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Monte Patria',
		label: 'Monte Patria, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Mulchén',
		label: 'Mulchén, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'Teno',
		label: 'Teno, Chile',
		type: 'city',
		flagClass: 'fi fi-cl',
		isPopular: false,
	},
	{
		value: 'China',
		label: 'China',
		type: 'country',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shanghai',
		label: 'Shanghai, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Beijing',
		label: 'Beijing, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Acheng',
		label: 'Acheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shenzhen',
		label: 'Shenzhen, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Guangzhou',
		label: 'Guangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Chengdu',
		label: 'Chengdu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dalian',
		label: 'Dalian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xiamen',
		label: 'Xiamen, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nanjing',
		label: 'Nanjing, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hangzhou',
		label: 'Hangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shenyang',
		label: 'Shenyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Qingdao',
		label: 'Qingdao, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wuhan',
		label: 'Wuhan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dongguan',
		label: 'Dongguan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Suzhou',
		label: 'Suzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Tianjin',
		label: 'Tianjin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xian',
		label: 'Xian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Chongqing',
		label: 'Chongqing, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Kunming',
		label: 'Kunming, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changzhou',
		label: 'Changzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhuhai',
		label: 'Zhuhai, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhengzhou',
		label: 'Zhengzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Ningbo',
		label: 'Ningbo, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinan',
		label: 'Jinan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wuxi',
		label: 'Wuxi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Gangdong',
		label: 'Gangdong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changchun',
		label: 'Changchun, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changsha',
		label: 'Changsha, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wenzhou',
		label: 'Wenzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Quanzhou',
		label: 'Quanzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Honggang',
		label: 'Honggang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Guilin',
		label: 'Guilin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yantai',
		label: 'Yantai, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiading',
		label: 'Jiading, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Harbin',
		label: 'Harbin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Taiyuan',
		label: 'Taiyuan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fuzhou',
		label: 'Fuzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Aomen',
		label: 'Aomen, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shangrao',
		label: 'Shangrao, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shatin',
		label: 'Shatin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Weifang',
		label: 'Weifang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Haian',
		label: 'Haian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Ganzhou',
		label: 'Ganzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinhua',
		label: 'Jinhua, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hanzhong',
		label: 'Hanzhong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shijiazhuang',
		label: 'Shijiazhuang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Handan',
		label: 'Handan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hongmei',
		label: 'Hongmei, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yangzhou',
		label: 'Yangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Baishishan',
		label: 'Baishishan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Foshan',
		label: 'Foshan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zunyi',
		label: 'Zunyi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changde',
		label: 'Changde, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nantong',
		label: 'Nantong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhangzhou',
		label: 'Zhangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fujin',
		label: 'Fujin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shangqiu',
		label: 'Shangqiu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Laizhou',
		label: 'Laizhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Korla',
		label: 'Korla, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Lanzhou',
		label: 'Lanzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jilin',
		label: 'Jilin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Aksu',
		label: 'Aksu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hefei',
		label: 'Hefei, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fuxin',
		label: 'Fuxin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hegang',
		label: 'Hegang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Langfang',
		label: 'Langfang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Anyang',
		label: 'Anyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Baoding',
		label: 'Baoding, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dandong',
		label: 'Dandong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiamusi',
		label: 'Jiamusi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xinxiang',
		label: 'Xinxiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Tunxi',
		label: 'Tunxi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wuhu',
		label: 'Wuhu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinchang',
		label: 'Jinchang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Huangzhou',
		label: 'Huangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Bijie',
		label: 'Bijie, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhilong',
		label: 'Zhilong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yichang',
		label: 'Yichang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Gaozhou',
		label: 'Gaozhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changzhi',
		label: 'Changzhi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Tangjiazhuang',
		label: 'Tangjiazhuang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Liaoyuan',
		label: 'Liaoyuan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Songhua',
		label: 'Songhua, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hulan',
		label: 'Hulan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Taonan',
		label: 'Taonan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Anjiang',
		label: 'Anjiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Changping',
		label: 'Changping, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Anqing',
		label: 'Anqing, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Taian',
		label: 'Taian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhenjiang',
		label: 'Zhenjiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jingdezhen',
		label: 'Jingdezhen, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhongshan',
		label: 'Zhongshan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dehui',
		label: 'Dehui, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Sucheng',
		label: 'Sucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Qinhuangdao',
		label: 'Qinhuangdao, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhucheng',
		label: 'Zhucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shahe',
		label: 'Shahe, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xiongzhou',
		label: 'Xiongzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zigong',
		label: 'Zigong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wuzhou',
		label: 'Wuzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Linyi',
		label: 'Linyi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Wucheng',
		label: 'Wucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Heze',
		label: 'Heze, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shaoguan',
		label: 'Shaoguan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Weihai',
		label: 'Weihai, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Aojiang',
		label: 'Aojiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Erenhot',
		label: 'Erenhot, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Laohekou',
		label: 'Laohekou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Cangzhou',
		label: 'Cangzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xilinhaote',
		label: 'Xilinhaote, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hebi',
		label: 'Hebi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiangmen',
		label: 'Jiangmen, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhoucheng',
		label: 'Zhoucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Guangkou',
		label: 'Guangkou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shaoxing',
		label: 'Shaoxing, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nanping',
		label: 'Nanping, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Caohe',
		label: 'Caohe, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zaozhuang',
		label: 'Zaozhuang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jingzhou',
		label: 'Jingzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Baiyin',
		label: 'Baiyin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fushan',
		label: 'Fushan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Bianzhuang',
		label: 'Bianzhuang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Huanggang',
		label: 'Huanggang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Beipiao',
		label: 'Beipiao, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fuyang',
		label: 'Fuyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xiaogan',
		label: 'Xiaogan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shangzhi',
		label: 'Shangzhi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hongan',
		label: 'Hongan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dengzhou',
		label: 'Dengzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Alihe',
		label: 'Alihe, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Choucheng',
		label: 'Choucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hainan',
		label: 'Hainan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Honghu',
		label: 'Honghu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiulong',
		label: 'Jiulong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xinzhou',
		label: 'Xinzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhongshu',
		label: 'Zhongshu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Quzhou',
		label: 'Quzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nanning',
		label: 'Nanning, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Botou',
		label: 'Botou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Luoyang',
		label: 'Luoyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Huaihua',
		label: 'Huaihua, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shanhetun',
		label: 'Shanhetun, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Huangshi',
		label: 'Huangshi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Anxiang',
		label: 'Anxiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinzhou',
		label: 'Jinzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Puqi',
		label: 'Puqi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hanting',
		label: 'Hanting, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yigou',
		label: 'Yigou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yakeshi',
		label: 'Yakeshi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Lushunkou',
		label: 'Lushunkou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Baoshan',
		label: 'Baoshan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hecun',
		label: 'Hecun, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Longkou',
		label: 'Longkou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Toutunhe',
		label: 'Toutunhe, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yingkou',
		label: 'Yingkou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiupu',
		label: 'Jiupu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinshi',
		label: 'Jinshi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Matian',
		label: 'Matian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Mudanjiang',
		label: 'Mudanjiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yongan',
		label: 'Yongan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jinxiang',
		label: 'Jinxiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jincheng',
		label: 'Jincheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Kaifeng',
		label: 'Kaifeng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dongshan',
		label: 'Dongshan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Suileng',
		label: 'Suileng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Liaoyang',
		label: 'Liaoyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Pingxiang',
		label: 'Pingxiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jishui',
		label: 'Jishui, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jijiang',
		label: 'Jijiang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Sanmenxia',
		label: 'Sanmenxia, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nanhai',
		label: 'Nanhai, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Tongshan',
		label: 'Tongshan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Hengyang',
		label: 'Hengyang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yushu',
		label: 'Yushu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xucheng',
		label: 'Xucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Nancha',
		label: 'Nancha, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shenxian',
		label: 'Shenxian, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yashan',
		label: 'Yashan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Linchuan',
		label: 'Linchuan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shilong',
		label: 'Shilong, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fenyi',
		label: 'Fenyi, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dawukou',
		label: 'Dawukou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shouguang',
		label: 'Shouguang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Yanliang',
		label: 'Yanliang, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Fengcheng',
		label: 'Fengcheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Qixia',
		label: 'Qixia, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Mingyue',
		label: 'Mingyue, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Daan',
		label: 'Daan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Bengbu',
		label: 'Bengbu, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Jiaohe',
		label: 'Jiaohe, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Shulan',
		label: 'Shulan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xiangyin',
		label: 'Xiangyin, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhoucun',
		label: 'Zhoucun, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xinhua',
		label: 'Xinhua, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Xiangtan',
		label: 'Xiangtan, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Licheng',
		label: 'Licheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Rucheng',
		label: 'Rucheng, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Haizhou',
		label: 'Haizhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Zhuzhou',
		label: 'Zhuzhou, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Dali',
		label: 'Dali, China',
		type: 'city',
		flagClass: 'fi fi-cn',
		isPopular: false,
	},
	{
		value: 'Christmas Island',
		label: 'Christmas Island',
		type: 'country',
		flagClass: 'fi fi-cx',
		isPopular: false,
	},
	{
		value: 'Cocos (Keeling) Islands',
		label: 'Cocos (Keeling) Islands',
		type: 'country',
		flagClass: 'fi fi-cc',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia',
		type: 'country',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Bogotá',
		label: 'Bogotá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Medellín',
		label: 'Medellín, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cali',
		label: 'Cali, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Barranquilla',
		label: 'Barranquilla, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Bucaramanga',
		label: 'Bucaramanga, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Abaiang',
		label: 'Abaiang, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Manizales',
		label: 'Manizales, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cartagena',
		label: 'Cartagena, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Antioquia',
		label: 'Antioquia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pereira',
		label: 'Pereira, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Armenia',
		label: 'Armenia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Santa Marta',
		label: 'Santa Marta, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Popayán',
		label: 'Popayán, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ibagué',
		label: 'Ibagué, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Villavicencio',
		label: 'Villavicencio, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cúcuta',
		label: 'Cúcuta, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Envigado',
		label: 'Envigado, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto Rico',
		label: 'Puerto Rico, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Barrancabermeja',
		label: 'Barrancabermeja, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sogamoso',
		label: 'Sogamoso, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tunja',
		label: 'Tunja, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chía',
		label: 'Chía, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Neiva',
		label: 'Neiva, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Montería',
		label: 'Montería, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Fusagasugá',
		label: 'Fusagasugá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Piedecuesta',
		label: 'Piedecuesta, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ríonegro',
		label: 'Ríonegro, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Gil',
		label: 'San Gil, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Caicedonia',
		label: 'Caicedonia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cajicá',
		label: 'Cajicá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Mocoa',
		label: 'Mocoa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Risaralda',
		label: 'Risaralda, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Garagoa',
		label: 'Garagoa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pasto',
		label: 'Pasto, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Valledupar',
		label: 'Valledupar, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tuluá',
		label: 'Tuluá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Yopal',
		label: 'Yopal, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tenerife',
		label: 'Tenerife, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Supía',
		label: 'Supía, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Buenaventura',
		label: 'Buenaventura, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Girardot',
		label: 'Girardot, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Girón',
		label: 'Girón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Facatativá',
		label: 'Facatativá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Calarcá',
		label: 'Calarcá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto Asís',
		label: 'Puerto Asís, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Aracataca',
		label: 'Aracataca, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ayapel',
		label: 'Ayapel, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chaparral',
		label: 'Chaparral, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Charalá',
		label: 'Charalá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Toledo',
		label: 'Toledo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chinú',
		label: 'Chinú, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Sebastián Villanueva',
		label: 'San Sebastián Villanueva, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Aquitania',
		label: 'Aquitania, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Urrao',
		label: 'Urrao, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Venecia',
		label: 'Venecia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'La Jagua Ibirico',
		label: 'La Jagua Ibirico, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pueblorrico',
		label: 'Pueblorrico, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Fresno',
		label: 'Fresno, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ambalema',
		label: 'Ambalema, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Bolívar',
		label: 'Bolívar, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pesca',
		label: 'Pesca, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Aguazul',
		label: 'Aguazul, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chiriguaná',
		label: 'Chiriguaná, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Bugalagrande',
		label: 'Bugalagrande, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Amagá',
		label: 'Amagá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Marseille',
		label: 'Marseille, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Agua de Dios',
		label: 'Agua de Dios, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Vélez',
		label: 'Vélez, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Majagual',
		label: 'Majagual, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Soacha',
		label: 'Soacha, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Itagüí',
		label: 'Itagüí, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Necoclí',
		label: 'Necoclí, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Floridablanca',
		label: 'Floridablanca, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Santa Rosa de Osos',
		label: 'Santa Rosa de Osos, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Florencia',
		label: 'Florencia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Buga',
		label: 'Buga, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Calera',
		label: 'Calera, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Moniquirá',
		label: 'Moniquirá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ríohacha',
		label: 'Ríohacha, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Duitama',
		label: 'Duitama, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Apartadó',
		label: 'Apartadó, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ocaña',
		label: 'Ocaña, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cajamarca',
		label: 'Cajamarca, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Yumbo',
		label: 'Yumbo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Calamar',
		label: 'Calamar, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Caldas',
		label: 'Caldas, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pamplona',
		label: 'Pamplona, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pitalito',
		label: 'Pitalito, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Yotoco',
		label: 'Yotoco, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chiquinquirá',
		label: 'Chiquinquirá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Lorica',
		label: 'Lorica, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'La Ceja',
		label: 'La Ceja, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto Berrío',
		label: 'Puerto Berrío, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cartagena del Chaira',
		label: 'Cartagena del Chaira, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Montelíbano',
		label: 'Montelíbano, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cota',
		label: 'Cota, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sincé',
		label: 'Sincé, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Zarzal',
		label: 'Zarzal, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guateque',
		label: 'Guateque, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Rovira',
		label: 'Rovira, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tame',
		label: 'Tame, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Roldanillo',
		label: 'Roldanillo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto Boyacá',
		label: 'Puerto Boyacá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tolú',
		label: 'Tolú, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Melgar',
		label: 'Melgar, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Anserma',
		label: 'Anserma, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Córdoba',
		label: 'Córdoba, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'La Unión',
		label: 'La Unión, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sucre',
		label: 'Sucre, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Belalcázar',
		label: 'Belalcázar, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Marquetalia',
		label: 'Marquetalia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Curumaní',
		label: 'Curumaní, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San José del Guaviare',
		label: 'San José del Guaviare, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Talaigua Nuevo',
		label: 'Talaigua Nuevo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'El Charco',
		label: 'El Charco, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Flandes',
		label: 'Flandes, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guaitarilla',
		label: 'Guaitarilla, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sabanagrande',
		label: 'Sabanagrande, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Trujillo',
		label: 'Trujillo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cañasgordas',
		label: 'Cañasgordas, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Carmen de Viboral',
		label: 'Carmen de Viboral, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sampués',
		label: 'Sampués, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Genève',
		label: 'Genève, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Zacamulpa',
		label: 'Zacamulpa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Santa Catalina',
		label: 'Santa Catalina, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ubaté',
		label: 'Ubaté, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guayabal',
		label: 'Guayabal, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Villeta',
		label: 'Villeta, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Villapinzón',
		label: 'Villapinzón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Barbosa',
		label: 'Barbosa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Yaguará',
		label: 'Yaguará, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Circasia',
		label: 'Circasia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guacarí',
		label: 'Guacarí, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Mitú',
		label: 'Mitú, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Túquerres',
		label: 'Túquerres, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Lérida',
		label: 'Lérida, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Viotá',
		label: 'Viotá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Galapa',
		label: 'Galapa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Barranco de Loba',
		label: 'Barranco de Loba, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puente Nacional',
		label: 'Puente Nacional, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'La Plata',
		label: 'La Plata, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ancuyá',
		label: 'Ancuyá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ríosucio',
		label: 'Ríosucio, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pijao',
		label: 'Pijao, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Aguadas',
		label: 'Aguadas, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Pelayo',
		label: 'San Pelayo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Málaga',
		label: 'Málaga, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Roque',
		label: 'San Roque, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Repelón',
		label: 'Repelón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Carmen de Apicalá',
		label: 'Carmen de Apicalá, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'El Copey',
		label: 'El Copey, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guaranda',
		label: 'Guaranda, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Benito Abad',
		label: 'San Benito Abad, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Serula',
		label: 'Serula, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Albán',
		label: 'Albán, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Zaragoza',
		label: 'Zaragoza, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Cocorná',
		label: 'Cocorná, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Ciénaga de Oro',
		label: 'Ciénaga de Oro, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'El Playón',
		label: 'El Playón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'El Molino',
		label: 'El Molino, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Salamina',
		label: 'Salamina, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Santuário',
		label: 'Santuário, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sonsón',
		label: 'Sonsón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Falán',
		label: 'Falán, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Andalucía',
		label: 'Andalucía, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Juan de Betulia',
		label: 'San Juan de Betulia, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Barrancas',
		label: 'Barrancas, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto López',
		label: 'Puerto López, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Andes',
		label: 'Andes, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Leiva',
		label: 'Leiva, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Sopetrán',
		label: 'Sopetrán, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Corinto',
		label: 'Corinto, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Azcatepec',
		label: 'Azcatepec, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Zenón',
		label: 'San Zenón, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Chimichagua',
		label: 'Chimichagua, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Vijes',
		label: 'Vijes, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Pacho',
		label: 'Pacho, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Dolores',
		label: 'Dolores, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Paz de Ariporo',
		label: 'Paz de Ariporo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Versalles',
		label: 'Versalles, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Manzanares',
		label: 'Manzanares, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guamo',
		label: 'Guamo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Viterbo',
		label: 'Viterbo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Piendamó',
		label: 'Piendamó, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Vicente del Caguan',
		label: 'San Vicente del Caguan, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Manatí',
		label: 'Manatí, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guarne',
		label: 'Guarne, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Los Palmitos',
		label: 'Los Palmitos, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Toro',
		label: 'Toro, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'San Pablo',
		label: 'San Pablo, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guaduas',
		label: 'Guaduas, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Istmina',
		label: 'Istmina, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Guapí',
		label: 'Guapí, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Tibú',
		label: 'Tibú, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'La Mesa',
		label: 'La Mesa, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Puerto Wilches',
		label: 'Puerto Wilches, Colombia',
		type: 'city',
		flagClass: 'fi fi-co',
		isPopular: false,
	},
	{
		value: 'Comoros',
		label: 'Comoros',
		type: 'country',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Moroni',
		label: 'Moroni, Comoros',
		type: 'city',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Domoni',
		label: 'Domoni, Comoros',
		type: 'city',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Fomboni',
		label: 'Fomboni, Comoros',
		type: 'city',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Mutsamudu',
		label: 'Mutsamudu, Comoros',
		type: 'city',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Mitsamiouli',
		label: 'Mitsamiouli, Comoros',
		type: 'city',
		flagClass: 'fi fi-km',
		isPopular: false,
	},
	{
		value: 'Congo',
		label: 'Congo',
		type: 'country',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Brazzaville',
		label: 'Brazzaville, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Boko',
		label: 'Boko, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Pointe Noire',
		label: 'Pointe Noire, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Mossaka',
		label: 'Mossaka, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Gamboma',
		label: 'Gamboma, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Komomo',
		label: 'Komomo, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Kinkala',
		label: 'Kinkala, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Djambala',
		label: 'Djambala, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Ngamaba-Mfilou',
		label: 'Ngamaba-Mfilou, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Impfondo',
		label: 'Impfondo, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Ewo',
		label: 'Ewo, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Madingou',
		label: 'Madingou, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Matsanga',
		label: 'Matsanga, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Dongou',
		label: 'Dongou, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Makoua',
		label: 'Makoua, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Sembé',
		label: 'Sembé, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Mindouli',
		label: 'Mindouli, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Kellé',
		label: 'Kellé, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Kibangou',
		label: 'Kibangou, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Epéna',
		label: 'Epéna, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Zanaga',
		label: 'Zanaga, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Ikélemba',
		label: 'Ikélemba, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Loudima',
		label: 'Loudima, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Souanké',
		label: 'Souanké, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Loubomo',
		label: 'Loubomo, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Nkayi',
		label: 'Nkayi, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Mossendjo',
		label: 'Mossendjo, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Owando',
		label: 'Owando, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Ouesso',
		label: 'Ouesso, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Loandjili',
		label: 'Loandjili, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Sibiti',
		label: 'Sibiti, Congo',
		type: 'city',
		flagClass: 'fi fi-cg',
		isPopular: false,
	},
	{
		value: 'Congo, Democratic Republic of the',
		label: 'Congo, Democratic Republic of the',
		type: 'country',
		flagClass: 'fi fi-cd',
		isPopular: false,
	},
	{
		value: 'Cook Islands',
		label: 'Cook Islands',
		type: 'country',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Avarua',
		label: 'Avarua, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Amuri',
		label: 'Amuri, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Mangaia',
		label: 'Mangaia, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Atiu',
		label: 'Atiu, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Mauke',
		label: 'Mauke, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Tauhunu',
		label: 'Tauhunu, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Omoka',
		label: 'Omoka, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Mitiaro',
		label: 'Mitiaro, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Roto',
		label: 'Roto, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Nassau',
		label: 'Nassau, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Rakahanga',
		label: 'Rakahanga, Cook Islands',
		type: 'city',
		flagClass: 'fi fi-ck',
		isPopular: false,
	},
	{
		value: 'Costa Rica',
		label: 'Costa Rica',
		type: 'country',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Escazú',
		label: 'Escazú, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Heredia',
		label: 'Heredia, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Alajuela',
		label: 'Alajuela, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Aguacaliente',
		label: 'Aguacaliente, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Curridabat',
		label: 'Curridabat, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Cartago',
		label: 'Cartago, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Guadalupe',
		label: 'Guadalupe, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Josecito',
		label: 'San Josecito, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Liberia',
		label: 'Liberia, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Puntarenas',
		label: 'Puntarenas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Juan',
		label: 'San Juan, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Sabanilla',
		label: 'Sabanilla, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Isidro',
		label: 'San Isidro, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Alajuelita',
		label: 'Alajuelita, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Grecia',
		label: 'Grecia, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Colón',
		label: 'Colón, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Limón',
		label: 'Limón, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Desemparados',
		label: 'Desemparados, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Cinco Esquinas',
		label: 'Cinco Esquinas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Atenas',
		label: 'Atenas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Quesada',
		label: 'Quesada, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Nicoya',
		label: 'Nicoya, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Quepos',
		label: 'Quepos, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Golfito',
		label: 'Golfito, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Santo Domingo',
		label: 'Santo Domingo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Turrialba',
		label: 'Turrialba, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Rafael',
		label: 'San Rafael, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Tres Ríos',
		label: 'Tres Ríos, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Antonio de Desamparados',
		label: 'San Antonio de Desamparados, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Rafael Arriba',
		label: 'San Rafael Arriba, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Buenos Aires',
		label: 'Buenos Aires, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Guácimo',
		label: 'Guácimo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Daniel Flores',
		label: 'Daniel Flores, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Tilarán',
		label: 'Tilarán, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Marcos de Tarrazú',
		label: 'San Marcos de Tarrazú, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'El Paraíso',
		label: 'El Paraíso, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Chacarita',
		label: 'Chacarita, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Rafael Abajo',
		label: 'San Rafael Abajo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Calle Blancos',
		label: 'Calle Blancos, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Cañas',
		label: 'Cañas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Guápiles',
		label: 'Guápiles, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Esparta',
		label: 'Esparta, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Apaseo el Grande',
		label: 'Apaseo el Grande, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Bagaces',
		label: 'Bagaces, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Upala',
		label: 'Upala, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Vito',
		label: 'San Vito, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Parrita',
		label: 'Parrita, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Vicente',
		label: 'San Vicente, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Purral',
		label: 'Purral, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Ipís',
		label: 'Ipís, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Aserrí',
		label: 'Aserrí, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Felipe',
		label: 'San Felipe, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Mercedes',
		label: 'Mercedes, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'El Tejar',
		label: 'El Tejar, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Pablo',
		label: 'San Pablo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Siquirres',
		label: 'Siquirres, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Diego',
		label: 'San Diego, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Carmen',
		label: 'Carmen, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Naranjo',
		label: 'Naranjo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Río Segundo',
		label: 'Río Segundo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Jose',
		label: 'San Jose, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Corredor',
		label: 'Corredor, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Miramar',
		label: 'Miramar, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Orotina',
		label: 'Orotina, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Filadeldia',
		label: 'Filadeldia, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Juntas',
		label: 'Juntas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Palmar de Bravo',
		label: 'Palmar de Bravo, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Palmares',
		label: 'Palmares, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Batán',
		label: 'Batán, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'La Cruz',
		label: 'La Cruz, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Puerto Cortés',
		label: 'Puerto Cortés, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Zarcero',
		label: 'Zarcero, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Los Chiles',
		label: 'Los Chiles, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Pocosol',
		label: 'Pocosol, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'La Suiza',
		label: 'La Suiza, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Matina',
		label: 'Matina, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Roxana',
		label: 'Roxana, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Pital',
		label: 'Pital, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Pacayas',
		label: 'Pacayas, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Florencia',
		label: 'Florencia, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Coco',
		label: 'Coco, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Brasilito',
		label: 'Brasilito, Costa Rica',
		type: 'city',
		flagClass: 'fi fi-cr',
		isPopular: false,
	},
	{
		value: 'Croatia',
		label: 'Croatia',
		type: 'country',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Zagreb',
		label: 'Zagreb, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Split',
		label: 'Split, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Rijeka',
		label: 'Rijeka, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Osijek',
		label: 'Osijek, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Beli Manastir',
		label: 'Beli Manastir, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Zadar',
		label: 'Zadar, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Varaždin',
		label: 'Varaždin, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Pula',
		label: 'Pula, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Dubrovnik',
		label: 'Dubrovnik, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Chakovec',
		label: 'Chakovec, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Petrinja',
		label: 'Petrinja, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Slavonski Brod',
		label: 'Slavonski Brod, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Velika Gorica',
		label: 'Velika Gorica, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Zapreshic',
		label: 'Zapreshic, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Knin',
		label: 'Knin, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Trogir',
		label: 'Trogir, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Vukovar',
		label: 'Vukovar, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Bjelovar',
		label: 'Bjelovar, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Metkovic',
		label: 'Metkovic, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Porech',
		label: 'Porech, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Novska',
		label: 'Novska, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Biograd na Moru',
		label: 'Biograd na Moru, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Karlovac',
		label: 'Karlovac, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Sesvete',
		label: 'Sesvete, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Shibenik',
		label: 'Shibenik, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Vinkovci',
		label: 'Vinkovci, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Koprivnica',
		label: 'Koprivnica, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Solin',
		label: 'Solin, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Virovitica',
		label: 'Virovitica, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Kutina',
		label: 'Kutina, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Nova Gradishka',
		label: 'Nova Gradishka, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Krizhevci',
		label: 'Krizhevci, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Ogulin',
		label: 'Ogulin, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Nashice',
		label: 'Nashice, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Krk',
		label: 'Krk, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Buje',
		label: 'Buje, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Sisak',
		label: 'Sisak, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Pozhega',
		label: 'Pozhega, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Dhakovo',
		label: 'Dhakovo, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Zhupanja',
		label: 'Zhupanja, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Rovinj',
		label: 'Rovinj, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Makarska',
		label: 'Makarska, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Sinj',
		label: 'Sinj, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Slatina',
		label: 'Slatina, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Opatija',
		label: 'Opatija, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Omish',
		label: 'Omish, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Gospic',
		label: 'Gospic, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Senj',
		label: 'Senj, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Krapina',
		label: 'Krapina, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Korchula',
		label: 'Korchula, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Grachac',
		label: 'Grachac, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Pag',
		label: 'Pag, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Rab',
		label: 'Rab, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Samobor',
		label: 'Samobor, Croatia',
		type: 'city',
		flagClass: 'fi fi-hr',
		isPopular: false,
	},
	{
		value: 'Cuba',
		label: 'Cuba',
		type: 'country',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Havana',
		label: 'Havana, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Abreus',
		label: 'Abreus, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cienfuegos',
		label: 'Cienfuegos, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santiago de Cuba',
		label: 'Santiago de Cuba, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Guantánamo',
		label: 'Guantánamo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Camagüey',
		label: 'Camagüey, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Holguín',
		label: 'Holguín, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Matanzas',
		label: 'Matanzas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Sagua la Grande',
		label: 'Sagua la Grande, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Pedro Betancourt',
		label: 'Pedro Betancourt, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Varadero',
		label: 'Varadero, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Aguacate',
		label: 'Aguacate, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Buenos Aires',
		label: 'Buenos Aires, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Batabanó',
		label: 'Batabanó, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Bayamo',
		label: 'Bayamo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Pinar del Río',
		label: 'Pinar del Río, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Ciego de Ávila',
		label: 'Ciego de Ávila, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Artemisa',
		label: 'Artemisa, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Nuevitas',
		label: 'Nuevitas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Placetas',
		label: 'Placetas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Songo-La Maya',
		label: 'Songo-La Maya, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Camajuaní',
		label: 'Camajuaní, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Manicaragua',
		label: 'Manicaragua, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cifuentes',
		label: 'Cifuentes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cacocum',
		label: 'Cacocum, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Báguanos',
		label: 'Báguanos, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Alquízar',
		label: 'Alquízar, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Antilla',
		label: 'Antilla, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Martí',
		label: 'Martí, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Manatí',
		label: 'Manatí, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Candelária',
		label: 'Candelária, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Los Arabos',
		label: 'Los Arabos, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Quemado de Güines',
		label: 'Quemado de Güines, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Juan Gualberto Gómez',
		label: 'Juan Gualberto Gómez, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Carlos Manuel de Céspedes',
		label: 'Carlos Manuel de Céspedes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Mantova',
		label: 'Mantova, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Pilón',
		label: 'Pilón, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Calabazar de Sagua',
		label: 'Calabazar de Sagua, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Ameca',
		label: 'Ameca, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Carlos Rojas',
		label: 'Carlos Rojas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'San Juan y Martínez',
		label: 'San Juan y Martínez, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Zaza del Medio',
		label: 'Zaza del Medio, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santa Fé',
		label: 'Santa Fé, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Bolondrón',
		label: 'Bolondrón, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Máximo Gómez',
		label: 'Máximo Gómez, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Alacranes',
		label: 'Alacranes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Zulueta',
		label: 'Zulueta, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cabañas',
		label: 'Cabañas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Agramonte',
		label: 'Agramonte, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Caney',
		label: 'Caney, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'El Cobre',
		label: 'El Cobre, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Caimito del Guayabal',
		label: 'Caimito del Guayabal, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Rancho Veloz',
		label: 'Rancho Veloz, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cauto Cristo',
		label: 'Cauto Cristo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Manguito',
		label: 'Manguito, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'San Diego de los Baños',
		label: 'San Diego de los Baños, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Ocoyucan',
		label: 'Ocoyucan, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Las Tunas',
		label: 'Las Tunas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Sancti Spíritus',
		label: 'Sancti Spíritus, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Manzanillo',
		label: 'Manzanillo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Palma Soriano',
		label: 'Palma Soriano, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Puerto Padre',
		label: 'Puerto Padre, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cárdenas',
		label: 'Cárdenas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Contramaestre',
		label: 'Contramaestre, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Mayarí',
		label: 'Mayarí, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Consolación del Sur',
		label: 'Consolación del Sur, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Moa',
		label: 'Moa, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Colón',
		label: 'Colón, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Amatlán',
		label: 'Amatlán, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Güines',
		label: 'Güines, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Huamantla',
		label: 'Huamantla, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jagüey Grande',
		label: 'Jagüey Grande, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Baracoa',
		label: 'Baracoa, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'San José de las Lajas',
		label: 'San José de las Lajas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jovellanos',
		label: 'Jovellanos, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Morón',
		label: 'Morón, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Trinidad',
		label: 'Trinidad, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Florida',
		label: 'Florida, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santo Domingo',
		label: 'Santo Domingo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Yaguajay',
		label: 'Yaguajay, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Ranchuelo',
		label: 'Ranchuelo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Guáimaro',
		label: 'Guáimaro, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Banes',
		label: 'Banes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santa Cruz del Sur',
		label: 'Santa Cruz del Sur, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Unión de Reyes',
		label: 'Unión de Reyes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cumanayagua',
		label: 'Cumanayagua, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jiguaní',
		label: 'Jiguaní, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cabaiguán',
		label: 'Cabaiguán, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Remedios',
		label: 'Remedios, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Bauta',
		label: 'Bauta, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'San Antonio de los Baños',
		label: 'San Antonio de los Baños, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Caibarién',
		label: 'Caibarién, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Condado',
		label: 'Condado, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Nueva Gerona',
		label: 'Nueva Gerona, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santiago de las Vegas',
		label: 'Santiago de las Vegas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Madruga',
		label: 'Madruga, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Vertientes',
		label: 'Vertientes, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Güira de Melena',
		label: 'Güira de Melena, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Mariel',
		label: 'Mariel, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Gibara',
		label: 'Gibara, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Yara',
		label: 'Yara, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Amancio',
		label: 'Amancio, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cueto',
		label: 'Cueto, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Los Palacios',
		label: 'Los Palacios, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Encrucijada',
		label: 'Encrucijada, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Chambas',
		label: 'Chambas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Guanajay',
		label: 'Guanajay, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Yateras',
		label: 'Yateras, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Perico',
		label: 'Perico, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Campechuela',
		label: 'Campechuela, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Aguada de Pasajeros',
		label: 'Aguada de Pasajeros, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Cruces',
		label: 'Cruces, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Calimete',
		label: 'Calimete, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Minas',
		label: 'Minas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Palmira',
		label: 'Palmira, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Río Cauto',
		label: 'Río Cauto, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Esmeralda',
		label: 'Esmeralda, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'San Diego del Valle',
		label: 'San Diego del Valle, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Bahía Honda',
		label: 'Bahía Honda, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Delicias',
		label: 'Delicias, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jaruco',
		label: 'Jaruco, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Fomento',
		label: 'Fomento, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jatibonico',
		label: 'Jatibonico, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Rodas',
		label: 'Rodas, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Sibanicú',
		label: 'Sibanicú, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Primero de Enero',
		label: 'Primero de Enero, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Corralillo',
		label: 'Corralillo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Sagua de Tánamo',
		label: 'Sagua de Tánamo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Bejucal',
		label: 'Bejucal, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Jobabo',
		label: 'Jobabo, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Niquero',
		label: 'Niquero, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Santa Cruz del Norte',
		label: 'Santa Cruz del Norte, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Guisa',
		label: 'Guisa, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Venezuela',
		label: 'Venezuela, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Guane',
		label: 'Guane, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Media Luna',
		label: 'Media Luna, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Baraguá',
		label: 'Baraguá, Cuba',
		type: 'city',
		flagClass: 'fi fi-cu',
		isPopular: false,
	},
	{
		value: 'Curaçao',
		label: 'Curaçao',
		type: 'country',
		flagClass: 'fi fi-cw',
		isPopular: false,
	},
	{
		value: 'Curacao',
		label: 'Curacao, Curaçao',
		type: 'city',
		flagClass: 'fi fi-cw',
		isPopular: false,
	},
	{
		value: 'Cyprus',
		label: 'Cyprus',
		type: 'country',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Nicosia',
		label: 'Nicosia, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Lemesos',
		label: 'Lemesos, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Larnaca',
		label: 'Larnaca, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Pafos',
		label: 'Pafos, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Aradippou',
		label: 'Aradippou, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Paralimni',
		label: 'Paralimni, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Famagusta',
		label: 'Famagusta, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Kyrenia',
		label: 'Kyrenia, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Polis',
		label: 'Polis, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Lefka',
		label: 'Lefka, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Morphou',
		label: 'Morphou, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Geri',
		label: 'Geri, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Ypsonas',
		label: 'Ypsonas, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Dromolaxia',
		label: 'Dromolaxia, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Pano Polemidia',
		label: 'Pano Polemidia, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Baru',
		label: 'Baru, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Rizokarpaso',
		label: 'Rizokarpaso, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Chlorakas',
		label: 'Chlorakas, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Lapithos',
		label: 'Lapithos, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Kythrea',
		label: 'Kythrea, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Iskele',
		label: 'Iskele, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Èmbi',
		label: 'Èmbi, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Yialousa',
		label: 'Yialousa, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Leonarisso',
		label: 'Leonarisso, Cyprus',
		type: 'city',
		flagClass: 'fi fi-cy',
		isPopular: false,
	},
	{
		value: 'Czechia',
		label: 'Czechia',
		type: 'country',
		flagClass: 'fi fi-cz',
		isPopular: false,
	},
	{
		value: "Côte d'Ivoire",
		label: "Côte d'Ivoire",
		type: 'country',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Abidjan',
		label: "Abidjan, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Abengourou',
		label: "Abengourou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bouaké',
		label: "Bouaké, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Aboisso',
		label: "Aboisso, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Yamoussoukro',
		label: "Yamoussoukro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Divo',
		label: "Divo, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Dabou',
		label: "Dabou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bouaflé',
		label: "Bouaflé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Adzopé',
		label: "Adzopé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bongouanou',
		label: "Bongouanou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Acatlán',
		label: "Acatlán, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Man',
		label: "Man, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Gagnoa',
		label: "Gagnoa, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Dimbokro',
		label: "Dimbokro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Toumodi',
		label: "Toumodi, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Duékoué',
		label: "Duékoué, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bonoua',
		label: "Bonoua, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bako',
		label: "Bako, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Fresco',
		label: "Fresco, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Korhogo',
		label: "Korhogo, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Anyama',
		label: "Anyama, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Grand Bassam',
		label: "Grand Bassam, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Agboville',
		label: "Agboville, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bingerville',
		label: "Bingerville, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Danané',
		label: "Danané, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bondoukou',
		label: "Bondoukou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Katiola',
		label: "Katiola, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Issia',
		label: "Issia, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Soubré',
		label: "Soubré, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Séguéla',
		label: "Séguéla, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Agnibilékrou',
		label: "Agnibilékrou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Boundiali',
		label: "Boundiali, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Zuénoula',
		label: "Zuénoula, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Vavoua',
		label: "Vavoua, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Afféry',
		label: "Afféry, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bouna',
		label: "Bouna, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Biankouma',
		label: "Biankouma, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tiébissou',
		label: "Tiébissou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bangolo',
		label: "Bangolo, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Adiaké',
		label: "Adiaké, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Dabakala',
		label: "Dabakala, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Sakassou',
		label: "Sakassou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Ayamé',
		label: "Ayamé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Alépé',
		label: "Alépé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Ndiékro',
		label: "Ndiékro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Bocanda',
		label: "Bocanda, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Grand-Lahou',
		label: "Grand-Lahou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Daloa',
		label: "Daloa, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Sinfra',
		label: "Sinfra, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Ferkessedougou',
		label: "Ferkessedougou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Oumé',
		label: "Oumé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Odienné',
		label: "Odienné, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Daoukro',
		label: "Daoukro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tiassalé',
		label: "Tiassalé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Akoupé',
		label: "Akoupé, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Lakota',
		label: "Lakota, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tingréla',
		label: "Tingréla, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Guiglo',
		label: "Guiglo, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Arrah',
		label: "Arrah, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Hiré',
		label: "Hiré, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Mbatto',
		label: "Mbatto, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Touba',
		label: "Touba, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Ouragahio',
		label: "Ouragahio, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Sassandra',
		label: "Sassandra, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Ndouci',
		label: "Ndouci, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tanda',
		label: "Tanda, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tabou',
		label: "Tabou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Béoumi',
		label: "Béoumi, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Mankono',
		label: "Mankono, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Dikodougou',
		label: "Dikodougou, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Rubino',
		label: "Rubino, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Kani',
		label: "Kani, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Tafiré',
		label: "Tafiré, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: "M'bahiakro",
		label: "M'bahiakro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Toulépleu',
		label: "Toulépleu, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Jacqueville',
		label: "Jacqueville, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Guibéroua',
		label: "Guibéroua, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Botro',
		label: "Botro, Côte d'Ivoire",
		type: 'city',
		flagClass: 'fi fi-ci',
		isPopular: false,
	},
	{
		value: 'Århus',
		label: 'Århus, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aalborg',
		label: 'Aalborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Frederiksberg',
		label: 'Frederiksberg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Odense',
		label: 'Odense, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kolding',
		label: 'Kolding, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aabenraa',
		label: 'Aabenraa, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Roskilde',
		label: 'Roskilde, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Randers',
		label: 'Randers, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vejle',
		label: 'Vejle, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Esbjerg',
		label: 'Esbjerg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Næstved',
		label: 'Næstved, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Køge',
		label: 'Køge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Herning',
		label: 'Herning, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nyborg',
		label: 'Nyborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Greve Strand',
		label: 'Greve Strand, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Helsingør',
		label: 'Helsingør, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Silkeborg',
		label: 'Silkeborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hillerød',
		label: 'Hillerød, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Svendborg',
		label: 'Svendborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Horsens',
		label: 'Horsens, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Slagelse',
		label: 'Slagelse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sønderborg',
		label: 'Sønderborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Birkerød',
		label: 'Birkerød, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Holstebro',
		label: 'Holstebro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fredericia',
		label: 'Fredericia, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Farum',
		label: 'Farum, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Billund',
		label: 'Billund, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hørsholm',
		label: 'Hørsholm, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Taastrup',
		label: 'Taastrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Frederikshavn',
		label: 'Frederikshavn, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nykøbing',
		label: 'Nykøbing, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ishøj',
		label: 'Ishøj, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Frederiksværk',
		label: 'Frederiksværk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Holbæk',
		label: 'Holbæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ringsted',
		label: 'Ringsted, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Varde',
		label: 'Varde, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ribe',
		label: 'Ribe, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Solrød',
		label: 'Solrød, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Brønderslev',
		label: 'Brønderslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vordingborg',
		label: 'Vordingborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vejen',
		label: 'Vejen, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aars',
		label: 'Aars, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hjørring',
		label: 'Hjørring, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Haderslev',
		label: 'Haderslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Skive',
		label: 'Skive, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kalundborg',
		label: 'Kalundborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Frederikssund',
		label: 'Frederikssund, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Værløse',
		label: 'Værløse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hobro',
		label: 'Hobro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hundested',
		label: 'Hundested, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fredensborg',
		label: 'Fredensborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Lynge',
		label: 'Lynge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hanstholm',
		label: 'Hanstholm, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Viborg',
		label: 'Viborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Skanderborg',
		label: 'Skanderborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Haslev',
		label: 'Haslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ringkøbing',
		label: 'Ringkøbing, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nivå',
		label: 'Nivå, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sorø',
		label: 'Sorø, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hadsten',
		label: 'Hadsten, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Skælskør',
		label: 'Skælskør, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ølstykke',
		label: 'Ølstykke, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aabybro',
		label: 'Aabybro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hvalsø',
		label: 'Hvalsø, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hjallerup',
		label: 'Hjallerup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Bullerup',
		label: 'Bullerup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Jelling',
		label: 'Jelling, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sindal',
		label: 'Sindal, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sundby',
		label: 'Sundby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Thisted',
		label: 'Thisted, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Struer',
		label: 'Struer, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tønder',
		label: 'Tønder, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Faaborg',
		label: 'Faaborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Brande',
		label: 'Brande, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Assens',
		label: 'Assens, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kerteminde',
		label: 'Kerteminde, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Gilleleje',
		label: 'Gilleleje, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ry',
		label: 'Ry, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Svenstrup',
		label: 'Svenstrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Viby',
		label: 'Viby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Brørup',
		label: 'Brørup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Bellinge',
		label: 'Bellinge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Juelsminde',
		label: 'Juelsminde, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hornbæk',
		label: 'Hornbæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Store Heddinge',
		label: 'Store Heddinge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tølløse',
		label: 'Tølløse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Dronninglund',
		label: 'Dronninglund, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Thyborøn',
		label: 'Thyborøn, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kibæk',
		label: 'Kibæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Lejre',
		label: 'Lejre, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ulfborg',
		label: 'Ulfborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nakskov',
		label: 'Nakskov, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Rønne',
		label: 'Rønne, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Stenløse',
		label: 'Stenløse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ørslev',
		label: 'Ørslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Dragør',
		label: 'Dragør, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Jyllinge',
		label: 'Jyllinge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Trørød',
		label: 'Trørød, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Måløv',
		label: 'Måløv, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Bjerringbro',
		label: 'Bjerringbro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tranbjerg',
		label: 'Tranbjerg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nordborg',
		label: 'Nordborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Skjern',
		label: 'Skjern, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hirtshals',
		label: 'Hirtshals, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Bramming',
		label: 'Bramming, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hinnerup',
		label: 'Hinnerup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Maribo',
		label: 'Maribo, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ringe',
		label: 'Ringe, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hadsund',
		label: 'Hadsund, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Rudkøbing',
		label: 'Rudkøbing, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sakskøbing',
		label: 'Sakskøbing, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Løgten',
		label: 'Løgten, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Højby',
		label: 'Højby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Give',
		label: 'Give, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vodskov',
		label: 'Vodskov, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Stege',
		label: 'Stege, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Videbæk',
		label: 'Videbæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fakse',
		label: 'Fakse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tarm',
		label: 'Tarm, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sunds',
		label: 'Sunds, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Bogense',
		label: 'Bogense, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Brædstrup',
		label: 'Brædstrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Broager',
		label: 'Broager, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Græsted',
		label: 'Græsted, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vissenbjerg',
		label: 'Vissenbjerg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ganløse',
		label: 'Ganløse, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aulum',
		label: 'Aulum, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Borup',
		label: 'Borup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Oksbøl',
		label: 'Oksbøl, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Søndersø',
		label: 'Søndersø, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nørre Aaby',
		label: 'Nørre Aaby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Christiansfeld',
		label: 'Christiansfeld, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Liseleje',
		label: 'Liseleje, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Pandrup',
		label: 'Pandrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Strøby Egede',
		label: 'Strøby Egede, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Cape Town',
		label: 'Cape Town, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aarup',
		label: 'Aarup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Auning',
		label: 'Auning, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ejby',
		label: 'Ejby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Mariager',
		label: 'Mariager, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nordby',
		label: 'Nordby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Haarby',
		label: 'Haarby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Rødby',
		label: 'Rødby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Arden',
		label: 'Arden, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tørring',
		label: 'Tørring, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Guderup',
		label: 'Guderup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Gørlev',
		label: 'Gørlev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Svebølle',
		label: 'Svebølle, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Forlev',
		label: 'Forlev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vestbjerg',
		label: 'Vestbjerg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Aakirkeby',
		label: 'Aakirkeby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Blovstrød',
		label: 'Blovstrød, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nørre Alslev',
		label: 'Nørre Alslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Karup',
		label: 'Karup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Allingåbro',
		label: 'Allingåbro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Veksø',
		label: 'Veksø, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Korsør',
		label: 'Korsør, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Løjt Kirkeby',
		label: 'Løjt Kirkeby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fuglebjerg',
		label: 'Fuglebjerg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Middelfart',
		label: 'Middelfart, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Espergærde',
		label: 'Espergærde, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kruså',
		label: 'Kruså, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fløng',
		label: 'Fløng, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Skagen',
		label: 'Skagen, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hedensted',
		label: 'Hedensted, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Lystrup',
		label: 'Lystrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Smørumnedre',
		label: 'Smørumnedre, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Humlebæk',
		label: 'Humlebæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Sæby',
		label: 'Sæby, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vojens',
		label: 'Vojens, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Lemvig',
		label: 'Lemvig, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Helsinge',
		label: 'Helsinge, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Slangerup',
		label: 'Slangerup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Støvring',
		label: 'Støvring, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hammel',
		label: 'Hammel, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hørning',
		label: 'Hørning, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ebeltoft',
		label: 'Ebeltoft, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Stavnsholt',
		label: 'Stavnsholt, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Neder Holluf',
		label: 'Neder Holluf, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Rødekro',
		label: 'Rødekro, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hellebæk',
		label: 'Hellebæk, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Munkebo',
		label: 'Munkebo, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Tune',
		label: 'Tune, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kolt',
		label: 'Kolt, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Galten',
		label: 'Galten, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Hornslet',
		label: 'Hornslet, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Padborg',
		label: 'Padborg, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Otterup',
		label: 'Otterup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Vamdrup',
		label: 'Vamdrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Løgstør',
		label: 'Løgstør, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Strib',
		label: 'Strib, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Kjellerup',
		label: 'Kjellerup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Beder',
		label: 'Beder, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Svogerslev',
		label: 'Svogerslev, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Fensmark',
		label: 'Fensmark, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Nibe',
		label: 'Nibe, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Ølgod',
		label: 'Ølgod, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Jægerspris',
		label: 'Jægerspris, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Havdrup',
		label: 'Havdrup, Denmark',
		type: 'city',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Djibouti',
		label: 'Djibouti',
		type: 'country',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: 'Jibuti',
		label: 'Jibuti, Djibouti',
		type: 'city',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: 'Dikhil',
		label: 'Dikhil, Djibouti',
		type: 'city',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: '´Ali Sabih',
		label: '´Ali Sabih, Djibouti',
		type: 'city',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: 'Tajurah',
		label: 'Tajurah, Djibouti',
		type: 'city',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: 'Ubuk',
		label: 'Ubuk, Djibouti',
		type: 'city',
		flagClass: 'fi fi-dj',
		isPopular: false,
	},
	{
		value: 'Dominica',
		label: 'Dominica',
		type: 'country',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Roseau',
		label: 'Roseau, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Atkinson',
		label: 'Atkinson, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Portsmouth',
		label: 'Portsmouth, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Saint Joseph',
		label: 'Saint Joseph, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Rosalie',
		label: 'Rosalie, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Laudat',
		label: 'Laudat, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'La Plaine',
		label: 'La Plaine, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Salybia',
		label: 'Salybia, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Berekua',
		label: 'Berekua, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Vieille Case',
		label: 'Vieille Case, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Pont Cassé',
		label: 'Pont Cassé, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Délices',
		label: 'Délices, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Marigot',
		label: 'Marigot, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Mahaut',
		label: 'Mahaut, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Wesley',
		label: 'Wesley, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Coulihaut',
		label: 'Coulihaut, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Barroui',
		label: 'Barroui, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Castle Bruce',
		label: 'Castle Bruce, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Pointe Michel',
		label: 'Pointe Michel, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Soufrière',
		label: 'Soufrière, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Petite Soufrière',
		label: 'Petite Soufrière, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Hampstead',
		label: 'Hampstead, Dominica',
		type: 'city',
		flagClass: 'fi fi-dm',
		isPopular: false,
	},
	{
		value: 'Dominican Republic',
		label: 'Dominican Republic',
		type: 'country',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Santo Domingo',
		label: 'Santo Domingo, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Puerto Plata',
		label: 'Puerto Plata, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Higüey',
		label: 'Higüey, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Amatlán',
		label: 'Amatlán, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Jarabacoa',
		label: 'Jarabacoa, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Samaná',
		label: 'Samaná, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'La Romana',
		label: 'La Romana, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'San Francisco de Macorís',
		label: 'San Francisco de Macorís, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Las Matas de Farfan',
		label: 'Las Matas de Farfan, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Bonao',
		label: 'Bonao, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Moca',
		label: 'Moca, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Ameca',
		label: 'Ameca, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Hato Mayor',
		label: 'Hato Mayor, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sosúa',
		label: 'Sosúa, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Barahona',
		label: 'Barahona, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Baní',
		label: 'Baní, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Nagua',
		label: 'Nagua, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Constanza',
		label: 'Constanza, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Dajabón',
		label: 'Dajabón, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Tamayo',
		label: 'Tamayo, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Villa Vázquez',
		label: 'Villa Vázquez, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'San Pedro de Macorís',
		label: 'San Pedro de Macorís, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'La Vega',
		label: 'La Vega, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Bajos de Haina',
		label: 'Bajos de Haina, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'San Juan de la Maguana',
		label: 'San Juan de la Maguana, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Azua',
		label: 'Azua, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Cotuí',
		label: 'Cotuí, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Villa Altagracia',
		label: 'Villa Altagracia, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Consuelo',
		label: 'Consuelo, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Tamboril',
		label: 'Tamboril, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Neyba',
		label: 'Neyba, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'El Seybo',
		label: 'El Seybo, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Las Guaranas',
		label: 'Las Guaranas, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sánchez',
		label: 'Sánchez, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Bavaro',
		label: 'Bavaro, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Mahón',
		label: 'Mahón, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Ocoa',
		label: 'Ocoa, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Villa Bisonó',
		label: 'Villa Bisonó, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sabaneta',
		label: 'Sabaneta, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sabana Grande de Boyá',
		label: 'Sabana Grande de Boyá, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Bayaguana',
		label: 'Bayaguana, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Monte Plata',
		label: 'Monte Plata, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Quisquella',
		label: 'Quisquella, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Monte Cristi',
		label: 'Monte Cristi, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Cabral',
		label: 'Cabral, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sabana de la Mar',
		label: 'Sabana de la Mar, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Pimentel',
		label: 'Pimentel, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'El Peñon',
		label: 'El Peñon, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Sabana Yegua',
		label: 'Sabana Yegua, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'La Mata',
		label: 'La Mata, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Maimón',
		label: 'Maimón, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Comendador',
		label: 'Comendador, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Duvergé',
		label: 'Duvergé, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Pedernales',
		label: 'Pedernales, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Fantino',
		label: 'Fantino, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Jimaní',
		label: 'Jimaní, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Punta Cana',
		label: 'Punta Cana, Dominican Republic',
		type: 'city',
		flagClass: 'fi fi-do',
		isPopular: false,
	},
	{
		value: 'Ecuador',
		label: 'Ecuador',
		type: 'country',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Quito',
		label: 'Quito, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Guayaquil',
		label: 'Guayaquil, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cuenca',
		label: 'Cuenca, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Alamor',
		label: 'Alamor, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Ambato',
		label: 'Ambato, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Loja',
		label: 'Loja, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Portoviejo',
		label: 'Portoviejo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Azogues',
		label: 'Azogues, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Puerto Baquerizo Moreno',
		label: 'Puerto Baquerizo Moreno, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Machala',
		label: 'Machala, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Otavalo',
		label: 'Otavalo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Baños',
		label: 'Baños, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Quevedo',
		label: 'Quevedo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Salinas',
		label: 'Salinas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'La Troncal',
		label: 'La Troncal, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Puyo',
		label: 'Puyo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cariamanga',
		label: 'Cariamanga, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cotacachi',
		label: 'Cotacachi, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Sucúa',
		label: 'Sucúa, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Gualaquiza',
		label: 'Gualaquiza, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Colimes',
		label: 'Colimes, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pietrari',
		label: 'Pietrari, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Eloy Alfaro',
		label: 'Eloy Alfaro, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Riobamba',
		label: 'Riobamba, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Ibarra',
		label: 'Ibarra, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Esmeraldas',
		label: 'Esmeraldas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Babahoyo',
		label: 'Babahoyo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Latacunga',
		label: 'Latacunga, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Tulcán',
		label: 'Tulcán, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pasaje',
		label: 'Pasaje, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Chone',
		label: 'Chone, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Ventanas',
		label: 'Ventanas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Vinces',
		label: 'Vinces, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Nueva Loja',
		label: 'Nueva Loja, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Macas',
		label: 'Macas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Buena Fé',
		label: 'Buena Fé, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Catamayo',
		label: 'Catamayo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Samborondón',
		label: 'Samborondón, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Monte Cristi',
		label: 'Monte Cristi, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Calinesti-Oas',
		label: 'Calinesti-Oas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cañar',
		label: 'Cañar, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pujilí',
		label: 'Pujilí, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Zaruma',
		label: 'Zaruma, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Alfredo Baquerizo Moreno',
		label: 'Alfredo Baquerizo Moreno, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Valdez',
		label: 'Valdez, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Lomas de Sargentillo',
		label: 'Lomas de Sargentillo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Catacocha',
		label: 'Catacocha, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Paján',
		label: 'Paján, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Palestina',
		label: 'Palestina, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Puebloviejo',
		label: 'Puebloviejo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Yantzaza',
		label: 'Yantzaza, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cuauhtenco',
		label: 'Cuauhtenco, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Catarama',
		label: 'Catarama, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pillaro',
		label: 'Pillaro, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pimampiro',
		label: 'Pimampiro, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Junín',
		label: 'Junín, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pedernales',
		label: 'Pedernales, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Yateras',
		label: 'Yateras, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Sangolquí',
		label: 'Sangolquí, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Celica',
		label: 'Celica, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Archidona',
		label: 'Archidona, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'El Ángel',
		label: 'El Ángel, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Amatlán',
		label: 'Amatlán, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Saquisilí',
		label: 'Saquisilí, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Palora',
		label: 'Palora, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Santo Domingo',
		label: 'Santo Domingo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Milagro',
		label: 'Milagro, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Callejones',
		label: 'Callejones, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Huaquillas',
		label: 'Huaquillas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'El Carmen',
		label: 'El Carmen, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Velasco Ibarra',
		label: 'Velasco Ibarra, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Jipijapa',
		label: 'Jipijapa, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Daule',
		label: 'Daule, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Balzar',
		label: 'Balzar, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Rosa Zárate',
		label: 'Rosa Zárate, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Naranjito',
		label: 'Naranjito, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Bahía de Caráquez',
		label: 'Bahía de Caráquez, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'El Triunfo',
		label: 'El Triunfo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Playas',
		label: 'Playas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Cayambe',
		label: 'Cayambe, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Naranjal',
		label: 'Naranjal, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Guaranda',
		label: 'Guaranda, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pedro Carbo',
		label: 'Pedro Carbo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Yaguachi',
		label: 'Yaguachi, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Atuntaqui',
		label: 'Atuntaqui, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Machachi',
		label: 'Machachi, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Chiautzingo',
		label: 'Chiautzingo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Bolívar',
		label: 'Bolívar, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Tena',
		label: 'Tena, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'San Gabriel',
		label: 'San Gabriel, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Arenillas',
		label: 'Arenillas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Piñas',
		label: 'Piñas, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Zamora',
		label: 'Zamora, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Macará',
		label: 'Macará, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Gualaceo',
		label: 'Gualaceo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'La Maná',
		label: 'La Maná, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Montalvo',
		label: 'Montalvo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Tosagua',
		label: 'Tosagua, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Pelileo',
		label: 'Pelileo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Sucre',
		label: 'Sucre, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Guano',
		label: 'Guano, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Rocafuerte',
		label: 'Rocafuerte, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Alausí',
		label: 'Alausí, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Balao',
		label: 'Balao, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Muisne',
		label: 'Muisne, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Portovelo',
		label: 'Portovelo, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Coronel Maridueña',
		label: 'Coronel Maridueña, Ecuador',
		type: 'city',
		flagClass: 'fi fi-ec',
		isPopular: false,
	},
	{
		value: 'Egypt',
		label: 'Egypt',
		type: 'country',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Cairo',
		label: 'Cairo, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Alexandria',
		label: 'Alexandria, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Jizah',
		label: 'al-Jizah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abnub',
		label: 'Abnub, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tanta',
		label: 'Tanta, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Mansurah',
		label: 'al-Mansurah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sharm-ash-Shaykh',
		label: 'Sharm-ash-Shaykh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Fayyum',
		label: 'al-Fayyum, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: '´Izbat-al-Burj',
		label: '´Izbat-al-Burj, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ibrahimiyah',
		label: 'al-Ibrahimiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Asyut',
		label: 'Asyut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ismailiyah',
		label: 'al-Ismailiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Nasr',
		label: 'Nasr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qanatir-al-Khayriyah',
		label: 'al-Qanatir-al-Khayriyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Aswan',
		label: 'Aswan, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Damanhur',
		label: 'Damanhur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ghardaqah',
		label: 'al-Ghardaqah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Shubra al-Khaymah',
		label: 'Shubra al-Khaymah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ashir mir-Ramadan',
		label: 'al-Ashir mir-Ramadan, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Aja',
		label: 'Aja, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bur Sa´id',
		label: 'Bur Sa´id, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Mit Gamr',
		label: 'Mit Gamr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Banha',
		label: 'Banha, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Kabir',
		label: 'Abu Kabir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'az-Zaqaziq',
		label: 'az-Zaqaziq, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sawhaj',
		label: 'Sawhaj, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Awsim',
		label: 'Awsim, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Shibin-al-Kawm',
		label: 'Shibin-al-Kawm, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Talkha',
		label: 'Talkha, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Zifta',
		label: 'Zifta, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr-az-Zayyat',
		label: 'Kafr-az-Zayyat, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Karnak',
		label: 'al-Karnak, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'an-Nasir',
		label: 'an-Nasir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Ras Gharib',
		label: 'Ras Gharib, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Mahallah al-Kubra',
		label: 'al-Mahallah al-Kubra, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr-ash-Shaykh',
		label: 'Kafr-ash-Shaykh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Matariyah',
		label: 'al-Matariyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dumyat',
		label: 'Dumyat, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Kharijah',
		label: 'al-Kharijah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Lalamusa',
		label: 'Lalamusa, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abyar',
		label: 'Abyar, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'as-Suways',
		label: 'as-Suways, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr-ad-Dawwar',
		label: 'Kafr-ad-Dawwar, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bani Suwayf',
		label: 'Bani Suwayf, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-´Abbasiyah',
		label: 'al-´Abbasiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bilqas',
		label: 'Bilqas, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sibin-al-Qanatir',
		label: 'Sibin-al-Qanatir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Shirbin',
		label: 'Shirbin, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Matay',
		label: 'Matay, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr Saqr',
		label: 'Kafr Saqr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Hummus',
		label: 'Abu Hummus, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dandarah',
		label: 'Dandarah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qusayr',
		label: 'al-Qusayr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Burj',
		label: 'al-Burj, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Uqsur',
		label: 'al-Uqsur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qina',
		label: 'Qina, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Mallawi',
		label: 'Mallawi, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Minuf',
		label: 'Minuf, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Faqus',
		label: 'Faqus, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dishna',
		label: 'Dishna, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tala',
		label: 'Tala, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kawm Hamada',
		label: 'Kawm Hamada, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Hammad',
		label: 'Abu Hammad, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Rafah',
		label: 'Rafah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Husayniyah',
		label: 'al-Husayniyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dar-as-Salam',
		label: 'Dar-as-Salam, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Mahmudiyah',
		label: 'al-Mahmudiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Fant',
		label: 'al-Fant, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Maks',
		label: 'al-Maks, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Hawamidiyah',
		label: 'al-Hawamidiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Akhmim',
		label: 'Akhmim, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Samalut',
		label: 'Samalut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Nasir',
		label: 'Nasir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Ashmun',
		label: 'Ashmun, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Manzilah',
		label: 'al-Manzilah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Magagah',
		label: 'Magagah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Rashid',
		label: 'Rashid, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Isna',
		label: 'Isna, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Khankah',
		label: 'al-Khankah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Marsa Matruh',
		label: 'Marsa Matruh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Badrashayn',
		label: 'al-Badrashayn, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qus',
		label: 'Qus, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sidi Salim',
		label: 'Sidi Salim, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Quwaysina',
		label: 'Quwaysina, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu al-Matamir',
		label: 'Abu al-Matamir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Naj´ Hammadi',
		label: 'Naj´ Hammadi, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'as-Saff',
		label: 'as-Saff, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Maragah',
		label: 'al-Maragah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Ihnasiyah',
		label: 'Ihnasiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Mutubis',
		label: 'Mutubis, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'an-Nukhaylah',
		label: 'an-Nukhaylah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qift',
		label: 'Qift, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Naqadah',
		label: 'Naqadah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Shubra Khit',
		label: 'Shubra Khit, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Mahallat Marhum',
		label: 'Mahallat Marhum, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sahil Salim',
		label: 'Sahil Salim, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ad-Dayr',
		label: 'ad-Dayr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr Salim',
		label: 'Kafr Salim, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Zawiyat Sidi Gazi',
		label: 'Zawiyat Sidi Gazi, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sawl',
		label: 'Sawl, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sanhur',
		label: 'Sanhur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Mansuriyah',
		label: 'al-Mansuriyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bahut',
		label: 'Bahut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tandah',
		label: 'Tandah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: "al-Ma'sarah",
		label: "al-Ma'sarah, Egypt",
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Batanun',
		label: 'al-Batanun, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Hijazah',
		label: 'Hijazah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Daraw',
		label: 'Daraw, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ad-Dabbiyah',
		label: 'ad-Dabbiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ghuli´ah',
		label: 'al-Ghuli´ah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bilbays',
		label: 'Bilbays, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qalyub',
		label: 'Qalyub, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Disuq',
		label: 'Disuq, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Armant',
		label: 'Armant, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Tij',
		label: 'Abu Tij, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tukh',
		label: 'Tukh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Biyala',
		label: 'Biyala, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Minyat-al-Qamh',
		label: 'Minyat-al-Qamh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bani Mazar',
		label: 'Bani Mazar, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Fashn',
		label: 'al-Fashn, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Qurqas',
		label: 'Abu Qurqas, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Minyat-an-Nasr',
		label: 'Minyat-an-Nasr, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Samannud',
		label: 'Samannud, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Itsa',
		label: 'Itsa, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'az-Zarqa',
		label: 'az-Zarqa, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dayr Mawas',
		label: 'Dayr Mawas, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Bajur',
		label: 'al-Bajur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Wasitah',
		label: 'al-Wasitah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sumusta',
		label: 'Sumusta, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ar-Rawdah',
		label: 'ar-Rawdah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Birkat-as-Sab´',
		label: 'Birkat-as-Sab´, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Safaja',
		label: 'Safaja, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ar-Rahmaniyah',
		label: 'ar-Rahmaniyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Wahat-al-Bahriyah',
		label: 'al-Wahat-al-Bahriyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qallin',
		label: 'Qallin, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Hiw',
		label: 'Hiw, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ar-Radisiyat-al-Bahriyah',
		label: 'ar-Radisiyat-al-Bahriyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Ballas',
		label: 'al-Ballas, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Saqqarah',
		label: 'Saqqarah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: "ad-Da'ba",
		label: "ad-Da'ba, Egypt",
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sanabu',
		label: 'Sanabu, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qutur',
		label: 'Qutur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Umm-al-Qusur',
		label: 'Umm-al-Qusur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qassasin',
		label: 'al-Qassasin, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qiman al-´Arus',
		label: 'Qiman al-´Arus, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Fikriyah',
		label: 'al-Fikriyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tallah',
		label: 'Tallah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qantarah',
		label: 'al-Qantarah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'as-Santah',
		label: 'as-Santah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Bani Muhammadiyat',
		label: 'Bani Muhammadiyat, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Buturis',
		label: 'Buturis, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr-al-Battikh',
		label: 'Kafr-al-Battikh, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kafr-al-Jara´idah',
		label: 'Kafr-al-Jara´idah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Za´bal',
		label: 'Abu Za´bal, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kiman-al-Mata´inah',
		label: 'Kiman-al-Mata´inah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qasr Qarun',
		label: 'Qasr Qarun, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Fidimin',
		label: 'Fidimin, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Nahya',
		label: 'Nahya, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Haddadi',
		label: 'al-Haddadi, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Kawm-al-Akhdar',
		label: 'al-Kawm-al-Akhdar, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'ad-Daljamun',
		label: 'ad-Daljamun, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Milij',
		label: 'Milij, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dayrut-ash-Sharif',
		label: 'Dayrut-ash-Sharif, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Nisf Thani Bashbish',
		label: 'Nisf Thani Bashbish, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Fa´id',
		label: 'Fa´id, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Awlad Tawq Sharq',
		label: 'Awlad Tawq Sharq, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Abu Rudays',
		label: 'Abu Rudays, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Waqf',
		label: 'al-Waqf, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Qasr-al-Farafirah',
		label: 'Qasr-al-Farafirah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sidi Barrani',
		label: 'Sidi Barrani, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'at-Tur',
		label: 'at-Tur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Atfih',
		label: 'Atfih, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Asfun-al-Mata´inah',
		label: 'Asfun-al-Mata´inah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sarabiyum',
		label: 'Sarabiyum, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Zawiyat Shammas',
		label: 'Zawiyat Shammas, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'as-Salihiyah',
		label: 'as-Salihiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Jirja',
		label: 'Jirja, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Idfu',
		label: 'Idfu, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Idku',
		label: 'Idku, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dikirnis',
		label: 'Dikirnis, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tagta',
		label: 'Tagta, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'as-Sinbillawayn',
		label: 'as-Sinbillawayn, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Hawsh ´Îsa',
		label: 'Hawsh ´Îsa, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sinnuris',
		label: 'Sinnuris, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Manfalut',
		label: 'Manfalut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Jamaliyah',
		label: 'al-Jamaliyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Tima',
		label: 'Tima, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qusiyah',
		label: 'al-Qusiyah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Dayrut',
		label: 'Dayrut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Fuwah',
		label: 'Fuwah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Kawm Umbu',
		label: 'Kawm Umbu, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Qurayn',
		label: 'al-Qurayn, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'al-Manshah',
		label: 'al-Manshah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Faraskur',
		label: 'Faraskur, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Beba Veche',
		label: 'Beba Veche, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Basyun',
		label: 'Basyun, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Farshut',
		label: 'Farshut, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Sirs-al-Layyanah',
		label: 'Sirs-al-Layyanah, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'Diyarb Najm',
		label: 'Diyarb Najm, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'at-Tall-al-Kabir',
		label: 'at-Tall-al-Kabir, Egypt',
		type: 'city',
		flagClass: 'fi fi-eg',
		isPopular: false,
	},
	{
		value: 'El Salvador',
		label: 'El Salvador',
		type: 'country',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Salvador',
		label: 'San Salvador, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Acajutla',
		label: 'Acajutla, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nueva San Salvador',
		label: 'Nueva San Salvador, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Sonsonate',
		label: 'Sonsonate, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Antiguo Cuscatlán',
		label: 'Antiguo Cuscatlán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Soyapango',
		label: 'Soyapango, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Apopa',
		label: 'Apopa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ilopango',
		label: 'Ilopango, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ahuachapán',
		label: 'Ahuachapán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Santiago de María',
		label: 'Santiago de María, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Santa Rosa de Lima',
		label: 'Santa Rosa de Lima, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Tonacatepeque',
		label: 'Tonacatepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Jocoro',
		label: 'Jocoro, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Pasaquina',
		label: 'Pasaquina, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Tenancingo',
		label: 'Tenancingo, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Mejicanos',
		label: 'Mejicanos, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Delgado',
		label: 'Delgado, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Cojutepeque',
		label: 'Cojutepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Zacatecoluca',
		label: 'Zacatecoluca, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Vicente',
		label: 'San Vicente, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Quezaltepeque',
		label: 'Quezaltepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Aguilares',
		label: 'Aguilares, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'La Unión',
		label: 'La Unión, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Chalatenango',
		label: 'Chalatenango, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Armenia',
		label: 'Armenia, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Berlín',
		label: 'Berlín, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Atiquizaya',
		label: 'Atiquizaya, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Antonio del Monte',
		label: 'San Antonio del Monte, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ciudad Barrios',
		label: 'Ciudad Barrios, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Candelaria de la Frontera',
		label: 'Candelaria de la Frontera, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Olocuilta',
		label: 'Olocuilta, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Chirilagua',
		label: 'Chirilagua, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'El Rosario',
		label: 'El Rosario, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Conchagua',
		label: 'Conchagua, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Lolotique',
		label: 'Lolotique, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Colón',
		label: 'Colón, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Etla',
		label: 'Etla, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Concepción de Oriente',
		label: 'Concepción de Oriente, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Guaymango',
		label: 'Guaymango, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Sociedad',
		label: 'Sociedad, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Jucuarán',
		label: 'Jucuarán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Sesori',
		label: 'Sesori, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Francisco Menéndez',
		label: 'San Francisco Menéndez, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Francisco Morazán',
		label: 'San Francisco Morazán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Marcos',
		label: 'San Marcos, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Cuscatancingo',
		label: 'Cuscatancingo, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Azcatepec',
		label: 'Azcatepec, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Usulután',
		label: 'Usulután, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Chalchuapa',
		label: 'Chalchuapa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ayutuxtepeque',
		label: 'Ayutuxtepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ilobasco',
		label: 'Ilobasco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Izalco',
		label: 'Izalco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Callejones',
		label: 'Callejones, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Metapán',
		label: 'Metapán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Rafael',
		label: 'San Rafael, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Sensuntepeque',
		label: 'Sensuntepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Hueyotlipan',
		label: 'Hueyotlipan, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Puerto El Triunfo',
		label: 'Puerto El Triunfo, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Sonzacate',
		label: 'Sonzacate, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Gotera',
		label: 'Gotera, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Zaragoza',
		label: 'Zaragoza, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Guazapa',
		label: 'Guazapa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ciudad Arce',
		label: 'Ciudad Arce, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Juayúa',
		label: 'Juayúa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Santiago Nonualco',
		label: 'Santiago Nonualco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Jucuapa',
		label: 'Jucuapa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'El Tránsito',
		label: 'El Tránsito, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'El Congo',
		label: 'El Congo, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nueva Concepción',
		label: 'Nueva Concepción, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Panchimalco',
		label: 'Panchimalco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Opico',
		label: 'Opico, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Concepción de Ataco',
		label: 'Concepción de Ataco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Jiquilisco',
		label: 'Jiquilisco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Chinameca',
		label: 'Chinameca, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nahuizalco',
		label: 'Nahuizalco, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nuevo Cuscatlán',
		label: 'Nuevo Cuscatlán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nejapa',
		label: 'Nejapa, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Luis la Herradura',
		label: 'San Luis la Herradura, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Rosario de Mora',
		label: 'Rosario de Mora, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Donostia',
		label: 'Donostia, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Coatepeque',
		label: 'Coatepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nueva Guadalupe',
		label: 'Nueva Guadalupe, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Chapeltique',
		label: 'Chapeltique, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Suchitoto',
		label: 'Suchitoto, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Tacuba',
		label: 'Tacuba, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Julián',
		label: 'San Julián, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Apastepeque',
		label: 'Apastepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Alejo',
		label: 'San Alejo, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Guatajiagua',
		label: 'Guatajiagua, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Ozatlán',
		label: 'Ozatlán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Pablo Tacachico',
		label: 'San Pablo Tacachico, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'La Palma',
		label: 'La Palma, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Estanzuelas',
		label: 'Estanzuelas, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'El Carmen',
		label: 'El Carmen, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Pedro Perulapán',
		label: 'San Pedro Perulapán, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Concepción Batres',
		label: 'Concepción Batres, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Intipucá',
		label: 'Intipucá, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Corinto',
		label: 'Corinto, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'San Pedro Masahuat',
		label: 'San Pedro Masahuat, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Tecoluca',
		label: 'Tecoluca, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Anamorós',
		label: 'Anamorós, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Texistepeque',
		label: 'Texistepeque, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Nueva Esparta',
		label: 'Nueva Esparta, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Cacaopera',
		label: 'Cacaopera, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Jujutla',
		label: 'Jujutla, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Moncagua',
		label: 'Moncagua, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'El Paisnal',
		label: 'El Paisnal, El Salvador',
		type: 'city',
		flagClass: 'fi fi-sv',
		isPopular: false,
	},
	{
		value: 'Equatorial Guinea',
		label: 'Equatorial Guinea',
		type: 'country',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Malabo',
		label: 'Malabo, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Aconibe',
		label: 'Aconibe, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Mongomo',
		label: 'Mongomo, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Ebebiyin',
		label: 'Ebebiyin, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Báta',
		label: 'Báta, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Mbini',
		label: 'Mbini, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Luba',
		label: 'Luba, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Evinayong',
		label: 'Evinayong, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Moca',
		label: 'Moca, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Acurenam',
		label: 'Acurenam, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Mikomeseng',
		label: 'Mikomeseng, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Niefang',
		label: 'Niefang, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Añisoc',
		label: 'Añisoc, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Palé',
		label: 'Palé, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Nsok',
		label: 'Nsok, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Riaba',
		label: 'Riaba, Equatorial Guinea',
		type: 'city',
		flagClass: 'fi fi-gq',
		isPopular: false,
	},
	{
		value: 'Eritrea',
		label: 'Eritrea',
		type: 'country',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Asmara',
		label: 'Asmara, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: "Addi K'eyih",
		label: "Addi K'eyih, Eritrea",
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Keren',
		label: 'Keren, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Barentu',
		label: 'Barentu, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Asseb',
		label: 'Asseb, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Addi Ugri',
		label: 'Addi Ugri, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Addi Kwala',
		label: 'Addi Kwala, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Teseney',
		label: 'Teseney, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Mitsiwa',
		label: 'Mitsiwa, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Êdd',
		label: 'Êdd, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Ginda',
		label: 'Ginda, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Mersa Fatma',
		label: 'Mersa Fatma, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Bêylul',
		label: 'Bêylul, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: "Dek'emhare",
		label: "Dek'emhare, Eritrea",
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: "Ak'ordat",
		label: "Ak'ordat, Eritrea",
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Himbirti',
		label: 'Himbirti, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Nefasit',
		label: 'Nefasit, Eritrea',
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: "Sen'afê",
		label: "Sen'afê, Eritrea",
		type: 'city',
		flagClass: 'fi fi-er',
		isPopular: false,
	},
	{
		value: 'Estonia',
		label: 'Estonia',
		type: 'country',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tallinn',
		label: 'Tallinn, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tartu',
		label: 'Tartu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Pärnu',
		label: 'Pärnu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kuressaare',
		label: 'Kuressaare, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Aakre',
		label: 'Aakre, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kuusalu',
		label: 'Kuusalu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ulila',
		label: 'Ulila, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Narva',
		label: 'Narva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kohtla-Järve',
		label: 'Kohtla-Järve, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Viljandi',
		label: 'Viljandi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rakvere',
		label: 'Rakvere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Haapsalu',
		label: 'Haapsalu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Johvi',
		label: 'Johvi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Elva',
		label: 'Elva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Jogeva',
		label: 'Jogeva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tammiku',
		label: 'Tammiku, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Laagri',
		label: 'Laagri, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rummu',
		label: 'Rummu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kärdla',
		label: 'Kärdla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Jüri',
		label: 'Jüri, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vändra',
		label: 'Vändra, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Väike-Maarja',
		label: 'Väike-Maarja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Lihula',
		label: 'Lihula, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Koo',
		label: 'Koo, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Aaspere',
		label: 'Aaspere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ülenurme',
		label: 'Ülenurme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Essu',
		label: 'Essu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Orissaare',
		label: 'Orissaare, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ääsmäe',
		label: 'Ääsmäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Roela',
		label: 'Roela, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Assaku',
		label: 'Assaku, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Haiba',
		label: 'Haiba, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Haage',
		label: 'Haage, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Keila-Joa',
		label: 'Keila-Joa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Koigi',
		label: 'Koigi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kudjape',
		label: 'Kudjape, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Mooste',
		label: 'Mooste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ravila',
		label: 'Ravila, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Külitse',
		label: 'Külitse, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tilsi',
		label: 'Tilsi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tudu',
		label: 'Tudu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Varstu',
		label: 'Varstu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Karjaküla',
		label: 'Karjaküla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sürgavere',
		label: 'Sürgavere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vao',
		label: 'Vao, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kolga-Jaani',
		label: 'Kolga-Jaani, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Krootuse',
		label: 'Krootuse, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Lelle',
		label: 'Lelle, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Luua',
		label: 'Luua, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rahinge',
		label: 'Rahinge, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Hüüru',
		label: 'Hüüru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Oisu',
		label: 'Oisu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Somerpalu',
		label: 'Somerpalu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vanamoisa',
		label: 'Vanamoisa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Are',
		label: 'Are, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Esku',
		label: 'Esku, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Habaja',
		label: 'Habaja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Helme',
		label: 'Helme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Hummuli',
		label: 'Hummuli, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Soinaste',
		label: 'Soinaste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Näpi',
		label: 'Näpi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Prillimäe',
		label: 'Prillimäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Annikoru',
		label: 'Annikoru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Lohusuu',
		label: 'Lohusuu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Maardu',
		label: 'Maardu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Luke',
		label: 'Luke, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Muraste',
		label: 'Muraste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sillamäe',
		label: 'Sillamäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saverna',
		label: 'Saverna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Selja',
		label: 'Selja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Voru',
		label: 'Voru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Uhti',
		label: 'Uhti, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Valga',
		label: 'Valga, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vajangu',
		label: 'Vajangu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Joesuu',
		label: 'Joesuu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kuimetsa',
		label: 'Kuimetsa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Keila',
		label: 'Keila, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kurtna',
		label: 'Kurtna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Paide',
		label: 'Paide, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vaskjala',
		label: 'Vaskjala, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kuremäe',
		label: 'Kuremäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kivioli',
		label: 'Kivioli, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Polgaste',
		label: 'Polgaste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tapa',
		label: 'Tapa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Toravere',
		label: 'Toravere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kumna',
		label: 'Kumna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Polva',
		label: 'Polva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Piira',
		label: 'Piira, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Türi',
		label: 'Türi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Reiu',
		label: 'Reiu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saue',
		label: 'Saue, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rohuneeme',
		label: 'Rohuneeme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rapla',
		label: 'Rapla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Rosma',
		label: 'Rosma, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saku',
		label: 'Saku, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saarde',
		label: 'Saarde, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Paldiski',
		label: 'Paldiski, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Uusna',
		label: 'Uusna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Poltsamaa',
		label: 'Poltsamaa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Viru-Jaagupi',
		label: 'Viru-Jaagupi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sindi',
		label: 'Sindi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kopu',
		label: 'Kopu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Loksa',
		label: 'Loksa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sinimäe',
		label: 'Sinimäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Halliste',
		label: 'Halliste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kehra',
		label: 'Kehra, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kabala',
		label: 'Kabala, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kunda',
		label: 'Kunda, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kabli',
		label: 'Kabli, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sihva',
		label: 'Sihva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kohila',
		label: 'Kohila, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Viru-Nigula',
		label: 'Viru-Nigula, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Torva',
		label: 'Torva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Mikitamäe',
		label: 'Mikitamäe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Märjamaa',
		label: 'Märjamaa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Narva-Joesuu',
		label: 'Narva-Joesuu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Albu',
		label: 'Albu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Räpina',
		label: 'Räpina, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ambla',
		label: 'Ambla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Köse',
		label: 'Köse, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Keeni',
		label: 'Keeni, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Paistu',
		label: 'Paistu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Haabneeme',
		label: 'Haabneeme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tali',
		label: 'Tali, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Loo',
		label: 'Loo, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tamme',
		label: 'Tamme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tabasalu',
		label: 'Tabasalu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tammiste',
		label: 'Tammiste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tamsalu',
		label: 'Tamsalu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tarbja',
		label: 'Tarbja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kadrina',
		label: 'Kadrina, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Uhtna',
		label: 'Uhtna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Aruküla',
		label: 'Aruküla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vaimastvere',
		label: 'Vaimastvere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kilingi-Nomme',
		label: 'Kilingi-Nomme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kaarepere',
		label: 'Kaarepere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Otepää',
		label: 'Otepää, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kodila',
		label: 'Kodila, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kullamaa',
		label: 'Kullamaa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Karksi-Nuia',
		label: 'Karksi-Nuia, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Osula',
		label: 'Osula, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Paikuse',
		label: 'Paikuse, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Puiga',
		label: 'Puiga, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Viimsi',
		label: 'Viimsi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saarepeedi',
		label: 'Saarepeedi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Aserrí',
		label: 'Aserrí, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Sipa',
		label: 'Sipa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Püssi',
		label: 'Püssi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ahula',
		label: 'Ahula, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Torvandi',
		label: 'Torvandi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Eidapere',
		label: 'Eidapere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Mustvee',
		label: 'Mustvee, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Hagudi',
		label: 'Hagudi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Noo',
		label: 'Noo, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kauksi',
		label: 'Kauksi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kehtna',
		label: 'Kehtna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Leisi',
		label: 'Leisi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Antsla',
		label: 'Antsla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Misso',
		label: 'Misso, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Järvakandi',
		label: 'Järvakandi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Nasva',
		label: 'Nasva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kallaste',
		label: 'Kallaste, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Surju',
		label: 'Surju, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vohma',
		label: 'Vohma, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Varbola',
		label: 'Varbola, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Voore',
		label: 'Voore, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kaagjärve',
		label: 'Kaagjärve, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Raasiku',
		label: 'Raasiku, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kääpa',
		label: 'Kääpa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Pärnu-Jaagupi',
		label: 'Pärnu-Jaagupi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Someru',
		label: 'Someru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Suuremoisa',
		label: 'Suuremoisa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Abja-Paluoja',
		label: 'Abja-Paluoja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Audru',
		label: 'Audru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Erastvere',
		label: 'Erastvere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Viiratsi',
		label: 'Viiratsi, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Lasva',
		label: 'Lasva, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Suure-Jaani',
		label: 'Suure-Jaani, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Seljametsa',
		label: 'Seljametsa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Soe',
		label: 'Soe, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Koeru',
		label: 'Koeru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Tsooru',
		label: 'Tsooru, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Puhja',
		label: 'Puhja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Ubja',
		label: 'Ubja, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Riisipere',
		label: 'Riisipere, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vana-Antsla',
		label: 'Vana-Antsla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Turba',
		label: 'Turba, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vihtra',
		label: 'Vihtra, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Haljala',
		label: 'Haljala, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Jämejala',
		label: 'Jämejala, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Vaida',
		label: 'Vaida, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kärstna',
		label: 'Kärstna, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Klooga',
		label: 'Klooga, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kohtla-Nomme',
		label: 'Kohtla-Nomme, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Raikküla',
		label: 'Raikküla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kose-Uuemoisa',
		label: 'Kose-Uuemoisa, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Saru Dornei',
		label: 'Saru Dornei, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Moisaküla',
		label: 'Moisaküla, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Aegviidu',
		label: 'Aegviidu, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Kiili',
		label: 'Kiili, Estonia',
		type: 'city',
		flagClass: 'fi fi-ee',
		isPopular: false,
	},
	{
		value: 'Eswatini',
		label: 'Eswatini',
		type: 'country',
		flagClass: 'fi fi-sz',
		isPopular: false,
	},
	{
		value: 'Ethiopia',
		label: 'Ethiopia',
		type: 'country',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Addis Abeba',
		label: 'Addis Abeba, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "'Alem Maya",
		label: "'Alem Maya, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Addis 'Alem",
		label: "Addis 'Alem, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Nazrêt',
		label: 'Nazrêt, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Jimma',
		label: 'Jimma, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Addis Zemen',
		label: 'Addis Zemen, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Mek'elê",
		label: "Mek'elê, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bahir Dar',
		label: 'Bahir Dar, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Awassa',
		label: 'Awassa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debre Zeyit',
		label: 'Debre Zeyit, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Harer',
		label: 'Harer, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Arba Minch',
		label: 'Arba Minch, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Nek'emtê",
		label: "Nek'emtê, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Holeta Genet',
		label: 'Holeta Genet, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Asayita',
		label: 'Asayita, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Wonji',
		label: 'Wonji, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Shashemennê',
		label: 'Shashemennê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Kembolcha',
		label: 'Kembolcha, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Addigrat',
		label: 'Addigrat, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Debre Mark'os",
		label: "Debre Mark'os, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Assela',
		label: 'Assela, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debre Birhan',
		label: 'Debre Birhan, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dilla',
		label: 'Dilla, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Alamat'a",
		label: "Alamat'a, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Hagere Hiywet',
		label: 'Hagere Hiywet, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Adwa',
		label: 'Adwa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Metu',
		label: 'Metu, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dembi Dolo',
		label: 'Dembi Dolo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Sebeta',
		label: 'Sebeta, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bati',
		label: 'Bati, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bichena',
		label: 'Bichena, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Jinka',
		label: 'Jinka, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Asasa',
		label: 'Asasa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gelemso',
		label: 'Gelemso, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Awash',
		label: 'Awash, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Lalibela',
		label: 'Lalibela, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Sendafa',
		label: 'Sendafa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dirê Dawa',
		label: 'Dirê Dawa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gondar',
		label: 'Gondar, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Desê',
		label: 'Desê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Hossa'ina",
		label: "Hossa'ina, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Soddo',
		label: 'Soddo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Goba',
		label: 'Goba, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Endasilasie',
		label: 'Endasilasie, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Negêlê',
		label: 'Negêlê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Jijiga',
		label: 'Jijiga, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Aksum',
		label: 'Aksum, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Giyon',
		label: 'Giyon, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Weldiya',
		label: 'Weldiya, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Robê',
		label: 'Robê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Yirga Alem',
		label: 'Yirga Alem, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Agaro',
		label: 'Agaro, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Mek'i",
		label: "Mek'i, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Mojo',
		label: 'Mojo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debre Tabor',
		label: 'Debre Tabor, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "K'obo",
		label: "K'obo, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gimbi',
		label: 'Gimbi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Butajira',
		label: 'Butajira, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Asbe Teferi',
		label: 'Asbe Teferi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Kibre Mengist',
		label: 'Kibre Mengist, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Maych'ew",
		label: "Maych'ew, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Fichê',
		label: 'Fichê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Ziway',
		label: 'Ziway, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Mott'a",
		label: "Mott'a, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dubti',
		label: 'Dubti, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gambêla',
		label: 'Gambêla, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Chagni',
		label: 'Chagni, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Korem',
		label: 'Korem, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dangla',
		label: 'Dangla, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Sawla',
		label: 'Sawla, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Shakiso',
		label: 'Shakiso, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Wik'ro",
		label: "Wik'ro, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Welk'it'ê",
		label: "Welk'it'ê, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Werota',
		label: 'Werota, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Alaba Kulito',
		label: 'Alaba Kulito, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Himora',
		label: 'Himora, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debark',
		label: 'Debark, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Shewa Robit',
		label: 'Shewa Robit, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dodola',
		label: 'Dodola, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Finote Selam',
		label: 'Finote Selam, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Boditi',
		label: 'Boditi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Burê',
		label: 'Burê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Hagere Maryam',
		label: 'Hagere Maryam, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Areka',
		label: 'Areka, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Adêt',
		label: 'Adêt, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Ginir',
		label: 'Ginir, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bedelê',
		label: 'Bedelê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Metehara',
		label: 'Metehara, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Asosa',
		label: 'Asosa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Welench'iti",
		label: "Welench'iti, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Yirga Ch'efê",
		label: "Yirga Ch'efê, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Wendo',
		label: 'Wendo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Shambu',
		label: 'Shambu, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gebre Guracha',
		label: 'Gebre Guracha, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Nedjo',
		label: 'Nedjo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bonga',
		label: 'Bonga, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bedêsa',
		label: 'Bedêsa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Kemisê',
		label: 'Kemisê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Nefas Mewcha',
		label: 'Nefas Mewcha, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Abomsa',
		label: 'Abomsa, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Mizan Teferi',
		label: 'Mizan Teferi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Ginch'i",
		label: "Ginch'i, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Têppi',
		label: 'Têppi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Moyalê',
		label: 'Moyalê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bako',
		label: 'Bako, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Yabêlo',
		label: 'Yabêlo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Mendi',
		label: 'Mendi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Burayu',
		label: 'Burayu, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Degeh Bur',
		label: 'Degeh Bur, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Guder',
		label: 'Guder, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Huruta',
		label: 'Huruta, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Hirna',
		label: 'Hirna, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dejen',
		label: 'Dejen, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dabat',
		label: 'Dabat, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Leku',
		label: 'Leku, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gewane',
		label: 'Gewane, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Werdêr',
		label: 'Werdêr, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gidolê',
		label: 'Gidolê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debre Werk',
		label: 'Debre Werk, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Tulu Bolo',
		label: 'Tulu Bolo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Abiy Adi',
		label: 'Abiy Adi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Sek'ot'a",
		label: "Sek'ot'a, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Shêh Hussên',
		label: 'Shêh Hussên, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Îmi',
		label: 'Îmi, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Sirê',
		label: 'Sirê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Kofelê',
		label: 'Kofelê, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Debre Sina',
		label: 'Debre Sina, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Dolaw',
		label: 'Dolaw, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gore',
		label: 'Gore, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Bircot',
		label: 'Bircot, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Deder',
		label: 'Deder, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Were Îlu',
		label: 'Were Îlu, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Ch'ench'a",
		label: "Ch'ench'a, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Gêdo',
		label: 'Gêdo, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Mêga',
		label: 'Mêga, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Hagere Selam',
		label: 'Hagere Selam, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Ankober',
		label: 'Ankober, Ethiopia',
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: "Addi Ark'ay",
		label: "Addi Ark'ay, Ethiopia",
		type: 'city',
		flagClass: 'fi fi-et',
		isPopular: false,
	},
	{
		value: 'Falkland Islands (Malvinas)',
		label: 'Falkland Islands (Malvinas)',
		type: 'country',
		flagClass: 'fi fi-fk',
		isPopular: false,
	},
	{
		value: 'Goose Green',
		label: 'Goose Green, Falkland Islands (Malvinas)',
		type: 'city',
		flagClass: 'fi fi-fk',
		isPopular: false,
	},
	{
		value: 'Port Stanley',
		label: 'Port Stanley, Falkland Islands (Malvinas)',
		type: 'city',
		flagClass: 'fi fi-fk',
		isPopular: false,
	},
	{
		value: 'Grytviken',
		label: 'Grytviken, Falkland Islands (Malvinas)',
		type: 'city',
		flagClass: 'fi fi-fk',
		isPopular: false,
	},
	{
		value: 'Port Howard',
		label: 'Port Howard, Falkland Islands (Malvinas)',
		type: 'city',
		flagClass: 'fi fi-fk',
		isPopular: false,
	},
	{
		value: 'Faroe Islands',
		label: 'Faroe Islands',
		type: 'country',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Tórshavn',
		label: 'Tórshavn, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Eiði',
		label: 'Eiði, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Húsavík',
		label: 'Húsavík, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Klaksvík',
		label: 'Klaksvík, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Gøta',
		label: 'Gøta, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Runavík',
		label: 'Runavík, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Tvøroyri',
		label: 'Tvøroyri, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Fuglafjarð',
		label: 'Fuglafjarð, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Vágs',
		label: 'Vágs, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Nes',
		label: 'Nes, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Vestmanna',
		label: 'Vestmanna, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Kollafjarð',
		label: 'Kollafjarð, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Sjó',
		label: 'Sjó, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Midvágs',
		label: 'Midvágs, Faroe Islands',
		type: 'city',
		flagClass: 'fi fi-fo',
		isPopular: false,
	},
	{
		value: 'Fiji',
		label: 'Fiji',
		type: 'country',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Suva',
		label: 'Suva, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Ba',
		label: 'Ba, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Nadi',
		label: 'Nadi, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Lautoka',
		label: 'Lautoka, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Nausori',
		label: 'Nausori, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Labasa',
		label: 'Labasa, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Sigatoka',
		label: 'Sigatoka, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Savusavu',
		label: 'Savusavu, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Lami',
		label: 'Lami, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Malhaha',
		label: 'Malhaha, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Namosi',
		label: 'Namosi, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Vatukoula',
		label: 'Vatukoula, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Rakiraki',
		label: 'Rakiraki, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Levuka',
		label: 'Levuka, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Tavua',
		label: 'Tavua, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Korovou',
		label: 'Korovou, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Vunisea',
		label: 'Vunisea, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Navua',
		label: 'Navua, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Deuba',
		label: 'Deuba, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Tubou',
		label: 'Tubou, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Navouvalu',
		label: 'Navouvalu, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Seaqaqa',
		label: 'Seaqaqa, Fiji',
		type: 'city',
		flagClass: 'fi fi-fj',
		isPopular: false,
	},
	{
		value: 'Finland',
		label: 'Finland',
		type: 'country',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Helsinki',
		label: 'Helsinki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Oulu',
		label: 'Oulu, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Espoo',
		label: 'Espoo, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Tampere',
		label: 'Tampere, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Turku',
		label: 'Turku, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Jyväskylä',
		label: 'Jyväskylä, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Vaasa',
		label: 'Vaasa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lahti',
		label: 'Lahti, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Joensuu',
		label: 'Joensuu, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Vantaa',
		label: 'Vantaa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Rovaniemi',
		label: 'Rovaniemi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Anjalankoski',
		label: 'Anjalankoski, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kuopio',
		label: 'Kuopio, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Mikkeli',
		label: 'Mikkeli, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Hämeenlinna',
		label: 'Hämeenlinna, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Porvoo',
		label: 'Porvoo, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lappeenranta',
		label: 'Lappeenranta, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Pori',
		label: 'Pori, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Varkaus',
		label: 'Varkaus, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kokkola',
		label: 'Kokkola, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kirkkonummi',
		label: 'Kirkkonummi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Seinäjoki',
		label: 'Seinäjoki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Raahe',
		label: 'Raahe, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Forssa',
		label: 'Forssa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kajaani',
		label: 'Kajaani, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Imatra',
		label: 'Imatra, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Riihimäki',
		label: 'Riihimäki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Salò',
		label: 'Salò, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Vammala',
		label: 'Vammala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kauhajoki',
		label: 'Kauhajoki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kotka',
		label: 'Kotka, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Hyvinkää',
		label: 'Hyvinkää, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Pietarsaari',
		label: 'Pietarsaari, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Äänekoski',
		label: 'Äänekoski, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Jämsä',
		label: 'Jämsä, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Hanko',
		label: 'Hanko, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kouvola',
		label: 'Kouvola, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Raisio',
		label: 'Raisio, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Iisalmi',
		label: 'Iisalmi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Valkeakoski',
		label: 'Valkeakoski, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kuusamo',
		label: 'Kuusamo, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Parainen',
		label: 'Parainen, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kempele',
		label: 'Kempele, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lohja',
		label: 'Lohja, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Rauma',
		label: 'Rauma, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kerava',
		label: 'Kerava, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Nokia',
		label: 'Nokia, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Tornio',
		label: 'Tornio, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Ylöjärvi',
		label: 'Ylöjärvi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kuusankoski',
		label: 'Kuusankoski, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lempäälä',
		label: 'Lempäälä, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lieksa',
		label: 'Lieksa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Keuruu',
		label: 'Keuruu, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kemijärvi',
		label: 'Kemijärvi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Hamina',
		label: 'Hamina, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Järvenpää',
		label: 'Järvenpää, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Nurmijärvi',
		label: 'Nurmijärvi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Savonlinna',
		label: 'Savonlinna, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Vihti',
		label: 'Vihti, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kangasala',
		label: 'Kangasala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Heinola',
		label: 'Heinola, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kaarina',
		label: 'Kaarina, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Hollola',
		label: 'Hollola, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Sillinjärvi',
		label: 'Sillinjärvi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Orimattila',
		label: 'Orimattila, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lapua',
		label: 'Lapua, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Loviisa',
		label: 'Loviisa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Nivala',
		label: 'Nivala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Ilmajoki',
		label: 'Ilmajoki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Maarianhamina',
		label: 'Maarianhamina, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Oulainen',
		label: 'Oulainen, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Eura',
		label: 'Eura, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Harjavalta',
		label: 'Harjavalta, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Uusikarlepyy',
		label: 'Uusikarlepyy, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Tuusula',
		label: 'Tuusula, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kemi',
		label: 'Kemi, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Mäntsälä',
		label: 'Mäntsälä, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Sipoo',
		label: 'Sipoo, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Uusikaupunki',
		label: 'Uusikaupunki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Laukaa',
		label: 'Laukaa, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Mustasaari',
		label: 'Mustasaari, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Haukipudas',
		label: 'Haukipudas, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Tammisaari',
		label: 'Tammisaari, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Janakkala',
		label: 'Janakkala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Nastola',
		label: 'Nastola, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Naantali',
		label: 'Naantali, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Lieto',
		label: 'Lieto, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Ylivieska',
		label: 'Ylivieska, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Pirkkala',
		label: 'Pirkkala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kankaanpää',
		label: 'Kankaanpää, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Vehkalahti',
		label: 'Vehkalahti, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Ulvila',
		label: 'Ulvila, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Valkeala',
		label: 'Valkeala, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Joutseno',
		label: 'Joutseno, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kurikka',
		label: 'Kurikka, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Huittinen',
		label: 'Huittinen, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Muhos',
		label: 'Muhos, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kokemäki',
		label: 'Kokemäki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Kristiinankaupunki',
		label: 'Kristiinankaupunki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Noormarkku',
		label: 'Noormarkku, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Eurajoki',
		label: 'Eurajoki, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Nakkila',
		label: 'Nakkila, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'Säkylä',
		label: 'Säkylä, Finland',
		type: 'city',
		flagClass: 'fi fi-fi',
		isPopular: false,
	},
	{
		value: 'France',
		label: 'France',
		type: 'country',
		flagClass: 'fi fi-fr',
		isPopular: true,
	},
	{
		value: 'Nice',
		label: 'Nice, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Toulouse',
		label: 'Toulouse, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Marseille',
		label: 'Marseille, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Lyon',
		label: 'Lyon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bordeaux',
		label: 'Bordeaux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Aix-en-Provence',
		label: 'Aix-en-Provence, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Lille',
		label: 'Lille, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Courbevoie',
		label: 'Courbevoie, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Abbeville',
		label: 'Abbeville, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Grenoble',
		label: 'Grenoble, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Montpellier',
		label: 'Montpellier, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Nantes',
		label: 'Nantes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Antibes',
		label: 'Antibes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Annecy',
		label: 'Annecy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Rennes',
		label: 'Rennes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Versailles',
		label: 'Versailles, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Nancy',
		label: 'Nancy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Clermont-Ferrand',
		label: 'Clermont-Ferrand, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Rouen',
		label: 'Rouen, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Metz',
		label: 'Metz, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Fontainebleau',
		label: 'Fontainebleau, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Boulogne-Billancourt',
		label: 'Boulogne-Billancourt, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Reims',
		label: 'Reims, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Nimes',
		label: 'Nimes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Avignon',
		label: 'Avignon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Orléans',
		label: 'Orléans, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Perpignan',
		label: 'Perpignan, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Tours',
		label: 'Tours, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Dijon',
		label: 'Dijon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Issy-les-Moulineaux',
		label: 'Issy-les-Moulineaux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Angoulême',
		label: 'Angoulême, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Angers',
		label: 'Angers, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Limoges',
		label: 'Limoges, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Germain-en-Laye',
		label: 'Saint-Germain-en-Laye, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Brest',
		label: 'Brest, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Cergy',
		label: 'Cergy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Schiltigheim',
		label: 'Schiltigheim, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Mulhouse',
		label: 'Mulhouse, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Annemasse',
		label: 'Annemasse, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Caen',
		label: 'Caen, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Neuilly-sur-Seine',
		label: 'Neuilly-sur-Seine, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Amiens',
		label: 'Amiens, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Poitiers',
		label: 'Poitiers, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Levallois-Perret',
		label: 'Levallois-Perret, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Étienne',
		label: 'Saint-Étienne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Quimper',
		label: 'Quimper, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Créteil',
		label: 'Créteil, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Colmar',
		label: 'Colmar, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Rueil-Malmaison',
		label: 'Rueil-Malmaison, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Le Havre',
		label: 'Le Havre, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'La Rochelle',
		label: 'La Rochelle, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Belfort',
		label: 'Belfort, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Vincennes',
		label: 'Vincennes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Montreuil',
		label: 'Montreuil, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Valbonne',
		label: 'Valbonne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Asnières-sur-Seine',
		label: 'Asnières-sur-Seine, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Vannes',
		label: 'Vannes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Antony',
		label: 'Antony, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chambéry',
		label: 'Chambéry, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Suresnes',
		label: 'Suresnes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Le Mans',
		label: 'Le Mans, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Orsay',
		label: 'Orsay, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Béziers',
		label: 'Béziers, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Maisons-Laffitte',
		label: 'Maisons-Laffitte, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Grasse',
		label: 'Grasse, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Frontignan',
		label: 'Frontignan, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Massy',
		label: 'Massy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Thonon-les-Bains',
		label: 'Thonon-les-Bains, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Besançon',
		label: 'Besançon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Nanterre',
		label: 'Nanterre, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Pau',
		label: 'Pau, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Carcassonne',
		label: 'Carcassonne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Toulon',
		label: 'Toulon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Argenteuil',
		label: 'Argenteuil, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Hyères',
		label: 'Hyères, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Clichy',
		label: 'Clichy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Manosque',
		label: 'Manosque, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Mougins',
		label: 'Mougins, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Colombes',
		label: 'Colombes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Troyes',
		label: 'Troyes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Meudon',
		label: 'Meudon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Puteaux',
		label: 'Puteaux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Melun',
		label: 'Melun, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Cloud',
		label: 'Saint-Cloud, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Maur-des-Fossés',
		label: 'Saint-Maur-des-Fossés, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Lorient',
		label: 'Lorient, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Noisy-le-Grand',
		label: 'Noisy-le-Grand, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Narbonne',
		label: 'Narbonne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Cagnes-sur-Mer',
		label: 'Cagnes-sur-Mer, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Douai',
		label: 'Douai, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Thionville',
		label: 'Thionville, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Gex',
		label: 'Gex, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Les Pavillons-sous-Bois',
		label: 'Les Pavillons-sous-Bois, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Agen',
		label: 'Agen, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Palaiseau',
		label: 'Palaiseau, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Morlaix',
		label: 'Morlaix, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chantilly',
		label: 'Chantilly, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Rambouillet',
		label: 'Rambouillet, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Niort',
		label: 'Niort, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Pontivy',
		label: 'Pontivy, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Auch',
		label: 'Auch, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Blois',
		label: 'Blois, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chalon-sur-Saone',
		label: 'Chalon-sur-Saone, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Ajaccio',
		label: 'Ajaccio, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Brieuc',
		label: 'Saint-Brieuc, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Compiègne',
		label: 'Compiègne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Salon-de-Provence',
		label: 'Salon-de-Provence, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Talence',
		label: 'Talence, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Biarritz',
		label: 'Biarritz, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Houilles',
		label: 'Houilles, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Castelnaudary',
		label: 'Castelnaudary, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Nogent-sur-Marne',
		label: 'Nogent-sur-Marne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bergerac',
		label: 'Bergerac, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Aix-les-Bains',
		label: 'Aix-les-Bains, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Le Vésinet',
		label: 'Le Vésinet, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Viroflay',
		label: 'Viroflay, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Enghien-les-Bains',
		label: 'Enghien-les-Bains, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Ivry-sur-Seine',
		label: 'Ivry-sur-Seine, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Fréjus',
		label: 'Fréjus, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Mantes-la-Jolie',
		label: 'Mantes-la-Jolie, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Montmorency',
		label: 'Montmorency, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Alès',
		label: 'Alès, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chartres',
		label: 'Chartres, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Sélestat',
		label: 'Sélestat, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Périgueux',
		label: 'Périgueux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Plaisir',
		label: 'Plaisir, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Menton',
		label: 'Menton, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Denis',
		label: 'Saint-Denis, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Calais',
		label: 'Calais, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Vitry-sur-Seine',
		label: 'Vitry-sur-Seine, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Champigny-sur-Marne',
		label: 'Champigny-sur-Marne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Sarcelles',
		label: 'Sarcelles, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chamonix-Mont-Blanc',
		label: 'Chamonix-Mont-Blanc, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Sèvres',
		label: 'Sèvres, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Beauvais',
		label: 'Beauvais, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Brive-la-Gaillarde',
		label: 'Brive-la-Gaillarde, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Pantin',
		label: 'Pantin, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Albi',
		label: 'Albi, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Villejuif',
		label: 'Villejuif, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Agde',
		label: 'Agde, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bastia',
		label: 'Bastia, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Cognac',
		label: 'Cognac, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Beausoleil',
		label: 'Beausoleil, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Auxerre',
		label: 'Auxerre, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Lagny-sur-Marne',
		label: 'Lagny-sur-Marne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Genis-Pouilly',
		label: 'Saint-Genis-Pouilly, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Anglet',
		label: 'Anglet, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Lons-le-Saunier',
		label: 'Lons-le-Saunier, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saverne',
		label: 'Saverne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Achères',
		label: 'Achères, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Draguignan',
		label: 'Draguignan, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Mont-de-Marsan',
		label: 'Mont-de-Marsan, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Villefranche-sur-Saone',
		label: 'Villefranche-sur-Saone, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chatillon',
		label: 'Chatillon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bernay',
		label: 'Bernay, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Marly-le-Roi',
		label: 'Marly-le-Roi, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Draveil',
		label: 'Draveil, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Omer',
		label: 'Saint-Omer, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Vanves',
		label: 'Vanves, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Gentilly',
		label: 'Gentilly, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bonneville',
		label: 'Bonneville, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Les Ulis',
		label: 'Les Ulis, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Dunkerque',
		label: 'Dunkerque, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Valença',
		label: 'Valença, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Le Kremlin-Bicêtre',
		label: 'Le Kremlin-Bicêtre, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saint-Malo',
		label: 'Saint-Malo, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Montauban',
		label: 'Montauban, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Limoux',
		label: 'Limoux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Sartrouville',
		label: 'Sartrouville, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Évry',
		label: 'Évry, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Tarbes',
		label: 'Tarbes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Martigues',
		label: 'Martigues, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Cahors',
		label: 'Cahors, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chelles',
		label: 'Chelles, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Valenciennes',
		label: 'Valenciennes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bayonne',
		label: 'Bayonne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Villeneuve-Loubet',
		label: 'Villeneuve-Loubet, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Montrouge',
		label: 'Montrouge, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bagneux',
		label: 'Bagneux, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bourg-la-Reine',
		label: 'Bourg-la-Reine, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Alfortville',
		label: 'Alfortville, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Pertuis',
		label: 'Pertuis, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Chatenay-Malabry',
		label: 'Chatenay-Malabry, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Mandelieu-la-Napoule',
		label: 'Mandelieu-la-Napoule, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Alençon',
		label: 'Alençon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Joinville-le-Pont',
		label: 'Joinville-le-Pont, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Orange',
		label: 'Orange, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Vierzon',
		label: 'Vierzon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Soisy-sous-Montmorency',
		label: 'Soisy-sous-Montmorency, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Sens',
		label: 'Sens, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Saintes',
		label: 'Saintes, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Pontoise',
		label: 'Pontoise, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Le Pecq',
		label: 'Le Pecq, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Cavaillon',
		label: 'Cavaillon, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Aulnay-sous-Bois',
		label: 'Aulnay-sous-Bois, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Tournefeuille',
		label: 'Tournefeuille, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bourges',
		label: 'Bourges, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: "Villeneuve-d'Ascq",
		label: "Villeneuve-d'Ascq, France",
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'Bry-sur-Marne',
		label: 'Bry-sur-Marne, France',
		type: 'city',
		flagClass: 'fi fi-fr',
		isPopular: false,
	},
	{
		value: 'French Guiana',
		label: 'French Guiana',
		type: 'country',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Cayenne',
		label: 'Cayenne, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Kourou',
		label: 'Kourou, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Matoury',
		label: 'Matoury, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Saint-Laurent-du-Maroni',
		label: 'Saint-Laurent-du-Maroni, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Remire-Montjoly',
		label: 'Remire-Montjoly, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Mana',
		label: 'Mana, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Macouria',
		label: 'Macouria, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Maripasoula',
		label: 'Maripasoula, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Apatou',
		label: 'Apatou, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Grand-Santi',
		label: 'Grand-Santi, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Sinnamary',
		label: 'Sinnamary, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Saint-Georges',
		label: 'Saint-Georges, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Roura',
		label: 'Roura, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Iracoubo',
		label: 'Iracoubo, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'Camopi',
		label: 'Camopi, French Guiana',
		type: 'city',
		flagClass: 'fi fi-gf',
		isPopular: false,
	},
	{
		value: 'French Polynesia',
		label: 'French Polynesia',
		type: 'country',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Papeete',
		label: 'Papeete, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Punaauia',
		label: 'Punaauia, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Afaahiti',
		label: 'Afaahiti, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vaitape',
		label: 'Vaitape, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Rangiroa',
		label: 'Rangiroa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fitii',
		label: 'Fitii, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Niua',
		label: 'Niua, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fetuna',
		label: 'Fetuna, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faaa',
		label: 'Faaa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mahina',
		label: 'Mahina, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Papara',
		label: 'Papara, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Papeari',
		label: 'Papeari, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Afareaitu',
		label: 'Afareaitu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tautira',
		label: 'Tautira, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vairao',
		label: 'Vairao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Teavaro',
		label: 'Teavaro, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Taiohae',
		label: 'Taiohae, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Papetoai',
		label: 'Papetoai, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Pueu',
		label: 'Pueu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faanui',
		label: 'Faanui, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hitiaa',
		label: 'Hitiaa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tevaitoa',
		label: 'Tevaitoa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Atuona',
		label: 'Atuona, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faaone',
		label: 'Faaone, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hakahao',
		label: 'Hakahao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fare',
		label: 'Fare, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Teahupoo',
		label: 'Teahupoo, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Anau',
		label: 'Anau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hao',
		label: 'Hao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Iripau',
		label: 'Iripau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Maupiti',
		label: 'Maupiti, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Opoa',
		label: 'Opoa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Rikitea',
		label: 'Rikitea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Takaroa',
		label: 'Takaroa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Maeva',
		label: 'Maeva, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Moerai',
		label: 'Moerai, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mahaena',
		label: 'Mahaena, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mataura',
		label: 'Mataura, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vaiaau',
		label: 'Vaiaau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Haamene',
		label: 'Haamene, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Manihi',
		label: 'Manihi, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Makemo',
		label: 'Makemo, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fakarava',
		label: 'Fakarava, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Arutua',
		label: 'Arutua, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tahuata',
		label: 'Tahuata, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Kauehi',
		label: 'Kauehi, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hakamaii',
		label: 'Hakamaii, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Haapu',
		label: 'Haapu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Ua-Huka',
		label: 'Ua-Huka, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fatu-Hiva',
		label: 'Fatu-Hiva, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Taahuaia',
		label: 'Taahuaia, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tapuamu',
		label: 'Tapuamu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Takapoto',
		label: 'Takapoto, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Rairua',
		label: 'Rairua, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Maroe',
		label: 'Maroe, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Rapa',
		label: 'Rapa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tehurui',
		label: 'Tehurui, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hipu',
		label: 'Hipu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mahu',
		label: 'Mahu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Parea',
		label: 'Parea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Ruutia',
		label: 'Ruutia, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Ahe',
		label: 'Ahe, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Anaa',
		label: 'Anaa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Apataki',
		label: 'Apataki, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faaaha',
		label: 'Faaaha, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vaitoare',
		label: 'Vaitoare, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Katiu',
		label: 'Katiu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tikehau',
		label: 'Tikehau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tefarerii',
		label: 'Tefarerii, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hauti',
		label: 'Hauti, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Taipivai',
		label: 'Taipivai, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Kaukura',
		label: 'Kaukura, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Reao',
		label: 'Reao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hatiheu',
		label: 'Hatiheu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Maiao',
		label: 'Maiao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faaite',
		label: 'Faaite, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Faie',
		label: 'Faie, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Puamau',
		label: 'Puamau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tureia',
		label: 'Tureia, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mutuaura',
		label: 'Mutuaura, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Anatonu',
		label: 'Anatonu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tatakoto',
		label: 'Tatakoto, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Amaru',
		label: 'Amaru, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Napuka',
		label: 'Napuka, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Anapoto',
		label: 'Anapoto, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mataiva',
		label: 'Mataiva, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vaiuru',
		label: 'Vaiuru, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Raroia',
		label: 'Raroia, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Pukarua',
		label: 'Pukarua, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Pukapuka',
		label: 'Pukapuka, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hikueru',
		label: 'Hikueru, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Amanu',
		label: 'Amanu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Puohine',
		label: 'Puohine, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fakahima',
		label: 'Fakahima, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Niau',
		label: 'Niau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Nukutavake',
		label: 'Nukutavake, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Fangatau',
		label: 'Fangatau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Taenga',
		label: 'Taenga, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vahitahi',
		label: 'Vahitahi, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Makatea',
		label: 'Makatea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Hereheretue',
		label: 'Hereheretue, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Marokau',
		label: 'Marokau, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tepoto',
		label: 'Tepoto, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Vairaatea',
		label: 'Vairaatea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Pirae',
		label: 'Pirae, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Paea',
		label: 'Paea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Arue',
		label: 'Arue, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Mataiea',
		label: 'Mataiea, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Paopao',
		label: 'Paopao, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Haapiti',
		label: 'Haapiti, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Uturoa',
		label: 'Uturoa, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Papenoo',
		label: 'Papenoo, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Avera',
		label: 'Avera, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Toahotu',
		label: 'Toahotu, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'Tiarei',
		label: 'Tiarei, French Polynesia',
		type: 'city',
		flagClass: 'fi fi-pf',
		isPopular: false,
	},
	{
		value: 'French Southern Territories',
		label: 'French Southern Territories',
		type: 'country',
		flagClass: 'fi fi-tf',
		isPopular: false,
	},
	{
		value: 'Alfred-Faure',
		label: 'Alfred-Faure, French Southern Territories',
		type: 'city',
		flagClass: 'fi fi-tf',
		isPopular: false,
	},
	{
		value: 'Port-aux-Français',
		label: 'Port-aux-Français, French Southern Territories',
		type: 'city',
		flagClass: 'fi fi-tf',
		isPopular: false,
	},
	{
		value: 'Martin-de-Viviès',
		label: 'Martin-de-Viviès, French Southern Territories',
		type: 'city',
		flagClass: 'fi fi-tf',
		isPopular: false,
	},
	{
		value: 'Gabon',
		label: 'Gabon',
		type: 'country',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Libreville',
		label: 'Libreville, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Port-Gentil',
		label: 'Port-Gentil, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Gamba',
		label: 'Gamba, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Tchibanga',
		label: 'Tchibanga, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Bitam',
		label: 'Bitam, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mimongo',
		label: 'Mimongo, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Masuku',
		label: 'Masuku, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Moanda',
		label: 'Moanda, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Oyem',
		label: 'Oyem, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Makokou',
		label: 'Makokou, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mouila',
		label: 'Mouila, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Lambaréné',
		label: 'Lambaréné, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Koulamoutou',
		label: 'Koulamoutou, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mounana',
		label: 'Mounana, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Ntoum',
		label: 'Ntoum, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Nkan',
		label: 'Nkan, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Lastoursville',
		label: 'Lastoursville, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Okandja',
		label: 'Okandja, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Tsogni',
		label: 'Tsogni, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Ndendé',
		label: 'Ndendé, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Booué',
		label: 'Booué, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Fougamou',
		label: 'Fougamou, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Ndjolé',
		label: 'Ndjolé, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Setté Cama',
		label: 'Setté Cama, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mayumba',
		label: 'Mayumba, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mbigou',
		label: 'Mbigou, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mitzic',
		label: 'Mitzic, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Mékambo',
		label: 'Mékambo, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Lékoni',
		label: 'Lékoni, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Minvoul',
		label: 'Minvoul, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Omboué',
		label: 'Omboué, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Cocobeach',
		label: 'Cocobeach, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Lalara',
		label: 'Lalara, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Médouneu',
		label: 'Médouneu, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Kango',
		label: 'Kango, Gabon',
		type: 'city',
		flagClass: 'fi fi-ga',
		isPopular: false,
	},
	{
		value: 'Gambia',
		label: 'Gambia',
		type: 'country',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Banjul',
		label: 'Banjul, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Serekunda',
		label: 'Serekunda, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'al-Gharbiyah',
		label: 'al-Gharbiyah, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Bakau',
		label: 'Bakau, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'George Town',
		label: 'George Town, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Sukuta',
		label: 'Sukuta, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Gunjur',
		label: 'Gunjur, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Bansang',
		label: 'Bansang, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Sabi',
		label: 'Sabi, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Gambissara',
		label: 'Gambissara, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Kuntaur',
		label: 'Kuntaur, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Brufut',
		label: 'Brufut, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Essau',
		label: 'Essau, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Kerewan',
		label: 'Kerewan, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Barra',
		label: 'Barra, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Salikeni',
		label: 'Salikeni, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Farafenni',
		label: 'Farafenni, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Basse',
		label: 'Basse, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Lamin',
		label: 'Lamin, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Mansakonko',
		label: 'Mansakonko, Gambia',
		type: 'city',
		flagClass: 'fi fi-gm',
		isPopular: false,
	},
	{
		value: 'Georgia',
		label: 'Georgia',
		type: 'country',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tbilisi',
		label: 'Tbilisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Abasha',
		label: 'Abasha, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tskneti',
		label: 'Tskneti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Adigeni',
		label: 'Adigeni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Java',
		label: 'Java, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kutaisi',
		label: 'Kutaisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gori',
		label: 'Gori, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Samtredia',
		label: 'Samtredia, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ozurgeti',
		label: 'Ozurgeti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Sachkhere',
		label: 'Sachkhere, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Agra',
		label: 'Agra, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tsageri',
		label: 'Tsageri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Chakvi',
		label: 'Chakvi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhaldaba',
		label: 'Akhaldaba, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Jinvali',
		label: 'Jinvali, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Chokhatauri',
		label: 'Chokhatauri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Makhinjauri',
		label: 'Makhinjauri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kazbegi',
		label: 'Kazbegi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Abastumani',
		label: 'Abastumani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Bediani',
		label: 'Bediani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Rustavi',
		label: 'Rustavi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Batumi',
		label: 'Batumi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Sukhumi',
		label: 'Sukhumi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Zugdidi',
		label: 'Zugdidi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Telavi',
		label: 'Telavi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gali',
		label: 'Gali, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kvareli',
		label: 'Kvareli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ducheti',
		label: 'Ducheti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Pitsunda',
		label: 'Pitsunda, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tsalka',
		label: 'Tsalka, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Dioknisi',
		label: 'Dioknisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ambrolauri',
		label: 'Ambrolauri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tetri Tskaro',
		label: 'Tetri Tskaro, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kazreti',
		label: 'Kazreti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kareli',
		label: 'Kareli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ninotsminda',
		label: 'Ninotsminda, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Khobi',
		label: 'Khobi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Vani',
		label: 'Vani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Martvili',
		label: 'Martvili, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Shaumiani',
		label: 'Shaumiani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kharagauli',
		label: 'Kharagauli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tsnori',
		label: 'Tsnori, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Laituri',
		label: 'Laituri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tianeti',
		label: 'Tianeti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Manglisi',
		label: 'Manglisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Urmenis',
		label: 'Urmenis, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Jvari',
		label: 'Jvari, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Chkhototsku',
		label: 'Chkhototsku, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Signagi',
		label: 'Signagi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Aspindza',
		label: 'Aspindza, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Dmanisi',
		label: 'Dmanisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Khelvachauri',
		label: 'Khelvachauri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhali Atoni',
		label: 'Akhali Atoni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Didi Lilo',
		label: 'Didi Lilo, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Mestia',
		label: 'Mestia, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Naruja',
		label: 'Naruja, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Samgori',
		label: 'Samgori, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Pasanauri',
		label: 'Pasanauri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tsagveri',
		label: 'Tsagveri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kulashi',
		label: 'Kulashi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kveda Nasakirali',
		label: 'Kveda Nasakirali, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Bakuriani',
		label: 'Bakuriani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Oni',
		label: 'Oni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ochkhamuri',
		label: 'Ochkhamuri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Zahesi',
		label: 'Zahesi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Shorapani',
		label: 'Shorapani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ureki',
		label: 'Ureki, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhalgori',
		label: 'Akhalgori, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Keda',
		label: 'Keda, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Bakurianis Andeziti',
		label: 'Bakurianis Andeziti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Trialeti',
		label: 'Trialeti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Sioni',
		label: 'Sioni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Khulo',
		label: 'Khulo, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kojori',
		label: 'Kojori, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tamarisi',
		label: 'Tamarisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Shuakhevi',
		label: 'Shuakhevi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kvaisi',
		label: 'Kvaisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kornisi',
		label: 'Kornisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kharistvala',
		label: 'Kharistvala, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Lajanurhesi',
		label: 'Lajanurhesi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gagra',
		label: 'Gagra, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Chiatura',
		label: 'Chiatura, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tskhaltubo',
		label: 'Tskhaltubo, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Khashuri',
		label: 'Khashuri, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Poti',
		label: 'Poti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tskhinvali',
		label: 'Tskhinvali, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tkibuli',
		label: 'Tkibuli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Zestaphoni',
		label: 'Zestaphoni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Senaki',
		label: 'Senaki, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gardabani',
		label: 'Gardabani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhaltsikhe',
		label: 'Akhaltsikhe, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kaspi',
		label: 'Kaspi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Marneuli',
		label: 'Marneuli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Borjomi',
		label: 'Borjomi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tkvarcheli',
		label: 'Tkvarcheli, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Mtskheta',
		label: 'Mtskheta, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Ochamchira',
		label: 'Ochamchira, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Sagarejo',
		label: 'Sagarejo, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Khoni',
		label: 'Khoni, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gurjaani',
		label: 'Gurjaani, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Bolnisi',
		label: 'Bolnisi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhalkaliki',
		label: 'Akhalkaliki, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gudauta',
		label: 'Gudauta, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Tsalenjikha',
		label: 'Tsalenjikha, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Akhmeta',
		label: 'Akhmeta, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Lentekhi',
		label: 'Lentekhi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Dedophlistskaro',
		label: 'Dedophlistskaro, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Kobuleti',
		label: 'Kobuleti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Surami',
		label: 'Surami, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Lanchkhuti',
		label: 'Lanchkhuti, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Terjola',
		label: 'Terjola, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Gulripshi',
		label: 'Gulripshi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Baghdati',
		label: 'Baghdati, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Lagodekhi',
		label: 'Lagodekhi, Georgia',
		type: 'city',
		flagClass: 'fi fi-ge',
		isPopular: false,
	},
	{
		value: 'Hamburg',
		label: 'Hamburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Frankfurt',
		label: 'Frankfurt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'München',
		label: 'München, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Düsseldorf',
		label: 'Düsseldorf, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Köln',
		label: 'Köln, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Aachen',
		label: 'Aachen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Stuttgart',
		label: 'Stuttgart, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kaiserslautern',
		label: 'Kaiserslautern, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bremen',
		label: 'Bremen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Heidelberg',
		label: 'Heidelberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bonn',
		label: 'Bonn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Darmstadt',
		label: 'Darmstadt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Wiesbaden',
		label: 'Wiesbaden, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hannover',
		label: 'Hannover, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Nürnberg',
		label: 'Nürnberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Mannheim',
		label: 'Mannheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Karlsruhe',
		label: 'Karlsruhe, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Mainz',
		label: 'Mainz, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Dresden',
		label: 'Dresden, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Freiburg',
		label: 'Freiburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Dortmund',
		label: 'Dortmund, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Leipzig',
		label: 'Leipzig, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Würzburg',
		label: 'Würzburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Regensburg',
		label: 'Regensburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Augsburg',
		label: 'Augsburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Göttingen',
		label: 'Göttingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Essen',
		label: 'Essen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bamberg',
		label: 'Bamberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ansbach',
		label: 'Ansbach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Schweinfurt',
		label: 'Schweinfurt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Münster',
		label: 'Münster, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Duisburg',
		label: 'Duisburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Trier',
		label: 'Trier, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kiel',
		label: 'Kiel, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bochum',
		label: 'Bochum, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bielefeld',
		label: 'Bielefeld, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ingolstadt',
		label: 'Ingolstadt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kassel',
		label: 'Kassel, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Amberg',
		label: 'Amberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Heilbronn',
		label: 'Heilbronn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Gießen',
		label: 'Gießen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Magdeburg',
		label: 'Magdeburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Saarbrücken',
		label: 'Saarbrücken, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Paderborn',
		label: 'Paderborn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Erfurt',
		label: 'Erfurt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hanau',
		label: 'Hanau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Aschaffenburg',
		label: 'Aschaffenburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ulm',
		label: 'Ulm, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Wuppertal',
		label: 'Wuppertal, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Mönchengladbach',
		label: 'Mönchengladbach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Aalen',
		label: 'Aalen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Tübingen',
		label: 'Tübingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Homburg',
		label: 'Bad Homburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bitburg',
		label: 'Bitburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Braunschweig',
		label: 'Braunschweig, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Konstanz',
		label: 'Konstanz, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Lübeck',
		label: 'Lübeck, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Koblenz',
		label: 'Koblenz, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Erlangen',
		label: 'Erlangen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Fulda',
		label: 'Fulda, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Freising',
		label: 'Freising, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Krefeld',
		label: 'Krefeld, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Oldenburg',
		label: 'Oldenburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Walldorf',
		label: 'Walldorf, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Rostock',
		label: 'Rostock, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Potsdam',
		label: 'Potsdam, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Esslingen',
		label: 'Esslingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Marburg',
		label: 'Marburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Rosenheim',
		label: 'Rosenheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Jena',
		label: 'Jena, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Lüneburg',
		label: 'Lüneburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Passau',
		label: 'Passau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Offenbach',
		label: 'Offenbach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Flensburg',
		label: 'Flensburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Kreuznach',
		label: 'Bad Kreuznach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Recklinghausen',
		label: 'Recklinghausen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bergisch Gladbach',
		label: 'Bergisch Gladbach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hildesheim',
		label: 'Hildesheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Villingen-Schwenningen',
		label: 'Villingen-Schwenningen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bayreuth',
		label: 'Bayreuth, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Leverkusen',
		label: 'Leverkusen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Wolfsburg',
		label: 'Wolfsburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Pforzheim',
		label: 'Pforzheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Waldshut-Tiengen',
		label: 'Waldshut-Tiengen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Friedrichshafen',
		label: 'Friedrichshafen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Siegburg',
		label: 'Siegburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Starnberg',
		label: 'Starnberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Reutlingen',
		label: 'Reutlingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ratingen',
		label: 'Ratingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Idar-Oberstein',
		label: 'Idar-Oberstein, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Erding',
		label: 'Erding, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Celle',
		label: 'Celle, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Lippstadt',
		label: 'Lippstadt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kleve',
		label: 'Kleve, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Soest',
		label: 'Soest, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Weiden',
		label: 'Weiden, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Coburg',
		label: 'Coburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Chemnitz',
		label: 'Chemnitz, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Halle',
		label: 'Halle, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Mülheim',
		label: 'Mülheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Osnabrück',
		label: 'Osnabrück, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ludwigshafen',
		label: 'Ludwigshafen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Pfaffenhofen',
		label: 'Pfaffenhofen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Schwerin',
		label: 'Schwerin, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ludwigsburg',
		label: 'Ludwigsburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Delmenhorst',
		label: 'Delmenhorst, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Babenhausen',
		label: 'Babenhausen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Vilbel',
		label: 'Bad Vilbel, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Landshut',
		label: 'Landshut, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Böblingen',
		label: 'Böblingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Heinsberg',
		label: 'Heinsberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Saarlouis',
		label: 'Saarlouis, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Siegen',
		label: 'Siegen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Jülich',
		label: 'Jülich, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Limburg',
		label: 'Limburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Gütersloh',
		label: 'Gütersloh, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Dessau',
		label: 'Dessau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Gladbeck',
		label: 'Gladbeck, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Norderstedt',
		label: 'Norderstedt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kempten',
		label: 'Kempten, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Rüsselsheim',
		label: 'Rüsselsheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Meerbusch',
		label: 'Meerbusch, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Lörrach',
		label: 'Lörrach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Freiberg',
		label: 'Freiberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Pirmasens',
		label: 'Pirmasens, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Heppenheim',
		label: 'Heppenheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bruchsal',
		label: 'Bruchsal, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bietigheim-Bissingen',
		label: 'Bietigheim-Bissingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Friedrichsdorf',
		label: 'Friedrichsdorf, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Gelsenkirchen',
		label: 'Gelsenkirchen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bensheim',
		label: 'Bensheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Oberhausen',
		label: 'Oberhausen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hofheim',
		label: 'Hofheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hamm',
		label: 'Hamm, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Eckernförde',
		label: 'Eckernförde, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Solingen',
		label: 'Solingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bremerhaven',
		label: 'Bremerhaven, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Fürstenfeldbruck',
		label: 'Fürstenfeldbruck, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Viernheim',
		label: 'Viernheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Troisdorf',
		label: 'Troisdorf, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Detmold',
		label: 'Detmold, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kitzingen',
		label: 'Kitzingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Soden',
		label: 'Bad Soden, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hameln',
		label: 'Hameln, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Offenburg',
		label: 'Offenburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Eschborn',
		label: 'Eschborn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Windsheim',
		label: 'Bad Windsheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Cuxhaven',
		label: 'Cuxhaven, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Nordhorn',
		label: 'Nordhorn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Neu-Ulm',
		label: 'Neu-Ulm, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Heidenheim',
		label: 'Heidenheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Neuenahr-Ahrweiler',
		label: 'Bad Neuenahr-Ahrweiler, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Erkrath',
		label: 'Erkrath, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Elmshorn',
		label: 'Elmshorn, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Limburgerhof',
		label: 'Limburgerhof, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bornheim',
		label: 'Bornheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Frankenthal',
		label: 'Frankenthal, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Garmisch-Partenkirchen',
		label: 'Garmisch-Partenkirchen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bünde',
		label: 'Bünde, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Rodgau',
		label: 'Rodgau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kaufbeuren',
		label: 'Kaufbeuren, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Landau',
		label: 'Landau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bingen',
		label: 'Bingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Dreieich',
		label: 'Dreieich, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Traunstein',
		label: 'Traunstein, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Alsfeld',
		label: 'Alsfeld, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hagen',
		label: 'Hagen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Herne',
		label: 'Herne, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Herzogenaurach',
		label: 'Herzogenaurach, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Neu-Isenburg',
		label: 'Neu-Isenburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Langen',
		label: 'Langen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Schwetzingen',
		label: 'Schwetzingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Remscheid',
		label: 'Remscheid, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Fürth',
		label: 'Fürth, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Sulingen',
		label: 'Sulingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Cottbus',
		label: 'Cottbus, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Mörfelden-Walldorf',
		label: 'Mörfelden-Walldorf, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Lüdenscheid',
		label: 'Lüdenscheid, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bad Reichenhall',
		label: 'Bad Reichenhall, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Berlin',
		label: 'Berlin, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: true,
	},
	{
		value: 'Überlingen',
		label: 'Überlingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Weimar',
		label: 'Weimar, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Radolfzell',
		label: 'Radolfzell, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Friedberg',
		label: 'Friedberg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hattingen',
		label: 'Hattingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Vaihingen',
		label: 'Vaihingen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Geilenkirchen',
		label: 'Geilenkirchen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Bretten',
		label: 'Bretten, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kevelaer',
		label: 'Kevelaer, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hammelburg',
		label: 'Hammelburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Gangelt',
		label: 'Gangelt, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Neckarsulm',
		label: 'Neckarsulm, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hof',
		label: 'Hof, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Günzburg',
		label: 'Günzburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Leimen',
		label: 'Leimen, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Hainburg',
		label: 'Hainburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ravensburg',
		label: 'Ravensburg, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Kelkheim',
		label: 'Kelkheim, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ilmenau',
		label: 'Ilmenau, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Schwanewede',
		label: 'Schwanewede, Germany',
		type: 'city',
		flagClass: 'fi fi-de',
		isPopular: false,
	},
	{
		value: 'Ghana',
		label: 'Ghana',
		type: 'country',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Accra',
		label: 'Accra, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kumasi',
		label: 'Kumasi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Aboso',
		label: 'Aboso, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Tamale',
		label: 'Tamale, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Tema New Town',
		label: 'Tema New Town, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Cape Coast',
		label: 'Cape Coast, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Takoradi',
		label: 'Takoradi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Koforidua',
		label: 'Koforidua, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Ashiaman',
		label: 'Ashiaman, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Ho',
		label: 'Ho, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Aburi',
		label: 'Aburi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Nsawam',
		label: 'Nsawam, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Sunyani',
		label: 'Sunyani, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Tafo',
		label: 'Tafo, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Tarkwa',
		label: 'Tarkwa, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Bolgatanga',
		label: 'Bolgatanga, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Swedru',
		label: 'Swedru, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Madina',
		label: 'Madina, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Aflao',
		label: 'Aflao, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Somanya',
		label: 'Somanya, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Tima',
		label: 'Tima, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Teshie',
		label: 'Teshie, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Wa',
		label: 'Wa, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Nungua',
		label: 'Nungua, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Winneba',
		label: 'Winneba, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Berekum',
		label: 'Berekum, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Bawku',
		label: 'Bawku, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Elmina',
		label: 'Elmina, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Ada',
		label: 'Ada, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Suhum',
		label: 'Suhum, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Konongo',
		label: 'Konongo, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Foso',
		label: 'Foso, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Keta',
		label: 'Keta, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Obuasi',
		label: 'Obuasi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Nkawkaw',
		label: 'Nkawkaw, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Mampong',
		label: 'Mampong, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Oda',
		label: 'Oda, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Anloga',
		label: 'Anloga, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Begoro',
		label: 'Begoro, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Ofinso',
		label: 'Ofinso, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Akropong',
		label: 'Akropong, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Mpraeso',
		label: 'Mpraeso, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Sekondi',
		label: 'Sekondi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Yendi',
		label: 'Yendi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Agogo',
		label: 'Agogo, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Techiman',
		label: 'Techiman, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Asamankese',
		label: 'Asamankese, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Hohoe',
		label: 'Hohoe, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Savelugu',
		label: 'Savelugu, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Dunkwa',
		label: 'Dunkwa, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Saltpond',
		label: 'Saltpond, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Bechem',
		label: 'Bechem, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Nyakrom',
		label: 'Nyakrom, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Komenda',
		label: 'Komenda, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kete-Krachi',
		label: 'Kete-Krachi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kibi',
		label: 'Kibi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Okitsiu',
		label: 'Okitsiu, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Wenchi',
		label: 'Wenchi, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kpandu',
		label: 'Kpandu, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kintampo',
		label: 'Kintampo, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Prestea',
		label: 'Prestea, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Apan',
		label: 'Apan, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Axim',
		label: 'Axim, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Mankranso',
		label: 'Mankranso, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Salaga',
		label: 'Salaga, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Shama',
		label: 'Shama, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kade',
		label: 'Kade, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Navrongo',
		label: 'Navrongo, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Duayaw Nkwanta',
		label: 'Duayaw Nkwanta, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Mumford',
		label: 'Mumford, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Mauri',
		label: 'Mauri, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Bibiani',
		label: 'Bibiani, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Anomabu',
		label: 'Anomabu, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Kpandae',
		label: 'Kpandae, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Akim Swedru',
		label: 'Akim Swedru, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Bekwai',
		label: 'Bekwai, Ghana',
		type: 'city',
		flagClass: 'fi fi-gh',
		isPopular: false,
	},
	{
		value: 'Gibraltar',
		label: 'Gibraltar',
		type: 'country',
		flagClass: 'fi fi-gi',
		isPopular: false,
	},
	{
		value: 'Gibraltar',
		label: 'Gibraltar, Gibraltar',
		type: 'city',
		flagClass: 'fi fi-gi',
		isPopular: false,
	},
	{
		value: 'Thessaloníki',
		label: 'Thessaloníki, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Rhodes',
		label: 'Rhodes, Greece',
		type: 'island',
		flagClass: 'fi fi-gr',
		isPopular: true,
	},
	{
		value: 'Adámas',
		label: 'Adámas, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Santorini',
		label: 'Santorini, Greece',
		type: 'island',
		flagClass: 'fi fi-gr',
		isPopular: true,
	},
	{
		value: 'Crete',
		label: 'Crete, Greece',
		type: 'island',
		flagClass: 'fi fi-gr',
		isPopular: true,
	},
	{
		value: 'Mykonos',
		label: 'Mykonos, Greece',
		type: 'island',
		flagClass: 'fi fi-gr',
		isPopular: true,
	},
	{
		value: 'Iráklion',
		label: 'Iráklion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Piraieús',
		label: 'Piraieús, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Glifáda',
		label: 'Glifáda, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Pátrai',
		label: 'Pátrai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vólos',
		label: 'Vólos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Lárisa',
		label: 'Lárisa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kalamáta',
		label: 'Kalamáta, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ródos',
		label: 'Ródos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kateríni',
		label: 'Kateríni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kérkira',
		label: 'Kérkira, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Mitilíni',
		label: 'Mitilíni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Voúla',
		label: 'Voúla, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kavála',
		label: 'Kavála, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kifisiá',
		label: 'Kifisiá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Aigáleo',
		label: 'Aigáleo, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Réthimnon',
		label: 'Réthimnon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Níkaia',
		label: 'Níkaia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Amaroúsion',
		label: 'Amaroúsion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ayía Paraskeví',
		label: 'Ayía Paraskeví, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ambelókipoi',
		label: 'Ambelókipoi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Árta',
		label: 'Árta, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Haniá',
		label: 'Haniá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Agrínion',
		label: 'Agrínion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Thrakomakedónes',
		label: 'Thrakomakedónes, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Alexandroúpoli',
		label: 'Alexandroúpoli, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Tríkala',
		label: 'Tríkala, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Áthira',
		label: 'Áthira, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Igoumenítsa',
		label: 'Igoumenítsa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Sámos',
		label: 'Sámos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Peristérion',
		label: 'Peristérion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ílion',
		label: 'Ílion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Keratsínion',
		label: 'Keratsínion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Smírni',
		label: 'Néa Smírni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Sérrai',
		label: 'Sérrai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Lamía',
		label: 'Lamía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Xánthi',
		label: 'Xánthi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vrilíssia',
		label: 'Vrilíssia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kastoriá',
		label: 'Kastoriá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ierápetra',
		label: 'Ierápetra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Zákinthos',
		label: 'Zákinthos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Anávissos',
		label: 'Anávissos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Moudaniá',
		label: 'Néa Moudaniá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Thíra',
		label: 'Thíra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Páros',
		label: 'Páros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ilioúpoli',
		label: 'Ilioúpoli, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Athíkia',
		label: 'Athíkia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Ionía',
		label: 'Néa Ionía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ioánnina',
		label: 'Ioánnina, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Eúosmon',
		label: 'Eúosmon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Dráma',
		label: 'Dráma, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Korinthía',
		label: 'Korinthía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ptolemaís',
		label: 'Ptolemaís, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kambí',
		label: 'Kambí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Filadelfia',
		label: 'Néa Filadelfia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Pírgos',
		label: 'Pírgos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Pilaía',
		label: 'Pilaía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kos',
		label: 'Kos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ellinikón',
		label: 'Ellinikón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Spárti',
		label: 'Spárti, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ermoúpolis',
		label: 'Ermoúpolis, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néon Psikhikón',
		label: 'Néon Psikhikón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Áyios Nikólaos',
		label: 'Áyios Nikólaos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Aíyina',
		label: 'Aíyina, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Toúmba',
		label: 'Toúmba, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Mikhanióna',
		label: 'Néa Mikhanióna, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ándros',
		label: 'Ándros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Leukás',
		label: 'Leukás, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Anthíli',
		label: 'Anthíli, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Gliká Nerá',
		label: 'Gliká Nerá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kría Vrísi',
		label: 'Kría Vrísi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Míkonos',
		label: 'Míkonos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Sími',
		label: 'Sími, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vouliagméni',
		label: 'Vouliagméni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kítros',
		label: 'Kítros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Drosiá',
		label: 'Drosiá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Polídrosos',
		label: 'Polídrosos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Alivérion',
		label: 'Alivérion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Palaiokhóra',
		label: 'Palaiokhóra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Políyiros',
		label: 'Políyiros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Stilís',
		label: 'Stilís, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Skhimatárion',
		label: 'Skhimatárion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vrontádos',
		label: 'Vrontádos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Desfína',
		label: 'Desfína, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Dístomon',
		label: 'Dístomon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ánthia',
		label: 'Ánthia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Marathón',
		label: 'Marathón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Saronís',
		label: 'Saronís, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kallithéa',
		label: 'Kallithéa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Alíartos',
		label: 'Alíartos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ntráfi',
		label: 'Ntráfi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Zeugolatíon',
		label: 'Zeugolatíon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Koridallós',
		label: 'Koridallós, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Palaión Fáliron',
		label: 'Palaión Fáliron, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Víron',
		label: 'Víron, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kíssamos',
		label: 'Kíssamos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Spétsai',
		label: 'Spétsai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Komotiní',
		label: 'Komotiní, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kalívai',
		label: 'Kalívai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kozáni',
		label: 'Kozáni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Aryiroúpoli',
		label: 'Aryiroúpoli, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Perdíkkas',
		label: 'Perdíkkas, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Khóra',
		label: 'Khóra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Afídnai',
		label: 'Afídnai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Metamórfosi',
		label: 'Metamórfosi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kaisarianí',
		label: 'Kaisarianí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Darátsos',
		label: 'Darátsos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Eleusís',
		label: 'Eleusís, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Salamís',
		label: 'Salamís, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Glóssa',
		label: 'Glóssa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Spárta',
		label: 'Spárta, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Dáfni',
		label: 'Dáfni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Erétria',
		label: 'Erétria, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Erikoússa',
		label: 'Erikoússa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Moskháton',
		label: 'Moskháton, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Mégara',
		label: 'Mégara, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Oinófita',
		label: 'Oinófita, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vartholomió',
		label: 'Vartholomió, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Mesopotamiá',
		label: 'Mesopotamiá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Peúki',
		label: 'Peúki, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Édessa',
		label: 'Édessa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Veryína',
		label: 'Veryína, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Préveza',
		label: 'Préveza, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ágrafa',
		label: 'Ágrafa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Skíros',
		label: 'Skíros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Áyios Ioánnis Réntis',
		label: 'Áyios Ioánnis Réntis, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Thesprotikón',
		label: 'Thesprotikón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Aiyíra',
		label: 'Aiyíra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Mákri',
		label: 'Néa Mákri, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Antikíra',
		label: 'Antikíra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Peraía',
		label: 'Peraía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Alessandria',
		label: 'Alessandria, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Íos',
		label: 'Íos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Naúpaktos',
		label: 'Naúpaktos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Paianía',
		label: 'Paianía, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kalívia Thorikoú',
		label: 'Kalívia Thorikoú, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Loutrákion',
		label: 'Loutrákion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kaména Voúrla',
		label: 'Kaména Voúrla, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Rafína',
		label: 'Rafína, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Tírnavos',
		label: 'Tírnavos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Piryetós',
		label: 'Piryetós, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Psikhikón',
		label: 'Psikhikón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kálimnos',
		label: 'Kálimnos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Alepoú',
		label: 'Alepoú, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kiáto',
		label: 'Kiáto, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Argostólion',
		label: 'Argostólion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Skoútari',
		label: 'Skoútari, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Karidítsa',
		label: 'Karidítsa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Astakós',
		label: 'Astakós, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Likóvrisi',
		label: 'Likóvrisi, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Grizánon',
		label: 'Grizánon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Markópoulon',
		label: 'Markópoulon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Árgos Orestikón',
		label: 'Árgos Orestikón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Rodolívos',
		label: 'Rodolívos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Mitrópoli',
		label: 'Mitrópoli, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Epídauros',
		label: 'Néa Epídauros, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Theodóriana',
		label: 'Theodóriana, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Gastoúni',
		label: 'Gastoúni, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Símantra',
		label: 'Símantra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Mitroúsion',
		label: 'Mitroúsion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Kharauyí',
		label: 'Néa Kharauyí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kalambáka',
		label: 'Kalambáka, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Tsarítsani',
		label: 'Tsarítsani, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Pella',
		label: 'Néa Pella, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Láva',
		label: 'Néa Láva, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Valsamáta',
		label: 'Valsamáta, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Keratéa',
		label: 'Keratéa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Vathí',
		label: 'Vathí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Potídaia',
		label: 'Néa Potídaia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Róda',
		label: 'Néa Róda, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Anakasiá',
		label: 'Anakasiá, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Néa Péramos',
		label: 'Néa Péramos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Anóyia',
		label: 'Anóyia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Nisíon',
		label: 'Nisíon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Áno Kastrítsion',
		label: 'Áno Kastrítsion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Epanomí',
		label: 'Epanomí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ássos',
		label: 'Ássos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Palaiokhórion',
		label: 'Palaiokhórion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Aréthousa',
		label: 'Aréthousa, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Filothí',
		label: 'Filothí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Drimós',
		label: 'Drimós, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Auliótai',
		label: 'Auliótai, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Khalástra',
		label: 'Khalástra, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Elátia',
		label: 'Elátia, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Plátanos',
		label: 'Plátanos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Ólinthos',
		label: 'Ólinthos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Eúmoiron',
		label: 'Eúmoiron, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Europós',
		label: 'Europós, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Pontisménon',
		label: 'Pontisménon, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Oxílithos',
		label: 'Oxílithos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Éxarkhos',
		label: 'Éxarkhos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Elassón',
		label: 'Elassón, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kanallákion',
		label: 'Kanallákion, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Thespiaí',
		label: 'Thespiaí, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Palaiomonástiron',
		label: 'Palaiomonástiron, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Gaúrio',
		label: 'Gaúrio, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Lankadás',
		label: 'Lankadás, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Kéfalos',
		label: 'Kéfalos, Greece',
		type: 'city',
		flagClass: 'fi fi-gr',
		isPopular: false,
	},
	{
		value: 'Greenland',
		label: 'Greenland',
		type: 'country',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Aappilattoq',
		label: 'Aappilattoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Narsaq',
		label: 'Narsaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Nuuk',
		label: 'Nuuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Sisimiut',
		label: 'Sisimiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ilulissat',
		label: 'Ilulissat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qaqortoq',
		label: 'Qaqortoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Paamiut',
		label: 'Paamiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Alluitsup Paa',
		label: 'Alluitsup Paa, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kulusuk',
		label: 'Kulusuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Upernavik Kujalleq',
		label: 'Upernavik Kujalleq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Uunarteq',
		label: 'Uunarteq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Alluitsoq',
		label: 'Alluitsoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangerluarsoruseq',
		label: 'Kangerluarsoruseq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Aasiaat',
		label: 'Aasiaat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Maniitsoq',
		label: 'Maniitsoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Tasiilaq',
		label: 'Tasiilaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qasigiannguit',
		label: 'Qasigiannguit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Uummannaq',
		label: 'Uummannaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Nanortalik',
		label: 'Nanortalik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Upernavik',
		label: 'Upernavik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qeqertarsuaq',
		label: 'Qeqertarsuaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangaatsiaq',
		label: 'Kangaatsiaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qaanaaq',
		label: 'Qaanaaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangerlussuaq',
		label: 'Kangerlussuaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Illoqqortoormiut',
		label: 'Illoqqortoormiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangaamiut',
		label: 'Kangaamiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kullorsuaq',
		label: 'Kullorsuaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kuumiut',
		label: 'Kuumiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Niaqornaarsuk',
		label: 'Niaqornaarsuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Attu',
		label: 'Attu, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qeqertarsuatsiaat',
		label: 'Qeqertarsuatsiaat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Saattut',
		label: 'Saattut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangersuatsiaq',
		label: 'Kangersuatsiaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ikerasak',
		label: 'Ikerasak, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Atammik',
		label: 'Atammik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qaarsut',
		label: 'Qaarsut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Nuusuaq',
		label: 'Nuusuaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Pituffik',
		label: 'Pituffik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ukkusissat',
		label: 'Ukkusissat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Arsuk',
		label: 'Arsuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Saqqaq',
		label: 'Saqqaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Tasiusaq',
		label: 'Tasiusaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Sermiligaaq',
		label: 'Sermiligaaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Narsarsuaq',
		label: 'Narsarsuaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Tiniteqilaaq',
		label: 'Tiniteqilaaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Itilleq',
		label: 'Itilleq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qeqertaq',
		label: 'Qeqertaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Eqalugaarsuit',
		label: 'Eqalugaarsuit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kangilinnguit',
		label: 'Kangilinnguit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Akunnaaq',
		label: 'Akunnaaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Napasoq',
		label: 'Napasoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Isortoq',
		label: 'Isortoq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Narsarmijit',
		label: 'Narsarmijit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Nuugaatsiaq',
		label: 'Nuugaatsiaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Sarfannguit',
		label: 'Sarfannguit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Illorsuit',
		label: 'Illorsuit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ammassivik',
		label: 'Ammassivik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kapisillit',
		label: 'Kapisillit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Kitsissuarsuit',
		label: 'Kitsissuarsuit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Iginniarfik',
		label: 'Iginniarfik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ilimanaq',
		label: 'Ilimanaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Savissivik',
		label: 'Savissivik, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ikerasaarsuk',
		label: 'Ikerasaarsuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ikamiut',
		label: 'Ikamiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Siorapaluk',
		label: 'Siorapaluk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Naajaat',
		label: 'Naajaat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Niaqornat',
		label: 'Niaqornat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Saarloq',
		label: 'Saarloq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Igaliku',
		label: 'Igaliku, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Moriusaq',
		label: 'Moriusaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qassiarsuk',
		label: 'Qassiarsuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qassimiut',
		label: 'Qassimiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Oqaatsut',
		label: 'Oqaatsut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Itterajivit',
		label: 'Itterajivit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qeqertat',
		label: 'Qeqertat, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Akuliaruseq',
		label: 'Akuliaruseq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Ivittuut',
		label: 'Ivittuut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qinngua',
		label: 'Qinngua, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Neriunaq',
		label: 'Neriunaq, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Qallimiut',
		label: 'Qallimiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Saqqamiut',
		label: 'Saqqamiut, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Timerliit',
		label: 'Timerliit, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Upernaviarsuk',
		label: 'Upernaviarsuk, Greenland',
		type: 'city',
		flagClass: 'fi fi-gl',
		isPopular: false,
	},
	{
		value: 'Grenada',
		label: 'Grenada',
		type: 'country',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Carlisle',
		label: 'Carlisle, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Saint Davids',
		label: 'Saint Davids, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Sauteurs',
		label: 'Sauteurs, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Gouyave',
		label: 'Gouyave, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Grenville',
		label: 'Grenville, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Saint Georges',
		label: 'Saint Georges, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Hillsborough',
		label: 'Hillsborough, Grenada',
		type: 'city',
		flagClass: 'fi fi-gd',
		isPopular: false,
	},
	{
		value: 'Guadeloupe',
		label: 'Guadeloupe',
		type: 'country',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Baie-Mahault',
		label: 'Baie-Mahault, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Petit-Bourg',
		label: 'Petit-Bourg, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Anse-Bertrand',
		label: 'Anse-Bertrand, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Les Abymes',
		label: 'Les Abymes, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Le Gosier',
		label: 'Le Gosier, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Capesterre-Belle-Eau',
		label: 'Capesterre-Belle-Eau, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Basse-Terre',
		label: 'Basse-Terre, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Point-à-Pitre',
		label: 'Point-à-Pitre, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Sainte-Rose',
		label: 'Sainte-Rose, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Saint-François',
		label: 'Saint-François, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Saint-Claude',
		label: 'Saint-Claude, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Grand-Bourg',
		label: 'Grand-Bourg, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Saint-Barthélemy',
		label: 'Saint-Barthélemy, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Le Moule',
		label: 'Le Moule, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Sainte-Anne',
		label: 'Sainte-Anne, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: "Morne-à-l'Eau",
		label: "Morne-à-l'Eau, Guadeloupe",
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Lamentin',
		label: 'Lamentin, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Trois-Rivières',
		label: 'Trois-Rivières, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Petit-Canal',
		label: 'Petit-Canal, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Pointe-Noire',
		label: 'Pointe-Noire, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Gourbeyre',
		label: 'Gourbeyre, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Vieux-Habitants',
		label: 'Vieux-Habitants, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Bouillante',
		label: 'Bouillante, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Baillif',
		label: 'Baillif, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Port-Louis',
		label: 'Port-Louis, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Marigot',
		label: 'Marigot, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: "Grand'Anse",
		label: "Grand'Anse, Guadeloupe",
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Terre-de-Bas',
		label: 'Terre-de-Bas, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Goyave',
		label: 'Goyave, Guadeloupe',
		type: 'city',
		flagClass: 'fi fi-gp',
		isPopular: false,
	},
	{
		value: 'Guam',
		label: 'Guam',
		type: 'country',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Agana',
		label: 'Agana, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Tamuning',
		label: 'Tamuning, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Yigo',
		label: 'Yigo, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Dededo',
		label: 'Dededo, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Santa Rita',
		label: 'Santa Rita, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Mangilao',
		label: 'Mangilao, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Anderson Air Force Base',
		label: 'Anderson Air Force Base, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Sinajana',
		label: 'Sinajana, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Barrigada',
		label: 'Barrigada, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Toto',
		label: 'Toto, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Agat',
		label: 'Agat, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Chalan Pago',
		label: 'Chalan Pago, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Inarajan',
		label: 'Inarajan, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Apra Harbor',
		label: 'Apra Harbor, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Ordot',
		label: 'Ordot, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Mongmong',
		label: 'Mongmong, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Talofofo',
		label: 'Talofofo, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Latte Heights',
		label: 'Latte Heights, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Agana Station',
		label: 'Agana Station, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Agana Heights',
		label: 'Agana Heights, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Yona',
		label: 'Yona, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Finegayan Station',
		label: 'Finegayan Station, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Merizo',
		label: 'Merizo, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Marbo Annex',
		label: 'Marbo Annex, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Barrigada Heights',
		label: 'Barrigada Heights, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Maina',
		label: 'Maina, Guam',
		type: 'city',
		flagClass: 'fi fi-gu',
		isPopular: false,
	},
	{
		value: 'Guatemala',
		label: 'Guatemala',
		type: 'country',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Guatemala',
		label: 'Guatemala, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Antigua Guatemala',
		label: 'Antigua Guatemala, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Quetzaltenango',
		label: 'Quetzaltenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Acatenango',
		label: 'Acatenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Puerto Barrios',
		label: 'Puerto Barrios, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Jalpatagua',
		label: 'Jalpatagua, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Mixco',
		label: 'Mixco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Panajachel',
		label: 'Panajachel, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José del Golfo',
		label: 'San José del Golfo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Huehuetenango',
		label: 'Huehuetenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Lucía Cotzumalguapa',
		label: 'Santa Lucía Cotzumalguapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cobán',
		label: 'Cobán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Patzún',
		label: 'Patzún, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Tiquisate',
		label: 'Tiquisate, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pedro Jocopilas',
		label: 'San Pedro Jocopilas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Lucas Sacatepéquez',
		label: 'San Lucas Sacatepéquez, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Melchor de Mencos',
		label: 'Melchor de Mencos, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Miguel Dueñas',
		label: 'San Miguel Dueñas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Huamantla',
		label: 'Huamantla, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Rio Hondo',
		label: 'Rio Hondo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Atenco',
		label: 'Atenco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Aguacaliente',
		label: 'Aguacaliente, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Iztapa',
		label: 'Iztapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Villa Canales',
		label: 'Villa Canales, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chimaltenango',
		label: 'Chimaltenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Catarina Pinula',
		label: 'Santa Catarina Pinula, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Jalapa',
		label: 'Jalapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chiquimula',
		label: 'Chiquimula, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José Pinula',
		label: 'San José Pinula, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santiago Atitlán',
		label: 'Santiago Atitlán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Salamá',
		label: 'Salamá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Bartolomé Jocotenango',
		label: 'San Bartolomé Jocotenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Bartolo',
		label: 'San Bartolo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'La Gomera',
		label: 'La Gomera, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Francisco la Unión',
		label: 'San Francisco la Unión, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Nahualá',
		label: 'Nahualá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José Ojetenán',
		label: 'San José Ojetenán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cantel',
		label: 'Cantel, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Sebastián Huehuetenango',
		label: 'San Sebastián Huehuetenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Lucía Utatlán',
		label: 'Santa Lucía Utatlán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Jocotenango',
		label: 'Jocotenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Zacamulpa',
		label: 'Zacamulpa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Cristóbal Verapaz',
		label: 'San Cristóbal Verapaz, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Andrés Itzapa',
		label: 'San Andrés Itzapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Lucía la Reforma',
		label: 'Santa Lucía la Reforma, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chicacao',
		label: 'Chicacao, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Sibilia',
		label: 'Sibilia, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Flores',
		label: 'Flores, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Concepcion Tutuapa',
		label: 'Concepcion Tutuapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Panzós',
		label: 'Panzós, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Rafael la Independencia',
		label: 'San Rafael la Independencia, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Gualán',
		label: 'Gualán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Colomba',
		label: 'Colomba, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Tamahú',
		label: 'Tamahú, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Patzicía',
		label: 'Patzicía, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Asunción Mita',
		label: 'Asunción Mita, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Patzité',
		label: 'Patzité, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Poptún',
		label: 'Poptún, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Granados',
		label: 'Granados, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Maria de Jesús',
		label: 'Santa Maria de Jesús, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Río Blanco',
		label: 'Río Blanco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Alotenango',
		label: 'Alotenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Sebastián Coatán',
		label: 'San Sebastián Coatán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Morales',
		label: 'Morales, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José Chacayá',
		label: 'San José Chacayá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Palencia',
		label: 'Palencia, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Tectitán',
		label: 'Tectitán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cuilapa',
		label: 'Cuilapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Sipacapa',
		label: 'Sipacapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Estor',
		label: 'El Estor, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Diego',
		label: 'San Diego, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Sanarate',
		label: 'Sanarate, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Gaspar Ixchil',
		label: 'San Gaspar Ixchil, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pablo Jocopilas',
		label: 'San Pablo Jocopilas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Malacatán',
		label: 'Malacatán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'La Democracía',
		label: 'La Democracía, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chisec',
		label: 'Chisec, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Lucas Tolimán',
		label: 'San Lucas Tolimán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Tejar',
		label: 'El Tejar, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Donostia',
		label: 'Donostia, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pedro Carchá',
		label: 'San Pedro Carchá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chiquimulilla',
		label: 'Chiquimulilla, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Palmar',
		label: 'El Palmar, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Nuevo San Carlos',
		label: 'Nuevo San Carlos, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Comitancillo',
		label: 'Comitancillo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Catalina la Tinta',
		label: 'Santa Catalina la Tinta, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Barillas',
		label: 'Barillas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'La Esperanza',
		label: 'La Esperanza, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Patulul',
		label: 'Patulul, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Salcajá',
		label: 'Salcajá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Almolonga',
		label: 'Almolonga, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Guastatoya',
		label: 'Guastatoya, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Lívingston',
		label: 'Lívingston, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Nueva Concepción',
		label: 'Nueva Concepción, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Ayutla',
		label: 'Ayutla, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Francisco Zapotitlán',
		label: 'San Francisco Zapotitlán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pablo',
		label: 'San Pablo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chajul',
		label: 'Chajul, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Monjas',
		label: 'Monjas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Catarina Ixtahuacán',
		label: 'Santa Catarina Ixtahuacán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Luis Jilotepeque',
		label: 'San Luis Jilotepeque, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Joyabaj',
		label: 'Joyabaj, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Juan Chamelco',
		label: 'San Juan Chamelco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Rabinal',
		label: 'Rabinal, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Miguel Chicaj',
		label: 'San Miguel Chicaj, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Catarina Mita',
		label: 'Santa Catarina Mita, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Mateo Ixtatán',
		label: 'San Mateo Ixtatán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Siquinalá',
		label: 'Siquinalá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cuyotenango',
		label: 'Cuyotenango, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Andrés Xecul',
		label: 'San Andrés Xecul, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Juan Cotzal',
		label: 'San Juan Cotzal, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pedro la Laguna',
		label: 'San Pedro la Laguna, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Flores Costa Cuca',
		label: 'Flores Costa Cuca, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Emilio Carranza',
		label: 'Emilio Carranza, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Antonio Suchitepéquez',
		label: 'San Antonio Suchitepéquez, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Martín Jilotepeque',
		label: 'San Martín Jilotepeque, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Zunil',
		label: 'Zunil, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Soloma',
		label: 'Soloma, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Agustín Acasaguastlán',
		label: 'San Agustín Acasaguastlán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Lucía Milpas Altas',
		label: 'Santa Lucía Milpas Altas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Zaragoza',
		label: 'Zaragoza, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Pastores',
		label: 'Pastores, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Samayac',
		label: 'Samayac, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Estanzuela',
		label: 'Estanzuela, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Nueva Santa Rosa',
		label: 'Nueva Santa Rosa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Parramos',
		label: 'Parramos, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Sacapulas',
		label: 'Sacapulas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Yepocapa',
		label: 'Yepocapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cubulco',
		label: 'Cubulco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Dolores',
		label: 'Dolores, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Quetzal',
		label: 'El Quetzal, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Tactic',
		label: 'Tactic, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Atescatempa',
		label: 'Atescatempa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chiantla',
		label: 'Chiantla, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santo Domingo Xenacoj',
		label: 'Santo Domingo Xenacoj, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Felipe',
		label: 'San Felipe, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Champerico',
		label: 'Champerico, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Oratorio',
		label: 'Oratorio, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Raymundo',
		label: 'San Raymundo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Sayaxché',
		label: 'Sayaxché, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Pajapita',
		label: 'Pajapita, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cabricán',
		label: 'Cabricán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Antonio Aguas Calientes',
		label: 'San Antonio Aguas Calientes, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Callejones',
		label: 'Callejones, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Masagua',
		label: 'Masagua, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Concepción Chiquirichapa',
		label: 'Concepción Chiquirichapa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Mataquescuintla',
		label: 'Mataquescuintla, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Río Bravo',
		label: 'Río Bravo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Guazacapán',
		label: 'Guazacapán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Zacualpan',
		label: 'Zacualpan, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Jeronimito',
		label: 'San Jeronimito, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Cruz Balanyá',
		label: 'Santa Cruz Balanyá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Vicente Pacaya',
		label: 'San Vicente Pacaya, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Cristóbal Cucho',
		label: 'San Cristóbal Cucho, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Tumbador',
		label: 'El Tumbador, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cunén',
		label: 'Cunén, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Ocós',
		label: 'Ocós, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Chuarrancho',
		label: 'Chuarrancho, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Moyuta',
		label: 'Moyuta, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Ixcán',
		label: 'Ixcán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Casillas',
		label: 'Casillas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Taxisco',
		label: 'Taxisco, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Fray Bartolomé de las Casas',
		label: 'Fray Bartolomé de las Casas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Nuevo Progreso',
		label: 'Nuevo Progreso, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Huaxpaltepec',
		label: 'Huaxpaltepec, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Huitán',
		label: 'Huitán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santo Tomás la Unión',
		label: 'Santo Tomás la Unión, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Teculután',
		label: 'Teculután, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Pablo la Laguna',
		label: 'San Pablo la Laguna, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Antonio la Paz',
		label: 'San Antonio la Paz, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José Poaquil',
		label: 'San José Poaquil, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Bartolomé Milpas Altas',
		label: 'San Bartolomé Milpas Altas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa María Chiquimula',
		label: 'Santa María Chiquimula, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santo Domingo Suchitepéquez',
		label: 'Santo Domingo Suchitepéquez, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Antonio Huista',
		label: 'San Antonio Huista, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Ipala',
		label: 'Ipala, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Magdalena Milpas Altas',
		label: 'Magdalena Milpas Altas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Carlos Alzatate',
		label: 'San Carlos Alzatate, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Aguacatán',
		label: 'Aguacatán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Cruz Verapaz',
		label: 'Santa Cruz Verapaz, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Miguel Sigüilá',
		label: 'San Miguel Sigüilá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Tacaná',
		label: 'Tacaná, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Carlos Sija',
		label: 'San Carlos Sija, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Clara la Laguna',
		label: 'Santa Clara la Laguna, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'El Asintal',
		label: 'El Asintal, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Purulhá',
		label: 'Purulhá, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San José Acatempa',
		label: 'San José Acatempa, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Jocotán',
		label: 'Jocotán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cabañas',
		label: 'Cabañas, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Senahú',
		label: 'Senahú, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Bernardino',
		label: 'San Bernardino, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Rosa de Lima',
		label: 'Santa Rosa de Lima, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Santa Cruz Naranjo',
		label: 'Santa Cruz Naranjo, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Cahabón',
		label: 'Cahabón, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Cristóbal Totonicapán',
		label: 'San Cristóbal Totonicapán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Uspantán',
		label: 'Uspantán, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'San Juan la Laguna',
		label: 'San Juan la Laguna, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'La Reforma',
		label: 'La Reforma, Guatemala',
		type: 'city',
		flagClass: 'fi fi-gt',
		isPopular: false,
	},
	{
		value: 'Guernsey',
		label: 'Guernsey',
		type: 'country',
		flagClass: 'fi fi-gg',
		isPopular: false,
	},
	{
		value: 'Guernsey',
		label: 'Guernsey, Guernsey',
		type: 'city',
		flagClass: 'fi fi-gg',
		isPopular: false,
	},
	{
		value: 'Castel',
		label: 'Castel, Guernsey',
		type: 'city',
		flagClass: 'fi fi-gg',
		isPopular: false,
	},
	{
		value: 'Guinea',
		label: 'Guinea',
		type: 'country',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Conakry',
		label: 'Conakry, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Biyala',
		label: 'Biyala, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Gaoual',
		label: 'Gaoual, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Dinguiraye',
		label: 'Dinguiraye, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Nzérékoré',
		label: 'Nzérékoré, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Kankan',
		label: 'Kankan, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Kindia',
		label: 'Kindia, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Mamou',
		label: 'Mamou, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Siguiri',
		label: 'Siguiri, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Labé',
		label: 'Labé, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Télimélé',
		label: 'Télimélé, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Kissidougou',
		label: 'Kissidougou, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Macenta',
		label: 'Macenta, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Tougué',
		label: 'Tougué, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Pita',
		label: 'Pita, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Tondon',
		label: 'Tondon, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Kouroussa',
		label: 'Kouroussa, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Boké',
		label: 'Boké, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Koundara',
		label: 'Koundara, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Dabola',
		label: 'Dabola, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Dalaba',
		label: 'Dalaba, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Forécariah',
		label: 'Forécariah, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Dubréka',
		label: 'Dubréka, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Lélouma',
		label: 'Lélouma, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Mandiana',
		label: 'Mandiana, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Koubia',
		label: 'Koubia, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Tokonou',
		label: 'Tokonou, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Youkounkoun',
		label: 'Youkounkoun, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Faranah',
		label: 'Faranah, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Fria',
		label: 'Fria, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Sanguéya',
		label: 'Sanguéya, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Kérouane',
		label: 'Kérouane, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Mali',
		label: 'Mali, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Yomou',
		label: 'Yomou, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Guéckédou',
		label: 'Guéckédou, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Boffa',
		label: 'Boffa, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Lola',
		label: 'Lola, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Coyah',
		label: 'Coyah, Guinea',
		type: 'city',
		flagClass: 'fi fi-gn',
		isPopular: false,
	},
	{
		value: 'Guinea-Bissau',
		label: 'Guinea-Bissau',
		type: 'country',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Bissau',
		label: 'Bissau, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Bafatá',
		label: 'Bafatá, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Cacheu',
		label: 'Cacheu, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Canchungo',
		label: 'Canchungo, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Gabú',
		label: 'Gabú, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Bissorã',
		label: 'Bissorã, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Bolama',
		label: 'Bolama, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Bubaque',
		label: 'Bubaque, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Catió',
		label: 'Catió, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Quebo',
		label: 'Quebo, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Buba',
		label: 'Buba, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Mansoa',
		label: 'Mansoa, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Farim',
		label: 'Farim, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Fulacunda',
		label: 'Fulacunda, Guinea-Bissau',
		type: 'city',
		flagClass: 'fi fi-gw',
		isPopular: false,
	},
	{
		value: 'Guyana',
		label: 'Guyana',
		type: 'country',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Georgetown',
		label: 'Georgetown, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'New Amsterdam',
		label: 'New Amsterdam, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Vreed en Hoop',
		label: 'Vreed en Hoop, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'al-Mahdiyah',
		label: 'al-Mahdiyah, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Linden',
		label: 'Linden, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Mahaica',
		label: 'Mahaica, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Suddie',
		label: 'Suddie, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Parika',
		label: 'Parika, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Corriverton',
		label: 'Corriverton, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Rosignol',
		label: 'Rosignol, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Fort Wellington',
		label: 'Fort Wellington, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Skeldon',
		label: 'Skeldon, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Anna Regina',
		label: 'Anna Regina, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Lethem',
		label: 'Lethem, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Mabaruma',
		label: 'Mabaruma, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Issano',
		label: 'Issano, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Springlands',
		label: 'Springlands, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Paradise',
		label: 'Paradise, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Mahaicony',
		label: 'Mahaicony, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Charity',
		label: 'Charity, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Rockstone',
		label: 'Rockstone, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Tumatumari',
		label: 'Tumatumari, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Bartica',
		label: 'Bartica, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Kumaka',
		label: 'Kumaka, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Queenstown',
		label: 'Queenstown, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Orealla',
		label: 'Orealla, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Biloku',
		label: 'Biloku, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Morawhanna',
		label: 'Morawhanna, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Epira',
		label: 'Epira, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Apoteri',
		label: 'Apoteri, Guyana',
		type: 'city',
		flagClass: 'fi fi-gy',
		isPopular: false,
	},
	{
		value: 'Haiti',
		label: 'Haiti',
		type: 'country',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Port-au-Prince',
		label: 'Port-au-Prince, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Pétionville',
		label: 'Pétionville, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Delmas',
		label: 'Delmas, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Cap-Haïtien',
		label: 'Cap-Haïtien, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Jacmel',
		label: 'Jacmel, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Anse-à-Galets',
		label: 'Anse-à-Galets, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Carrefour',
		label: 'Carrefour, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Ouanaminthe',
		label: 'Ouanaminthe, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Les Cayes',
		label: 'Les Cayes, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Port-de-Paix',
		label: 'Port-de-Paix, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Petit Goave',
		label: 'Petit Goave, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Saint-Louis-du-Nord',
		label: 'Saint-Louis-du-Nord, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Léogane',
		label: 'Léogane, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Gonaïves',
		label: 'Gonaïves, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Garoafa',
		label: 'Garoafa, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Desdunes',
		label: 'Desdunes, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Fort-Liberté',
		label: 'Fort-Liberté, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Pignon',
		label: 'Pignon, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Croix-des-Bouquets',
		label: 'Croix-des-Bouquets, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Lascahobas',
		label: 'Lascahobas, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Saint-Marc',
		label: 'Saint-Marc, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Verrettes',
		label: 'Verrettes, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Jérémie',
		label: 'Jérémie, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: "L'Artibonite",
		label: "L'Artibonite, Haiti",
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Hinche',
		label: 'Hinche, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Dessalines',
		label: 'Dessalines, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: "Saint-Michel-de-l'Atalaye",
		label: "Saint-Michel-de-l'Atalaye, Haiti",
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Trou-du-Nord',
		label: 'Trou-du-Nord, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Mirebalais',
		label: 'Mirebalais, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Grande Rivière du Nord',
		label: 'Grande Rivière du Nord, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: "Anse-d'Hainault",
		label: "Anse-d'Hainault, Haiti",
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Gros-Morne',
		label: 'Gros-Morne, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Miragoane',
		label: 'Miragoane, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Dame Marie',
		label: 'Dame Marie, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Saint-Raphaël',
		label: 'Saint-Raphaël, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Aquin',
		label: 'Aquin, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Kenscoff',
		label: 'Kenscoff, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Dérac',
		label: 'Dérac, Haiti',
		type: 'city',
		flagClass: 'fi fi-ht',
		isPopular: false,
	},
	{
		value: 'Heard Island and McDonald Islands',
		label: 'Heard Island and McDonald Islands',
		type: 'country',
		flagClass: 'fi fi-hm',
		isPopular: false,
	},
	{
		value: 'Holy See',
		label: 'Holy See',
		type: 'country',
		flagClass: 'fi fi-va',
		isPopular: false,
	},
	{
		value: 'Honduras',
		label: 'Honduras',
		type: 'country',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Tegucigalpita',
		label: 'Tegucigalpita, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Pedro Sula',
		label: 'San Pedro Sula, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Ceiba',
		label: 'La Ceiba, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Achiotal',
		label: 'Achiotal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Roatán',
		label: 'Roatán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Distrito Central',
		label: 'Distrito Central, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Siguatepeque',
		label: 'Siguatepeque, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Tela',
		label: 'Tela, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Marañón',
		label: 'El Marañón, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Comayagua',
		label: 'Comayagua, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Puerto Cortés',
		label: 'Puerto Cortés, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Rancho',
		label: 'El Rancho, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Francisco de Yojoa',
		label: 'San Francisco de Yojoa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Llano',
		label: 'El Llano, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Utila',
		label: 'Utila, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Guastatoya',
		label: 'Guastatoya, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Danli',
		label: 'Danli, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Juticalpa',
		label: 'Juticalpa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Ocotepeque',
		label: 'Ocotepeque, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agua Blanca Sur',
		label: 'Agua Blanca Sur, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Gracias',
		label: 'Gracias, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Copán',
		label: 'Copán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Azacualpa',
		label: 'Azacualpa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Santa Rosa de Aguán',
		label: 'Santa Rosa de Aguán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Apacilagua',
		label: 'Apacilagua, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Arizona',
		label: 'Arizona, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Omoa',
		label: 'Omoa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Pinalejo',
		label: 'Pinalejo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'José Santos Guardiola',
		label: 'José Santos Guardiola, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Sula',
		label: 'Sula, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Limón',
		label: 'Limón, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Quezailica',
		label: 'Quezailica, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Ojo de Água',
		label: 'Ojo de Água, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Francisco de Cones',
		label: 'San Francisco de Cones, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Jeronimito',
		label: 'San Jeronimito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Juan de Planes',
		label: 'San Juan de Planes, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Amapala',
		label: 'Amapala, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Pedro Zacapa',
		label: 'San Pedro Zacapa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Francisco de Becerra',
		label: 'San Francisco de Becerra, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Sandy Bay',
		label: 'Sandy Bay, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Santiago de Puringla',
		label: 'Santiago de Puringla, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Silca',
		label: 'Silca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Zapotal del Norte',
		label: 'Zapotal del Norte, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Teguajinal',
		label: 'Teguajinal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Belén Gualcho',
		label: 'Belén Gualcho, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Trojas',
		label: 'Trojas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Jericó',
		label: 'Jericó, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Yaruchel',
		label: 'Yaruchel, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Río Blanquito',
		label: 'Río Blanquito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Bajamar',
		label: 'Bajamar, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Trinidad de Copán',
		label: 'Trinidad de Copán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Tránsito',
		label: 'El Tránsito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Corozal',
		label: 'Corozal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Guaymitas',
		label: 'Guaymitas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Río Amarillo',
		label: 'Río Amarillo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Lepaterique',
		label: 'Lepaterique, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Río Arriba',
		label: 'Río Arriba, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Sinuapa',
		label: 'Sinuapa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Río Bonito',
		label: 'Río Bonito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Protección',
		label: 'Protección, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Fernando',
		label: 'San Fernando, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Río Abajo',
		label: 'Río Abajo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Savannah Bight',
		label: 'Savannah Bight, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Cane',
		label: 'Cane, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Texíguat',
		label: 'Texíguat, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Suyatal',
		label: 'El Suyatal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agua Azul Sierra',
		label: 'Agua Azul Sierra, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Triunfo de La Cruz',
		label: 'El Triunfo de La Cruz, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agua Caliente de Linaca',
		label: 'Agua Caliente de Linaca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Campana',
		label: 'La Campana, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agua Dulcita',
		label: 'Agua Dulcita, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Flecha',
		label: 'La Flecha, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Chiquila',
		label: 'Chiquila, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Sarrosa',
		label: 'La Sarrosa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Cololaca',
		label: 'Cololaca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Sabanagrande',
		label: 'Sabanagrande, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Concepcion de La Barranca',
		label: 'Concepcion de La Barranca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Yorito',
		label: 'Yorito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Durazno',
		label: 'El Durazno, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Brisas del Calán',
		label: 'Brisas del Calán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Higuero',
		label: 'El Higuero, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Dulce Nombre de Culmí',
		label: 'Dulce Nombre de Culmí, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Jocomico',
		label: 'El Jocomico, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Las Choapas',
		label: 'Las Choapas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Monterrey',
		label: 'Monterrey, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Rusio',
		label: 'El Rusio, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Nueva Esperanza',
		label: 'Nueva Esperanza, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Guatemalita',
		label: 'Guatemalita, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Quebrada Seca',
		label: 'Quebrada Seca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Brea',
		label: 'La Brea, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Vallecillo',
		label: 'Vallecillo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Criba',
		label: 'La Criba, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Bugaba',
		label: 'Bugaba, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Liure',
		label: 'Liure, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Cañaveral',
		label: 'Cañaveral, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Macholoa',
		label: 'Macholoa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Mochito',
		label: 'El Mochito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Morolica',
		label: 'Morolica, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Piedras Amarillas',
		label: 'Piedras Amarillas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Nuevo Chamelecón',
		label: 'Nuevo Chamelecón, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Antonio de La Cuesta',
		label: 'San Antonio de La Cuesta, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Chalmeca',
		label: 'Chalmeca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Taragual',
		label: 'Taragual, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Tular',
		label: 'El Tular, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Tepanguare',
		label: 'Tepanguare, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Marcovia',
		label: 'Marcovia, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Curva',
		label: 'La Curva, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Antigua Ocotepeque',
		label: 'Antigua Ocotepeque, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agua Azul Rancho',
		label: 'Agua Azul Rancho, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Ocote',
		label: 'El Ocote, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Jigua',
		label: 'La Jigua, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Erandique',
		label: 'Erandique, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Reina',
		label: 'La Reina, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Guanaja',
		label: 'Guanaja, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Las Mercedes',
		label: 'Las Mercedes, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Ilama',
		label: 'Ilama, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Nuevo Celilac',
		label: 'Nuevo Celilac, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Cuesta Dos',
		label: 'La Cuesta Dos, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Antonio del Norte',
		label: 'San Antonio del Norte, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Mezapita',
		label: 'Mezapita, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Toloa Adentro',
		label: 'Toloa Adentro, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Punuare',
		label: 'Punuare, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Concepción del Norte',
		label: 'Concepción del Norte, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Ermitaño',
		label: 'El Ermitaño, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Francisco del Valle',
		label: 'San Francisco del Valle, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Mercedes',
		label: 'Mercedes, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Pedro de Tutule',
		label: 'San Pedro de Tutule, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Santa Ana de Yusguare',
		label: 'Santa Ana de Yusguare, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Colorada',
		label: 'La Colorada, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Arimís',
		label: 'Arimís, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Lagunas',
		label: 'Lagunas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Atenas de San Cristóbal',
		label: 'Atenas de San Cristóbal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Bodega de Los Tangos',
		label: 'Bodega de Los Tangos, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Bálsamo',
		label: 'El Bálsamo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Chivana',
		label: 'Chivana, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Etla',
		label: 'Etla, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Juancito',
		label: 'San Juancito, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Lamaní',
		label: 'Lamaní, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Vivistorio',
		label: 'Vivistorio, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Namasigüe',
		label: 'Namasigüe, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Agualote',
		label: 'Agualote, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Portillo de González',
		label: 'Portillo de González, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Atima',
		label: 'Atima, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Guapinol',
		label: 'El Guapinol, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Concepción de María',
		label: 'Concepción de María, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Jardines',
		label: 'Jardines, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Milagro',
		label: 'El Milagro, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Kino',
		label: 'Kino, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Pedernal',
		label: 'El Pedernal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San José de Pane',
		label: 'San José de Pane, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Suyapa de Leán',
		label: 'Suyapa de Leán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Arenal',
		label: 'El Arenal, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Coyoles',
		label: 'Coyoles, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Jocón',
		label: 'Jocón, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Derrumbo',
		label: 'El Derrumbo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Mandasta',
		label: 'Mandasta, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Sapadril Abajo',
		label: 'Sapadril Abajo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San José de Tarros',
		label: 'San José de Tarros, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Chichicaste',
		label: 'El Chichicaste, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Buen Pastor',
		label: 'El Buen Pastor, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Obraje',
		label: 'El Obraje, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Guayape',
		label: 'Guayape, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Estancia',
		label: 'La Estancia, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San José de los Arroyos',
		label: 'San José de los Arroyos, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Ocote Paulino',
		label: 'Ocote Paulino, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Chirinos',
		label: 'Chirinos, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Orocuina',
		label: 'Orocuina, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Empalizada',
		label: 'La Empalizada, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San Juan de Opoa',
		label: 'San Juan de Opoa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Ayapa',
		label: 'Ayapa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'San José de Oriente',
		label: 'San José de Oriente, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Cuyalí',
		label: 'Cuyalí, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Guayabo',
		label: 'El Guayabo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Lolo',
		label: 'El Lolo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Pescadero',
		label: 'El Pescadero, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'La Rosa',
		label: 'La Rosa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Waksma',
		label: 'Waksma, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Lomitas',
		label: 'Lomitas, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Los Naranjos',
		label: 'Los Naranjos, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Edén',
		label: 'El Edén, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Marale',
		label: 'Marale, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Magdalena Tequisistlán',
		label: 'Magdalena Tequisistlán, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Tepusteca',
		label: 'Tepusteca, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Santa Fe',
		label: 'Santa Fe, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Yaguacire',
		label: 'Yaguacire, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Corinto',
		label: 'Corinto, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Bálsamo Oriental',
		label: 'Bálsamo Oriental, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Hicaque',
		label: 'Hicaque, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Tegucigalpa',
		label: 'Tegucigalpa, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Cedeño',
		label: 'Cedeño, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Llano Largo',
		label: 'Llano Largo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Concepción de Guasistagua',
		label: 'Concepción de Guasistagua, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Nueva Florida',
		label: 'Nueva Florida, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Donostia',
		label: 'Donostia, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Meámbar',
		label: 'Meámbar, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Choloma',
		label: 'Choloma, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Rincón',
		label: 'El Rincón, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'El Rodeo',
		label: 'El Rodeo, Honduras',
		type: 'city',
		flagClass: 'fi fi-hn',
		isPopular: false,
	},
	{
		value: 'Hong Kong',
		label: 'Hong Kong',
		type: 'country',
		flagClass: 'fi fi-hk',
		isPopular: false,
	},
	{
		value: 'Hong Kong',
		label: 'Hong Kong, Hong Kong',
		type: 'city',
		flagClass: 'fi fi-hk',
		isPopular: false,
	},
	{
		value: 'Hungary',
		label: 'Hungary',
		type: 'country',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Debrecen',
		label: 'Debrecen, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szeged',
		label: 'Szeged, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Aba',
		label: 'Aba, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Miskolc',
		label: 'Miskolc, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pécs',
		label: 'Pécs, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Székesfehérvár',
		label: 'Székesfehérvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Györ',
		label: 'Györ, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Eger',
		label: 'Eger, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kecskemét',
		label: 'Kecskemét, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Érd',
		label: 'Érd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szolnok',
		label: 'Szolnok, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kaposvár',
		label: 'Kaposvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Úrkút',
		label: 'Úrkút, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tata',
		label: 'Tata, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nyíregyháza',
		label: 'Nyíregyháza, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Békéscsaba',
		label: 'Békéscsaba, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Cegléd',
		label: 'Cegléd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gödöllö',
		label: 'Gödöllö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Budaörs',
		label: 'Budaörs, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Zalaegerszeg',
		label: 'Zalaegerszeg, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sopron',
		label: 'Sopron, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Salgótarján',
		label: 'Salgótarján, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szombathely',
		label: 'Szombathely, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Dunaújváros',
		label: 'Dunaújváros, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Vecsés',
		label: 'Vecsés, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tapolca',
		label: 'Tapolca, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nagykanizsa',
		label: 'Nagykanizsa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szegvár',
		label: 'Szegvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gyöngyös',
		label: 'Gyöngyös, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gyula',
		label: 'Gyula, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szabadbattyán',
		label: 'Szabadbattyán, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Várpalota',
		label: 'Várpalota, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Ozora',
		label: 'Ozora, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Százhalombatta',
		label: 'Százhalombatta, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Fót',
		label: 'Fót, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pomáz',
		label: 'Pomáz, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kapuvár',
		label: 'Kapuvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Biatorbágy',
		label: 'Biatorbágy, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tatabánya',
		label: 'Tatabánya, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Veszprém',
		label: 'Veszprém, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Ózd',
		label: 'Ózd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Vác',
		label: 'Vác, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mosonmagyaróvár',
		label: 'Mosonmagyaróvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kiskunhalas',
		label: 'Kiskunhalas, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Dunakeszi',
		label: 'Dunakeszi, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szigetszentmiklós',
		label: 'Szigetszentmiklós, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Siófok',
		label: 'Siófok, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hévíz',
		label: 'Hévíz, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hatvan',
		label: 'Hatvan, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Paks',
		label: 'Paks, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szarvas',
		label: 'Szarvas, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tiszaújváros',
		label: 'Tiszaújváros, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Abony',
		label: 'Abony, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nyírbátor',
		label: 'Nyírbátor, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nagykáta',
		label: 'Nagykáta, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bogyiszló',
		label: 'Bogyiszló, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szigetvár',
		label: 'Szigetvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Törökbálint',
		label: 'Törökbálint, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bicske',
		label: 'Bicske, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Üllö',
		label: 'Üllö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Budakalász',
		label: 'Budakalász, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tököl',
		label: 'Tököl, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hajdúszovát',
		label: 'Hajdúszovát, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Halásztelek',
		label: 'Halásztelek, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Algyö',
		label: 'Algyö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Petneháza',
		label: 'Petneháza, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hajdúböszörmény',
		label: 'Hajdúböszörmény, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kiskunfélegyháza',
		label: 'Kiskunfélegyháza, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Ajka',
		label: 'Ajka, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Esztergom',
		label: 'Esztergom, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Jászberény',
		label: 'Jászberény, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Répcelak',
		label: 'Répcelak, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Baj',
		label: 'Baj, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Törökszentmiklós',
		label: 'Törökszentmiklós, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mándok',
		label: 'Mándok, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szilvásvárad',
		label: 'Szilvásvárad, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Keszthely',
		label: 'Keszthely, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Dombóvár',
		label: 'Dombóvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Monor',
		label: 'Monor, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Oroszlány',
		label: 'Oroszlány, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Lakitelek',
		label: 'Lakitelek, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mezötúr',
		label: 'Mezötúr, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mohács',
		label: 'Mohács, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Csongrád',
		label: 'Csongrád, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kesztölc',
		label: 'Kesztölc, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Domaszék',
		label: 'Domaszék, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Monok',
		label: 'Monok, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kalocsa',
		label: 'Kalocsa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Smederevo',
		label: 'Smederevo, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sátoraljaújhely',
		label: 'Sátoraljaújhely, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hajdúnánás',
		label: 'Hajdúnánás, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kisvárda',
		label: 'Kisvárda, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mezökövesd',
		label: 'Mezökövesd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Dunaharaszti',
		label: 'Dunaharaszti, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kozármisleny',
		label: 'Kozármisleny, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sárvár',
		label: 'Sárvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gyomaendröd',
		label: 'Gyomaendröd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Dunavecse',
		label: 'Dunavecse, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Göd',
		label: 'Göd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kiszombor',
		label: 'Kiszombor, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sárospatak',
		label: 'Sárospatak, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bátonyterenye',
		label: 'Bátonyterenye, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gyömrö',
		label: 'Gyömrö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Taktaharkány',
		label: 'Taktaharkány, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Újfehértó',
		label: 'Újfehértó, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Rábapatona',
		label: 'Rábapatona, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sárbogárd',
		label: 'Sárbogárd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Balatonfüred',
		label: 'Balatonfüred, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bucsa',
		label: 'Bucsa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Budakeszi',
		label: 'Budakeszi, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pilisvörösvár',
		label: 'Pilisvörösvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Almásfüzitö',
		label: 'Almásfüzitö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szigethalom',
		label: 'Szigethalom, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Buják',
		label: 'Buják, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Forró',
		label: 'Forró, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tiszaföldvár',
		label: 'Tiszaföldvár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Köszeg',
		label: 'Köszeg, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Vaja',
		label: 'Vaja, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bóly',
		label: 'Bóly, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Maklár',
		label: 'Maklár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Valkó',
		label: 'Valkó, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Csorna',
		label: 'Csorna, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Sásd',
		label: 'Sásd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pilis',
		label: 'Pilis, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Veresegyház',
		label: 'Veresegyház, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pásztó',
		label: 'Pásztó, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Siklós',
		label: 'Siklós, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szerencs',
		label: 'Szerencs, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szeghalom',
		label: 'Szeghalom, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Jászapáti',
		label: 'Jászapáti, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kunfehértó',
		label: 'Kunfehértó, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Lábod',
		label: 'Lábod, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Múcsony',
		label: 'Múcsony, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Maglód',
		label: 'Maglód, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mátraderecske',
		label: 'Mátraderecske, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Orgovány',
		label: 'Orgovány, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Derecske',
		label: 'Derecske, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Fehérgyarmat',
		label: 'Fehérgyarmat, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kunszentmiklós',
		label: 'Kunszentmiklós, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Solymár',
		label: 'Solymár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hidas',
		label: 'Hidas, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kunhegyes',
		label: 'Kunhegyes, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Lenti',
		label: 'Lenti, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tarpa',
		label: 'Tarpa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gárdony',
		label: 'Gárdony, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tárnok',
		label: 'Tárnok, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Jászdózsa',
		label: 'Jászdózsa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Ecser',
		label: 'Ecser, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nyírtelek',
		label: 'Nyírtelek, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Zámoly',
		label: 'Zámoly, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Encs',
		label: 'Encs, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Újszász',
		label: 'Újszász, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Aranyosapáti',
		label: 'Aranyosapáti, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pilisborosjenö',
		label: 'Pilisborosjenö, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Rétság',
		label: 'Rétság, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szabadszállás',
		label: 'Szabadszállás, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Domoszló',
		label: 'Domoszló, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Polgárdi',
		label: 'Polgárdi, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Heréd',
		label: 'Heréd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nyírlugos',
		label: 'Nyírlugos, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Okány',
		label: 'Okány, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Piliscsaba',
		label: 'Piliscsaba, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szentkirályszabadja',
		label: 'Szentkirályszabadja, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szigetújfalu',
		label: 'Szigetújfalu, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tiszapüspöki',
		label: 'Tiszapüspöki, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Diósd',
		label: 'Diósd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Taksony',
		label: 'Taksony, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Aszaló',
		label: 'Aszaló, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Jászkisér',
		label: 'Jászkisér, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Mélykút',
		label: 'Mélykút, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Litér',
		label: 'Litér, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Ballószög',
		label: 'Ballószög, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Csobánka',
		label: 'Csobánka, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Gyöngyöspata',
		label: 'Gyöngyöspata, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Rákócziújfalu',
		label: 'Rákócziújfalu, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kenderes',
		label: 'Kenderes, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Martonvásár',
		label: 'Martonvásár, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tokaj',
		label: 'Tokaj, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Hódmezövásárhely',
		label: 'Hódmezövásárhely, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Balatonlelle',
		label: 'Balatonlelle, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szekszárd',
		label: 'Szekszárd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Pápa',
		label: 'Pápa, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Császártöltés',
		label: 'Császártöltés, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kazincbarcika',
		label: 'Kazincbarcika, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Orosháza',
		label: 'Orosháza, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nagykovácsi',
		label: 'Nagykovácsi, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szentes',
		label: 'Szentes, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Bakonyszentlászló',
		label: 'Bakonyszentlászló, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Nagykörös',
		label: 'Nagykörös, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Györújbarát',
		label: 'Györújbarát, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Szentistván',
		label: 'Szentistván, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Izsófalva',
		label: 'Izsófalva, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Aomen',
		label: 'Aomen, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Üröm',
		label: 'Üröm, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tápióság',
		label: 'Tápióság, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kecskéd',
		label: 'Kecskéd, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Zsámbék',
		label: 'Zsámbék, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Tornyospálca',
		label: 'Tornyospálca, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Kisléta',
		label: 'Kisléta, Hungary',
		type: 'city',
		flagClass: 'fi fi-hu',
		isPopular: false,
	},
	{
		value: 'Iceland',
		label: 'Iceland',
		type: 'country',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Reykjavík',
		label: 'Reykjavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Akranes',
		label: 'Akranes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Kópavogur',
		label: 'Kópavogur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Akureyri',
		label: 'Akureyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Keflavík',
		label: 'Keflavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hafnarfjörður',
		label: 'Hafnarfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Mosfellsbær',
		label: 'Mosfellsbær, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Vogar',
		label: 'Vogar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Garðabær',
		label: 'Garðabær, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Borgarnes',
		label: 'Borgarnes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Fáskrúðsfjörður',
		label: 'Fáskrúðsfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Grundarhverfi',
		label: 'Grundarhverfi, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Selfoss',
		label: 'Selfoss, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Seltjarnarnes',
		label: 'Seltjarnarnes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Ísafjörður',
		label: 'Ísafjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Höfn',
		label: 'Höfn, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Sandgerði',
		label: 'Sandgerði, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Eskifjörður',
		label: 'Eskifjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Reyðarfjörður',
		label: 'Reyðarfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Vopnafjörður',
		label: 'Vopnafjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Buðardalur',
		label: 'Buðardalur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Litli-Árskógssandur',
		label: 'Litli-Árskógssandur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Borgarfjörður',
		label: 'Borgarfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Vestmannæyjar',
		label: 'Vestmannæyjar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Sauðárkrókur',
		label: 'Sauðárkrókur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Grindavík',
		label: 'Grindavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Húsavík',
		label: 'Húsavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Álftanes',
		label: 'Álftanes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hveragerði',
		label: 'Hveragerði, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Egilsstaðir',
		label: 'Egilsstaðir, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Dalvík',
		label: 'Dalvík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Siglufjörður',
		label: 'Siglufjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Þorlákshöfn',
		label: 'Þorlákshöfn, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Garður',
		label: 'Garður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Neskaupstaður',
		label: 'Neskaupstaður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Stykkishólmur',
		label: 'Stykkishólmur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Ólafsvík',
		label: 'Ólafsvík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Ólafsfjörður',
		label: 'Ólafsfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Bolungarvík',
		label: 'Bolungarvík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Grundarfjörður',
		label: 'Grundarfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Blönduós',
		label: 'Blönduós, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Seyðisfjörður',
		label: 'Seyðisfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hvolsvöllur',
		label: 'Hvolsvöllur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Patreksfjörður',
		label: 'Patreksfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hella',
		label: 'Hella, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Skagaströnd',
		label: 'Skagaströnd, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hvammstangi',
		label: 'Hvammstangi, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Eyrarbakki',
		label: 'Eyrarbakki, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Stokkseyri',
		label: 'Stokkseyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hellissandur',
		label: 'Hellissandur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Djúpivogur',
		label: 'Djúpivogur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Þórshöfn',
		label: 'Þórshöfn, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Fellabær',
		label: 'Fellabær, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hólmavík',
		label: 'Hólmavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Tálknafjörður',
		label: 'Tálknafjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Suðureyri',
		label: 'Suðureyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Þingeyri',
		label: 'Þingeyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Vík í Mýrdal',
		label: 'Vík í Mýrdal, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Flúðir',
		label: 'Flúðir, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Raufarhöfn',
		label: 'Raufarhöfn, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Grenivík',
		label: 'Grenivík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Flateyri',
		label: 'Flateyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Stöðvarfjörður',
		label: 'Stöðvarfjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Bíldudalur',
		label: 'Bíldudalur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Reykjahlíð',
		label: 'Reykjahlíð, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Svalbarðseyri',
		label: 'Svalbarðseyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hrísey',
		label: 'Hrísey, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Breiðdalsvík',
		label: 'Breiðdalsvík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hofsós',
		label: 'Hofsós, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Suðavík',
		label: 'Suðavík, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hvanneyri',
		label: 'Hvanneyri, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Kirkjubæjarklaustur',
		label: 'Kirkjubæjarklaustur, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Laugarvatn',
		label: 'Laugarvatn, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hauganes',
		label: 'Hauganes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Rif',
		label: 'Rif, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Kópasker',
		label: 'Kópasker, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Laugarás',
		label: 'Laugarás, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Varmahlíð',
		label: 'Varmahlíð, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Reykholt',
		label: 'Reykholt, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hafnir',
		label: 'Hafnir, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Reykhólar',
		label: 'Reykhólar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Bakkafjörður',
		label: 'Bakkafjörður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hrafnagil',
		label: 'Hrafnagil, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Grímsey',
		label: 'Grímsey, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Drangsnes',
		label: 'Drangsnes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Laugar',
		label: 'Laugar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hólar',
		label: 'Hólar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Sólheimar',
		label: 'Sólheimar, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Hallormsstaður',
		label: 'Hallormsstaður, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'Kristnes',
		label: 'Kristnes, Iceland',
		type: 'city',
		flagClass: 'fi fi-is',
		isPopular: false,
	},
	{
		value: 'India',
		label: 'India',
		type: 'country',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Mumbai',
		label: 'Mumbai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Delhi',
		label: 'Delhi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bangalore',
		label: 'Bangalore, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Chennai',
		label: 'Chennai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Hyderabad',
		label: 'Hyderabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pune',
		label: 'Pune, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kolkata',
		label: 'Kolkata, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Gurgaon',
		label: 'Gurgaon, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Noida',
		label: 'Noida, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Chandigarh',
		label: 'Chandigarh, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Abhayapuri',
		label: 'Abhayapuri, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jaipur',
		label: 'Jaipur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ahmedabad',
		label: 'Ahmedabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Indore',
		label: 'Indore, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kochi',
		label: 'Kochi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Navi Mumbai',
		label: 'Navi Mumbai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nagpur',
		label: 'Nagpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Vadodara',
		label: 'Vadodara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Surat',
		label: 'Surat, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Madurai',
		label: 'Madurai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bhubaneswar',
		label: 'Bhubaneswar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Guwahati',
		label: 'Guwahati, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nashik',
		label: 'Nashik, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ni Dilli',
		label: 'Ni Dilli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Visakhapatnam',
		label: 'Visakhapatnam, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Faridabad',
		label: 'Faridabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ludhiana',
		label: 'Ludhiana, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bhopal',
		label: 'Bhopal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Allahabad',
		label: 'Allahabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pondicherry',
		label: 'Pondicherry, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Thana',
		label: 'Thana, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Thiruvananthapuram',
		label: 'Thiruvananthapuram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jalandhar',
		label: 'Jalandhar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pune Cantonment',
		label: 'Pune Cantonment, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ghaziabad',
		label: 'Ghaziabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dehra Dun',
		label: 'Dehra Dun, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kanpur',
		label: 'Kanpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jamshedpur',
		label: 'Jamshedpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tambaram',
		label: 'Tambaram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Vijayawada',
		label: 'Vijayawada, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tiruchchirappalli',
		label: 'Tiruchchirappalli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Erode',
		label: 'Erode, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Agra',
		label: 'Agra, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kalyan',
		label: 'Kalyan, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Thrissur',
		label: 'Thrissur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Chetpet',
		label: 'Chetpet, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Yelahanka',
		label: 'Yelahanka, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Vapi',
		label: 'Vapi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Guntur',
		label: 'Guntur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Patna',
		label: 'Patna, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Mira Bhayandar',
		label: 'Mira Bhayandar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kozhikkod',
		label: 'Kozhikkod, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tiruppur',
		label: 'Tiruppur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Rajkot',
		label: 'Rajkot, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Peddapuram',
		label: 'Peddapuram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Raipur',
		label: 'Raipur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Panvel',
		label: 'Panvel, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Varanasi',
		label: 'Varanasi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jabalpur',
		label: 'Jabalpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Lakhnau',
		label: 'Lakhnau, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Hosur',
		label: 'Hosur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Amritsar',
		label: 'Amritsar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tirunelveli',
		label: 'Tirunelveli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Patiala',
		label: 'Patiala, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Aurangabad',
		label: 'Aurangabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Hubli',
		label: 'Hubli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ranchi',
		label: 'Ranchi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kolhapur',
		label: 'Kolhapur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jodhpur',
		label: 'Jodhpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Navi Mumbai Panvel',
		label: 'Navi Mumbai Panvel, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ulhasnagar',
		label: 'Ulhasnagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ambattur',
		label: 'Ambattur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Shoranur',
		label: 'Shoranur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kottayam',
		label: 'Kottayam, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bharuch',
		label: 'Bharuch, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Mangaluru',
		label: 'Mangaluru, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Raikot',
		label: 'Raikot, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ambala',
		label: 'Ambala, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Virar',
		label: 'Virar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Goa Velha',
		label: 'Goa Velha, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Mohali',
		label: 'Mohali, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Panaji',
		label: 'Panaji, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Aligarh',
		label: 'Aligarh, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Valsad',
		label: 'Valsad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Udaipur',
		label: 'Udaipur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pimpri',
		label: 'Pimpri, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Panchkula',
		label: 'Panchkula, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Panipat',
		label: 'Panipat, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Thanjavur',
		label: 'Thanjavur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nagercoil',
		label: 'Nagercoil, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Koyampattur',
		label: 'Koyampattur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Rohtak',
		label: 'Rohtak, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Chengalpattu',
		label: 'Chengalpattu, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Shimla',
		label: 'Shimla, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bhilai',
		label: 'Bhilai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Sivakasi',
		label: 'Sivakasi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kollam',
		label: 'Kollam, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Sikandarabad',
		label: 'Sikandarabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Neyveli',
		label: 'Neyveli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Banga',
		label: 'Banga, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jamnagar',
		label: 'Jamnagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ajmer',
		label: 'Ajmer, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Avadi',
		label: 'Avadi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Rewari',
		label: 'Rewari, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Alappuzha',
		label: 'Alappuzha, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pallavaram',
		label: 'Pallavaram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Valasaravakkam',
		label: 'Valasaravakkam, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tirupati',
		label: 'Tirupati, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kannur',
		label: 'Kannur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Gwalior',
		label: 'Gwalior, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tiruchengode',
		label: 'Tiruchengode, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Anand',
		label: 'Anand, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Karur',
		label: 'Karur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Haora',
		label: 'Haora, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Shillong',
		label: 'Shillong, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Palakkad',
		label: 'Palakkad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Warangal',
		label: 'Warangal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ahmadnagar',
		label: 'Ahmadnagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kakinada',
		label: 'Kakinada, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Badlapur',
		label: 'Badlapur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Haridwar',
		label: 'Haridwar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Durgapur',
		label: 'Durgapur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jalgaon',
		label: 'Jalgaon, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Aizawl',
		label: 'Aizawl, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Karnal',
		label: 'Karnal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jammu',
		label: 'Jammu, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bommanahalli',
		label: 'Bommanahalli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kanchipuram',
		label: 'Kanchipuram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Goregaon',
		label: 'Goregaon, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Adilabad',
		label: 'Adilabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tumkur',
		label: 'Tumkur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dwarka',
		label: 'Dwarka, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Jajpur Road',
		label: 'Jajpur Road, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Lonavale',
		label: 'Lonavale, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Sangli-Miraj',
		label: 'Sangli-Miraj, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Abohar',
		label: 'Abohar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dehri',
		label: 'Dehri, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Modinagar',
		label: 'Modinagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Sonipat',
		label: 'Sonipat, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Belgaum',
		label: 'Belgaum, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ichalkaranji',
		label: 'Ichalkaranji, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ambarnath',
		label: 'Ambarnath, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Srinagar',
		label: 'Srinagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Navsari',
		label: 'Navsari, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Gorakhpur',
		label: 'Gorakhpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bhiwandi',
		label: 'Bhiwandi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tiruvethipuram',
		label: 'Tiruvethipuram, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bikaner',
		label: 'Bikaner, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Namakkal',
		label: 'Namakkal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nellur',
		label: 'Nellur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nizamabad',
		label: 'Nizamabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Satara',
		label: 'Satara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dhanbad',
		label: 'Dhanbad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Gandhinagar',
		label: 'Gandhinagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Amravati',
		label: 'Amravati, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bhavnagar',
		label: 'Bhavnagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dilli Cantonment',
		label: 'Dilli Cantonment, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Rajamahendri',
		label: 'Rajamahendri, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bilaspur',
		label: 'Bilaspur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Boisar',
		label: 'Boisar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bathinda',
		label: 'Bathinda, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Agartala',
		label: 'Agartala, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nalasopara',
		label: 'Nalasopara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Ambala Cantonment',
		label: 'Ambala Cantonment, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bulandshahr',
		label: 'Bulandshahr, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kota',
		label: 'Kota, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Selam',
		label: 'Selam, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Moradabad',
		label: 'Moradabad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Habra',
		label: 'Habra, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Silvassa',
		label: 'Silvassa, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Palghar',
		label: 'Palghar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Chennamalai',
		label: 'Chennamalai, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nangal',
		label: 'Nangal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Thuthukkudi',
		label: 'Thuthukkudi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Phagwara',
		label: 'Phagwara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Nadiad',
		label: 'Nadiad, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Yamunanagar',
		label: 'Yamunanagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pollachi',
		label: 'Pollachi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Machalpur',
		label: 'Machalpur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Madgaon',
		label: 'Madgaon, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Asansol',
		label: 'Asansol, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bellary',
		label: 'Bellary, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Udupi',
		label: 'Udupi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Darbhanga',
		label: 'Darbhanga, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Tiruvottiyur',
		label: 'Tiruvottiyur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Indi',
		label: 'Indi, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Sagwara',
		label: 'Sagwara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Himatnagar',
		label: 'Himatnagar, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Dharamshala',
		label: 'Dharamshala, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Karjat',
		label: 'Karjat, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Gandhidham',
		label: 'Gandhidham, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Kotdwara',
		label: 'Kotdwara, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Bardoli',
		label: 'Bardoli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Mathura',
		label: 'Mathura, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Pammal',
		label: 'Pammal, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Hapur',
		label: 'Hapur, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Haldia',
		label: 'Haldia, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Khopoli',
		label: 'Khopoli, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Daman',
		label: 'Daman, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Talegaon Dabhade',
		label: 'Talegaon Dabhade, India',
		type: 'city',
		flagClass: 'fi fi-in',
		isPopular: false,
	},
	{
		value: 'Indonesia',
		label: 'Indonesia',
		type: 'country',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jakarta',
		label: 'Jakarta, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bandung',
		label: 'Bandung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Surabaya',
		label: 'Surabaya, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Yogyakarta',
		label: 'Yogyakarta, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Batam',
		label: 'Batam, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Medan',
		label: 'Medan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Semarang',
		label: 'Semarang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bogor',
		label: 'Bogor, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Denpasar',
		label: 'Denpasar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Aberpura',
		label: 'Aberpura, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Malang',
		label: 'Malang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Balikpapan',
		label: 'Balikpapan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Palembang',
		label: 'Palembang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bekasi',
		label: 'Bekasi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tangerang',
		label: 'Tangerang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Depok',
		label: 'Depok, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Banda Aceh',
		label: 'Banda Aceh, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Makasar',
		label: 'Makasar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Padang',
		label: 'Padang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pontianak',
		label: 'Pontianak, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pondokgede',
		label: 'Pondokgede, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bandar Lampung',
		label: 'Bandar Lampung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sidoarjo',
		label: 'Sidoarjo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Samarinda',
		label: 'Samarinda, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Manado',
		label: 'Manado, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Karawang',
		label: 'Karawang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Surakarta',
		label: 'Surakarta, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Banjarmasin',
		label: 'Banjarmasin, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pekan Baru',
		label: 'Pekan Baru, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kuta',
		label: 'Kuta, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jambi',
		label: 'Jambi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Salatiga',
		label: 'Salatiga, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tulungagung',
		label: 'Tulungagung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Temanggung',
		label: 'Temanggung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Purwokerto',
		label: 'Purwokerto, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cilegon',
		label: 'Cilegon, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Magelang',
		label: 'Magelang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Gresik',
		label: 'Gresik, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ubud',
		label: 'Ubud, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cimahi',
		label: 'Cimahi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jember',
		label: 'Jember, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Madiun',
		label: 'Madiun, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Mataram',
		label: 'Mataram, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tanjung Pinang',
		label: 'Tanjung Pinang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tanjung Balai',
		label: 'Tanjung Balai, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Singkawang',
		label: 'Singkawang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Purworejo',
		label: 'Purworejo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Lamongan',
		label: 'Lamongan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ciputat',
		label: 'Ciputat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cirebon',
		label: 'Cirebon, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kediri',
		label: 'Kediri, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pekalongan',
		label: 'Pekalongan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pematang Siantar',
		label: 'Pematang Siantar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tasikmalaya',
		label: 'Tasikmalaya, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Mojokerto',
		label: 'Mojokerto, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kuningan',
		label: 'Kuningan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tarakan',
		label: 'Tarakan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bontang',
		label: 'Bontang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Palangka Raya',
		label: 'Palangka Raya, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Majalengka',
		label: 'Majalengka, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Klaten',
		label: 'Klaten, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Singaraja',
		label: 'Singaraja, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cilacap',
		label: 'Cilacap, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Serang',
		label: 'Serang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sukabumi',
		label: 'Sukabumi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jaten',
		label: 'Jaten, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Brebes',
		label: 'Brebes, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kebumen',
		label: 'Kebumen, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Subang',
		label: 'Subang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cileunyi',
		label: 'Cileunyi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ponorogo',
		label: 'Ponorogo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cirebon Utara',
		label: 'Cirebon Utara, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cikarang',
		label: 'Cikarang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Indramayu',
		label: 'Indramayu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Lubuk Pakam',
		label: 'Lubuk Pakam, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Palu',
		label: 'Palu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jaya Pura',
		label: 'Jaya Pura, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Citeureup',
		label: 'Citeureup, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Garut',
		label: 'Garut, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Banjaran',
		label: 'Banjaran, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kraksaan',
		label: 'Kraksaan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jepara',
		label: 'Jepara, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Prabumulih',
		label: 'Prabumulih, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cileungsi',
		label: 'Cileungsi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Purwodadi',
		label: 'Purwodadi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Karanganyar',
		label: 'Karanganyar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Muntilan',
		label: 'Muntilan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Boyolali',
		label: 'Boyolali, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ambon',
		label: 'Ambon, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bengkulu',
		label: 'Bengkulu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cimanggis',
		label: 'Cimanggis, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kendari',
		label: 'Kendari, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Baki',
		label: 'Baki, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pasuruan',
		label: 'Pasuruan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kupang',
		label: 'Kupang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Probolinggo',
		label: 'Probolinggo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sumber',
		label: 'Sumber, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Curup',
		label: 'Curup, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cianjur',
		label: 'Cianjur, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Gorontalo',
		label: 'Gorontalo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Blitar',
		label: 'Blitar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Lhokseumawe',
		label: 'Lhokseumawe, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tabanan',
		label: 'Tabanan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Gombong',
		label: 'Gombong, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Purwakarta',
		label: 'Purwakarta, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Magetan',
		label: 'Magetan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jombang',
		label: 'Jombang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Rantauprapat',
		label: 'Rantauprapat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Dumai',
		label: 'Dumai, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sibolga',
		label: 'Sibolga, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Margasari',
		label: 'Margasari, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jati',
		label: 'Jati, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Demak',
		label: 'Demak, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Serpong',
		label: 'Serpong, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ciledug',
		label: 'Ciledug, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tomohon',
		label: 'Tomohon, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ciamis',
		label: 'Ciamis, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Nganjuk',
		label: 'Nganjuk, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cibitung',
		label: 'Cibitung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Gunung Stoli',
		label: 'Gunung Stoli, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bumiayu',
		label: 'Bumiayu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sumedang',
		label: 'Sumedang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Blora',
		label: 'Blora, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sampit',
		label: 'Sampit, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kaliwungu',
		label: 'Kaliwungu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sragen',
		label: 'Sragen, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sumbawa',
		label: 'Sumbawa, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Singaparna',
		label: 'Singaparna, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Hamparan Perak',
		label: 'Hamparan Perak, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kencong',
		label: 'Kencong, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pringsewu',
		label: 'Pringsewu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Palabuhanratu',
		label: 'Palabuhanratu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sleman',
		label: 'Sleman, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sukoharjo',
		label: 'Sukoharjo, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Padang Panjang',
		label: 'Padang Panjang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Luwuk',
		label: 'Luwuk, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tegal',
		label: 'Tegal, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pandaan',
		label: 'Pandaan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ketapang',
		label: 'Ketapang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bitung',
		label: 'Bitung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Binjai',
		label: 'Binjai, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Balaipungut',
		label: 'Balaipungut, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tebingtinggi',
		label: 'Tebingtinggi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Buaran',
		label: 'Buaran, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Mobagu',
		label: 'Mobagu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Jatiroto',
		label: 'Jatiroto, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Meulaboh',
		label: 'Meulaboh, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pangkal Pinang',
		label: 'Pangkal Pinang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Poso',
		label: 'Poso, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cibinong',
		label: 'Cibinong, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kudus',
		label: 'Kudus, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Majalaya',
		label: 'Majalaya, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pondok Aren',
		label: 'Pondok Aren, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Padang Sidempuan',
		label: 'Padang Sidempuan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Wlingi',
		label: 'Wlingi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Banyuwangi',
		label: 'Banyuwangi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sidareja',
		label: 'Sidareja, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Trenggalek',
		label: 'Trenggalek, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pare Pare',
		label: 'Pare Pare, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ruteng',
		label: 'Ruteng, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Perbaungan',
		label: 'Perbaungan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Adiwerna',
		label: 'Adiwerna, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Karangampel',
		label: 'Karangampel, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kisaran',
		label: 'Kisaran, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Balapulang',
		label: 'Balapulang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Metro',
		label: 'Metro, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pangkalanbuun',
		label: 'Pangkalanbuun, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cibadak',
		label: 'Cibadak, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Labuhan Deli',
		label: 'Labuhan Deli, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bukit Tinggi',
		label: 'Bukit Tinggi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Babat',
		label: 'Babat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cikampek',
		label: 'Cikampek, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Paciran',
		label: 'Paciran, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pemangkat',
		label: 'Pemangkat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Cirebon Barat',
		label: 'Cirebon Barat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Manyar',
		label: 'Manyar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Lumajang',
		label: 'Lumajang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Padalarang',
		label: 'Padalarang, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Batu',
		label: 'Batu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Ngunut',
		label: 'Ngunut, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bojonegoro',
		label: 'Bojonegoro, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Grogol',
		label: 'Grogol, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Sungai Liat',
		label: 'Sungai Liat, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Pati',
		label: 'Pati, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Rangkasbitung',
		label: 'Rangkasbitung, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tanjung Balai-Meral',
		label: 'Tanjung Balai-Meral, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Delanggu',
		label: 'Delanggu, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Kelari',
		label: 'Kelari, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bondowoso',
		label: 'Bondowoso, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Bangil',
		label: 'Bangil, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Mayong',
		label: 'Mayong, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Lubuk Linggau',
		label: 'Lubuk Linggau, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Parakan',
		label: 'Parakan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Amuntai',
		label: 'Amuntai, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Singosari',
		label: 'Singosari, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Banjar',
		label: 'Banjar, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Gondanglegi',
		label: 'Gondanglegi, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Plered',
		label: 'Plered, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Payakumbuh',
		label: 'Payakumbuh, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Tanjung Pandan',
		label: 'Tanjung Pandan, Indonesia',
		type: 'city',
		flagClass: 'fi fi-id',
		isPopular: false,
	},
	{
		value: 'Iran, Islamic Republic of',
		label: 'Iran, Islamic Republic of',
		type: 'country',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tehran',
		label: 'Tehran, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Esfahan',
		label: 'Esfahan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Karaj',
		label: 'Karaj, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Abadan',
		label: 'Abadan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tabriz',
		label: 'Tabriz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mashhad',
		label: 'Mashhad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shiraz',
		label: 'Shiraz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ahvaz',
		label: 'Ahvaz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Rasht',
		label: 'Rasht, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Qazvin',
		label: 'Qazvin, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Qom',
		label: 'Qom, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Orumiyeh',
		label: 'Orumiyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Yazd',
		label: 'Yazd, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Babol',
		label: 'Babol, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sanandaj',
		label: 'Sanandaj, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Gorgan',
		label: 'Gorgan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kermanshah',
		label: 'Kermanshah, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hamadan',
		label: 'Hamadan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahinshahr',
		label: 'Shahinshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Arak',
		label: 'Arak, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mahabad',
		label: 'Mahabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kerman',
		label: 'Kerman, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Zanjan',
		label: 'Zanjan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Gonbad-e Qabus',
		label: 'Gonbad-e Qabus, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sari',
		label: 'Sari, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Behbahan',
		label: 'Behbahan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tonekabon',
		label: 'Tonekabon, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ardabil',
		label: 'Ardabil, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sabzevar',
		label: 'Sabzevar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Zahedan',
		label: 'Zahedan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Birjand',
		label: 'Birjand, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bandar-e ´Abbas',
		label: 'Bandar-e ´Abbas, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bushehr',
		label: 'Bushehr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Gonabad',
		label: 'Gonabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bojnurd',
		label: 'Bojnurd, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bandar-e Anzali',
		label: 'Bandar-e Anzali, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Lahijan',
		label: 'Lahijan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Esfarayen',
		label: 'Esfarayen, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Torbat-e Heydariyeh',
		label: 'Torbat-e Heydariyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Quchan',
		label: 'Quchan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kangavar',
		label: 'Kangavar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ardakan',
		label: 'Ardakan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Falavarjan',
		label: 'Falavarjan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Azar Shahr',
		label: 'Azar Shahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mahallat',
		label: 'Mahallat, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sar-e-Pol-e-Zohab',
		label: 'Sar-e-Pol-e-Zohab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ramsar',
		label: 'Ramsar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Alashtar',
		label: 'Alashtar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Amol',
		label: 'Amol, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Saveh',
		label: 'Saveh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Zarinshahr',
		label: 'Zarinshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Minab',
		label: 'Minab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kamyaran',
		label: 'Kamyaran, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahriyar',
		label: 'Shahriyar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khorramdarreh',
		label: 'Khorramdarreh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hashtgerd',
		label: 'Hashtgerd, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Makó',
		label: 'Makó, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Neka',
		label: 'Neka, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahr-e Babak',
		label: 'Shahr-e Babak, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Rudsar',
		label: 'Rudsar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ramshir',
		label: 'Ramshir, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mehriz',
		label: 'Mehriz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bafq',
		label: 'Bafq, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Semirom',
		label: 'Semirom, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Abdanan',
		label: 'Abdanan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Gheshm',
		label: 'Gheshm, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hashtrud',
		label: 'Hashtrud, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Dezful',
		label: 'Dezful, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Borujerd',
		label: 'Borujerd, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kashan',
		label: 'Kashan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Qa´emshahr',
		label: 'Qa´emshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Îlam',
		label: 'Îlam, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Andimeshk',
		label: 'Andimeshk, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bukan',
		label: 'Bukan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Saqqez',
		label: 'Saqqez, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Semnan',
		label: 'Semnan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shushtar',
		label: 'Shushtar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahreza',
		label: 'Shahreza, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Do Rud',
		label: 'Do Rud, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Borazjan',
		label: 'Borazjan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mianeh',
		label: 'Mianeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Yasuj',
		label: 'Yasuj, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bonab',
		label: 'Bonab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Damghan',
		label: 'Damghan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Firuzabad',
		label: 'Firuzabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bandar-e Gonaveh',
		label: 'Bandar-e Gonaveh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Chahbahar',
		label: 'Chahbahar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Chalus',
		label: 'Chalus, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Deh Dasht',
		label: 'Deh Dasht, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Eqlid',
		label: 'Eqlid, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Nushahr',
		label: 'Nushahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Dorchehpiyaz',
		label: 'Dorchehpiyaz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khalkhal',
		label: 'Khalkhal, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Abyek',
		label: 'Abyek, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sardasht',
		label: 'Sardasht, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Estehban',
		label: 'Estehban, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mahdasht',
		label: 'Mahdasht, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Garmsar',
		label: 'Garmsar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahindezh',
		label: 'Shahindezh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Faman',
		label: 'Faman, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Darreh Gaz',
		label: 'Darreh Gaz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Baft',
		label: 'Baft, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Fereydunkenar',
		label: 'Fereydunkenar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bardsir',
		label: 'Bardsir, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kordkuy',
		label: 'Kordkuy, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khormuj',
		label: 'Khormuj, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ravar',
		label: 'Ravar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ivan',
		label: 'Ivan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bandar-e Lengeh',
		label: 'Bandar-e Lengeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tabas',
		label: 'Tabas, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Na´in',
		label: 'Na´in, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Malekan',
		label: 'Malekan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kehkiluyeh',
		label: 'Kehkiluyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Agha Jari',
		label: 'Agha Jari, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ardistan',
		label: 'Ardistan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Dir',
		label: 'Dir, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tafresh',
		label: 'Tafresh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Nur',
		label: 'Nur, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mehran',
		label: 'Mehran, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tangestan',
		label: 'Tangestan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ashtian',
		label: 'Ashtian, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Savadkuh',
		label: 'Savadkuh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Eslamshahr',
		label: 'Eslamshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khorramabad',
		label: 'Khorramabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khomeynishahr',
		label: 'Khomeynishahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Neyshabur',
		label: 'Neyshabur, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Malayer',
		label: 'Malayer, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Maragheh',
		label: 'Maragheh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Varamin',
		label: 'Varamin, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahrud',
		label: 'Shahrud, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Marv Dasht',
		label: 'Marv Dasht, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Rafsanjan',
		label: 'Rafsanjan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ezeh',
		label: 'Ezeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Miandoab',
		label: 'Miandoab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Shahr-e Kord',
		label: 'Shahr-e Kord, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Iranshahr',
		label: 'Iranshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Agra',
		label: 'Agra, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Eslamabad',
		label: 'Eslamabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Fasa',
		label: 'Fasa, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Do Gonbadan',
		label: 'Do Gonbadan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ahar',
		label: 'Ahar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Behshahr',
		label: 'Behshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Aligudarz',
		label: 'Aligudarz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Salmas',
		label: 'Salmas, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Omidiyeh',
		label: 'Omidiyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Torbat-e Jam',
		label: 'Torbat-e Jam, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Golara',
		label: 'Golara, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Abhar',
		label: 'Abhar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Takestan',
		label: 'Takestan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Lar',
		label: 'Lar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Abadeh',
		label: 'Abadeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bijar',
		label: 'Bijar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Takab',
		label: 'Takab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sanghar',
		label: 'Sanghar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Zarand',
		label: 'Zarand, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Rehnan',
		label: 'Rehnan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Golpayegan',
		label: 'Golpayegan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Aliabad',
		label: 'Aliabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Borujan',
		label: 'Borujan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bandar-e Torkaman',
		label: 'Bandar-e Torkaman, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Robat Karim',
		label: 'Robat Karim, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Fuladshahr',
		label: 'Fuladshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Meybod',
		label: 'Meybod, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Neyriz',
		label: 'Neyriz, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Babol Sar',
		label: 'Babol Sar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tayyebat',
		label: 'Tayyebat, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Piranshahr',
		label: 'Piranshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Tuysarkan',
		label: 'Tuysarkan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Azna',
		label: 'Azna, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Javanrud',
		label: 'Javanrud, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Eqbaliyeh',
		label: 'Eqbaliyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Azad Shahr',
		label: 'Azad Shahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sarab',
		label: 'Sarab, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sahneh',
		label: 'Sahneh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Pishva',
		label: 'Pishva, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hashtpar',
		label: 'Hashtpar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Astaneh-ye Ashrafiyeh',
		label: 'Astaneh-ye Ashrafiyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Mohammadiyeh',
		label: 'Mohammadiyeh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Chenaran',
		label: 'Chenaran, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Astara',
		label: 'Astara, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Garmi',
		label: 'Garmi, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sawma´eh Sara',
		label: 'Sawma´eh Sara, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Qahdarijan',
		label: 'Qahdarijan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Dawlatabad',
		label: 'Dawlatabad, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hendijan',
		label: 'Hendijan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Sarakhs',
		label: 'Sarakhs, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Dehloran',
		label: 'Dehloran, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Fariman',
		label: 'Fariman, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Farrokhshahr',
		label: 'Farrokhshahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Damavand',
		label: 'Damavand, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Bahar',
		label: 'Bahar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Hadishahr',
		label: 'Hadishahr, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Delijan',
		label: 'Delijan, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Juybar',
		label: 'Juybar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Qa´afur',
		label: 'Qa´afur, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kalaleh',
		label: 'Kalaleh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Kahnuj',
		label: 'Kahnuj, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Aq Qal´eh',
		label: 'Aq Qal´eh, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Khonsar',
		label: 'Khonsar, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Ajabshir',
		label: 'Ajabshir, Iran, Islamic Republic of',
		type: 'city',
		flagClass: 'fi fi-ir',
		isPopular: false,
	},
	{
		value: 'Iraq',
		label: 'Iraq',
		type: 'country',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Baghdad',
		label: 'Baghdad, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Basrah',
		label: 'al-Basrah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Irbil',
		label: 'Irbil, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Abu al-Khasib',
		label: 'Abu al-Khasib, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'as-Sulaymaniyah',
		label: 'as-Sulaymaniyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Mawsil',
		label: 'al-Mawsil, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Dahuk',
		label: 'Dahuk, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Kirkuk',
		label: 'Kirkuk, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Hillah',
		label: 'al-Hillah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Tikrit',
		label: 'Tikrit, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Ba´qubah',
		label: 'Ba´qubah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Shatt-al-´Arab',
		label: 'Shatt-al-´Arab, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'an-Najaf',
		label: 'an-Najaf, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'an-Nasiriyah',
		label: 'an-Nasiriyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Balad',
		label: 'Balad, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ad-Diwaniyah',
		label: 'ad-Diwaniyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Fallujah',
		label: 'al-Fallujah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'as-Samawah',
		label: 'as-Samawah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: '´Afak',
		label: '´Afak, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Samarra',
		label: 'Samarra, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Chamchamal',
		label: 'Chamchamal, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Majarr-al-Kabir',
		label: 'al-Majarr-al-Kabir, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Kut',
		label: 'al-Kut, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Hit',
		label: 'Hit, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Karbala',
		label: 'Karbala, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ar-Ramadi',
		label: 'ar-Ramadi, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-´Abbasiyah',
		label: 'al-´Abbasiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Kufah',
		label: 'al-Kufah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Hindiyah',
		label: 'al-Hindiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Habbaniyah',
		label: 'al-Habbaniyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Tuz',
		label: 'Tuz, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: '´Aqrah',
		label: '´Aqrah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Hamzah',
		label: 'al-Hamzah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Kusanjaq',
		label: 'Kusanjaq, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Ghammas',
		label: 'al-Ghammas, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Sinjar',
		label: 'Sinjar, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ad-Dujayl',
		label: 'ad-Dujayl, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ar-Rifa´i',
		label: 'ar-Rifa´i, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ar-Rutbah',
		label: 'ar-Rutbah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'az-Zubayr',
		label: 'az-Zubayr, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Tall ´Afar',
		label: 'Tall ´Afar, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ash-Shatrah',
		label: 'ash-Shatrah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Harithah',
		label: 'Harithah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Qasim',
		label: 'al-Qasim, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Suq-ash-Shuyukh',
		label: 'Suq-ash-Shuyukh, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Hayy',
		label: 'al-Hayy, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ash-Shaykhan',
		label: 'ash-Shaykhan, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Hanaqin',
		label: 'Hanaqin, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Chaqalawa',
		label: 'Chaqalawa, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Bayji',
		label: 'Bayji, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Musayyib',
		label: 'al-Musayyib, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Zakhu',
		label: 'Zakhu, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: '´Anah',
		label: '´Anah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Hadithah',
		label: 'al-Hadithah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ash-Shamiyah',
		label: 'ash-Shamiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Faw',
		label: 'al-Faw, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'as-Suwayrah',
		label: 'as-Suwayrah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Jalula´´',
		label: 'Jalula´´, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Miqdadiyah',
		label: 'al-Miqdadiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Kifri',
		label: 'Kifri, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Khalis',
		label: 'al-Khalis, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Halabjah',
		label: 'Halabjah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Mandali',
		label: 'Mandali, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ar-Rumaythah',
		label: 'ar-Rumaythah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Madhatiyah',
		label: 'al-Madhatiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'an-Nu´maniyah',
		label: 'an-Nu´maniyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Panjwin',
		label: 'Panjwin, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Lashkar Gah',
		label: 'Lashkar Gah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Fuhud',
		label: 'al-Fuhud, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Qarah Qush',
		label: 'Qarah Qush, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Jurf-as-Sakhr',
		label: 'Jurf-as-Sakhr, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Rawah',
		label: 'Rawah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Dhalu´iyah',
		label: 'Dhalu´iyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'al-Mishkhab',
		label: 'al-Mishkhab, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'ash-Shinafiyah',
		label: 'ash-Shinafiyah, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Qal´at Dizeh',
		label: 'Qal´at Dizeh, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: '´Ali al Gharbi',
		label: '´Ali al Gharbi, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Tall Kayf',
		label: 'Tall Kayf, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Rawanduz',
		label: 'Rawanduz, Iraq',
		type: 'city',
		flagClass: 'fi fi-iq',
		isPopular: false,
	},
	{
		value: 'Ireland',
		label: 'Ireland',
		type: 'country',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Dublin',
		label: 'Dublin, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cork',
		label: 'Cork, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Limerick',
		label: 'Limerick, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Galway',
		label: 'Galway, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Swords',
		label: 'Swords, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Abbeyfeale',
		label: 'Abbeyfeale, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Drogheda',
		label: 'Drogheda, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Dundalk',
		label: 'Dundalk, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Navan',
		label: 'Navan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Waterford',
		label: 'Waterford, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kildare',
		label: 'Kildare, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kilkenny',
		label: 'Kilkenny, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Mullingar',
		label: 'Mullingar, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Wexford',
		label: 'Wexford, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Sligo',
		label: 'Sligo, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Wicklow',
		label: 'Wicklow, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Athlone',
		label: 'Athlone, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tralee',
		label: 'Tralee, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Carlow',
		label: 'Carlow, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bray',
		label: 'Bray, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Naas',
		label: 'Naas, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Maynooth',
		label: 'Maynooth, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ennis',
		label: 'Ennis, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Letterkenny',
		label: 'Letterkenny, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Nenagh',
		label: 'Nenagh, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clonmel',
		label: 'Clonmel, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Balbriggan',
		label: 'Balbriggan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Castlebar',
		label: 'Castlebar, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Malahide',
		label: 'Malahide, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Donegal',
		label: 'Donegal, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Celbridge',
		label: 'Celbridge, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cavan',
		label: 'Cavan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Greystones',
		label: 'Greystones, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Arklow',
		label: 'Arklow, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tullamore',
		label: 'Tullamore, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tipperary',
		label: 'Tipperary, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Port Laoise',
		label: 'Port Laoise, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Newbridge',
		label: 'Newbridge, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clonakilty',
		label: 'Clonakilty, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballina',
		label: 'Ballina, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Dungarvan',
		label: 'Dungarvan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cobh',
		label: 'Cobh, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Longford',
		label: 'Longford, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Carrick-on-Shannon',
		label: 'Carrick-on-Shannon, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Leixlip',
		label: 'Leixlip, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Killarney',
		label: 'Killarney, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kells',
		label: 'Kells, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bandon',
		label: 'Bandon, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Birr',
		label: 'Birr, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Westport',
		label: 'Westport, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Gorey',
		label: 'Gorey, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Roscommon',
		label: 'Roscommon, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Newcastle',
		label: 'Newcastle, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Thurles',
		label: 'Thurles, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Loughrea',
		label: 'Loughrea, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Dunmanway',
		label: 'Dunmanway, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Youghal',
		label: 'Youghal, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Monaghan',
		label: 'Monaghan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Trim',
		label: 'Trim, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Enniscorthy',
		label: 'Enniscorthy, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'New Ross',
		label: 'New Ross, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ardee',
		label: 'Ardee, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Carrickmacross',
		label: 'Carrickmacross, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Boyle',
		label: 'Boyle, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Shannon',
		label: 'Shannon, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Buncrana',
		label: 'Buncrana, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Charleville',
		label: 'Charleville, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Dingle',
		label: 'Dingle, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballyhaunis',
		label: 'Ballyhaunis, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Midleton',
		label: 'Midleton, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Rush',
		label: 'Rush, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tuam',
		label: 'Tuam, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bantry',
		label: 'Bantry, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Skibbereen',
		label: 'Skibbereen, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Claremorris',
		label: 'Claremorris, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Skerries',
		label: 'Skerries, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballinasloe',
		label: 'Ballinasloe, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Roscrea',
		label: 'Roscrea, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Portarlington',
		label: 'Portarlington, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bundoran',
		label: 'Bundoran, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Rathdrum',
		label: 'Rathdrum, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Passage West',
		label: 'Passage West, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Mitchelstown',
		label: 'Mitchelstown, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kinsale',
		label: 'Kinsale, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bagenalstown',
		label: 'Bagenalstown, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Castleblayney',
		label: 'Castleblayney, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Blarney',
		label: 'Blarney, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Castlerea',
		label: 'Castlerea, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Bailieborough',
		label: 'Bailieborough, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballinrobe',
		label: 'Ballinrobe, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Belturbet',
		label: 'Belturbet, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Carrigaline',
		label: 'Carrigaline, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tramore',
		label: 'Tramore, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Athy',
		label: 'Athy, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Rathcoole',
		label: 'Rathcoole, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Edenderry',
		label: 'Edenderry, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Listowel',
		label: 'Listowel, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cashel',
		label: 'Cashel, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kilrush',
		label: 'Kilrush, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Macroom',
		label: 'Macroom, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Tullow',
		label: 'Tullow, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Templemore',
		label: 'Templemore, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clones',
		label: 'Clones, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Athenry',
		label: 'Athenry, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Banagher',
		label: 'Banagher, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kanturk',
		label: 'Kanturk, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Thomastown',
		label: 'Thomastown, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Mountrath',
		label: 'Mountrath, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Killorglin',
		label: 'Killorglin, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Gort',
		label: 'Gort, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cahirciveen',
		label: 'Cahirciveen, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Malaita',
		label: 'Malaita, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Laytown',
		label: 'Laytown, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Carrick-on-Suir',
		label: 'Carrick-on-Suir, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballybofey',
		label: 'Ballybofey, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballyshannon',
		label: 'Ballyshannon, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clara',
		label: 'Clara, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Cahir',
		label: 'Cahir, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Drumcar',
		label: 'Drumcar, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Coothill',
		label: 'Coothill, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Moate',
		label: 'Moate, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Abbeyleix',
		label: 'Abbeyleix, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballybunion',
		label: 'Ballybunion, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Rathkeale',
		label: 'Rathkeale, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kilmallock',
		label: 'Kilmallock, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballaghaderreen',
		label: 'Ballaghaderreen, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Granard',
		label: 'Granard, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Moville',
		label: 'Moville, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Millstreet',
		label: 'Millstreet, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Swinford',
		label: 'Swinford, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kenmare',
		label: 'Kenmare, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kilcormac',
		label: 'Kilcormac, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Mountmellick',
		label: 'Mountmellick, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Portrane',
		label: 'Portrane, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Monasterevan',
		label: 'Monasterevan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clane',
		label: 'Clane, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Castleisland',
		label: 'Castleisland, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Drishane',
		label: 'Drishane, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Killybegs',
		label: 'Killybegs, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Castlecomer',
		label: 'Castlecomer, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Lifford',
		label: 'Lifford, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Kilkee',
		label: 'Kilkee, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Callan',
		label: 'Callan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clifden',
		label: 'Clifden, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Clondalkin',
		label: 'Clondalkin, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'county meath',
		label: 'county meath, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ashbourne',
		label: 'Ashbourne, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ratoath',
		label: 'Ratoath, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Meath',
		label: 'Meath, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Killaloe',
		label: 'Killaloe, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Ballina-Tipperary',
		label: 'Ballina-Tipperary, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Corofin',
		label: 'Corofin, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Lucan',
		label: 'Lucan, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Garristown',
		label: 'Garristown, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Roundwood',
		label: 'Roundwood, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Portumna',
		label: 'Portumna, Ireland',
		type: 'city',
		flagClass: 'fi fi-ie',
		isPopular: false,
	},
	{
		value: 'Isle of Man',
		label: 'Isle of Man',
		type: 'country',
		flagClass: 'fi fi-im',
		isPopular: false,
	},
	{
		value: 'Isle of Man',
		label: 'Isle of Man, Isle of Man',
		type: 'city',
		flagClass: 'fi fi-im',
		isPopular: false,
	},
	{
		value: 'Israel',
		label: 'Israel',
		type: 'country',
		flagClass: 'fi fi-il',
		isPopular: true,
	},
	{
		value: 'Tel Aviv-Yafo',
		label: 'Tel Aviv-Yafo, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: true,
	},
	{
		value: 'Jerusalem',
		label: 'Jerusalem, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: true,
	},
	{
		value: 'Herzeliyya',
		label: 'Herzeliyya, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Haifa',
		label: 'Haifa, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Ra'anana",
		label: "Ra'anana, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Rekhovot',
		label: 'Rekhovot, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kefar Sava',
		label: 'Kefar Sava, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ramat Gan',
		label: 'Ramat Gan, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Netanya',
		label: 'Netanya, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Modi'in",
		label: "Modi'in, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Hod HaSharon',
		label: 'Hod HaSharon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Petakh Tiqwa',
		label: 'Petakh Tiqwa, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bet Shemesh',
		label: 'Bet Shemesh, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Rishon LeZiyyon',
		label: 'Rishon LeZiyyon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Afula",
		label: "'Afula, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ramat HaSharon',
		label: 'Ramat HaSharon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Be'er Sheva",
		label: "Be'er Sheva, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Giv'atayim",
		label: "Giv'atayim, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ashdod',
		label: 'Ashdod, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Zikhron Ya'aqov",
		label: "Zikhron Ya'aqov, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bat Yam',
		label: 'Bat Yam, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Karmiel',
		label: 'Karmiel, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ashqelon',
		label: 'Ashqelon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Shoham',
		label: 'Shoham, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nahariyya',
		label: 'Nahariyya, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Rosh HaAyin',
		label: 'Rosh HaAyin, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Eilat',
		label: 'Eilat, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Ono',
		label: 'Qiryat Ono, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ganne Tiqwa',
		label: 'Ganne Tiqwa, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Pardes Khanna-Karkur',
		label: 'Pardes Khanna-Karkur, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nes Ziyyona',
		label: 'Nes Ziyyona, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Binyamina',
		label: 'Binyamina, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Mevasserat Ziyyon',
		label: 'Mevasserat Ziyyon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Lod',
		label: 'Lod, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Giv'at Shemuel",
		label: "Giv'at Shemuel, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Qiryat Tiv'on",
		label: "Qiryat Tiv'on, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ramla',
		label: 'Ramla, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Ma'ale Adummim",
		label: "Ma'ale Adummim, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Or Yehuda',
		label: 'Or Yehuda, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Yehud',
		label: 'Yehud, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nazerat',
		label: 'Nazerat, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Akko",
		label: "'Akko, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Nazerat 'Illit",
		label: "Nazerat 'Illit, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Tiberias',
		label: 'Tiberias, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nesher',
		label: 'Nesher, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Yoqne'am Illit",
		label: "Yoqne'am Illit, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bene Beraq',
		label: 'Bene Beraq, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Motzkin',
		label: 'Qiryat Motzkin, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Zefat',
		label: 'Zefat, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kefar Yona',
		label: 'Kefar Yona, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Azor',
		label: 'Azor, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kholon',
		label: 'Kholon, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Even Yehuda',
		label: 'Even Yehuda, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Gat',
		label: 'Qiryat Gat, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Yam',
		label: 'Qiryat Yam, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Bialik',
		label: 'Qiryat Bialik, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Yavne',
		label: 'Yavne, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Gedera',
		label: 'Gedera, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Isifya",
		label: "'Isifya, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Jatt',
		label: 'Jatt, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Mazkeret Batya',
		label: 'Mazkeret Batya, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Pardesiyya',
		label: 'Pardesiyya, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Atta',
		label: 'Qiryat Atta, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Rahat',
		label: 'Rahat, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Tayibe',
		label: 'Tayibe, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Arad",
		label: "'Arad, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Or 'Aqiva",
		label: "Or 'Aqiva, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Ar'ara",
		label: "'Ar'ara, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Daliyat-al-Karmil',
		label: 'Daliyat-al-Karmil, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qadima',
		label: 'Qadima, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kabul',
		label: 'Kabul, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Ilut",
		label: "'Ilut, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Umm-al-Fahm',
		label: 'Umm-al-Fahm, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Migdal Ha'Emeq",
		label: "Migdal Ha'Emeq, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Tamra',
		label: 'Tamra, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qiryat Shemona',
		label: 'Qiryat Shemona, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Baqa al-Gharbiyyah',
		label: 'Baqa al-Gharbiyyah, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Sederot',
		label: 'Sederot, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Qiryat Mal'akhi",
		label: "Qiryat Mal'akhi, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Arrabe",
		label: "'Arrabe, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Qalansawe',
		label: 'Qalansawe, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Judeide-Maker',
		label: 'Judeide-Maker, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Reine',
		label: 'Reine, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Gan Yavne',
		label: 'Gan Yavne, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Abu Sinan',
		label: 'Abu Sinan, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Iksal',
		label: 'Iksal, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Jizr-az-Zarqa',
		label: 'Jizr-az-Zarqa, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Yeroham',
		label: 'Yeroham, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Dayr Hannah',
		label: 'Dayr Hannah, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Rekhasim',
		label: 'Rekhasim, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Jaljulye',
		label: 'Jaljulye, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Omer",
		label: "'Omer, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nahalal',
		label: 'Nahalal, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Ari'el",
		label: "Ari'el, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Neve Ilan',
		label: 'Neve Ilan, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Khadera',
		label: 'Khadera, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Dimona',
		label: 'Dimona, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Shefar'am",
		label: "Shefar'am, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Sakhnin',
		label: 'Sakhnin, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Ofaqim',
		label: 'Ofaqim, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Netivot',
		label: 'Netivot, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Ma'alot Tarshikha",
		label: "Ma'alot Tarshikha, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Tire',
		label: 'Tire, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Hadera',
		label: 'Hadera, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Tirat Karmel',
		label: 'Tirat Karmel, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Mugar',
		label: 'Mugar, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kafar Kanna',
		label: 'Kafar Kanna, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kafar Qasem',
		label: 'Kafar Qasem, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Bet She'an",
		label: "Bet She'an, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kafar Manda',
		label: 'Kafar Manda, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Kafar Qara'",
		label: "Kafar Qara', Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Yirka',
		label: 'Yirka, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Majd-al-Kurum',
		label: 'Majd-al-Kurum, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Tur'an",
		label: "Tur'an, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "'Ein Mahel",
		label: "'Ein Mahel, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "I'billin",
		label: "I'billin, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Qiryat 'Eqron",
		label: "Qiryat 'Eqron, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Fureidis',
		label: 'Fureidis, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Beit Jann',
		label: 'Beit Jann, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Nahef',
		label: 'Nahef, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Dayr-al-Asad',
		label: 'Dayr-al-Asad, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Hazor HaGelilit',
		label: 'Hazor HaGelilit, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Be'er Ya'aqov",
		label: "Be'er Ya'aqov, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Dabburye',
		label: 'Dabburye, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kafar Yasif',
		label: 'Kafar Yasif, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Bu'eine-Nujeidat",
		label: "Bu'eine-Nujeidat, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'El Rama',
		label: 'El Rama, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bi´r Ghabalu',
		label: 'Bi´r Ghabalu, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bir-al-Maksur',
		label: 'Bir-al-Maksur, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Mashhed',
		label: 'Mashhed, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Kisra-Sumei',
		label: 'Kisra-Sumei, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: "Basmat Tab'un",
		label: "Basmat Tab'un, Israel",
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Bene Ayish',
		label: 'Bene Ayish, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Yakum',
		label: 'Yakum, Israel',
		type: 'city',
		flagClass: 'fi fi-il',
		isPopular: false,
	},
	{
		value: 'Roma',
		label: 'Roma, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Capri',
		label: 'Capri, Italy',
		type: 'island',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Italy',
		label: 'Italy',
		type: 'country',
		flagClass: 'fi fi-it',
		isPopular: true,
	},
	{
		value: 'Milano',
		label: 'Milano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Napoli',
		label: 'Napoli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Torino',
		label: 'Torino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bologna',
		label: 'Bologna, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Firenze',
		label: 'Firenze, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Palermo',
		label: 'Palermo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Genova',
		label: 'Genova, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Catania',
		label: 'Catania, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Modena',
		label: 'Modena, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Verona',
		label: 'Verona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cagliari',
		label: 'Cagliari, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bari',
		label: 'Bari, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Brescia',
		label: 'Brescia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Padova',
		label: 'Padova, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Venezia',
		label: 'Venezia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: "Reggio nell'Emilia",
		label: "Reggio nell'Emilia, Italy",
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lecce',
		label: 'Lecce, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bergamo',
		label: 'Bergamo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Perugia',
		label: 'Perugia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Treviso',
		label: 'Treviso, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Udine',
		label: 'Udine, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Trieste',
		label: 'Trieste, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Taranto',
		label: 'Taranto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Parma',
		label: 'Parma, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pescara',
		label: 'Pescara, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Vicenza',
		label: 'Vicenza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Rimini',
		label: 'Rimini, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pisa',
		label: 'Pisa, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ferrara',
		label: 'Ferrara, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Matera',
		label: 'Matera, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Prato',
		label: 'Prato, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Trento',
		label: 'Trento, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Varese',
		label: 'Varese, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ancona',
		label: 'Ancona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Salerno',
		label: 'Salerno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Piacenza',
		label: 'Piacenza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Livorno',
		label: 'Livorno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cosenza',
		label: 'Cosenza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pesaro',
		label: 'Pesaro, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Siena',
		label: 'Siena, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Forlì',
		label: 'Forlì, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Mantova',
		label: 'Mantova, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Terni',
		label: 'Terni, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pavia',
		label: 'Pavia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cerro Maggiore',
		label: 'Cerro Maggiore, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'La Spezia',
		label: 'La Spezia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cesena',
		label: 'Cesena, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cuneo',
		label: 'Cuneo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Abano Terme',
		label: 'Abano Terme, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Monza',
		label: 'Monza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Foggia',
		label: 'Foggia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Arezzo',
		label: 'Arezzo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ravenna',
		label: 'Ravenna, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Novara',
		label: 'Novara, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Como',
		label: 'Como, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Caserta',
		label: 'Caserta, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lucca',
		label: 'Lucca, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Sanremo',
		label: 'Sanremo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Catanzaro',
		label: 'Catanzaro, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pordenone',
		label: 'Pordenone, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Viareggio',
		label: 'Viareggio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Siracusa',
		label: 'Siracusa, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Messina',
		label: 'Messina, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Latina',
		label: 'Latina, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bolzano',
		label: 'Bolzano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Savona',
		label: 'Savona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pistoia',
		label: 'Pistoia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Sassari',
		label: 'Sassari, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Faenza',
		label: 'Faenza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Reggio di Calabria',
		label: 'Reggio di Calabria, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Grosseto',
		label: 'Grosseto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Brindisi',
		label: 'Brindisi, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Asti',
		label: 'Asti, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Fano',
		label: 'Fano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ascoli Piceno',
		label: 'Ascoli Piceno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Carrara',
		label: 'Carrara, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Teramo',
		label: 'Teramo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bassano del Grappa',
		label: 'Bassano del Grappa, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Potenza',
		label: 'Potenza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Alessandria',
		label: 'Alessandria, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Busto Arsizio',
		label: 'Busto Arsizio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Imola',
		label: 'Imola, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cremona',
		label: 'Cremona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Macerata',
		label: 'Macerata, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Biella',
		label: 'Biella, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Massa',
		label: 'Massa, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lecco',
		label: 'Lecco, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Benevento',
		label: 'Benevento, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Trapani',
		label: 'Trapani, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Imperia',
		label: 'Imperia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Jesi',
		label: 'Jesi, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Andria',
		label: 'Andria, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'San Benedetto del Tronto',
		label: 'San Benedetto del Tronto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: "L'Aquila",
		label: "L'Aquila, Italy",
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Viterbo',
		label: 'Viterbo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Crotone',
		label: 'Crotone, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Barletta',
		label: 'Barletta, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Fermo',
		label: 'Fermo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Castelfranco Veneto',
		label: 'Castelfranco Veneto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Belluno',
		label: 'Belluno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Senigallia',
		label: 'Senigallia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Avellino',
		label: 'Avellino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Rovigo',
		label: 'Rovigo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ischia',
		label: 'Ischia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ivrea',
		label: 'Ivrea, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Carbonia',
		label: 'Carbonia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lodi',
		label: 'Lodi, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Torre del Greco',
		label: 'Torre del Greco, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pomezia',
		label: 'Pomezia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Pozzuoli',
		label: 'Pozzuoli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Foligno',
		label: 'Foligno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Nuoro',
		label: 'Nuoro, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Acerra',
		label: 'Acerra, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Voghera',
		label: 'Voghera, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Oristano',
		label: 'Oristano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Copertino',
		label: 'Copertino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Campobasso',
		label: 'Campobasso, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Verbania',
		label: 'Verbania, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Civitanova Marche',
		label: 'Civitanova Marche, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Fiumicino',
		label: 'Fiumicino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Olbia',
		label: 'Olbia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Saronno',
		label: 'Saronno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Gorizia',
		label: 'Gorizia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Caltanissetta',
		label: 'Caltanissetta, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Velletri',
		label: 'Velletri, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Aosta',
		label: 'Aosta, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lanciano',
		label: 'Lanciano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Altamura',
		label: 'Altamura, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Rieti',
		label: 'Rieti, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Carpi',
		label: 'Carpi, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Empoli',
		label: 'Empoli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Nettuno',
		label: 'Nettuno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: "Pomigliano d'Arco",
		label: "Pomigliano d'Arco, Italy",
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Battipaglia',
		label: 'Battipaglia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Trani',
		label: 'Trani, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Rho',
		label: 'Rho, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Schio',
		label: 'Schio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Spoleto',
		label: 'Spoleto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Vigevano',
		label: 'Vigevano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Follonica',
		label: 'Follonica, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Chieti',
		label: 'Chieti, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Nola',
		label: 'Nola, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Villafranca di Verona',
		label: 'Villafranca di Verona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Agrigento',
		label: 'Agrigento, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bisceglie',
		label: 'Bisceglie, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Castellammare di Stabia',
		label: 'Castellammare di Stabia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Domodossola',
		label: 'Domodossola, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Aprilia',
		label: 'Aprilia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Rivoli',
		label: 'Rivoli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Vercelli',
		label: 'Vercelli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Lugo',
		label: 'Lugo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Chiavari',
		label: 'Chiavari, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Erba',
		label: 'Erba, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Ragusa',
		label: 'Ragusa, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'San Donà di Piave',
		label: 'San Donà di Piave, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Borgomanero',
		label: 'Borgomanero, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Abbiategrasso',
		label: 'Abbiategrasso, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Formia',
		label: 'Formia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Alba',
		label: 'Alba, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Portici',
		label: 'Portici, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cerignola',
		label: 'Cerignola, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Vibo Valentia',
		label: 'Vibo Valentia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Casale Monferrato',
		label: 'Casale Monferrato, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Chieri',
		label: 'Chieri, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Giugliano in Campania',
		label: 'Giugliano in Campania, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cinisello Balsamo',
		label: 'Cinisello Balsamo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bracciano',
		label: 'Bracciano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Fabriano',
		label: 'Fabriano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Guidonia Montecelio',
		label: 'Guidonia Montecelio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Cerveteri',
		label: 'Cerveteri, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Thiene',
		label: 'Thiene, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Castellanza',
		label: 'Castellanza, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Genzano di Roma',
		label: 'Genzano di Roma, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Piombino',
		label: 'Piombino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'San Severo',
		label: 'San Severo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Tivoli',
		label: 'Tivoli, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Chioggia',
		label: 'Chioggia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Desio',
		label: 'Desio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Sondrio',
		label: 'Sondrio, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Crema',
		label: 'Crema, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Enna',
		label: 'Enna, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Melegnano',
		label: 'Melegnano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Acqui Terme',
		label: 'Acqui Terme, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Urbino',
		label: 'Urbino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Civitavecchia',
		label: 'Civitavecchia, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Frosinone',
		label: 'Frosinone, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bra',
		label: 'Bra, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Tortona',
		label: 'Tortona, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Bitonto',
		label: 'Bitonto, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Moncalieri',
		label: 'Moncalieri, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Alcamo',
		label: 'Alcamo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Alghero',
		label: 'Alghero, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Albano Laziale',
		label: 'Albano Laziale, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Legnano',
		label: 'Legnano, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Albenga',
		label: 'Albenga, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Collegno',
		label: 'Collegno, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Mira',
		label: 'Mira, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Saluzzo',
		label: 'Saluzzo, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Sesto Fiorentino',
		label: 'Sesto Fiorentino, Italy',
		type: 'city',
		flagClass: 'fi fi-it',
		isPopular: false,
	},
	{
		value: 'Jamaica',
		label: 'Jamaica',
		type: 'country',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Kingston-Blackmans Bay',
		label: 'Kingston-Blackmans Bay, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Montego Bay',
		label: 'Montego Bay, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Half Way Tree',
		label: 'Half Way Tree, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Portmore',
		label: 'Portmore, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Spanish Town',
		label: 'Spanish Town, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Albany',
		label: 'Albany, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Ocho Rios',
		label: 'Ocho Rios, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Mandeville',
		label: 'Mandeville, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'May Pen',
		label: 'May Pen, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Port Antonio',
		label: 'Port Antonio, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Morant Bay',
		label: 'Morant Bay, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Savanna la Mar',
		label: 'Savanna la Mar, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Black River',
		label: 'Black River, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Lucea',
		label: 'Lucea, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: "Saint Ann's Bay",
		label: "Saint Ann's Bay, Jamaica",
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Anotto Bay',
		label: 'Anotto Bay, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Falmouth',
		label: 'Falmouth, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: "Brown's Town",
		label: "Brown's Town, Jamaica",
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Port Maria',
		label: 'Port Maria, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Bull Savanna',
		label: 'Bull Savanna, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Bamboo',
		label: 'Bamboo, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Cambridge',
		label: 'Cambridge, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Negril',
		label: 'Negril, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Albert Town',
		label: 'Albert Town, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Anchovy',
		label: 'Anchovy, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Maroon Town',
		label: 'Maroon Town, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Discovery Bay',
		label: 'Discovery Bay, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Kingston',
		label: 'Kingston, Jamaica',
		type: 'city',
		flagClass: 'fi fi-jm',
		isPopular: false,
	},
	{
		value: 'Osaka',
		label: 'Osaka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Okinawa',
		label: 'Okinawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yokohama',
		label: 'Yokohama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagoya',
		label: 'Nagoya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yokosuka',
		label: 'Yokosuka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kawasaki',
		label: 'Kawasaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Chiba',
		label: 'Chiba, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Abashiri',
		label: 'Abashiri, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kyoto',
		label: 'Kyoto, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fukuoka',
		label: 'Fukuoka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kobe',
		label: 'Kobe, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Misawa',
		label: 'Misawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fussa',
		label: 'Fussa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Sagamihara',
		label: 'Sagamihara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Sasebo',
		label: 'Sasebo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Sapporo',
		label: 'Sapporo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hamamatsu',
		label: 'Hamamatsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Sendai',
		label: 'Sendai, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Shizuoka',
		label: 'Shizuoka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Zama',
		label: 'Zama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Atsugi',
		label: 'Atsugi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hachioji',
		label: 'Hachioji, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tsukuba',
		label: 'Tsukuba, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Gifu',
		label: 'Gifu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Funabashi',
		label: 'Funabashi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ichikawa',
		label: 'Ichikawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fujisawa',
		label: 'Fujisawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ibaraki',
		label: 'Ibaraki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kumamoto',
		label: 'Kumamoto, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kawaguchi',
		label: 'Kawaguchi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nara',
		label: 'Nara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kamakura',
		label: 'Kamakura, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Urayasu',
		label: 'Urayasu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Naha',
		label: 'Naha, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Beppu',
		label: 'Beppu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nishinomiya',
		label: 'Nishinomiya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kashiwa',
		label: 'Kashiwa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Shiga',
		label: 'Shiga, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Niigata',
		label: 'Niigata, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsudo',
		label: 'Matsudo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagasaki',
		label: 'Nagasaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tachikawa',
		label: 'Tachikawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Iwakuni',
		label: 'Iwakuni, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Himeji',
		label: 'Himeji, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Machida',
		label: 'Machida, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagano',
		label: 'Nagano, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsumoto',
		label: 'Matsumoto, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Toyo',
		label: 'Toyo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagayo',
		label: 'Nagayo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kitakyushu',
		label: 'Kitakyushu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ayase',
		label: 'Ayase, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Utsunomiya',
		label: 'Utsunomiya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Okazaki',
		label: 'Okazaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Soka',
		label: 'Soka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Chigasaki',
		label: 'Chigasaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ageo',
		label: 'Ageo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Saga',
		label: 'Saga, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Narita',
		label: 'Narita, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Okayama',
		label: 'Okayama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Aomori',
		label: 'Aomori, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hiratsuka',
		label: 'Hiratsuka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ota',
		label: 'Ota, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kanazawa',
		label: 'Kanazawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Toyohashi',
		label: 'Toyohashi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tokorozawa',
		label: 'Tokorozawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kawagoe',
		label: 'Kawagoe, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Miyazaki',
		label: 'Miyazaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Takasaki',
		label: 'Takasaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Odawara',
		label: 'Odawara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tsu',
		label: 'Tsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsue',
		label: 'Matsue, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Musashino',
		label: 'Musashino, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Wakayama',
		label: 'Wakayama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Koshigaya',
		label: 'Koshigaya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Omihachiman',
		label: 'Omihachiman, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yomitan',
		label: 'Yomitan, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Maebashi',
		label: 'Maebashi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Sakura',
		label: 'Sakura, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kakamigahara',
		label: 'Kakamigahara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ebina',
		label: 'Ebina, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hikone',
		label: 'Hikone, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Akishima',
		label: 'Akishima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tajimi',
		label: 'Tajimi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Amagasaki',
		label: 'Amagasaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fukuyama',
		label: 'Fukuyama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Wako',
		label: 'Wako, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kochi',
		label: 'Kochi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kasugai',
		label: 'Kasugai, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ichinomiya',
		label: 'Ichinomiya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Takarazuka',
		label: 'Takarazuka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Chofu',
		label: 'Chofu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Suzuka',
		label: 'Suzuka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Date',
		label: 'Date, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Mitaka',
		label: 'Mitaka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Higashihiroshima',
		label: 'Higashihiroshima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Isehara',
		label: 'Isehara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nakano',
		label: 'Nakano, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hirakata',
		label: 'Hirakata, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kunitachi',
		label: 'Kunitachi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Takamatsu',
		label: 'Takamatsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kodaira',
		label: 'Kodaira, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Aioi',
		label: 'Aioi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Narashino',
		label: 'Narashino, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Iruma',
		label: 'Iruma, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yamanashi',
		label: 'Yamanashi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tama',
		label: 'Tama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tsuchiura',
		label: 'Tsuchiura, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Abiko',
		label: 'Abiko, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Isesaki',
		label: 'Isesaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yamoto',
		label: 'Yamoto, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Minokamo',
		label: 'Minokamo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ashiya',
		label: 'Ashiya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Chatan',
		label: 'Chatan, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kagoshima',
		label: 'Kagoshima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsuyama',
		label: 'Matsuyama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Higashiyamato',
		label: 'Higashiyamato, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Toyota',
		label: 'Toyota, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Asahikawa',
		label: 'Asahikawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Okegawa',
		label: 'Okegawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kiyose',
		label: 'Kiyose, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Mito',
		label: 'Mito, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fuji',
		label: 'Fuji, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fuchu',
		label: 'Fuchu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yamato',
		label: 'Yamato, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hasuda',
		label: 'Hasuda, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kasukabe',
		label: 'Kasukabe, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Numazu',
		label: 'Numazu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Zushi',
		label: 'Zushi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kawanishi',
		label: 'Kawanishi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kumagaya',
		label: 'Kumagaya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tottori',
		label: 'Tottori, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Otaru',
		label: 'Otaru, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hamura',
		label: 'Hamura, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yamaguchi',
		label: 'Yamaguchi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yonago',
		label: 'Yonago, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kusatsu',
		label: 'Kusatsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Aizuwakamatsu',
		label: 'Aizuwakamatsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Higashikurume',
		label: 'Higashikurume, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Toda',
		label: 'Toda, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Koganei',
		label: 'Koganei, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fukaya',
		label: 'Fukaya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ise',
		label: 'Ise, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Gyoda',
		label: 'Gyoda, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tochigi',
		label: 'Tochigi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Toride',
		label: 'Toride, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Shiroishi',
		label: 'Shiroishi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Komae',
		label: 'Komae, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nisshin',
		label: 'Nisshin, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Iwaki',
		label: 'Iwaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Suita',
		label: 'Suita, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kuroishi',
		label: 'Kuroishi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kuki',
		label: 'Kuki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Otsu',
		label: 'Otsu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yokkaichi',
		label: 'Yokkaichi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tsurugashima',
		label: 'Tsurugashima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hakodate',
		label: 'Hakodate, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ichihara',
		label: 'Ichihara, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yao',
		label: 'Yao, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tokushima',
		label: 'Tokushima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fukui',
		label: 'Fukui, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Eniwa',
		label: 'Eniwa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kurume',
		label: 'Kurume, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Shimizu',
		label: 'Shimizu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Moka',
		label: 'Moka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Chiryu',
		label: 'Chiryu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagaoka',
		label: 'Nagaoka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kofu',
		label: 'Kofu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nagahama',
		label: 'Nagahama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Izumi',
		label: 'Izumi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yachiyo',
		label: 'Yachiyo, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Tomakomai',
		label: 'Tomakomai, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fukuroi',
		label: 'Fukuroi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Uwajima',
		label: 'Uwajima, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ashikaga',
		label: 'Ashikaga, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Koga',
		label: 'Koga, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ogaki',
		label: 'Ogaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Komaki',
		label: 'Komaki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Higashimurayama',
		label: 'Higashimurayama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kariya',
		label: 'Kariya, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hashimoto',
		label: 'Hashimoto, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fujieda',
		label: 'Fujieda, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kikugawa',
		label: 'Kikugawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ueda',
		label: 'Ueda, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsusaka',
		label: 'Matsusaka, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Yuki',
		label: 'Yuki, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kasai',
		label: 'Kasai, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Hofu',
		label: 'Hofu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ikoma',
		label: 'Ikoma, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Handa',
		label: 'Handa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Matsubushi',
		label: 'Matsubushi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Fujimi',
		label: 'Fujimi, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Kamogawa',
		label: 'Kamogawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Iwakura',
		label: 'Iwakura, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Inazawa',
		label: 'Inazawa, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Izumisano',
		label: 'Izumisano, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Higashimatsuyama',
		label: 'Higashimatsuyama, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Aira',
		label: 'Aira, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Ginowan',
		label: 'Ginowan, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Nasu',
		label: 'Nasu, Japan',
		type: 'city',
		flagClass: 'fi fi-jp',
		isPopular: false,
	},
	{
		value: 'Jersey',
		label: 'Jersey',
		type: 'country',
		flagClass: 'fi fi-je',
		isPopular: false,
	},
	{
		value: 'Jordan',
		label: 'Jordan',
		type: 'country',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: '´Amman',
		label: '´Amman, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Irbid',
		label: 'Irbid, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Jubayhah',
		label: 'al-Jubayhah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Abu ´Alanda',
		label: 'Abu ´Alanda, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: "az-Zarqa'",
		label: "az-Zarqa', Jordan",
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-´Aqabah',
		label: 'al-´Aqabah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Khalda wa Tila´-al-´Ali',
		label: 'Khalda wa Tila´-al-´Ali, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Madaba',
		label: 'Madaba, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'as-Salt',
		label: 'as-Salt, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Husun',
		label: 'al-Husun, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Suwaylih',
		label: 'Suwaylih, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'ar-Ramtha',
		label: 'ar-Ramtha, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Baq´ah',
		label: 'al-Baq´ah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Jarash',
		label: 'Jarash, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Askan Abu Nusayr',
		label: 'Askan Abu Nusayr, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'ar-Russayfah',
		label: 'ar-Russayfah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Wadi as-Sir',
		label: 'Wadi as-Sir, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Sahab',
		label: 'Sahab, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Tariq',
		label: 'Tariq, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Karak',
		label: 'al-Karak, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Ajlun',
		label: 'Ajlun, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Mushayrfat Ras al-´Ayn',
		label: 'Mushayrfat Ras al-´Ayn, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Mafraq',
		label: 'al-Mafraq, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Quwaysimah',
		label: 'al-Quwaysimah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Ma´addi',
		label: 'Ma´addi, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'at-Tafilah',
		label: 'at-Tafilah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Ayn al-Basha',
		label: 'Ayn al-Basha, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Amman',
		label: 'Amman, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Shnillar',
		label: 'Shnillar, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Khraybat As-Suq',
		label: 'Khraybat As-Suq, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Umm Qusayr wal Muqabalin',
		label: 'Umm Qusayr wal Muqabalin, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'al-Juwaydah',
		label: 'al-Juwaydah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'as-Sarih',
		label: 'as-Sarih, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Kufranjah',
		label: 'Kufranjah, Jordan',
		type: 'city',
		flagClass: 'fi fi-jo',
		isPopular: false,
	},
	{
		value: 'Kazakhstan',
		label: 'Kazakhstan',
		type: 'country',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Almaty',
		label: 'Almaty, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Abay',
		label: 'Abay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karaganda',
		label: 'Karaganda, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Astana',
		label: 'Astana, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Pavlodar',
		label: 'Pavlodar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aksay',
		label: 'Aksay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Simkent',
		label: 'Simkent, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Taraz',
		label: 'Taraz, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Öskemen',
		label: 'Öskemen, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Semey',
		label: 'Semey, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Temirtau',
		label: 'Temirtau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aktau',
		label: 'Aktau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Atirau',
		label: 'Atirau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Hromtau',
		label: 'Hromtau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kusmurin',
		label: 'Kusmurin, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Osakarovka',
		label: 'Osakarovka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Makansi',
		label: 'Makansi, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Borovskoy',
		label: 'Borovskoy, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Georgiyev',
		label: 'Georgiyev, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Batis Kazakstan',
		label: 'Batis Kazakstan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Arkalik',
		label: 'Arkalik, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Stepnogorsk',
		label: 'Stepnogorsk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Canatas',
		label: 'Canatas, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ziryan',
		label: 'Ziryan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Saran',
		label: 'Saran, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aksu',
		label: 'Aksu, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sahti',
		label: 'Sahti, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ermak',
		label: 'Ermak, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Lisakovsk',
		label: 'Lisakovsk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aris',
		label: 'Aris, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kapsagay',
		label: 'Kapsagay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aral',
		label: 'Aral, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Tekeli',
		label: 'Tekeli, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Salkar',
		label: 'Salkar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Canakazali',
		label: 'Canakazali, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karatau',
		label: 'Karatau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Üstöbe',
		label: 'Üstöbe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Atbasar',
		label: 'Atbasar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ayaköz',
		label: 'Ayaköz, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Esil',
		label: 'Esil, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kandagaç',
		label: 'Kandagaç, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kaskelen',
		label: 'Kaskelen, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Chui',
		label: 'Chui, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Talgar',
		label: 'Talgar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Derjavinsk',
		label: 'Derjavinsk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Lugovoy',
		label: 'Lugovoy, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Tobol',
		label: 'Tobol, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Volodar',
		label: 'Volodar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Komsomol',
		label: 'Komsomol, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ertis',
		label: 'Ertis, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Krasnoarmeets',
		label: 'Krasnoarmeets, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Makin',
		label: 'Makin, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kaçiri',
		label: 'Kaçiri, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sarbakti',
		label: 'Sarbakti, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Maykain',
		label: 'Maykain, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kirgili',
		label: 'Kirgili, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Merke',
		label: 'Merke, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Lener',
		label: 'Lener, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kiziltu',
		label: 'Kiziltu, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Belyy Vody',
		label: 'Belyy Vody, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kürsim',
		label: 'Kürsim, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Boralday',
		label: 'Boralday, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Konrat',
		label: 'Konrat, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Födorov',
		label: 'Födorov, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karkarali',
		label: 'Karkarali, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sardara',
		label: 'Sardara, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Subarkudik',
		label: 'Subarkudik, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Esik',
		label: 'Esik, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Canakorgan',
		label: 'Canakorgan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Gulsat',
		label: 'Gulsat, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Alka',
		label: 'Alka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Açisay',
		label: 'Açisay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karabulak',
		label: 'Karabulak, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kirov',
		label: 'Kirov, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Makat',
		label: 'Makat, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sergeyevka',
		label: 'Sergeyevka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Zatobolsk',
		label: 'Zatobolsk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Glubokoe',
		label: 'Glubokoe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Semonaiha',
		label: 'Semonaiha, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Uzunagaç',
		label: 'Uzunagaç, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karacal',
		label: 'Karacal, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Carkant',
		label: 'Carkant, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cetibay',
		label: 'Cetibay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sieli',
		label: 'Sieli, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Èmbi',
		label: 'Èmbi, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Mamlyutka',
		label: 'Mamlyutka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sariözek',
		label: 'Sariözek, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Atasu',
		label: 'Atasu, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Bulaev',
		label: 'Bulaev, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Serebryansk',
		label: 'Serebryansk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Alekseevka',
		label: 'Alekseevka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sarisagan',
		label: 'Sarisagan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Zaysan',
		label: 'Zaysan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Külsari',
		label: 'Külsari, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sumisker',
		label: 'Sumisker, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ürcar',
		label: 'Ürcar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aghadir',
		label: 'Aghadir, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kurik',
		label: 'Kurik, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Belousovka',
		label: 'Belousovka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ereymentau',
		label: 'Ereymentau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Inderbor',
		label: 'Inderbor, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Oytal',
		label: 'Oytal, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Energetyçeskiy',
		label: 'Energetyçeskiy, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sarkand',
		label: 'Sarkand, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sar',
		label: 'Sar, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Bestobe',
		label: 'Bestobe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sayram',
		label: 'Sayram, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Ulba',
		label: 'Ulba, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Iliç',
		label: 'Iliç, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cosali',
		label: 'Cosali, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Colimbet',
		label: 'Colimbet, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Selek',
		label: 'Selek, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Mangyslak',
		label: 'Mangyslak, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Setpe',
		label: 'Setpe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Mihaylov',
		label: 'Mihaylov, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Oktos',
		label: 'Oktos, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Zaçagansk',
		label: 'Zaçagansk, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cayrem',
		label: 'Cayrem, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karsakbay',
		label: 'Karsakbay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Novodolinskiy',
		label: 'Novodolinskiy, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kurchatov',
		label: 'Kurchatov, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Caltir',
		label: 'Caltir, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Tokaryovka',
		label: 'Tokaryovka, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sariagas',
		label: 'Sariagas, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Stepnyak',
		label: 'Stepnyak, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Fabrichniy',
		label: 'Fabrichniy, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Tasböget',
		label: 'Tasböget, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Beyneu',
		label: 'Beyneu, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Çapaev',
		label: 'Çapaev, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cetisay',
		label: 'Cetisay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kazali',
		label: 'Kazali, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Dossor',
		label: 'Dossor, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Karaton',
		label: 'Karaton, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Batamsi',
		label: 'Batamsi, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sübarsi',
		label: 'Sübarsi, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sinirlau',
		label: 'Sinirlau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Oporni',
		label: 'Oporni, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Fort-Sevçenko',
		label: 'Fort-Sevçenko, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Temir',
		label: 'Temir, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Aktöbe',
		label: 'Aktöbe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kostanay',
		label: 'Kostanay, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Petropavl',
		label: 'Petropavl, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Akmeçet',
		label: 'Akmeçet, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Èkibastuz',
		label: 'Èkibastuz, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Köksetau',
		label: 'Köksetau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Rudni',
		label: 'Rudni, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Taldikorgan',
		label: 'Taldikorgan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cezkazgan',
		label: 'Cezkazgan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Türkistan',
		label: 'Türkistan, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Balkas',
		label: 'Balkas, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Satpaev',
		label: 'Satpaev, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Baykonir',
		label: 'Baykonir, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Riddir',
		label: 'Riddir, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kentau',
		label: 'Kentau, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Cetikara',
		label: 'Cetikara, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Sçuçe',
		label: 'Sçuçe, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Canaözen',
		label: 'Canaözen, Kazakhstan',
		type: 'city',
		flagClass: 'fi fi-kz',
		isPopular: false,
	},
	{
		value: 'Kenya',
		label: 'Kenya',
		type: 'country',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nairobi',
		label: 'Nairobi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mombasa',
		label: 'Mombasa, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ahero',
		label: 'Ahero, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nakuru',
		label: 'Nakuru, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kisumu',
		label: 'Kisumu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Eldoret',
		label: 'Eldoret, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Thika',
		label: 'Thika, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyeri',
		label: 'Nyeri, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kiambu',
		label: 'Kiambu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kikuyu',
		label: 'Kikuyu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Bungoma',
		label: 'Bungoma, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ngong',
		label: 'Ngong, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Embu',
		label: 'Embu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kakamega',
		label: 'Kakamega, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kericho',
		label: 'Kericho, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kitale',
		label: 'Kitale, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Naivasha',
		label: 'Naivasha, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Migori',
		label: 'Migori, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kisii',
		label: 'Kisii, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Siaya',
		label: 'Siaya, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mbita Point',
		label: 'Mbita Point, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Limuru',
		label: 'Limuru, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Machakos',
		label: 'Machakos, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kerugoya',
		label: 'Kerugoya, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nanyuki',
		label: 'Nanyuki, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Molo',
		label: 'Molo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Makueni',
		label: 'Makueni, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Butere',
		label: 'Butere, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kajiado',
		label: 'Kajiado, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Oyugis',
		label: 'Oyugis, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Itentambach',
		label: 'Itentambach, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyahururu',
		label: 'Nyahururu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Narok',
		label: 'Narok, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Karuri',
		label: 'Karuri, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Awendo',
		label: 'Awendo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Muhoroni',
		label: 'Muhoroni, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Taveta',
		label: 'Taveta, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: "Murang'a",
		label: "Murang'a, Kenya",
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyamira',
		label: 'Nyamira, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Bondo',
		label: 'Bondo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Karatina',
		label: 'Karatina, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Litein',
		label: 'Litein, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Malava',
		label: 'Malava, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Malindi',
		label: 'Malindi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Méru',
		label: 'Méru, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mumias',
		label: 'Mumias, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Busia',
		label: 'Busia, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kilifi',
		label: 'Kilifi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Webuye',
		label: 'Webuye, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Vihiga',
		label: 'Vihiga, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Lamu',
		label: 'Lamu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Lodwar',
		label: 'Lodwar, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ol Kalou',
		label: 'Ol Kalou, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kitui',
		label: 'Kitui, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kehancha',
		label: 'Kehancha, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Wundanyi',
		label: 'Wundanyi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mauá',
		label: 'Mauá, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kabarnet',
		label: 'Kabarnet, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kangundo',
		label: 'Kangundo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Oloitokitok',
		label: 'Oloitokitok, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Baringo',
		label: 'Baringo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Gilgil',
		label: 'Gilgil, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Tabaka',
		label: 'Tabaka, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kijabe',
		label: 'Kijabe, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Bomet',
		label: 'Bomet, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kwale',
		label: 'Kwale, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Othaya',
		label: 'Othaya, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kangema',
		label: 'Kangema, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nandi Hills',
		label: 'Nandi Hills, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ugunja',
		label: 'Ugunja, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kipini',
		label: 'Kipini, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nadi',
		label: 'Nadi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Sagana',
		label: 'Sagana, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Sotik',
		label: 'Sotik, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Runjenjes',
		label: 'Runjenjes, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Funyula',
		label: 'Funyula, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Garissa',
		label: 'Garissa, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Homa Bay',
		label: 'Homa Bay, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mandera',
		label: 'Mandera, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Isiolo',
		label: 'Isiolo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mavoko',
		label: 'Mavoko, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kapsabet',
		label: 'Kapsabet, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Voi',
		label: 'Voi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Maralal',
		label: 'Maralal, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Tana River',
		label: 'Tana River, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Lokichar',
		label: 'Lokichar, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Moyalê',
		label: 'Moyalê, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Marsabit',
		label: 'Marsabit, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kapenguria',
		label: 'Kapenguria, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Magadi',
		label: 'Magadi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Sawasawa',
		label: 'Sawasawa, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mariakani',
		label: 'Mariakani, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Namanga',
		label: 'Namanga, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Eldama Ravine',
		label: 'Eldama Ravine, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kimilili',
		label: 'Kimilili, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mwingi',
		label: 'Mwingi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Hola',
		label: 'Hola, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Lokitaung',
		label: 'Lokitaung, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mambrui',
		label: 'Mambrui, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Garsen',
		label: 'Garsen, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Njoro',
		label: 'Njoro, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Takaungu',
		label: 'Takaungu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mutomo',
		label: 'Mutomo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kangonde',
		label: 'Kangonde, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Rongai',
		label: 'Rongai, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Luanda',
		label: 'Luanda, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Solio',
		label: 'Solio, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Naro Moru',
		label: 'Naro Moru, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Malaba',
		label: 'Malaba, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kinango',
		label: 'Kinango, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Chhukha',
		label: 'Chhukha, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Wamba',
		label: 'Wamba, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Rongo',
		label: 'Rongo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Port Victoria',
		label: 'Port Victoria, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Wote',
		label: 'Wote, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Matuu',
		label: 'Matuu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mount Elgon',
		label: 'Mount Elgon, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Lugari',
		label: 'Lugari, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Witu',
		label: 'Witu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Gazi',
		label: 'Gazi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mitoto-Andei',
		label: 'Mitoto-Andei, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Maragua',
		label: 'Maragua, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Rumuruti',
		label: 'Rumuruti, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Suneka',
		label: 'Suneka, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Londiani',
		label: 'Londiani, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Malakisi',
		label: 'Malakisi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Keroka',
		label: 'Keroka, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyansiongo',
		label: 'Nyansiongo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Vanga',
		label: 'Vanga, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Burnt Forest',
		label: 'Burnt Forest, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kipkelion',
		label: 'Kipkelion, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Chogoria',
		label: 'Chogoria, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Mado Gashi',
		label: 'Mado Gashi, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Yala',
		label: 'Yala, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyamache',
		label: 'Nyamache, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Shimoni',
		label: 'Shimoni, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Konza',
		label: 'Konza, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Masimba',
		label: 'Masimba, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ogembo',
		label: 'Ogembo, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nambale',
		label: 'Nambale, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Chepareria',
		label: 'Chepareria, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kandara',
		label: 'Kandara, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Sirisia',
		label: 'Sirisia, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ukwala',
		label: 'Ukwala, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kendu Bay',
		label: 'Kendu Bay, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Nyamarambe',
		label: 'Nyamarambe, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Makuyu',
		label: 'Makuyu, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Ruiru',
		label: 'Ruiru, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Wajir',
		label: 'Wajir, Kenya',
		type: 'city',
		flagClass: 'fi fi-ke',
		isPopular: false,
	},
	{
		value: 'Kiribati',
		label: 'Kiribati',
		type: 'country',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Bairiki',
		label: 'Bairiki, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Bikenibeu',
		label: 'Bikenibeu, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Abaokoro',
		label: 'Abaokoro, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Ooma',
		label: 'Ooma, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Pyramid Point',
		label: 'Pyramid Point, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Bonriki',
		label: 'Bonriki, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Rawannawi',
		label: 'Rawannawi, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Utiroa',
		label: 'Utiroa, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Tabontebike',
		label: 'Tabontebike, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Binoinano',
		label: 'Binoinano, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Nabari',
		label: 'Nabari, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Taburao',
		label: 'Taburao, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Butaritari',
		label: 'Butaritari, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Buariki',
		label: 'Buariki, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Tabukiniberu',
		label: 'Tabukiniberu, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Teraina',
		label: 'Teraina, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Temaraia',
		label: 'Temaraia, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Tabiauea',
		label: 'Tabiauea, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Rungata',
		label: 'Rungata, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Ijaki',
		label: 'Ijaki, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Makin',
		label: 'Makin, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Roreti',
		label: 'Roreti, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: 'Takaeang',
		label: 'Takaeang, Kiribati',
		type: 'city',
		flagClass: 'fi fi-ki',
		isPopular: false,
	},
	{
		value: "Korea, Democratic People's Republic of",
		label: "Korea, Democratic People's Republic of",
		type: 'country',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Pyeongyang',
		label: "Pyeongyang, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Cheongjin',
		label: "Cheongjin, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Phyeongseong',
		label: "Phyeongseong, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Hamheung',
		label: "Hamheung, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Hyesan',
		label: "Hyesan, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Nampo',
		label: "Nampo, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Sineuiju',
		label: "Sineuiju, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Weonsan',
		label: "Weonsan, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Sariweon',
		label: "Sariweon, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Haeju',
		label: "Haeju, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Kanggye',
		label: "Kanggye, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Kimchaek',
		label: "Kimchaek, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Kaeseong',
		label: "Kaeseong, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Seongnim',
		label: "Seongnim, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Najin',
		label: "Najin, Korea, Democratic People's Republic of",
		type: 'city',
		flagClass: 'fi fi-kp',
		isPopular: false,
	},
	{
		value: 'Korea, Republic of',
		label: 'Korea, Republic of',
		type: 'country',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seoul',
		label: 'Seoul, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pusan',
		label: 'Pusan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Incheon',
		label: 'Incheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Suwon',
		label: 'Suwon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Taegu',
		label: 'Taegu, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pyeongtaek',
		label: 'Pyeongtaek, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Anyang',
		label: 'Anyang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Cheonan',
		label: 'Cheonan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Aeweol',
		label: 'Aeweol, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yongin',
		label: 'Yongin, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Ansan',
		label: 'Ansan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Ulsan',
		label: 'Ulsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Osan',
		label: 'Osan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Taejeon',
		label: 'Taejeon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seongnam',
		label: 'Seongnam, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hanam',
		label: 'Hanam, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Tongducheon',
		label: 'Tongducheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kwangju',
		label: 'Kwangju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Koyang',
		label: 'Koyang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pohang',
		label: 'Pohang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Icheon',
		label: 'Icheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Euijeongbu',
		label: 'Euijeongbu, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Cheju',
		label: 'Cheju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pucheon',
		label: 'Pucheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Cheongju',
		label: 'Cheongju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Namyangju',
		label: 'Namyangju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chuncheon',
		label: 'Chuncheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Anseong',
		label: 'Anseong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Cheonju',
		label: 'Cheonju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Mokpo',
		label: 'Mokpo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kunsan',
		label: 'Kunsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Changweon',
		label: 'Changweon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Asan',
		label: 'Asan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Waegwan',
		label: 'Waegwan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kunpo',
		label: 'Kunpo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kimpo',
		label: 'Kimpo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yangsan',
		label: 'Yangsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pochon',
		label: 'Pochon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Iksan',
		label: 'Iksan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Shiheung',
		label: 'Shiheung, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chungju',
		label: 'Chungju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kumi',
		label: 'Kumi, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Weonju',
		label: 'Weonju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chinhae',
		label: 'Chinhae, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Masan',
		label: 'Masan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Andong',
		label: 'Andong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seogwipo',
		label: 'Seogwipo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seosan',
		label: 'Seosan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Geoje',
		label: 'Geoje, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeoju',
		label: 'Yeoju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kimhae',
		label: 'Kimhae, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Euiwang',
		label: 'Euiwang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeongju',
		label: 'Yeongju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Sacheon',
		label: 'Sacheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Nonsan',
		label: 'Nonsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Paengseong',
		label: 'Paengseong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kwangmyeong',
		label: 'Kwangmyeong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeosu',
		label: 'Yeosu, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Suncheon',
		label: 'Suncheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chechon',
		label: 'Chechon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Tongyeong',
		label: 'Tongyeong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kyeongsan',
		label: 'Kyeongsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kwangyang',
		label: 'Kwangyang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeongcheon',
		label: 'Yeongcheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Angang',
		label: 'Angang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seonghwan',
		label: 'Seonghwan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hwasun',
		label: 'Hwasun, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Koseong',
		label: 'Koseong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kanghwa',
		label: 'Kanghwa, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Puan',
		label: 'Puan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chinju',
		label: 'Chinju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kuri',
		label: 'Kuri, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kangneung',
		label: 'Kangneung, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kyeongju',
		label: 'Kyeongju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kimcheon',
		label: 'Kimcheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kihung',
		label: 'Kihung, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Taebaek',
		label: 'Taebaek, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Miryang',
		label: 'Miryang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hoechon',
		label: 'Hoechon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Munsan',
		label: 'Munsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chochiwon',
		label: 'Chochiwon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Naju',
		label: 'Naju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Taean',
		label: 'Taean, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Okchon',
		label: 'Okchon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Naeso',
		label: 'Naeso, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Tangjin',
		label: 'Tangjin, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kumsan',
		label: 'Kumsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yongdong',
		label: 'Yongdong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chincheon',
		label: 'Chincheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seonsan',
		label: 'Seonsan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Poryong',
		label: 'Poryong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Tonghae',
		label: 'Tonghae, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kwacheon',
		label: 'Kwacheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Seokcho',
		label: 'Seokcho, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeocheon',
		label: 'Yeocheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chongup',
		label: 'Chongup, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kongju',
		label: 'Kongju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Namwon',
		label: 'Namwon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Sangju',
		label: 'Sangju, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Ungsang',
		label: 'Ungsang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Mungyong',
		label: 'Mungyong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kimje',
		label: 'Kimje, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Sinhyeon',
		label: 'Sinhyeon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Nongso',
		label: 'Nongso, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kumchon',
		label: 'Kumchon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Samchok',
		label: 'Samchok, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yesan',
		label: 'Yesan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kochang',
		label: 'Kochang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Pubal',
		label: 'Pubal, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hongseong',
		label: 'Hongseong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kwangyang Up',
		label: 'Kwangyang Up, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Ochon',
		label: 'Ochon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Heunghae',
		label: 'Heunghae, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hwawon',
		label: 'Hwawon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hwado',
		label: 'Hwado, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Wabu',
		label: 'Wabu, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chinjop',
		label: 'Chinjop, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Puyeo',
		label: 'Puyeo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kijang',
		label: 'Kijang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hayang',
		label: 'Hayang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Hongcheon',
		label: 'Hongcheon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chinyeong',
		label: 'Chinyeong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Chongok',
		label: 'Chongok, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeongweol',
		label: 'Yeongweol, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yonmu',
		label: 'Yonmu, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Haenam',
		label: 'Haenam, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Taesan',
		label: 'Taesan, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yeonil',
		label: 'Yeonil, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yechon',
		label: 'Yechon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Oedong',
		label: 'Oedong, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Peolgyo',
		label: 'Peolgyo, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Yonggwang',
		label: 'Yonggwang, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Daejeon',
		label: 'Daejeon, Korea, Republic of',
		type: 'city',
		flagClass: 'fi fi-kr',
		isPopular: false,
	},
	{
		value: 'Kuwait',
		label: 'Kuwait',
		type: 'country',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Kuwayt',
		label: 'al-Kuwayt, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'as-Salimiyah',
		label: 'as-Salimiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Hawalli',
		label: 'Hawalli, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Abraq Khitan',
		label: 'Abraq Khitan, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: "Salwa'",
		label: "Salwa', Kuwait",
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Jabiriyah',
		label: 'al-Jabiriyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Farwaniyah',
		label: 'al-Farwaniyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Ahmadi',
		label: 'al-Ahmadi, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Manqaf',
		label: 'al-Manqaf, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Mahbulah',
		label: 'al-Mahbulah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Fintas',
		label: 'al-Fintas, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ar-Rumaythiyah',
		label: 'ar-Rumaythiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Bayan',
		label: 'Bayan, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Kayfan',
		label: 'Kayfan, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Jalib ash-Shuyuh',
		label: 'Jalib ash-Shuyuh, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ar-Rawdah',
		label: 'ar-Rawdah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Abu Hulayfah',
		label: 'Abu Hulayfah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Fayha',
		label: 'al-Fayha, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Fuhayhil',
		label: 'al-Fuhayhil, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Janub-as-Surrah',
		label: 'Janub-as-Surrah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Subbah-as-Salim',
		label: 'Subbah-as-Salim, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Jahra',
		label: 'al-Jahra, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ad-Da´iyah',
		label: 'ad-Da´iyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ash-Shuwaykh Reservoir',
		label: 'ash-Shuwaykh Reservoir, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Ardiyah',
		label: 'Ardiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Dahar',
		label: 'Dahar, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Qusayr',
		label: 'al-Qusayr, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: "ad-Dasma'",
		label: "ad-Dasma', Kuwait",
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ash-Shuwaykh Industrial',
		label: 'ash-Shuwaykh Industrial, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'as-Sabahiyah',
		label: 'as-Sabahiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Tayma´',
		label: 'Tayma´, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ar-Riqqah',
		label: 'ar-Riqqah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'as-Sulaybihat',
		label: 'as-Sulaybihat, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-´Udayliyah',
		label: 'al-´Udayliyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Wafrah',
		label: 'al-Wafrah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Khitan-al-Janubiyah',
		label: 'Khitan-al-Janubiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'as-Sulaybiyah',
		label: 'as-Sulaybiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Waha',
		label: 'Waha, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Jabbar-al-´Ali',
		label: 'Jabbar-al-´Ali, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'az-Zawr',
		label: 'az-Zawr, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Funaytis',
		label: 'al-Funaytis, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Karim',
		label: 'al-Karim, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Fardaws',
		label: 'Fardaws, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'ar-Rabbiyah',
		label: 'ar-Rabbiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'al-Funaytis-al-Garbiyah',
		label: 'al-Funaytis-al-Garbiyah, Kuwait',
		type: 'city',
		flagClass: 'fi fi-kw',
		isPopular: false,
	},
	{
		value: 'Kyrgyzstan',
		label: 'Kyrgyzstan',
		type: 'country',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Bishkek',
		label: 'Bishkek, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Chat-Bazar',
		label: 'Chat-Bazar, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ak-Bulok',
		label: 'Ak-Bulok, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Teploklyuchenka',
		label: 'Teploklyuchenka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Osh',
		label: 'Osh, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Jalal-Abad',
		label: 'Jalal-Abad, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Karakol',
		label: 'Karakol, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kant',
		label: 'Kant, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Bazarkurgon',
		label: 'Bazarkurgon, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Chui',
		label: 'Chui, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Sulukta',
		label: 'Sulukta, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Grigoryevka',
		label: 'Grigoryevka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Jyrgolon',
		label: 'Jyrgolon, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Chaldovar',
		label: 'Chaldovar, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Sosnovka',
		label: 'Sosnovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Karabalta',
		label: 'Karabalta, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Tokmok',
		label: 'Tokmok, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Uzgen',
		label: 'Uzgen, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Balykchy',
		label: 'Balykchy, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Naryn',
		label: 'Naryn, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Talas',
		label: 'Talas, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kyzyl-Kiya',
		label: 'Kyzyl-Kiya, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Tash-Kumyr',
		label: 'Tash-Kumyr, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kara-Suu',
		label: 'Kara-Suu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Mingkush',
		label: 'Mingkush, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Sokuluk',
		label: 'Sokuluk, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kemin',
		label: 'Kemin, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Belovodskoye',
		label: 'Belovodskoye, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Mailuu-Suu',
		label: 'Mailuu-Suu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kosh Tegirmen',
		label: 'Kosh Tegirmen, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kalininskoye',
		label: 'Kalininskoye, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Toktogul',
		label: 'Toktogul, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'At-Bashi',
		label: 'At-Bashi, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kyzyl-Suu',
		label: 'Kyzyl-Suu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Isfana',
		label: 'Isfana, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kochkor-Ata',
		label: 'Kochkor-Ata, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kyzyl-Tuu',
		label: 'Kyzyl-Tuu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ivanovka',
		label: 'Ivanovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Orlovka',
		label: 'Orlovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Tyup',
		label: 'Tyup, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Bashkaingdy',
		label: 'Bashkaingdy, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Cholpon-Ata',
		label: 'Cholpon-Ata, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Krasnaya Rechka',
		label: 'Krasnaya Rechka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Sopokov',
		label: 'Sopokov, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Khaidarkan',
		label: 'Khaidarkan, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Leninopol',
		label: 'Leninopol, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ak-Suu',
		label: 'Ak-Suu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Karavan',
		label: 'Karavan, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kok-Jangak',
		label: 'Kok-Jangak, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kayingdi',
		label: 'Kayingdi, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kayirma',
		label: 'Kayirma, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Boroldoy',
		label: 'Boroldoy, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Leninskoye',
		label: 'Leninskoye, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Minbulok',
		label: 'Minbulok, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Batken',
		label: 'Batken, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Jangybazar',
		label: 'Jangybazar, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ala Buka',
		label: 'Ala Buka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ottuk',
		label: 'Ottuk, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Chaiek',
		label: 'Chaiek, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kochkorka',
		label: 'Kochkorka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Maimak',
		label: 'Maimak, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Jangyjar',
		label: 'Jangyjar, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kyzyl-Adyr',
		label: 'Kyzyl-Adyr, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Klyuchevka',
		label: 'Klyuchevka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kalinovka',
		label: 'Kalinovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Mihaylov',
		label: 'Mihaylov, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ananyevo',
		label: 'Ananyevo, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Darkhon',
		label: 'Darkhon, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kuturgu',
		label: 'Kuturgu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Ak-Terek',
		label: 'Ak-Terek, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Jangypakhtar',
		label: 'Jangypakhtar, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Taldy-Suu',
		label: 'Taldy-Suu, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Karako',
		label: 'Karako, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kulanak',
		label: 'Kulanak, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Semyonovka',
		label: 'Semyonovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Don Arik',
		label: 'Don Arik, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Kegety',
		label: 'Kegety, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Novovoznesenovka',
		label: 'Novovoznesenovka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Yuryevka',
		label: 'Yuryevka, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Groznoye',
		label: 'Groznoye, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Barskoon',
		label: 'Barskoon, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: 'Chatkyol',
		label: 'Chatkyol, Kyrgyzstan',
		type: 'city',
		flagClass: 'fi fi-kg',
		isPopular: false,
	},
	{
		value: "Lao People's Democratic Republic",
		label: "Lao People's Democratic Republic",
		type: 'country',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Viangchan',
		label: "Viangchan, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Luang Prabang',
		label: "Luang Prabang, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Pakxe',
		label: "Pakxe, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Thakek',
		label: "Thakek, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Muang Sing',
		label: "Muang Sing, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Xaignabury',
		label: "Xaignabury, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Champasak',
		label: "Champasak, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Phonhong',
		label: "Phonhong, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Savannakhet',
		label: "Savannakhet, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Xam Nua',
		label: "Xam Nua, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Attopu',
		label: "Attopu, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Pakxan',
		label: "Pakxan, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Luang Nam Tha',
		label: "Luang Nam Tha, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Pek',
		label: "Pek, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Saravan',
		label: "Saravan, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Phongsaly',
		label: "Phongsaly, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Huayxay',
		label: "Huayxay, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Muang Khongxedon',
		label: "Muang Khongxedon, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Muang Khong',
		label: "Muang Khong, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Muang Vangviang',
		label: "Muang Vangviang, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Ban Donkon',
		label: "Ban Donkon, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Sekong',
		label: "Sekong, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Ban Nahin',
		label: "Ban Nahin, Lao People's Democratic Republic",
		type: 'city',
		flagClass: 'fi fi-la',
		isPopular: false,
	},
	{
		value: 'Latvia',
		label: 'Latvia',
		type: 'country',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Riga',
		label: 'Riga, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Jelgava',
		label: 'Jelgava, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ainazhi',
		label: 'Ainazhi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Jurmala',
		label: 'Jurmala, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Liepaja',
		label: 'Liepaja, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Kuldiga',
		label: 'Kuldiga, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Rêzekne',
		label: 'Rêzekne, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Aizkraukle',
		label: 'Aizkraukle, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Balvi',
		label: 'Balvi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Daugavpils',
		label: 'Daugavpils, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ventspils',
		label: 'Ventspils, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Jêkabspils',
		label: 'Jêkabspils, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Cêsis',
		label: 'Cêsis, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Limbazhi',
		label: 'Limbazhi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Salaspils',
		label: 'Salaspils, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Talsi',
		label: 'Talsi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Dobele',
		label: 'Dobele, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Sigulda',
		label: 'Sigulda, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Bauska',
		label: 'Bauska, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Madona',
		label: 'Madona, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Kandava',
		label: 'Kandava, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ikshkile',
		label: 'Ikshkile, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Rujiena',
		label: 'Rujiena, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Saulkrasti',
		label: 'Saulkrasti, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Salacgriva',
		label: 'Salacgriva, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Viesite',
		label: 'Viesite, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Lubana',
		label: 'Lubana, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Valmiera',
		label: 'Valmiera, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ogre',
		label: 'Ogre, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Tukums',
		label: 'Tukums, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Olaine',
		label: 'Olaine, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Saldus',
		label: 'Saldus, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Kraslava',
		label: 'Kraslava, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ludza',
		label: 'Ludza, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Livani',
		label: 'Livani, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Aluksne',
		label: 'Aluksne, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Gulbene',
		label: 'Gulbene, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Preili',
		label: 'Preili, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Valka',
		label: 'Valka, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Aizpute',
		label: 'Aizpute, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Smiltene',
		label: 'Smiltene, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Lielvarde',
		label: 'Lielvarde, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Grobina',
		label: 'Grobina, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Vilani',
		label: 'Vilani, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Balozhi',
		label: 'Balozhi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Vangazhi',
		label: 'Vangazhi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Plavinas',
		label: 'Plavinas, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Auce',
		label: 'Auce, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ilukste',
		label: 'Ilukste, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Dagda',
		label: 'Dagda, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Brocêni',
		label: 'Brocêni, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Priekule',
		label: 'Priekule, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Skrunda',
		label: 'Skrunda, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Karsava',
		label: 'Karsava, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Kegums',
		label: 'Kegums, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Varaklani',
		label: 'Varaklani, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Kalnciems',
		label: 'Kalnciems, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Zilupe',
		label: 'Zilupe, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Strenchi',
		label: 'Strenchi, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Baldone',
		label: 'Baldone, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Jaunjelgava',
		label: 'Jaunjelgava, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Stende',
		label: 'Stende, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Vilaka',
		label: 'Vilaka, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Cesvaine',
		label: 'Cesvaine, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Mazsalaca',
		label: 'Mazsalaca, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Seda',
		label: 'Seda, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Sabile',
		label: 'Sabile, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ape',
		label: 'Ape, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Akniste',
		label: 'Akniste, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Aloja',
		label: 'Aloja, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Ligatne',
		label: 'Ligatne, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Staicele',
		label: 'Staicele, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Pavilosta',
		label: 'Pavilosta, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Valdemarpils',
		label: 'Valdemarpils, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Piltene',
		label: 'Piltene, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Subate',
		label: 'Subate, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Durbe',
		label: 'Durbe, Latvia',
		type: 'city',
		flagClass: 'fi fi-lv',
		isPopular: false,
	},
	{
		value: 'Lebanon',
		label: 'Lebanon',
		type: 'country',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Beirut',
		label: 'Beirut, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Juniyah',
		label: 'Juniyah, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'al-Batrun',
		label: 'al-Batrun, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Tarabulus',
		label: 'Tarabulus, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: "Sayda'",
		label: "Sayda', Lebanon",
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Jubayl',
		label: 'Jubayl, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'B´abda',
		label: 'B´abda, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: '´Alayh',
		label: '´Alayh, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Sur',
		label: 'Sur, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Ba´labakk',
		label: 'Ba´labakk, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Zahlah',
		label: 'Zahlah, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'al-Hirmil',
		label: 'al-Hirmil, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Riyak',
		label: 'Riyak, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Marj ´Uyun',
		label: 'Marj ´Uyun, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Jazzin',
		label: 'Jazzin, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Rashayya',
		label: 'Rashayya, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'an-Nabatiyat-at-Tahta',
		label: 'an-Nabatiyat-at-Tahta, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Jubb Jannin',
		label: 'Jubb Jannin, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Juwayya',
		label: 'Juwayya, Lebanon',
		type: 'city',
		flagClass: 'fi fi-lb',
		isPopular: false,
	},
	{
		value: 'Lesotho',
		label: 'Lesotho',
		type: 'country',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Maseru',
		label: 'Maseru, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Butha Buthe',
		label: 'Butha Buthe, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: "Qacha's Nek",
		label: "Qacha's Nek, Lesotho",
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Quthing',
		label: 'Quthing, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Teyateyaneng',
		label: 'Teyateyaneng, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Maputsoa',
		label: 'Maputsoa, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Mafeteng',
		label: 'Mafeteng, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Hlotse',
		label: 'Hlotse, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: "Mohale's Hoek",
		label: "Mohale's Hoek, Lesotho",
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Mokhotlong',
		label: 'Mokhotlong, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Thaba-Tseka',
		label: 'Thaba-Tseka, Lesotho',
		type: 'city',
		flagClass: 'fi fi-ls',
		isPopular: false,
	},
	{
		value: 'Liberia',
		label: 'Liberia',
		type: 'country',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Monrovia',
		label: 'Monrovia, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Barclayville',
		label: 'Barclayville, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Harbel',
		label: 'Harbel, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Zwedru',
		label: 'Zwedru, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Ganta',
		label: 'Ganta, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Harper',
		label: 'Harper, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Gbarnga',
		label: 'Gbarnga, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Greenville',
		label: 'Greenville, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Voinjama',
		label: 'Voinjama, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Buchanan',
		label: 'Buchanan, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Yekepa',
		label: 'Yekepa, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Bensonville',
		label: 'Bensonville, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Tubmanburg',
		label: 'Tubmanburg, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Robertsport',
		label: 'Robertsport, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Tapeta',
		label: 'Tapeta, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Sanniquellie',
		label: 'Sanniquellie, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Kakata',
		label: 'Kakata, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Rivercess',
		label: 'Rivercess, Liberia',
		type: 'city',
		flagClass: 'fi fi-lr',
		isPopular: false,
	},
	{
		value: 'Libya',
		label: 'Libya',
		type: 'country',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Tripoli',
		label: 'Tripoli, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Banghazi',
		label: 'Banghazi, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Ajdabiya',
		label: 'Ajdabiya, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'az-Zawiyah',
		label: 'az-Zawiyah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Misratah',
		label: 'Misratah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Bayda',
		label: 'al-Bayda, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Sabha',
		label: 'Sabha, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Ghadamis',
		label: 'Ghadamis, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Gharyan',
		label: 'Gharyan, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Tubruq',
		label: 'Tubruq, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Waddan',
		label: 'Waddan, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Khums',
		label: 'al-Khums, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Yafran',
		label: 'Yafran, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Tarhunah',
		label: 'Tarhunah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Darnah',
		label: 'Darnah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Sabratah',
		label: 'Sabratah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Nalut',
		label: 'Nalut, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Mizdah',
		label: 'Mizdah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Suluq',
		label: 'Suluq, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Bardiyah',
		label: 'Bardiyah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Marj',
		label: 'al-Marj, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Zlitan',
		label: 'Zlitan, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Awbari',
		label: 'Awbari, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Surt',
		label: 'Surt, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Aziziyah',
		label: 'al-Aziziyah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Murzuq',
		label: 'Murzuq, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Bani Walid',
		label: 'Bani Walid, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Zuwarah',
		label: 'Zuwarah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Shahhat',
		label: 'Shahhat, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Birak',
		label: 'Birak, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Abyar',
		label: 'al-Abyar, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Quriyah',
		label: 'al-Quriyah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'az-Zuwaytinah',
		label: 'az-Zuwaytinah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Ghat',
		label: 'Ghat, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Jawf',
		label: 'al-Jawf, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Awjilah',
		label: 'Awjilah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Marsa al-Burayqah',
		label: 'Marsa al-Burayqah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'al-Qaryah-ash-Sharqiyah',
		label: 'al-Qaryah-ash-Sharqiyah, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Zaltan',
		label: 'Zaltan, Libya',
		type: 'city',
		flagClass: 'fi fi-ly',
		isPopular: false,
	},
	{
		value: 'Liechtenstein',
		label: 'Liechtenstein',
		type: 'country',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Balzers',
		label: 'Balzers, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Vaduz',
		label: 'Vaduz, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Schaan',
		label: 'Schaan, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Eschen',
		label: 'Eschen, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Triesen',
		label: 'Triesen, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Mauren',
		label: 'Mauren, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Triesenberg',
		label: 'Triesenberg, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Ruggell',
		label: 'Ruggell, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Gamprin',
		label: 'Gamprin, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Selimbar',
		label: 'Selimbar, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Planken',
		label: 'Planken, Liechtenstein',
		type: 'city',
		flagClass: 'fi fi-li',
		isPopular: false,
	},
	{
		value: 'Lithuania',
		label: 'Lithuania',
		type: 'country',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Vilnius',
		label: 'Vilnius, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kaunas',
		label: 'Kaunas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Klaipeda',
		label: 'Klaipeda, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shiauliai',
		label: 'Shiauliai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Akmene',
		label: 'Akmene, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Alytus',
		label: 'Alytus, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Panevezhys',
		label: 'Panevezhys, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Ukmerge',
		label: 'Ukmerge, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Marijampole',
		label: 'Marijampole, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Palanga',
		label: 'Palanga, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Visaginas',
		label: 'Visaginas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Taurage',
		label: 'Taurage, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shilute',
		label: 'Shilute, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Druskininkai',
		label: 'Druskininkai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Moletai',
		label: 'Moletai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Trakai',
		label: 'Trakai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Ariogala',
		label: 'Ariogala, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Mazheikiai',
		label: 'Mazheikiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Jonava',
		label: 'Jonava, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Utena',
		label: 'Utena, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Plunge',
		label: 'Plunge, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Birzhai',
		label: 'Birzhai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Gargzhdai',
		label: 'Gargzhdai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kurshenai',
		label: 'Kurshenai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Jurbarkas',
		label: 'Jurbarkas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Vilkavishkis',
		label: 'Vilkavishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Grigishkes',
		label: 'Grigishkes, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Skuodas',
		label: 'Skuodas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Pakruojis',
		label: 'Pakruojis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Neringa',
		label: 'Neringa, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Pagegiai',
		label: 'Pagegiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Vilkija',
		label: 'Vilkija, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kedainiai',
		label: 'Kedainiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Telshiai',
		label: 'Telshiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kretinga',
		label: 'Kretinga, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Radvilishkis',
		label: 'Radvilishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Rokishkis',
		label: 'Rokishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Elektrenai',
		label: 'Elektrenai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Garliava',
		label: 'Garliava, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Raseiniai',
		label: 'Raseiniai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Naujoji Akmene',
		label: 'Naujoji Akmene, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Anykshchiai',
		label: 'Anykshchiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Lentvaris',
		label: 'Lentvaris, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Jonishkis',
		label: 'Jonishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Prienai',
		label: 'Prienai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kelme',
		label: 'Kelme, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Varena',
		label: 'Varena, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kaishiadorys',
		label: 'Kaishiadorys, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Pasvalys',
		label: 'Pasvalys, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kupishkis',
		label: 'Kupishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Zarasai',
		label: 'Zarasai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kazlu Ruda',
		label: 'Kazlu Ruda, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shirvintos',
		label: 'Shirvintos, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shvenchioneliai',
		label: 'Shvenchioneliai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shakiai',
		label: 'Shakiai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shalchininkai',
		label: 'Shalchininkai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kybartai',
		label: 'Kybartai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Ignalina',
		label: 'Ignalina, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Pabrade',
		label: 'Pabrade, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shilale',
		label: 'Shilale, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Nemenchine',
		label: 'Nemenchine, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Shvenchionys',
		label: 'Shvenchionys, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Vievis',
		label: 'Vievis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Lazdijai',
		label: 'Lazdijai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kalvarija',
		label: 'Kalvarija, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Rietavas',
		label: 'Rietavas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Zhiezhmariai',
		label: 'Zhiezhmariai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Eishishkes',
		label: 'Eishishkes, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Sheduva',
		label: 'Sheduva, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Venta',
		label: 'Venta, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Birshtonas',
		label: 'Birshtonas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Tytuvenai',
		label: 'Tytuvenai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Rudishkes',
		label: 'Rudishkes, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Rusne',
		label: 'Rusne, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Viekshniai',
		label: 'Viekshniai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Zhagare',
		label: 'Zhagare, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Ezherelis',
		label: 'Ezherelis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Skaudvile',
		label: 'Skaudvile, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Gelgaudishkis',
		label: 'Gelgaudishkis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Juodupe',
		label: 'Juodupe, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kudirkos Naumiestis',
		label: 'Kudirkos Naumiestis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Simnas',
		label: 'Simnas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Salantai',
		label: 'Salantai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Linkuva',
		label: 'Linkuva, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Veisiejai',
		label: 'Veisiejai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Priekule',
		label: 'Priekule, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Ramygala',
		label: 'Ramygala, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Zhemaichiu Naumiestis',
		label: 'Zhemaichiu Naumiestis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Jieznas',
		label: 'Jieznas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Jonishkelis',
		label: 'Jonishkelis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Daugai',
		label: 'Daugai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kulautuva',
		label: 'Kulautuva, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Obeliai',
		label: 'Obeliai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Varniai',
		label: 'Varniai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Virbalis',
		label: 'Virbalis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Seda',
		label: 'Seda, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Vabalninkas',
		label: 'Vabalninkas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Subachius',
		label: 'Subachius, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Baltoji Voke',
		label: 'Baltoji Voke, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Dukshtas',
		label: 'Dukshtas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Pandelys',
		label: 'Pandelys, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Dusetos',
		label: 'Dusetos, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Uzhventis',
		label: 'Uzhventis, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Dotnuva',
		label: 'Dotnuva, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kavarskas',
		label: 'Kavarskas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Kachergine',
		label: 'Kachergine, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Smalininkai',
		label: 'Smalininkai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Troshkunai',
		label: 'Troshkunai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Tyruliai',
		label: 'Tyruliai, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Panemune',
		label: 'Panemune, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Turmantas',
		label: 'Turmantas, Lithuania',
		type: 'city',
		flagClass: 'fi fi-lt',
		isPopular: false,
	},
	{
		value: 'Luxembourg',
		label: 'Luxembourg',
		type: 'country',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Luxembourg',
		label: 'Luxembourg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Abweiler',
		label: 'Abweiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Esch-Alzette',
		label: 'Esch-Alzette, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mamer',
		label: 'Mamer, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bereldange',
		label: 'Bereldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hesperange',
		label: 'Hesperange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Howald',
		label: 'Howald, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bettembourg',
		label: 'Bettembourg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Strassen',
		label: 'Strassen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bertrange',
		label: 'Bertrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kayl',
		label: 'Kayl, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Grevenmacher',
		label: 'Grevenmacher, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Steinsel',
		label: 'Steinsel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dudelange',
		label: 'Dudelange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Remich',
		label: 'Remich, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mondorf-les-Bains',
		label: 'Mondorf-les-Bains, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bridel',
		label: 'Bridel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Sanem',
		label: 'Sanem, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Niederanven',
		label: 'Niederanven, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wickrange',
		label: 'Wickrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wecker',
		label: 'Wecker, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Münsbach',
		label: 'Münsbach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Schifflange',
		label: 'Schifflange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Pétange',
		label: 'Pétange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Echternach',
		label: 'Echternach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mersch',
		label: 'Mersch, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Sandweiler',
		label: 'Sandweiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Steinfort',
		label: 'Steinfort, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Clemency',
		label: 'Clemency, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Leudelange',
		label: 'Leudelange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kehlen',
		label: 'Kehlen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Oetrange',
		label: 'Oetrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Nospelt',
		label: 'Nospelt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wormeldange',
		label: 'Wormeldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Ehlerange',
		label: 'Ehlerange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Medingen',
		label: 'Medingen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Uebersyren',
		label: 'Uebersyren, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Calmus',
		label: 'Calmus, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Platen',
		label: 'Platen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wellenstein',
		label: 'Wellenstein, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Noerdange',
		label: 'Noerdange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bockholtz',
		label: 'Bockholtz, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Alscheid',
		label: 'Alscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Christnach',
		label: 'Christnach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Oberpallen',
		label: 'Oberpallen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Zittig',
		label: 'Zittig, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Ell',
		label: 'Ell, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Betzdorf',
		label: 'Betzdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Nocher',
		label: 'Nocher, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Differdange',
		label: 'Differdange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Soleuvre',
		label: 'Soleuvre, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Roodt',
		label: 'Roodt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bascharage',
		label: 'Bascharage, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Obercorn',
		label: 'Obercorn, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rodange',
		label: 'Rodange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mondercange',
		label: 'Mondercange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Itzig',
		label: 'Itzig, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Lintgen',
		label: 'Lintgen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Senningerberg',
		label: 'Senningerberg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Gonderange',
		label: 'Gonderange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dondelange',
		label: 'Dondelange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Moutfort',
		label: 'Moutfort, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Contern',
		label: 'Contern, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Koerich',
		label: 'Koerich, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Aspelt',
		label: 'Aspelt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Noertzange',
		label: 'Noertzange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Tadler-Ringel-Dirbach',
		label: 'Tadler-Ringel-Dirbach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Winseler',
		label: 'Winseler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kleinbettingen',
		label: 'Kleinbettingen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dippach',
		label: 'Dippach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hosingen',
		label: 'Hosingen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Colpach-Bas',
		label: 'Colpach-Bas, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dellen-Lehrhof-Grevels',
		label: 'Dellen-Lehrhof-Grevels, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Lorentzweiler',
		label: 'Lorentzweiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Girst',
		label: 'Girst, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hoesdorf',
		label: 'Hoesdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Walferdange',
		label: 'Walferdange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hoscheid-Dickt',
		label: 'Hoscheid-Dickt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Vichten',
		label: 'Vichten, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kehmen-Scheidel',
		label: 'Kehmen-Scheidel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Roeser',
		label: 'Roeser, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Stadtbredimus',
		label: 'Stadtbredimus, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Marienthal',
		label: 'Marienthal, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Oberanven',
		label: 'Oberanven, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Michelbouch',
		label: 'Michelbouch, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rameldange',
		label: 'Rameldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rippig',
		label: 'Rippig, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rosport',
		label: 'Rosport, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rodenbourg',
		label: 'Rodenbourg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Brouch',
		label: 'Brouch, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bourglinster',
		label: 'Bourglinster, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dickweiler',
		label: 'Dickweiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Elvange',
		label: 'Elvange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Findel',
		label: 'Findel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kopstal',
		label: 'Kopstal, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Lannen',
		label: 'Lannen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Weiswampach',
		label: 'Weiswampach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Biwisch',
		label: 'Biwisch, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Beckerich',
		label: 'Beckerich, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Breidweiler',
		label: 'Breidweiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Remerschen',
		label: 'Remerschen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Graulinster-Blumenthal',
		label: 'Graulinster-Blumenthal, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Berbourg',
		label: 'Berbourg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Grosbous',
		label: 'Grosbous, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Useldange',
		label: 'Useldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mompach',
		label: 'Mompach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Helmdange',
		label: 'Helmdange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Prettange',
		label: 'Prettange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Perlé',
		label: 'Perlé, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Beiler',
		label: 'Beiler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Biwer',
		label: 'Biwer, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Berg',
		label: 'Berg, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hellange',
		label: 'Hellange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Dorscheid',
		label: 'Dorscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Emerange',
		label: 'Emerange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bivange',
		label: 'Bivange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Lellingen',
		label: 'Lellingen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Heffingen',
		label: 'Heffingen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Merckholtz',
		label: 'Merckholtz, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Huncherange',
		label: 'Huncherange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Petit-Nobressart',
		label: 'Petit-Nobressart, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Reckange',
		label: 'Reckange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Rodershausen',
		label: 'Rodershausen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Tuntange',
		label: 'Tuntange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Savelborn-Fermes',
		label: 'Savelborn-Fermes, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Lener',
		label: 'Lener, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wallendorf',
		label: 'Wallendorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Watrange',
		label: 'Watrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Greiveldange',
		label: 'Greiveldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Holler',
		label: 'Holler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Peppange',
		label: 'Peppange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Tandel',
		label: 'Tandel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Altwies',
		label: 'Altwies, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Boevange',
		label: 'Boevange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bigelbach',
		label: 'Bigelbach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Keispelt',
		label: 'Keispelt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bivels',
		label: 'Bivels, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Reckange-sur-Mess',
		label: 'Reckange-sur-Mess, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bech-Kleinmacher',
		label: 'Bech-Kleinmacher, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Givenich',
		label: 'Givenich, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Steinheim',
		label: 'Steinheim, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Heispelt',
		label: 'Heispelt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Holzem',
		label: 'Holzem, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hemstal',
		label: 'Hemstal, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bous',
		label: 'Bous, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hinkel',
		label: 'Hinkel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Wormeldange-Haut',
		label: 'Wormeldange-Haut, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Landscheid',
		label: 'Landscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Leithum',
		label: 'Leithum, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Ehnen',
		label: 'Ehnen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Liefrange',
		label: 'Liefrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Reisdorf',
		label: 'Reisdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Longsdorf',
		label: 'Longsdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Weiler-la-Tour',
		label: 'Weiler-la-Tour, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Boudler',
		label: 'Boudler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Foetz',
		label: 'Foetz, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bour',
		label: 'Bour, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bigonville',
		label: 'Bigonville, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Grass',
		label: 'Grass, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Blaschette',
		label: 'Blaschette, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kuborn',
		label: 'Kuborn, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Nachtmanderscheid',
		label: 'Nachtmanderscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Bürden',
		label: 'Bürden, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Neunhausen',
		label: 'Neunhausen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Godbrange',
		label: 'Godbrange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Pissange',
		label: 'Pissange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Gosseldange',
		label: 'Gosseldange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Roder',
		label: 'Roder, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Troine-Route',
		label: 'Troine-Route, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Scheidgen',
		label: 'Scheidgen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Walsdorf',
		label: 'Walsdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hassel',
		label: 'Hassel, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Allerborn',
		label: 'Allerborn, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Goeblange',
		label: 'Goeblange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Marnach',
		label: 'Marnach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Grümelscheid',
		label: 'Grümelscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Manternach',
		label: 'Manternach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Kalborn',
		label: 'Kalborn, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Schengen',
		label: 'Schengen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Mecher',
		label: 'Mecher, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Ehlange',
		label: 'Ehlange, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Selscheid',
		label: 'Selscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Syren',
		label: 'Syren, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Siebenaler',
		label: 'Siebenaler, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Eschdorf',
		label: 'Eschdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Heiderscheid',
		label: 'Heiderscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Heinerscheid',
		label: 'Heinerscheid, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Breidfeld',
		label: 'Breidfeld, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Moestroff',
		label: 'Moestroff, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Cruchten',
		label: 'Cruchten, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Neidhausen',
		label: 'Neidhausen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Hünsdorf',
		label: 'Hünsdorf, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Pommerloch',
		label: 'Pommerloch, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Stegen',
		label: 'Stegen, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Schwebach',
		label: 'Schwebach, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Waldbillig',
		label: 'Waldbillig, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Urspelt',
		label: 'Urspelt, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Asselborn',
		label: 'Asselborn, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Breinert',
		label: 'Breinert, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Heiderscheid-Fond',
		label: 'Heiderscheid-Fond, Luxembourg',
		type: 'city',
		flagClass: 'fi fi-lu',
		isPopular: false,
	},
	{
		value: 'Macao',
		label: 'Macao',
		type: 'country',
		flagClass: 'fi fi-mo',
		isPopular: false,
	},
	{
		value: 'Macau',
		label: 'Macau, Macao',
		type: 'city',
		flagClass: 'fi fi-mo',
		isPopular: false,
	},
	{
		value: 'Macao',
		label: 'Macao, Macao',
		type: 'city',
		flagClass: 'fi fi-mo',
		isPopular: false,
	},
	{
		value: 'Madagascar',
		label: 'Madagascar',
		type: 'country',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antananarivo',
		label: 'Antananarivo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambalavao',
		label: 'Ambalavao, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Toamasina',
		label: 'Toamasina, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Mahajanga',
		label: 'Mahajanga, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antsirabé',
		label: 'Antsirabé, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antsiranana',
		label: 'Antsiranana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antanifotsy',
		label: 'Antanifotsy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Nosy Varika',
		label: 'Nosy Varika, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Manjakandriana',
		label: 'Manjakandriana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambatolampy',
		label: 'Ambatolampy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Beloha',
		label: 'Beloha, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Fianarantsoa',
		label: 'Fianarantsoa, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Toliary',
		label: 'Toliary, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambovombe',
		label: 'Ambovombe, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Amparafaravola',
		label: 'Amparafaravola, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Taolanaro',
		label: 'Taolanaro, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambatondrazaka',
		label: 'Ambatondrazaka, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Soavinandriana',
		label: 'Soavinandriana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Mananara',
		label: 'Mananara, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Mahanoro',
		label: 'Mahanoro, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Soanierana Ivongo',
		label: 'Soanierana Ivongo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Morondava',
		label: 'Morondava, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Manakara',
		label: 'Manakara, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Faratsiho',
		label: 'Faratsiho, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Amboasary',
		label: 'Amboasary, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antalaha',
		label: 'Antalaha, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Vavatenina',
		label: 'Vavatenina, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ikongo',
		label: 'Ikongo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Sambava',
		label: 'Sambava, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Fandriana',
		label: 'Fandriana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambanja',
		label: 'Ambanja, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambositra',
		label: 'Ambositra, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Betioky',
		label: 'Betioky, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Marovoay',
		label: 'Marovoay, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Tsihombe',
		label: 'Tsihombe, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Betafo',
		label: 'Betafo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Mananjary',
		label: 'Mananjary, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Moramanga',
		label: 'Moramanga, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambatofinandrahana',
		label: 'Ambatofinandrahana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Tsiroanomandidy',
		label: 'Tsiroanomandidy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ankazoabo',
		label: 'Ankazoabo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ampanihy',
		label: 'Ampanihy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Farafangana',
		label: 'Farafangana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: "Anosibe An'ala",
		label: "Anosibe An'ala, Madagascar",
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Marolambo',
		label: 'Marolambo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Vangaindrano',
		label: 'Vangaindrano, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Vohibinany',
		label: 'Vohibinany, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: "Belon'i Tsiribihina",
		label: "Belon'i Tsiribihina, Madagascar",
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antsirambazaha',
		label: 'Antsirambazaha, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Maroantsetra',
		label: 'Maroantsetra, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambato Boina',
		label: 'Ambato Boina, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Sakaraha',
		label: 'Sakaraha, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Andapa',
		label: 'Andapa, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Arivonimamo',
		label: 'Arivonimamo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Antsohihy',
		label: 'Antsohihy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Miandrivazo',
		label: 'Miandrivazo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Vondrozo',
		label: 'Vondrozo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Fenoarivo',
		label: 'Fenoarivo, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Andilamena',
		label: 'Andilamena, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Beroroha',
		label: 'Beroroha, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Anjozorobe',
		label: 'Anjozorobe, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ifanadiana',
		label: 'Ifanadiana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ihosy',
		label: 'Ihosy, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Bealanana',
		label: 'Bealanana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Tsaratanana',
		label: 'Tsaratanana, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ikalamavony',
		label: 'Ikalamavony, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ankazobe',
		label: 'Ankazobe, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambilobe',
		label: 'Ambilobe, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Ambodifototra',
		label: 'Ambodifototra, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Andevoranto',
		label: 'Andevoranto, Madagascar',
		type: 'city',
		flagClass: 'fi fi-mg',
		isPopular: false,
	},
	{
		value: 'Malawi',
		label: 'Malawi',
		type: 'country',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Blantyre',
		label: 'Blantyre, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Lilongwe',
		label: 'Lilongwe, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Balaka',
		label: 'Balaka, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Zomba',
		label: 'Zomba, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mzuzu',
		label: 'Mzuzu, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Kasungu',
		label: 'Kasungu, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mangochi',
		label: 'Mangochi, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mzimba',
		label: 'Mzimba, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Karonga',
		label: 'Karonga, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Dedza',
		label: 'Dedza, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mulanje',
		label: 'Mulanje, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mponela',
		label: 'Mponela, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Dowa',
		label: 'Dowa, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Salima',
		label: 'Salima, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Nkhotakota',
		label: 'Nkhotakota, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Nsanje',
		label: 'Nsanje, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Liwonde',
		label: 'Liwonde, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Rumphi',
		label: 'Rumphi, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mchinji',
		label: 'Mchinji, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Chilumba',
		label: 'Chilumba, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Nkhata Bay',
		label: 'Nkhata Bay, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Luchenza',
		label: 'Luchenza, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Monkey Bay',
		label: 'Monkey Bay, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Mwanza',
		label: 'Mwanza, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Ntcheu',
		label: 'Ntcheu, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Chitipa',
		label: 'Chitipa, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Chikwawa',
		label: 'Chikwawa, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Thyolo',
		label: 'Thyolo, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Ntchisi',
		label: 'Ntchisi, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Livingstonia',
		label: 'Livingstonia, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Phalombe',
		label: 'Phalombe, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Chipoka',
		label: 'Chipoka, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Chiradzulu',
		label: 'Chiradzulu, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Machinga',
		label: 'Machinga, Malawi',
		type: 'city',
		flagClass: 'fi fi-mw',
		isPopular: false,
	},
	{
		value: 'Malaysia',
		label: 'Malaysia',
		type: 'country',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Lumpur',
		label: 'Kuala Lumpur, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Petaling Jaya',
		label: 'Petaling Jaya, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Johor Bahru',
		label: 'Johor Bahru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Subang Jaya',
		label: 'Subang Jaya, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuching',
		label: 'Kuching, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kota Kinabalu',
		label: 'Kota Kinabalu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Shah Alam',
		label: 'Shah Alam, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ipoh',
		label: 'Ipoh, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Alor Gajah',
		label: 'Alor Gajah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Klang',
		label: 'Klang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Georgetown',
		label: 'Georgetown, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Melaka',
		label: 'Melaka, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Seremban',
		label: 'Seremban, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kajang-Sungai Chua',
		label: 'Kajang-Sungai Chua, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuantan',
		label: 'Kuantan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Miri',
		label: 'Miri, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ampang Jaya',
		label: 'Ampang Jaya, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bintulu',
		label: 'Bintulu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Terengganu',
		label: 'Kuala Terengganu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Alor Setar',
		label: 'Alor Setar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Nilai',
		label: 'Nilai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kota Bahru',
		label: 'Kota Bahru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Rawang',
		label: 'Rawang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sibu',
		label: 'Sibu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Petani',
		label: 'Sungai Petani, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Butterworth',
		label: 'Butterworth, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bukit Mertajam',
		label: 'Bukit Mertajam, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Selangor',
		label: 'Kuala Selangor, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Gelugor',
		label: 'Gelugor, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Taiping',
		label: 'Taiping, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ayer Keroh',
		label: 'Ayer Keroh, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Port Dickson',
		label: 'Port Dickson, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kluang',
		label: 'Kluang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tawau',
		label: 'Tawau, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ayer Itam',
		label: 'Ayer Itam, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Banting',
		label: 'Banting, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Selayang Baru',
		label: 'Selayang Baru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Gombak Setia',
		label: 'Gombak Setia, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kulai',
		label: 'Kulai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kulim',
		label: 'Kulim, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sandakan',
		label: 'Sandakan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pasir Gudang',
		label: 'Pasir Gudang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Balakong',
		label: 'Balakong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Kubu Baru',
		label: 'Kuala Kubu Baru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sekudai',
		label: 'Sekudai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Perai',
		label: 'Perai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Lumut',
		label: 'Lumut, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bandar Penggaram',
		label: 'Bandar Penggaram, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Keningau',
		label: 'Keningau, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Teluk Intan',
		label: 'Teluk Intan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanjong Bunga',
		label: 'Tanjong Bunga, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kangar',
		label: 'Kangar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Senai',
		label: 'Senai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bentong',
		label: 'Bentong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kota Tinggi',
		label: 'Kota Tinggi, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Nibong Tebal',
		label: 'Nibong Tebal, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kepala Batas',
		label: 'Kepala Batas, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Ara',
		label: 'Sungai Ara, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bandar Maharani',
		label: 'Bandar Maharani, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Segamat',
		label: 'Segamat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pekan',
		label: 'Pekan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bandar Baru Salak Tinggi',
		label: 'Bandar Baru Salak Tinggi, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Kangsar',
		label: 'Kuala Kangsar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Batu Berendam',
		label: 'Batu Berendam, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanjong Malim',
		label: 'Tanjong Malim, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Dungun',
		label: 'Dungun, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Semenyih',
		label: 'Semenyih, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Temerloh',
		label: 'Temerloh, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Batu Gajah',
		label: 'Batu Gajah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Raub',
		label: 'Raub, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tampin',
		label: 'Tampin, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Jenjarom',
		label: 'Jenjarom, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Parit Raja',
		label: 'Parit Raja, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sabak',
		label: 'Sabak, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pontian Kecil',
		label: 'Pontian Kecil, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Siput Utara',
		label: 'Sungai Siput Utara, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Mersing',
		label: 'Mersing, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Pilah',
		label: 'Kuala Pilah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bagan Serai',
		label: 'Bagan Serai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Beaufort',
		label: 'Beaufort, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Batu Sembilan Cheras',
		label: 'Batu Sembilan Cheras, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Cukai',
		label: 'Cukai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ulu Tiram',
		label: 'Ulu Tiram, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Jitra',
		label: 'Jitra, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bidor',
		label: 'Bidor, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sri Aman',
		label: 'Sri Aman, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pasir Mas',
		label: 'Pasir Mas, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Simpang Rengam',
		label: 'Simpang Rengam, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Jertih',
		label: 'Jertih, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Beranang',
		label: 'Beranang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Taman Greenwood',
		label: 'Taman Greenwood, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Lahad Datu',
		label: 'Lahad Datu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Simpang Empat',
		label: 'Simpang Empat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Mentakab',
		label: 'Mentakab, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Klebang',
		label: 'Klebang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kampong Koh',
		label: 'Kampong Koh, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanjong Tokong',
		label: 'Tanjong Tokong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kerteh',
		label: 'Kerteh, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Marang',
		label: 'Marang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Gua Musang',
		label: 'Gua Musang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ayer Tawar',
		label: 'Ayer Tawar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ayer Molek',
		label: 'Ayer Molek, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Perlis',
		label: 'Kuala Perlis, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kota Belud',
		label: 'Kota Belud, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Putatan',
		label: 'Putatan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Donggongon',
		label: 'Donggongon, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bukit Baru',
		label: 'Bukit Baru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Semporna',
		label: 'Semporna, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tangkak',
		label: 'Tangkak, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Masjid Tanah',
		label: 'Masjid Tanah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sarikel',
		label: 'Sarikel, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Jerantut',
		label: 'Jerantut, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Permatang Kuching',
		label: 'Permatang Kuching, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Parit Buntar',
		label: 'Parit Buntar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuah',
		label: 'Kuah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Yong Peng',
		label: 'Yong Peng, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Krai',
		label: 'Kuala Krai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Limbang',
		label: 'Limbang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Paka',
		label: 'Paka, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Labis',
		label: 'Labis, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Ranau',
		label: 'Ranau, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kunak',
		label: 'Kunak, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sekinchan',
		label: 'Sekinchan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Lipis',
		label: 'Kuala Lipis, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pantai Remis',
		label: 'Pantai Remis, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bemban',
		label: 'Bemban, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kelapa Sawit',
		label: 'Kelapa Sawit, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: "Val d'Or",
		label: "Val d'Or, Malaysia",
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pangkal Kalong',
		label: 'Pangkal Kalong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bedong',
		label: 'Bedong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kudat',
		label: 'Kudat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanah Merah',
		label: 'Tanah Merah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bahau',
		label: 'Bahau, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tapah',
		label: 'Tapah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Serendah',
		label: 'Serendah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Besar',
		label: 'Sungai Besar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kampar',
		label: 'Kampar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pekan Nenas',
		label: 'Pekan Nenas, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kadok',
		label: 'Kadok, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pengkalan Kundang',
		label: 'Pengkalan Kundang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Kedah',
		label: 'Kuala Kedah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Batu Arang',
		label: 'Batu Arang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuang',
		label: 'Kuang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bukit Rambai',
		label: 'Bukit Rambai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Papar',
		label: 'Papar, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Batang Berjuntai',
		label: 'Batang Berjuntai, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kinarut',
		label: 'Kinarut, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanjong Karang',
		label: 'Tanjong Karang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tumpat',
		label: 'Tumpat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Juru',
		label: 'Juru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bukit Tinggi',
		label: 'Bukit Tinggi, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kuala Sungai Baru',
		label: 'Kuala Sungai Baru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Chaah',
		label: 'Chaah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Pelek',
		label: 'Sungai Pelek, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Puchong',
		label: 'Puchong, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Putrajaya',
		label: 'Putrajaya, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Cyberjaya',
		label: 'Cyberjaya, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Garoafa',
		label: 'Garoafa, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sabah',
		label: 'Sabah, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Sungai Udang',
		label: 'Sungai Udang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Peringat',
		label: 'Peringat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Bukit Bakri',
		label: 'Bukit Bakri, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Lawan Kuda Baharu',
		label: 'Lawan Kuda Baharu, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Wakaf Baru',
		label: 'Wakaf Baru, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Tanjong Sepat',
		label: 'Tanjong Sepat, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Kapit',
		label: 'Kapit, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Gürün',
		label: 'Gürün, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Buloh Kasap',
		label: 'Buloh Kasap, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Pulau Sebang',
		label: 'Pulau Sebang, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Seri Kembangan',
		label: 'Seri Kembangan, Malaysia',
		type: 'city',
		flagClass: 'fi fi-my',
		isPopular: false,
	},
	{
		value: 'Maldives',
		label: 'Maldives',
		type: 'country',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Malé',
		label: 'Malé, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Agolhitheemu',
		label: 'Agolhitheemu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dharavandhoo',
		label: 'Dharavandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Holhudhoo',
		label: 'Holhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hithaadhoo',
		label: 'Hithaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hinnavaru',
		label: 'Hinnavaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thulhaadhoo',
		label: 'Thulhaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Miladhoo',
		label: 'Miladhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Nellaidhoo',
		label: 'Nellaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kulhudhuffushi',
		label: 'Kulhudhuffushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hulhudhoo',
		label: 'Hulhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maradhoo-Feydhoo',
		label: 'Maradhoo-Feydhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thoddoo',
		label: 'Thoddoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kumundhoo',
		label: 'Kumundhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Neykurendhoo',
		label: 'Neykurendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hirilandhoo',
		label: 'Hirilandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Lhaimagu',
		label: 'Lhaimagu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Feydhoo',
		label: 'Feydhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maradhoo',
		label: 'Maradhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Alifushi',
		label: 'Alifushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maamigili',
		label: 'Maamigili, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Nolhivaramu',
		label: 'Nolhivaramu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kurendhoo',
		label: 'Kurendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Vilufushi',
		label: 'Vilufushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Funadhoo',
		label: 'Funadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Muli',
		label: 'Muli, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fiyoari',
		label: 'Fiyoari, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Totesti',
		label: 'Totesti, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Filladhoo',
		label: 'Filladhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Madifushi',
		label: 'Madifushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Rasgetheemu',
		label: 'Rasgetheemu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Feridhoo',
		label: 'Feridhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Himandhoo',
		label: 'Himandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fares',
		label: 'Fares, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kanduhulhudhoo',
		label: 'Kanduhulhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Uligamu',
		label: 'Uligamu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kamadhoo',
		label: 'Kamadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Rakeedhoo',
		label: 'Rakeedhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhiyadhoo',
		label: 'Dhiyadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fuvammulah',
		label: 'Fuvammulah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thinadhoo',
		label: 'Thinadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Naifaru',
		label: 'Naifaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kadholhudhoo',
		label: 'Kadholhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hoarafushi',
		label: 'Hoarafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maavah',
		label: 'Maavah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Manadhoo',
		label: 'Manadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Vaikaradhoo',
		label: 'Vaikaradhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kolamaafushi',
		label: 'Kolamaafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Rasdhoo',
		label: 'Rasdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Himmafushi',
		label: 'Himmafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hulhudhuffaaru',
		label: 'Hulhudhuffaaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maamendhoo',
		label: 'Maamendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kolhufushi',
		label: 'Kolhufushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhiffushi',
		label: 'Dhiffushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gemanafushi',
		label: 'Gemanafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Biledhdhoo',
		label: 'Biledhdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Feeali',
		label: 'Feeali, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thulusdhoo',
		label: 'Thulusdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maabaidhoo',
		label: 'Maabaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Madeveli',
		label: 'Madeveli, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kibidhoo',
		label: 'Kibidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maakurathu',
		label: 'Maakurathu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gaafaru',
		label: 'Gaafaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhiggaru',
		label: 'Dhiggaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Huraa',
		label: 'Huraa, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Veymandhoo',
		label: 'Veymandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maafaru',
		label: 'Maafaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kendhoo',
		label: 'Kendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Omadhoo',
		label: 'Omadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Feevah',
		label: 'Feevah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maaugoodhoo',
		label: 'Maaugoodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhagethi',
		label: 'Dhagethi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Vashafaru',
		label: 'Vashafaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Landhoo',
		label: 'Landhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhabidhoo',
		label: 'Dhabidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Nadallaa',
		label: 'Nadallaa, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gulhi',
		label: 'Gulhi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maroshi',
		label: 'Maroshi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Badidhoo',
		label: 'Badidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maalhendhoo',
		label: 'Maalhendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fenfushi',
		label: 'Fenfushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maaeboodhoo',
		label: 'Maaeboodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Utheemu',
		label: 'Utheemu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Rasmaadhoo',
		label: 'Rasmaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hirimaradhoo',
		label: 'Hirimaradhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Rathafandhoo',
		label: 'Rathafandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kunahandhoo',
		label: 'Kunahandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhevvadhoo',
		label: 'Dhevvadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mundhoo',
		label: 'Mundhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hulhudheli',
		label: 'Hulhudheli, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Innamaadhoo',
		label: 'Innamaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Felidhoo',
		label: 'Felidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Lhohi',
		label: 'Lhohi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maarandhoo',
		label: 'Maarandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Ukulhas',
		label: 'Ukulhas, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hangnameedhoo',
		label: 'Hangnameedhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Keyodhoo',
		label: 'Keyodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mathiveri',
		label: 'Mathiveri, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Noomaraa',
		label: 'Noomaraa, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thakandhoo',
		label: 'Thakandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hoadedhdhoo',
		label: 'Hoadedhdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maathodaa',
		label: 'Maathodaa, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kuribi',
		label: 'Kuribi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Bilehffahi',
		label: 'Bilehffahi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhiyamigili',
		label: 'Dhiyamigili, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Goidhoo',
		label: 'Goidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Magoodhoo',
		label: 'Magoodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Muraidhoo',
		label: 'Muraidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Naivaadhoo',
		label: 'Naivaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Bodufolhudhoo',
		label: 'Bodufolhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Narudhoo',
		label: 'Narudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Nolhivaranfaru',
		label: 'Nolhivaranfaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Olhuvelifushi',
		label: 'Olhuvelifushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hebadhoo',
		label: 'Hebadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kalhaidhoo',
		label: 'Kalhaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kuburudhoo',
		label: 'Kuburudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kudarikilu',
		label: 'Kudarikilu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhigurah',
		label: 'Dhigurah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Ribudhoo',
		label: 'Ribudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thuraakunu',
		label: 'Thuraakunu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kudafari',
		label: 'Kudafari, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Firubaidhoo',
		label: 'Firubaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kinolhas',
		label: 'Kinolhas, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kadoodhoo',
		label: 'Kadoodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maalhos',
		label: 'Maalhos, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Vaanee',
		label: 'Vaanee, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhonfanu',
		label: 'Dhonfanu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fulidhoo',
		label: 'Fulidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Finey',
		label: 'Finey, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gemendhoo',
		label: 'Gemendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maavaidhoo',
		label: 'Maavaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mandhoo',
		label: 'Mandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gaadhiffushi',
		label: 'Gaadhiffushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kihaadhoo',
		label: 'Kihaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Buruni',
		label: 'Buruni, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Naalaafushi',
		label: 'Naalaafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fodhdhoo',
		label: 'Fodhdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fulhadhoo',
		label: 'Fulhadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fainu',
		label: 'Fainu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kodey',
		label: 'Kodey, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Vandhoo',
		label: 'Vandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mulhadhoo',
		label: 'Mulhadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dharaboodhoo',
		label: 'Dharaboodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Veyvah',
		label: 'Veyvah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Faridhoo',
		label: 'Faridhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Raimandhoo',
		label: 'Raimandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fehendhoo',
		label: 'Fehendhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hathifushi',
		label: 'Hathifushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maafilaafushi',
		label: 'Maafilaafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Berinmadhoo',
		label: 'Berinmadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hondaidhoo',
		label: 'Hondaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhidhdhoo',
		label: 'Dhidhdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gamu',
		label: 'Gamu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Eydhafushi',
		label: 'Eydhafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maafushi',
		label: 'Maafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Viligili',
		label: 'Viligili, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Ihavandhoo',
		label: 'Ihavandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mahibadhoo',
		label: 'Mahibadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Fonadhoo',
		label: 'Fonadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Velidhoo',
		label: 'Velidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Nilandhoo',
		label: 'Nilandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kaashidhoo',
		label: 'Kaashidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maakandoodhoo',
		label: 'Maakandoodhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Gaadhoo',
		label: 'Gaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Maduvvari',
		label: 'Maduvvari, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Meedhoo',
		label: 'Meedhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Komandoo',
		label: 'Komandoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Guraidhoo',
		label: 'Guraidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Isdhoo',
		label: 'Isdhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Thimarafushi',
		label: 'Thimarafushi, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Iguraidhoo',
		label: 'Iguraidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Baarah',
		label: 'Baarah, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Miim',
		label: 'Miim, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kudahuvadhoo',
		label: 'Kudahuvadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Dhaandhoo',
		label: 'Dhaandhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Hanimaadhoo',
		label: 'Hanimaadhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kelaa',
		label: 'Kelaa, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Makunudhoo',
		label: 'Makunudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Ugoofaaru',
		label: 'Ugoofaaru, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Foakaidhoo',
		label: 'Foakaidhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kaditheemu',
		label: 'Kaditheemu, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Kedhikolhudhoo',
		label: 'Kedhikolhudhoo, Maldives',
		type: 'city',
		flagClass: 'fi fi-mv',
		isPopular: false,
	},
	{
		value: 'Mali',
		label: 'Mali',
		type: 'country',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Bamako',
		label: 'Bamako, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Araouane',
		label: 'Araouane, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Mopti',
		label: 'Mopti, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kati',
		label: 'Kati, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'San´a',
		label: 'San´a, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Yorosso',
		label: 'Yorosso, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Sokolo',
		label: 'Sokolo, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Tessalit',
		label: 'Tessalit, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Sikasso',
		label: 'Sikasso, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Ségou',
		label: 'Ségou, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Koutiala',
		label: 'Koutiala, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Nkayi',
		label: 'Nkayi, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Nioro',
		label: 'Nioro, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Markala',
		label: 'Markala, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Gao',
		label: 'Gao, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kolokani',
		label: 'Kolokani, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Tombouctou',
		label: 'Tombouctou, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Bougouni',
		label: 'Bougouni, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Niono',
		label: 'Niono, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Koulikoro',
		label: 'Koulikoro, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Banamba',
		label: 'Banamba, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Nara',
		label: 'Nara, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Djenné',
		label: 'Djenné, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Bafoulabé',
		label: 'Bafoulabé, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kangaba',
		label: 'Kangaba, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Diré',
		label: 'Diré, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kidal',
		label: 'Kidal, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Koro',
		label: 'Koro, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Niafunké',
		label: 'Niafunké, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Goundam',
		label: 'Goundam, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kolondiéba',
		label: 'Kolondiéba, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Ké-Massina',
		label: 'Ké-Massina, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Douentza',
		label: 'Douentza, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Bandiagara',
		label: 'Bandiagara, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Tenenkou',
		label: 'Tenenkou, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kimparana',
		label: 'Kimparana, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Kita',
		label: 'Kita, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Taoudenni',
		label: 'Taoudenni, Mali',
		type: 'city',
		flagClass: 'fi fi-ml',
		isPopular: false,
	},
	{
		value: 'Malta',
		label: 'Malta',
		type: 'country',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Sliema',
		label: 'Sliema, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Valletta',
		label: 'Valletta, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Asfi',
		label: 'Asfi, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Birkirkara',
		label: 'Birkirkara, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Attard',
		label: 'Attard, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'San Pawl il-Bahar',
		label: 'San Pawl il-Bahar, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Mellieha',
		label: 'Mellieha, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'San Gwann',
		label: 'San Gwann, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'San Ghiljan',
		label: 'San Ghiljan, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Marsascala',
		label: 'Marsascala, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Qormi',
		label: 'Qormi, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Mosta',
		label: 'Mosta, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Fgura',
		label: 'Fgura, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Naxxar',
		label: 'Naxxar, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Birzebugia',
		label: 'Birzebugia, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Hamrun',
		label: 'Hamrun, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Zurrieq',
		label: 'Zurrieq, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Tarxien',
		label: 'Tarxien, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Gzira',
		label: 'Gzira, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Pembroke',
		label: 'Pembroke, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Gharghur',
		label: 'Gharghur, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Zebbug',
		label: 'Zebbug, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Paola',
		label: 'Paola, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Santa Venera',
		label: 'Santa Venera, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Garoafa',
		label: 'Garoafa, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Marsa',
		label: 'Marsa, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Isla',
		label: 'Isla, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Gudja',
		label: 'Gudja, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Lija',
		label: 'Lija, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Mdina',
		label: 'Mdina, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Zabbar',
		label: 'Zabbar, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Sighghiewi',
		label: 'Sighghiewi, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Swieqi',
		label: 'Swieqi, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Bormla',
		label: 'Bormla, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Nadur',
		label: 'Nadur, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Mqabba',
		label: 'Mqabba, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Floriana',
		label: 'Floriana, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Zejtun',
		label: 'Zejtun, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Luqa',
		label: 'Luqa, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: "Pieta'",
		label: "Pieta', Malta",
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Balzan',
		label: 'Balzan, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Birgu',
		label: 'Birgu, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Dingli',
		label: 'Dingli, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Kalkara',
		label: 'Kalkara, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Ghajnsielem and Comino',
		label: 'Ghajnsielem and Comino, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Ta Xbiex',
		label: 'Ta Xbiex, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Kercem',
		label: 'Kercem, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Munxar',
		label: 'Munxar, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Msida',
		label: 'Msida, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Ghaxaq',
		label: 'Ghaxaq, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Xaghra',
		label: 'Xaghra, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Iklin',
		label: 'Iklin, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Xewkija',
		label: 'Xewkija, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Marsaxlokk',
		label: 'Marsaxlokk, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Mgarr',
		label: 'Mgarr, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Qrendi',
		label: 'Qrendi, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Kirkop',
		label: 'Kirkop, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Sannat',
		label: 'Sannat, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Qala´-an-Nahl',
		label: 'Qala´-an-Nahl, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Gharb',
		label: 'Gharb, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Xghajra',
		label: 'Xghajra, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'San Lawrenz',
		label: 'San Lawrenz, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Ghasri',
		label: 'Ghasri, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Gozo',
		label: 'Gozo, Malta',
		type: 'city',
		flagClass: 'fi fi-mt',
		isPopular: false,
	},
	{
		value: 'Marshall Islands',
		label: 'Marshall Islands',
		type: 'country',
		flagClass: 'fi fi-mh',
		isPopular: false,
	},
	{
		value: 'Ebeye',
		label: 'Ebeye, Marshall Islands',
		type: 'city',
		flagClass: 'fi fi-mh',
		isPopular: false,
	},
	{
		value: 'Jaluit',
		label: 'Jaluit, Marshall Islands',
		type: 'city',
		flagClass: 'fi fi-mh',
		isPopular: false,
	},
	{
		value: 'Rita',
		label: 'Rita, Marshall Islands',
		type: 'city',
		flagClass: 'fi fi-mh',
		isPopular: false,
	},
	{
		value: 'Martinique',
		label: 'Martinique',
		type: 'country',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Fort-de-France',
		label: 'Fort-de-France, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Lamentin',
		label: 'Le Lamentin, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Ambodifototra',
		label: 'Ambodifototra, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Saint-Esprit',
		label: 'Saint-Esprit, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Marin',
		label: 'Le Marin, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Basse-Pointe',
		label: 'Basse-Pointe, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Schoelcher',
		label: 'Schoelcher, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Les Trois-Îlets',
		label: 'Les Trois-Îlets, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Robert',
		label: 'Le Robert, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le François',
		label: 'Le François, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Saint-Joseph',
		label: 'Saint-Joseph, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Ducos',
		label: 'Ducos, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Rivière-Pilote',
		label: 'Rivière-Pilote, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'La Trinité',
		label: 'La Trinité, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Rivière-Salée',
		label: 'Rivière-Salée, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Gros-Morne',
		label: 'Gros-Morne, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Lorrain',
		label: 'Le Lorrain, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Vauclin',
		label: 'Le Vauclin, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Sainte-Luce',
		label: 'Sainte-Luce, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Le Morne-Rouge',
		label: 'Le Morne-Rouge, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Saint-Pierre',
		label: 'Saint-Pierre, Martinique',
		type: 'city',
		flagClass: 'fi fi-mq',
		isPopular: false,
	},
	{
		value: 'Mauritania',
		label: 'Mauritania',
		type: 'country',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Nouakchott',
		label: 'Nouakchott, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Alaq',
		label: 'Alaq, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Atar',
		label: 'Atar, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: '´Ayun-al-´Atrus',
		label: '´Ayun-al-´Atrus, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Nawadhibu',
		label: 'Nawadhibu, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Kifah',
		label: 'Kifah, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Kayhaydi',
		label: 'Kayhaydi, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Rusu',
		label: 'Rusu, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Zuwarat',
		label: 'Zuwarat, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'an-Na´mah',
		label: 'an-Na´mah, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Tijiqjah',
		label: 'Tijiqjah, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Magta´ Lahjar',
		label: 'Magta´ Lahjar, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Walatah',
		label: 'Walatah, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Aqjawajat',
		label: 'Aqjawajat, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Buqah',
		label: 'Buqah, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Hsay Walad ´Ali Babi',
		label: 'Hsay Walad ´Ali Babi, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Shingati',
		label: 'Shingati, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Timbédra',
		label: 'Timbédra, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Kubanni',
		label: 'Kubanni, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Fdayrik',
		label: 'Fdayrik, Mauritania',
		type: 'city',
		flagClass: 'fi fi-mr',
		isPopular: false,
	},
	{
		value: 'Mauritius',
		label: 'Mauritius',
		type: 'country',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Port Louis',
		label: 'Port Louis, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Curepipe',
		label: 'Curepipe, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Albion',
		label: 'Albion, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Quatre Bornes',
		label: 'Quatre Bornes, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Beau Bassin-Rose Hill',
		label: 'Beau Bassin-Rose Hill, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Vacoas-Phoenix',
		label: 'Vacoas-Phoenix, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Moka',
		label: 'Moka, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand Baie',
		label: 'Grand Baie, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Terre Rouge',
		label: 'Terre Rouge, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Tamarin',
		label: 'Tamarin, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Chemin Grenier',
		label: 'Chemin Grenier, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Flic en Flac',
		label: 'Flic en Flac, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Central Flacq',
		label: 'Central Flacq, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Riviere du Rempart',
		label: 'Riviere du Rempart, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Montagne Blanche',
		label: 'Montagne Blanche, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Long Mountain',
		label: 'Long Mountain, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Camp Thorel',
		label: 'Camp Thorel, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Triolet',
		label: 'Triolet, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Goodlands',
		label: 'Goodlands, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Le Hochet',
		label: 'Le Hochet, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Saint Pierre',
		label: 'Saint Pierre, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Baie du Tombeau',
		label: 'Baie du Tombeau, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Rose Belle',
		label: 'Rose Belle, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'New Grove',
		label: 'New Grove, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Morcellement Saint André',
		label: 'Morcellement Saint André, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Cascavelle',
		label: 'Cascavelle, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Case Noyale',
		label: 'Case Noyale, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bel Air',
		label: 'Bel Air, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Mahébourg',
		label: 'Mahébourg, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Surinam',
		label: 'Surinam, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Pailles',
		label: 'Pailles, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Plaine Magnien',
		label: 'Plaine Magnien, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Lalmatie',
		label: 'Lalmatie, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Petit Raffray',
		label: 'Petit Raffray, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand Bois',
		label: 'Grand Bois, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Pamplemousse',
		label: 'Pamplemousse, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Dagotière',
		label: 'Dagotière, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Brisee Verdiere',
		label: 'Brisee Verdiere, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Laventure',
		label: 'Laventure, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "Trou d'Eau Douce",
		label: "Trou d'Eau Douce, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Fond du Sac',
		label: 'Fond du Sac, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "Poudre d'Or",
		label: "Poudre d'Or, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Cap Malheureux',
		label: 'Cap Malheureux, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Camp Diable',
		label: 'Camp Diable, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Richelieu',
		label: 'Richelieu, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Camp de Masque Pavé',
		label: 'Camp de Masque Pavé, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Souillac',
		label: 'Souillac, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Arsenal',
		label: 'Arsenal, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Queen Victoria',
		label: 'Queen Victoria, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Villebague',
		label: 'Villebague, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'La Gaulette',
		label: 'La Gaulette, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Saint Aubin',
		label: 'Saint Aubin, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Cluny',
		label: 'Cluny, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bambous',
		label: 'Bambous, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Rivière des Anguilles',
		label: 'Rivière des Anguilles, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Pointe aux Piments',
		label: 'Pointe aux Piments, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Beau Vallon',
		label: 'Beau Vallon, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "L'Escalier",
		label: "L'Escalier, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Plaines des Papayes',
		label: 'Plaines des Papayes, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bon Accueil',
		label: 'Bon Accueil, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Nouvelle France',
		label: 'Nouvelle France, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand Gaube',
		label: 'Grand Gaube, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Medine-Camp de Masque',
		label: 'Medine-Camp de Masque, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Poste de Flacq',
		label: 'Poste de Flacq, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Quatre Cocos',
		label: 'Quatre Cocos, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Quartier Militaire',
		label: 'Quartier Militaire, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Ecroignard',
		label: 'Ecroignard, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Roches Noires',
		label: 'Roches Noires, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Sébastopol',
		label: 'Sébastopol, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Chamouny',
		label: 'Chamouny, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Calebasses',
		label: 'Calebasses, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Piton',
		label: 'Piton, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Midlands',
		label: 'Midlands, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "D'Epinay",
		label: "D'Epinay, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Belle Vue Maurel',
		label: 'Belle Vue Maurel, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Petite Rivière',
		label: 'Petite Rivière, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Camp Ithier',
		label: 'Camp Ithier, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Notre Dame',
		label: 'Notre Dame, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Plaine des Roches',
		label: 'Plaine des Roches, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Saint Hubert',
		label: 'Saint Hubert, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Olivia',
		label: 'Olivia, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'The Vale',
		label: 'The Vale, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Cottage',
		label: 'Cottage, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Roche Terre',
		label: 'Roche Terre, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Quatre Soeurs',
		label: 'Quatre Soeurs, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "Saint Julien d'Hotman",
		label: "Saint Julien d'Hotman, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Providence',
		label: 'Providence, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Gros Cailloux',
		label: 'Gros Cailloux, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Dubreuil',
		label: 'Dubreuil, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Ripailles',
		label: 'Ripailles, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Saint Julien',
		label: 'Saint Julien, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Crève Coeur',
		label: 'Crève Coeur, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Amaury',
		label: 'Amaury, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Camp de Masque',
		label: 'Camp de Masque, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "L'Avenir",
		label: "L'Avenir, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Amitié-Gokhoola',
		label: 'Amitié-Gokhoola, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand River South East',
		label: 'Grand River South East, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand Sable',
		label: 'Grand Sable, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Clémencia',
		label: 'Clémencia, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Espérance Trébuchet',
		label: 'Espérance Trébuchet, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: "Poudre d'Or Hamlet",
		label: "Poudre d'Or Hamlet, Mauritius",
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grande Riviere Noire',
		label: 'Grande Riviere Noire, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Mare La Chaux',
		label: 'Mare La Chaux, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Verdun',
		label: 'Verdun, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Melrose',
		label: 'Melrose, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Espérance',
		label: 'Espérance, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bois des Amourettes',
		label: 'Bois des Amourettes, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bambous Virieux',
		label: 'Bambous Virieux, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Congomah',
		label: 'Congomah, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Grand Bel Air',
		label: 'Grand Bel Air, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Le Morne',
		label: 'Le Morne, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'La Laura-Malenga',
		label: 'La Laura-Malenga, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Mapou',
		label: 'Mapou, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Chamarel',
		label: 'Chamarel, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Bananes',
		label: 'Bananes, Mauritius',
		type: 'city',
		flagClass: 'fi fi-mu',
		isPopular: false,
	},
	{
		value: 'Mayotte',
		label: 'Mayotte',
		type: 'country',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Dzaoudzi',
		label: 'Dzaoudzi, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Pamanzi',
		label: 'Pamanzi, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Acoua',
		label: 'Acoua, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Mamoudzou',
		label: 'Mamoudzou, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Koungou',
		label: 'Koungou, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Whittlesea',
		label: 'Whittlesea, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Bandraboua',
		label: 'Bandraboua, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Mtsamboro',
		label: 'Mtsamboro, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Chiconi',
		label: 'Chiconi, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Dembéni',
		label: 'Dembéni, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Tsingoni',
		label: 'Tsingoni, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Chirongui',
		label: 'Chirongui, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Mtsangamouji',
		label: 'Mtsangamouji, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Bandrélé',
		label: 'Bandrélé, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Ouangani',
		label: 'Ouangani, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Bouéni',
		label: 'Bouéni, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'Kanikéli',
		label: 'Kanikéli, Mayotte',
		type: 'city',
		flagClass: 'fi fi-yt',
		isPopular: false,
	},
	{
		value: 'México City',
		label: 'México City, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Monterrey',
		label: 'Monterrey, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Guadalajara',
		label: 'Guadalajara, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Puerto Vallarta',
		label: 'Puerto Vallarta, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tijuana',
		label: 'Tijuana, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Abasolo',
		label: 'Abasolo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Puebla',
		label: 'Puebla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Querétaro',
		label: 'Querétaro, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chihuahua',
		label: 'Chihuahua, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Hermosillo',
		label: 'Hermosillo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuernavaca',
		label: 'Cuernavaca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mexicali',
		label: 'Mexicali, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Veracruz',
		label: 'Veracruz, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mérida',
		label: 'Mérida, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Reynosa',
		label: 'Reynosa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cabo San Lucas',
		label: 'Cabo San Lucas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Nicolás de los Garza',
		label: 'San Nicolás de los Garza, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tampico',
		label: 'Tampico, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Torreón',
		label: 'Torreón, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Oaxaca',
		label: 'Oaxaca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Morelia',
		label: 'Morelia, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ensenada',
		label: 'Ensenada, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Culiacán',
		label: 'Culiacán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Toluca',
		label: 'Toluca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'León',
		label: 'León, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Miguel de Allende',
		label: 'San Miguel de Allende, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Acapulco',
		label: 'Acapulco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Xalapa',
		label: 'Xalapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ecatepec',
		label: 'Ecatepec, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Saltillo',
		label: 'Saltillo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mazatlán',
		label: 'Mazatlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Aguascalientes',
		label: 'Aguascalientes, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Villahermosa',
		label: 'Villahermosa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuautitlán Izcalli',
		label: 'Cuautitlán Izcalli, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Matamoros',
		label: 'Matamoros, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nuevo Laredo',
		label: 'Nuevo Laredo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Zapopan',
		label: 'Zapopan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tlalnepantla',
		label: 'Tlalnepantla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Guadalupe',
		label: 'Guadalupe, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Durango',
		label: 'Durango, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'La Paz',
		label: 'La Paz, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Colima',
		label: 'Colima, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Guanajuato',
		label: 'Guanajuato, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Atizapán',
		label: 'Atizapán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Pachuca',
		label: 'Pachuca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Rosarito',
		label: 'Rosarito, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tepic',
		label: 'Tepic, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Apodaca',
		label: 'Apodaca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Monclova',
		label: 'Monclova, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Celaya',
		label: 'Celaya, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Zacatecas',
		label: 'Zacatecas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Puerto Peñasco',
		label: 'Puerto Peñasco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nuevo México',
		label: 'Nuevo México, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Metepec',
		label: 'Metepec, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tuxtla Gutiérrez',
		label: 'Tuxtla Gutiérrez, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chetumal',
		label: 'Chetumal, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuauhtémoc',
		label: 'Cuauhtémoc, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Morelos',
		label: 'Morelos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Álvaro Obregón',
		label: 'Álvaro Obregón, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Coacalco',
		label: 'Coacalco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Coatzacoalcos',
		label: 'Coatzacoalcos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mazatán',
		label: 'Mazatán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nezahualcóyotl',
		label: 'Nezahualcóyotl, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ajijic',
		label: 'Ajijic, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nogales',
		label: 'Nogales, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Texcoco',
		label: 'Texcoco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Sinaloa',
		label: 'Sinaloa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Navajoa',
		label: 'Navajoa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chapala',
		label: 'Chapala, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cadereyta',
		label: 'Cadereyta, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tabasco',
		label: 'Tabasco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Los Mochis',
		label: 'Los Mochis, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Campeche',
		label: 'Campeche, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Huixquilucan',
		label: 'Huixquilucan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Coatepec',
		label: 'Coatepec, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santa Catarina',
		label: 'Santa Catarina, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Poza Rica',
		label: 'Poza Rica, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Minatitlán',
		label: 'Minatitlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Garza García',
		label: 'Garza García, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ciudad Valles',
		label: 'Ciudad Valles, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Jalapa',
		label: 'Jalapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cozumel',
		label: 'Cozumel, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Apizaco',
		label: 'Apizaco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Los Cabos',
		label: 'Los Cabos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Irapuato',
		label: 'Irapuato, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Uruapan',
		label: 'Uruapan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santa Fé',
		label: 'Santa Fé, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Adolfo López Mateos',
		label: 'Adolfo López Mateos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Carmen',
		label: 'Carmen, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Cristóbal de las Casas',
		label: 'San Cristóbal de las Casas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Manzanillo',
		label: 'Manzanillo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Guaymas',
		label: 'Guaymas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Dolores Hidalgo',
		label: 'Dolores Hidalgo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Taxco',
		label: 'Taxco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Miguel Hidalgo',
		label: 'Miguel Hidalgo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Montemorelos',
		label: 'Montemorelos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nombre de Dios',
		label: 'Nombre de Dios, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ixmiquilpan',
		label: 'Ixmiquilpan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Ciro de Acosta',
		label: 'San Ciro de Acosta, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Felipe',
		label: 'San Felipe, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Madero',
		label: 'Madero, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tultitlán',
		label: 'Tultitlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Huixquilucan de Degollado',
		label: 'Huixquilucan de Degollado, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuautla',
		label: 'Cuautla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Salamanca',
		label: 'Salamanca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Piedras Negras',
		label: 'Piedras Negras, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Zamora',
		label: 'Zamora, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Orizaba',
		label: 'Orizaba, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Allende',
		label: 'Allende, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Fresnillo',
		label: 'Fresnillo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tulancingo',
		label: 'Tulancingo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Río Bravo',
		label: 'Río Bravo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tlaxcala',
		label: 'Tlaxcala, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cholula',
		label: 'Cholula, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuautitlán',
		label: 'Cuautitlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Boca del Río',
		label: 'Boca del Río, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Linares',
		label: 'Linares, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tapalpa',
		label: 'Tapalpa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'San Luis de la Paz',
		label: 'San Luis de la Paz, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chapultepec',
		label: 'Chapultepec, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Zumpango',
		label: 'Zumpango, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Moroleón',
		label: 'Moroleón, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Camargo',
		label: 'Camargo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tangancicuaro',
		label: 'Tangancicuaro, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ixtlahuacán de los Membrillos',
		label: 'Ixtlahuacán de los Membrillos, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Natívitas',
		label: 'Natívitas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chietla',
		label: 'Chietla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Huandacareo',
		label: 'Huandacareo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Jalcocotán',
		label: 'Jalcocotán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tonalá',
		label: 'Tonalá, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Xico',
		label: 'Xico, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Escobedo',
		label: 'Escobedo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chilpancingo',
		label: 'Chilpancingo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Córdoba',
		label: 'Córdoba, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santa Catarina del Monte',
		label: 'Santa Catarina del Monte, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Matatlán',
		label: 'Matatlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Acuña',
		label: 'Acuña, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tempoal',
		label: 'Tempoal, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Delicias',
		label: 'Delicias, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ciudad del Maíz',
		label: 'Ciudad del Maíz, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Bacobampo',
		label: 'Bacobampo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cárdenas',
		label: 'Cárdenas, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'El Mante',
		label: 'El Mante, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tepatitlán',
		label: 'Tepatitlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mexicaltzingo',
		label: 'Mexicaltzingo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santos Reyes Nopala',
		label: 'Santos Reyes Nopala, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Oxkutzcab',
		label: 'Oxkutzcab, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tuxpam',
		label: 'Tuxpam, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tonatico',
		label: 'Tonatico, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Agua Prieta',
		label: 'Agua Prieta, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Aguacaliente',
		label: 'Aguacaliente, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'General Bravo',
		label: 'General Bravo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Xilitla',
		label: 'Xilitla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Santa Catarina de Tepehuanes',
		label: 'Santa Catarina de Tepehuanes, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Mezcala',
		label: 'Mezcala, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Imuris',
		label: 'Imuris, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Acaponeta',
		label: 'Acaponeta, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Zacapú',
		label: 'Zacapú, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Huauchinango',
		label: 'Huauchinango, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ixtapa',
		label: 'Ixtapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Altamira',
		label: 'Altamira, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Río Verde',
		label: 'Río Verde, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tepecoacuilco',
		label: 'Tepecoacuilco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Coalcomán',
		label: 'Coalcomán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Valle de Juárez',
		label: 'Valle de Juárez, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Acayucan',
		label: 'Acayucan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Huajuapan',
		label: 'Huajuapan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Panotla',
		label: 'Panotla, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Progreso',
		label: 'Progreso, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Autlán',
		label: 'Autlán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tlanalapa',
		label: 'Tlanalapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Armería',
		label: 'Armería, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuautepec',
		label: 'Cuautepec, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Comalcalco',
		label: 'Comalcalco, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Jérez',
		label: 'Jérez, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tizayuca',
		label: 'Tizayuca, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Altotonga',
		label: 'Altotonga, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Ramos Arizpe',
		label: 'Ramos Arizpe, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'General Zuazua',
		label: 'General Zuazua, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Venustiano Carranza',
		label: 'Venustiano Carranza, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Tepeji',
		label: 'Tepeji, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Sabinas Hidalgo',
		label: 'Sabinas Hidalgo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Perote',
		label: 'Perote, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cuajinicuilapa',
		label: 'Cuajinicuilapa, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Maravatío',
		label: 'Maravatío, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Cosamaloapan',
		label: 'Cosamaloapan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Chimalhuacán',
		label: 'Chimalhuacán, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Valle de Bravo',
		label: 'Valle de Bravo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Nanchital',
		label: 'Nanchital, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'General Escobedo',
		label: 'General Escobedo, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Jiquilpan',
		label: 'Jiquilpan, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Los Reyes',
		label: 'Los Reyes, Mexico',
		type: 'city',
		flagClass: 'fi fi-mx',
		isPopular: false,
	},
	{
		value: 'Micronesia, Federated States of',
		label: 'Micronesia, Federated States of',
		type: 'country',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Colonia',
		label: 'Colonia, Micronesia, Federated States of',
		type: 'city',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Kolonia',
		label: 'Kolonia, Micronesia, Federated States of',
		type: 'city',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Weno',
		label: 'Weno, Micronesia, Federated States of',
		type: 'city',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Palikir',
		label: 'Palikir, Micronesia, Federated States of',
		type: 'city',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Kusaie',
		label: 'Kusaie, Micronesia, Federated States of',
		type: 'city',
		flagClass: 'fi fi-fm',
		isPopular: false,
	},
	{
		value: 'Moldova, Republic of',
		label: 'Moldova, Republic of',
		type: 'country',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Chisinau',
		label: 'Chisinau, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Balti',
		label: 'Balti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: "Tiraspol'",
		label: "Tiraspol', Moldova, Republic of",
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Cahul',
		label: 'Cahul, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Edinet',
		label: 'Edinet, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Cimislia',
		label: 'Cimislia, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Orhei',
		label: 'Orhei, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Causani',
		label: 'Causani, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Calarasi',
		label: 'Calarasi, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Leova',
		label: 'Leova, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Tighina',
		label: 'Tighina, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Rabnita',
		label: 'Rabnita, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Soroca',
		label: 'Soroca, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Ungheni',
		label: 'Ungheni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Dubasari',
		label: 'Dubasari, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Comrat',
		label: 'Comrat, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Ciadar Lunga',
		label: 'Ciadar Lunga, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Drochia',
		label: 'Drochia, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Falesti',
		label: 'Falesti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Hancesti',
		label: 'Hancesti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Slobozia',
		label: 'Slobozia, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Floresti',
		label: 'Floresti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Vulcanesti',
		label: 'Vulcanesti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Rascani',
		label: 'Rascani, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Nisporeni',
		label: 'Nisporeni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Taraclia',
		label: 'Taraclia, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Basarabeasca',
		label: 'Basarabeasca, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Rezina',
		label: 'Rezina, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Dnestrovsc',
		label: 'Dnestrovsc, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Camenca',
		label: 'Camenca, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Donduseni',
		label: 'Donduseni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Glodeni',
		label: 'Glodeni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Griguriopol',
		label: 'Griguriopol, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Briceni',
		label: 'Briceni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Ocnita',
		label: 'Ocnita, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Straseni',
		label: 'Straseni, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Telenesti',
		label: 'Telenesti, Moldova, Republic of',
		type: 'city',
		flagClass: 'fi fi-md',
		isPopular: false,
	},
	{
		value: 'Monaco',
		label: 'Monaco',
		type: 'country',
		flagClass: 'fi fi-mc',
		isPopular: false,
	},
	{
		value: 'Monte Carlo',
		label: 'Monte Carlo, Monaco',
		type: 'city',
		flagClass: 'fi fi-mc',
		isPopular: false,
	},
	{
		value: 'Monaco-Ville',
		label: 'Monaco-Ville, Monaco',
		type: 'city',
		flagClass: 'fi fi-mc',
		isPopular: false,
	},
	{
		value: 'Fontvieille',
		label: 'Fontvieille, Monaco',
		type: 'city',
		flagClass: 'fi fi-mc',
		isPopular: false,
	},
	{
		value: 'La Condamine',
		label: 'La Condamine, Monaco',
		type: 'city',
		flagClass: 'fi fi-mc',
		isPopular: false,
	},
	{
		value: 'Mongolia',
		label: 'Mongolia',
		type: 'country',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Ulaanbaatar',
		label: 'Ulaanbaatar, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Altaj',
		label: 'Altaj, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Darhan',
		label: 'Darhan, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Èrdènèt',
		label: 'Èrdènèt, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Hovd',
		label: 'Hovd, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Bajanhongor',
		label: 'Bajanhongor, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Ölgij',
		label: 'Ölgij, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Mörön',
		label: 'Mörön, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Ulaangom',
		label: 'Ulaangom, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Zuunmod',
		label: 'Zuunmod, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Bulgan',
		label: 'Bulgan, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Chojbalsan',
		label: 'Chojbalsan, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Sajnshand',
		label: 'Sajnshand, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Uliastaj',
		label: 'Uliastaj, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Sühbaatar',
		label: 'Sühbaatar, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Arvajhèèr',
		label: 'Arvajhèèr, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Cècèrleg',
		label: 'Cècèrleg, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Zuunharaa',
		label: 'Zuunharaa, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Dalanzadgad',
		label: 'Dalanzadgad, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Baruun-Urt',
		label: 'Baruun-Urt, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Mandalgovi',
		label: 'Mandalgovi, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Öndörhaan',
		label: 'Öndörhaan, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Tosoncengel',
		label: 'Tosoncengel, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Nalajh',
		label: 'Nalajh, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Chojr',
		label: 'Chojr, Mongolia',
		type: 'city',
		flagClass: 'fi fi-mn',
		isPopular: false,
	},
	{
		value: 'Montenegro',
		label: 'Montenegro',
		type: 'country',
		flagClass: 'fi fi-me',
		isPopular: false,
	},
	{
		value: 'Podgorica',
		label: 'Podgorica, Montenegro',
		type: 'city',
		flagClass: 'fi fi-me',
		isPopular: false,
	},
	{
		value: 'Nikšić',
		label: 'Nikšić, Montenegro',
		type: 'city',
		flagClass: 'fi fi-me',
		isPopular: false,
	},
	{
		value: 'Pljevlja',
		label: 'Pljevlja, Montenegro',
		type: 'city',
		flagClass: 'fi fi-me',
		isPopular: false,
	},
	{
		value: 'Budva',
		label: 'Budva, Montenegro',
		type: 'city',
		flagClass: 'fi fi-me',
		isPopular: false,
	},
	{
		value: 'Montserrat',
		label: 'Montserrat',
		type: 'country',
		flagClass: 'fi fi-ms',
		isPopular: false,
	},
	{
		value: 'Montserrat',
		label: 'Montserrat, Montserrat',
		type: 'city',
		flagClass: 'fi fi-ms',
		isPopular: false,
	},
	{
		value: 'Morocco',
		label: 'Morocco',
		type: 'country',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'ad-Dar-al-Bayda',
		label: 'ad-Dar-al-Bayda, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'ar-Ribat',
		label: 'ar-Ribat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Aghadir',
		label: 'Aghadir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Marrakush',
		label: 'Marrakush, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Fas',
		label: 'Fas, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Miknas',
		label: 'Miknas, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tanjah',
		label: 'Tanjah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tarudant',
		label: 'Tarudant, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Husaymah',
		label: 'al-Husaymah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tazah',
		label: 'Tazah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tiznit',
		label: 'Tiznit, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Warzazat',
		label: 'Warzazat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Qanitrah',
		label: 'al-Qanitrah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Asfi',
		label: 'Asfi, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Titwan',
		label: 'Titwan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bani Mallal',
		label: 'Bani Mallal, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'an-Nadur',
		label: 'an-Nadur, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Midalt',
		label: 'Midalt, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sakhirat',
		label: 'Sakhirat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ahfir',
		label: 'Ahfir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Îfran',
		label: 'Îfran, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: '´Ayn Diab',
		label: '´Ayn Diab, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ujdah',
		label: 'Ujdah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Jadidah',
		label: 'al-Jadidah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Khamissat',
		label: 'Khamissat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Yussufiyah',
		label: 'Yussufiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Safru',
		label: 'Safru, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Wazzan',
		label: 'Wazzan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-´Ayun',
		label: 'al-´Ayun, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: '´Allal-at-Tazi',
		label: '´Allal-at-Tazi, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Khuribghah',
		label: 'Khuribghah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sattat',
		label: 'Sattat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ghulimim',
		label: 'Ghulimim, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Birkan',
		label: 'Birkan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Khanifrah',
		label: 'Khanifrah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Qasim',
		label: 'Sidi Qasim, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bin Gharir',
		label: 'Bin Gharir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Zagorá',
		label: 'Zagorá, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Zayu',
		label: 'Zayu, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tawnat',
		label: 'Tawnat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Hajab',
		label: 'al-Hajab, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Martil',
		label: 'Martil, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Mahdiyah',
		label: 'Mahdiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Midar',
		label: 'Midar, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Buruj',
		label: 'al-Buruj, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tarfaya',
		label: 'Tarfaya, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Battash',
		label: 'Sidi Battash, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ait Baha',
		label: 'Ait Baha, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Qasr-al-Kabir',
		label: 'al-Qasr-al-Kabir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Azru',
		label: 'Azru, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Suq-al-Arb´a',
		label: 'Suq-al-Arb´a, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Qasbat Tadlah',
		label: 'Qasbat Tadlah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bu-al-Jad',
		label: 'Bu-al-Jad, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Shifshawn',
		label: 'Shifshawn, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tinghir',
		label: 'Tinghir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Yahya al-Gharb',
		label: 'Sidi Yahya al-Gharb, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tazah-al-Uliyah',
		label: 'Tazah-al-Uliyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Asilah',
		label: 'Asilah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Îfni',
		label: 'Sidi Îfni, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Buznika',
		label: 'Buznika, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Midiq',
		label: 'Midiq, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tahala',
		label: 'Tahala, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Azilal',
		label: 'Azilal, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bu ´Arfa',
		label: 'Bu ´Arfa, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Mulay',
		label: 'Mulay, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Taliwin',
		label: 'Taliwin, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Inazkan',
		label: 'Inazkan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Asni',
		label: 'Asni, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Îmin Tanut',
		label: 'Îmin Tanut, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Amizmiz',
		label: 'Amizmiz, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Madyunah',
		label: 'Madyunah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Bu Ghadrah',
		label: 'Sidi Bu Ghadrah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Katwat',
		label: 'al-Katwat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'ash-Shama´iyah',
		label: 'ash-Shama´iyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bab Tazah',
		label: 'Bab Tazah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ghafsay',
		label: 'Ghafsay, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bani Tajjit',
		label: 'Bani Tajjit, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Afurir',
		label: 'Afurir, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Sulayman',
		label: 'Sidi Sulayman, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tawrirt',
		label: 'Tawrirt, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bir Rashid',
		label: 'Bir Rashid, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Jaradah',
		label: 'Jaradah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'as-Sawirah',
		label: 'as-Sawirah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: "al-Qal´at-al-Khasba'",
		label: "al-Qal´at-al-Khasba', Morocco",
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tiflat',
		label: 'Tiflat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Awlat Taymah',
		label: 'Awlat Taymah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tantan',
		label: 'Tantan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Gharsif',
		label: 'Gharsif, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Suq Sabt Awlat Nama',
		label: 'Suq Sabt Awlat Nama, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bin Sulayman',
		label: 'Bin Sulayman, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Finidiq',
		label: 'Finidiq, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Binnur',
		label: 'Sidi Binnur, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Azimur',
		label: 'Azimur, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Arwi',
		label: 'al-Arwi, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Jama´at-al-Marirt',
		label: 'Jama´at-al-Marirt, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Imzuran',
		label: 'Imzuran, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bin Ansar',
		label: 'Bin Ansar, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Mashra Bin-al-Qsiri',
		label: 'Mashra Bin-al-Qsiri, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Amalu Ighriban',
		label: 'Amalu Ighriban, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Isma´il',
		label: 'Sidi Isma´il, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Mulay Idris',
		label: 'Mulay Idris, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Fijij',
		label: 'Fijij, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Damnat',
		label: 'Damnat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bin Ahmad',
		label: 'Bin Ahmad, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bu Danib',
		label: 'Bu Danib, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Qsibah',
		label: 'al-Qsibah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Walidiyah',
		label: 'Walidiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sulwan',
		label: 'Sulwan, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'ar-Rummani',
		label: 'ar-Rummani, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tafraut',
		label: 'Tafraut, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Buciumeni',
		label: 'Buciumeni, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bulman',
		label: 'Bulman, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'as-Sa´idiyah',
		label: 'as-Sa´idiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Awtat Awlat-al-Hajj',
		label: 'Awtat Awlat-al-Hajj, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Allal-al-Bahrawi',
		label: 'Sidi Allal-al-Bahrawi, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Targhist',
		label: 'Targhist, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Casablanca',
		label: 'Casablanca, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tandrarah',
		label: 'Tandrarah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'az-Zahiliqah',
		label: 'az-Zahiliqah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Kitamah',
		label: 'Kitamah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Tamri',
		label: 'Tamri, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Timhadit',
		label: 'Timhadit, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Rabat',
		label: 'Rabat, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Birjant',
		label: 'Birjant, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Awluz',
		label: 'Awluz, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Dabdu',
		label: 'Dabdu, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Unaghah',
		label: 'Unaghah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ghurramah',
		label: 'Ghurramah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Îgharm',
		label: 'Îgharm, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Îmuzzar-al-Kandar',
		label: 'Îmuzzar-al-Kandar, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Talmist',
		label: 'Talmist, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Shishawah',
		label: 'Shishawah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Marrakesh',
		label: 'Marrakesh, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Bumiyah',
		label: 'Bumiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Biukra',
		label: 'Biukra, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sidi Hajjaj',
		label: 'Sidi Hajjaj, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Ijukak',
		label: 'Ijukak, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Khamis-az-Zamamrah',
		label: 'Khamis-az-Zamamrah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Sukhur-ar-Rihamnah',
		label: 'Sukhur-ar-Rihamnah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Errachidia',
		label: 'Errachidia, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-´Abbasiyah',
		label: 'al-´Abbasiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'al-Faqih Bin Salah',
		label: 'al-Faqih Bin Salah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'ar-Rasidiyah',
		label: 'ar-Rasidiyah, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Wad Zam',
		label: 'Wad Zam, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Meknes',
		label: 'Meknes, Morocco',
		type: 'city',
		flagClass: 'fi fi-ma',
		isPopular: false,
	},
	{
		value: 'Mozambique',
		label: 'Mozambique',
		type: 'country',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Maputo',
		label: 'Maputo, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Matola',
		label: 'Matola, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Angoche',
		label: 'Angoche, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Beira',
		label: 'Beira, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Nampula',
		label: 'Nampula, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Tete',
		label: 'Tete, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Chimoio',
		label: 'Chimoio, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Quelimane',
		label: 'Quelimane, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Lichinga',
		label: 'Lichinga, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Pemba',
		label: 'Pemba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Dondo',
		label: 'Dondo, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Mocuba',
		label: 'Mocuba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Inhambane',
		label: 'Inhambane, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Moçambique',
		label: 'Moçambique, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Nazombe',
		label: 'Nazombe, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Panda',
		label: 'Panda, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Bela Vista',
		label: 'Bela Vista, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Nacala',
		label: 'Nacala, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Xai-Xai',
		label: 'Xai-Xai, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Garue',
		label: 'Garue, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Maxixe',
		label: 'Maxixe, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Cuamba',
		label: 'Cuamba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Montepuez',
		label: 'Montepuez, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Chókwè',
		label: 'Chókwè, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Chibuto',
		label: 'Chibuto, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Manica',
		label: 'Manica, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Quissico',
		label: 'Quissico, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Lumbo',
		label: 'Lumbo, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Inharrime',
		label: 'Inharrime, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Macia',
		label: 'Macia, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Marrupa',
		label: 'Marrupa, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Chongoene',
		label: 'Chongoene, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Homoíne',
		label: 'Homoíne, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Manhiça',
		label: 'Manhiça, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Guijá',
		label: 'Guijá, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Magude',
		label: 'Magude, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Zumbo',
		label: 'Zumbo, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Jangamo',
		label: 'Jangamo, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Maniamba',
		label: 'Maniamba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Marracuene',
		label: 'Marracuene, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Moamba',
		label: 'Moamba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Mandimba',
		label: 'Mandimba, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Namaacha',
		label: 'Namaacha, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Chidenguele',
		label: 'Chidenguele, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Manjacaze',
		label: 'Manjacaze, Mozambique',
		type: 'city',
		flagClass: 'fi fi-mz',
		isPopular: false,
	},
	{
		value: 'Myanmar',
		label: 'Myanmar',
		type: 'country',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Yangon',
		label: 'Yangon, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mandalay',
		label: 'Mandalay, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Yandoon',
		label: 'Yandoon, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Akyab',
		label: 'Akyab, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pakokku',
		label: 'Pakokku, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Loikaw',
		label: 'Loikaw, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Bago',
		label: 'Bago, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Keng Tung',
		label: 'Keng Tung, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pathein',
		label: 'Pathein, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Taunggyi',
		label: 'Taunggyi, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Myingyan',
		label: 'Myingyan, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Maymyo',
		label: 'Maymyo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Magway',
		label: 'Magway, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pyinmana',
		label: 'Pyinmana, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mogok',
		label: 'Mogok, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Meiktila',
		label: 'Meiktila, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mergui',
		label: 'Mergui, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Lashio',
		label: 'Lashio, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pyay',
		label: 'Pyay, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mudon',
		label: 'Mudon, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Nyaunglebin',
		label: 'Nyaunglebin, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Myitkyina',
		label: 'Myitkyina, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pyapon',
		label: 'Pyapon, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Arakan',
		label: 'Arakan, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Thongwa',
		label: 'Thongwa, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Ye',
		label: 'Ye, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kyaikto',
		label: 'Kyaikto, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kyaukse',
		label: 'Kyaukse, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Wakema',
		label: 'Wakema, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Myanaung',
		label: 'Myanaung, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Falam',
		label: 'Falam, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mawlamyine',
		label: 'Mawlamyine, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Monywa',
		label: 'Monywa, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Dawei',
		label: 'Dawei, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Henzada',
		label: 'Henzada, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Thaton',
		label: 'Thaton, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Yenangyaung',
		label: 'Yenangyaung, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Toungoo',
		label: 'Toungoo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kalay',
		label: 'Kalay, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Chauk',
		label: 'Chauk, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Shwebo',
		label: 'Shwebo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Sagaing',
		label: 'Sagaing, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Syriam',
		label: 'Syriam, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Bogale',
		label: 'Bogale, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Taungdwingyi',
		label: 'Taungdwingyi, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kanbe',
		label: 'Kanbe, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Thayetmyo',
		label: 'Thayetmyo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Allanmyo',
		label: 'Allanmyo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Minbu',
		label: 'Minbu, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Tharrawaddy',
		label: 'Tharrawaddy, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Maubin',
		label: 'Maubin, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kyaiklat',
		label: 'Kyaiklat, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Martaban',
		label: 'Martaban, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kyaikkami',
		label: 'Kyaikkami, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Banmo',
		label: 'Banmo, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Twante',
		label: 'Twante, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Yamethin',
		label: 'Yamethin, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Mawlaik',
		label: 'Mawlaik, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Labutta',
		label: 'Labutta, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Pyu',
		label: 'Pyu, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Kayan',
		label: 'Kayan, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Moulmeingyun',
		label: 'Moulmeingyun, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Letpadan',
		label: 'Letpadan, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Katha',
		label: 'Katha, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Thanatpin',
		label: 'Thanatpin, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Paungde',
		label: 'Paungde, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Hpa-an',
		label: 'Hpa-an, Myanmar',
		type: 'city',
		flagClass: 'fi fi-mm',
		isPopular: false,
	},
	{
		value: 'Namibia',
		label: 'Namibia',
		type: 'country',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Windhoek',
		label: 'Windhoek, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Arandis',
		label: 'Arandis, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Walvis Bay',
		label: 'Walvis Bay, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Tsumeb',
		label: 'Tsumeb, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Swakopmund',
		label: 'Swakopmund, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Katima Mulilo',
		label: 'Katima Mulilo, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Okahandja',
		label: 'Okahandja, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Kuisebmond',
		label: 'Kuisebmond, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Aranos',
		label: 'Aranos, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Oshikango',
		label: 'Oshikango, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Otjiwarongo',
		label: 'Otjiwarongo, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Keetmanshoop',
		label: 'Keetmanshoop, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Gobabis',
		label: 'Gobabis, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Ondangwa',
		label: 'Ondangwa, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Oranjemund',
		label: 'Oranjemund, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Bethanien',
		label: 'Bethanien, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Outjo',
		label: 'Outjo, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Rundu',
		label: 'Rundu, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Oshakati',
		label: 'Oshakati, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Grootfontein',
		label: 'Grootfontein, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Lüderitz',
		label: 'Lüderitz, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Mariental',
		label: 'Mariental, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Khorixas',
		label: 'Khorixas, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Ongwediva',
		label: 'Ongwediva, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Omaruru',
		label: 'Omaruru, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Karasburg',
		label: 'Karasburg, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Opuwo',
		label: 'Opuwo, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Karibib',
		label: 'Karibib, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Okakarara',
		label: 'Okakarara, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Otavi',
		label: 'Otavi, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Usakos',
		label: 'Usakos, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Otjimbingwe',
		label: 'Otjimbingwe, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Ongandjera',
		label: 'Ongandjera, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Maltahöhe',
		label: 'Maltahöhe, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Warmbad',
		label: 'Warmbad, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Henties Bay',
		label: 'Henties Bay, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Rekhovot',
		label: 'Rekhovot, Namibia',
		type: 'city',
		flagClass: 'fi fi-na',
		isPopular: false,
	},
	{
		value: 'Nauru',
		label: 'Nauru',
		type: 'country',
		flagClass: 'fi fi-nr',
		isPopular: false,
	},
	{
		value: 'Yaren',
		label: 'Yaren, Nauru',
		type: 'city',
		flagClass: 'fi fi-nr',
		isPopular: false,
	},
	{
		value: 'Nepal',
		label: 'Nepal',
		type: 'country',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Kathmandu',
		label: 'Kathmandu, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Baglung',
		label: 'Baglung, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Lalitpur',
		label: 'Lalitpur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Pokhara',
		label: 'Pokhara, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Butwal',
		label: 'Butwal, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bhaktapur',
		label: 'Bhaktapur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Biratnagar',
		label: 'Biratnagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bharatpur',
		label: 'Bharatpur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Dharan',
		label: 'Dharan, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Rajbiraj',
		label: 'Rajbiraj, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Birganj',
		label: 'Birganj, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Damak',
		label: 'Damak, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Itahari',
		label: 'Itahari, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Janakpur',
		label: 'Janakpur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Tansen',
		label: 'Tansen, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Ilam',
		label: 'Ilam, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Jumla',
		label: 'Jumla, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Mahendranagar',
		label: 'Mahendranagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Kirtipur',
		label: 'Kirtipur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Tulsipur',
		label: 'Tulsipur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Byas',
		label: 'Byas, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Dhankuta',
		label: 'Dhankuta, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bhadrapur',
		label: 'Bhadrapur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Banepa',
		label: 'Banepa, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bidur',
		label: 'Bidur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Hetauda',
		label: 'Hetauda, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Dhangadi',
		label: 'Dhangadi, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Nepalganj',
		label: 'Nepalganj, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Madhyapur Thimi',
		label: 'Madhyapur Thimi, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Gulariya',
		label: 'Gulariya, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Mechinagar',
		label: 'Mechinagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Tribuvannagar',
		label: 'Tribuvannagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Leknath',
		label: 'Leknath, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Birendranagar',
		label: 'Birendranagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Kalaiya',
		label: 'Kalaiya, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Putalibazar',
		label: 'Putalibazar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Panauti',
		label: 'Panauti, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Gaur',
		label: 'Gaur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Jaleshwar',
		label: 'Jaleshwar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Triyuga',
		label: 'Triyuga, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Sidharthanagar',
		label: 'Sidharthanagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Tikapur',
		label: 'Tikapur, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Ratnanagar',
		label: 'Ratnanagar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Kamalamai',
		label: 'Kamalamai, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Kapilwastu',
		label: 'Kapilwastu, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Lahan',
		label: 'Lahan, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Prithivinarayan',
		label: 'Prithivinarayan, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Siraha',
		label: 'Siraha, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bhimeshwar',
		label: 'Bhimeshwar, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Inaruwa',
		label: 'Inaruwa, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Malangwa',
		label: 'Malangwa, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Khandbari',
		label: 'Khandbari, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Dipayal',
		label: 'Dipayal, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Waling',
		label: 'Waling, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Sinduli Marhi',
		label: 'Sinduli Marhi, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Salyan',
		label: 'Salyan, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bishalter',
		label: 'Bishalter, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Weni',
		label: 'Weni, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Bahadurganj',
		label: 'Bahadurganj, Nepal',
		type: 'city',
		flagClass: 'fi fi-np',
		isPopular: false,
	},
	{
		value: 'Amsterdam',
		label: 'Amsterdam, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: true,
	},
	{
		value: 'Rotterdam',
		label: 'Rotterdam, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: true,
	},
	{
		value: 'Den Haag',
		label: 'Den Haag, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Utrecht',
		label: 'Utrecht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Eindhoven',
		label: 'Eindhoven, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Nijmegen',
		label: 'Nijmegen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hilversum',
		label: 'Hilversum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Groningen',
		label: 'Groningen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Haarlem',
		label: 'Haarlem, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leiden',
		label: 'Leiden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Arnhem',
		label: 'Arnhem, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Delft',
		label: 'Delft, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Maastricht',
		label: 'Maastricht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Almere',
		label: 'Almere, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Breda',
		label: 'Breda, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Amersfoort',
		label: 'Amersfoort, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Amstelveen',
		label: 'Amstelveen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: "'s-Hertogenbosch",
		label: "'s-Hertogenbosch, Netherlands",
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Tilburg',
		label: 'Tilburg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Alkmaar',
		label: 'Alkmaar, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Enschede',
		label: 'Enschede, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zoetermeer',
		label: 'Zoetermeer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Helmond',
		label: 'Helmond, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zwolle',
		label: 'Zwolle, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leeuwarden',
		label: 'Leeuwarden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Apeldoorn',
		label: 'Apeldoorn, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Venlo',
		label: 'Venlo, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hoorn',
		label: 'Hoorn, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Dordrecht',
		label: 'Dordrecht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zaanstad',
		label: 'Zaanstad, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Lelystad',
		label: 'Lelystad, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Wageningen',
		label: 'Wageningen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Ede',
		label: 'Ede, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Rijswijk',
		label: 'Rijswijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Gouda',
		label: 'Gouda, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Nieuwegein',
		label: 'Nieuwegein, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heerlen',
		label: 'Heerlen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Haarlemmermeer',
		label: 'Haarlemmermeer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bussum',
		label: 'Bussum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Purmerend',
		label: 'Purmerend, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Doetinchem',
		label: 'Doetinchem, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zeist',
		label: 'Zeist, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hengelo',
		label: 'Hengelo, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leidschendam-Voorburg',
		label: 'Leidschendam-Voorburg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Emmen',
		label: 'Emmen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bergen op Zoom',
		label: 'Bergen op Zoom, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Roermond',
		label: 'Roermond, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Deventer',
		label: 'Deventer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Schiedam',
		label: 'Schiedam, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Beverwijk',
		label: 'Beverwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hardenberg',
		label: 'Hardenberg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heerhugowaard',
		label: 'Heerhugowaard, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zutphen',
		label: 'Zutphen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Culemborg',
		label: 'Culemborg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Woerden',
		label: 'Woerden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Veldhoven',
		label: 'Veldhoven, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Den Helder',
		label: 'Den Helder, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Wassenaar',
		label: 'Wassenaar, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Voorschoten',
		label: 'Voorschoten, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Huizen',
		label: 'Huizen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heemskerk',
		label: 'Heemskerk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Goes',
		label: 'Goes, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Nuenen',
		label: 'Nuenen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Roosendaal',
		label: 'Roosendaal, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oss',
		label: 'Oss, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Houten',
		label: 'Houten, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Diemen',
		label: 'Diemen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Weesp',
		label: 'Weesp, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zandvoort',
		label: 'Zandvoort, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Almelo',
		label: 'Almelo, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Alphen',
		label: 'Alphen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Assen',
		label: 'Assen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Barneveld',
		label: 'Barneveld, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Soest',
		label: 'Soest, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'De Bilt',
		label: 'De Bilt, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Dronten',
		label: 'Dronten, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Terneuzen',
		label: 'Terneuzen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Meppel',
		label: 'Meppel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Aalsmeer',
		label: 'Aalsmeer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Capelle',
		label: 'Capelle, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Veenendaal',
		label: 'Veenendaal, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hoogeveen',
		label: 'Hoogeveen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Middelburg',
		label: 'Middelburg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heemstede',
		label: 'Heemstede, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Vlaardingen',
		label: 'Vlaardingen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Ridderkerk',
		label: 'Ridderkerk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Maarsen',
		label: 'Maarsen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'IJsselstein',
		label: 'IJsselstein, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Vught',
		label: 'Vught, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Baarn',
		label: 'Baarn, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Noordwijk',
		label: 'Noordwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oosterhout',
		label: 'Oosterhout, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Kampen',
		label: 'Kampen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heerenveen',
		label: 'Heerenveen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Uden',
		label: 'Uden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Landgraaf',
		label: 'Landgraaf, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Gorinchem',
		label: 'Gorinchem, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Brunssum',
		label: 'Brunssum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oegstgeest',
		label: 'Oegstgeest, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Vianen',
		label: 'Vianen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Naarden',
		label: 'Naarden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Weert',
		label: 'Weert, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Tiel',
		label: 'Tiel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hellevoetsluis',
		label: 'Hellevoetsluis, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Wijchen',
		label: 'Wijchen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Stadskanaal',
		label: 'Stadskanaal, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Blaricum',
		label: 'Blaricum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Deurne',
		label: 'Deurne, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oud-Beijerland',
		label: 'Oud-Beijerland, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zeewolde',
		label: 'Zeewolde, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Berkel en Rodenrijs',
		label: 'Berkel en Rodenrijs, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bloemendaal',
		label: 'Bloemendaal, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Spijkenisse',
		label: 'Spijkenisse, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Waalwijk',
		label: 'Waalwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Steenwijk',
		label: 'Steenwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Harderwijk',
		label: 'Harderwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Venray',
		label: 'Venray, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Barendrecht',
		label: 'Barendrecht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Pijnacker-Nootdorp',
		label: 'Pijnacker-Nootdorp, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Castricum',
		label: 'Castricum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Sneek',
		label: 'Sneek, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Maassluis',
		label: 'Maassluis, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bergen',
		label: 'Bergen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Boxtel',
		label: 'Boxtel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leusden',
		label: 'Leusden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Winterswijk',
		label: 'Winterswijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leiderdorp',
		label: 'Leiderdorp, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Nieuwekerk aan den IJssel',
		label: 'Nieuwekerk aan den IJssel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hendrik-Ido-Ambacht',
		label: 'Hendrik-Ido-Ambacht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Lisse',
		label: 'Lisse, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hulst',
		label: 'Hulst, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Enkhuizen',
		label: 'Enkhuizen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Velsen',
		label: 'Velsen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Vlissingen',
		label: 'Vlissingen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Katwijk',
		label: 'Katwijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Laren',
		label: 'Laren, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Uitgeest',
		label: 'Uitgeest, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'De Ronde Venen',
		label: 'De Ronde Venen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Doorn',
		label: 'Doorn, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Waddinxveen',
		label: 'Waddinxveen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Uithoorn',
		label: 'Uithoorn, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Dongen',
		label: 'Dongen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leerdam',
		label: 'Leerdam, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bodegraven',
		label: 'Bodegraven, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Lichtenvoorde',
		label: 'Lichtenvoorde, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Lochem',
		label: 'Lochem, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Schagen',
		label: 'Schagen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Waalre',
		label: 'Waalre, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Brielle',
		label: 'Brielle, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Breukelen',
		label: 'Breukelen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Rheden',
		label: 'Rheden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zwijndrecht',
		label: 'Zwijndrecht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Neede',
		label: 'Neede, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hof van Twente',
		label: 'Hof van Twente, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Hoogezand-Sappemeer',
		label: 'Hoogezand-Sappemeer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Krimpen',
		label: 'Krimpen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Geldrop',
		label: 'Geldrop, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Achtkarspelen',
		label: 'Achtkarspelen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Gemert-Bakel',
		label: 'Gemert-Bakel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Ermelo',
		label: 'Ermelo, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Duiven',
		label: 'Duiven, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Aa en Hunze',
		label: 'Aa en Hunze, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Geldermalsen',
		label: 'Geldermalsen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Haaksbergen',
		label: 'Haaksbergen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Schijndel',
		label: 'Schijndel, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Heiloo',
		label: 'Heiloo, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Borne',
		label: 'Borne, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Haren',
		label: 'Haren, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oostburg',
		label: 'Oostburg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Valkenburg',
		label: 'Valkenburg, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Rhenen',
		label: 'Rhenen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Waterland',
		label: 'Waterland, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bergschenhoek',
		label: 'Bergschenhoek, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Anna Paulowna',
		label: 'Anna Paulowna, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bunnik',
		label: 'Bunnik, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Maasbree',
		label: 'Maasbree, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Eijsden',
		label: 'Eijsden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Nijkerk',
		label: 'Nijkerk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Moerdijk',
		label: 'Moerdijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Rijssen',
		label: 'Rijssen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Zevenhuizen-Moerkapelle',
		label: 'Zevenhuizen-Moerkapelle, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Midden-Drenthe',
		label: 'Midden-Drenthe, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Renkum',
		label: 'Renkum, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Oldenzaal',
		label: 'Oldenzaal, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Valkenswaard',
		label: 'Valkenswaard, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Papendrecht',
		label: 'Papendrecht, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Boxmeer',
		label: 'Boxmeer, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Best',
		label: 'Best, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Delfzijl',
		label: 'Delfzijl, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Veendam',
		label: 'Veendam, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Gilze en Rijen',
		label: 'Gilze en Rijen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Cuijk',
		label: 'Cuijk, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'De Wolden',
		label: 'De Wolden, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Steenbergen',
		label: 'Steenbergen, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Putten',
		label: 'Putten, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Loon op Zand',
		label: 'Loon op Zand, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Borsele',
		label: 'Borsele, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Monster',
		label: 'Monster, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Leek',
		label: 'Leek, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'Bunschoten',
		label: 'Bunschoten, Netherlands',
		type: 'city',
		flagClass: 'fi fi-nl',
		isPopular: false,
	},
	{
		value: 'New Caledonia',
		label: 'New Caledonia',
		type: 'country',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Nouméa',
		label: 'Nouméa, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Mont-Doré',
		label: 'Mont-Doré, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Païta',
		label: 'Païta, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Bourail',
		label: 'Bourail, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Dumbéa',
		label: 'Dumbéa, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Wé',
		label: 'Wé, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Tadine',
		label: 'Tadine, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Fayaoué',
		label: 'Fayaoué, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Houaïlu',
		label: 'Houaïlu, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Poindimié',
		label: 'Poindimié, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Koné',
		label: 'Koné, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Canala',
		label: 'Canala, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Pouébo',
		label: 'Pouébo, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'La Foa',
		label: 'La Foa, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Thio',
		label: 'Thio, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Ponerihouen',
		label: 'Ponerihouen, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Koumac',
		label: 'Koumac, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Hienghène',
		label: 'Hienghène, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Ouégoa',
		label: 'Ouégoa, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Poya',
		label: 'Poya, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Touho',
		label: 'Touho, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Vao',
		label: 'Vao, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Voh',
		label: 'Voh, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Kaala Gomén',
		label: 'Kaala Gomén, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Bouloupari',
		label: 'Bouloupari, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Yaté',
		label: 'Yaté, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Poum',
		label: 'Poum, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Pouembout',
		label: 'Pouembout, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Belep',
		label: 'Belep, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Moindou',
		label: 'Moindou, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Sarraméa',
		label: 'Sarraméa, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'Farino',
		label: 'Farino, New Caledonia',
		type: 'city',
		flagClass: 'fi fi-nc',
		isPopular: false,
	},
	{
		value: 'New Zealand',
		label: 'New Zealand',
		type: 'country',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Auckland',
		label: 'Auckland, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Christchurch',
		label: 'Christchurch, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wellington',
		label: 'Wellington, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hamilton',
		label: 'Hamilton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Dunedin',
		label: 'Dunedin, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tauranga',
		label: 'Tauranga, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Palmerston North',
		label: 'Palmerston North, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'North Shore',
		label: 'North Shore, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Whangarei',
		label: 'Whangarei, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ahipara',
		label: 'Ahipara, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Rotorua',
		label: 'Rotorua, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Nelson',
		label: 'Nelson, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Invercargill',
		label: 'Invercargill, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Lower Hutt',
		label: 'Lower Hutt, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Napier',
		label: 'Napier, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'New Plymouth',
		label: 'New Plymouth, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Manukau',
		label: 'Manukau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waitakere',
		label: 'Waitakere, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taupo',
		label: 'Taupo, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Pukekohe',
		label: 'Pukekohe, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wanganui',
		label: 'Wanganui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kerikeri',
		label: 'Kerikeri, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Upper Hutt',
		label: 'Upper Hutt, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Gisborne',
		label: 'Gisborne, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hastings',
		label: 'Hastings, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Porirua',
		label: 'Porirua, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Blenheim',
		label: 'Blenheim, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ashburton',
		label: 'Ashburton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Awamutu',
		label: 'Te Awamutu, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kapiti',
		label: 'Kapiti, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Oamaru',
		label: 'Oamaru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Queenstown',
		label: 'Queenstown, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Timaru',
		label: 'Timaru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Masterton',
		label: 'Masterton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Whakatane',
		label: 'Whakatane, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Cambridge',
		label: 'Cambridge, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Matamata',
		label: 'Matamata, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Orewa',
		label: 'Orewa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Rangiora',
		label: 'Rangiora, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hawera',
		label: 'Hawera, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waiheke',
		label: 'Waiheke, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Warkworth',
		label: 'Warkworth, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Thames',
		label: 'Thames, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wanaka',
		label: 'Wanaka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Arrowtown',
		label: 'Arrowtown, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Foxton',
		label: 'Foxton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaikohe',
		label: 'Kaikohe, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Feilding',
		label: 'Feilding, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Motueka',
		label: 'Motueka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Marton',
		label: 'Marton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waihi',
		label: 'Waihi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Katikati',
		label: 'Katikati, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Raglan',
		label: 'Raglan, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Mangawhai Heads',
		label: 'Mangawhai Heads, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Levin',
		label: 'Levin, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waiuku',
		label: 'Waiuku, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Otaki',
		label: 'Otaki, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaitaia',
		label: 'Kaitaia, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ngaruawahia',
		label: 'Ngaruawahia, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Balclutha',
		label: 'Balclutha, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Helensville',
		label: 'Helensville, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Amberley',
		label: 'Amberley, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Avarua',
		label: 'Avarua, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Horo',
		label: 'Te Horo, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Puke',
		label: 'Te Puke, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Paeroa',
		label: 'Paeroa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Aroha',
		label: 'Te Aroha, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Whitianga',
		label: 'Whitianga, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wellsford',
		label: 'Wellsford, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Martinborough',
		label: 'Martinborough, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Matata',
		label: 'Matata, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaiwaka',
		label: 'Kaiwaka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Havelock',
		label: 'Havelock, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Çust',
		label: 'Çust, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Awanui',
		label: 'Awanui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Otematata',
		label: 'Otematata, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tokoroa',
		label: 'Tokoroa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Greymouth',
		label: 'Greymouth, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Huntly',
		label: 'Huntly, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kawerau',
		label: 'Kawerau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Morrinsville',
		label: 'Morrinsville, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Dargaville',
		label: 'Dargaville, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Johannesburg',
		label: 'Johannesburg, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Kuiti',
		label: 'Te Kuiti, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Westport',
		label: 'Westport, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waihi Beach',
		label: 'Waihi Beach, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taihape',
		label: 'Taihape, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Bulls',
		label: 'Bulls, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Darfield',
		label: 'Darfield, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Coromandel',
		label: 'Coromandel, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ohakune',
		label: 'Ohakune, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Takaka',
		label: 'Takaka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ngatea',
		label: 'Ngatea, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Twizel',
		label: 'Twizel, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Clyde',
		label: 'Clyde, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaitangata',
		label: 'Kaitangata, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Russell',
		label: 'Russell, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Maungaturoto',
		label: 'Maungaturoto, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Dobson',
		label: 'Dobson, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waikuku',
		label: 'Waikuku, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ohaeawai',
		label: 'Ohaeawai, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Southbridge',
		label: 'Southbridge, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Mumbai',
		label: 'Mumbai, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Murchison',
		label: 'Murchison, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kawhia',
		label: 'Kawhia, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Käo',
		label: 'Käo, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Seddon',
		label: 'Seddon, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Rawene',
		label: 'Rawene, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Karamea',
		label: 'Karamea, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ratana',
		label: 'Ratana, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Warrington',
		label: 'Warrington, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Clinton',
		label: 'Clinton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Franz Josef',
		label: 'Franz Josef, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Lake Tekapo',
		label: 'Lake Tekapo, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Gore',
		label: 'Gore, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waitara',
		label: 'Waitara, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Dannevirke',
		label: 'Dannevirke, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taumarunui',
		label: 'Taumarunui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Opotiki',
		label: 'Opotiki, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Temuka',
		label: 'Temuka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Whangamata',
		label: 'Whangamata, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hokitika',
		label: 'Hokitika, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Cromwell',
		label: 'Cromwell, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waimate',
		label: 'Waimate, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Featherston',
		label: 'Featherston, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Rolleston',
		label: 'Rolleston, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Muriwai Beach',
		label: 'Muriwai Beach, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaikoura',
		label: 'Kaikoura, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Milton',
		label: 'Milton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Anau',
		label: 'Te Anau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waipawa',
		label: 'Waipawa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Oxford',
		label: 'Oxford, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taipa Bay-Mangonui',
		label: 'Taipa Bay-Mangonui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Edgecumbe',
		label: 'Edgecumbe, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Riverton',
		label: 'Riverton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waiouru',
		label: 'Waiouru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tairua',
		label: 'Tairua, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Woodville',
		label: 'Woodville, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ngunguru',
		label: 'Ngunguru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Patea',
		label: 'Patea, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Leeston',
		label: 'Leeston, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Mangakino',
		label: 'Mangakino, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Methven',
		label: 'Methven, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Parakai',
		label: 'Parakai, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Maketu',
		label: 'Maketu, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Paengaroa',
		label: 'Paengaroa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Algies Bay-Mahurangi',
		label: 'Algies Bay-Mahurangi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taneatua',
		label: 'Taneatua, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ranfurly',
		label: 'Ranfurly, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Otautau',
		label: 'Otautau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tirau',
		label: 'Tirau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Pauanui Beach',
		label: 'Pauanui Beach, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Fairlie',
		label: 'Fairlie, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Mamaku',
		label: 'Mamaku, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Okaihau',
		label: 'Okaihau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hanmer Springs',
		label: 'Hanmer Springs, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tuatapere',
		label: 'Tuatapere, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waitangi',
		label: 'Waitangi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waimana',
		label: 'Waimana, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Manutuke',
		label: 'Manutuke, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Roxburgh',
		label: 'Roxburgh, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Teko',
		label: 'Te Teko, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wallacetown',
		label: 'Wallacetown, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Rongotea',
		label: 'Rongotea, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Outram',
		label: 'Outram, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Haruru Falls',
		label: 'Haruru Falls, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Omapere and Opononi',
		label: 'Omapere and Opononi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Akaroa',
		label: 'Akaroa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Eketahuna',
		label: 'Eketahuna, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Takapau',
		label: 'Takapau, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Edendale',
		label: 'Edendale, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Wyndham',
		label: 'Wyndham, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Reporoa',
		label: 'Reporoa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kaingaroa Forest',
		label: 'Kaingaroa Forest, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Otane',
		label: 'Otane, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Karaka',
		label: 'Te Karaka, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tokomaru',
		label: 'Tokomaru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waharoa',
		label: 'Waharoa, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Himatangi',
		label: 'Himatangi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Athenree',
		label: 'Athenree, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Okato',
		label: 'Okato, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Hunterville',
		label: 'Hunterville, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kerepehi',
		label: 'Kerepehi, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Sefton',
		label: 'Sefton, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Sanson',
		label: 'Sanson, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Waitati',
		label: 'Waitati, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Te Kopuru',
		label: 'Te Kopuru, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Egmont Village',
		label: 'Egmont Village, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Lawrence',
		label: 'Lawrence, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Piopio',
		label: 'Piopio, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Pareora',
		label: 'Pareora, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Tokomaru Bay',
		label: 'Tokomaru Bay, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Lumsden',
		label: 'Lumsden, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Ruawai',
		label: 'Ruawai, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Halcombe',
		label: 'Halcombe, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Leigh',
		label: 'Leigh, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Taitapu',
		label: 'Taitapu, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Urenui',
		label: 'Urenui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Kakanui',
		label: 'Kakanui, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Culverden',
		label: 'Culverden, New Zealand',
		type: 'city',
		flagClass: 'fi fi-nz',
		isPopular: false,
	},
	{
		value: 'Nicaragua',
		label: 'Nicaragua',
		type: 'country',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Managua',
		label: 'Managua, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'León',
		label: 'León, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Granada',
		label: 'Granada, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Estelí',
		label: 'Estelí, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Matagalpa',
		label: 'Matagalpa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Acoyapa',
		label: 'Acoyapa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Masaya',
		label: 'Masaya, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Chinandega',
		label: 'Chinandega, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Tipitapa',
		label: 'Tipitapa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Juigalpa',
		label: 'Juigalpa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Diriamba',
		label: 'Diriamba, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Nagarote',
		label: 'Nagarote, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Chichigalpa',
		label: 'Chichigalpa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Rivas',
		label: 'Rivas, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Nindirí',
		label: 'Nindirí, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'La Trinidad',
		label: 'La Trinidad, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Diriomo',
		label: 'Diriomo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Bluefields',
		label: 'Bluefields, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'El Viejo',
		label: 'El Viejo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Nueva Guinea',
		label: 'Nueva Guinea, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Jinotega',
		label: 'Jinotega, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Ocotal',
		label: 'Ocotal, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Jinotepe',
		label: 'Jinotepe, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Puerto Cabezas',
		label: 'Puerto Cabezas, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Jalapa',
		label: 'Jalapa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Rafael del Sur',
		label: 'San Rafael del Sur, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Boaco',
		label: 'Boaco, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'La Paz Centro',
		label: 'La Paz Centro, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'El Rama',
		label: 'El Rama, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Corinto',
		label: 'Corinto, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Sébaco',
		label: 'Sébaco, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Marcos',
		label: 'San Marcos, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Nandaime',
		label: 'Nandaime, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Somoto',
		label: 'Somoto, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Masatepe',
		label: 'Masatepe, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Mateare',
		label: 'Mateare, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Camoapa',
		label: 'Camoapa, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Hueyotlipan',
		label: 'Hueyotlipan, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Somotillo',
		label: 'Somotillo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Ciudad Darío',
		label: 'Ciudad Darío, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Río Blanco',
		label: 'Río Blanco, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Bugaba',
		label: 'Bugaba, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Siuna',
		label: 'Siuna, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Quilalí',
		label: 'Quilalí, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Condega',
		label: 'Condega, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Ticuantepe',
		label: 'Ticuantepe, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Matiguás',
		label: 'Matiguás, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'El Sauce',
		label: 'El Sauce, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Villa Sandino',
		label: 'Villa Sandino, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Telica',
		label: 'Telica, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'El Jícaro',
		label: 'El Jícaro, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Rosita',
		label: 'Rosita, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Jorge',
		label: 'San Jorge, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Wiwilí',
		label: 'Wiwilí, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Larreynaga',
		label: 'Larreynaga, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Juan del Sur',
		label: 'San Juan del Sur, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Chiautzingo',
		label: 'Chiautzingo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Corn Island',
		label: 'Corn Island, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Waspán',
		label: 'Waspán, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Niquinohomo',
		label: 'Niquinohomo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Dolores',
		label: 'Dolores, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Isidro',
		label: 'San Isidro, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Santo Domingo',
		label: 'Santo Domingo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Nandasmo',
		label: 'Nandasmo, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Bonanza',
		label: 'Bonanza, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Puerto Morazán',
		label: 'Puerto Morazán, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Magdalena Tequisistlán',
		label: 'Magdalena Tequisistlán, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Waslala',
		label: 'Waslala, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Bayt Lahm',
		label: 'Bayt Lahm, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Bocana de Paiwas',
		label: 'Bocana de Paiwas, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Laguna de Perlas',
		label: 'Laguna de Perlas, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'San Miguelito',
		label: 'San Miguelito, Nicaragua',
		type: 'city',
		flagClass: 'fi fi-ni',
		isPopular: false,
	},
	{
		value: 'Niger',
		label: 'Niger',
		type: 'country',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Niamey',
		label: 'Niamey, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Agadez',
		label: 'Agadez, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tahoua',
		label: 'Tahoua, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: "Birni N'Konni",
		label: "Birni N'Konni, Niger",
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Dakoro',
		label: 'Dakoro, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tanout',
		label: 'Tanout, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Madarounfa',
		label: 'Madarounfa, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Zinder',
		label: 'Zinder, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Maradi',
		label: 'Maradi, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Arlit',
		label: 'Arlit, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Dosso',
		label: 'Dosso, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tessaoua',
		label: 'Tessaoua, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Dogondoutchi',
		label: 'Dogondoutchi, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Ayorou',
		label: 'Ayorou, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Mirriah',
		label: 'Mirriah, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: "Birni N'Gaouré",
		label: "Birni N'Gaouré, Niger",
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Gaya',
		label: 'Gaya, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Diffa',
		label: 'Diffa, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Téra',
		label: 'Téra, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Magaria',
		label: 'Magaria, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Illéla',
		label: 'Illéla, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Matameye',
		label: 'Matameye, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: "N'Guigmi",
		label: "N'Guigmi, Niger",
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tillabéry',
		label: 'Tillabéry, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tibiri',
		label: 'Tibiri, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Guidan Roumdji',
		label: 'Guidan Roumdji, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Filingué',
		label: 'Filingué, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Keita',
		label: 'Keita, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Maïné-Soroa',
		label: 'Maïné-Soroa, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Madaoua',
		label: 'Madaoua, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Ouallam',
		label: 'Ouallam, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Gouré',
		label: 'Gouré, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Mayahi',
		label: 'Mayahi, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Say',
		label: 'Say, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Kollo',
		label: 'Kollo, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Boboye',
		label: 'Boboye, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tchirozérine',
		label: 'Tchirozérine, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Kantché',
		label: 'Kantché, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Bouza',
		label: 'Bouza, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Aguié',
		label: 'Aguié, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Tchintabaraden',
		label: 'Tchintabaraden, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Bilma',
		label: 'Bilma, Niger',
		type: 'city',
		flagClass: 'fi fi-ne',
		isPopular: false,
	},
	{
		value: 'Nigeria',
		label: 'Nigeria',
		type: 'country',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Lagos',
		label: 'Lagos, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abuja',
		label: 'Abuja, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Port Harcourt',
		label: 'Port Harcourt, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Aba',
		label: 'Aba, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ibadan',
		label: 'Ibadan, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Benin',
		label: 'Benin, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Enugu',
		label: 'Enugu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Owerri',
		label: 'Owerri, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Warri',
		label: 'Warri, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kaduna',
		label: 'Kaduna, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abeokuta',
		label: 'Abeokuta, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Calabar',
		label: 'Calabar, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: '´Îsa',
		label: '´Îsa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kano',
		label: 'Kano, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Asaba',
		label: 'Asaba, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Jos',
		label: 'Jos, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikorodu',
		label: 'Ikorodu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Anambra',
		label: 'Anambra, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Surulere',
		label: 'Surulere, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Uyo',
		label: 'Uyo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ilorin',
		label: 'Ilorin, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Akure',
		label: 'Akure, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ijebu Ode',
		label: 'Ijebu Ode, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ife',
		label: 'Ife, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Onitsha',
		label: 'Onitsha, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oshogbo',
		label: 'Oshogbo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Umuahia',
		label: 'Umuahia, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oyo',
		label: 'Oyo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ekpoma',
		label: 'Ekpoma, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ondo',
		label: 'Ondo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Sapele',
		label: 'Sapele, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nsukka',
		label: 'Nsukka, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Egbeda',
		label: 'Egbeda, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Katsina',
		label: 'Katsina, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Agenebode',
		label: 'Agenebode, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Iseyin',
		label: 'Iseyin, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ado',
		label: 'Ado, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abua',
		label: 'Abua, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Minna',
		label: 'Minna, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Yenagoa',
		label: 'Yenagoa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Eket',
		label: 'Eket, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abakaliki',
		label: 'Abakaliki, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ogbomosho',
		label: 'Ogbomosho, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Makurdi',
		label: 'Makurdi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Yola',
		label: 'Yola, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Zaria',
		label: 'Zaria, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Sokoto',
		label: 'Sokoto, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Shagamu',
		label: 'Shagamu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nnewi',
		label: 'Nnewi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Isanlu',
		label: 'Isanlu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ilaro',
		label: 'Ilaro, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Enugu Ngwo',
		label: 'Enugu Ngwo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ajaokuta',
		label: 'Ajaokuta, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bauchi',
		label: 'Bauchi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Okrika',
		label: 'Okrika, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oron',
		label: 'Oron, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ojo',
		label: 'Ojo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Auchi',
		label: 'Auchi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Enugu Ezike',
		label: 'Enugu Ezike, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Agbara',
		label: 'Agbara, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ode',
		label: 'Ode, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ilesha',
		label: 'Ilesha, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikot Ekpene',
		label: 'Ikot Ekpene, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikene',
		label: 'Ikene, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ota',
		label: 'Ota, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Suleja',
		label: 'Suleja, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gwagwalada',
		label: 'Gwagwalada, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Igboho',
		label: 'Igboho, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ijesha',
		label: 'Ijesha, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Modakeke',
		label: 'Modakeke, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ijebu Igbo',
		label: 'Ijebu Igbo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abadan',
		label: 'Abadan, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Agbor',
		label: 'Agbor, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Rano',
		label: 'Rano, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Emure',
		label: 'Emure, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Garki',
		label: 'Garki, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abraka',
		label: 'Abraka, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Dekina',
		label: 'Dekina, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Omoko',
		label: 'Omoko, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Igarra',
		label: 'Igarra, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Umunede',
		label: 'Umunede, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ugep',
		label: 'Ugep, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikire',
		label: 'Ikire, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Abaji',
		label: 'Abaji, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikirun',
		label: 'Ikirun, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ejigbo',
		label: 'Ejigbo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Offa',
		label: 'Offa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Okigwe',
		label: 'Okigwe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ilero',
		label: 'Ilero, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nkpor',
		label: 'Nkpor, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Epe',
		label: 'Epe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Uburu',
		label: 'Uburu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Aguata',
		label: 'Aguata, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bukuru',
		label: 'Bukuru, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oka',
		label: 'Oka, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gwoza',
		label: 'Gwoza, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ohafia',
		label: 'Ohafia, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nkwerre',
		label: 'Nkwerre, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Lafiagi',
		label: 'Lafiagi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kwale',
		label: 'Kwale, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Donga',
		label: 'Donga, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Sabon Birnin Gwari',
		label: 'Sabon Birnin Gwari, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Egume',
		label: 'Egume, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ogoja',
		label: 'Ogoja, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Udi',
		label: 'Udi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oturkpo',
		label: 'Oturkpo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Oguta',
		label: 'Oguta, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Omu-Aran',
		label: 'Omu-Aran, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Owo',
		label: 'Owo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ibeju',
		label: 'Ibeju, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gombe',
		label: 'Gombe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Dadiya',
		label: 'Dadiya, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gboko',
		label: 'Gboko, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ilawe',
		label: 'Ilawe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Aboh',
		label: 'Aboh, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bonny',
		label: 'Bonny, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Jebba',
		label: 'Jebba, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Obosi',
		label: 'Obosi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ado Odo',
		label: 'Ado Odo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Amaigbo',
		label: 'Amaigbo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Pankshin',
		label: 'Pankshin, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Uromi',
		label: 'Uromi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Taki',
		label: 'Taki, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Hadejia',
		label: 'Hadejia, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Birnin Kebbi',
		label: 'Birnin Kebbi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Wukari',
		label: 'Wukari, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Keffi',
		label: 'Keffi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ughelli',
		label: 'Ughelli, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Agulu',
		label: 'Agulu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Opobo',
		label: 'Opobo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Babura',
		label: 'Babura, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Etiti',
		label: 'Etiti, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Fika',
		label: 'Fika, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Lokoja',
		label: 'Lokoja, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ezeagu',
		label: 'Ezeagu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kabba',
		label: 'Kabba, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Okpe',
		label: 'Okpe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Yelwa',
		label: 'Yelwa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Garkida',
		label: 'Garkida, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bori',
		label: 'Bori, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Fiditi',
		label: 'Fiditi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kurfi',
		label: 'Kurfi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ifon',
		label: 'Ifon, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Lalupon',
		label: 'Lalupon, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Zuba',
		label: 'Zuba, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Dakingari',
		label: 'Dakingari, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ipoti',
		label: 'Ipoti, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Aiyetoro',
		label: 'Aiyetoro, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Amper',
		label: 'Amper, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Idanre',
		label: 'Idanre, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Aramoko',
		label: 'Aramoko, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Shanono',
		label: 'Shanono, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ete',
		label: 'Ete, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Iperu',
		label: 'Iperu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kazaure',
		label: 'Kazaure, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Okwe',
		label: 'Okwe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Jada',
		label: 'Jada, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nafada',
		label: 'Nafada, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kaltungo',
		label: 'Kaltungo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Sabongari',
		label: 'Sabongari, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Awgu',
		label: 'Awgu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Jikamshi',
		label: 'Jikamshi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Nike',
		label: 'Nike, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Shiroro',
		label: 'Shiroro, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Chanchaga',
		label: 'Chanchaga, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Amagunze',
		label: 'Amagunze, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gulma',
		label: 'Gulma, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Giwa',
		label: 'Giwa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Igbor',
		label: 'Igbor, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gwadabawa',
		label: 'Gwadabawa, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Agbabu',
		label: 'Agbabu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Owode',
		label: 'Owode, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ringim',
		label: 'Ringim, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Mando',
		label: 'Mando, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Obudu',
		label: 'Obudu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Maiduguri',
		label: 'Maiduguri, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ubiaja',
		label: 'Ubiaja, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Kotorkoshi',
		label: 'Kotorkoshi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Geidam',
		label: 'Geidam, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ifaki',
		label: 'Ifaki, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Okene',
		label: 'Okene, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Biliri',
		label: 'Biliri, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Takum',
		label: 'Takum, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bebeji',
		label: 'Bebeji, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Chibok',
		label: 'Chibok, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Gwazo',
		label: 'Gwazo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Duku',
		label: 'Duku, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Chafe',
		label: 'Chafe, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Odigbo',
		label: 'Odigbo, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Damaturu',
		label: 'Damaturu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Babana',
		label: 'Babana, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Badeggi',
		label: 'Badeggi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Mubi',
		label: 'Mubi, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ogori',
		label: 'Ogori, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Langtang',
		label: 'Langtang, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ore',
		label: 'Ore, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Lajere',
		label: 'Lajere, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Odogbolu',
		label: 'Odogbolu, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Bida',
		label: 'Bida, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Ikare',
		label: 'Ikare, Nigeria',
		type: 'city',
		flagClass: 'fi fi-ng',
		isPopular: false,
	},
	{
		value: 'Niue',
		label: 'Niue',
		type: 'country',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Alofi',
		label: 'Alofi, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Avatele',
		label: 'Avatele, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Liku',
		label: 'Liku, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Hakupu',
		label: 'Hakupu, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Tamakautoga',
		label: 'Tamakautoga, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Mutalau',
		label: 'Mutalau, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Tuapa',
		label: 'Tuapa, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Lakepa',
		label: 'Lakepa, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Makefu',
		label: 'Makefu, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Hikutavake',
		label: 'Hikutavake, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Vaiea',
		label: 'Vaiea, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Toi',
		label: 'Toi, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Namukulu',
		label: 'Namukulu, Niue',
		type: 'city',
		flagClass: 'fi fi-nu',
		isPopular: false,
	},
	{
		value: 'Norfolk Island',
		label: 'Norfolk Island',
		type: 'country',
		flagClass: 'fi fi-nf',
		isPopular: false,
	},
	{
		value: 'Kingston-Blackmans Bay',
		label: 'Kingston-Blackmans Bay, Norfolk Island',
		type: 'city',
		flagClass: 'fi fi-nf',
		isPopular: false,
	},
	{
		value: 'North Macedonia',
		label: 'North Macedonia',
		type: 'country',
		flagClass: 'fi fi-mk',
		isPopular: false,
	},
	{
		value: 'Northern Mariana Islands',
		label: 'Northern Mariana Islands',
		type: 'country',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Garapan',
		label: 'Garapan, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Capital Hill',
		label: 'Capital Hill, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Koblerville',
		label: 'Koblerville, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'San Vicente',
		label: 'San Vicente, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Tanapag',
		label: 'Tanapag, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Chalan Kanoa',
		label: 'Chalan Kanoa, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Dandan',
		label: 'Dandan, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Gualo Rai',
		label: 'Gualo Rai, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Susupe',
		label: 'Susupe, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Songsong',
		label: 'Songsong, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'San Roque',
		label: 'San Roque, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Settlement',
		label: 'Settlement, Northern Mariana Islands',
		type: 'city',
		flagClass: 'fi fi-mp',
		isPopular: false,
	},
	{
		value: 'Trondheim',
		label: 'Trondheim, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Bergen',
		label: 'Bergen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stavanger',
		label: 'Stavanger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kristiansand',
		label: 'Kristiansand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Porsgrunn-Skien',
		label: 'Porsgrunn-Skien, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Alta',
		label: 'Alta, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fredrikstad-Sarpsborg',
		label: 'Fredrikstad-Sarpsborg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tønsberg',
		label: 'Tønsberg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Drammen',
		label: 'Drammen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ålesund',
		label: 'Ålesund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tromsø',
		label: 'Tromsø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sandane',
		label: 'Sandane, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Bodø',
		label: 'Bodø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Haugesund',
		label: 'Haugesund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sandefjord',
		label: 'Sandefjord, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Arendal',
		label: 'Arendal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hamar',
		label: 'Hamar, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Moss',
		label: 'Moss, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Larvik',
		label: 'Larvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lillehammer',
		label: 'Lillehammer, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Molde',
		label: 'Molde, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kongsberg',
		label: 'Kongsberg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Jessheim',
		label: 'Jessheim, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Horten',
		label: 'Horten, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kristiansund',
		label: 'Kristiansund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hammerfest',
		label: 'Hammerfest, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vestby',
		label: 'Vestby, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Halden',
		label: 'Halden, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Harstad',
		label: 'Harstad, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Elverum',
		label: 'Elverum, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Drøbak',
		label: 'Drøbak, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kongsvinger',
		label: 'Kongsvinger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Nesoddtangen',
		label: 'Nesoddtangen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Bryne',
		label: 'Bryne, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Å',
		label: 'Å, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Gjøvik',
		label: 'Gjøvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ski',
		label: 'Ski, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Mosjøen',
		label: 'Mosjøen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Namsos',
		label: 'Namsos, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ask',
		label: 'Ask, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lillesand',
		label: 'Lillesand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Volda',
		label: 'Volda, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sykkylven',
		label: 'Sykkylven, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Varhaug',
		label: 'Varhaug, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rena',
		label: 'Rena, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Askim',
		label: 'Askim, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Dale',
		label: 'Dale, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Grimstad',
		label: 'Grimstad, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Seljord',
		label: 'Seljord, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Notodden',
		label: 'Notodden, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Leksvik',
		label: 'Leksvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fetsund',
		label: 'Fetsund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vossevangen',
		label: 'Vossevangen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kragerø',
		label: 'Kragerø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Brønnøysund',
		label: 'Brønnøysund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Røros',
		label: 'Røros, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Eidsvoll',
		label: 'Eidsvoll, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Årnes',
		label: 'Årnes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Gol',
		label: 'Gol, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Geilo',
		label: 'Geilo, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tynset',
		label: 'Tynset, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hauge',
		label: 'Hauge, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Husnes',
		label: 'Husnes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Andebu',
		label: 'Andebu, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hønefoss',
		label: 'Hønefoss, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tingvollvågen',
		label: 'Tingvollvågen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ålgård-Figgjo',
		label: 'Ålgård-Figgjo, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Frogner',
		label: 'Frogner, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Levanger',
		label: 'Levanger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Førde',
		label: 'Førde, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Brumunddal',
		label: 'Brumunddal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ash',
		label: 'Ash, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Osøyro',
		label: 'Osøyro, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Søgne',
		label: 'Søgne, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Løkken Verk',
		label: 'Løkken Verk, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Orkanger-Fannrem',
		label: 'Orkanger-Fannrem, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ørsta',
		label: 'Ørsta, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sveio',
		label: 'Sveio, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Raufoss',
		label: 'Raufoss, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fauske',
		label: 'Fauske, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tananger',
		label: 'Tananger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Mysen',
		label: 'Mysen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Jørpeland',
		label: 'Jørpeland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ulsteinvik',
		label: 'Ulsteinvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fevik',
		label: 'Fevik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Risør',
		label: 'Risør, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Son-Store Brevik',
		label: 'Son-Store Brevik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sauda',
		label: 'Sauda, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sortland',
		label: 'Sortland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Jevnaker',
		label: 'Jevnaker, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Svolvær',
		label: 'Svolvær, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hommelvik',
		label: 'Hommelvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lierbyen',
		label: 'Lierbyen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lyngdal',
		label: 'Lyngdal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Svelvik',
		label: 'Svelvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fosnavåg-Leinstrand',
		label: 'Fosnavåg-Leinstrand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sagvåg',
		label: 'Sagvåg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Spydeberg',
		label: 'Spydeberg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Nordstrand',
		label: 'Nordstrand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sætre',
		label: 'Sætre, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rørvik',
		label: 'Rørvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Røyken',
		label: 'Røyken, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stokke',
		label: 'Stokke, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stranda',
		label: 'Stranda, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Skjervøy',
		label: 'Skjervøy, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tjøme',
		label: 'Tjøme, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Birkeland',
		label: 'Birkeland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Bjørkelangen',
		label: 'Bjørkelangen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Maura',
		label: 'Maura, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Brattvåg',
		label: 'Brattvåg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Gullhaug',
		label: 'Gullhaug, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Myre',
		label: 'Myre, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tvedestrand',
		label: 'Tvedestrand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hauknes',
		label: 'Hauknes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Skarnes',
		label: 'Skarnes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Blakstad',
		label: 'Blakstad, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Nodeland',
		label: 'Nodeland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Frekhaug',
		label: 'Frekhaug, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kolvereid',
		label: 'Kolvereid, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Ringebu',
		label: 'Ringebu, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sande',
		label: 'Sande, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vigeland',
		label: 'Vigeland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Berger',
		label: 'Berger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Isfjorden',
		label: 'Isfjorden, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lervik',
		label: 'Lervik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Svelgen',
		label: 'Svelgen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Mo i Rana',
		label: 'Mo i Rana, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Åros',
		label: 'Åros, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Berlevåg',
		label: 'Berlevåg, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Askøy',
		label: 'Askøy, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Narvik',
		label: 'Narvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vennesla',
		label: 'Vennesla, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Søfteland',
		label: 'Søfteland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Steinkjer',
		label: 'Steinkjer, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Eide',
		label: 'Eide, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Leirvik',
		label: 'Leirvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hagavik',
		label: 'Hagavik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Mandal',
		label: 'Mandal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Straumen',
		label: 'Straumen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Knarrevik-Straume',
		label: 'Knarrevik-Straume, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hjelset',
		label: 'Hjelset, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hvittingfoss',
		label: 'Hvittingfoss, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Råholt',
		label: 'Råholt, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Knappskog',
		label: 'Knappskog, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Florø',
		label: 'Florø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stamsund',
		label: 'Stamsund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Magnor',
		label: 'Magnor, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Skoger',
		label: 'Skoger, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Slevik',
		label: 'Slevik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Verdalsøra',
		label: 'Verdalsøra, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Etne',
		label: 'Etne, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kopervik',
		label: 'Kopervik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lundamo',
		label: 'Lundamo, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vaksdal',
		label: 'Vaksdal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Øyer',
		label: 'Øyer, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Storebø',
		label: 'Storebø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rosendal',
		label: 'Rosendal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Berkåk',
		label: 'Berkåk, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Indre Arna',
		label: 'Indre Arna, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Lørenfallet',
		label: 'Lørenfallet, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kleppe-Verdalen',
		label: 'Kleppe-Verdalen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Holmestrand',
		label: 'Holmestrand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sørkjosen',
		label: 'Sørkjosen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Malvik',
		label: 'Malvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sandnessjøen',
		label: 'Sandnessjøen, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tranby',
		label: 'Tranby, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Åmot-Geithus',
		label: 'Åmot-Geithus, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hommersåk',
		label: 'Hommersåk, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stavern',
		label: 'Stavern, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Flekkefjord',
		label: 'Flekkefjord, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kløfta',
		label: 'Kløfta, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kvernaland',
		label: 'Kvernaland, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vadsø',
		label: 'Vadsø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Nærbø',
		label: 'Nærbø, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rotnes',
		label: 'Rotnes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Melhus',
		label: 'Melhus, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Odda',
		label: 'Odda, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Brandbu-Jaren',
		label: 'Brandbu-Jaren, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sunndalsøra',
		label: 'Sunndalsøra, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Knarvik',
		label: 'Knarvik, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Moelv',
		label: 'Moelv, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Finnsnes',
		label: 'Finnsnes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Hareid',
		label: 'Hareid, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rakkestad',
		label: 'Rakkestad, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Rjukan',
		label: 'Rjukan, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Oppdal',
		label: 'Oppdal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Øvre Årdal',
		label: 'Øvre Årdal, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Sørumsand',
		label: 'Sørumsand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Vear',
		label: 'Vear, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Fanahammeren',
		label: 'Fanahammeren, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Skudeneshamn',
		label: 'Skudeneshamn, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Kirkenes',
		label: 'Kirkenes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Tofte',
		label: 'Tofte, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Måløy',
		label: 'Måløy, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Farsund',
		label: 'Farsund, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Flateby',
		label: 'Flateby, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Stokmarknes',
		label: 'Stokmarknes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Åsgårdstrand',
		label: 'Åsgårdstrand, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Andenes',
		label: 'Andenes, Norway',
		type: 'city',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Oman',
		label: 'Oman',
		type: 'country',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Masqat',
		label: 'Masqat, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Ruwi',
		label: 'Ruwi, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'al-Buraymi',
		label: 'al-Buraymi, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Qurm',
		label: 'Qurm, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Dhufar',
		label: 'Dhufar, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Madinat Qabus',
		label: 'Madinat Qabus, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'as-Sib',
		label: 'as-Sib, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Bawshar',
		label: 'Bawshar, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Suhar',
		label: 'Suhar, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Nizwa',
		label: 'Nizwa, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Sur',
		label: 'Sur, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Saham',
		label: 'Saham, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: '´Ibri',
		label: '´Ibri, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: "Bahla'",
		label: "Bahla', Oman",
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'al-Khaburah',
		label: 'al-Khaburah, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'al-Masna´ah',
		label: 'al-Masna´ah, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'as-Suwayq',
		label: 'as-Suwayq, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Shinas',
		label: 'Shinas, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Qurayyat',
		label: 'Qurayyat, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Ibra',
		label: 'Ibra, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Khasab',
		label: 'Khasab, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'ar-Rustaq',
		label: 'ar-Rustaq, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Marsa Matruh',
		label: 'Marsa Matruh, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'al-Marj',
		label: 'al-Marj, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'al-Mudaybi',
		label: 'al-Mudaybi, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Sumayl',
		label: 'Sumayl, Oman',
		type: 'city',
		flagClass: 'fi fi-om',
		isPopular: false,
	},
	{
		value: 'Pakistan',
		label: 'Pakistan',
		type: 'country',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Karachi',
		label: 'Karachi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Islamabad',
		label: 'Islamabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lahore',
		label: 'Lahore, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Rawalpindi',
		label: 'Rawalpindi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Faisalabad',
		label: 'Faisalabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Abottabad',
		label: 'Abottabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Peshawar',
		label: 'Peshawar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gujranwala',
		label: 'Gujranwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sialkot',
		label: 'Sialkot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Multan',
		label: 'Multan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Hyderabad',
		label: 'Hyderabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sargodha',
		label: 'Sargodha, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gujrat',
		label: 'Gujrat, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Quetta',
		label: 'Quetta, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jhelum',
		label: 'Jhelum, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Muzaffarabad',
		label: 'Muzaffarabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Swabi',
		label: 'Swabi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bahawalpur',
		label: 'Bahawalpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pattoki',
		label: 'Pattoki, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: '´Abdul Hakim',
		label: '´Abdul Hakim, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Rahim Yar Khan',
		label: 'Rahim Yar Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Hafizabad',
		label: 'Hafizabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lalamusa',
		label: 'Lalamusa, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Khanewal',
		label: 'Khanewal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chakwal',
		label: 'Chakwal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Attock',
		label: 'Attock, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Wah',
		label: 'Wah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Larkana',
		label: 'Larkana, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Talagang',
		label: 'Talagang, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mardan',
		label: 'Mardan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mandi Bahauddin',
		label: 'Mandi Bahauddin, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kulachi',
		label: 'Kulachi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kohat',
		label: 'Kohat, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Shakargarh',
		label: 'Shakargarh, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sukkur',
		label: 'Sukkur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kabirwala',
		label: 'Kabirwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dera Ghazi Khan',
		label: 'Dera Ghazi Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bannu',
		label: 'Bannu, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Okara',
		label: 'Okara, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sahiwal',
		label: 'Sahiwal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kharian',
		label: 'Kharian, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mansehra',
		label: 'Mansehra, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Narowal',
		label: 'Narowal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pasrur',
		label: 'Pasrur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Hasan Abdal',
		label: 'Hasan Abdal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhera',
		label: 'Bhera, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pindi Gheb',
		label: 'Pindi Gheb, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dadu',
		label: 'Dadu, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhakkar',
		label: 'Bhakkar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sanghar',
		label: 'Sanghar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Taunsa',
		label: 'Taunsa, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kamoke',
		label: 'Kamoke, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Rabwah',
		label: 'Rabwah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Charsadda',
		label: 'Charsadda, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Arifwala',
		label: 'Arifwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Hasilpur',
		label: 'Hasilpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ghotki',
		label: 'Ghotki, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Haripur',
		label: 'Haripur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mirpur Mathelo',
		label: 'Mirpur Mathelo, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Renala Khurd',
		label: 'Renala Khurd, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chitral',
		label: 'Chitral, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Murree',
		label: 'Murree, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Nawabshah',
		label: 'Nawabshah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mingaora',
		label: 'Mingaora, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sadiqabad',
		label: 'Sadiqabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jacobabad',
		label: 'Jacobabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lodhran',
		label: 'Lodhran, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhalwal',
		label: 'Bhalwal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lakki Marwat',
		label: 'Lakki Marwat, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pirmahal',
		label: 'Pirmahal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Karor Lal Esan',
		label: 'Karor Lal Esan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Shekhupura',
		label: 'Shekhupura, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pind Dadan Khan',
		label: 'Pind Dadan Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mirpur Khas',
		label: 'Mirpur Khas, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Matiari',
		label: 'Matiari, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mianwali',
		label: 'Mianwali, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Taxila',
		label: 'Taxila, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lieah',
		label: 'Lieah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gujar Khan',
		label: 'Gujar Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Islamkot',
		label: 'Islamkot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jampur',
		label: 'Jampur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gilgit',
		label: 'Gilgit, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Alipur Chatha',
		label: 'Alipur Chatha, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sarai Alamgir',
		label: 'Sarai Alamgir, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tordher',
		label: 'Tordher, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chiniot',
		label: 'Chiniot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kanganpur',
		label: 'Kanganpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gharo',
		label: 'Gharo, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jaranwala',
		label: 'Jaranwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Daharki',
		label: 'Daharki, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Naushehra',
		label: 'Naushehra, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mian Channun',
		label: 'Mian Channun, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Toba Tek Singh',
		label: 'Toba Tek Singh, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Fort Abbas',
		label: 'Fort Abbas, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Nowshera Virkan',
		label: 'Nowshera Virkan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pindi Bhattian',
		label: 'Pindi Bhattian, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mehrabpur',
		label: 'Mehrabpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Zafarwal',
		label: 'Zafarwal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kasur',
		label: 'Kasur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Burewala',
		label: 'Burewala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gojra',
		label: 'Gojra, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bahawalnagar',
		label: 'Bahawalnagar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tando Adam',
		label: 'Tando Adam, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chishtian Mandi',
		label: 'Chishtian Mandi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tando Allah Yar',
		label: 'Tando Allah Yar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chichawatni',
		label: 'Chichawatni, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sarai Sidhu',
		label: 'Sarai Sidhu, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tando Muhammad Khan',
		label: 'Tando Muhammad Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kotri',
		label: 'Kotri, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Shahdadkot',
		label: 'Shahdadkot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sambrial',
		label: 'Sambrial, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ghakar',
		label: 'Ghakar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Gwadar',
		label: 'Gwadar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Karoondi',
		label: 'Karoondi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Thatta',
		label: 'Thatta, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Umarkot',
		label: 'Umarkot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Badah',
		label: 'Badah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Malakwal',
		label: 'Malakwal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Alipur',
		label: 'Alipur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Naudero',
		label: 'Naudero, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sukheke',
		label: 'Sukheke, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Minchinabad',
		label: 'Minchinabad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jhawarian',
		label: 'Jhawarian, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kunri',
		label: 'Kunri, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Raja Jang',
		label: 'Raja Jang, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Chawinda',
		label: 'Chawinda, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ubauro',
		label: 'Ubauro, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Akora',
		label: 'Akora, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kotli Loharan',
		label: 'Kotli Loharan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Shikarpur',
		label: 'Shikarpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Muzaffargarh',
		label: 'Muzaffargarh, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kanpur',
		label: 'Kanpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Pakpattan',
		label: 'Pakpattan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhit Shah',
		label: 'Bhit Shah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Daska',
		label: 'Daska, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ahmadpur East',
		label: 'Ahmadpur East, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ghurgushti',
		label: 'Ghurgushti, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Vihari',
		label: 'Vihari, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kot Addu',
		label: 'Kot Addu, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mangla',
		label: 'Mangla, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tando Ghulam Ali',
		label: 'Tando Ghulam Ali, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Turbat',
		label: 'Turbat, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Choa Saidan Shah',
		label: 'Choa Saidan Shah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Badin',
		label: 'Badin, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dalbandin',
		label: 'Dalbandin, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Garhi Yasin',
		label: 'Garhi Yasin, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dokri',
		label: 'Dokri, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kot Abdul Malik',
		label: 'Kot Abdul Malik, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sobhodero',
		label: 'Sobhodero, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kahror Pakka',
		label: 'Kahror Pakka, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lakhi',
		label: 'Lakhi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhiria City',
		label: 'Bhiria City, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Mankera',
		label: 'Mankera, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Timargara',
		label: 'Timargara, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bakshshapur',
		label: 'Bakshshapur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kot Radha Kishan',
		label: 'Kot Radha Kishan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kamra',
		label: 'Kamra, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kandiari',
		label: 'Kandiari, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Usta Muhammad',
		label: 'Usta Muhammad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kario Ghanwar',
		label: 'Kario Ghanwar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ziarat',
		label: 'Ziarat, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jalalpur Pirwala',
		label: 'Jalalpur Pirwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Risalpur',
		label: 'Risalpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Topi',
		label: 'Topi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dunyapur',
		label: 'Dunyapur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'al-Karak',
		label: 'al-Karak, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tulamba',
		label: 'Tulamba, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kunjah',
		label: 'Kunjah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dijkot',
		label: 'Dijkot, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sujawal',
		label: 'Sujawal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sillanwali',
		label: 'Sillanwali, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kandiaro',
		label: 'Kandiaro, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Zaida',
		label: 'Zaida, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jhudo',
		label: 'Jhudo, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Amangarh',
		label: 'Amangarh, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ahmadpur Sial',
		label: 'Ahmadpur Sial, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Phalia',
		label: 'Phalia, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jhang',
		label: 'Jhang, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kot Samaba',
		label: 'Kot Samaba, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ranipur',
		label: 'Ranipur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kot Ghulam Mohammad',
		label: 'Kot Ghulam Mohammad, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Padidan',
		label: 'Padidan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dhoronaro',
		label: 'Dhoronaro, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Sarai Naurang',
		label: 'Sarai Naurang, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jand',
		label: 'Jand, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Fatehpur',
		label: 'Fatehpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dera Bugti',
		label: 'Dera Bugti, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Lachi',
		label: 'Lachi, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dajal',
		label: 'Dajal, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kamalia',
		label: 'Kamalia, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Khuzdar',
		label: 'Khuzdar, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Tharushah',
		label: 'Tharushah, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Dera Îsmail Khan',
		label: 'Dera Îsmail Khan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Bhopalwala',
		label: 'Bhopalwala, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Radhan',
		label: 'Radhan, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Ahmadpur Lumma',
		label: 'Ahmadpur Lumma, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jiwani',
		label: 'Jiwani, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kalabagh',
		label: 'Kalabagh, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Jalalpur',
		label: 'Jalalpur, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Kamar Mashani',
		label: 'Kamar Mashani, Pakistan',
		type: 'city',
		flagClass: 'fi fi-pk',
		isPopular: false,
	},
	{
		value: 'Palau',
		label: 'Palau',
		type: 'country',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Airai',
		label: 'Airai, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Koror',
		label: 'Koror, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Meyungs',
		label: 'Meyungs, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ulimang',
		label: 'Ulimang, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Kayangel',
		label: 'Kayangel, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Kloulklubed',
		label: 'Kloulklubed, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ngermechau',
		label: 'Ngermechau, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Melekeok',
		label: 'Melekeok, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Chol',
		label: 'Chol, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ngaramash',
		label: 'Ngaramash, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Imeong',
		label: 'Imeong, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ngerkeai',
		label: 'Ngerkeai, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ollei',
		label: 'Ollei, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Oikul',
		label: 'Oikul, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Ngetkip',
		label: 'Ngetkip, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Dongosaru',
		label: 'Dongosaru, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Hatohobei',
		label: 'Hatohobei, Palau',
		type: 'city',
		flagClass: 'fi fi-pw',
		isPopular: false,
	},
	{
		value: 'Palestine, State of',
		label: 'Palestine, State of',
		type: 'country',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Gaza City',
		label: 'Gaza City, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Ramallah',
		label: 'Ramallah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'al-Quds',
		label: 'al-Quds, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Tulkarm',
		label: 'Tulkarm, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Nabulus',
		label: 'Nabulus, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'al-Khalil',
		label: 'al-Khalil, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bayt Lahm',
		label: 'Bayt Lahm, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'ad-Dahiriyah',
		label: 'ad-Dahiriyah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bayt Sahur',
		label: 'Bayt Sahur, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Janin',
		label: 'Janin, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Khan Yunis',
		label: 'Khan Yunis, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Dayr-al-Balah',
		label: 'Dayr-al-Balah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'al-Birah',
		label: 'al-Birah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'ar-Ram',
		label: 'ar-Ram, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Rafah',
		label: 'Rafah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bayt Lahiyah',
		label: 'Bayt Lahiyah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Qalqilyah',
		label: 'Qalqilyah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Halhul',
		label: 'Halhul, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Tubas',
		label: 'Tubas, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bayt Jala',
		label: 'Bayt Jala, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Salfit',
		label: 'Salfit, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Jabaliyah',
		label: 'Jabaliyah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'al-Insayrat',
		label: 'al-Insayrat, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Yattah',
		label: 'Yattah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'al-Burayj',
		label: 'al-Burayj, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bani Suhaylah',
		label: 'Bani Suhaylah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Bayt Hanun',
		label: 'Bayt Hanun, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Ma´ale Adummim',
		label: 'Ma´ale Adummim, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Dura',
		label: 'Dura, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Ariha',
		label: 'Ariha, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Qabatiyah',
		label: 'Qabatiyah, Palestine, State of',
		type: 'city',
		flagClass: 'fi fi-ps',
		isPopular: false,
	},
	{
		value: 'Panama',
		label: 'Panama',
		type: 'country',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Panamá',
		label: 'Panamá, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Colón',
		label: 'Colón, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'David',
		label: 'David, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Aguacaliente',
		label: 'Aguacaliente, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'La Chorrera',
		label: 'La Chorrera, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Bocas del Toro',
		label: 'Bocas del Toro, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'San Miguelito',
		label: 'San Miguelito, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Bajo Boquete',
		label: 'Bajo Boquete, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Arraiján',
		label: 'Arraiján, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Portobelo',
		label: 'Portobelo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Cañazas',
		label: 'Cañazas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chame',
		label: 'Chame, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Río Sereno',
		label: 'Río Sereno, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Aiton',
		label: 'Aiton, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Las Tablas',
		label: 'Las Tablas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Los Santos',
		label: 'Los Santos, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Gualaca',
		label: 'Gualaca, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Parita',
		label: 'Parita, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Boquerón',
		label: 'Boquerón, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Tonosí',
		label: 'Tonosí, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chiriquí Grande',
		label: 'Chiriquí Grande, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Miguel de la Borda',
		label: 'Miguel de la Borda, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Pedasí',
		label: 'Pedasí, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Horconcitos',
		label: 'Horconcitos, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Changuinola',
		label: 'Changuinola, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Soná',
		label: 'Soná, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Puerto Armuelles',
		label: 'Puerto Armuelles, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Bugaba',
		label: 'Bugaba, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Penonomé',
		label: 'Penonomé, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Narganá',
		label: 'Narganá, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chepo',
		label: 'Chepo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Ocú',
		label: 'Ocú, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chitré',
		label: 'Chitré, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Aguadulce',
		label: 'Aguadulce, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Dolega',
		label: 'Dolega, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Natá',
		label: 'Natá, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Capira',
		label: 'Capira, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Montijo',
		label: 'Montijo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Atalaya',
		label: 'Atalaya, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'La Mesa',
		label: 'La Mesa, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Guararé',
		label: 'Guararé, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'La Palma',
		label: 'La Palma, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chichica',
		label: 'Chichica, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'La Pintada',
		label: 'La Pintada, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Las Palmas',
		label: 'Las Palmas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Tolé',
		label: 'Tolé, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Kusapin',
		label: 'Kusapin, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Santa Fé',
		label: 'Santa Fé, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Alanje',
		label: 'Alanje, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Cerro Iglesias',
		label: 'Cerro Iglesias, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Macaracas',
		label: 'Macaracas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Río de Jesús',
		label: 'Río de Jesús, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Calobre',
		label: 'Calobre, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Soloy',
		label: 'Soloy, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Pesé',
		label: 'Pesé, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Las Minas',
		label: 'Las Minas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Los Pozos',
		label: 'Los Pozos, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Río Sábalo',
		label: 'Río Sábalo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Bisira',
		label: 'Bisira, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'El Olingo',
		label: 'El Olingo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Ajoloapán',
		label: 'Ajoloapán, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Hato Pilón',
		label: 'Hato Pilón, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Chimán',
		label: 'Chimán, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Olá',
		label: 'Olá, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'El Real de Santa María',
		label: 'El Real de Santa María, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Las Lajas',
		label: 'Las Lajas, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Remedios',
		label: 'Remedios, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Taboga',
		label: 'Taboga, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Pocrí',
		label: 'Pocrí, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Nuevo Chagres',
		label: 'Nuevo Chagres, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Malabo',
		label: 'Malabo, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Playa Coronado',
		label: 'Playa Coronado, Panama',
		type: 'city',
		flagClass: 'fi fi-pa',
		isPopular: false,
	},
	{
		value: 'Papua New Guinea',
		label: 'Papua New Guinea',
		type: 'country',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Port Moresby',
		label: 'Port Moresby, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Aitape',
		label: 'Aitape, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Goroka',
		label: 'Goroka, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Lae',
		label: 'Lae, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Madang',
		label: 'Madang, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Wewak',
		label: 'Wewak, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kimbe',
		label: 'Kimbe, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Vanimo',
		label: 'Vanimo, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Mount Hagen',
		label: 'Mount Hagen, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Daru',
		label: 'Daru, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Alotau',
		label: 'Alotau, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Mendi',
		label: 'Mendi, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kiunga',
		label: 'Kiunga, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Lorengau',
		label: 'Lorengau, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kerema',
		label: 'Kerema, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Arawa',
		label: 'Arawa, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Rabaul',
		label: 'Rabaul, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kavieng',
		label: 'Kavieng, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Popondetta',
		label: 'Popondetta, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Bulolo',
		label: 'Bulolo, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Waw',
		label: 'Waw, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kundiawa',
		label: 'Kundiawa, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Wabag',
		label: 'Wabag, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kieta',
		label: 'Kieta, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kokoda',
		label: 'Kokoda, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kokopo',
		label: 'Kokopo, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Panguna',
		label: 'Panguna, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kainantu',
		label: 'Kainantu, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Morehead',
		label: 'Morehead, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Porgera',
		label: 'Porgera, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Sohano',
		label: 'Sohano, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Ambunti',
		label: 'Ambunti, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Samarai',
		label: 'Samarai, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Angoram',
		label: 'Angoram, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Namatanai',
		label: 'Namatanai, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Buin',
		label: 'Buin, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Laiagam',
		label: 'Laiagam, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Finschhafen',
		label: 'Finschhafen, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Kandrian',
		label: 'Kandrian, Papua New Guinea',
		type: 'city',
		flagClass: 'fi fi-pg',
		isPopular: false,
	},
	{
		value: 'Paraguay',
		label: 'Paraguay',
		type: 'country',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Asunción',
		label: 'Asunción, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ciudad del Este',
		label: 'Ciudad del Este, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Abaí',
		label: 'Abaí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Encarnación',
		label: 'Encarnación, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Germania',
		label: 'Nueva Germania, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Londres',
		label: 'Nueva Londres, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Juan Bautista de Ñeembucú',
		label: 'San Juan Bautista de Ñeembucú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'La Paz',
		label: 'La Paz, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Luque',
		label: 'Luque, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Lambaré',
		label: 'Lambaré, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Minga Guazú',
		label: 'Minga Guazú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Paraguarí',
		label: 'Paraguarí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ypacaraí',
		label: 'Ypacaraí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Bella Vista',
		label: 'Bella Vista, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Pedro del Paraná',
		label: 'San Pedro del Paraná, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Pirayú',
		label: 'Pirayú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yguazú',
		label: 'Yguazú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Caapucú',
		label: 'Caapucú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capitán Mauricio José Troche',
		label: 'Capitán Mauricio José Troche, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Delgado',
		label: 'General Delgado, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Buena Vista',
		label: 'Buena Vista, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Miguel',
		label: 'San Miguel, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Bernardino Caballero',
		label: 'General Bernardino Caballero, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yegros',
		label: 'Yegros, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Cerrito',
		label: 'Cerrito, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Eugenio Alejandrino Garay',
		label: 'General Eugenio Alejandrino Garay, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tres de Febrero',
		label: 'Tres de Febrero, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mayor Pablo Lagerenza',
		label: 'Mayor Pablo Lagerenza, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mayor José Dejesús Martínez',
		label: 'Mayor José Dejesús Martínez, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Domingo Martínez de Irala',
		label: 'Domingo Martínez de Irala, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ñumí',
		label: 'Ñumí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Puerto Pinasco',
		label: 'Puerto Pinasco, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capitán Meza',
		label: 'Capitán Meza, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Paso de Patria',
		label: 'Paso de Patria, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Primero de Marzo',
		label: 'Primero de Marzo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Quyquyho',
		label: 'Quyquyho, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ñacunday',
		label: 'Ñacunday, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Salvador',
		label: 'San Salvador, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Simón Bolívar',
		label: 'Simón Bolívar, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Cambyreta',
		label: 'Cambyreta, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Iruña',
		label: 'Iruña, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Veinticinco de Diciembre',
		label: 'Veinticinco de Diciembre, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Pablo',
		label: 'San Pablo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tavaí',
		label: 'Tavaí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Laureles',
		label: 'Laureles, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Marechal Francisco Solano López',
		label: 'Marechal Francisco Solano López, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mbocayty del Yhaguy',
		label: 'Mbocayty del Yhaguy, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa Oliva',
		label: 'Villa Oliva, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Lázaro',
		label: 'San Lázaro, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Colombia',
		label: 'Nueva Colombia, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itapúa Poty',
		label: 'Itapúa Poty, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Manila',
		label: 'Manila, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Félix Pérez Cardozo',
		label: 'Félix Pérez Cardozo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ybytimí',
		label: 'Ybytimí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Alto Verá',
		label: 'Alto Verá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Juan de Mena',
		label: 'Juan de Mena, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mbaracayú',
		label: 'Mbaracayú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San José Obrero',
		label: 'San José Obrero, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Amatlán',
		label: 'Amatlán, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'José Fasardi',
		label: 'José Fasardi, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Maciel',
		label: 'Maciel, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Rafael del Paraná',
		label: 'San Rafael del Paraná, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa Franca',
		label: 'Villa Franca, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Loma Grande',
		label: 'Loma Grande, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villalbín',
		label: 'Villalbín, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'La Pastoria',
		label: 'La Pastoria, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tebicuarymí',
		label: 'Tebicuarymí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Moisés Bertoni',
		label: 'Doctor Moisés Bertoni, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Guazu Cuá',
		label: 'Guazu Cuá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Borja',
		label: 'Borja, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Isla Umbú',
		label: 'Isla Umbú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itanará',
		label: 'Itanará, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Leandro Oviedo',
		label: 'Leandro Oviedo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tacuaras',
		label: 'Tacuaras, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'José Falcón',
		label: 'José Falcón, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Alborada',
		label: 'Nueva Alborada, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Escobar',
		label: 'Escobar, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tres Corrales',
		label: 'Tres Corrales, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yabebyry',
		label: 'Yabebyry, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Desmochados',
		label: 'Desmochados, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Botrell',
		label: 'Doctor Botrell, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Chiautzingo',
		label: 'Chiautzingo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capiatá',
		label: 'Capiatá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Fernando de la Mora',
		label: 'Fernando de la Mora, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Limpio',
		label: 'Limpio, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ñemby',
		label: 'Ñemby, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mariano Roque Alonso',
		label: 'Mariano Roque Alonso, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Pedro Juan Caballero',
		label: 'Pedro Juan Caballero, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa Elisa',
		label: 'Villa Elisa, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Caaguazú',
		label: 'Caaguazú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Coronel Oviedo',
		label: 'Coronel Oviedo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itauguá',
		label: 'Itauguá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Presidente Franco',
		label: 'Presidente Franco, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Hernandaríaz',
		label: 'Hernandaríaz, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villarrica',
		label: 'Villarrica, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Pilar',
		label: 'Pilar, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Caacupé',
		label: 'Caacupé, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itá',
		label: 'Itá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa Hayes',
		label: 'Villa Hayes, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Estanislao',
		label: 'San Estanislao, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ayolas',
		label: 'Ayolas, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tuxtepec',
		label: 'Tuxtepec, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villeta',
		label: 'Villeta, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Areguá',
		label: 'Areguá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Horqueta',
		label: 'Horqueta, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Eulogio Estigarribia',
		label: 'Doctor Eulogio Estigarribia, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Curuguaty',
		label: 'Curuguaty, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tobatí',
		label: 'Tobatí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Piribebuy',
		label: 'Piribebuy, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Coronel Bogado',
		label: 'Coronel Bogado, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Santa Rita',
		label: 'Santa Rita, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Guarambaré',
		label: 'Guarambaré, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Pedro de Ycuamandiyú',
		label: 'San Pedro de Ycuamandiyú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capitán Bado',
		label: 'Capitán Bado, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Eusebio Ayala',
		label: 'Eusebio Ayala, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Benjamín Aceval',
		label: 'Benjamín Aceval, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Filadelfia',
		label: 'Filadelfia, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Juan Nepomuceno',
		label: 'San Juan Nepomuceno, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Juan León Mallorquín',
		label: 'Doctor Juan León Mallorquín, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Jaguarão',
		label: 'Jaguarão, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Salto del Guairá',
		label: 'Salto del Guairá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Caazapá',
		label: 'Caazapá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ypané',
		label: 'Ypané, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Alberdi',
		label: 'Alberdi, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Carapeguá',
		label: 'Carapeguá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Repatriación',
		label: 'Repatriación, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Obligado',
		label: 'Obligado, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Marechal Estigarribia',
		label: 'Marechal Estigarribia, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Emboscada',
		label: 'Emboscada, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa del Rosario',
		label: 'Villa del Rosario, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San José de los Arroyos',
		label: 'San José de los Arroyos, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tomás Romero Pereira',
		label: 'Tomás Romero Pereira, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Menno',
		label: 'Menno, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nanawa',
		label: 'Nanawa, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Hohenau',
		label: 'Hohenau, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Quiindy',
		label: 'Quiindy, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ybycuí',
		label: 'Ybycuí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Juan Manuel Frutos',
		label: 'Doctor Juan Manuel Frutos, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Atyrá',
		label: 'Atyrá, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'La Victoria',
		label: 'La Victoria, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Altos',
		label: 'Altos, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yuty',
		label: 'Yuty, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Pedro P. Peña',
		label: 'Doctor Pedro P. Peña, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Iturbe',
		label: 'Iturbe, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mayor Otaño',
		label: 'Mayor Otaño, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Alberto',
		label: 'San Alberto, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Bernardino',
		label: 'San Bernardino, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Carmen del Paraná',
		label: 'Carmen del Paraná, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Juan Augusto Saldívar',
		label: 'Juan Augusto Saldívar, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'La Paloma',
		label: 'La Paloma, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Artigas',
		label: 'General Artigas, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itacurubí del Rosario',
		label: 'Itacurubí del Rosario, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Katueté',
		label: 'Katueté, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itacurubí de la Cordillera',
		label: 'Itacurubí de la Cordillera, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capiíbary',
		label: 'Capiíbary, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Fram',
		label: 'Fram, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Loreto',
		label: 'Loreto, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Acahay',
		label: 'Acahay, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: "Juan Emilio O'Leary",
		label: "Juan Emilio O'Leary, Paraguay",
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Esperanza',
		label: 'Nueva Esperanza, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Itaquyry',
		label: 'Itaquyry, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Vaquería',
		label: 'Vaquería, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Elizardo Aquino',
		label: 'General Elizardo Aquino, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Francisco Álvarez',
		label: 'General Francisco Álvarez, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Oaxaca',
		label: 'Oaxaca, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Nueva Italia de Ruiz',
		label: 'Nueva Italia de Ruiz, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yatytay',
		label: 'Yatytay, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Neuland',
		label: 'Neuland, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'La Colmena',
		label: 'La Colmena, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Los Cedrales',
		label: 'Los Cedrales, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Trinidad',
		label: 'Trinidad, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Jesús',
		label: 'Jesús, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ygatimi',
		label: 'Ygatimi, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Natalio',
		label: 'Natalio, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Capitán Miranda',
		label: 'Capitán Miranda, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Carayaó',
		label: 'Carayaó, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Lima',
		label: 'Lima, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Arroyos y Esteros',
		label: 'Arroyos y Esteros, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Fuerte Olimpo',
		label: 'Fuerte Olimpo, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mbocayaty',
		label: 'Mbocayaty, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Mbuyapey',
		label: 'Mbuyapey, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Villa Florida',
		label: 'Villa Florida, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Choré',
		label: 'Choré, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'San Cosme y Damián',
		label: 'San Cosme y Damián, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Tacuatí',
		label: 'Tacuatí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ajoloapán',
		label: 'Ajoloapán, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Doctor Cecilio Báez',
		label: 'Doctor Cecilio Báez, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Guayaibi',
		label: 'Guayaibi, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yhú',
		label: 'Yhú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Naranjal',
		label: 'Naranjal, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'General Isidro Resquín',
		label: 'General Isidro Resquín, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Sapucaí',
		label: 'Sapucaí, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Ypehú',
		label: 'Ypehú, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Yataity',
		label: 'Yataity, Paraguay',
		type: 'city',
		flagClass: 'fi fi-py',
		isPopular: false,
	},
	{
		value: 'Peru',
		label: 'Peru',
		type: 'country',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Lima',
		label: 'Lima, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Arequipa',
		label: 'Arequipa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cusco',
		label: 'Cusco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Trujillo',
		label: 'Trujillo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Abancay',
		label: 'Abancay, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chiclayo',
		label: 'Chiclayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Piura',
		label: 'Piura, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Lambayeque',
		label: 'Lambayeque, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chaclacayo',
		label: 'Chaclacayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Iquitos',
		label: 'Iquitos, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huancayo',
		label: 'Huancayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chimbote',
		label: 'Chimbote, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pucallpa',
		label: 'Pucallpa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tacna',
		label: 'Tacna, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ica',
		label: 'Ica, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huánuco',
		label: 'Huánuco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huaraz',
		label: 'Huaraz, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Jauja',
		label: 'Jauja, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chachapoyas',
		label: 'Chachapoyas, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Junín',
		label: 'Junín, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Azángaro',
		label: 'Azángaro, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Jepelacio',
		label: 'Jepelacio, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chincha Alta',
		label: 'Chincha Alta, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cajamarca',
		label: 'Cajamarca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Puno',
		label: 'Puno, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huacho',
		label: 'Huacho, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ilo',
		label: 'Ilo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Barranca',
		label: 'Barranca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chepén',
		label: 'Chepén, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Monsefú',
		label: 'Monsefú, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Guadalupe',
		label: 'Guadalupe, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huamachuco',
		label: 'Huamachuco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Andahuaylas',
		label: 'Andahuaylas, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ajoloapán',
		label: 'Ajoloapán, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Satipo',
		label: 'Satipo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ascope',
		label: 'Ascope, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Soritor',
		label: 'Soritor, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Oxapampa',
		label: 'Oxapampa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ilabaya',
		label: 'Ilabaya, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'El Alto',
		label: 'El Alto, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Morococha',
		label: 'Morococha, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Acobamba',
		label: 'Acobamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Caleta de Carquín',
		label: 'Caleta de Carquín, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Lircay',
		label: 'Lircay, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Llata',
		label: 'Llata, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Juliaca',
		label: 'Juliaca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ayacucho',
		label: 'Ayacucho, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tarapoto',
		label: 'Tarapoto, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Orcotuna',
		label: 'Orcotuna, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huaral',
		label: 'Huaral, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tarma',
		label: 'Tarma, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huancavelica',
		label: 'Huancavelica, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Moyobamba',
		label: 'Moyobamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tambopata',
		label: 'Tambopata, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Sicuani',
		label: 'Sicuani, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Saña',
		label: 'Saña, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Juanjuí',
		label: 'Juanjuí, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ferreñafe',
		label: 'Ferreñafe, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Imperial',
		label: 'Imperial, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Nuevo Imperial',
		label: 'Nuevo Imperial, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Puerto Maldonado',
		label: 'Puerto Maldonado, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Unión',
		label: 'La Unión, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Oroya',
		label: 'La Oroya, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Arena',
		label: 'La Arena, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chocope',
		label: 'Chocope, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Paramonga',
		label: 'Paramonga, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pacasmayo',
		label: 'Pacasmayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chancay',
		label: 'Chancay, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chaupimarca',
		label: 'Chaupimarca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Hualmay',
		label: 'Hualmay, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Mollendo',
		label: 'Mollendo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tocache',
		label: 'Tocache, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tambo Grande',
		label: 'Tambo Grande, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San Vicente de Cañete',
		label: 'San Vicente de Cañete, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Peca',
		label: 'La Peca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa Ana',
		label: 'Santa Ana, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Rioja',
		label: 'Rioja, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Laredo',
		label: 'Laredo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Marcavélica',
		label: 'Marcavélica, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Querecotillo',
		label: 'Querecotillo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Yanacancha',
		label: 'Yanacancha, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Nazca',
		label: 'Nazca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huaura',
		label: 'Huaura, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Moche',
		label: 'Moche, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santiago de Cao',
		label: 'Santiago de Cao, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Sechura',
		label: 'Sechura, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Paucarpata',
		label: 'Paucarpata, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Casma',
		label: 'Casma, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Paiján',
		label: 'Paiján, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Virú',
		label: 'Virú, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Requena',
		label: 'Requena, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Bagua Grande',
		label: 'Bagua Grande, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ayaviri',
		label: 'Ayaviri, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Corrales',
		label: 'Corrales, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huanta',
		label: 'Huanta, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Malaita',
		label: 'Malaita, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pachacámac',
		label: 'Pachacámac, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huanchanco',
		label: 'Huanchanco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Uchiza',
		label: 'Uchiza, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Zarumilla',
		label: 'Zarumilla, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Camaná',
		label: 'Camaná, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huarmey',
		label: 'Huarmey, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ilave',
		label: 'Ilave, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San Pedro de Lloc',
		label: 'San Pedro de Lloc, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chongoyape',
		label: 'Chongoyape, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San Clemente',
		label: 'San Clemente, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Marcona',
		label: 'Marcona, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pimentel',
		label: 'Pimentel, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Bojaya',
		label: 'Bojaya, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Choishco',
		label: 'Choishco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chicama',
		label: 'Chicama, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Supe',
		label: 'Supe, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Apaseo el Grande',
		label: 'Apaseo el Grande, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Saposoa',
		label: 'Saposoa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Celendín',
		label: 'Celendín, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cutervo',
		label: 'Cutervo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chota',
		label: 'Chota, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Brea',
		label: 'La Brea, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa',
		label: 'Santa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chilca',
		label: 'Chilca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Contamana',
		label: 'Contamana, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa Rosa de Saco',
		label: 'Santa Rosa de Saco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Etén',
		label: 'Etén, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Motupe',
		label: 'Motupe, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa Maria de Lamas',
		label: 'Santa Maria de Lamas, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Colán',
		label: 'Colán, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cajabamba',
		label: 'Cajabamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Bambamarca',
		label: 'Bambamarca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Quillabamba',
		label: 'Quillabamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Yanahuara',
		label: 'Yanahuara, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pueblo Nuevo',
		label: 'Pueblo Nuevo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Supe Puerto',
		label: 'Supe Puerto, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tabalosos',
		label: 'Tabalosos, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Vice',
		label: 'Vice, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pativilca',
		label: 'Pativilca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Zorritos',
		label: 'Zorritos, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Nauta',
		label: 'Nauta, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Morropón',
		label: 'Morropón, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Concepción',
		label: 'Concepción, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tupac Amaru Inca',
		label: 'Tupac Amaru Inca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Caraz',
		label: 'Caraz, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Puquío',
		label: 'Puquío, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ulma',
		label: 'Ulma, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tingo María',
		label: 'Tingo María, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Vista Alegre',
		label: 'Vista Alegre, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Yunguyo',
		label: 'Yunguyo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Otuzco',
		label: 'Otuzco, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Salaverry',
		label: 'Salaverry, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Olmos',
		label: 'Olmos, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Reque',
		label: 'Reque, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huamantla',
		label: 'Huamantla, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San José de Sisa',
		label: 'San José de Sisa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Lagunas',
		label: 'Lagunas, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Calca',
		label: 'Calca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Carhuamayo',
		label: 'Carhuamayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chupaca',
		label: 'Chupaca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Quiruvilca',
		label: 'Quiruvilca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Yauya',
		label: 'Yauya, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Subtanjalla',
		label: 'Subtanjalla, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Aguas Verdes',
		label: 'Aguas Verdes, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Las Lomas',
		label: 'Las Lomas, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San Jerónimo de Tunán',
		label: 'San Jerónimo de Tunán, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Campoverde',
		label: 'Campoverde, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cocachacra',
		label: 'Cocachacra, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pacanga',
		label: 'Pacanga, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pilcomayo',
		label: 'Pilcomayo, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huancabamba',
		label: 'Huancabamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Putina',
		label: 'Putina, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'La Huaca',
		label: 'La Huaca, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chazuta',
		label: 'Chazuta, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'San Ignacio',
		label: 'San Ignacio, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Huancane',
		label: 'Huancane, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Los Aquijes',
		label: 'Los Aquijes, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Buenos Aires',
		label: 'Buenos Aires, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Coracora',
		label: 'Coracora, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Pacocha',
		label: 'Pacocha, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Urubamba',
		label: 'Urubamba, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Villa Rica',
		label: 'Villa Rica, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Mochumí',
		label: 'Mochumí, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Talavera',
		label: 'Talavera, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Cajaruro',
		label: 'Cajaruro, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Juli',
		label: 'Juli, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Máncora',
		label: 'Máncora, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Chicla',
		label: 'Chicla, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Vargas Guerra',
		label: 'Vargas Guerra, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Juan Lacaze',
		label: 'Juan Lacaze, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Quilmaná',
		label: 'Quilmaná, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Túcume',
		label: 'Túcume, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Torata',
		label: 'Torata, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Santa Eulalia',
		label: 'Santa Eulalia, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Oyón',
		label: 'Oyón, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Perené',
		label: 'Perené, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Tuxtepec',
		label: 'Tuxtepec, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Acolla',
		label: 'Acolla, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Ambos',
		label: 'Ambos, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Mazamari',
		label: 'Mazamari, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Sicaya',
		label: 'Sicaya, Peru',
		type: 'city',
		flagClass: 'fi fi-pe',
		isPopular: false,
	},
	{
		value: 'Philippines',
		label: 'Philippines',
		type: 'country',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Manila',
		label: 'Manila, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cebu',
		label: 'Cebu, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cavite',
		label: 'Cavite, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Davao',
		label: 'Davao, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Ángeles',
		label: 'Ángeles, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Baguio',
		label: 'Baguio, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Antipolo',
		label: 'Antipolo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Iloilo',
		label: 'Iloilo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bacolod',
		label: 'Bacolod, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Batangas',
		label: 'Batangas, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cagayan de Oro',
		label: 'Cagayan de Oro, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cainta',
		label: 'Cainta, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tacloban',
		label: 'Tacloban, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Zamboanga',
		label: 'Zamboanga, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Dumaguete',
		label: 'Dumaguete, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Iligan',
		label: 'Iligan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Olongapo',
		label: 'Olongapo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tarlac',
		label: 'Tarlac, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Malolos',
		label: 'Malolos, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Lucena',
		label: 'Lucena, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'San Pedro',
		label: 'San Pedro, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Naga',
		label: 'Naga, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Dagupan',
		label: 'Dagupan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bacoor',
		label: 'Bacoor, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Calamba',
		label: 'Calamba, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Los Baños',
		label: 'Los Baños, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cabanatuan',
		label: 'Cabanatuan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Butuan',
		label: 'Butuan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Legaspi',
		label: 'Legaspi, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'General Santos',
		label: 'General Santos, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'San Pablo',
		label: 'San Pablo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Meycauayan',
		label: 'Meycauayan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'San Fernando',
		label: 'San Fernando, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Biñan',
		label: 'Biñan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Taytay',
		label: 'Taytay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Angono',
		label: 'Angono, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Ozamiz',
		label: 'Ozamiz, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Baliuag',
		label: 'Baliuag, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tagbilaran',
		label: 'Tagbilaran, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cotabato',
		label: 'Cotabato, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Marawi',
		label: 'Marawi, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Montalban',
		label: 'Montalban, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Laoag',
		label: 'Laoag, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Puerto Princessa',
		label: 'Puerto Princessa, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bocaue',
		label: 'Bocaue, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tagaytay',
		label: 'Tagaytay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Dipolog',
		label: 'Dipolog, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Vigan',
		label: 'Vigan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Mandaue',
		label: 'Mandaue, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Dasmariñas',
		label: 'Dasmariñas, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Binangonan',
		label: 'Binangonan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Sorsogon',
		label: 'Sorsogon, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Mati',
		label: 'Mati, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Isabela',
		label: 'Isabela, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Koronadal',
		label: 'Koronadal, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Surigao',
		label: 'Surigao, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Lapu-Lapu',
		label: 'Lapu-Lapu, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Daet',
		label: 'Daet, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Roxas',
		label: 'Roxas, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Mariveles',
		label: 'Mariveles, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Lipa',
		label: 'Lipa, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Pagadian',
		label: 'Pagadian, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tagum',
		label: 'Tagum, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tuguegarao',
		label: 'Tuguegarao, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Mabalacat',
		label: 'Mabalacat, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Pulilan',
		label: 'Pulilan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Digos',
		label: 'Digos, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Santiago',
		label: 'Santiago, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Gapan',
		label: 'Gapan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bislig',
		label: 'Bislig, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Calbayog',
		label: 'Calbayog, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Calumpit',
		label: 'Calumpit, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bais',
		label: 'Bais, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Hagonoy',
		label: 'Hagonoy, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Gingoog',
		label: 'Gingoog, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Iriga',
		label: 'Iriga, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Catarama',
		label: 'Catarama, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Guiguinto',
		label: 'Guiguinto, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Kabankalan',
		label: 'Kabankalan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bago',
		label: 'Bago, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Atenco',
		label: 'Atenco, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tanay',
		label: 'Tanay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Catbalogan',
		label: 'Catbalogan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Silay',
		label: 'Silay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Macabebe',
		label: 'Macabebe, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Dapitan',
		label: 'Dapitan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Balagtas',
		label: 'Balagtas, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Obando',
		label: 'Obando, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Solano',
		label: 'Solano, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Bangued',
		label: 'Bangued, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Cádiz',
		label: 'Cádiz, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Trece Martires',
		label: 'Trece Martires, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'La Carlota',
		label: 'La Carlota, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Toledo',
		label: 'Toledo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'General Mariano Alvarez',
		label: 'General Mariano Alvarez, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Jolo',
		label: 'Jolo, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Victorias',
		label: 'Victorias, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Talisay',
		label: 'Talisay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Kawit',
		label: 'Kawit, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Sultan Kudarat',
		label: 'Sultan Kudarat, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Mangaldan',
		label: 'Mangaldan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Polomoloc',
		label: 'Polomoloc, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Manaoag',
		label: 'Manaoag, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Sagay',
		label: 'Sagay, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Binalbagan',
		label: 'Binalbagan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Guagua',
		label: 'Guagua, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tangub',
		label: 'Tangub, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Uíge',
		label: 'Uíge, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Tanza',
		label: 'Tanza, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Pasig City',
		label: 'Pasig City, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Liliw',
		label: 'Liliw, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Makati',
		label: 'Makati, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'City of Balanga',
		label: 'City of Balanga, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Danao',
		label: 'Danao, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Hueyotlipan',
		label: 'Hueyotlipan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Santa Catalina',
		label: 'Santa Catalina, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'El Rosario',
		label: 'El Rosario, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Taal',
		label: 'Taal, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Canlaon',
		label: 'Canlaon, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Quezon City',
		label: 'Quezon City, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Palayan',
		label: 'Palayan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Pulupandan',
		label: 'Pulupandan, Philippines',
		type: 'city',
		flagClass: 'fi fi-ph',
		isPopular: false,
	},
	{
		value: 'Pitcairn',
		label: 'Pitcairn',
		type: 'country',
		flagClass: 'fi fi-pn',
		isPopular: false,
	},
	{
		value: 'Poznan',
		label: 'Poznan, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kraków',
		label: 'Kraków, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wroclaw',
		label: 'Wroclaw, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Łódź',
		label: 'Łódź, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Szczecin',
		label: 'Szczecin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Aleksandrów Kujawski',
		label: 'Aleksandrów Kujawski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lublin',
		label: 'Lublin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gdansk',
		label: 'Gdansk, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Katowice',
		label: 'Katowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gdynia',
		label: 'Gdynia, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Torun',
		label: 'Torun, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gliwice',
		label: 'Gliwice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Rzeszów',
		label: 'Rzeszów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bydgoszcz',
		label: 'Bydgoszcz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bialystok',
		label: 'Bialystok, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bielsko-Biala',
		label: 'Bielsko-Biala, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Olsztyn',
		label: 'Olsztyn, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Opole',
		label: 'Opole, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kielce',
		label: 'Kielce, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Radom',
		label: 'Radom, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gorzów Wielkopolski',
		label: 'Gorzów Wielkopolski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Koszalin',
		label: 'Koszalin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Czestochowa',
		label: 'Czestochowa, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sopot',
		label: 'Sopot, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowa Sól',
		label: 'Nowa Sól, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Brodnica',
		label: 'Brodnica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bytom',
		label: 'Bytom, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Walbrzych',
		label: 'Walbrzych, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Stalowa Wola',
		label: 'Stalowa Wola, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Jaworzno',
		label: 'Jaworzno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zamosc',
		label: 'Zamosc, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Starachowice',
		label: 'Starachowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sandomierz',
		label: 'Sandomierz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Tychy',
		label: 'Tychy, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Plock',
		label: 'Plock, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Tarnów',
		label: 'Tarnów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Glogów',
		label: 'Glogów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Tarnobrzeg',
		label: 'Tarnobrzeg, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Piaseczno',
		label: 'Piaseczno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zabrze',
		label: 'Zabrze, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Rybnik',
		label: 'Rybnik, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Elblag',
		label: 'Elblag, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Slupsk',
		label: 'Slupsk, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Jastrzebie-Zdrój',
		label: 'Jastrzebie-Zdrój, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ostrów Wielkopolski',
		label: 'Ostrów Wielkopolski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bedzin',
		label: 'Bedzin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Skierniewice',
		label: 'Skierniewice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Krosno',
		label: 'Krosno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ciechanów',
		label: 'Ciechanów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Oswiecim',
		label: 'Oswiecim, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sochaczew',
		label: 'Sochaczew, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Biskupiec',
		label: 'Biskupiec, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bochnia',
		label: 'Bochnia, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lubartów',
		label: 'Lubartów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wloclawek',
		label: 'Wloclawek, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kalisz',
		label: 'Kalisz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Piotrków Trybunalski',
		label: 'Piotrków Trybunalski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Inowroclaw',
		label: 'Inowroclaw, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pila',
		label: 'Pila, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Przemysl',
		label: 'Przemysl, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zory',
		label: 'Zory, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Swidnica',
		label: 'Swidnica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Biala Podlaska',
		label: 'Biala Podlaska, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Legionowo',
		label: 'Legionowo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Skarzysko-Kamienna',
		label: 'Skarzysko-Kamienna, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Radomsko',
		label: 'Radomsko, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wegrów',
		label: 'Wegrów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kolobrzeg',
		label: 'Kolobrzeg, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sieradz',
		label: 'Sieradz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Rumia',
		label: 'Rumia, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Swinoujscie',
		label: 'Swinoujscie, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wegorzewo',
		label: 'Wegorzewo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Chrzanów',
		label: 'Chrzanów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Jaroslaw',
		label: 'Jaroslaw, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zary',
		label: 'Zary, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Szczecinek',
		label: 'Szczecinek, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Brzeg',
		label: 'Brzeg, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kwidzyn',
		label: 'Kwidzyn, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Dzierzoniów',
		label: 'Dzierzoniów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Police',
		label: 'Police, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zywiec',
		label: 'Zywiec, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Luków',
		label: 'Luków, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gorlice',
		label: 'Gorlice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Czersk',
		label: 'Czersk, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wyszków',
		label: 'Wyszków, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Grodzisk Mazowiecki',
		label: 'Grodzisk Mazowiecki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Koscian',
		label: 'Koscian, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Fribourg',
		label: 'Fribourg, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Laziska Górne',
		label: 'Laziska Górne, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Mragowo',
		label: 'Mragowo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gostynin',
		label: 'Gostynin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wadowice',
		label: 'Wadowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kety',
		label: 'Kety, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pisz',
		label: 'Pisz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sokolów Podlaski',
		label: 'Sokolów Podlaski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Reda',
		label: 'Reda, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Miedzyrzec Podlaski',
		label: 'Miedzyrzec Podlaski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sosnowiec',
		label: 'Sosnowiec, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowogard',
		label: 'Nowogard, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Radzyn Podlaski',
		label: 'Radzyn Podlaski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Chorzów',
		label: 'Chorzów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nisko',
		label: 'Nisko, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Legnica',
		label: 'Legnica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Grudziadz',
		label: 'Grudziadz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowy Sacz',
		label: 'Nowy Sacz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Konin',
		label: 'Konin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Glucholazy',
		label: 'Glucholazy, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lubin',
		label: 'Lubin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Myslowice',
		label: 'Myslowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lomianki',
		label: 'Lomianki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gniezno',
		label: 'Gniezno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Suwalki',
		label: 'Suwalki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wlodawa',
		label: 'Wlodawa, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zgierz',
		label: 'Zgierz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pulawy',
		label: 'Pulawy, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wodzislaw Slaski',
		label: 'Wodzislaw Slaski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nysa',
		label: 'Nysa, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Krosno Odrzanskie',
		label: 'Krosno Odrzanskie, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Debica',
		label: 'Debica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Blonie',
		label: 'Blonie, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zdunska Wola',
		label: 'Zdunska Wola, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Otwock',
		label: 'Otwock, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Mosina',
		label: 'Mosina, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zyrardów',
		label: 'Zyrardów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Brzeszcze',
		label: 'Brzeszcze, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Boleslawiec',
		label: 'Boleslawiec, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Janów Lubelski',
		label: 'Janów Lubelski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Drawsko Pomorskie',
		label: 'Drawsko Pomorskie, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Olkusz',
		label: 'Olkusz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Góra Kalwaria',
		label: 'Góra Kalwaria, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Jaslo',
		label: 'Jaslo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Olesnica',
		label: 'Olesnica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wolomin',
		label: 'Wolomin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lobez',
		label: 'Lobez, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Czechowice-Dziedzice',
		label: 'Czechowice-Dziedzice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Drezdenko',
		label: 'Drezdenko, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ostróda',
		label: 'Ostróda, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Görlitz',
		label: 'Görlitz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kudowa-Zdrój',
		label: 'Kudowa-Zdrój, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowy Targ',
		label: 'Nowy Targ, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sztum',
		label: 'Sztum, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Olawa',
		label: 'Olawa, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Krzeszowice',
		label: 'Krzeszowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lowicz',
		label: 'Lowicz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gizycko',
		label: 'Gizycko, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Turek',
		label: 'Turek, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowy Dwór Gdanski',
		label: 'Nowy Dwór Gdanski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kozuchów',
		label: 'Kozuchów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lwówek Slaski',
		label: 'Lwówek Slaski, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ustrzyki Dolne',
		label: 'Ustrzyki Dolne, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Nowy Dwór Mazowiecki',
		label: 'Nowy Dwór Mazowiecki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zagan',
		label: 'Zagan, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Szczytno',
		label: 'Szczytno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Walcz',
		label: 'Walcz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bartoszyce',
		label: 'Bartoszyce, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Stary Sacz',
		label: 'Stary Sacz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lubon',
		label: 'Lubon, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pszczyna',
		label: 'Pszczyna, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Opalenica',
		label: 'Opalenica, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Poreba',
		label: 'Poreba, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Wielun',
		label: 'Wielun, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Grodków',
		label: 'Grodków, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bialogard',
		label: 'Bialogard, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Polaniec',
		label: 'Polaniec, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kolo',
		label: 'Kolo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Piastów',
		label: 'Piastów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Grajewo',
		label: 'Grajewo, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ostrów Mazowiecka',
		label: 'Ostrów Mazowiecka, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Hajnówka',
		label: 'Hajnówka, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Leczna',
		label: 'Leczna, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Swiebodzin',
		label: 'Swiebodzin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sroda Wielkopolska',
		label: 'Sroda Wielkopolska, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gryfino',
		label: 'Gryfino, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Rawicz',
		label: 'Rawicz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gostyn',
		label: 'Gostyn, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Chelmno',
		label: 'Chelmno, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pionki',
		label: 'Pionki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Chodziez',
		label: 'Chodziez, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bogatynia',
		label: 'Bogatynia, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Pyskowice',
		label: 'Pyskowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Lask',
		label: 'Lask, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sierpc',
		label: 'Sierpc, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Kozienice',
		label: 'Kozienice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Szamotuly',
		label: 'Szamotuly, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Krapkowice',
		label: 'Krapkowice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Sulechów',
		label: 'Sulechów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Oborniki',
		label: 'Oborniki, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Libiaz',
		label: 'Libiaz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Józefów',
		label: 'Józefów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zielonka',
		label: 'Zielonka, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gubin',
		label: 'Gubin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Boguszów-Gorce',
		label: 'Boguszów-Gorce, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Bytów',
		label: 'Bytów, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Gryfice',
		label: 'Gryfice, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Przasnysz',
		label: 'Przasnysz, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Ruda Slaska',
		label: 'Ruda Slaska, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Rypin',
		label: 'Rypin, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Zabkowice Slaskie',
		label: 'Zabkowice Slaskie, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Dabrowa Górnicza',
		label: 'Dabrowa Górnicza, Poland',
		type: 'city',
		flagClass: 'fi fi-pl',
		isPopular: false,
	},
	{
		value: 'Porto',
		label: 'Porto, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Cascais',
		label: 'Cascais, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Almada',
		label: 'Almada, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Coimbra',
		label: 'Coimbra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Braga',
		label: 'Braga, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Aveiro',
		label: 'Aveiro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'A dos Cunhados',
		label: 'A dos Cunhados, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Leiria',
		label: 'Leiria, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Setúbal',
		label: 'Setúbal, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Sintra',
		label: 'Sintra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Nova de Gaia',
		label: 'Vila Nova de Gaia, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Faro',
		label: 'Faro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Amadora',
		label: 'Amadora, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Viseu',
		label: 'Viseu, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Oeiras e São Julião da Barra',
		label: 'Oeiras e São Julião da Barra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Caldas da Rainha',
		label: 'Caldas da Rainha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Albufeira',
		label: 'Albufeira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Viana do Castelo',
		label: 'Viana do Castelo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ponta Delgada',
		label: 'Ponta Delgada, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Funchal',
		label: 'Funchal, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Odivelas',
		label: 'Odivelas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Barreiro',
		label: 'Barreiro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Portimão',
		label: 'Portimão, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Abrantes',
		label: 'Abrantes, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Loures',
		label: 'Loures, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lagos',
		label: 'Lagos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Maia',
		label: 'Maia, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santarém',
		label: 'Santarém, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Estoril',
		label: 'Estoril, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Matosinhos',
		label: 'Matosinhos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Carcavelos',
		label: 'Carcavelos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Amora',
		label: 'Amora, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Torres Vedras',
		label: 'Torres Vedras, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Espinho',
		label: 'Espinho, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Évora',
		label: 'Évora, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Parede',
		label: 'Parede, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Tomar',
		label: 'Tomar, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Real',
		label: 'Vila Real, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Oliveira de Azeméis',
		label: 'Oliveira de Azeméis, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Corroios',
		label: 'Corroios, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Guimarães',
		label: 'Guimarães, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São João da Madeira',
		label: 'São João da Madeira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Algés',
		label: 'Algés, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ermesinde',
		label: 'Ermesinde, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila do Conde',
		label: 'Vila do Conde, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Paço de Arcos',
		label: 'Paço de Arcos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Figueira da Foz',
		label: 'Figueira da Foz, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Montijo',
		label: 'Montijo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Barcelos',
		label: 'Barcelos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Mafra',
		label: 'Mafra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Pombal',
		label: 'Pombal, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Quarteira',
		label: 'Quarteira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Gondomar',
		label: 'Gondomar, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Guarda',
		label: 'Guarda, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Carnaxide',
		label: 'Carnaxide, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ovar',
		label: 'Ovar, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Torres Novas',
		label: 'Torres Novas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Águeda',
		label: 'Águeda, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alcochete',
		label: 'Alcochete, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Agualva-Cacém',
		label: 'Agualva-Cacém, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Domingos de Rana',
		label: 'São Domingos de Rana, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Sesimbra',
		label: 'Sesimbra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alverca do Ribatejo',
		label: 'Alverca do Ribatejo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Póvoa de Varzim',
		label: 'Póvoa de Varzim, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Linda-a-Velha',
		label: 'Linda-a-Velha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Loulé',
		label: 'Loulé, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alcobaça',
		label: 'Alcobaça, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Covilhã',
		label: 'Covilhã, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Tavira',
		label: 'Tavira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Almeirim',
		label: 'Almeirim, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Nova de Famalicão',
		label: 'Vila Nova de Famalicão, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Castelo Branco',
		label: 'Castelo Branco, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Baixa da Banheira',
		label: 'Baixa da Banheira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Pinhal Novo',
		label: 'Pinhal Novo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Charneca de Caparica',
		label: 'Charneca de Caparica, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Bragança',
		label: 'Bragança, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santa Maria de Lamas',
		label: 'Santa Maria de Lamas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Fafe',
		label: 'Fafe, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Oliveira do Hospital',
		label: 'Oliveira do Hospital, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santo André',
		label: 'Santo André, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lamego',
		label: 'Lamego, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Rebordosa',
		label: 'Rebordosa, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'A Ver-o-Mar',
		label: 'A Ver-o-Mar, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Carregado',
		label: 'Carregado, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Argoncilhe',
		label: 'Argoncilhe, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Benedita',
		label: 'Benedita, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Mira',
		label: 'Mira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Algueirão-Mem Martins',
		label: 'Algueirão-Mem Martins, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Paços de Ferreira',
		label: 'Paços de Ferreira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Arruda dos Vinhos',
		label: 'Arruda dos Vinhos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Olhão',
		label: 'Olhão, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Águas Santas',
		label: 'Águas Santas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Bombarral',
		label: 'Bombarral, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Entroncamento',
		label: 'Entroncamento, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Venda do Pinheiro',
		label: 'Venda do Pinheiro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alhos Vedros',
		label: 'Alhos Vedros, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Rio Maior',
		label: 'Rio Maior, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Mirandela',
		label: 'Mirandela, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Fernão Ferro',
		label: 'Fernão Ferro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Fundão',
		label: 'Fundão, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lagoa',
		label: 'Lagoa, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Bartolomeu de Messines',
		label: 'São Bartolomeu de Messines, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Camacha',
		label: 'Camacha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Penafiel',
		label: 'Penafiel, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Albergaria-A-Velha',
		label: 'Albergaria-A-Velha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Colares',
		label: 'Colares, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alhandra',
		label: 'Alhandra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ericeira',
		label: 'Ericeira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Rio Tinto',
		label: 'Rio Tinto, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Rio de Mouro',
		label: 'Rio de Mouro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Amarante',
		label: 'Amarante, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Camara de Lobos',
		label: 'Camara de Lobos, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Marinha Grande',
		label: 'Marinha Grande, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Póvoa de Santa Iria',
		label: 'Póvoa de Santa Iria, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Belas',
		label: 'Belas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Franca de Xira',
		label: 'Vila Franca de Xira, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Portalegre',
		label: 'Portalegre, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Praia de Ancora',
		label: 'Vila Praia de Ancora, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alfena',
		label: 'Alfena, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Porto Salvo',
		label: 'Porto Salvo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Arcozelo',
		label: 'Arcozelo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Chaves',
		label: 'Chaves, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Costa da Caparica',
		label: 'Costa da Caparica, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alcanena',
		label: 'Alcanena, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Avintes',
		label: 'Avintes, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Esmoriz',
		label: 'Esmoriz, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Aldeia de Paio Pires',
		label: 'Aldeia de Paio Pires, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Milheirós',
		label: 'Milheirós, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Sobreda',
		label: 'Sobreda, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Sobralinho',
		label: 'Sobralinho, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Campanário',
		label: 'Campanário, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lousã',
		label: 'Lousã, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Nazaré',
		label: 'Nazaré, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lourosa',
		label: 'Lourosa, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Armação de Pêra',
		label: 'Armação de Pêra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São João de Ver',
		label: 'São João de Ver, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Abraveses',
		label: 'Abraveses, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Silvalde',
		label: 'Silvalde, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santiago do Cacém',
		label: 'Santiago do Cacém, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Cantanhede',
		label: 'Cantanhede, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Reguengos de Monsaraz',
		label: 'Reguengos de Monsaraz, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Horta',
		label: 'Horta, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Praia da Vitória',
		label: 'Praia da Vitória, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santa Cruz do Bispo',
		label: 'Santa Cruz do Bispo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alcabideche',
		label: 'Alcabideche, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Arrentela',
		label: 'Arrentela, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Porto de Mós',
		label: 'Porto de Mós, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Senhora da Hora',
		label: 'Senhora da Hora, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Oliveira do Bairro',
		label: 'Oliveira do Bairro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Sertã',
		label: 'Sertã, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Mamede de Infesta',
		label: 'São Mamede de Infesta, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Pontinha',
		label: 'Pontinha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Laranjeiro',
		label: 'Laranjeiro, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Franca do Campo',
		label: 'Vila Franca do Campo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alvor',
		label: 'Alvor, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Moita',
		label: 'Moita, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ílhavo',
		label: 'Ílhavo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Real',
		label: 'Real, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Castro Verde',
		label: 'Castro Verde, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Peniche',
		label: 'Peniche, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Rio Meão',
		label: 'Rio Meão, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Póvoa de Santo Adrião',
		label: 'Póvoa de Santo Adrião, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Gafanha da Nazaré',
		label: 'Gafanha da Nazaré, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Angra',
		label: 'Angra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Moscavide',
		label: 'Moscavide, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Perafita',
		label: 'Perafita, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Porto Santo',
		label: 'Porto Santo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Teixoso',
		label: 'Teixoso, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Barcarena',
		label: 'Barcarena, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Félix da Marinha',
		label: 'São Félix da Marinha, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Forte da Casa',
		label: 'Forte da Casa, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Santa Bárbara de Nexe',
		label: 'Santa Bárbara de Nexe, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Silves',
		label: 'Silves, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Caneças',
		label: 'Caneças, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Cortegaça',
		label: 'Cortegaça, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Chã',
		label: 'Vila Chã, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Ponte de Sor',
		label: 'Ponte de Sor, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Serzedelo',
		label: 'Serzedelo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Grijó',
		label: 'Grijó, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Cartaxo',
		label: 'Cartaxo, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Adaúfe',
		label: 'Adaúfe, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Brás de Alportel',
		label: 'São Brás de Alportel, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Golegã',
		label: 'Golegã, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Caldas de Vizela',
		label: 'Caldas de Vizela, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Mira de Aire',
		label: 'Mira de Aire, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Elvas',
		label: 'Elvas, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'São Pedro do Sul',
		label: 'São Pedro do Sul, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Gulpilhares',
		label: 'Gulpilhares, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Guifões',
		label: 'Guifões, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Lavra',
		label: 'Lavra, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Tondela',
		label: 'Tondela, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Tramagal',
		label: 'Tramagal, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Milheirós de Poiares',
		label: 'Milheirós de Poiares, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Coruche',
		label: 'Coruche, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vizela',
		label: 'Vizela, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Valadares',
		label: 'Valadares, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Vila Verde',
		label: 'Vila Verde, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Alenquer',
		label: 'Alenquer, Portugal',
		type: 'city',
		flagClass: 'fi fi-pt',
		isPopular: false,
	},
	{
		value: 'Puerto Rico',
		label: 'Puerto Rico',
		type: 'country',
		flagClass: 'fi fi-pr',
		isPopular: false,
	},
	{
		value: 'Qatar',
		label: 'Qatar',
		type: 'country',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Doha',
		label: 'Doha, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'ad-Dawhah',
		label: 'ad-Dawhah, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'al-Wakrah',
		label: 'al-Wakrah, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'ar-Rayyan',
		label: 'ar-Rayyan, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Dukhan',
		label: 'Dukhan, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'al-Khawr',
		label: 'al-Khawr, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'ar-Ruways',
		label: 'ar-Ruways, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Umm Salal',
		label: 'Umm Salal, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'al-Jumayliyah',
		label: 'al-Jumayliyah, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'al-Wukayr',
		label: 'al-Wukayr, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'al-Ghuwayriyah',
		label: 'al-Ghuwayriyah, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Musay´id',
		label: 'Musay´id, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'ash-Shahaniyah',
		label: 'ash-Shahaniyah, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Umm Bab',
		label: 'Umm Bab, Qatar',
		type: 'city',
		flagClass: 'fi fi-qa',
		isPopular: false,
	},
	{
		value: 'Romania',
		label: 'Romania',
		type: 'country',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bucharest',
		label: 'Bucharest, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: true,
	},
	{
		value: 'Bucuresci',
		label: 'Bucuresci, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cluj-Napoca',
		label: 'Cluj-Napoca, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Timisoara',
		label: 'Timisoara, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Constanta',
		label: 'Constanta, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Iasi',
		label: 'Iasi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Abramut',
		label: 'Abramut, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Brasov',
		label: 'Brasov, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Craiova',
		label: 'Craiova, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sibiu',
		label: 'Sibiu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ploiesti',
		label: 'Ploiesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Oradea',
		label: 'Oradea, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Targu-Mures',
		label: 'Targu-Mures, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Galati',
		label: 'Galati, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Pitesti',
		label: 'Pitesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Arad',
		label: 'Arad, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Baia Mare',
		label: 'Baia Mare, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bacau',
		label: 'Bacau, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Targoviste',
		label: 'Targoviste, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Suceava',
		label: 'Suceava, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Braila',
		label: 'Braila, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Buzau',
		label: 'Buzau, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Deva',
		label: 'Deva, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Piatra Neamt',
		label: 'Piatra Neamt, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Lupeni',
		label: 'Lupeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Alba Iulia',
		label: 'Alba Iulia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ramnicu Valcea',
		label: 'Ramnicu Valcea, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sfantu Gheorghe',
		label: 'Sfantu Gheorghe, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Petrosani',
		label: 'Petrosani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Calarasi',
		label: 'Calarasi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Satu Mare',
		label: 'Satu Mare, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Barlad',
		label: 'Barlad, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Slobozia',
		label: 'Slobozia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Onesti',
		label: 'Onesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Botosani',
		label: 'Botosani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Slatina',
		label: 'Slatina, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sighisoara',
		label: 'Sighisoara, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bistrita',
		label: 'Bistrita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vaslui',
		label: 'Vaslui, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Medias',
		label: 'Medias, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Targu Jiu',
		label: 'Targu Jiu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Lugoj',
		label: 'Lugoj, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Campulung',
		label: 'Campulung, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Caransebes',
		label: 'Caransebes, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vatra Dornei',
		label: 'Vatra Dornei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Resita',
		label: 'Resita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Hunedoara',
		label: 'Hunedoara, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Falticeni',
		label: 'Falticeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Blaj',
		label: 'Blaj, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Alesd',
		label: 'Alesd, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Craiva',
		label: 'Craiva, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Drobeta-Turnu Severin',
		label: 'Drobeta-Turnu Severin, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Tulcea',
		label: 'Tulcea, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Mangalia',
		label: 'Mangalia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bilbor',
		label: 'Bilbor, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bucu',
		label: 'Bucu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Giurgiu',
		label: 'Giurgiu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Roman',
		label: 'Roman, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Zalau',
		label: 'Zalau, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Alessandria',
		label: 'Alessandria, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Pascani',
		label: 'Pascani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Marghita',
		label: 'Marghita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sinaia',
		label: 'Sinaia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Darabani',
		label: 'Darabani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Techirghiol',
		label: 'Techirghiol, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Faurei',
		label: 'Faurei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Uricani',
		label: 'Uricani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cosmesti',
		label: 'Cosmesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Salsig',
		label: 'Salsig, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bodesti',
		label: 'Bodesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Turceni',
		label: 'Turceni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bicaz',
		label: 'Bicaz, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Medgidia',
		label: 'Medgidia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Baile Herculane',
		label: 'Baile Herculane, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Miercurea-Ciuc',
		label: 'Miercurea-Ciuc, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Campina',
		label: 'Campina, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Odorheiu Secuiesc',
		label: 'Odorheiu Secuiesc, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sacele',
		label: 'Sacele, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cotmeana',
		label: 'Cotmeana, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Aiud',
		label: 'Aiud, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Oltenita',
		label: 'Oltenita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Moinesti',
		label: 'Moinesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Maglavit',
		label: 'Maglavit, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Comanesti',
		label: 'Comanesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Carei',
		label: 'Carei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Orastie',
		label: 'Orastie, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Targu-Neamt',
		label: 'Targu-Neamt, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gheorgheni',
		label: 'Gheorgheni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Buhusi',
		label: 'Buhusi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ludus',
		label: 'Ludus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Viseu de Sus',
		label: 'Viseu de Sus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Simleu Silvaniei',
		label: 'Simleu Silvaniei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Toplita',
		label: 'Toplita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Simeria',
		label: 'Simeria, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Targu-Lapus',
		label: 'Targu-Lapus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sinesti',
		label: 'Sinesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Victor Vlad Delamarina',
		label: 'Victor Vlad Delamarina, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Rovinari',
		label: 'Rovinari, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sadu',
		label: 'Sadu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gaiseni',
		label: 'Gaiseni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Grebanu',
		label: 'Grebanu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Brezoaiele',
		label: 'Brezoaiele, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sofronea',
		label: 'Sofronea, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bolintinu-din-Vale',
		label: 'Bolintinu-din-Vale, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bradeni',
		label: 'Bradeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vlahita',
		label: 'Vlahita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Uileacu de Beius',
		label: 'Uileacu de Beius, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Tudor Vladimirescu',
		label: 'Tudor Vladimirescu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Balaci',
		label: 'Balaci, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ianca',
		label: 'Ianca, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Salard',
		label: 'Salard, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Lipova',
		label: 'Lipova, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Maneciu',
		label: 'Maneciu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Caianu',
		label: 'Caianu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Rebrisoara',
		label: 'Rebrisoara, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Balanesti',
		label: 'Balanesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Jimbolia',
		label: 'Jimbolia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cleja',
		label: 'Cleja, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Racari',
		label: 'Racari, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Costesti',
		label: 'Costesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gheorghe Doja',
		label: 'Gheorghe Doja, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Brezoi',
		label: 'Brezoi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Pui',
		label: 'Pui, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Baia',
		label: 'Baia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Nasaud',
		label: 'Nasaud, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Grajduri',
		label: 'Grajduri, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vladimirescu',
		label: 'Vladimirescu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Orlat',
		label: 'Orlat, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Busteni',
		label: 'Busteni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bradesti',
		label: 'Bradesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Crevedia',
		label: 'Crevedia, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Negrasi',
		label: 'Negrasi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ineu',
		label: 'Ineu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Otopeni',
		label: 'Otopeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Baltatesti',
		label: 'Baltatesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sascut',
		label: 'Sascut, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Brosteni',
		label: 'Brosteni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Fratautii Vechi',
		label: 'Fratautii Vechi, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bran',
		label: 'Bran, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Magureni',
		label: 'Magureni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Copsa Mica',
		label: 'Copsa Mica, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Butoiesti',
		label: 'Butoiesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vadu Izei',
		label: 'Vadu Izei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ortisoara',
		label: 'Ortisoara, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Negresti',
		label: 'Negresti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Zatreni',
		label: 'Zatreni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ghimes-Faget',
		label: 'Ghimes-Faget, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Costisa',
		label: 'Costisa, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gaiceana',
		label: 'Gaiceana, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Draghiceni',
		label: 'Draghiceni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Frasin',
		label: 'Frasin, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gradistea',
		label: 'Gradistea, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cristuru Secuiesc',
		label: 'Cristuru Secuiesc, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Timisesti',
		label: 'Timisesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Baiut',
		label: 'Baiut, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Babaita',
		label: 'Babaita, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Plopeni',
		label: 'Plopeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Mesesenii de Jos',
		label: 'Mesesenii de Jos, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Vintu de Jos',
		label: 'Vintu de Jos, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Deta',
		label: 'Deta, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Babeni',
		label: 'Babeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Eforie',
		label: 'Eforie, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Romanu',
		label: 'Romanu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Alexandru Odobescu',
		label: 'Alexandru Odobescu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cavnic',
		label: 'Cavnic, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ibanesti',
		label: 'Ibanesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Poienesti',
		label: 'Poienesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Soars',
		label: 'Soars, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Siret',
		label: 'Siret, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Niculesti',
		label: 'Niculesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Anina',
		label: 'Anina, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Suncuius',
		label: 'Suncuius, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Salatig',
		label: 'Salatig, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Voivodeni',
		label: 'Voivodeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Budila',
		label: 'Budila, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Tuzla',
		label: 'Tuzla, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Valea Danului',
		label: 'Valea Danului, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Abrud',
		label: 'Abrud, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Dumitra',
		label: 'Dumitra, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Santandrei',
		label: 'Santandrei, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Bistrita Bargaului',
		label: 'Bistrita Bargaului, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Viseu de Jos',
		label: 'Viseu de Jos, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Provita de Sus',
		label: 'Provita de Sus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Rabagani',
		label: 'Rabagani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Tasca',
		label: 'Tasca, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Focsani',
		label: 'Focsani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Sacalaz',
		label: 'Sacalaz, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Ciolpani',
		label: 'Ciolpani, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Suciu de Sus',
		label: 'Suciu de Sus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cetariu',
		label: 'Cetariu, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Cozmesti',
		label: 'Cozmesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Rasova',
		label: 'Rasova, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Dornesti',
		label: 'Dornesti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Glodeni',
		label: 'Glodeni, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Densus',
		label: 'Densus, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Gura Vaii',
		label: 'Gura Vaii, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Rasmiresti',
		label: 'Rasmiresti, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Razvad',
		label: 'Razvad, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Potcoava',
		label: 'Potcoava, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Köln',
		label: 'Köln, Romania',
		type: 'city',
		flagClass: 'fi fi-ro',
		isPopular: false,
	},
	{
		value: 'Russian Federation',
		label: 'Russian Federation',
		type: 'country',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Moscow',
		label: 'Moscow, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'St. Petersburg',
		label: 'St. Petersburg, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Abakan',
		label: 'Abakan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kazan',
		label: 'Kazan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novosibirsk',
		label: 'Novosibirsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Krasnodar',
		label: 'Krasnodar, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Cheboksary',
		label: 'Cheboksary, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Vladivostok',
		label: 'Vladivostok, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Samara',
		label: 'Samara, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Rostov',
		label: 'Rostov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Tomsk',
		label: 'Tomsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Ufa',
		label: 'Ufa, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Volgograd',
		label: 'Volgograd, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Jekaterinburg',
		label: 'Jekaterinburg, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Sochi',
		label: 'Sochi, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: '´Anah',
		label: '´Anah, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kaliningrad',
		label: 'Kaliningrad, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kirov',
		label: 'Kirov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Omsk',
		label: 'Omsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Perm',
		label: 'Perm, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Voronezh',
		label: 'Voronezh, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Habarovsk',
		label: 'Habarovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Joshkar-Ola',
		label: 'Joshkar-Ola, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Cheljabinsk',
		label: 'Cheljabinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Irkutsk',
		label: 'Irkutsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Penza',
		label: 'Penza, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Almetjevsk',
		label: 'Almetjevsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Krasnojarsk',
		label: 'Krasnojarsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Saratov',
		label: 'Saratov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Izhevsk',
		label: 'Izhevsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kursk',
		label: 'Kursk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Toljatti',
		label: 'Toljatti, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Barnaul',
		label: 'Barnaul, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Uljanovsk',
		label: 'Uljanovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Magnitogorsk',
		label: 'Magnitogorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Jaroslavl',
		label: 'Jaroslavl, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novokuzneck',
		label: 'Novokuzneck, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Ivanovo',
		label: 'Ivanovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Arhangelsk',
		label: 'Arhangelsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Volzhskij',
		label: 'Volzhskij, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Taganrog',
		label: 'Taganrog, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Podolsk',
		label: 'Podolsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kemerovo',
		label: 'Kemerovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Belgorod',
		label: 'Belgorod, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Vladimir',
		label: 'Vladimir, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Petrozavodsk',
		label: 'Petrozavodsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Velikij Novgorod',
		label: 'Velikij Novgorod, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Petropavlovsk-Kamchatskij',
		label: 'Petropavlovsk-Kamchatskij, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Elista',
		label: 'Elista, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Birobidzhan',
		label: 'Birobidzhan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Dubna',
		label: 'Dubna, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Orenburg',
		label: 'Orenburg, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Tatarsk',
		label: 'Tatarsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Tula',
		label: 'Tula, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhnij Tagil',
		label: 'Nizhnij Tagil, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Stavropol',
		label: 'Stavropol, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Orjol',
		label: 'Orjol, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Murmansk',
		label: 'Murmansk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Surgut',
		label: 'Surgut, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Saransk',
		label: 'Saransk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novorossijsk',
		label: 'Novorossijsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zeljenograd',
		label: 'Zeljenograd, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Syktyvkar',
		label: 'Syktyvkar, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zvenigorod',
		label: 'Zvenigorod, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Prokopjevsk',
		label: 'Prokopjevsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Rybinsk',
		label: 'Rybinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nadym',
		label: 'Nadym, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Engels',
		label: 'Engels, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Dimitrovgrad',
		label: 'Dimitrovgrad, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Orehovo-Zujevo',
		label: 'Orehovo-Zujevo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Obninsk',
		label: 'Obninsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Magadan',
		label: 'Magadan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Podporozhje',
		label: 'Podporozhje, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhneudinsk',
		label: 'Nizhneudinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novyj Urengoj',
		label: 'Novyj Urengoj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kstovo',
		label: 'Kstovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Solnechnogorsk',
		label: 'Solnechnogorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kudymkar',
		label: 'Kudymkar, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Belye Berega',
		label: 'Belye Berega, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Mahackala',
		label: 'Mahackala, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zernograd',
		label: 'Zernograd, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zubova Poljana',
		label: 'Zubova Poljana, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Rjazan',
		label: 'Rjazan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Naberezhnyje Chelny',
		label: 'Naberezhnyje Chelny, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kotovo',
		label: 'Kotovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Lipetsk',
		label: 'Lipetsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novoaltajsk',
		label: 'Novoaltajsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Urengoj',
		label: 'Urengoj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Belorechensk',
		label: 'Belorechensk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nogliki',
		label: 'Nogliki, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kotelnich',
		label: 'Kotelnich, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Pervomajsk',
		label: 'Pervomajsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Gorno-Altajsk',
		label: 'Gorno-Altajsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Trubchjovsk',
		label: 'Trubchjovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kurgan',
		label: 'Kurgan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kanash',
		label: 'Kanash, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Smolensk',
		label: 'Smolensk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nalchik',
		label: 'Nalchik, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Lytkarino',
		label: 'Lytkarino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhnjaja Pojma',
		label: 'Nizhnjaja Pojma, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Vologda',
		label: 'Vologda, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Roslavl',
		label: 'Roslavl, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kostroma',
		label: 'Kostroma, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Malgobek',
		label: 'Malgobek, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Bezheck',
		label: 'Bezheck, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhnevartovsk',
		label: 'Nizhnevartovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Groznyj',
		label: 'Groznyj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Angarsk',
		label: 'Angarsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Buj',
		label: 'Buj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Monchegorsk',
		label: 'Monchegorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Gorohovec',
		label: 'Gorohovec, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Staryj Oskol',
		label: 'Staryj Oskol, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Shelehov',
		label: 'Shelehov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Jakutsk',
		label: 'Jakutsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Leninsk',
		label: 'Leninsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Armavir',
		label: 'Armavir, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Pavlovsk',
		label: 'Pavlovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Pskov',
		label: 'Pskov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zlatoust',
		label: 'Zlatoust, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Ahtubinsk',
		label: 'Ahtubinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Yuzhno-Sakhalinsk',
		label: 'Yuzhno-Sakhalinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhnij Lomov',
		label: 'Nizhnij Lomov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Mostovskoj',
		label: 'Mostovskoj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Korolyov',
		label: 'Korolyov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Sharja',
		label: 'Sharja, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kolomna',
		label: 'Kolomna, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Aleksandrovsk-Sahalinskij',
		label: 'Aleksandrovsk-Sahalinskij, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kovrov',
		label: 'Kovrov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Lyskovo',
		label: 'Lyskovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Pjatigorsk',
		label: 'Pjatigorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Bekovo',
		label: 'Bekovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Odincovo',
		label: 'Odincovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Partizansk',
		label: 'Partizansk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kislovodsk',
		label: 'Kislovodsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zhirnov',
		label: 'Zhirnov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Norilsk',
		label: 'Norilsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Abdulino',
		label: 'Abdulino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kolchugino',
		label: 'Kolchugino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Hotkovo',
		label: 'Hotkovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Dalnegorsk',
		label: 'Dalnegorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Noginsk',
		label: 'Noginsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Achinsk',
		label: 'Achinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Seversk',
		label: 'Seversk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Tavda',
		label: 'Tavda, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Babajevo',
		label: 'Babajevo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Camenca',
		label: 'Camenca, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kyzyl',
		label: 'Kyzyl, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Uhta',
		label: 'Uhta, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Slancy',
		label: 'Slancy, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Serebrjanyj Bor',
		label: 'Serebrjanyj Bor, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Tynda',
		label: 'Tynda, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nytva',
		label: 'Nytva, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Birsk',
		label: 'Birsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Sarapul',
		label: 'Sarapul, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Serov',
		label: 'Serov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Ust-Ilimsk',
		label: 'Ust-Ilimsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Balashov',
		label: 'Balashov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Bugulma',
		label: 'Bugulma, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Aldan',
		label: 'Aldan, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novouralsk',
		label: 'Novouralsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Novovoronezh',
		label: 'Novovoronezh, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Skalnyj',
		label: 'Skalnyj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Abinsk',
		label: 'Abinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Gatchina',
		label: 'Gatchina, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Vyborg',
		label: 'Vyborg, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Sljudjanka',
		label: 'Sljudjanka, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Bektemir',
		label: 'Bektemir, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Vorkuta',
		label: 'Vorkuta, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Belovo',
		label: 'Belovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Prohladnyj',
		label: 'Prohladnyj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Lysva',
		label: 'Lysva, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Urussu',
		label: 'Urussu, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Volsk',
		label: 'Volsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Stupino',
		label: 'Stupino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Navashino',
		label: 'Navashino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Korsakov',
		label: 'Korsakov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Iskitim',
		label: 'Iskitim, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Zelenogorsk',
		label: 'Zelenogorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Aleksin',
		label: 'Aleksin, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Gorodec',
		label: 'Gorodec, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Nizhnij Odes',
		label: 'Nizhnij Odes, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Dno',
		label: 'Dno, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Budjonnovsk',
		label: 'Budjonnovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Klincy',
		label: 'Klincy, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Sertolovo',
		label: 'Sertolovo, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Severo-Zadonsk',
		label: 'Severo-Zadonsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Revda',
		label: 'Revda, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Horki',
		label: 'Horki, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Krasnoturinsk',
		label: 'Krasnoturinsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Aleksandrov',
		label: 'Aleksandrov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Chehov',
		label: 'Chehov, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Dalnerechensk',
		label: 'Dalnerechensk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Abaza',
		label: 'Abaza, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kuvandyk',
		label: 'Kuvandyk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Kurtamysh',
		label: 'Kurtamysh, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Shahtjorsk',
		label: 'Shahtjorsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Shchjokino',
		label: 'Shchjokino, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Morozovsk',
		label: 'Morozovsk, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Udachnyj',
		label: 'Udachnyj, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Totma',
		label: 'Totma, Russian Federation',
		type: 'city',
		flagClass: 'fi fi-ru',
		isPopular: false,
	},
	{
		value: 'Rwanda',
		label: 'Rwanda',
		type: 'country',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Kigali',
		label: 'Kigali, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Butare',
		label: 'Butare, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Byumba',
		label: 'Byumba, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Cyangugu',
		label: 'Cyangugu, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Gitarama',
		label: 'Gitarama, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Kibuye',
		label: 'Kibuye, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Ruhengeri',
		label: 'Ruhengeri, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Nyanza',
		label: 'Nyanza, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Rwamagana',
		label: 'Rwamagana, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Gisenyi',
		label: 'Gisenyi, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Kibungo',
		label: 'Kibungo, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Gikongoro',
		label: 'Gikongoro, Rwanda',
		type: 'city',
		flagClass: 'fi fi-rw',
		isPopular: false,
	},
	{
		value: 'Réunion',
		label: 'Réunion',
		type: 'country',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Pierre',
		label: 'Saint-Pierre, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Denis',
		label: 'Saint-Denis, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Ambodifototra',
		label: 'Ambodifototra, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Le Tampon',
		label: 'Le Tampon, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Le Port',
		label: 'Le Port, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'La Possession',
		label: 'La Possession, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Salazie',
		label: 'Salazie, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Cilaos',
		label: 'Cilaos, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Paul',
		label: 'Saint-Paul, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Louis',
		label: 'Saint-Louis, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-André',
		label: 'Saint-André, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Benoit',
		label: 'Saint-Benoit, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Joseph',
		label: 'Saint-Joseph, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Leu',
		label: 'Saint-Leu, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Sainte-Suzanne',
		label: 'Sainte-Suzanne, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: "L'Étang-Salé",
		label: "L'Étang-Salé, Réunion",
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Petite-Ile',
		label: 'Petite-Ile, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Bras-Panon',
		label: 'Bras-Panon, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Les Aviron',
		label: 'Les Aviron, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Les Trois-Bassins',
		label: 'Les Trois-Bassins, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Sainte-Rose',
		label: 'Sainte-Rose, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Entre-Deux',
		label: 'Entre-Deux, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint-Philippe',
		label: 'Saint-Philippe, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Réunion',
		label: 'Réunion, Réunion',
		type: 'city',
		flagClass: 'fi fi-re',
		isPopular: false,
	},
	{
		value: 'Saint Barthélemy',
		label: 'Saint Barthélemy',
		type: 'country',
		flagClass: 'fi fi-bl',
		isPopular: false,
	},
	{
		value: 'Saint Helena, Ascension and Tristan da Cunha',
		label: 'Saint Helena, Ascension and Tristan da Cunha',
		type: 'country',
		flagClass: 'fi fi-sh',
		isPopular: false,
	},
	{
		value: 'Edinburgh',
		label: 'Edinburgh, Saint Helena, Ascension and Tristan da Cunha',
		type: 'city',
		flagClass: 'fi fi-sh',
		isPopular: false,
	},
	{
		value: 'Holetown',
		label: 'Holetown, Saint Helena, Ascension and Tristan da Cunha',
		type: 'city',
		flagClass: 'fi fi-sh',
		isPopular: false,
	},
	{
		value: 'Georgetown',
		label: 'Georgetown, Saint Helena, Ascension and Tristan da Cunha',
		type: 'city',
		flagClass: 'fi fi-sh',
		isPopular: false,
	},
	{
		value: 'Saint Kitts and Nevis',
		label: 'Saint Kitts and Nevis',
		type: 'country',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Basseterre',
		label: 'Basseterre, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Charlestown',
		label: 'Charlestown, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: "Saint Paul's",
		label: "Saint Paul's, Saint Kitts and Nevis",
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Cotton Ground',
		label: 'Cotton Ground, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Old Road',
		label: 'Old Road, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Sadlers',
		label: 'Sadlers, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Middle Island',
		label: 'Middle Island, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Cayon',
		label: 'Cayon, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Tabernacle',
		label: 'Tabernacle, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Sandy Point',
		label: 'Sandy Point, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Mansion',
		label: 'Mansion, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Boyds',
		label: 'Boyds, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Dieppe Bay',
		label: 'Dieppe Bay, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Monkey Hill',
		label: 'Monkey Hill, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Newcastle',
		label: 'Newcastle, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Gingerland',
		label: 'Gingerland, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Fig Tree',
		label: 'Fig Tree, Saint Kitts and Nevis',
		type: 'city',
		flagClass: 'fi fi-kn',
		isPopular: false,
	},
	{
		value: 'Saint Lucia',
		label: 'Saint Lucia',
		type: 'country',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Castries',
		label: 'Castries, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Gros Islet',
		label: 'Gros Islet, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Anse-la-Raye',
		label: 'Anse-la-Raye, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Vieux Fort',
		label: 'Vieux Fort, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Cap Estate',
		label: 'Cap Estate, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Micoud',
		label: 'Micoud, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Soufrière',
		label: 'Soufrière, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Canaries',
		label: 'Canaries, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Choiseul',
		label: 'Choiseul, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Dennery',
		label: 'Dennery, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Laborie',
		label: 'Laborie, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Choc',
		label: 'Choc, Saint Lucia',
		type: 'city',
		flagClass: 'fi fi-lc',
		isPopular: false,
	},
	{
		value: 'Saint Martin (French part)',
		label: 'Saint Martin (French part)',
		type: 'country',
		flagClass: 'fi fi-mf',
		isPopular: false,
	},
	{
		value: 'Saint Pierre and Miquelon',
		label: 'Saint Pierre and Miquelon',
		type: 'country',
		flagClass: 'fi fi-pm',
		isPopular: false,
	},
	{
		value: 'Saint-Pierre',
		label: 'Saint-Pierre, Saint Pierre and Miquelon',
		type: 'city',
		flagClass: 'fi fi-pm',
		isPopular: false,
	},
	{
		value: 'Miquelon',
		label: 'Miquelon, Saint Pierre and Miquelon',
		type: 'city',
		flagClass: 'fi fi-pm',
		isPopular: false,
	},
	{
		value: 'Saint Vincent and the Grenadines',
		label: 'Saint Vincent and the Grenadines',
		type: 'country',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Kingstown',
		label: 'Kingstown, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Georgetown',
		label: 'Georgetown, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Barroualie',
		label: 'Barroualie, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Biabou',
		label: 'Biabou, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Grenadines',
		label: 'Grenadines, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Saint Vincent',
		label: 'Saint Vincent, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Byera',
		label: 'Byera, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Layou',
		label: 'Layou, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Port Elizabeth',
		label: 'Port Elizabeth, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Chateaubelair',
		label: 'Chateaubelair, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Hamilton',
		label: 'Hamilton, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Dovers',
		label: 'Dovers, Saint Vincent and the Grenadines',
		type: 'city',
		flagClass: 'fi fi-vc',
		isPopular: false,
	},
	{
		value: 'Samoa',
		label: 'Samoa',
		type: 'country',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Solosolo',
		label: 'Solosolo, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Falelatai',
		label: 'Falelatai, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Mulifanua',
		label: 'Mulifanua, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Taga',
		label: 'Taga, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: "Samalae'ulu",
		label: "Samalae'ulu, Samoa",
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: "A'opo",
		label: "A'opo, Samoa",
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Neiafu',
		label: 'Neiafu, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Abaiang',
		label: 'Abaiang, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Safotulafai',
		label: 'Safotulafai, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Samamea',
		label: 'Samamea, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'Gautavai',
		label: 'Gautavai, Samoa',
		type: 'city',
		flagClass: 'fi fi-ws',
		isPopular: false,
	},
	{
		value: 'San Marino',
		label: 'San Marino',
		type: 'country',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Serravalle',
		label: 'Serravalle, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'San Marino',
		label: 'San Marino, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Borgo Maggiore',
		label: 'Borgo Maggiore, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Acquaviva',
		label: 'Acquaviva, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Fiorentino',
		label: 'Fiorentino, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Faetano',
		label: 'Faetano, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Domagnano',
		label: 'Domagnano, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Chiesanuova',
		label: 'Chiesanuova, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Montegiardino',
		label: 'Montegiardino, San Marino',
		type: 'city',
		flagClass: 'fi fi-sm',
		isPopular: false,
	},
	{
		value: 'Sao Tome and Principe',
		label: 'Sao Tome and Principe',
		type: 'country',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Trindade',
		label: 'Trindade, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'São Tomé',
		label: 'São Tomé, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Neves',
		label: 'Neves, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Santo Amaro',
		label: 'Santo Amaro, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Santana',
		label: 'Santana, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Santo António',
		label: 'Santo António, Sao Tome and Principe',
		type: 'city',
		flagClass: 'fi fi-st',
		isPopular: false,
	},
	{
		value: 'Saudi Arabia',
		label: 'Saudi Arabia',
		type: 'country',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Riyadh',
		label: 'Riyadh, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Jiddah',
		label: 'Jiddah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'ad-Dammam',
		label: 'ad-Dammam, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Khubar',
		label: 'al-Khubar, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Abha',
		label: 'Abha, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Jubayl',
		label: 'Jubayl, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Yanbu',
		label: 'Yanbu, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Madinah',
		label: 'al-Madinah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Makkah',
		label: 'Makkah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Qatif',
		label: 'al-Qatif, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Tabuk',
		label: 'Tabuk, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Hufuf',
		label: 'al-Hufuf, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Buraydah',
		label: 'Buraydah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: '´Afif',
		label: '´Afif, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'at-Ta´if',
		label: 'at-Ta´if, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Ha´il',
		label: 'Ha´il, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Khafji',
		label: 'al-Khafji, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Sayhat',
		label: 'Sayhat, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Bahah',
		label: 'al-Bahah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Kharj',
		label: 'al-Kharj, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Najran',
		label: 'Najran, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Jizan',
		label: 'Jizan, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Khamis Mushayt',
		label: 'Khamis Mushayt, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Ara´ar',
		label: 'Ara´ar, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Jawf',
		label: 'al-Jawf, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: '´Unayzah',
		label: '´Unayzah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'ar-Rass',
		label: 'ar-Rass, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Rahimah',
		label: 'Rahimah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'ad-Dawadimi',
		label: 'ad-Dawadimi, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'ad-Dilam',
		label: 'ad-Dilam, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Hafar-al-Batin',
		label: 'Hafar-al-Batin, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'ath-Thuqbah',
		label: 'ath-Thuqbah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'az-Zahran',
		label: 'az-Zahran, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Mubarraz',
		label: 'al-Mubarraz, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Sakakah',
		label: 'Sakakah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Tarut',
		label: 'Tarut, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Sabya',
		label: 'Sabya, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Rabig',
		label: 'Rabig, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Qurayyat',
		label: 'al-Qurayyat, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'az-Zulfi',
		label: 'az-Zulfi, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Safwah',
		label: 'Safwah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Buqayq',
		label: 'Buqayq, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Majma´ah',
		label: 'al-Majma´ah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Dar´a',
		label: 'Dar´a, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Qal´at Bishah',
		label: 'Qal´at Bishah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Abu ´Alanda',
		label: 'Abu ´Alanda, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Turayf',
		label: 'Turayf, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Rafha',
		label: 'Rafha, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Umm Lajj',
		label: 'Umm Lajj, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'al-Hawiyah',
		label: 'al-Hawiyah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Sharurah',
		label: 'Sharurah, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Al Hofuf',
		label: 'Al Hofuf, Saudi Arabia',
		type: 'city',
		flagClass: 'fi fi-sa',
		isPopular: false,
	},
	{
		value: 'Senegal',
		label: 'Senegal',
		type: 'country',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Dakar',
		label: 'Dakar, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'al-Madinah',
		label: 'al-Madinah, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Bakel',
		label: 'Bakel, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Diourbel',
		label: 'Diourbel, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Bambey',
		label: 'Bambey, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Médina Gounas',
		label: 'Médina Gounas, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kaolack',
		label: 'Kaolack, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Daga',
		label: 'Daga, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Diofior',
		label: 'Diofior, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Thiès',
		label: 'Thiès, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Saint-Louis',
		label: 'Saint-Louis, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kolda',
		label: 'Kolda, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Goudomp',
		label: 'Goudomp, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Dabo',
		label: 'Dabo, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Mbour',
		label: 'Mbour, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Fatick',
		label: 'Fatick, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Dahra',
		label: 'Dahra, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Khombole',
		label: 'Khombole, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Touba',
		label: 'Touba, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Toubakouta',
		label: 'Toubakouta, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Louga',
		label: 'Louga, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Bignona',
		label: 'Bignona, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kayar',
		label: 'Kayar, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Linguère',
		label: 'Linguère, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kanel',
		label: 'Kanel, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Thilogne',
		label: 'Thilogne, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Passi',
		label: 'Passi, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Foundiougne',
		label: 'Foundiougne, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kahone',
		label: 'Kahone, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Ziguinchor',
		label: 'Ziguinchor, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Richard Toll',
		label: 'Richard Toll, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Tambacounda',
		label: 'Tambacounda, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Mbacké',
		label: 'Mbacké, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Tivaouane',
		label: 'Tivaouane, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Joal-Fadiouth',
		label: 'Joal-Fadiouth, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kaffrine',
		label: 'Kaffrine, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Pout',
		label: 'Pout, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Vélingara',
		label: 'Vélingara, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Nioro',
		label: 'Nioro, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Sédhiou',
		label: 'Sédhiou, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Mékhé',
		label: 'Mékhé, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kébémer',
		label: 'Kébémer, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Kédougou',
		label: 'Kédougou, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Guinguinéo',
		label: 'Guinguinéo, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Koungheul',
		label: 'Koungheul, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Sokone',
		label: 'Sokone, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Wassadou',
		label: 'Wassadou, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Matam',
		label: 'Matam, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Waoundé',
		label: 'Waoundé, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Gossas',
		label: 'Gossas, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Ourossogui',
		label: 'Ourossogui, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Marsassoum',
		label: 'Marsassoum, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Ndoffane',
		label: 'Ndoffane, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Thionck-Essyl',
		label: 'Thionck-Essyl, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Thiadiaye',
		label: 'Thiadiaye, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Podor',
		label: 'Podor, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Oussouye',
		label: 'Oussouye, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Gandiaye',
		label: 'Gandiaye, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Nguékhokh',
		label: 'Nguékhokh, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Ndioum',
		label: 'Ndioum, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Semmé',
		label: 'Semmé, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Golléré',
		label: 'Golléré, Senegal',
		type: 'city',
		flagClass: 'fi fi-sn',
		isPopular: false,
	},
	{
		value: 'Serbia',
		label: 'Serbia',
		type: 'country',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Beograd',
		label: 'Beograd, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Novi Sad',
		label: 'Novi Sad, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Niš',
		label: 'Niš, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Apatin',
		label: 'Apatin, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kragujevac',
		label: 'Kragujevac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Subotica',
		label: 'Subotica, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Panchevo',
		label: 'Panchevo, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Zrenjanin',
		label: 'Zrenjanin, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Zaječar',
		label: 'Zaječar, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kruševac',
		label: 'Kruševac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Sombor',
		label: 'Sombor, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Senta',
		label: 'Senta, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Nova Pazova',
		label: 'Nova Pazova, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Chachak',
		label: 'Chachak, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kraljevo',
		label: 'Kraljevo, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Vranje',
		label: 'Vranje, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Šabac',
		label: 'Šabac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Bur',
		label: 'Bur, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Jagodina',
		label: 'Jagodina, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Paraćin',
		label: 'Paraćin, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Valjevo',
		label: 'Valjevo, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Požarevac',
		label: 'Požarevac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Vršac',
		label: 'Vršac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Ruma',
		label: 'Ruma, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Gornji Milanovac',
		label: 'Gornji Milanovac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Leskovac',
		label: 'Leskovac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Smederevo',
		label: 'Smederevo, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Užice',
		label: 'Užice, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Inđija',
		label: 'Inđija, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Obrenovac',
		label: 'Obrenovac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Mladenovac',
		label: 'Mladenovac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Loznica',
		label: 'Loznica, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Novi Pazar',
		label: 'Novi Pazar, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kikinda',
		label: 'Kikinda, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Borča',
		label: 'Borča, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Bačka Palanka',
		label: 'Bačka Palanka, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Prokuplje',
		label: 'Prokuplje, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Vrbas',
		label: 'Vrbas, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Bečej',
		label: 'Bečej, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Smederevska Palanka',
		label: 'Smederevska Palanka, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Aranđelovac',
		label: 'Aranđelovac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Lazarevac',
		label: 'Lazarevac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Ćuprija',
		label: 'Ćuprija, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Priboj',
		label: 'Priboj, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kula',
		label: 'Kula, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Stara Pazova',
		label: 'Stara Pazova, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Futog',
		label: 'Futog, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Sremčica',
		label: 'Sremčica, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Pirot',
		label: 'Pirot, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Uroševac',
		label: 'Uroševac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'BG',
		label: 'BG, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Kaluđerica',
		label: 'Kaluđerica, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Knjaževac',
		label: 'Knjaževac, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Temerin',
		label: 'Temerin, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Veternik',
		label: 'Veternik, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Trstenik',
		label: 'Trstenik, Serbia',
		type: 'city',
		flagClass: 'fi fi-rs',
		isPopular: false,
	},
	{
		value: 'Seychelles',
		label: 'Seychelles',
		type: 'country',
		flagClass: 'fi fi-sc',
		isPopular: true,
	},
	{
		value: 'Victoria',
		label: 'Victoria, Seychelles',
		type: 'city',
		flagClass: 'fi fi-sc',
		isPopular: false,
	},
	{
		value: 'Anse Boileau',
		label: 'Anse Boileau, Seychelles',
		type: 'city',
		flagClass: 'fi fi-sc',
		isPopular: false,
	},
	{
		value: 'Anse Royal',
		label: 'Anse Royal, Seychelles',
		type: 'city',
		flagClass: 'fi fi-sc',
		isPopular: false,
	},
	{
		value: 'Cascade',
		label: 'Cascade, Seychelles',
		type: 'city',
		flagClass: 'fi fi-sc',
		isPopular: false,
	},
	{
		value: 'Takamaka',
		label: 'Takamaka, Seychelles',
		type: 'city',
		flagClass: 'fi fi-sc',
		isPopular: false,
	},
	{
		value: 'Sierra Leone',
		label: 'Sierra Leone',
		type: 'country',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Freetown',
		label: 'Freetown, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Biama',
		label: 'Biama, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Bø',
		label: 'Bø, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Kenema',
		label: 'Kenema, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Kabala',
		label: 'Kabala, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Lungi',
		label: 'Lungi, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Lunsar',
		label: 'Lunsar, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Port Loko',
		label: 'Port Loko, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Matru',
		label: 'Matru, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Daru',
		label: 'Daru, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Makeni',
		label: 'Makeni, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Binkolo',
		label: 'Binkolo, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Bonthe',
		label: 'Bonthe, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'York',
		label: 'York, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Segbwema',
		label: 'Segbwema, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Kambia',
		label: 'Kambia, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Manowa',
		label: 'Manowa, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Pendembu',
		label: 'Pendembu, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Pujehun',
		label: 'Pujehun, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Koidu',
		label: 'Koidu, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Koindu',
		label: 'Koindu, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Yengema',
		label: 'Yengema, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Taiama',
		label: 'Taiama, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Magburaka',
		label: 'Magburaka, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Pepel',
		label: 'Pepel, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Yele',
		label: 'Yele, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Sefadu',
		label: 'Sefadu, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Kailahun',
		label: 'Kailahun, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Moyamba',
		label: 'Moyamba, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Kissy',
		label: 'Kissy, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Mambolo',
		label: 'Mambolo, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Giehun',
		label: 'Giehun, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Bumpe',
		label: 'Bumpe, Sierra Leone',
		type: 'city',
		flagClass: 'fi fi-sl',
		isPopular: false,
	},
	{
		value: 'Singapore',
		label: 'Singapore',
		type: 'country',
		flagClass: 'fi fi-sg',
		isPopular: false,
	},
	{
		value: 'Sint Maarten (Dutch part)',
		label: 'Sint Maarten (Dutch part)',
		type: 'country',
		flagClass: 'fi fi-sx',
		isPopular: false,
	},
	{
		value: 'Slovakia',
		label: 'Slovakia',
		type: 'country',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Bratislava',
		label: 'Bratislava, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Košice',
		label: 'Košice, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Bánovce',
		label: 'Bánovce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Trenchín',
		label: 'Trenchín, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Banská Bystrica',
		label: 'Banská Bystrica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Preshov',
		label: 'Preshov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Trnava',
		label: 'Trnava, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Komárno',
		label: 'Komárno, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nitra',
		label: 'Nitra, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zhilina',
		label: 'Zhilina, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Martin',
		label: 'Martin, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zvolen',
		label: 'Zvolen, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nové Zámky',
		label: 'Nové Zámky, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Levice',
		label: 'Levice, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Piesht'any",
		label: "Piesht'any, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Luchenec',
		label: 'Luchenec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Dolný Kubín',
		label: 'Dolný Kubín, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Poprad',
		label: 'Poprad, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Prievidza',
		label: 'Prievidza, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Michalovce',
		label: 'Michalovce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Humenné',
		label: 'Humenné, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Ruzhomberok',
		label: 'Ruzhomberok, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Rimavská Sobota',
		label: 'Rimavská Sobota, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Dunajská Streda',
		label: 'Dunajská Streda, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Stará L'ubovna",
		label: "Stará L'ubovna, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Vel'ký Krtísh",
		label: "Vel'ký Krtísh, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Povazhská Bystrica',
		label: 'Povazhská Bystrica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Liptovský Mikulásh',
		label: 'Liptovský Mikulásh, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Topol'chany",
		label: "Topol'chany, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Chadca',
		label: 'Chadca, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Dubnica',
		label: 'Dubnica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Partizánske',
		label: 'Partizánske, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Hlohovec',
		label: 'Hlohovec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Vranov',
		label: 'Vranov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Trebishov',
		label: 'Trebishov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Senica',
		label: 'Senica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Pezinok',
		label: 'Pezinok, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Handlová',
		label: 'Handlová, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Sered'",
		label: "Sered', Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Kysucké Nové Mesto',
		label: 'Kysucké Nové Mesto, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zlaté Moravce',
		label: 'Zlaté Moravce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Skalica',
		label: 'Skalica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Senec',
		label: 'Senec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Svidnik',
		label: 'Svidnik, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Shtúrovo',
		label: 'Shtúrovo, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Holích',
		label: 'Holích, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Banská Shtiavnica',
		label: 'Banská Shtiavnica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Stropkov',
		label: 'Stropkov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Kolárovo',
		label: 'Kolárovo, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Vráble',
		label: 'Vráble, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Vel'ký Meder",
		label: "Vel'ký Meder, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Modra',
		label: 'Modra, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Hurbanovo',
		label: 'Hurbanovo, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Námestovo',
		label: 'Námestovo, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Stupava',
		label: 'Stupava, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Král'ovský Chlmec",
		label: "Král'ovský Chlmec, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Turzovka',
		label: 'Turzovka, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Vrútky',
		label: 'Vrútky, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Vrbové',
		label: 'Vrbové, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Chierna nad Tisou',
		label: 'Chierna nad Tisou, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Spishská Nová Ves',
		label: 'Spishská Nová Ves, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Bardejov',
		label: 'Bardejov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Shal'a",
		label: "Shal'a, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Brezno',
		label: 'Brezno, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nové Mesto',
		label: 'Nové Mesto, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Snina',
		label: 'Snina, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Kezhmarok',
		label: 'Kezhmarok, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zhiar',
		label: 'Zhiar, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Rasnov',
		label: 'Rasnov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Púchov',
		label: 'Púchov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Malacky',
		label: 'Malacky, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Galanta',
		label: 'Galanta, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Detva',
		label: 'Detva, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Levocha',
		label: 'Levocha, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Revúca',
		label: 'Revúca, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Myjava',
		label: 'Myjava, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nová Dubnica',
		label: 'Nová Dubnica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Sabinov',
		label: 'Sabinov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Shamorín',
		label: 'Shamorín, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Bytcha',
		label: 'Bytcha, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Shurany',
		label: 'Shurany, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Stará Turá',
		label: 'Stará Turá, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Fil'akovo",
		label: "Fil'akovo, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Vel'ké Kapushany",
		label: "Vel'ké Kapushany, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Moldava nad Bodvou',
		label: 'Moldava nad Bodvou, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Tvrdoshín',
		label: 'Tvrdoshín, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Krompachy',
		label: 'Krompachy, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Hrinová',
		label: 'Hrinová, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Liptovský Hrádok',
		label: 'Liptovský Hrádok, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Tornal'a",
		label: "Tornal'a, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Shahy',
		label: 'Shahy, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Krupina',
		label: 'Krupina, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Sechovce',
		label: 'Sechovce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Hnúsht'a",
		label: "Hnúsht'a, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Kaliningrad',
		label: 'Kaliningrad, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Trstená',
		label: 'Trstená, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zheliezovce',
		label: 'Zheliezovce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Rajec',
		label: 'Rajec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Svit',
		label: 'Svit, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Turchianské Teplice',
		label: 'Turchianské Teplice, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Medzilaborce',
		label: 'Medzilaborce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Zharnovica',
		label: 'Zharnovica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Gelnica',
		label: 'Gelnica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Sobrance',
		label: 'Sobrance, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nemshová',
		label: 'Nemshová, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Poltár',
		label: 'Poltár, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Sládkovichovo',
		label: 'Sládkovichovo, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Spishská Belá',
		label: 'Spishská Belá, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Lipany',
		label: 'Lipany, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Kremnica',
		label: 'Kremnica, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Brezová pod Bradlom',
		label: 'Brezová pod Bradlom, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Ilava',
		label: 'Ilava, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Gbely',
		label: 'Gbely, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Bojnice',
		label: 'Bojnice, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Dobshiná',
		label: 'Dobshiná, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Sliach',
		label: 'Sliach, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Svätý Jur',
		label: 'Svätý Jur, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Strázhske',
		label: 'Strázhske, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Nováky',
		label: 'Nováky, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Trenchianske Teplice',
		label: 'Trenchianske Teplice, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Tlmache',
		label: 'Tlmache, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Giraltovce',
		label: 'Giraltovce, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Tisovec',
		label: 'Tisovec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Leopoldov',
		label: 'Leopoldov, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: "Vel'ký Sharish",
		label: "Vel'ký Sharish, Slovakia",
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Spishské Podhradie',
		label: 'Spishské Podhradie, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Medzev',
		label: 'Medzev, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Podolínec',
		label: 'Podolínec, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Svodín',
		label: 'Svodín, Slovakia',
		type: 'city',
		flagClass: 'fi fi-sk',
		isPopular: false,
	},
	{
		value: 'Slovenia',
		label: 'Slovenia',
		type: 'country',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ljubljana',
		label: 'Ljubljana, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Maribor',
		label: 'Maribor, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Kranj',
		label: 'Kranj, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ajdovshchina',
		label: 'Ajdovshchina, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Koper',
		label: 'Koper, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Celje',
		label: 'Celje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Nova Gorica',
		label: 'Nova Gorica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Domzhale',
		label: 'Domzhale, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ptuj',
		label: 'Ptuj, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Slovenska Bistrica',
		label: 'Slovenska Bistrica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Grosuplje',
		label: 'Grosuplje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Trbovlje',
		label: 'Trbovlje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Kamnik',
		label: 'Kamnik, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Vrhnika',
		label: 'Vrhnika, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Krshko',
		label: 'Krshko, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Zagorje ob Savi',
		label: 'Zagorje ob Savi, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Idrija',
		label: 'Idrija, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Mengesh',
		label: 'Mengesh, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Bled',
		label: 'Bled, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Velenje',
		label: 'Velenje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Nové Mesto na Morave',
		label: 'Nové Mesto na Morave, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shkofja Loka',
		label: 'Shkofja Loka, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Logatec',
		label: 'Logatec, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Chrnomelj',
		label: 'Chrnomelj, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Sezhana',
		label: 'Sezhana, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Slovenske Konjice',
		label: 'Slovenske Konjice, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Dravograd',
		label: 'Dravograd, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Bistrica ob Trzhichu',
		label: 'Bistrica ob Trzhichu, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ankaran',
		label: 'Ankaran, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Portorozh',
		label: 'Portorozh, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Vrtojba',
		label: 'Vrtojba, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Izola',
		label: 'Izola, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Postojna',
		label: 'Postojna, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Slovenj Gradec',
		label: 'Slovenj Gradec, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Brezhice',
		label: 'Brezhice, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Hrastnik',
		label: 'Hrastnik, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lucija',
		label: 'Lucija, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Piran',
		label: 'Piran, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shempeter',
		label: 'Shempeter, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Cerknica',
		label: 'Cerknica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ribnica',
		label: 'Ribnica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Solkan',
		label: 'Solkan, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Zhelezniki',
		label: 'Zhelezniki, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Metlika',
		label: 'Metlika, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Trebnje',
		label: 'Trebnje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Zreche',
		label: 'Zreche, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shenchur',
		label: 'Shenchur, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Radlje ob Dravi',
		label: 'Radlje ob Dravi, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Rache',
		label: 'Rache, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Brezovica pri Ljubljani',
		label: 'Brezovica pri Ljubljani, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Limbush',
		label: 'Limbush, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Strazha',
		label: 'Strazha, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lovrenc na Pohorju',
		label: 'Lovrenc na Pohorju, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Mozirje',
		label: 'Mozirje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Renche',
		label: 'Renche, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Jesenice',
		label: 'Jesenice, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Murska Sobota',
		label: 'Murska Sobota, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ravne',
		label: 'Ravne, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Litija',
		label: 'Litija, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Radovljica',
		label: 'Radovljica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Zhalec',
		label: 'Zhalec, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Medvode',
		label: 'Medvode, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Sevnica',
		label: 'Sevnica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ilirska Bistrica',
		label: 'Ilirska Bistrica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Rogashka Slatina',
		label: 'Rogashka Slatina, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shentjur',
		label: 'Shentjur, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Rushe',
		label: 'Rushe, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Prevalje',
		label: 'Prevalje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Monfalcone',
		label: 'Monfalcone, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Miklavzh na Dravskem Polju',
		label: 'Miklavzh na Dravskem Polju, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Tolmin',
		label: 'Tolmin, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Zhiri',
		label: 'Zhiri, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Mezhica',
		label: 'Mezhica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lashko',
		label: 'Lashko, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lendava',
		label: 'Lendava, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ljutomer',
		label: 'Ljutomer, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Trzin',
		label: 'Trzin, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Gornja Radgona',
		label: 'Gornja Radgona, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Vir',
		label: 'Vir, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shoshtanj',
		label: 'Shoshtanj, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lesce',
		label: 'Lesce, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Lenart',
		label: 'Lenart, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Chrna na Koroshkem',
		label: 'Chrna na Koroshkem, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Muta',
		label: 'Muta, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Polzela',
		label: 'Polzela, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Senovo',
		label: 'Senovo, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Radeche',
		label: 'Radeche, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Beltinci',
		label: 'Beltinci, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Koroshka Bela',
		label: 'Koroshka Bela, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ormozh',
		label: 'Ormozh, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Radenci',
		label: 'Radenci, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Spodnje Hoche',
		label: 'Spodnje Hoche, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Borovnica',
		label: 'Borovnica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Ig',
		label: 'Ig, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Jagodje',
		label: 'Jagodje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shkofljica',
		label: 'Shkofljica, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Pivka',
		label: 'Pivka, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Rakek',
		label: 'Rakek, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Vojnik',
		label: 'Vojnik, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Shtore',
		label: 'Shtore, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Mislinja',
		label: 'Mislinja, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Slovenski Javornik',
		label: 'Slovenski Javornik, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Spodnja Idrija',
		label: 'Spodnja Idrija, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Kromberk',
		label: 'Kromberk, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Verd',
		label: 'Verd, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Vnanje Gorice',
		label: 'Vnanje Gorice, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Kranjska Gora',
		label: 'Kranjska Gora, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Pesnica pri Mariboru',
		label: 'Pesnica pri Mariboru, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Novo mesto',
		label: 'Novo mesto, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Kochevje',
		label: 'Kochevje, Slovenia',
		type: 'city',
		flagClass: 'fi fi-si',
		isPopular: false,
	},
	{
		value: 'Solomon Islands',
		label: 'Solomon Islands',
		type: 'country',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Honiara',
		label: 'Honiara, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Auki',
		label: 'Auki, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Tulagi',
		label: 'Tulagi, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Cuauhtenco',
		label: 'Cuauhtenco, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Gizo',
		label: 'Gizo, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Buala',
		label: 'Buala, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Kirakira',
		label: 'Kirakira, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Taro Island',
		label: 'Taro Island, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Tigoa',
		label: 'Tigoa, Solomon Islands',
		type: 'city',
		flagClass: 'fi fi-sb',
		isPopular: false,
	},
	{
		value: 'Somalia',
		label: 'Somalia',
		type: 'country',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Mogadishu',
		label: 'Mogadishu, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Afgoye',
		label: 'Afgoye, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Hargeysa',
		label: 'Hargeysa, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Baydhabo',
		label: 'Baydhabo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bosaso',
		label: 'Bosaso, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Adadlay',
		label: '´Adadlay, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Jamame',
		label: 'Jamame, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Berbera',
		label: 'Berbera, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Kismayo',
		label: 'Kismayo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Marka',
		label: 'Marka, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Qoryoley',
		label: 'Qoryoley, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Wanlaweyn',
		label: 'Wanlaweyn, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Qardho',
		label: 'Qardho, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Jilib',
		label: 'Jilib, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Borama',
		label: 'Borama, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Galka´yo',
		label: 'Galka´yo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Las´anod',
		label: 'Las´anod, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Luq',
		label: 'Luq, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Jawhar',
		label: 'Jawhar, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Beled Wêyne',
		label: 'Beled Wêyne, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bur´o',
		label: 'Bur´o, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Êldhêre',
		label: '´Êldhêre, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bur Hakkaba',
		label: 'Bur Hakkaba, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Awdhêgle',
		label: 'Awdhêgle, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bardhêre',
		label: 'Bardhêre, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Barawe',
		label: 'Barawe, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bulobarde',
		label: 'Bulobarde, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bandarbeyla',
		label: 'Bandarbeyla, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Garowe',
		label: 'Garowe, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Êrigabo',
		label: '´Êrigabo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Dinsor',
		label: 'Dinsor, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Garbaharey',
		label: 'Garbaharey, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Baki',
		label: 'Baki, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bur Gabo',
		label: 'Bur Gabo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Berêda',
		label: 'Berêda, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Sha´´ab',
		label: 'Sha´´ab, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Mahadday Weyne',
		label: 'Mahadday Weyne, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bandarmu´ayo',
		label: 'Bandarmu´ayo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Xafun',
		label: 'Xafun, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Qandala',
		label: 'Qandala, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Eyl',
		label: 'Eyl, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Êk',
		label: '´Êk, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Êlbur',
		label: '´Êlbur, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Dhusa Marrêb',
		label: 'Dhusa Marrêb, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Dolaw',
		label: 'Dolaw, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Gebilay',
		label: 'Gebilay, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Afmadu',
		label: 'Afmadu, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Jalalassi',
		label: 'Jalalassi, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Sayla´',
		label: 'Sayla´, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bargal',
		label: 'Bargal, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Lasqoray',
		label: 'Lasqoray, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Alula',
		label: '´Alula, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Bal´ad',
		label: 'Bal´ad, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Xuddur',
		label: 'Xuddur, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Iskushuban',
		label: 'Iskushuban, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Odweyne',
		label: 'Odweyne, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Hobyo',
		label: 'Hobyo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: '´Adale',
		label: '´Adale, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Dujuma',
		label: 'Dujuma, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Wajid',
		label: 'Wajid, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Yêt',
		label: 'Yêt, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Tayêglo',
		label: 'Tayêglo, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'Xarardhêre',
		label: 'Xarardhêre, Somalia',
		type: 'city',
		flagClass: 'fi fi-so',
		isPopular: false,
	},
	{
		value: 'South Africa',
		label: 'South Africa',
		type: 'country',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Cape Town',
		label: 'Cape Town, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Johannesburg',
		label: 'Johannesburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Pretoria',
		label: 'Pretoria, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Durban',
		label: 'Durban, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bloemfontein',
		label: 'Bloemfontein, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Adelaide',
		label: 'Adelaide, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Port Elizabeth',
		label: 'Port Elizabeth, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Stellenbosch',
		label: 'Stellenbosch, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Midrand',
		label: 'Midrand, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Nelspruit',
		label: 'Nelspruit, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Benoni',
		label: 'Benoni, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Pietermaritzburg',
		label: 'Pietermaritzburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Boksburg',
		label: 'Boksburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Alberton',
		label: 'Alberton, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'East London',
		label: 'East London, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Richards Bay',
		label: 'Richards Bay, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Krugersdorp',
		label: 'Krugersdorp, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Rustenburg',
		label: 'Rustenburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Paarl',
		label: 'Paarl, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Potchefstroom',
		label: 'Potchefstroom, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Knysna',
		label: 'Knysna, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Secunda',
		label: 'Secunda, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Witbank',
		label: 'Witbank, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Klerksdorp',
		label: 'Klerksdorp, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'George',
		label: 'George, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Vanderbijlpark',
		label: 'Vanderbijlpark, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Plettenberg Bay',
		label: 'Plettenberg Bay, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Soweto',
		label: 'Soweto, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Pietersburg',
		label: 'Pietersburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Grahamstown',
		label: 'Grahamstown, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Vereeniging',
		label: 'Vereeniging, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Carltonville',
		label: 'Carltonville, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Randfontein',
		label: 'Randfontein, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Middelburg',
		label: 'Middelburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Port Alfred',
		label: 'Port Alfred, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Brakpan',
		label: 'Brakpan, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kimberley',
		label: 'Kimberley, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kroonstad',
		label: 'Kroonstad, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Tzaneen',
		label: 'Tzaneen, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Springs',
		label: 'Springs, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Worcester',
		label: 'Worcester, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mmabatho',
		label: 'Mmabatho, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Jeffreys Bay',
		label: 'Jeffreys Bay, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Newcastle',
		label: 'Newcastle, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Welkom',
		label: 'Welkom, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Hermanus',
		label: 'Hermanus, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Saldanha',
		label: 'Saldanha, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bronkhorstspruit',
		label: 'Bronkhorstspruit, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kathu',
		label: 'Kathu, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Tembisa',
		label: 'Tembisa, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Uitenhage',
		label: 'Uitenhage, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Umtata',
		label: 'Umtata, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mosselbay',
		label: 'Mosselbay, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Margate',
		label: 'Margate, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Fochville',
		label: 'Fochville, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Howick',
		label: 'Howick, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Empangeni',
		label: 'Empangeni, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lydenburg',
		label: 'Lydenburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Thulamahashe',
		label: 'Thulamahashe, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Komatipoort',
		label: 'Komatipoort, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Verwoerdburg',
		label: 'Verwoerdburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Phalaborwa',
		label: 'Phalaborwa, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mabopane',
		label: 'Mabopane, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Sasolburg',
		label: 'Sasolburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Oudtshoorn',
		label: 'Oudtshoorn, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lichtenburg',
		label: 'Lichtenburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Heidelberg',
		label: 'Heidelberg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Delmas',
		label: 'Delmas, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Port Shepstone',
		label: 'Port Shepstone, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Scottsburgh',
		label: 'Scottsburgh, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Zeerust',
		label: 'Zeerust, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ballitoville',
		label: 'Ballitoville, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Somerset East',
		label: 'Somerset East, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Belfast',
		label: 'Belfast, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Alice',
		label: 'Alice, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Caledon',
		label: 'Caledon, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Standerton',
		label: 'Standerton, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Virginia',
		label: 'Virginia, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Brits',
		label: 'Brits, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Upington',
		label: 'Upington, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Phuthaditjhaba',
		label: 'Phuthaditjhaba, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Vryburg',
		label: 'Vryburg, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Stanger',
		label: 'Stanger, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ekangala',
		label: 'Ekangala, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Harrismith',
		label: 'Harrismith, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Butterworth',
		label: 'Butterworth, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Richmond',
		label: 'Richmond, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Malmesbury',
		label: 'Malmesbury, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Wolmaranstad',
		label: 'Wolmaranstad, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Cullinan',
		label: 'Cullinan, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Volksrust',
		label: 'Volksrust, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Robertson',
		label: 'Robertson, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Umkomaas',
		label: 'Umkomaas, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Witrivier',
		label: 'Witrivier, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mankweng',
		label: 'Mankweng, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Brandfort',
		label: 'Brandfort, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Thabazimbi',
		label: 'Thabazimbi, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ritchie',
		label: 'Ritchie, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kuruman',
		label: 'Kuruman, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Calvinia',
		label: 'Calvinia, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Westonaria',
		label: 'Westonaria, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Makasar',
		label: 'Makasar, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Nigel',
		label: 'Nigel, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Potgietersrus',
		label: 'Potgietersrus, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Louis Trichardt',
		label: 'Louis Trichardt, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bethlehem',
		label: 'Bethlehem, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Queenstown',
		label: 'Queenstown, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Temba',
		label: 'Temba, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ermelo',
		label: 'Ermelo, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Thaba Nchu',
		label: 'Thaba Nchu, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kgotsong',
		label: 'Kgotsong, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Warmbad',
		label: 'Warmbad, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Beaufort-West',
		label: 'Beaufort-West, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Piet Retief',
		label: 'Piet Retief, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Schweizer Reneke',
		label: 'Schweizer Reneke, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Cradock',
		label: 'Cradock, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Dundee',
		label: 'Dundee, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Barberton',
		label: 'Barberton, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lulekani',
		label: 'Lulekani, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Fort Beaufort',
		label: 'Fort Beaufort, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'De Aar',
		label: 'De Aar, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lebowakgomo',
		label: 'Lebowakgomo, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lady Frere',
		label: 'Lady Frere, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kokstad',
		label: 'Kokstad, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Balfour',
		label: 'Balfour, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Aliwal North',
		label: 'Aliwal North, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Giyani',
		label: 'Giyani, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Theunissen',
		label: 'Theunissen, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Messina',
		label: 'Messina, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Grabouw',
		label: 'Grabouw, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ellisras',
		label: 'Ellisras, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ulundi',
		label: 'Ulundi, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Eshowe',
		label: 'Eshowe, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kriel',
		label: 'Kriel, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Greytown',
		label: 'Greytown, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Needscamp',
		label: 'Needscamp, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Jan Kempdorp',
		label: 'Jan Kempdorp, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Glencoe',
		label: 'Glencoe, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Burgersdorp',
		label: 'Burgersdorp, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Clocolan',
		label: 'Clocolan, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Breyten',
		label: 'Breyten, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Danielskuil',
		label: 'Danielskuil, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Molteno',
		label: 'Molteno, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mooi River',
		label: 'Mooi River, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Dordrecht',
		label: 'Dordrecht, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Willowmore',
		label: 'Willowmore, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Umzimvubu',
		label: 'Umzimvubu, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Carnarvon',
		label: 'Carnarvon, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Utrecht',
		label: 'Utrecht, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Somerset West',
		label: 'Somerset West, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Melkbosstrand',
		label: 'Melkbosstrand, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Germiston',
		label: 'Germiston, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Botshabelo',
		label: 'Botshabelo, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bisho',
		label: 'Bisho, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Emnambithi',
		label: 'Emnambithi, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Epumalanga',
		label: 'Epumalanga, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Embalenhle',
		label: 'Embalenhle, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Orkney',
		label: 'Orkney, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'GaRankuwa',
		label: 'GaRankuwa, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Vryheid',
		label: 'Vryheid, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Stilfontein',
		label: 'Stilfontein, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Atlantis',
		label: 'Atlantis, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kutlwanong',
		label: 'Kutlwanong, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bethal',
		label: 'Bethal, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Parys',
		label: 'Parys, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Thohoyandou',
		label: 'Thohoyandou, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Esikhawini',
		label: 'Esikhawini, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Siyabuswa',
		label: 'Siyabuswa, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Graaff-Reinet',
		label: 'Graaff-Reinet, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mondlo',
		label: 'Mondlo, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Wembezi',
		label: 'Wembezi, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Centurion',
		label: 'Centurion, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ceres',
		label: 'Ceres, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Phola',
		label: 'Phola, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Lebohang',
		label: 'Lebohang, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Heilbron',
		label: 'Heilbron, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Viljoenskroon',
		label: 'Viljoenskroon, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Wesselsbron',
		label: 'Wesselsbron, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Duiwelskloof',
		label: 'Duiwelskloof, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Hennenman',
		label: 'Hennenman, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Pampierstad',
		label: 'Pampierstad, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ekuphumleni',
		label: 'Ekuphumleni, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Mpophomeni',
		label: 'Mpophomeni, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Frankfort',
		label: 'Frankfort, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Stutterheim',
		label: 'Stutterheim, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Nylstroom',
		label: 'Nylstroom, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Allanridge',
		label: 'Allanridge, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bulfontein',
		label: 'Bulfontein, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Senekal',
		label: 'Senekal, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Nkowakowa',
		label: 'Nkowakowa, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Kruisfontein',
		label: 'Kruisfontein, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ezibeleni',
		label: 'Ezibeleni, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Warrenton',
		label: 'Warrenton, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ncotshane',
		label: 'Ncotshane, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Christiana',
		label: 'Christiana, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Ladybrand',
		label: 'Ladybrand, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Bloemhof',
		label: 'Bloemhof, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Reitz',
		label: 'Reitz, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Hendrina',
		label: 'Hendrina, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'Vrede',
		label: 'Vrede, South Africa',
		type: 'city',
		flagClass: 'fi fi-za',
		isPopular: false,
	},
	{
		value: 'South Georgia and the South Sandwich Islands',
		label: 'South Georgia and the South Sandwich Islands',
		type: 'country',
		flagClass: 'fi fi-gs',
		isPopular: false,
	},
	{
		value: 'South Sudan',
		label: 'South Sudan',
		type: 'country',
		flagClass: 'fi fi-ss',
		isPopular: false,
	},
	{
		value: 'Valencia',
		label: 'Valencia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'A Coruña',
		label: 'A Coruña, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sevilla',
		label: 'Sevilla, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Málaga',
		label: 'Málaga, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Palma',
		label: 'Palma, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alacant',
		label: 'Alacant, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Marbella',
		label: 'Marbella, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torrevieja',
		label: 'Torrevieja, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Murcia',
		label: 'Murcia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Bilbao',
		label: 'Bilbao, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Girona',
		label: 'Girona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Cruz de Tenerife',
		label: 'Santa Cruz de Tenerife, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Granada',
		label: 'Granada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Zaragoza',
		label: 'Zaragoza, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Las Palmas',
		label: 'Las Palmas, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Fuengirola',
		label: 'Fuengirola, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Almería',
		label: 'Almería, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cádiz',
		label: 'Cádiz, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Tarragona',
		label: 'Tarragona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Gijón',
		label: 'Gijón, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vigo',
		label: 'Vigo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Oviedo',
		label: 'Oviedo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Estepona',
		label: 'Estepona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Valladolid',
		label: 'Valladolid, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Terrassa',
		label: 'Terrassa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Salamanca',
		label: 'Salamanca, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Badalona',
		label: 'Badalona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cartagena',
		label: 'Cartagena, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sabadell',
		label: 'Sabadell, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pamplona',
		label: 'Pamplona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Badajoz',
		label: 'Badajoz, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Donostia',
		label: 'Donostia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cantabria',
		label: 'Cantabria, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santiago de Compostela',
		label: 'Santiago de Compostela, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Arona',
		label: 'Arona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Abarán',
		label: 'Abarán, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'La Rioja',
		label: 'La Rioja, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sant Cugat del Vallès',
		label: 'Sant Cugat del Vallès, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Castelló',
		label: 'Castelló, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Lleida',
		label: 'Lleida, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Puerto del Rosario',
		label: 'Puerto del Rosario, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Toledo',
		label: 'Toledo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Rota',
		label: 'Rota, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ourense',
		label: 'Ourense, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Huelva',
		label: 'Huelva, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'León',
		label: 'León, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sitges',
		label: 'Sitges, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vitoria',
		label: 'Vitoria, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pontevedra',
		label: 'Pontevedra, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Albox',
		label: 'Albox, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Benidorm',
		label: 'Benidorm, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Eivissa',
		label: 'Eivissa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Córdoba',
		label: 'Córdoba, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Albacete',
		label: 'Albacete, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcorcón',
		label: 'Alcorcón, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Madrid',
		label: 'Madrid, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: true,
	},
	{
		value: 'Barcelona',
		label: 'Barcelona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: true,
	},
	{
		value: 'Ibiza',
		label: 'Ibiza, Spain',
		type: 'island',
		flagClass: 'fi fi-es',
		isPopular: true,
	},
	{
		value: 'Huesca',
		label: 'Huesca, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Dénia',
		label: 'Dénia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mahón',
		label: 'Mahón, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcalá de Henares',
		label: 'Alcalá de Henares, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'A Estrada',
		label: 'A Estrada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ponferrada',
		label: 'Ponferrada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Benalmádena',
		label: 'Benalmádena, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcobendas',
		label: 'Alcobendas, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Algeciras',
		label: 'Algeciras, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pozuelo de Alarcón',
		label: 'Pozuelo de Alarcón, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Manresa',
		label: 'Manresa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vilanova i la Geltrú',
		label: 'Vilanova i la Geltrú, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vilafranca del Penedès',
		label: 'Vilafranca del Penedès, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Elx',
		label: 'Elx, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Burgos',
		label: 'Burgos, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cáceres',
		label: 'Cáceres, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ciudad Real',
		label: 'Ciudad Real, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Gandia',
		label: 'Gandia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Majadahonda',
		label: 'Majadahonda, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'La Línea',
		label: 'La Línea, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torremolinos',
		label: 'Torremolinos, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Castelldefels',
		label: 'Castelldefels, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Altea',
		label: 'Altea, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ronda',
		label: 'Ronda, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vic',
		label: 'Vic, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Premià de Mar',
		label: 'Premià de Mar, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Móstoles',
		label: 'Móstoles, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Pola',
		label: 'Santa Pola, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mataró',
		label: 'Mataró, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Lugo',
		label: 'Lugo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Xàbia',
		label: 'Xàbia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Palencia',
		label: 'Palencia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torrent',
		label: 'Torrent, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vélez-Málaga',
		label: 'Vélez-Málaga, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcoi',
		label: 'Alcoi, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cerdanyola',
		label: 'Cerdanyola, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torrelavega',
		label: 'Torrelavega, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pozoblanco',
		label: 'Pozoblanco, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Malgrat de Mar',
		label: 'Malgrat de Mar, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Tortosa',
		label: 'Tortosa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Xàtiva',
		label: 'Xàtiva, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Lloret de Mar',
		label: 'Lloret de Mar, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'El Puerto de Santa María',
		label: 'El Puerto de Santa María, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alhaurín el Grande',
		label: 'Alhaurín el Grande, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'San Sebastián de los Reyes',
		label: 'San Sebastián de los Reyes, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Viladecans',
		label: 'Viladecans, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Segovia',
		label: 'Segovia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Granollers',
		label: 'Granollers, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cuenca',
		label: 'Cuenca, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Arrecife',
		label: 'Arrecife, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Coín',
		label: 'Coín, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Tres Cantos',
		label: 'Tres Cantos, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Igualada',
		label: 'Igualada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ontinyent',
		label: 'Ontinyent, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Figueres',
		label: 'Figueres, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sant Joan Despí',
		label: 'Sant Joan Despí, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Boadilla del Monte',
		label: 'Boadilla del Monte, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Montornès del Vallès',
		label: 'Montornès del Vallès, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Totana',
		label: 'Totana, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sant Pere de Ribes',
		label: 'Sant Pere de Ribes, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Banyoles',
		label: 'Banyoles, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcúdia',
		label: 'Alcúdia, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sant Celoni',
		label: 'Sant Celoni, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ibi',
		label: 'Ibi, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Jerez',
		label: 'Jerez, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'El Escorial',
		label: 'El Escorial, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Jaén',
		label: 'Jaén, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torrejón de Ardoz',
		label: 'Torrejón de Ardoz, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Coloma de Gramenet',
		label: 'Santa Coloma de Gramenet, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Reus',
		label: 'Reus, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Avilés',
		label: 'Avilés, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Talavera de la Reina',
		label: 'Talavera de la Reina, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Getxo',
		label: 'Getxo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Adeje',
		label: 'Adeje, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Orihuela',
		label: 'Orihuela, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mijas',
		label: 'Mijas, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mieres',
		label: 'Mieres, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Basauri',
		label: 'Basauri, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Gavà',
		label: 'Gavà, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Soria',
		label: 'Soria, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Barbastro',
		label: 'Barbastro, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Caldes de Montbui',
		label: 'Caldes de Montbui, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Cruz de la Palma',
		label: 'Santa Cruz de la Palma, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Tomelloso',
		label: 'Tomelloso, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ripollet',
		label: 'Ripollet, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'La Pobla de Vallbona',
		label: 'La Pobla de Vallbona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pilar de la Horadada',
		label: 'Pilar de la Horadada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Puerto de la Cruz',
		label: 'Puerto de la Cruz, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Arcos de la Frontera',
		label: 'Arcos de la Frontera, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Tàrrega',
		label: 'Tàrrega, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Balaguer',
		label: 'Balaguer, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alhaurín de la Torre',
		label: 'Alhaurín de la Torre, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mazarrón',
		label: 'Mazarrón, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Inca',
		label: 'Inca, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Baza',
		label: 'Baza, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: "L'Hospitalet de Llobregat",
		label: "L'Hospitalet de Llobregat, Spain",
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Fuenlabrada',
		label: 'Fuenlabrada, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Perpètua de Mogoda',
		label: 'Santa Perpètua de Mogoda, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Priego de Córdoba',
		label: 'Priego de Córdoba, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Molins de Rei',
		label: 'Molins de Rei, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Granadilla de Abona',
		label: 'Granadilla de Abona, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vejer de la Frontera',
		label: 'Vejer de la Frontera, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Dos Hermanas',
		label: 'Dos Hermanas, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'El Campello',
		label: 'El Campello, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Oliva',
		label: 'Oliva, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'El Masnou',
		label: 'El Masnou, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Torrox',
		label: 'Torrox, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ferrol',
		label: 'Ferrol, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santoña',
		label: 'Santoña, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ceuta',
		label: 'Ceuta, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Santa Eulalia del Río',
		label: 'Santa Eulalia del Río, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Collado Villalba',
		label: 'Collado Villalba, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Elda',
		label: 'Elda, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mollet del Vallès',
		label: 'Mollet del Vallès, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Esplugues de Llobregat',
		label: 'Esplugues de Llobregat, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mula',
		label: 'Mula, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Mairena del Aljarafe',
		label: 'Mairena del Aljarafe, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ayamonte',
		label: 'Ayamonte, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Salou',
		label: 'Salou, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cártama',
		label: 'Cártama, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Cehegín',
		label: 'Cehegín, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Úbeda',
		label: 'Úbeda, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'San Lorenzo de El Escorial',
		label: 'San Lorenzo de El Escorial, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Vilagarcía de Arousa',
		label: 'Vilagarcía de Arousa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Teruel',
		label: 'Teruel, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: "L'Eliana",
		label: "L'Eliana, Spain",
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Blanes',
		label: 'Blanes, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Viveiro',
		label: 'Viveiro, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: "La Vall d'Uixó",
		label: "La Vall d'Uixó, Spain",
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Alcañiz',
		label: 'Alcañiz, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Älät',
		label: 'Älät, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Eibar',
		label: 'Eibar, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Arenys de Mar',
		label: 'Arenys de Mar, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Aguilar de la Frontera',
		label: 'Aguilar de la Frontera, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Llanes',
		label: 'Llanes, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Camargo',
		label: 'Camargo, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'O Barco de Valdeorras',
		label: 'O Barco de Valdeorras, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Ribeira',
		label: 'Ribeira, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Pollença',
		label: 'Pollença, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Betanzos',
		label: 'Betanzos, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'La Vila Joiosa',
		label: 'La Vila Joiosa, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Castro-Urdiales',
		label: 'Castro-Urdiales, Spain',
		type: 'city',
		flagClass: 'fi fi-es',
		isPopular: false,
	},
	{
		value: 'Sri Lanka',
		label: 'Sri Lanka',
		type: 'country',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Colombo',
		label: 'Colombo, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Dehiwala-Mount Lavinia',
		label: 'Dehiwala-Mount Lavinia, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Sri Jayawardenepura',
		label: 'Sri Jayawardenepura, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Gampaha',
		label: 'Gampaha, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Ambalamgoda',
		label: 'Ambalamgoda, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Galle',
		label: 'Galle, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Battaramulla',
		label: 'Battaramulla, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Maharagama',
		label: 'Maharagama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kolonnawa',
		label: 'Kolonnawa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Moratuwa',
		label: 'Moratuwa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kurunegala',
		label: 'Kurunegala, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Maha Nuwara',
		label: 'Maha Nuwara, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Wattala',
		label: 'Wattala, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Homagama',
		label: 'Homagama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Jaela',
		label: 'Jaela, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kalutara',
		label: 'Kalutara, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Matara',
		label: 'Matara, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Ratnapuraya',
		label: 'Ratnapuraya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kelaniya',
		label: 'Kelaniya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kêgalla',
		label: 'Kêgalla, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Nawalapitiya',
		label: 'Nawalapitiya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kuliyapitiya',
		label: 'Kuliyapitiya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Daluguma',
		label: 'Daluguma, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Matale',
		label: 'Matale, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Katunayaka',
		label: 'Katunayaka, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Horana',
		label: 'Horana, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Gampola',
		label: 'Gampola, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Bandarawela',
		label: 'Bandarawela, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Anuradhapuraya',
		label: 'Anuradhapuraya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Amparai',
		label: 'Amparai, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Hendala',
		label: 'Hendala, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kandana',
		label: 'Kandana, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Minuwangoda',
		label: 'Minuwangoda, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Jaffna',
		label: 'Jaffna, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Badulla',
		label: 'Badulla, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Panadraya',
		label: 'Panadraya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Ragama',
		label: 'Ragama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Mulleriyawa',
		label: 'Mulleriyawa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kadugannawa',
		label: 'Kadugannawa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Puttalama',
		label: 'Puttalama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Beruwala',
		label: 'Beruwala, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Eravur',
		label: 'Eravur, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Balangoda',
		label: 'Balangoda, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Tanggalla',
		label: 'Tanggalla, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Migamuwa',
		label: 'Migamuwa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Chavakachchêri',
		label: 'Chavakachchêri, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Tirikunamalaya',
		label: 'Tirikunamalaya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Valvedditturai',
		label: 'Valvedditturai, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Dambulla',
		label: 'Dambulla, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Vavuniyawa',
		label: 'Vavuniyawa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Katankudi',
		label: 'Katankudi, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Nuwara Eliya',
		label: 'Nuwara Eliya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Seethawakapura',
		label: 'Seethawakapura, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Hatton',
		label: 'Hatton, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Polonnaruwa',
		label: 'Polonnaruwa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Monaragala',
		label: 'Monaragala, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Wattegama',
		label: 'Wattegama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Mullaitivu',
		label: 'Mullaitivu, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Pêduru Tuduwa',
		label: 'Pêduru Tuduwa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kotikawatta',
		label: 'Kotikawatta, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Mannarama',
		label: 'Mannarama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Peliyagoda',
		label: 'Peliyagoda, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Hambantota',
		label: 'Hambantota, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Polgahawela',
		label: 'Polgahawela, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Haputale',
		label: 'Haputale, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Talawakele',
		label: 'Talawakele, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Sigiriya',
		label: 'Sigiriya, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Galmunê',
		label: 'Galmunê, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Madakalpuwa',
		label: 'Madakalpuwa, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Keselwatta',
		label: 'Keselwatta, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Welesara',
		label: 'Welesara, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Halawata',
		label: 'Halawata, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Weligama',
		label: 'Weligama, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Kilinochchi',
		label: 'Kilinochchi, Sri Lanka',
		type: 'city',
		flagClass: 'fi fi-lk',
		isPopular: false,
	},
	{
		value: 'Sudan',
		label: 'Sudan',
		type: 'country',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Khartum',
		label: 'al-Khartum, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Durman',
		label: 'Umm Durman, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Khartum Bahri',
		label: 'al-Khartum Bahri, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Abu Hijar',
		label: 'Abu Hijar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Juba',
		label: 'Juba, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: '´Atbarah',
		label: '´Atbarah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sawakin',
		label: 'Sawakin, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Wad Madani',
		label: 'Wad Madani, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Fashir',
		label: 'al-Fashir, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kutum',
		label: 'Kutum, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Bur Sudan',
		label: 'Bur Sudan, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kassala',
		label: 'Kassala, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Damazin',
		label: 'ad-Damazin, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Duwaym',
		label: 'ad-Duwaym, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sandi',
		label: 'Sandi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Nasir',
		label: 'Nasir, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Abu Jubayhah',
		label: 'Abu Jubayhah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Abu Zabad',
		label: 'Abu Zabad, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Kurumuk',
		label: 'al-Kurumuk, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Niyala',
		label: 'Niyala, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Junaynah',
		label: 'al-Junaynah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Rabak',
		label: 'Rabak, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Damir',
		label: 'ad-Damir, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Khashm-al-Qirbah',
		label: 'Khashm-al-Qirbah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kodok',
		label: 'Kodok, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Yirol',
		label: 'Yirol, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Barbar',
		label: 'Barbar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Doka',
		label: 'Doka, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Dabbah',
		label: 'ad-Dabbah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Jazirah',
		label: 'al-Jazirah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kuraymah',
		label: 'Kuraymah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Dunqulah',
		label: 'Dunqulah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tangasi-ar-Ru´ays',
		label: 'Tangasi-ar-Ru´ays, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Dalqu',
		label: 'Dalqu, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kabushiyah',
		label: 'Kabushiyah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Abu Karshola',
		label: 'Abu Karshola, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Wad Rawah',
		label: 'Wad Rawah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tonj',
		label: 'Tonj, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Karmah-an-Nuzul',
		label: 'Karmah-an-Nuzul, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Ubayyid',
		label: 'al-Ubayyid, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Qadarif',
		label: 'al-Qadarif, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kusti',
		label: 'Kusti, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Manaqil',
		label: 'al-Manaqil, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kaduqli',
		label: 'Kaduqli, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Du´ayn',
		label: 'ad-Du´ayn, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sinnar',
		label: 'Sinnar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Ruwabah',
		label: 'Umm Ruwabah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Malakal',
		label: 'Malakal, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Waw',
		label: 'Waw, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Halfa al-Jadidah',
		label: 'Halfa al-Jadidah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'an-Nuhud',
		label: 'an-Nuhud, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Yei',
		label: 'Yei, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sinjah',
		label: 'Sinjah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Uwayl',
		label: 'Uwayl, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Gogrial',
		label: 'Gogrial, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Yambio',
		label: 'Yambio, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Babanusah',
		label: 'Babanusah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Dillinj',
		label: 'ad-Dillinj, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Arba´atun wa ´Ishrun-al-Qurashi',
		label: 'Arba´atun wa ´Ishrun-al-Qurashi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Rufa´a',
		label: 'Rufa´a, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'as-Suki',
		label: 'as-Suki, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Nzara',
		label: 'Nzara, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tandalti',
		label: 'Tandalti, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Bur',
		label: 'Bur, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Zalinqay',
		label: 'Zalinqay, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Mayurnu',
		label: 'Mayurnu, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Dawm',
		label: 'Umm Dawm, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Rumbik',
		label: 'Rumbik, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Asalaya',
		label: 'Asalaya, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Hawatah',
		label: 'al-Hawatah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kinanah',
		label: 'Kinanah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ar-Rusayris',
		label: 'ar-Rusayris, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ar-Rank',
		label: 'ar-Rank, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ad-Dindar',
		label: 'ad-Dindar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Warab',
		label: 'Warab, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Mijlad',
		label: 'al-Mijlad, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'ar-Rahad',
		label: 'ar-Rahad, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Maharaybah',
		label: 'Maharaybah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Shuwak',
		label: 'Shuwak, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Bawga',
		label: 'al-Bawga, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Husayhisah',
		label: 'al-Husayhisah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Karkawj',
		label: 'Karkawj, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Shawkah',
		label: 'Umm Shawkah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Wagar',
		label: 'Wagar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Hawsh',
		label: 'al-Hawsh, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Hilaliyah',
		label: 'al-Hilaliyah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-´Abbasiyah',
		label: 'al-´Abbasiyah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Torit',
		label: 'Torit, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Bara',
		label: 'Bara, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Qutaynah',
		label: 'al-Qutaynah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Rahad-al-Bardi',
		label: 'Rahad-al-Bardi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tawkar',
		label: 'Tawkar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Kawah',
		label: 'al-Kawah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kurti',
		label: 'Kurti, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Mashra ar-Raqq',
		label: 'Mashra ar-Raqq, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Huda',
		label: 'al-Huda, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Shabashah',
		label: 'Shabashah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Wadi Halfa',
		label: 'Wadi Halfa, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Kamilin',
		label: 'al-Kamilin, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Talawdi',
		label: 'Talawdi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tabat',
		label: 'Tabat, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Kaddadah',
		label: 'Umm Kaddadah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Matammah',
		label: 'al-Matammah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Hajj ´Abdallah',
		label: 'Hajj ´Abdallah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Fulah',
		label: 'al-Fulah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Ler',
		label: 'Ler, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Gabait',
		label: 'Gabait, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Marabba',
		label: 'Marabba, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sinkat',
		label: 'Sinkat, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tambul',
		label: 'Tambul, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Qala´-an-Nahl',
		label: 'Qala´-an-Nahl, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Karaymat',
		label: 'al-Karaymat, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kanisah',
		label: 'Kanisah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Miallayab',
		label: 'Miallayab, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Gulli',
		label: 'Gulli, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Sharafat',
		label: 'Sharafat, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Musallamiyah',
		label: 'al-Musallamiyah, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Marawi',
		label: 'Marawi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Maridi',
		label: 'Maridi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Abu ´Usar',
		label: 'Abu ´Usar, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Aruma',
		label: 'Aruma, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Wad-az-Zaki',
		label: 'Wad-az-Zaki, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Bentiu',
		label: 'Bentiu, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Faw',
		label: 'al-Faw, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'al-Quwaysi',
		label: 'al-Quwaysi, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Umm Jarr',
		label: 'Umm Jarr, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Lagawa',
		label: 'Lagawa, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Kapoêta',
		label: 'Kapoêta, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Galgani',
		label: 'Galgani, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Tambura',
		label: 'Tambura, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Argu',
		label: 'Argu, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Raga',
		label: 'Raga, Sudan',
		type: 'city',
		flagClass: 'fi fi-sd',
		isPopular: false,
	},
	{
		value: 'Suriname',
		label: 'Suriname',
		type: 'country',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Paramaribo',
		label: 'Paramaribo, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Lelydorp',
		label: 'Lelydorp, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Nieuw Nickerie',
		label: 'Nieuw Nickerie, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Albina',
		label: 'Albina, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Moengo',
		label: 'Moengo, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Meerzorg',
		label: 'Meerzorg, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Nieuw Amsterdam',
		label: 'Nieuw Amsterdam, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Aluksne',
		label: 'Aluksne, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Wageningen',
		label: 'Wageningen, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Groningen',
		label: 'Groningen, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Brownsweg',
		label: 'Brownsweg, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Brokopondo',
		label: 'Brokopondo, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Ellisras',
		label: 'Ellisras, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Totness',
		label: 'Totness, Suriname',
		type: 'city',
		flagClass: 'fi fi-sr',
		isPopular: false,
	},
	{
		value: 'Svalbard and Jan Mayen',
		label: 'Svalbard and Jan Mayen',
		type: 'country',
		flagClass: 'fi fi-sj',
		isPopular: false,
	},
	{
		value: 'Longyearbyen',
		label: 'Longyearbyen, Svalbard and Jan Mayen',
		type: 'city',
		flagClass: 'fi fi-sj',
		isPopular: false,
	},
	{
		value: 'Barentsburg',
		label: 'Barentsburg, Svalbard and Jan Mayen',
		type: 'city',
		flagClass: 'fi fi-sj',
		isPopular: false,
	},
	{
		value: 'Ny-Ålesund',
		label: 'Ny-Ålesund, Svalbard and Jan Mayen',
		type: 'city',
		flagClass: 'fi fi-sj',
		isPopular: false,
	},
	{
		value: 'Hornsund',
		label: 'Hornsund, Svalbard and Jan Mayen',
		type: 'city',
		flagClass: 'fi fi-sj',
		isPopular: false,
	},
	{
		value: 'Göteborg',
		label: 'Göteborg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Malmö',
		label: 'Malmö, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Lund',
		label: 'Lund, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Uppsala',
		label: 'Uppsala, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Helsingborg',
		label: 'Helsingborg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Linköping',
		label: 'Linköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Halmstad',
		label: 'Halmstad, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Luleå',
		label: 'Luleå, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Örebro',
		label: 'Örebro, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Karlstad',
		label: 'Karlstad, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Västerås',
		label: 'Västerås, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Umeå',
		label: 'Umeå, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Jönköping',
		label: 'Jönköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Växjö',
		label: 'Växjö, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Norrköping',
		label: 'Norrköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Borås',
		label: 'Borås, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Gävle',
		label: 'Gävle, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Borlänge',
		label: 'Borlänge, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Sundsvall',
		label: 'Sundsvall, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Alingsås',
		label: 'Alingsås, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Eskilstuna',
		label: 'Eskilstuna, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kalmar',
		label: 'Kalmar, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Skövde',
		label: 'Skövde, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Karlskrona',
		label: 'Karlskrona, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Uddevalla',
		label: 'Uddevalla, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Östersund',
		label: 'Östersund, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Trollhättan',
		label: 'Trollhättan, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kristianstad',
		label: 'Kristianstad, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Ronneby',
		label: 'Ronneby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Åkersberga',
		label: 'Åkersberga, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kungsbacka',
		label: 'Kungsbacka, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Ängelholm',
		label: 'Ängelholm, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Södertälje',
		label: 'Södertälje, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Örnsköldsvik',
		label: 'Örnsköldsvik, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Arvika',
		label: 'Arvika, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Falun',
		label: 'Falun, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Visby',
		label: 'Visby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Piteå',
		label: 'Piteå, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Ystad',
		label: 'Ystad, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Täby',
		label: 'Täby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Lidköping',
		label: 'Lidköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Enköping',
		label: 'Enköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Hässleholm',
		label: 'Hässleholm, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Lidingö',
		label: 'Lidingö, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Varberg',
		label: 'Varberg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Skellefteå',
		label: 'Skellefteå, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Landskrona',
		label: 'Landskrona, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Katrineholm',
		label: 'Katrineholm, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Hudiksvall',
		label: 'Hudiksvall, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Nynäshamn',
		label: 'Nynäshamn, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Karlshamn',
		label: 'Karlshamn, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Mariestad',
		label: 'Mariestad, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Eslöv',
		label: 'Eslöv, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Norrtälje',
		label: 'Norrtälje, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Lerum',
		label: 'Lerum, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Bollnäs',
		label: 'Bollnäs, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Tumba',
		label: 'Tumba, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Karlskoga',
		label: 'Karlskoga, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Oskarshamn',
		label: 'Oskarshamn, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Falköping',
		label: 'Falköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Ljungby',
		label: 'Ljungby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Mjölby',
		label: 'Mjölby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Nyköping',
		label: 'Nyköping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Trelleborg',
		label: 'Trelleborg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Sandviken',
		label: 'Sandviken, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kungälv',
		label: 'Kungälv, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Västervik',
		label: 'Västervik, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Boden',
		label: 'Boden, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Värnamo',
		label: 'Värnamo, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Ludvika',
		label: 'Ludvika, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Vetlanda',
		label: 'Vetlanda, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Strängnäs',
		label: 'Strängnäs, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Fagersta',
		label: 'Fagersta, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Märsta',
		label: 'Märsta, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Boo',
		label: 'Boo, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Falkenberg',
		label: 'Falkenberg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kristinehamn',
		label: 'Kristinehamn, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Bålsta',
		label: 'Bålsta, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Finspång',
		label: 'Finspång, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Söderhamn',
		label: 'Söderhamn, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Upplands-Väsby',
		label: 'Upplands-Väsby, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Motala',
		label: 'Motala, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Vänersborg',
		label: 'Vänersborg, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Härnösand',
		label: 'Härnösand, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Avesta',
		label: 'Avesta, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kumla',
		label: 'Kumla, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Nybro',
		label: 'Nybro, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Vallentuna',
		label: 'Vallentuna, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Köping',
		label: 'Köping, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Nässjö',
		label: 'Nässjö, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Tranås',
		label: 'Tranås, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Kinna',
		label: 'Kinna, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Mölnlycke',
		label: 'Mölnlycke, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Sala',
		label: 'Sala, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Älmhult',
		label: 'Älmhult, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Säffle',
		label: 'Säffle, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Skara',
		label: 'Skara, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Lysekil',
		label: 'Lysekil, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Girón',
		label: 'Girón, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'stratford',
		label: 'stratford, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Västerhaninge',
		label: 'Västerhaninge, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Staffanstorp',
		label: 'Staffanstorp, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Höganäs',
		label: 'Höganäs, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Skoghall',
		label: 'Skoghall, Sweden',
		type: 'city',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Zürich',
		label: 'Zürich, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Genève',
		label: 'Genève, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lausanne',
		label: 'Lausanne, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bern',
		label: 'Bern, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lugano',
		label: 'Lugano, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Basel',
		label: 'Basel, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Winterthur',
		label: 'Winterthur, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Luzern',
		label: 'Luzern, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zug',
		label: 'Zug, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Nyon',
		label: 'Nyon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Neuchatel',
		label: 'Neuchatel, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aadorf',
		label: 'Aadorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sankt Gallen',
		label: 'Sankt Gallen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Fribourg',
		label: 'Fribourg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Baden',
		label: 'Baden, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Schaffhausen',
		label: 'Schaffhausen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Montreux',
		label: 'Montreux, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Vevey',
		label: 'Vevey, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aarau',
		label: 'Aarau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Locarno',
		label: 'Locarno, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Morges',
		label: 'Morges, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bellinzona',
		label: 'Bellinzona, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Thalwil',
		label: 'Thalwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Biel',
		label: 'Biel, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sion',
		label: 'Sion, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Solothurn',
		label: 'Solothurn, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wettingen',
		label: 'Wettingen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zollikon',
		label: 'Zollikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Richterswil',
		label: 'Richterswil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Thun',
		label: 'Thun, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Adliswil',
		label: 'Adliswil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Versoix',
		label: 'Versoix, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Mendrisio',
		label: 'Mendrisio, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Chur',
		label: 'Chur, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Yverdon',
		label: 'Yverdon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Frauenfeld',
		label: 'Frauenfeld, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bülach',
		label: 'Bülach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Gland',
		label: 'Gland, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Dietikon',
		label: 'Dietikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Kloten',
		label: 'Kloten, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sierre',
		label: 'Sierre, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rapperswil',
		label: 'Rapperswil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Allschwil',
		label: 'Allschwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Kreuzlingen',
		label: 'Kreuzlingen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Olten',
		label: 'Olten, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Regensdorf',
		label: 'Regensdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Chiasso',
		label: 'Chiasso, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Uster',
		label: 'Uster, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Baar',
		label: 'Baar, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wädenswil',
		label: 'Wädenswil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wil',
		label: 'Wil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Küsnacht',
		label: 'Küsnacht, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Brugg',
		label: 'Brugg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lachen',
		label: 'Lachen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Birmensdorf',
		label: 'Birmensdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Pully',
		label: 'Pully, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Monthey',
		label: 'Monthey, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bulle',
		label: 'Bulle, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Pfäffikon',
		label: 'Pfäffikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Le Locle',
		label: 'Le Locle, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Stans',
		label: 'Stans, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bremgarten',
		label: 'Bremgarten, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Stäfa',
		label: 'Stäfa, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Buchs',
		label: 'Buchs, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lenzburg',
		label: 'Lenzburg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wangen-Brüttisellen',
		label: 'Wangen-Brüttisellen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Chavannes',
		label: 'Chavannes, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'La Chaux-de-Fonds',
		label: 'La Chaux-de-Fonds, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Glarus',
		label: 'Glarus, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Horgen',
		label: 'Horgen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sargans',
		label: 'Sargans, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Opfikon',
		label: 'Opfikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Spreitenbach',
		label: 'Spreitenbach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sursee',
		label: 'Sursee, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Yens',
		label: 'Yens, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Neuenhof',
		label: 'Neuenhof, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wollerau',
		label: 'Wollerau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Collonge-Bellerive',
		label: 'Collonge-Bellerive, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Dietlikon',
		label: 'Dietlikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Biasca',
		label: 'Biasca, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zermatt',
		label: 'Zermatt, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Buochs',
		label: 'Buochs, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Oberglatt',
		label: 'Oberglatt, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Ascona',
		label: 'Ascona, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Herisau',
		label: 'Herisau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Saint-Imier',
		label: 'Saint-Imier, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Volketswil',
		label: 'Volketswil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Langenthal',
		label: 'Langenthal, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Schwyz',
		label: 'Schwyz, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Cham',
		label: 'Cham, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rheinfelden',
		label: 'Rheinfelden, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lyss',
		label: 'Lyss, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Affoltern',
		label: 'Affoltern, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Davos',
		label: 'Davos, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zofingen',
		label: 'Zofingen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Kilchberg',
		label: 'Kilchberg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Payerne',
		label: 'Payerne, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Kriens',
		label: 'Kriens, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Appenzell',
		label: 'Appenzell, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Dübendorf',
		label: 'Dübendorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Orbe',
		label: 'Orbe, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wetzikon',
		label: 'Wetzikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Jona',
		label: 'Jona, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zumikon',
		label: 'Zumikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Allaman',
		label: 'Allaman, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Martigny',
		label: 'Martigny, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Thonex',
		label: 'Thonex, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Arzier',
		label: 'Arzier, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Arbon',
		label: 'Arbon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bursins',
		label: 'Bursins, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Meilen',
		label: 'Meilen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Küssnacht',
		label: 'Küssnacht, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Gingins',
		label: 'Gingins, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aesch',
		label: 'Aesch, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rolle',
		label: 'Rolle, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Männedorf',
		label: 'Männedorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Arth',
		label: 'Arth, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Langnau',
		label: 'Langnau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lutry',
		label: 'Lutry, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Embrach',
		label: 'Embrach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aigle',
		label: 'Aigle, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Emmen',
		label: 'Emmen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Eschenbach',
		label: 'Eschenbach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Meyrin',
		label: 'Meyrin, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Carouge',
		label: 'Carouge, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Renens',
		label: 'Renens, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Gossau',
		label: 'Gossau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Interlaken',
		label: 'Interlaken, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Blonay',
		label: 'Blonay, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Onex',
		label: 'Onex, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Huttwil',
		label: 'Huttwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Meiringen',
		label: 'Meiringen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Pratteln',
		label: 'Pratteln, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Burgdorf',
		label: 'Burgdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Wohlen',
		label: 'Wohlen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Schlieren',
		label: 'Schlieren, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aubonne',
		label: 'Aubonne, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Uzwil',
		label: 'Uzwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Coppet',
		label: 'Coppet, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Delémont',
		label: 'Delémont, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Crans-pres-Celigny',
		label: 'Crans-pres-Celigny, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Brig-Glis',
		label: 'Brig-Glis, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rüti',
		label: 'Rüti, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Grand-Lancy',
		label: 'Grand-Lancy, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Münchenstein',
		label: 'Münchenstein, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Altstätten',
		label: 'Altstätten, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Neuhausen',
		label: 'Neuhausen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Oberwil',
		label: 'Oberwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Saint-Prex',
		label: 'Saint-Prex, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Zollikofen',
		label: 'Zollikofen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Trelex',
		label: 'Trelex, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bassersdorf',
		label: 'Bassersdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bernex',
		label: 'Bernex, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Altdorf',
		label: 'Altdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Risch',
		label: 'Risch, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Hünenberg',
		label: 'Hünenberg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Kirchberg',
		label: 'Kirchberg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Giubiasco',
		label: 'Giubiasco, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Epalinges',
		label: 'Epalinges, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Au',
		label: 'Au, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Crissier',
		label: 'Crissier, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Seuzach',
		label: 'Seuzach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Dornach',
		label: 'Dornach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Thal',
		label: 'Thal, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rümlang',
		label: 'Rümlang, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Frenkendorf',
		label: 'Frenkendorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Herrliberg',
		label: 'Herrliberg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Murten',
		label: 'Murten, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Uetendorf',
		label: 'Uetendorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bottmingen',
		label: 'Bottmingen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Uznach',
		label: 'Uznach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Neuenkirch',
		label: 'Neuenkirch, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Peseux',
		label: 'Peseux, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Greifensee',
		label: 'Greifensee, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Heimberg',
		label: 'Heimberg, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Oberuzwil',
		label: 'Oberuzwil, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Teufen',
		label: 'Teufen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Rüschlikon',
		label: 'Rüschlikon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Riehen',
		label: 'Riehen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Cologny',
		label: 'Cologny, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Alpnach',
		label: 'Alpnach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Reinach',
		label: 'Reinach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Colombier',
		label: 'Colombier, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Le Mont-sur-Lausanne',
		label: 'Le Mont-sur-Lausanne, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Bellach',
		label: 'Bellach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Muttenz',
		label: 'Muttenz, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Laufen',
		label: 'Laufen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Sumiswald',
		label: 'Sumiswald, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Grenchen',
		label: 'Grenchen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Seon',
		label: 'Seon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Walenstadt',
		label: 'Walenstadt, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Fehraltdorf',
		label: 'Fehraltdorf, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Lengnau',
		label: 'Lengnau, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Arosa',
		label: 'Arosa, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Freienbach',
		label: 'Freienbach, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aire',
		label: 'Aire, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Aire-La-Ville',
		label: 'Aire-La-Ville, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Binningen',
		label: 'Binningen, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Anieres',
		label: 'Anieres, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Arnex-Sur-Nyon',
		label: 'Arnex-Sur-Nyon, Switzerland',
		type: 'city',
		flagClass: 'fi fi-ch',
		isPopular: false,
	},
	{
		value: 'Syrian Arab Republic',
		label: 'Syrian Arab Republic',
		type: 'country',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Dimashq',
		label: 'Dimashq, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Halab',
		label: 'Halab, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Abu Kamal',
		label: 'Abu Kamal, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Hims',
		label: 'Hims, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: '´Afrin',
		label: '´Afrin, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Ladhiqiyah',
		label: 'al-Ladhiqiyah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Hamah',
		label: 'Hamah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'as-Suwayda',
		label: 'as-Suwayda, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: '´Ayn-al-´Arab',
		label: '´Ayn-al-´Arab, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Duma',
		label: 'Duma, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Salamiyah',
		label: 'Salamiyah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Jablah',
		label: 'Jablah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Safita',
		label: 'Safita, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Dayr az-Zawr',
		label: 'Dayr az-Zawr, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Qamishli',
		label: 'al-Qamishli, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Jaramanah',
		label: 'Jaramanah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'an-Nabk',
		label: 'an-Nabk, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'ar-Raqqah',
		label: 'ar-Raqqah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Dar´a',
		label: 'Dar´a, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Bab',
		label: 'al-Bab, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Malikiyah',
		label: 'al-Malikiyah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Tartus',
		label: 'Tartus, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Idlib',
		label: 'Idlib, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Darayya',
		label: 'Darayya, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Jisr-ash-Shughur',
		label: 'Jisr-ash-Shughur, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Baniyas',
		label: 'Baniyas, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Mayadin',
		label: 'al-Mayadin, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Hajar Aswad',
		label: 'Hajar Aswad, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'ar-Rastan',
		label: 'ar-Rastan, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Masyaf',
		label: 'Masyaf, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'az-Zabadani',
		label: 'az-Zabadani, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Å',
		label: 'Å, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'at-Tall',
		label: 'at-Tall, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Yabrud',
		label: 'Yabrud, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Hasakah',
		label: 'al-Hasakah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'ath-Thawrah',
		label: 'ath-Thawrah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Manbij',
		label: 'Manbij, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Ma´addi',
		label: 'Ma´addi, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Nawa',
		label: 'Nawa, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Kabir-as-Sit',
		label: 'Kabir-as-Sit, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Tudmur',
		label: 'Tudmur, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Ariha',
		label: 'Ariha, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Harasta al-Bas',
		label: 'Harasta al-Bas, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Qunaytirah',
		label: 'al-Qunaytirah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'as-Safirah',
		label: 'as-Safirah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Qusayr',
		label: 'al-Qusayr, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Muhradah',
		label: 'Muhradah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Qatana',
		label: 'Qatana, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: "Ra's-al-´Ayn",
		label: "Ra's-al-´Ayn, Syrian Arab Republic",
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'al-Qutayfah',
		label: 'al-Qutayfah, Syrian Arab Republic',
		type: 'city',
		flagClass: 'fi fi-sy',
		isPopular: false,
	},
	{
		value: 'Taiwan',
		label: 'Taiwan, Province of China',
		type: 'country',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Taipei',
		label: 'Taipei, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Taichung',
		label: 'Taichung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsinchu',
		label: 'Hsinchu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kaohsiung',
		label: 'Kaohsiung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Changhwa',
		label: 'Changhwa, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tainan',
		label: 'Tainan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Taoyuan',
		label: 'Taoyuan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chiayi',
		label: 'Chiayi, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsinchuang',
		label: 'Hsinchuang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Nantou',
		label: 'Nantou, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Ilan',
		label: 'Ilan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Keelung',
		label: 'Keelung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chungli',
		label: 'Chungli, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chunan',
		label: 'Chunan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Panchiao',
		label: 'Panchiao, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tali',
		label: 'Tali, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chupei',
		label: 'Chupei, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chaochou',
		label: 'Chaochou, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tuku',
		label: 'Tuku, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tucheng',
		label: 'Tucheng, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Pingtung',
		label: 'Pingtung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tanshui',
		label: 'Tanshui, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Miaoli',
		label: 'Miaoli, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tachi',
		label: 'Tachi, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chishan',
		label: 'Chishan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chungho',
		label: 'Chungho, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Sanchung',
		label: 'Sanchung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Fengshan',
		label: 'Fengshan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsintien',
		label: 'Hsintien, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Luchou',
		label: 'Luchou, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Shulin',
		label: 'Shulin, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yuanlin',
		label: 'Yuanlin, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yangmei',
		label: 'Yangmei, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Taitung',
		label: 'Taitung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hualian',
		label: 'Hualian, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Touliu',
		label: 'Touliu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chutung',
		label: 'Chutung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yingko',
		label: 'Yingko, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsilo',
		label: 'Hsilo, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Wuchi',
		label: 'Wuchi, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Peikang',
		label: 'Peikang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tienchung',
		label: 'Tienchung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Houlung',
		label: 'Houlung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsinpu',
		label: 'Hsinpu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Talin',
		label: 'Talin, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Peitou',
		label: 'Peitou, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kuanhsi',
		label: 'Kuanhsi, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yenshui',
		label: 'Yenshui, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kincheng',
		label: 'Kincheng, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chichi',
		label: 'Chichi, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kuanshan',
		label: 'Kuanshan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yungho',
		label: 'Yungho, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yungkang',
		label: 'Yungkang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Pingchen',
		label: 'Pingchen, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Fengyuan',
		label: 'Fengyuan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Pate',
		label: 'Pate, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsichih',
		label: 'Hsichih, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tsaotun',
		label: 'Tsaotun, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kangshan',
		label: 'Kangshan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Pulí',
		label: 'Pulí, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Toufen',
		label: 'Toufen, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chingshui',
		label: 'Chingshui, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Homei',
		label: 'Homei, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Lukang',
		label: 'Lukang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Sanhsia',
		label: 'Sanhsia, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tachia',
		label: 'Tachia, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsinying',
		label: 'Hsinying, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Shalu',
		label: 'Shalu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Lotung',
		label: 'Lotung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Huwei',
		label: 'Huwei, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chushan',
		label: 'Chushan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tungshih',
		label: 'Tungshih, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Erhlin',
		label: 'Erhlin, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chiali',
		label: 'Chiali, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chihu',
		label: 'Chihu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Makó',
		label: 'Makó, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tungkang',
		label: 'Tungkang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yuanli',
		label: 'Yuanli, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Juifang',
		label: 'Juifang, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Suao',
		label: 'Suao, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tounan',
		label: 'Tounan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Meinung',
		label: 'Meinung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Matou',
		label: 'Matou, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsinhua',
		label: 'Hsinhua, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Potzu',
		label: 'Potzu, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tunghsiao',
		label: 'Tunghsiao, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Shanhwa',
		label: 'Shanhwa, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Paiho',
		label: 'Paiho, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Putai',
		label: 'Putai, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Toucheng',
		label: 'Toucheng, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Yuri',
		label: 'Yuri, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Taipao',
		label: 'Taipao, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hengchun',
		label: 'Hengchun, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Hsuechia',
		label: 'Hsuechia, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Cholan',
		label: 'Cholan, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Chengkung',
		label: 'Chengkung, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Fenglin',
		label: 'Fenglin, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Kinhsia',
		label: 'Kinhsia, Taiwan, Province of China',
		type: 'city',
		flagClass: 'fi fi-tw',
		isPopular: false,
	},
	{
		value: 'Tajikistan',
		label: 'Tajikistan',
		type: 'country',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Adrasmon',
		label: 'Adrasmon, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Dushanbe',
		label: 'Dushanbe, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Jilikul',
		label: 'Jilikul, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Asht',
		label: 'Asht, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Bustonkala',
		label: 'Bustonkala, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Vorukh',
		label: 'Vorukh, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Boshkengash',
		label: 'Boshkengash, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Isfara',
		label: 'Isfara, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Chkalov',
		label: 'Chkalov, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Hisor',
		label: 'Hisor, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Gafurov',
		label: 'Gafurov, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Taboshar',
		label: 'Taboshar, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Khojamaston',
		label: 'Khojamaston, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Dusti',
		label: 'Dusti, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kirov',
		label: 'Kirov, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Sovetskij',
		label: 'Sovetskij, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Pyanj',
		label: 'Pyanj, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Rogun',
		label: 'Rogun, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kuybyshevski',
		label: 'Kuybyshevski, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Navabadski',
		label: 'Navabadski, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kumsangir',
		label: 'Kumsangir, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Orzu',
		label: 'Orzu, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Navabad',
		label: 'Navabad, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Shakhrinau',
		label: 'Shakhrinau, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kansay',
		label: 'Kansay, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Altyn-Topkan',
		label: 'Altyn-Topkan, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Nefteabad',
		label: 'Nefteabad, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Chorbog',
		label: 'Chorbog, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Shurob',
		label: 'Shurob, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Choruh-Dairon',
		label: 'Choruh-Dairon, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kuruksay',
		label: 'Kuruksay, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Palas',
		label: 'Palas, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Karakendzha',
		label: 'Karakendzha, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Syrdarinskiy',
		label: 'Syrdarinskiy, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Chorku',
		label: 'Chorku, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Takob',
		label: 'Takob, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kim',
		label: 'Kim, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Tartki',
		label: 'Tartki, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Takeli',
		label: 'Takeli, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Ayni',
		label: 'Ayni, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Varzob',
		label: 'Varzob, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Darband',
		label: 'Darband, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Naugarzan',
		label: 'Naugarzan, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Khujand',
		label: 'Khujand, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kulob',
		label: 'Kulob, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Qurgonteppa',
		label: 'Qurgonteppa, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Konibodom',
		label: 'Konibodom, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Uroteppa',
		label: 'Uroteppa, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kofarnihon',
		label: 'Kofarnihon, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Tursunzoda',
		label: 'Tursunzoda, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Panjakent',
		label: 'Panjakent, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Khorug',
		label: 'Khorug, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Leninskiy',
		label: 'Leninskiy, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Tugalan',
		label: 'Tugalan, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Yovon',
		label: 'Yovon, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Nurak',
		label: 'Nurak, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Farkhor',
		label: 'Farkhor, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Moskva',
		label: 'Moskva, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Dangara',
		label: 'Dangara, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Vakhsh',
		label: 'Vakhsh, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Proletarsk',
		label: 'Proletarsk, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Matcha',
		label: 'Matcha, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Zafarabad',
		label: 'Zafarabad, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Shaartuz',
		label: 'Shaartuz, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Buston',
		label: 'Buston, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Nau',
		label: 'Nau, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Garm',
		label: 'Garm, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Sarband',
		label: 'Sarband, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Muminobod',
		label: 'Muminobod, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Murgob',
		label: 'Murgob, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Obigarm',
		label: 'Obigarm, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Kuybyshev',
		label: 'Kuybyshev, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Qayroqqum',
		label: 'Qayroqqum, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Mehnatabad',
		label: 'Mehnatabad, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Sharora',
		label: 'Sharora, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Garavuti',
		label: 'Garavuti, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Pakhtakoron',
		label: 'Pakhtakoron, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Ganchi',
		label: 'Ganchi, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Chichka',
		label: 'Chichka, Tajikistan',
		type: 'city',
		flagClass: 'fi fi-tj',
		isPopular: false,
	},
	{
		value: 'Tanzania, United Republic of',
		label: 'Tanzania, United Republic of',
		type: 'country',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Dar es Salaam',
		label: 'Dar es Salaam, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Arusha',
		label: 'Arusha, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwanza',
		label: 'Mwanza, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Zanzibar',
		label: 'Zanzibar, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: true,
	},
	{
		value: 'Singida',
		label: 'Singida, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Moshi',
		label: 'Moshi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mbeya',
		label: 'Mbeya, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Dodoma',
		label: 'Dodoma, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Morogoro',
		label: 'Morogoro, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kigoma',
		label: 'Kigoma, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mtwara',
		label: 'Mtwara, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Wete',
		label: 'Wete, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tandahimba',
		label: 'Tandahimba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tanga',
		label: 'Tanga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tabora',
		label: 'Tabora, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Musoma',
		label: 'Musoma, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bugene',
		label: 'Bugene, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bukoba',
		label: 'Bukoba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ifakara',
		label: 'Ifakara, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lindi',
		label: 'Lindi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kidodi',
		label: 'Kidodi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bariadi',
		label: 'Bariadi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bugarama',
		label: 'Bugarama, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tarime',
		label: 'Tarime, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tunduru',
		label: 'Tunduru, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tukuyu',
		label: 'Tukuyu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kisesa',
		label: 'Kisesa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Dutwa',
		label: 'Dutwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sokoni',
		label: 'Sokoni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Vikindu',
		label: 'Vikindu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Chala',
		label: 'Chala, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mpwapwa',
		label: 'Mpwapwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Liwale',
		label: 'Liwale, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Dareda',
		label: 'Dareda, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bashnet',
		label: 'Bashnet, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nangwa',
		label: 'Nangwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Iringa',
		label: 'Iringa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mugango',
		label: 'Mugango, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kilosa',
		label: 'Kilosa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nyanguge',
		label: 'Nyanguge, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ushirombo',
		label: 'Ushirombo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sumbawanga',
		label: 'Sumbawanga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ngorongoro',
		label: 'Ngorongoro, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bagamoyo',
		label: 'Bagamoyo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kandete',
		label: 'Kandete, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Majengo',
		label: 'Majengo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mpanda',
		label: 'Mpanda, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Igurubi',
		label: 'Igurubi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lusanga',
		label: 'Lusanga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Uyovu',
		label: 'Uyovu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Makanya',
		label: 'Makanya, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kalangalala',
		label: 'Kalangalala, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Micheweni',
		label: 'Micheweni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Makambako',
		label: 'Makambako, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: "Condé-sur-l'Escaut",
		label: "Condé-sur-l'Escaut, Tanzania, United Republic of",
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mishoma',
		label: 'Mishoma, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Maneromango',
		label: 'Maneromango, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sengerama',
		label: 'Sengerama, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ludewa',
		label: 'Ludewa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Buseresere',
		label: 'Buseresere, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Istanbul',
		label: 'Istanbul, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mererani',
		label: 'Mererani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwembe',
		label: 'Mwembe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bunda',
		label: 'Bunda, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Longido',
		label: 'Longido, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Katoro',
		label: 'Katoro, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mbamba',
		label: 'Mbamba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Utengule Usongwe',
		label: 'Utengule Usongwe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kihurio',
		label: 'Kihurio, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Siha Kati',
		label: 'Siha Kati, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Pangani',
		label: 'Pangani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Njombe',
		label: 'Njombe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: "Lang'ata",
		label: "Lang'ata, Tanzania, United Republic of",
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Masuguru',
		label: 'Masuguru, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nkome',
		label: 'Nkome, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lulindi',
		label: 'Lulindi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kiranyi',
		label: 'Kiranyi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kintinku',
		label: 'Kintinku, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nkololo',
		label: 'Nkololo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Issenye',
		label: 'Issenye, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Vwawa',
		label: 'Vwawa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kwakoa',
		label: 'Kwakoa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Gairo',
		label: 'Gairo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mahenge',
		label: 'Mahenge, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kidadu',
		label: 'Kidadu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Isongole',
		label: 'Isongole, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nguruka',
		label: 'Nguruka, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwaya',
		label: 'Mwaya, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tunduma',
		label: 'Tunduma, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kisiwani',
		label: 'Kisiwani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Masasi',
		label: 'Masasi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bukene',
		label: 'Bukene, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Korogwe',
		label: 'Korogwe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Malangali',
		label: 'Malangali, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Usoke',
		label: 'Usoke, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kasulu',
		label: 'Kasulu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mtambile',
		label: 'Mtambile, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mafinga',
		label: 'Mafinga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Itewe',
		label: 'Itewe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Newala',
		label: 'Newala, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nansio',
		label: 'Nansio, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Isagehe',
		label: 'Isagehe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kilimatinde',
		label: 'Kilimatinde, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mikindani',
		label: 'Mikindani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nakatunguru',
		label: 'Nakatunguru, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Missungwi',
		label: 'Missungwi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nkowe',
		label: 'Nkowe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mlimba',
		label: 'Mlimba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mahonda',
		label: 'Mahonda, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Igunga',
		label: 'Igunga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Monduli',
		label: 'Monduli, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Chalinze',
		label: 'Chalinze, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Msanga',
		label: 'Msanga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kahama',
		label: 'Kahama, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kibaya',
		label: 'Kibaya, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Segese',
		label: 'Segese, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Katesh',
		label: 'Katesh, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Masumbwe',
		label: 'Masumbwe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mbumi',
		label: 'Mbumi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ubaruku',
		label: 'Ubaruku, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bukongo',
		label: 'Bukongo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Biharamulo',
		label: 'Biharamulo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kijini',
		label: 'Kijini, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Somanda',
		label: 'Somanda, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Gamba',
		label: 'Gamba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Dunga Bweni',
		label: 'Dunga Bweni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tumbi',
		label: 'Tumbi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ilembo',
		label: 'Ilembo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Babati',
		label: 'Babati, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mkokotoni',
		label: 'Mkokotoni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kirando',
		label: 'Kirando, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Uweleni',
		label: 'Uweleni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Koani',
		label: 'Koani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Chanika',
		label: 'Chanika, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nganani',
		label: 'Nganani, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mvomero',
		label: 'Mvomero, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kibiti',
		label: 'Kibiti, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kyela',
		label: 'Kyela, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: "Mang'ula",
		label: "Mang'ula, Tanzania, United Republic of",
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lugulu',
		label: 'Lugulu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lukuledi',
		label: 'Lukuledi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kabwe',
		label: 'Kabwe, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ilula',
		label: 'Ilula, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mlandizi',
		label: 'Mlandizi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Rujewa',
		label: 'Rujewa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwena',
		label: 'Mwena, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mtibwa',
		label: 'Mtibwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kashaulili',
		label: 'Kashaulili, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mkuranga',
		label: 'Mkuranga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwamapalala',
		label: 'Mwamapalala, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Bungu',
		label: 'Bungu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Chato',
		label: 'Chato, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Namanyere',
		label: 'Namanyere, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kasamwa',
		label: 'Kasamwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kibondo',
		label: 'Kibondo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Livingstone',
		label: 'Livingstone, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kalemela',
		label: 'Kalemela, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Malinyi',
		label: 'Malinyi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mtinko',
		label: 'Mtinko, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sikonge',
		label: 'Sikonge, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwanhuzi',
		label: 'Mwanhuzi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Makongorosi',
		label: 'Makongorosi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nzega',
		label: 'Nzega, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Luchingu',
		label: 'Luchingu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Manyoni',
		label: 'Manyoni, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sepuka',
		label: 'Sepuka, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ilemela',
		label: 'Ilemela, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mlingoti Magharibi',
		label: 'Mlingoti Magharibi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Magugu',
		label: 'Magugu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Buziku',
		label: 'Buziku, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mbinga',
		label: 'Mbinga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Shelui',
		label: 'Shelui, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Chimala',
		label: 'Chimala, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Igurusi',
		label: 'Igurusi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lushoto',
		label: 'Lushoto, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kibaha',
		label: 'Kibaha, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mwadui',
		label: 'Mwadui, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Haidom',
		label: 'Haidom, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Sirari',
		label: 'Sirari, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nyalikungu',
		label: 'Nyalikungu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Namtumbo',
		label: 'Namtumbo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Mgandu',
		label: 'Mgandu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kiomboi',
		label: 'Kiomboi, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nangomba',
		label: 'Nangomba, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Urambo',
		label: 'Urambo, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kakonko',
		label: 'Kakonko, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Matai',
		label: 'Matai, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kondoa',
		label: 'Kondoa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Songwa',
		label: 'Songwa, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Iguguno',
		label: 'Iguguno, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Nachingwea',
		label: 'Nachingwea, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Ngudu',
		label: 'Ngudu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Maguu',
		label: 'Maguu, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Lalango',
		label: 'Lalango, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kigonsera',
		label: 'Kigonsera, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kingori',
		label: 'Kingori, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Rulenge',
		label: 'Rulenge, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Tinde',
		label: 'Tinde, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Kukirango',
		label: 'Kukirango, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Old Shinyanga',
		label: 'Old Shinyanga, Tanzania, United Republic of',
		type: 'city',
		flagClass: 'fi fi-tz',
		isPopular: false,
	},
	{
		value: 'Pattaya',
		label: 'Pattaya, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Koh Phi-Phi',
		label: 'Koh Phi-Phi, Thailand',
		type: 'island',
		flagClass: 'fi fi-th',
		isPopular: true,
	},
	{
		value: 'Koh Samui',
		label: 'Koh Samui, Thailand',
		type: 'island',
		flagClass: 'fi fi-th',
		isPopular: true,
	},
	{
		value: 'Ko Samui',
		label: 'Ko Samui, Thailand',
		type: 'island',
		flagClass: 'fi fi-th',
		isPopular: true,
	},
	{
		value: 'Koh Tao',
		label: 'Koh Tao, Thailand',
		type: 'island',
		flagClass: 'fi fi-th',
		isPopular: true,
	},
	{
		value: 'Amnat Charoen',
		label: 'Amnat Charoen, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Rayong',
		label: 'Rayong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phra Pradaeng',
		label: 'Phra Pradaeng, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nonthaburi',
		label: 'Nonthaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pathum Thani',
		label: 'Pathum Thani, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chon Buri',
		label: 'Chon Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Samut Prakan',
		label: 'Samut Prakan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Udon Thani',
		label: 'Udon Thani, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ayutthaya',
		label: 'Ayutthaya, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Hat Yai',
		label: 'Hat Yai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phitsanulok',
		label: 'Phitsanulok, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Hua Hin',
		label: 'Hua Hin, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chiang Rai',
		label: 'Chiang Rai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Surat Thani',
		label: 'Surat Thani, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Ratchasima',
		label: 'Nakhon Ratchasima, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Si Thammarat',
		label: 'Nakhon Si Thammarat, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lampang',
		label: 'Lampang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Khon Kaen',
		label: 'Khon Kaen, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Pathom',
		label: 'Nakhon Pathom, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ubon Ratchathani',
		label: 'Ubon Ratchathani, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lop Buri',
		label: 'Lop Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mae Sot',
		label: 'Mae Sot, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Khla',
		label: 'Bang Khla, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Si Racha',
		label: 'Si Racha, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Songkhla',
		label: 'Songkhla, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Saraburi',
		label: 'Saraburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Maha Sarakham',
		label: 'Maha Sarakham, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Bo Thong',
		label: 'Bang Bo Thong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Ban',
		label: 'Bang Ban, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Phaeo',
		label: 'Ban Phaeo, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mukdahan',
		label: 'Mukdahan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mae Sai',
		label: 'Mae Sai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ang Thong',
		label: 'Ang Thong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Satuk',
		label: 'Satuk, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ratchaburi',
		label: 'Ratchaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Krathum Baen',
		label: 'Krathum Baen, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Kruai',
		label: 'Bang Kruai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chachoengsao',
		label: 'Chachoengsao, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Surin',
		label: 'Surin, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Buri Ram',
		label: 'Buri Ram, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Satun',
		label: 'Satun, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Prachuap Khiri Khan',
		label: 'Prachuap Khiri Khan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nong Phai',
		label: 'Nong Phai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sa Kaeo',
		label: 'Sa Kaeo, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phayao',
		label: 'Phayao, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Taphan Hin',
		label: 'Taphan Hin, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Trat',
		label: 'Trat, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phibun Mangsahan',
		label: 'Phibun Mangsahan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kaset',
		label: 'Kaset, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Tak',
		label: 'Ban Tak, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pa Sang',
		label: 'Pa Sang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kabin Buri',
		label: 'Kabin Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lang Suan',
		label: 'Lang Suan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Yai',
		label: 'Bang Yai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Khlong Luang',
		label: 'Khlong Luang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Sawan',
		label: 'Nakhon Sawan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Yala',
		label: 'Yala, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Trang',
		label: 'Trang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lam Luk Ka',
		label: 'Lam Luk Ka, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lamphun',
		label: 'Lamphun, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phrae',
		label: 'Phrae, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Wichian Buri',
		label: 'Wichian Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Photharam',
		label: 'Photharam, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Lamung',
		label: 'Bang Lamung, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Phanom',
		label: 'Nakhon Phanom, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Bo',
		label: 'Bang Bo, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sankamphaeng',
		label: 'Sankamphaeng, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kumphawapi',
		label: 'Kumphawapi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Chang',
		label: 'Ban Chang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ranong',
		label: 'Ranong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chok Chai',
		label: 'Chok Chai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sing Buri',
		label: 'Sing Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Bung',
		label: 'Ban Bung, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kamalasai',
		label: 'Kamalasai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nakhon Nayok',
		label: 'Nakhon Nayok, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Len',
		label: 'Bang Len, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Laem',
		label: 'Ban Laem, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Dung',
		label: 'Ban Dung, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chai Nat',
		label: 'Chai Nat, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bua Yai',
		label: 'Bua Yai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Aranya Prathet',
		label: 'Aranya Prathet, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chon Daen',
		label: 'Chon Daen, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Mun Nak',
		label: 'Bang Mun Nak, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sawang Daen Din',
		label: 'Sawang Daen Din, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bamnet Narong',
		label: 'Bamnet Narong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bo Phloi',
		label: 'Bo Phloi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chiang Kham',
		label: 'Chiang Kham, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chom Bung',
		label: 'Chom Bung, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Sai',
		label: 'Bang Sai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bo Rai',
		label: 'Bo Rai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nong Ki',
		label: 'Nong Ki, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Non Thai',
		label: 'Non Thai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pak Kret',
		label: 'Pak Kret, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Suwannaphum',
		label: 'Suwannaphum, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chanthaburi',
		label: 'Chanthaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bacho',
		label: 'Bacho, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Samut Sakhon',
		label: 'Samut Sakhon, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pa Daet',
		label: 'Pa Daet, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sakhon Nakhon',
		label: 'Sakhon Nakhon, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nong Khai',
		label: 'Nong Khai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ao Luk',
		label: 'Ao Luk, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chaiyaphum',
		label: 'Chaiyaphum, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Uttaradit',
		label: 'Uttaradit, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mae Hong Son',
		label: 'Mae Hong Son, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kanchanaburi',
		label: 'Kanchanaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Pong',
		label: 'Ban Pong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Klaeng',
		label: 'Klaeng, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pak Chong',
		label: 'Pak Chong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kalasin',
		label: 'Kalasin, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sadao',
		label: 'Sadao, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chaam',
		label: 'Chaam, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phetchabun',
		label: 'Phetchabun, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phetchaburi',
		label: 'Phetchaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sam Phran',
		label: 'Sam Phran, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tha Yang',
		label: 'Tha Yang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sukhothai',
		label: 'Sukhothai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Roi Et',
		label: 'Roi Et, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phichit',
		label: 'Phichit, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Loei',
		label: 'Loei, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sansai',
		label: 'Sansai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Det Udom',
		label: 'Det Udom, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Sao Thong',
		label: 'Bang Sao Thong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phra Samut Judee',
		label: 'Phra Samut Judee, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Na Klang',
		label: 'Na Klang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mae Chan',
		label: 'Mae Chan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sikhiu',
		label: 'Sikhiu, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Thung Song',
		label: 'Thung Song, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Yaring',
		label: 'Yaring, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kaeng Khlo',
		label: 'Kaeng Khlo, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Phae',
		label: 'Bang Phae, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ron Phibun',
		label: 'Ron Phibun, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kathu',
		label: 'Kathu, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Prachin Buri',
		label: 'Prachin Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kaeng Khoi',
		label: 'Kaeng Khoi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pak Phanang',
		label: 'Pak Phanang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Pakong',
		label: 'Bang Pakong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Chai Badan',
		label: 'Chai Badan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Betong',
		label: 'Betong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Dok Kham Tai',
		label: 'Dok Kham Tai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nong Han',
		label: 'Nong Han, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Si Satchanalai',
		label: 'Si Satchanalai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Pak Thong Chai',
		label: 'Pak Thong Chai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phun Phin',
		label: 'Phun Phin, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Yasothon',
		label: 'Yasothon, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Maetaeng',
		label: 'Maetaeng, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kut Chap',
		label: 'Kut Chap, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tha Muang',
		label: 'Tha Muang, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tak',
		label: 'Tak, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nan',
		label: 'Nan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Damnoen Saduak',
		label: 'Damnoen Saduak, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Se Na',
		label: 'Se Na, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nang Rong',
		label: 'Nang Rong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lamplai Mat',
		label: 'Lamplai Mat, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Laplae',
		label: 'Laplae, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Song Phi Nong',
		label: 'Song Phi Nong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nong Wua So',
		label: 'Nong Wua So, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tha Mai',
		label: 'Tha Mai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ban Na San',
		label: 'Ban Na San, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Ranot',
		label: 'Ranot, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Pa In',
		label: 'Bang Pa In, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Khon Buri',
		label: 'Khon Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Non Sung',
		label: 'Non Sung, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phak Hai',
		label: 'Phak Hai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Uthai Thani',
		label: 'Uthai Thani, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Den Chai',
		label: 'Den Chai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tha Rua',
		label: 'Tha Rua, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sawankhalok',
		label: 'Sawankhalok, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Thoen',
		label: 'Thoen, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kuchinarai',
		label: 'Kuchinarai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phanat Nikhom',
		label: 'Phanat Nikhom, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nam Som',
		label: 'Nam Som, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Racham',
		label: 'Bang Racham, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Suwan Khuha',
		label: 'Suwan Khuha, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Lat Yao',
		label: 'Lat Yao, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Huai Yot',
		label: 'Huai Yot, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Khanu Woralaksaburi',
		label: 'Khanu Woralaksaburi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Wiset Chai Chan',
		label: 'Wiset Chai Chan, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Khao Yoi',
		label: 'Khao Yoi, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phu Khieo',
		label: 'Phu Khieo, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sam Roi Yot',
		label: 'Sam Roi Yot, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kanchanadit',
		label: 'Kanchanadit, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kaset Sombun',
		label: 'Kaset Sombun, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Mae Ramat',
		label: 'Mae Ramat, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Seka',
		label: 'Seka, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Selaphum',
		label: 'Selaphum, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Bang Krathum',
		label: 'Bang Krathum, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Dan Khun Thot',
		label: 'Dan Khun Thot, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Kui Buri',
		label: 'Kui Buri, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Phanom Sarakham',
		label: 'Phanom Sarakham, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Tak Bai',
		label: 'Tak Bai, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Huai Thalaeng',
		label: 'Huai Thalaeng, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Nam Phong',
		label: 'Nam Phong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Hangdong',
		label: 'Hangdong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Sanpatong',
		label: 'Sanpatong, Thailand',
		type: 'city',
		flagClass: 'fi fi-th',
		isPopular: false,
	},
	{
		value: 'Timor-Leste',
		label: 'Timor-Leste',
		type: 'country',
		flagClass: 'fi fi-tl',
		isPopular: false,
	},
	{
		value: 'Togo',
		label: 'Togo',
		type: 'country',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Lomé',
		label: 'Lomé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Agbélouvé',
		label: 'Agbélouvé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Aného',
		label: 'Aného, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Atakpamé',
		label: 'Atakpamé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kara',
		label: 'Kara, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Mango',
		label: 'Mango, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Badou',
		label: 'Badou, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Sokodé',
		label: 'Sokodé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Tsévié',
		label: 'Tsévié, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Vogan',
		label: 'Vogan, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Amlamé',
		label: 'Amlamé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kpagouda',
		label: 'Kpagouda, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Dapaong',
		label: 'Dapaong, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kpalimé',
		label: 'Kpalimé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Notsé',
		label: 'Notsé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Tchamba',
		label: 'Tchamba, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Bafilo',
		label: 'Bafilo, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Sotouboua',
		label: 'Sotouboua, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Tandjouaré',
		label: 'Tandjouaré, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Anié',
		label: 'Anié, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kouvé',
		label: 'Kouvé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Tabligbo',
		label: 'Tabligbo, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kandé',
		label: 'Kandé, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Bassar',
		label: 'Bassar, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Niamtougou',
		label: 'Niamtougou, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Blitta',
		label: 'Blitta, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Kpessi',
		label: 'Kpessi, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Guérin Kouka',
		label: 'Guérin Kouka, Togo',
		type: 'city',
		flagClass: 'fi fi-tg',
		isPopular: false,
	},
	{
		value: 'Tokelau',
		label: 'Tokelau',
		type: 'country',
		flagClass: 'fi fi-tk',
		isPopular: false,
	},
	{
		value: 'Atafu',
		label: 'Atafu, Tokelau',
		type: 'city',
		flagClass: 'fi fi-tk',
		isPopular: false,
	},
	{
		value: 'Fakaofo',
		label: 'Fakaofo, Tokelau',
		type: 'city',
		flagClass: 'fi fi-tk',
		isPopular: false,
	},
	{
		value: 'Nukunonu',
		label: 'Nukunonu, Tokelau',
		type: 'city',
		flagClass: 'fi fi-tk',
		isPopular: false,
	},
	{
		value: 'Tonga',
		label: 'Tonga',
		type: 'country',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Haveloloto',
		label: 'Haveloloto, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: "Nuku'alofa",
		label: "Nuku'alofa, Tonga",
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Neiafu',
		label: 'Neiafu, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Vaini',
		label: 'Vaini, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Tofoa-Koloua',
		label: 'Tofoa-Koloua, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Pangai',
		label: 'Pangai, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Hihifo',
		label: 'Hihifo, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: "Mu'a",
		label: "Mu'a, Tonga",
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Ohonua',
		label: 'Ohonua, Tonga',
		type: 'city',
		flagClass: 'fi fi-to',
		isPopular: false,
	},
	{
		value: 'Trinidad and Tobago',
		label: 'Trinidad and Tobago',
		type: 'country',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Port of Spain',
		label: 'Port of Spain, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Arima',
		label: 'Arima, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'San Fernando',
		label: 'San Fernando, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Chaguanas',
		label: 'Chaguanas, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Tunapuna',
		label: 'Tunapuna, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'San Juan',
		label: 'San Juan, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Couva',
		label: 'Couva, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Saint Joseph',
		label: 'Saint Joseph, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Sangre Grande',
		label: 'Sangre Grande, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Princes Town',
		label: 'Princes Town, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Scarborough',
		label: 'Scarborough, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Point Fortín',
		label: 'Point Fortín, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Arouca',
		label: 'Arouca, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Tacarigua',
		label: 'Tacarigua, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Río Claro',
		label: 'Río Claro, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Marabella',
		label: 'Marabella, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Siparia',
		label: 'Siparia, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Débé',
		label: 'Débé, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Peñal',
		label: 'Peñal, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Mucurapo',
		label: 'Mucurapo, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Biche',
		label: 'Biche, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Tabaquite',
		label: 'Tabaquite, Trinidad and Tobago',
		type: 'city',
		flagClass: 'fi fi-tt',
		isPopular: false,
	},
	{
		value: 'Tunisia',
		label: 'Tunisia',
		type: 'country',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tunis',
		label: 'Tunis, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Safaqis',
		label: 'Safaqis, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ad-Dahmani',
		label: 'ad-Dahmani, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Susah',
		label: 'Susah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Hammamat',
		label: 'al-Hammamat, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Binzart',
		label: 'Binzart, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bin ´Arus',
		label: 'Bin ´Arus, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Marsa',
		label: 'al-Marsa, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: '´Allal-at-Tazi',
		label: '´Allal-at-Tazi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bardaw',
		label: 'Bardaw, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Nabul',
		label: 'Nabul, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Bu Ruqaybah',
		label: 'Manzil Bu Ruqaybah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Hammam Susah',
		label: 'Hammam Susah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Aryanah',
		label: 'Aryanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qafsah',
		label: 'Qafsah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Munastir',
		label: 'al-Munastir, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "Bi'r Ali Bin Khalifah",
		label: "Bi'r Ali Bin Khalifah, Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Qayrawan',
		label: 'al-Qayrawan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Muruj',
		label: 'al-Muruj, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Masakin',
		label: 'Masakin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jarbah Hawmat-as-Suq',
		label: 'Jarbah Hawmat-as-Suq, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Madaniyin',
		label: 'Madaniyin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bajah',
		label: 'Bajah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jarbah Midun',
		label: 'Jarbah Midun, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Radis',
		label: 'Radis, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manubah',
		label: 'Manubah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Ras-al-Jabal',
		label: 'Ras-al-Jabal, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Baqalitah',
		label: 'al-Baqalitah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Mazzunah',
		label: 'al-Mazzunah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Lamtah',
		label: 'Lamtah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Middah',
		label: 'al-Middah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Nibbar',
		label: 'Nibbar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ash-Shabikah',
		label: 'ash-Shabikah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tatawin',
		label: 'Tatawin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Mahdiyah',
		label: 'al-Mahdiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jundubah',
		label: 'Jundubah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Hammam-al-Anif',
		label: 'Hammam-al-Anif, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Saqiyat-az-Zayt',
		label: 'Saqiyat-az-Zayt, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jammal',
		label: 'Jammal, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Tamim',
		label: 'Manzil Tamim, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tawzar',
		label: 'Tawzar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Matir',
		label: 'Matir, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Maqrin',
		label: 'Maqrin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Duz',
		label: 'Duz, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sulayman',
		label: 'Sulayman, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Silyanah',
		label: 'Silyanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "Ghar-ad-Dima'",
		label: "Ghar-ad-Dima', Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Fahs',
		label: 'al-Fahs, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qal´at-al-Andalus',
		label: 'Qal´at-al-Andalus, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Miknassi',
		label: 'al-Miknassi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tastur',
		label: 'Tastur, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bin Qirdan',
		label: 'Bin Qirdan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bu ´Aradah',
		label: 'Bu ´Aradah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Huwariyah',
		label: 'al-Huwariyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Matwiyah',
		label: 'al-Matwiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Qal´ah',
		label: 'al-Qal´ah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Mallulash',
		label: 'Mallulash, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jamnah',
		label: 'Jamnah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tuzah',
		label: 'Tuzah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Battan',
		label: 'al-Battan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jilmah',
		label: 'Jilmah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qal´at-as-Sanan',
		label: 'Qal´at-as-Sanan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Ghar-al-Milh',
		label: 'Ghar-al-Milh, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'az-Zarat',
		label: 'az-Zarat, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Qusur',
		label: 'al-Qusur, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Sawasi',
		label: 'as-Sawasi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "Bi'r-al-Hufayy",
		label: "Bi'r-al-Hufayy, Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sajanan',
		label: 'Sajanan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bumirdas',
		label: 'Bumirdas, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Majal Bal ´Abbas',
		label: 'Majal Bal ´Abbas, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Zawiyat Quntash',
		label: 'Zawiyat Quntash, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Dhahibah',
		label: 'Dhahibah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Hurr',
		label: 'Manzil Hurr, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Rimadah',
		label: 'Rimadah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ar-Rawhiyah',
		label: 'ar-Rawhiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bu Hajjar',
		label: 'Bu Hajjar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sidi Bin Nur',
		label: 'Sidi Bin Nur, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: '´Awsajah',
		label: '´Awsajah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bani Khaddash',
		label: 'Bani Khaddash, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qurbus',
		label: 'Qurbus, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Quballat',
		label: 'Quballat, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Masdur',
		label: 'al-Masdur, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Haydrah',
		label: 'Haydrah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Salim',
		label: 'Manzil Salim, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Shakir',
		label: 'Manzil Shakir, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sidi al-Hani',
		label: 'Sidi al-Hani, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tamaghzah',
		label: 'Tamaghzah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Kasra',
		label: 'Kasra, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Matmatat-al-Qadimah',
		label: 'Matmatat-al-Qadimah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Wadi Maliz',
		label: 'Wadi Maliz, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: '´Ayn Jalulah',
		label: '´Ayn Jalulah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Firnanah',
		label: 'Firnanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bani Matir',
		label: 'Bani Matir, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'at-Tadaman Dawwar Hishar',
		label: 'at-Tadaman Dawwar Hishar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qabis',
		label: 'Qabis, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Halq-al-Wadi',
		label: 'Halq-al-Wadi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Qasrayn',
		label: 'al-Qasrayn, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jarjis',
		label: 'Jarjis, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Muhammadiyat Fushanah',
		label: 'Muhammadiyat Fushanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Muknin',
		label: 'al-Muknin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Kaf',
		label: 'al-Kaf, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "al-Qal´at-al-Khasba'",
		label: "al-Qal´at-al-Khasba', Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Wadi al-Layl',
		label: 'Wadi al-Layl, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Mitlawi',
		label: 'al-Mitlawi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qasr Hallal',
		label: 'Qasr Hallal, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sidi Bu Zayd',
		label: 'Sidi Bu Zayd, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-´Ayn',
		label: 'al-´Ayn, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qalibiyah',
		label: 'Qalibiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Hammah',
		label: 'al-Hammah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Saqiyat-ad-Dair',
		label: 'Saqiyat-ad-Dair, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "az-Zahra'",
		label: "az-Zahra', Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Dar Sha´ban',
		label: 'Dar Sha´ban, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qarmadah',
		label: 'Qarmadah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qurbah',
		label: 'Qurbah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Murnaq',
		label: 'Murnaq, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tabulbah',
		label: 'Tabulbah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ar-Rudayyif',
		label: 'ar-Rudayyif, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Qasr',
		label: 'al-Qasr, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qusur-as-Saf',
		label: 'Qusur-as-Saf, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Umm-al-´Arais',
		label: 'Umm-al-´Arais, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ad-Dandan',
		label: 'ad-Dandan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jarbah Ajim',
		label: 'Jarbah Ajim, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Taburbah',
		label: 'Taburbah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Firyanah',
		label: 'Firyanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Naftah',
		label: 'Naftah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Subaytilah',
		label: 'Subaytilah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Jamil',
		label: 'Manzil Jamil, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ash-Shabbah',
		label: 'ash-Shabbah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Ghannush',
		label: 'Ghannush, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bu Salim',
		label: 'Bu Salim, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Taklisah',
		label: 'Taklisah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Majaz-al-Bab',
		label: 'Majaz-al-Bab, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Jamm',
		label: 'al-Jamm, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Akkudah',
		label: 'Akkudah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qibili',
		label: 'Qibili, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tajarwin',
		label: 'Tajarwin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qurunbaliyah',
		label: 'Qurunbaliyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tinjah',
		label: 'Tinjah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Wardanin',
		label: 'al-Wardanin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bani Hiyar',
		label: 'Bani Hiyar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qartaj',
		label: 'Qartaj, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Zaramidin',
		label: 'Zaramidin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qarqannah',
		label: 'Qarqannah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Talah',
		label: 'Talah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Zaghwan',
		label: 'Zaghwan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-´Abbasiyah',
		label: 'al-´Abbasiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Mahras',
		label: 'al-Mahras, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Bu Zalafah',
		label: 'Manzil Bu Zalafah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil ´Abd-ar-Rahman',
		label: 'Manzil ´Abd-ar-Rahman, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Jarissah',
		label: 'al-Jarissah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Makthar',
		label: 'Makthar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Ghumrassin',
		label: 'Ghumrassin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tabarqah',
		label: 'Tabarqah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sahilin Ma´atmar',
		label: 'Sahilin Ma´atmar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sayyadah',
		label: 'Sayyadah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sanini an-Nahal',
		label: 'Sanini an-Nahal, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Murnaqiyah',
		label: 'al-Murnaqiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tabursuq',
		label: 'Tabursuq, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Banblat wal-Manarah',
		label: 'Banblat wal-Manarah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Banan Budar',
		label: 'Banan Budar, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bani Khallad',
		label: 'Bani Khallad, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Sars',
		label: 'as-Sars, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qusaybat-al-Madyuni',
		label: 'Qusaybat-al-Madyuni, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Marath',
		label: 'Marath, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Qa´afur',
		label: 'Qa´afur, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'an-Nafidah',
		label: 'an-Nafidah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Waslatiyah',
		label: 'al-Waslatiyah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bu ´Ûrqub',
		label: 'Bu ´Ûrqub, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Khunays',
		label: 'Khunays, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Wadhraf',
		label: 'Wadhraf, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Rafraf',
		label: 'Rafraf, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Sukhayrah',
		label: 'as-Sukhayrah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Rajish',
		label: 'Rajish, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sidi Thabit',
		label: 'Sidi Thabit, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Sidi Bu ´Ali',
		label: 'Sidi Bu ´Ali, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Zawiyat Susah',
		label: 'Zawiyat Susah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'az-Zaribah',
		label: 'az-Zaribah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Daqash',
		label: 'Daqash, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Manzil Kamil',
		label: 'Manzil Kamil, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Hammam-al-Aghzaz',
		label: 'Hammam-al-Aghzaz, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bani Hassan',
		label: 'Bani Hassan, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Sanad',
		label: 'as-Sanad, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Haffuz',
		label: 'Haffuz, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Karib',
		label: 'al-Karib, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Matlin',
		label: 'al-Matlin, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Bu Fishah',
		label: 'Bu Fishah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Jabinyanah',
		label: 'Jabinyanah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: '´Ayn Darahim',
		label: '´Ayn Darahim, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Subaykhah',
		label: 'as-Subaykhah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Tazirkah',
		label: 'Tazirkah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Ma´murah',
		label: 'al-Ma´murah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Harqalah',
		label: 'Harqalah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Masa´din',
		label: 'al-Masa´din, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'ar-Riqab',
		label: 'ar-Riqab, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Hammat-al-Jarid',
		label: 'Hammat-al-Jarid, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Saqiyat Sidi Yussuf',
		label: 'Saqiyat Sidi Yussuf, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'as-Sama´ah',
		label: 'as-Sama´ah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: "Bi'r Mashariqah",
		label: "Bi'r Mashariqah, Tunisia",
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Zawiyat-al-Jadidi',
		label: 'Zawiyat-al-Jadidi, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'al-Hanashah',
		label: 'al-Hanashah, Tunisia',
		type: 'city',
		flagClass: 'fi fi-tn',
		isPopular: false,
	},
	{
		value: 'Turkey',
		label: 'Turkey',
		type: 'country',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Istanbul',
		label: 'Istanbul, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ankara',
		label: 'Ankara, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Izmir',
		label: 'Izmir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Adana',
		label: 'Adana, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Antalya',
		label: 'Antalya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bursa',
		label: 'Bursa, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Izmit',
		label: 'Izmit, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Konya',
		label: 'Konya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Alanya',
		label: 'Alanya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Eskisehir',
		label: 'Eskisehir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gaziantep',
		label: 'Gaziantep, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Içel',
		label: 'Içel, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bodrum',
		label: 'Bodrum, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Mugla',
		label: 'Mugla, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kayseri',
		label: 'Kayseri, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Marmaris',
		label: 'Marmaris, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Fethiye',
		label: 'Fethiye, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Adapazari',
		label: 'Adapazari, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Balikesir',
		label: 'Balikesir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Diyarbakir',
		label: 'Diyarbakir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Samsun',
		label: 'Samsun, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Erzurum',
		label: 'Erzurum, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Trabzon',
		label: 'Trabzon, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Manisa',
		label: 'Manisa, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Antakya',
		label: 'Antakya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Aydin',
		label: 'Aydin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Manavgat',
		label: 'Manavgat, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kütahya',
		label: 'Kütahya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tekirdag',
		label: 'Tekirdag, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Malatya',
		label: 'Malatya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Denizli',
		label: 'Denizli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ordu',
		label: 'Ordu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Zonguldak',
		label: 'Zonguldak, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bolu',
		label: 'Bolu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kirklareli',
		label: 'Kirklareli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Didim',
		label: 'Didim, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sivas',
		label: 'Sivas, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Isparta',
		label: 'Isparta, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Edirne',
		label: 'Edirne, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bandirma',
		label: 'Bandirma, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Giresun',
		label: 'Giresun, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çanakkale',
		label: 'Çanakkale, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Karamürsel',
		label: 'Karamürsel, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Van',
		label: 'Van, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Batman',
		label: 'Batman, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çorum',
		label: 'Çorum, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çorlu',
		label: 'Çorlu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Afyonkarahisar',
		label: 'Afyonkarahisar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kirsehir',
		label: 'Kirsehir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Lüleburgaz',
		label: 'Lüleburgaz, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Rize',
		label: 'Rize, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Yozgat',
		label: 'Yozgat, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Nevsehir',
		label: 'Nevsehir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ayvalik',
		label: 'Ayvalik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Elazig',
		label: 'Elazig, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gebze',
		label: 'Gebze, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Aksaray',
		label: 'Aksaray, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tokat',
		label: 'Tokat, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Körfez',
		label: 'Körfez, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Nigde',
		label: 'Nigde, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Yalova',
		label: 'Yalova, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Orhangazi',
		label: 'Orhangazi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bilecik',
		label: 'Bilecik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sinop',
		label: 'Sinop, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Artvin',
		label: 'Artvin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çesme',
		label: 'Çesme, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gelibolu',
		label: 'Gelibolu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Hayrabolu',
		label: 'Hayrabolu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Usak',
		label: 'Usak, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Nazilli',
		label: 'Nazilli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Karaman',
		label: 'Karaman, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kars',
		label: 'Kars, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Fatsa',
		label: 'Fatsa, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tatvan',
		label: 'Tatvan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kusadasi',
		label: 'Kusadasi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Niksar',
		label: 'Niksar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Afsin',
		label: 'Afsin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Develi',
		label: 'Develi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Vakfikebir',
		label: 'Vakfikebir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Burhaniye',
		label: 'Burhaniye, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kulu',
		label: 'Kulu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Osmancik',
		label: 'Osmancik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Göksun',
		label: 'Göksun, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Akçakoca',
		label: 'Akçakoca, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kaman',
		label: 'Kaman, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Biga',
		label: 'Biga, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Selçuk',
		label: 'Selçuk, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Malkara',
		label: 'Malkara, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Boyabat',
		label: 'Boyabat, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Erzin',
		label: 'Erzin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Karakoçan',
		label: 'Karakoçan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Malazgirt',
		label: 'Malazgirt, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Haskovo',
		label: 'Haskovo, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Akyazi',
		label: 'Akyazi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kahramanmaras',
		label: 'Kahramanmaras, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Iznik',
		label: 'Iznik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kovancilar',
		label: 'Kovancilar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tarsus',
		label: 'Tarsus, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gediz',
		label: 'Gediz, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Iskilip',
		label: 'Iskilip, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Osmaniye',
		label: 'Osmaniye, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Horasan',
		label: 'Horasan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Iskenderun',
		label: 'Iskenderun, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Inegöl',
		label: 'Inegöl, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Erzincan',
		label: 'Erzincan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Karabük',
		label: 'Karabük, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ceyhan',
		label: 'Ceyhan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Derince',
		label: 'Derince, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Turgutlu',
		label: 'Turgutlu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bafra',
		label: 'Bafra, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Salihli',
		label: 'Salihli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Polatli',
		label: 'Polatli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Akhisar',
		label: 'Akhisar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Amasya',
		label: 'Amasya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Cizre',
		label: 'Cizre, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ünye',
		label: 'Ünye, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Mardin',
		label: 'Mardin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Burdur',
		label: 'Burdur, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çankiri',
		label: 'Çankiri, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ödemis',
		label: 'Ödemis, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bismil',
		label: 'Bismil, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Hakkari',
		label: 'Hakkari, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Anamur',
		label: 'Anamur, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tavsanli',
		label: 'Tavsanli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Düziçi',
		label: 'Düziçi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Adilcevaz',
		label: 'Adilcevaz, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sebinkarahisar',
		label: 'Sebinkarahisar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Akçaabat',
		label: 'Akçaabat, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Urla',
		label: 'Urla, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Aliaga',
		label: 'Aliaga, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Uzunköprü',
		label: 'Uzunköprü, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Büyükçekmece',
		label: 'Büyükçekmece, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Talas',
		label: 'Talas, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Samandag',
		label: 'Samandag, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Beypazari',
		label: 'Beypazari, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Üzümlü',
		label: 'Üzümlü, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bulancak',
		label: 'Bulancak, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Yerköy',
		label: 'Yerköy, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bayburt',
		label: 'Bayburt, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Serik',
		label: 'Serik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Safranbolu',
		label: 'Safranbolu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ceylanpinar',
		label: 'Ceylanpinar, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Besikdüzü',
		label: 'Besikdüzü, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bogaziliyan',
		label: 'Bogaziliyan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Hendek',
		label: 'Hendek, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gümüshane',
		label: 'Gümüshane, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bur',
		label: 'Bur, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Simav',
		label: 'Simav, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Hinis',
		label: 'Hinis, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Imamoglu',
		label: 'Imamoglu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bucak',
		label: 'Bucak, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gölbasi',
		label: 'Gölbasi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Karasu',
		label: 'Karasu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kestel',
		label: 'Kestel, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Görele',
		label: 'Görele, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çan',
		label: 'Çan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kozluk',
		label: 'Kozluk, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kurtalan',
		label: 'Kurtalan, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ortaköy',
		label: 'Ortaköy, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Of',
		label: 'Of, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Ilgin',
		label: 'Ilgin, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sarkikaraagaç',
		label: 'Sarkikaraagaç, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bozyazi',
		label: 'Bozyazi, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kumluca',
		label: 'Kumluca, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kula',
		label: 'Kula, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Yenisehir',
		label: 'Yenisehir, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Babaeski',
		label: 'Babaeski, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gerede',
		label: 'Gerede, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Terme',
		label: 'Terme, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Susehri',
		label: 'Susehri, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tunceli',
		label: 'Tunceli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Alaca',
		label: 'Alaca, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Kirkagaç',
		label: 'Kirkagaç, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Pazarcik',
		label: 'Pazarcik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gölköy',
		label: 'Gölköy, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bulanik',
		label: 'Bulanik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çay',
		label: 'Çay, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Eskil',
		label: 'Eskil, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sarikamis',
		label: 'Sarikamis, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Oltu',
		label: 'Oltu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Vezirköprü',
		label: 'Vezirköprü, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Elmadag',
		label: 'Elmadag, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Pasinler',
		label: 'Pasinler, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Yahyali',
		label: 'Yahyali, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Susurluk',
		label: 'Susurluk, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Tosya',
		label: 'Tosya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Devrek',
		label: 'Devrek, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Gürsu',
		label: 'Gürsu, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Urfa',
		label: 'Urfa, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Demirci',
		label: 'Demirci, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Sarkisla',
		label: 'Sarkisla, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Mudanya',
		label: 'Mudanya, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çayeli',
		label: 'Çayeli, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Emirdag',
		label: 'Emirdag, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Akdagmadeni',
		label: 'Akdagmadeni, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çermik',
		label: 'Çermik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Bozova',
		label: 'Bozova, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Derik',
		label: 'Derik, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Çine',
		label: 'Çine, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Emet',
		label: 'Emet, Turkey',
		type: 'city',
		flagClass: 'fi fi-tr',
		isPopular: false,
	},
	{
		value: 'Turkmenistan',
		label: 'Turkmenistan',
		type: 'country',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Asgabat',
		label: 'Asgabat, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gubadag',
		label: 'Gubadag, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Adyndaky',
		label: 'Adyndaky, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Balkanabat',
		label: 'Balkanabat, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Türkmenbasi',
		label: 'Türkmenbasi, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Annau',
		label: 'Annau, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Türkmenabat',
		label: 'Türkmenabat, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Bekdash',
		label: 'Bekdash, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Dasoguz',
		label: 'Dasoguz, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Mari',
		label: 'Mari, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Bayramali',
		label: 'Bayramali, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Tecen',
		label: 'Tecen, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Serdar',
		label: 'Serdar, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Büzmeyin',
		label: 'Büzmeyin, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Boldumsaz',
		label: 'Boldumsaz, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Govurdak',
		label: 'Govurdak, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Köhne Ürgenç',
		label: 'Köhne Ürgenç, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Kerki',
		label: 'Kerki, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Komsomolsk',
		label: 'Komsomolsk, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Elöten',
		label: 'Elöten, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Akdepe',
		label: 'Akdepe, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Yilanli',
		label: 'Yilanli, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gumdag',
		label: 'Gumdag, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Bäherden',
		label: 'Bäherden, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gazanjyk',
		label: 'Gazanjyk, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Khazar',
		label: 'Khazar, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gökedepe',
		label: 'Gökedepe, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Kaka',
		label: 'Kaka, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Karakala',
		label: 'Karakala, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gazojak',
		label: 'Gazojak, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Saragt',
		label: 'Saragt, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Tagta',
		label: 'Tagta, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Goturdepe',
		label: 'Goturdepe, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Moskva',
		label: 'Moskva, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Seydi',
		label: 'Seydi, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Sayat',
		label: 'Sayat, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Halaç',
		label: 'Halaç, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Dänew',
		label: 'Dänew, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Miana',
		label: 'Miana, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Sakarchäge',
		label: 'Sakarchäge, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Jebel',
		label: 'Jebel, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Krasnyj Oktjabr',
		label: 'Krasnyj Oktjabr, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Farap',
		label: 'Farap, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Babadayhan',
		label: 'Babadayhan, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Birleshik Pervi',
		label: 'Birleshik Pervi, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gorelde',
		label: 'Gorelde, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Derveze',
		label: 'Derveze, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Dushak',
		label: 'Dushak, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Tagtabazar',
		label: 'Tagtabazar, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Murgob',
		label: 'Murgob, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Ovaz Jalatay',
		label: 'Ovaz Jalatay, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Sharlawuk',
		label: 'Sharlawuk, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Esenmengli',
		label: 'Esenmengli, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gasanguli',
		label: 'Gasanguli, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Mukri',
		label: 'Mukri, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Darganata',
		label: 'Darganata, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Ahchadepe',
		label: 'Ahchadepe, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Gusgi',
		label: 'Gusgi, Turkmenistan',
		type: 'city',
		flagClass: 'fi fi-tm',
		isPopular: false,
	},
	{
		value: 'Turks and Caicos Islands',
		label: 'Turks and Caicos Islands',
		type: 'country',
		flagClass: 'fi fi-tc',
		isPopular: false,
	},
	{
		value: 'Cockburn Town',
		label: 'Cockburn Town, Turks and Caicos Islands',
		type: 'city',
		flagClass: 'fi fi-tc',
		isPopular: false,
	},
	{
		value: 'Cockburn Harbour',
		label: 'Cockburn Harbour, Turks and Caicos Islands',
		type: 'city',
		flagClass: 'fi fi-tc',
		isPopular: false,
	},
	{
		value: 'Providenciales',
		label: 'Providenciales, Turks and Caicos Islands',
		type: 'city',
		flagClass: 'fi fi-tc',
		isPopular: false,
	},
	{
		value: 'Tuvalu',
		label: 'Tuvalu',
		type: 'country',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Asau',
		label: 'Asau, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Tonga',
		label: 'Tonga, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Lolua',
		label: 'Lolua, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Tanrake',
		label: 'Tanrake, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Vaiaku',
		label: 'Vaiaku, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Kua',
		label: 'Kua, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Savave',
		label: 'Savave, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Fangaua',
		label: 'Fangaua, Tuvalu',
		type: 'city',
		flagClass: 'fi fi-tv',
		isPopular: false,
	},
	{
		value: 'Uganda',
		label: 'Uganda',
		type: 'country',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kampala',
		label: 'Kampala, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Adjumani',
		label: 'Adjumani, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Jinja',
		label: 'Jinja, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mukono',
		label: 'Mukono, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Entebbe',
		label: 'Entebbe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mbarara',
		label: 'Mbarara, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mityana',
		label: 'Mityana, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Wakiso',
		label: 'Wakiso, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mbale',
		label: 'Mbale, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Masaka',
		label: 'Masaka, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Hoima',
		label: 'Hoima, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Gulu',
		label: 'Gulu, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Soroti',
		label: 'Soroti, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Fort Portal',
		label: 'Fort Portal, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Iganga',
		label: 'Iganga, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kamwenge',
		label: 'Kamwenge, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Apac',
		label: 'Apac, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kajansi',
		label: 'Kajansi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'La Lira',
		label: 'La Lira, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kasese',
		label: 'Kasese, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kayunga',
		label: 'Kayunga, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mubende',
		label: 'Mubende, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kyenjojo',
		label: 'Kyenjojo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kanungu',
		label: 'Kanungu, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Jinja-Kawempe',
		label: 'Jinja-Kawempe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Pader',
		label: 'Pader, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Arua',
		label: 'Arua, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kitgum',
		label: 'Kitgum, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Tororo',
		label: 'Tororo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Busia',
		label: 'Busia, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Lugazi',
		label: 'Lugazi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Luwero',
		label: 'Luwero, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Nebbi',
		label: 'Nebbi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bushenyi',
		label: 'Bushenyi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kaberamaido',
		label: 'Kaberamaido, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Namasuba',
		label: 'Namasuba, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Wobulenzi',
		label: 'Wobulenzi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bugiri',
		label: 'Bugiri, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Pakwach',
		label: 'Pakwach, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kireka',
		label: 'Kireka, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Yumbe',
		label: 'Yumbe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Buwenge',
		label: 'Buwenge, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bombo',
		label: 'Bombo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kamuli',
		label: 'Kamuli, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kisoro',
		label: 'Kisoro, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bweyogerere',
		label: 'Bweyogerere, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Malaba',
		label: 'Malaba, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kumi',
		label: 'Kumi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Lyantonde',
		label: 'Lyantonde, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kilembe',
		label: 'Kilembe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kaabong',
		label: 'Kaabong, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Nakasongola',
		label: 'Nakasongola, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Rakai',
		label: 'Rakai, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kibaale',
		label: 'Kibaale, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kalangala',
		label: 'Kalangala, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kagadi',
		label: 'Kagadi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Njeru',
		label: 'Njeru, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kabale',
		label: 'Kabale, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Koboko',
		label: 'Koboko, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Masindi',
		label: 'Masindi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Paidha',
		label: 'Paidha, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Pallisa',
		label: 'Pallisa, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Ibanda',
		label: 'Ibanda, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Rukungiri',
		label: 'Rukungiri, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kabwohe-Itendero',
		label: 'Kabwohe-Itendero, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Lukaya',
		label: 'Lukaya, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bundibugyo',
		label: 'Bundibugyo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kotido',
		label: 'Kotido, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Ntungamo',
		label: 'Ntungamo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Hima',
		label: 'Hima, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Busembatia',
		label: 'Busembatia, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Moyo',
		label: 'Moyo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kiboga',
		label: 'Kiboga, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Sironko',
		label: 'Sironko, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Nkonkonjeru',
		label: 'Nkonkonjeru, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mpigi',
		label: 'Mpigi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Bugembe',
		label: 'Bugembe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Mayuge',
		label: 'Mayuge, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kapchorwa',
		label: 'Kapchorwa, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kyotera',
		label: 'Kyotera, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Moroto',
		label: 'Moroto, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Ngora',
		label: 'Ngora, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Katakwi',
		label: 'Katakwi, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Masindi-Port',
		label: 'Masindi-Port, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Katwe',
		label: 'Katwe, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Kigorobya',
		label: 'Kigorobya, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Sembabule',
		label: 'Sembabule, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Nakapiripirit',
		label: 'Nakapiripirit, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Muhororo',
		label: 'Muhororo, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Amudat',
		label: 'Amudat, Uganda',
		type: 'city',
		flagClass: 'fi fi-ug',
		isPopular: false,
	},
	{
		value: 'Ukraine',
		label: 'Ukraine',
		type: 'country',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kyiv',
		label: 'Kyiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kharkiv',
		label: 'Kharkiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Odesa',
		label: 'Odesa, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "L'viv",
		label: "L'viv, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Adancata',
		label: 'Adancata, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Dnipropetrovs'k",
		label: "Dnipropetrovs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Donets'k",
		label: "Donets'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Zaporizhzhya',
		label: 'Zaporizhzhya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Simferopol'",
		label: "Simferopol', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Luhans'k",
		label: "Luhans'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Cherkasy',
		label: 'Cherkasy, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Ternopil'",
		label: "Ternopil', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Ivano-Frankivs'k",
		label: "Ivano-Frankivs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Vinnytsya',
		label: 'Vinnytsya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Chernivets'ka",
		label: "Chernivets'ka, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Mykolayiv',
		label: 'Mykolayiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kherson',
		label: 'Kherson, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Zhytomyr',
		label: 'Zhytomyr, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Rivne',
		label: 'Rivne, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Luts'k",
		label: "Luts'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Poltavs'ka",
		label: "Poltavs'ka, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Chernihiv',
		label: 'Chernihiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Fastiv',
		label: 'Fastiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Sevastopol'",
		label: "Sevastopol', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kalush',
		label: 'Kalush, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Khmel'nyts'ka",
		label: "Khmel'nyts'ka, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Dniprodzerzhyns'k",
		label: "Dniprodzerzhyns'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Uzhhorod',
		label: 'Uzhhorod, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Berdyans'k",
		label: "Berdyans'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Kam'yanets'-Podil's'kyy",
		label: "Kam'yanets'-Podil's'kyy, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Umán',
		label: 'Umán, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Berdychiv',
		label: 'Berdychiv, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Korosten'",
		label: "Korosten', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Mariupol'",
		label: "Mariupol', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Makiyivka',
		label: 'Makiyivka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Sums'ka",
		label: "Sums'ka, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kirovohrad',
		label: 'Kirovohrad, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kremenchuh',
		label: 'Kremenchuh, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Kramators'k",
		label: "Kramators'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kerch',
		label: 'Kerch, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Yenakiyeve',
		label: 'Yenakiyeve, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Artemivs'k",
		label: "Artemivs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Izmayil',
		label: 'Izmayil, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Drohobych',
		label: 'Drohobych, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Smila',
		label: 'Smila, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Kovel'",
		label: "Kovel', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Druzhkivka',
		label: 'Druzhkivka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Antratsyt',
		label: 'Antratsyt, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Pryluky',
		label: 'Pryluky, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Lozova',
		label: 'Lozova, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Novovolyns'k",
		label: "Novovolyns'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Bryanka',
		label: 'Bryanka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Bilhorod-Dnistrovs'kyy",
		label: "Bilhorod-Dnistrovs'kyy, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Zhovti Vody',
		label: 'Zhovti Vody, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Romny',
		label: 'Romny, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Dzerzhyns'k",
		label: "Dzerzhyns'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kryvyy Rih',
		label: 'Kryvyy Rih, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Sumy',
		label: 'Sumy, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Bila Tserkva',
		label: 'Bila Tserkva, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Melitpol'",
		label: "Melitpol', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Nikopol'",
		label: "Nikopol', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Slov'yans'k",
		label: "Slov'yans'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Alchevs'k",
		label: "Alchevs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Syeverodonets'k",
		label: "Syeverodonets'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Pavlodar',
		label: 'Pavlodar, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Lysychans'k",
		label: "Lysychans'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Yevpatoriya',
		label: 'Yevpatoriya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kostyantynivka',
		label: 'Kostyantynivka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Konotop',
		label: 'Konotop, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Oleksandriya',
		label: 'Oleksandriya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Krasnyy Luch',
		label: 'Krasnyy Luch, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Brovary',
		label: 'Brovary, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Shostka',
		label: 'Shostka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Stakhanov',
		label: 'Stakhanov, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Mukacheve',
		label: 'Mukacheve, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Yalta',
		label: 'Yalta, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Nizhyn',
		label: 'Nizhyn, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Jekaterinburg',
		label: 'Jekaterinburg, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Feodosiya',
		label: 'Feodosiya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Novomoskovs'k",
		label: "Novomoskovs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Torez',
		label: 'Torez, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Chervonohrad',
		label: 'Chervonohrad, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Krasnoarmeets',
		label: 'Krasnoarmeets, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Pervomays'k",
		label: "Pervomays'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Khartsyz'k",
		label: "Khartsyz'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Rubizhne',
		label: 'Rubizhne, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Stryy',
		label: 'Stryy, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Kolomyya',
		label: 'Kolomyya, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Snizhne',
		label: 'Snizhne, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Shahtjorsk',
		label: 'Shahtjorsk, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Novohrad-Volyns'kyy",
		label: "Novohrad-Volyns'kyy, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Boryspil'",
		label: "Boryspil', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Illichivs'k",
		label: "Illichivs'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Izyum',
		label: 'Izyum, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Roven'ky",
		label: "Roven'ky, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Enerhodar',
		label: 'Enerhodar, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Krasnodon',
		label: 'Krasnodon, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Dymytrov',
		label: 'Dymytrov, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Komsomol's'k",
		label: "Komsomol's'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Svidlovods'k",
		label: "Svidlovods'k, Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Lubny',
		label: 'Lubny, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Shepetivka',
		label: 'Shepetivka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Nova Kakhovka',
		label: 'Nova Kakhovka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Okhtyrka',
		label: 'Okhtyrka, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: "Marhanets'",
		label: "Marhanets', Ukraine",
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Dzhankoy',
		label: 'Dzhankoy, Ukraine',
		type: 'city',
		flagClass: 'fi fi-ua',
		isPopular: false,
	},
	{
		value: 'Abu Dhabi',
		label: 'Abu Dhabi, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'ash-Shariqah',
		label: 'ash-Shariqah, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'Ajman',
		label: 'Ajman, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'al-´Ayn',
		label: 'al-´Ayn, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'Umm al-Qaywayn',
		label: 'Umm al-Qaywayn, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: "Ra's al-Khaymah",
		label: "Ra's al-Khaymah, United Arab Emirates",
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'al-Fujayrah',
		label: 'al-Fujayrah, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'Khawr Fakkan',
		label: 'Khawr Fakkan, United Arab Emirates',
		type: 'city',
		flagClass: 'fi fi-ae',
		isPopular: false,
	},
	{
		value: 'United Kingdom',
		label: 'United Kingdom',
		type: 'country',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Manchester',
		label: 'Manchester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Glasgow',
		label: 'Glasgow, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Edinburgh',
		label: 'Edinburgh, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Birmingham',
		label: 'Birmingham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Leeds',
		label: 'Leeds, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bristol',
		label: 'Bristol, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Nottingham',
		label: 'Nottingham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Liverpool',
		label: 'Liverpool, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Brighton',
		label: 'Brighton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Newcastle Upon Tyne',
		label: 'Newcastle Upon Tyne, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Belfast',
		label: 'Belfast, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Oxford',
		label: 'Oxford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Reading',
		label: 'Reading, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Leicester',
		label: 'Leicester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Aberchirder',
		label: 'Aberchirder, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Cambridge',
		label: 'Cambridge, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Milton Keynes',
		label: 'Milton Keynes, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Cardiff',
		label: 'Cardiff, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'York',
		label: 'York, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stoke-on-Trent',
		label: 'Stoke-on-Trent, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Dundee',
		label: 'Dundee, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Southampton',
		label: 'Southampton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Portsmouth',
		label: 'Portsmouth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Guildford',
		label: 'Guildford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Northampton',
		label: 'Northampton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bournemouth',
		label: 'Bournemouth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Sheffield',
		label: 'Sheffield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Wolverhampton',
		label: 'Wolverhampton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Derby',
		label: 'Derby, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Swindon',
		label: 'Swindon, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stockport',
		label: 'Stockport, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Coventry',
		label: 'Coventry, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bath',
		label: 'Bath, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bolton',
		label: 'Bolton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hull',
		label: 'Hull, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Aberdeen',
		label: 'Aberdeen, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Norwich',
		label: 'Norwich, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Watford',
		label: 'Watford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Maidenhead',
		label: 'Maidenhead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Basingstoke',
		label: 'Basingstoke, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Exeter',
		label: 'Exeter, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Blackpool',
		label: 'Blackpool, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Doncaster',
		label: 'Doncaster, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Chester',
		label: 'Chester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Colchester',
		label: 'Colchester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Witney',
		label: 'Witney, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bradford',
		label: 'Bradford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Ipswich',
		label: 'Ipswich, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'High Wycombe',
		label: 'High Wycombe, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Falkirk',
		label: 'Falkirk, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Southend-on-Sea',
		label: 'Southend-on-Sea, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Wakefield',
		label: 'Wakefield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Plymouth',
		label: 'Plymouth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Slough',
		label: 'Slough, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Cheltenham',
		label: 'Cheltenham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Harrogate',
		label: 'Harrogate, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Peterborough',
		label: 'Peterborough, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bedford',
		label: 'Bedford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Lincoln',
		label: 'Lincoln, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Luton',
		label: 'Luton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Woking',
		label: 'Woking, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Huddersfield',
		label: 'Huddersfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Gloucester',
		label: 'Gloucester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Preston',
		label: 'Preston, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Swansea',
		label: 'Swansea, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Basildon',
		label: 'Basildon, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Wigan',
		label: 'Wigan, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Aylesbury',
		label: 'Aylesbury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Maidstone',
		label: 'Maidstone, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Chelmsford',
		label: 'Chelmsford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Eastbourne',
		label: 'Eastbourne, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Warrington',
		label: 'Warrington, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Worcester',
		label: 'Worcester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Windsor',
		label: 'Windsor, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Walsall',
		label: 'Walsall, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Winchester',
		label: 'Winchester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Nuneaton',
		label: 'Nuneaton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Birkenhead',
		label: 'Birkenhead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stafford',
		label: 'Stafford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Middlesbrough',
		label: 'Middlesbrough, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Chichester',
		label: 'Chichester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Telford',
		label: 'Telford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Canterbury',
		label: 'Canterbury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Durham',
		label: 'Durham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Newbury',
		label: 'Newbury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'St Albans',
		label: 'St Albans, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Solihull',
		label: 'Solihull, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Dartford',
		label: 'Dartford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bracknell',
		label: 'Bracknell, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Poole',
		label: 'Poole, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Leamington Spa',
		label: 'Leamington Spa, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Crawley',
		label: 'Crawley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Shrewsbury',
		label: 'Shrewsbury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Halifax',
		label: 'Halifax, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Dunfermline',
		label: 'Dunfermline, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Worthing',
		label: 'Worthing, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Macclesfield',
		label: 'Macclesfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hemel Hempstead',
		label: 'Hemel Hempstead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Lancaster',
		label: 'Lancaster, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Epsom',
		label: 'Epsom, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Camberley',
		label: 'Camberley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hove',
		label: 'Hove, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Reigate',
		label: 'Reigate, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Newport',
		label: 'Newport, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Barnsley',
		label: 'Barnsley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Harlow',
		label: 'Harlow, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Sunderland',
		label: 'Sunderland, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'East Kilbride',
		label: 'East Kilbride, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Ayr',
		label: 'Ayr, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hereford',
		label: 'Hereford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stirling',
		label: 'Stirling, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Dudley',
		label: 'Dudley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Livingston',
		label: 'Livingston, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Wokingham',
		label: 'Wokingham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hastings',
		label: 'Hastings, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hertford',
		label: 'Hertford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Banbury',
		label: 'Banbury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Farnborough',
		label: 'Farnborough, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Altrincham',
		label: 'Altrincham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stevenage',
		label: 'Stevenage, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Horsham',
		label: 'Horsham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Chesterfield',
		label: 'Chesterfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Rochester',
		label: 'Rochester, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Staines',
		label: 'Staines, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Tonbridge',
		label: 'Tonbridge, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Sevenoaks',
		label: 'Sevenoaks, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Rochdale',
		label: 'Rochdale, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Darlington',
		label: 'Darlington, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Loughborough',
		label: 'Loughborough, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Yeovil',
		label: 'Yeovil, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Burnley',
		label: 'Burnley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Truro',
		label: 'Truro, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: "Bishop's Stortford",
		label: "Bishop's Stortford, United Kingdom",
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Oldham',
		label: 'Oldham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Carlisle',
		label: 'Carlisle, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Kilmarnock',
		label: 'Kilmarnock, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Blackburn',
		label: 'Blackburn, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Weston-super-mare',
		label: 'Weston-super-mare, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Ashford',
		label: 'Ashford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Loughton',
		label: 'Loughton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Abingdon',
		label: 'Abingdon, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Londonderry',
		label: 'Londonderry, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Burton-on-Trent',
		label: 'Burton-on-Trent, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Taunton',
		label: 'Taunton, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Fareham',
		label: 'Fareham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Wrexham',
		label: 'Wrexham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Farnham',
		label: 'Farnham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stockton-on-Tees',
		label: 'Stockton-on-Tees, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Torquay',
		label: 'Torquay, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Greenock',
		label: 'Greenock, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Crewe',
		label: 'Crewe, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Gillingham',
		label: 'Gillingham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Rugby',
		label: 'Rugby, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Rotherham',
		label: 'Rotherham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Brentwood',
		label: 'Brentwood, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Grimsby',
		label: 'Grimsby, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Inverness',
		label: 'Inverness, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bury St Edmunds',
		label: 'Bury St Edmunds, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Salford',
		label: 'Salford, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Weybridge',
		label: 'Weybridge, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Gravesend',
		label: 'Gravesend, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Amersham',
		label: 'Amersham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hitchin',
		label: 'Hitchin, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Tunbridge Wells',
		label: 'Tunbridge Wells, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Grays',
		label: 'Grays, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Aldershot',
		label: 'Aldershot, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Bury',
		label: 'Bury, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Chippenham',
		label: 'Chippenham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Tamworth',
		label: 'Tamworth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Warwick',
		label: 'Warwick, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Andover',
		label: 'Andover, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Motherwell',
		label: 'Motherwell, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Gateshead',
		label: 'Gateshead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Redditch',
		label: 'Redditch, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Mansfield',
		label: 'Mansfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Kettering',
		label: 'Kettering, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Perth',
		label: 'Perth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Stratford-upon-avon',
		label: 'Stratford-upon-avon, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Scunthorpe',
		label: 'Scunthorpe, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Cumbernauld',
		label: 'Cumbernauld, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Sutton Coldfield',
		label: 'Sutton Coldfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Beverley',
		label: 'Beverley, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Kirkcaldy',
		label: 'Kirkcaldy, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Leatherhead',
		label: 'Leatherhead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Leighton Buzzard',
		label: 'Leighton Buzzard, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Harpenden',
		label: 'Harpenden, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Barrow-in-Furness',
		label: 'Barrow-in-Furness, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: "King's Lynn",
		label: "King's Lynn, United Kingdom",
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Northwich',
		label: 'Northwich, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hartlepool',
		label: 'Hartlepool, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Gosport',
		label: 'Gosport, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Egham',
		label: 'Egham, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Hatfield',
		label: 'Hatfield, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Weymouth',
		label: 'Weymouth, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Dunstable',
		label: 'Dunstable, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'East Grinstead',
		label: 'East Grinstead, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Ashton-under-Lyne',
		label: 'Ashton-under-Lyne, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Accrington',
		label: 'Accrington, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'Newark',
		label: 'Newark, United Kingdom',
		type: 'city',
		flagClass: 'fi fi-gb',
		isPopular: false,
	},
	{
		value: 'United States Minor Outlying Islands',
		label: 'United States Minor Outlying Islands',
		type: 'country',
		flagClass: 'fi fi-um',
		isPopular: false,
	},
	{
		value: 'Chicago',
		label: 'Chicago, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'San Diego',
		label: 'San Diego, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Washington',
		label: 'Washington, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Los Angeles',
		label: 'Los Angeles, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Houston',
		label: 'Houston, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Atlanta',
		label: 'Atlanta, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'San Francisco',
		label: 'San Francisco, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Seattle',
		label: 'Seattle, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Austin',
		label: 'Austin, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Philadelphia',
		label: 'Philadelphia, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Denver',
		label: 'Denver, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Dallas',
		label: 'Dallas, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Portland',
		label: 'Portland, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Boston',
		label: 'Boston, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Raleigh',
		label: 'Raleigh, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Brooklyn',
		label: 'Brooklyn, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Orlando',
		label: 'Orlando, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Phoenix',
		label: 'Phoenix, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Las Vegas',
		label: 'Las Vegas, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: true,
	},
	{
		value: 'Hawaii',
		label: 'Hawaii, United States',
		type: 'country',
		flagClass: 'fi fi-us',
		isPopular: true,
	},
	{
		value: 'Minneapolis',
		label: 'Minneapolis, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Charlotte',
		label: 'Charlotte, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Sacramento',
		label: 'Sacramento, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'San Antonio',
		label: 'San Antonio, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tampa',
		label: 'Tampa, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fort Lauderdale',
		label: 'Fort Lauderdale, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'San Jose',
		label: 'San Jose, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Saint Louis',
		label: 'Saint Louis, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Miami',
		label: 'Miami, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Pittsburgh',
		label: 'Pittsburgh, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Baltimore',
		label: 'Baltimore, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Jacksonville',
		label: 'Jacksonville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Richmond',
		label: 'Richmond, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tucson',
		label: 'Tucson, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Columbus',
		label: 'Columbus, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Nashville',
		label: 'Nashville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Cincinnati',
		label: 'Cincinnati, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Indianapolis',
		label: 'Indianapolis, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Kansas City',
		label: 'Kansas City, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Arlington',
		label: 'Arlington, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Santa Monica',
		label: 'Santa Monica, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fort Worth',
		label: 'Fort Worth, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Saint Paul',
		label: 'Saint Paul, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Cleveland',
		label: 'Cleveland, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Irvine',
		label: 'Irvine, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Oakland',
		label: 'Oakland, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Milwaukee',
		label: 'Milwaukee, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Colorado Springs',
		label: 'Colorado Springs, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Rochester',
		label: 'Rochester, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fairfax',
		label: 'Fairfax, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Albuquerque',
		label: 'Albuquerque, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Long Beach',
		label: 'Long Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Virginia Beach',
		label: 'Virginia Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Scottsdale',
		label: 'Scottsdale, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Alexandria',
		label: 'Alexandria, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Salt Lake City',
		label: 'Salt Lake City, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Boulder',
		label: 'Boulder, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Anaheim',
		label: 'Anaheim, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Detroit',
		label: 'Detroit, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Louisville',
		label: 'Louisville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Marietta',
		label: 'Marietta, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Plano',
		label: 'Plano, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'West Palm Beach',
		label: 'West Palm Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'New Orleans',
		label: 'New Orleans, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Saint Petersburg',
		label: 'Saint Petersburg, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Cambridge',
		label: 'Cambridge, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Buffalo',
		label: 'Buffalo, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Albany',
		label: 'Albany, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Madison',
		label: 'Madison, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Greensboro',
		label: 'Greensboro, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Knoxville',
		label: 'Knoxville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Littleton',
		label: 'Littleton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Bellevue',
		label: 'Bellevue, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Cary',
		label: 'Cary, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Oklahoma City',
		label: 'Oklahoma City, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Ann Arbor',
		label: 'Ann Arbor, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Norfolk',
		label: 'Norfolk, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Rockville',
		label: 'Rockville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Bronx',
		label: 'Bronx, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Durham',
		label: 'Durham, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Mesa',
		label: 'Mesa, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Riverside',
		label: 'Riverside, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tacoma',
		label: 'Tacoma, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fort Collins',
		label: 'Fort Collins, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tulsa',
		label: 'Tulsa, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Omaha',
		label: 'Omaha, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Pasadena',
		label: 'Pasadena, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Sarasota',
		label: 'Sarasota, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Providence',
		label: 'Providence, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Greenville',
		label: 'Greenville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Memphis',
		label: 'Memphis, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Stamford',
		label: 'Stamford, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Gilbert',
		label: 'Gilbert, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'White Plains',
		label: 'White Plains, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Hollywood',
		label: 'Hollywood, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: true,
	},
	{
		value: 'Schaumburg',
		label: 'Schaumburg, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Silver Spring',
		label: 'Silver Spring, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Chandler',
		label: 'Chandler, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tempe',
		label: 'Tempe, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Tallahassee',
		label: 'Tallahassee, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Birmingham',
		label: 'Birmingham, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fresno',
		label: 'Fresno, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Palo Alto',
		label: 'Palo Alto, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Wilmington',
		label: 'Wilmington, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Boise',
		label: 'Boise, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Charleston',
		label: 'Charleston, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Boca Raton',
		label: 'Boca Raton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Jersey City',
		label: 'Jersey City, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Alpharetta',
		label: 'Alpharetta, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'New Haven',
		label: 'New Haven, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Berkeley',
		label: 'Berkeley, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Syracuse',
		label: 'Syracuse, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Mountain View',
		label: 'Mountain View, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Lexington',
		label: 'Lexington, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Huntington',
		label: 'Huntington, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Grand Rapids',
		label: 'Grand Rapids, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Anchorage',
		label: 'Anchorage, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Asheville',
		label: 'Asheville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Huntington Beach',
		label: 'Huntington Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Bakersfield',
		label: 'Bakersfield, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Henderson',
		label: 'Henderson, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Columbia',
		label: 'Columbia, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Escondido',
		label: 'Escondido, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fort Myers',
		label: 'Fort Myers, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Honolulu',
		label: 'Honolulu, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Hialeah',
		label: 'Hialeah, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Pompano Beach',
		label: 'Pompano Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Palmdale',
		label: 'Palmdale, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Reno',
		label: 'Reno, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Astoria',
		label: 'Astoria, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fayetteville',
		label: 'Fayetteville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Newark',
		label: 'Newark, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Hartford',
		label: 'Hartford, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Gainesville',
		label: 'Gainesville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Baton Rouge',
		label: 'Baton Rouge, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Santa Cruz',
		label: 'Santa Cruz, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Staten Island',
		label: 'Staten Island, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Everett',
		label: 'Everett, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Ridgewood',
		label: 'Ridgewood, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Santa Rosa',
		label: 'Santa Rosa, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Spring',
		label: 'Spring, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Trenton',
		label: 'Trenton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Des Moines',
		label: 'Des Moines, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Wichita',
		label: 'Wichita, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Sunnyvale',
		label: 'Sunnyvale, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Walnut Creek',
		label: 'Walnut Creek, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Worcester',
		label: 'Worcester, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Aurora',
		label: 'Aurora, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Harrisburg',
		label: 'Harrisburg, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Akron',
		label: 'Akron, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Vancouver',
		label: 'Vancouver, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Spokane',
		label: 'Spokane, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Naperville',
		label: 'Naperville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Allentown',
		label: 'Allentown, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Ventura',
		label: 'Ventura, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Torrance',
		label: 'Torrance, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Huntsville',
		label: 'Huntsville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Carlsbad',
		label: 'Carlsbad, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Beaverton',
		label: 'Beaverton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Naples',
		label: 'Naples, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Dayton',
		label: 'Dayton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Frisco',
		label: 'Frisco, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Olympia',
		label: 'Olympia, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Newport Beach',
		label: 'Newport Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Savannah',
		label: 'Savannah, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Oceanside',
		label: 'Oceanside, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Reston',
		label: 'Reston, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Pensacola',
		label: 'Pensacola, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Manchester',
		label: 'Manchester, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Somerville',
		label: 'Somerville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Fremont',
		label: 'Fremont, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Charlottesville',
		label: 'Charlottesville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Toledo',
		label: 'Toledo, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Eugene',
		label: 'Eugene, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Renton',
		label: 'Renton, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Santa Barbara',
		label: 'Santa Barbara, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'McKinney',
		label: 'McKinney, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Clearwater',
		label: 'Clearwater, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Costa Mesa',
		label: 'Costa Mesa, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Melbourne',
		label: 'Melbourne, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Miami Beach',
		label: 'Miami Beach, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'New Brunswick',
		label: 'New Brunswick, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Chattanooga',
		label: 'Chattanooga, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Lansing',
		label: 'Lansing, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Poughkeepsie',
		label: 'Poughkeepsie, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Roanoke',
		label: 'Roanoke, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Beverly Hills',
		label: 'Beverly Hills, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Irving',
		label: 'Irving, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Katy',
		label: 'Katy, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'San Mateo',
		label: 'San Mateo, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Lancaster',
		label: 'Lancaster, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Cherry Hill',
		label: 'Cherry Hill, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Santa Clara',
		label: 'Santa Clara, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Overland Park',
		label: 'Overland Park, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Glendale',
		label: 'Glendale, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Roseville',
		label: 'Roseville, United States',
		type: 'city',
		flagClass: 'fi fi-us',
		isPopular: false,
	},
	{
		value: 'Uruguay',
		label: 'Uruguay',
		type: 'country',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Montevideo',
		label: 'Montevideo, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Artigas',
		label: 'Artigas, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Maldonado',
		label: 'Maldonado, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Fray Bentos',
		label: 'Fray Bentos, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Pando',
		label: 'Pando, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Durazno',
		label: 'Durazno, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Treinta y Tres',
		label: 'Treinta y Tres, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Colonia',
		label: 'Colonia, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Trinidad',
		label: 'Trinidad, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Colombia',
		label: 'Colombia, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Bella Unión',
		label: 'Bella Unión, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Ciudad de la Costa',
		label: 'Ciudad de la Costa, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Paysandú',
		label: 'Paysandú, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Melo',
		label: 'Melo, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Tacuarembó',
		label: 'Tacuarembó, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Mercedes',
		label: 'Mercedes, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Rocha',
		label: 'Rocha, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'La Paz',
		label: 'La Paz, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Carmelo',
		label: 'Carmelo, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Young',
		label: 'Young, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Paso de los Toros',
		label: 'Paso de los Toros, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Chui',
		label: 'Chui, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Nueva Helvecia',
		label: 'Nueva Helvecia, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Las Piedras',
		label: 'Las Piedras, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Minas',
		label: 'Minas, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Chiapa',
		label: 'Chiapa, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Florida',
		label: 'Florida, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Cacaotepec',
		label: 'Cacaotepec, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Progreso',
		label: 'Progreso, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Delta del Tigre',
		label: 'Delta del Tigre, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Río Branco',
		label: 'Río Branco, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Dolores',
		label: 'Dolores, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Camino Maldonado',
		label: 'Camino Maldonado, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Juan Antonio Artigas',
		label: 'Juan Antonio Artigas, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Paso de Carrasco',
		label: 'Paso de Carrasco, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Juan Lacaze',
		label: 'Juan Lacaze, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Salto',
		label: 'Salto, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Cuernavaca',
		label: 'Cuernavaca, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Rivera',
		label: 'Rivera, Uruguay',
		type: 'city',
		flagClass: 'fi fi-uy',
		isPopular: false,
	},
	{
		value: 'Uzbekistan',
		label: 'Uzbekistan',
		type: 'country',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Toskent',
		label: 'Toskent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ahunabayev',
		label: 'Ahunabayev, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Samarkand',
		label: 'Samarkand, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Buhoro',
		label: 'Buhoro, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Andijon',
		label: 'Andijon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Nukus',
		label: 'Nukus, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çirçik',
		label: 'Çirçik, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Angren',
		label: 'Angren, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Bekobod',
		label: 'Bekobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sahrisabz',
		label: 'Sahrisabz, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Asaka',
		label: 'Asaka, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çartak',
		label: 'Çartak, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Uçkuduk',
		label: 'Uçkuduk, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gurlan',
		label: 'Gurlan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sovot',
		label: 'Sovot, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yakkabog',
		label: 'Yakkabog, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Urtaçim',
		label: 'Urtaçim, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çelak',
		label: 'Çelak, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Akkürgon',
		label: 'Akkürgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Boz',
		label: 'Boz, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Altyarik',
		label: 'Altyarik, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Camboy',
		label: 'Camboy, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kibray',
		label: 'Kibray, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Almazar',
		label: 'Almazar, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Buston',
		label: 'Buston, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Baht',
		label: 'Baht, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Avval',
		label: 'Avval, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Aytim',
		label: 'Aytim, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Namangan',
		label: 'Namangan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Karsi',
		label: 'Karsi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Fargona',
		label: 'Fargona, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kükon',
		label: 'Kükon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ürgenç',
		label: 'Ürgenç, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Cizah',
		label: 'Cizah, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Navoi',
		label: 'Navoi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Margilon',
		label: 'Margilon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Termiz',
		label: 'Termiz, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Olmalik',
		label: 'Olmalik, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hücayli',
		label: 'Hücayli, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Guliston',
		label: 'Guliston, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kattakürgon',
		label: 'Kattakürgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Denau',
		label: 'Denau, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Türtkül',
		label: 'Türtkül, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çust',
		label: 'Çust, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kogon',
		label: 'Kogon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Zarafson',
		label: 'Zarafson, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sahrihan',
		label: 'Sahrihan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Koson',
		label: 'Koson, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Küngirot',
		label: 'Küngirot, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yaniyül',
		label: 'Yaniyül, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Tahiatos',
		label: 'Tahiatos, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Heva',
		label: 'Heva, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Beruni',
		label: 'Beruni, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Urgut',
		label: 'Urgut, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kosonsoy',
		label: 'Kosonsoy, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kitob',
		label: 'Kitob, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gijduvon',
		label: 'Gijduvon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Honko',
		label: 'Honko, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Oktos',
		label: 'Oktos, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hovos',
		label: 'Hovos, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Parkent',
		label: 'Parkent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ohangaron',
		label: 'Ohangaron, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çimboy',
		label: 'Çimboy, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Uçkürgon',
		label: 'Uçkürgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kuva',
		label: 'Kuva, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yaniyer',
		label: 'Yaniyer, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Karabagis',
		label: 'Karabagis, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kamasi',
		label: 'Kamasi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kuvasoy',
		label: 'Kuvasoy, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Mangit',
		label: 'Mangit, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Riston',
		label: 'Riston, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Nurota',
		label: 'Nurota, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Muborak',
		label: 'Muborak, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Pskent',
		label: 'Pskent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Turakürgon',
		label: 'Turakürgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sirdare',
		label: 'Sirdare, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Bulungur',
		label: 'Bulungur, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Bektemir',
		label: 'Bektemir, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Carkurgon',
		label: 'Carkurgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hakkulobod',
		label: 'Hakkulobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kürgontepa',
		label: 'Kürgontepa, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kirgili',
		label: 'Kirgili, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Särur',
		label: 'Särur, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Paytug',
		label: 'Paytug, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Serobod',
		label: 'Serobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Guzor',
		label: 'Guzor, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Pahtaobod',
		label: 'Pahtaobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Boysun',
		label: 'Boysun, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çinoz',
		label: 'Çinoz, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gazalkent',
		label: 'Gazalkent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gagarin',
		label: 'Gagarin, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sürçi',
		label: 'Sürçi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yaniobod',
		label: 'Yaniobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Iskandar',
		label: 'Iskandar, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gallaorol',
		label: 'Gallaorol, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Karmana',
		label: 'Karmana, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kara-Kul',
		label: 'Kara-Kul, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Pop',
		label: 'Pop, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Besarik',
		label: 'Besarik, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Stantsiya Gorchakovo',
		label: 'Stantsiya Gorchakovo, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Pahtakor',
		label: 'Pahtakor, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Tahtaküpir',
		label: 'Tahtaküpir, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yaypan',
		label: 'Yaypan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Tüytepa',
		label: 'Tüytepa, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Üyçi',
		label: 'Üyçi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Cuma',
		label: 'Cuma, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Buka',
		label: 'Buka, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ulyanovo',
		label: 'Ulyanovo, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çirakçi',
		label: 'Çirakçi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Keles',
		label: 'Keles, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Paskurd',
		label: 'Paskurd, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yanikürgon',
		label: 'Yanikürgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kegayli',
		label: 'Kegayli, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Zan',
		label: 'Zan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Honobod',
		label: 'Honobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kumkurgon',
		label: 'Kumkurgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sariasiya',
		label: 'Sariasiya, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Unhoyat',
		label: 'Unhoyat, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Maydayap',
		label: 'Maydayap, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Chichka',
		label: 'Chichka, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hazorasp',
		label: 'Hazorasp, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Karauzyak',
		label: 'Karauzyak, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Tosbulok',
		label: 'Tosbulok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kasbi',
		label: 'Kasbi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Drujba',
		label: 'Drujba, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Salar',
		label: 'Salar, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Beskent',
		label: 'Beskent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ceynau',
		label: 'Ceynau, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hocaobod',
		label: 'Hocaobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Küsküpir',
		label: 'Küsküpir, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Karabag',
		label: 'Karabag, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kizketken',
		label: 'Kizketken, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Vobkent',
		label: 'Vobkent, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Düstlik',
		label: 'Düstlik, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kallig',
		label: 'Kallig, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Dinau',
		label: 'Dinau, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sargun',
		label: 'Sargun, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Krasnogorskij',
		label: 'Krasnogorskij, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Superfosfatniy',
		label: 'Superfosfatniy, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Toslok',
		label: 'Toslok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Ziadin',
		label: 'Ziadin, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çarhin',
		label: 'Çarhin, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Galaosiye',
		label: 'Galaosiye, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Paysanba',
		label: 'Paysanba, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sumanay',
		label: 'Sumanay, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Marhomat',
		label: 'Marhomat, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Urtaaul',
		label: 'Urtaaul, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kozokdaryo',
		label: 'Kozokdaryo, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Soldatski',
		label: 'Soldatski, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Cangeldi',
		label: 'Cangeldi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Sirin',
		label: 'Sirin, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Müynok',
		label: 'Müynok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kiziltepa',
		label: 'Kiziltepa, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Hamza',
		label: 'Hamza, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Istihon',
		label: 'Istihon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Romitan',
		label: 'Romitan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Konimeh',
		label: 'Konimeh, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Oyokkuduk',
		label: 'Oyokkuduk, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Zomin',
		label: 'Zomin, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Maymanak',
		label: 'Maymanak, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Halkobod',
		label: 'Halkobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Küyluk',
		label: 'Küyluk, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Älät',
		label: 'Älät, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Iskavat',
		label: 'Iskavat, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Dahbed',
		label: 'Dahbed, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Tomdibulok',
		label: 'Tomdibulok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gazli',
		label: 'Gazli, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Dehkanobod',
		label: 'Dehkanobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Safirkon',
		label: 'Safirkon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Uzunkuduk',
		label: 'Uzunkuduk, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Rapkan',
		label: 'Rapkan, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yaninison',
		label: 'Yaninison, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Madaniyat',
		label: 'Madaniyat, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Yanirobod',
		label: 'Yanirobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Nurabad',
		label: 'Nurabad, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Küsrobod',
		label: 'Küsrobod, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Mesekli',
		label: 'Mesekli, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Talimarcon',
		label: 'Talimarcon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Besbulok',
		label: 'Besbulok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Gozgon',
		label: 'Gozgon, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Minbulok',
		label: 'Minbulok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Turpokkala',
		label: 'Turpokkala, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Çingeldi',
		label: 'Çingeldi, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kalkuduk',
		label: 'Kalkuduk, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kizilravbe',
		label: 'Kizilravbe, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Kükça',
		label: 'Kükça, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Korovulbazar',
		label: 'Korovulbazar, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Marcanbulok',
		label: 'Marcanbulok, Uzbekistan',
		type: 'city',
		flagClass: 'fi fi-uz',
		isPopular: false,
	},
	{
		value: 'Vanuatu',
		label: 'Vanuatu',
		type: 'country',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Isangel',
		label: 'Isangel, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Vila',
		label: 'Vila, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Luganville',
		label: 'Luganville, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Sola',
		label: 'Sola, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Lakatoro',
		label: 'Lakatoro, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Norsup',
		label: 'Norsup, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Longana',
		label: 'Longana, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Port Olry',
		label: 'Port Olry, Vanuatu',
		type: 'city',
		flagClass: 'fi fi-vu',
		isPopular: false,
	},
	{
		value: 'Venezuela, Bolivarian Republic of',
		label: 'Venezuela, Bolivarian Republic of',
		type: 'country',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Caracas',
		label: 'Caracas, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Maracaibo',
		label: 'Maracaibo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Acarigua',
		label: 'Acarigua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Valencia',
		label: 'Valencia, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Maracay',
		label: 'Maracay, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Barquisimeto',
		label: 'Barquisimeto, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Antonio de los Altos',
		label: 'San Antonio de los Altos, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ciudad Guayana',
		label: 'Ciudad Guayana, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Puerto la Cruz',
		label: 'Puerto la Cruz, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ciudad Bolívar',
		label: 'Ciudad Bolívar, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Maturín',
		label: 'Maturín, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Mérida',
		label: 'Mérida, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Táriba',
		label: 'Táriba, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Coro',
		label: 'Coro, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Porlamar',
		label: 'Porlamar, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Guarenas',
		label: 'Guarenas, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Guatire',
		label: 'Guatire, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cabudare',
		label: 'Cabudare, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Los Teques',
		label: 'Los Teques, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Charallave',
		label: 'Charallave, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cumaná',
		label: 'Cumaná, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Barinas',
		label: 'Barinas, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Tigre',
		label: 'El Tigre, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Mariara',
		label: 'Mariara, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Carúpano',
		label: 'Carúpano, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cagua',
		label: 'Cagua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Anaco',
		label: 'Anaco, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ciudad Ojeda',
		label: 'Ciudad Ojeda, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Caucagüita',
		label: 'Caucagüita, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Altagracia de Orituco',
		label: 'Altagracia de Orituco, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Carrizal',
		label: 'Carrizal, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Antonio del Táchira',
		label: 'San Antonio del Táchira, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Trujillo',
		label: 'Trujillo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'La Guaira',
		label: 'La Guaira, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Baruta',
		label: 'Baruta, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'La Victoria',
		label: 'La Victoria, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cúa',
		label: 'Cúa, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Carora',
		label: 'Carora, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Rubio',
		label: 'Rubio, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Chacao',
		label: 'Chacao, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Maiquetía',
		label: 'Maiquetía, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Morón',
		label: 'Morón, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Tucupita',
		label: 'Tucupita, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Tacarigua',
		label: 'Tacarigua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Barinitas',
		label: 'Barinitas, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Petare',
		label: 'Petare, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cabimas',
		label: 'Cabimas, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Puerto Cabello',
		label: 'Puerto Cabello, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Magdalena Tequisistlán',
		label: 'Magdalena Tequisistlán, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Limón',
		label: 'El Limón, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Guanare',
		label: 'Guanare, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Catia La Mar',
		label: 'Catia La Mar, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ocumare del Tuy',
		label: 'Ocumare del Tuy, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Valera',
		label: 'Valera, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Calabozo',
		label: 'Calabozo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Fernando',
		label: 'San Fernando, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Punto Fijo',
		label: 'Punto Fijo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Valle de la Pascua',
		label: 'Valle de la Pascua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ayotzingo',
		label: 'Ayotzingo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Araure',
		label: 'Araure, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Felipe',
		label: 'San Felipe, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Benito Juárez',
		label: 'Benito Juárez, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Cafetal',
		label: 'El Cafetal, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Tinaquillo',
		label: 'Tinaquillo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Palo Negro',
		label: 'Palo Negro, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Vigía',
		label: 'El Vigía, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Yaritagua',
		label: 'Yaritagua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Villa de Cura',
		label: 'Villa de Cura, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Ejido',
		label: 'Ejido, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Güigüe',
		label: 'Güigüe, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Los Dos Caminos',
		label: 'Los Dos Caminos, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Puerto Ayacucho',
		label: 'Puerto Ayacucho, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Upata',
		label: 'Upata, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San José de Guanipa',
		label: 'San José de Guanipa, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Hatillo',
		label: 'El Hatillo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'La Dolorita',
		label: 'La Dolorita, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Machiques',
		label: 'Machiques, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Punta Cardón',
		label: 'Punta Cardón, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Villa del Rosario',
		label: 'Villa del Rosario, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Carlos del Zulia',
		label: 'San Carlos del Zulia, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Chivacoa',
		label: 'Chivacoa, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Goaigoaza',
		label: 'Goaigoaza, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Quíbor',
		label: 'Quíbor, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Zaraza',
		label: 'Zaraza, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Atenco',
		label: 'Atenco, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Acatlán',
		label: 'Acatlán, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Joaquín',
		label: 'San Joaquín, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'El Tocuyo',
		label: 'El Tocuyo, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Villa Bruzual',
		label: 'Villa Bruzual, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Juan de Colón',
		label: 'San Juan de Colón, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Caraballeda',
		label: 'Caraballeda, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Guasdualito',
		label: 'Guasdualito, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Santa Rita',
		label: 'Santa Rita, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Villa Rosa',
		label: 'Villa Rosa, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Los Rastrojos',
		label: 'Los Rastrojos, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Las Teyerías',
		label: 'Las Teyerías, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Cantaura',
		label: 'Cantaura, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Nirgua',
		label: 'Nirgua, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Filas de Mariche',
		label: 'Filas de Mariche, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'La Asunción',
		label: 'La Asunción, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'La Fría',
		label: 'La Fría, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Bachaquero',
		label: 'Bachaquero, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'San Cristobal',
		label: 'San Cristobal, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Turmero',
		label: 'Turmero, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Amatlán',
		label: 'Amatlán, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Guacara',
		label: 'Guacara, Venezuela, Bolivarian Republic of',
		type: 'city',
		flagClass: 'fi fi-ve',
		isPopular: false,
	},
	{
		value: 'Vietnam',
		label: 'Vietnam',
		type: 'country',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hanoi',
		label: 'Hanoi, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Thanh Pho Ho Chi Minh',
		label: 'Thanh Pho Ho Chi Minh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ha Noi',
		label: 'Ha Noi, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bac Can',
		label: 'Bac Can, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Nha Trang',
		label: 'Nha Trang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bien Hoa',
		label: 'Bien Hoa, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hai Phong',
		label: 'Hai Phong, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Dha Nang',
		label: 'Dha Nang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hue',
		label: 'Hue, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Vung Tau',
		label: 'Vung Tau, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Can Tho',
		label: 'Can Tho, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Long Xuyen',
		label: 'Long Xuyen, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Da Lat',
		label: 'Da Lat, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ha Dong',
		label: 'Ha Dong, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bac Giang',
		label: 'Bac Giang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bac Ninh',
		label: 'Bac Ninh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hoi An',
		label: 'Hoi An, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Dong Ha',
		label: 'Dong Ha, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Buon Me Thuot',
		label: 'Buon Me Thuot, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ca Mau',
		label: 'Ca Mau, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hoa Binh',
		label: 'Hoa Binh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tuy Hoa',
		label: 'Tuy Hoa, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tay Ninh',
		label: 'Tay Ninh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Phan Thiet',
		label: 'Phan Thiet, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'My Tho',
		label: 'My Tho, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Thanh Hoa',
		label: 'Thanh Hoa, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Vinh',
		label: 'Vinh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Song Be',
		label: 'Song Be, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bien San',
		label: 'Bien San, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ha Tinh',
		label: 'Ha Tinh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Qui Nhon',
		label: 'Qui Nhon, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Nam Dinh',
		label: 'Nam Dinh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Cam Ranh',
		label: 'Cam Ranh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Thai Nguyen',
		label: 'Thai Nguyen, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Soc Trang',
		label: 'Soc Trang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Play Cu',
		label: 'Play Cu, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Bac Lieu',
		label: 'Bac Lieu, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Vinh Long',
		label: 'Vinh Long, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Yen Bai',
		label: 'Yen Bai, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Viet Tri',
		label: 'Viet Tri, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tam Ky',
		label: 'Tam Ky, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hai Duong',
		label: 'Hai Duong, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tra Vinh',
		label: 'Tra Vinh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Thai Binh',
		label: 'Thai Binh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Lao Cai',
		label: 'Lao Cai, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Quang Ngai',
		label: 'Quang Ngai, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tuyen Quang',
		label: 'Tuyen Quang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Dien Bien',
		label: 'Dien Bien, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Dong Xoai',
		label: 'Dong Xoai, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Rach Gia',
		label: 'Rach Gia, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Cam Pha',
		label: 'Cam Pha, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Hong Gai',
		label: 'Hong Gai, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Phan Rang',
		label: 'Phan Rang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Uong Bi',
		label: 'Uong Bi, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Tan An',
		label: 'Tan An, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Chau Doc',
		label: 'Chau Doc, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ben Tre',
		label: 'Ben Tre, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Kon Tum',
		label: 'Kon Tum, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Sa Dec',
		label: 'Sa Dec, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Huong Yen',
		label: 'Huong Yen, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Son Tay',
		label: 'Son Tay, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Cao Bang',
		label: 'Cao Bang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ninh Binh',
		label: 'Ninh Binh, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Ha Giang',
		label: 'Ha Giang, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Lang Son',
		label: 'Lang Son, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Dong Hoi',
		label: 'Dong Hoi, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Phu Ly',
		label: 'Phu Ly, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Son La',
		label: 'Son La, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Vinh Yen',
		label: 'Vinh Yen, Vietnam',
		type: 'city',
		flagClass: 'fi fi-vn',
		isPopular: false,
	},
	{
		value: 'Virgin Islands, British',
		label: 'Virgin Islands, British',
		type: 'country',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'East End-Long Look',
		label: 'East End-Long Look, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'Road Town',
		label: 'Road Town, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'West End',
		label: 'West End, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'Little Harbour',
		label: 'Little Harbour, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'Spanish Town',
		label: 'Spanish Town, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'Settlement',
		label: 'Settlement, Virgin Islands, British',
		type: 'city',
		flagClass: 'fi fi-vg',
		isPopular: false,
	},
	{
		value: 'Virgin Islands, U.S.',
		label: 'Virgin Islands, U.S.',
		type: 'country',
		flagClass: 'fi fi-vi',
		isPopular: false,
	},
	{
		value: 'Wallis and Futuna',
		label: 'Wallis and Futuna',
		type: 'country',
		flagClass: 'fi fi-wf',
		isPopular: false,
	},
	{
		value: "Mata'Utu",
		label: "Mata'Utu, Wallis and Futuna",
		type: 'city',
		flagClass: 'fi fi-wf',
		isPopular: false,
	},
	{
		value: 'Western Sahara',
		label: 'Western Sahara',
		type: 'country',
		flagClass: 'fi fi-eh',
		isPopular: false,
	},
	{
		value: 'ad-Dakhlah',
		label: 'ad-Dakhlah, Western Sahara',
		type: 'city',
		flagClass: 'fi fi-eh',
		isPopular: false,
	},
	{
		value: 'al-´Ayun',
		label: 'al-´Ayun, Western Sahara',
		type: 'city',
		flagClass: 'fi fi-eh',
		isPopular: false,
	},
	{
		value: 'Bu Jaydur',
		label: 'Bu Jaydur, Western Sahara',
		type: 'city',
		flagClass: 'fi fi-eh',
		isPopular: false,
	},
	{
		value: 'as-Samarah',
		label: 'as-Samarah, Western Sahara',
		type: 'city',
		flagClass: 'fi fi-eh',
		isPopular: false,
	},
	{
		value: 'Yemen',
		label: 'Yemen',
		type: 'country',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'San´a',
		label: 'San´a, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: '´Adan',
		label: '´Adan, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Ahwar',
		label: 'Ahwar, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Ta´izz',
		label: 'Ta´izz, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Mukalla',
		label: 'al-Mukalla, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Hudaydah',
		label: 'al-Hudaydah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Ibb',
		label: 'Ibb, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Shibam',
		label: 'Shibam, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Habban',
		label: 'Habban, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Mukha',
		label: 'al-Mukha, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Zinjibar',
		label: 'Zinjibar, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Dhamar',
		label: 'Dhamar, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Ja´ar',
		label: 'Ja´ar, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Marawi´ah',
		label: 'al-Marawi´ah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Sahar',
		label: 'Sahar, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Yarim',
		label: 'Yarim, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Bayda',
		label: 'al-Bayda, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Lahij',
		label: 'Lahij, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Qa´afur',
		label: 'Qa´afur, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Sayhut',
		label: 'Sayhut, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: "Ma'rib",
		label: "Ma'rib, Yemen",
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Hazm',
		label: 'al-Hazm, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Ghaydah',
		label: 'al-Ghaydah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Sayán',
		label: 'Sayán, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'ash-Shahir',
		label: 'ash-Shahir, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Zabid',
		label: 'Zabid, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Bajil',
		label: 'Bajil, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Raydah',
		label: 'Raydah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Hajjah',
		label: 'Hajjah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Dhi Sufal',
		label: 'Dhi Sufal, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Bayt-al-Faqih',
		label: 'Bayt-al-Faqih, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: '´Amran',
		label: '´Amran, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Hawthah',
		label: 'al-Hawthah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: "Shaqra'",
		label: "Shaqra', Yemen",
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'al-Luhayya',
		label: 'al-Luhayya, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'az-Zaydiyah',
		label: 'az-Zaydiyah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Jiblah',
		label: 'Jiblah, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Sha´´ab',
		label: 'Sha´´ab, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: '´Ataq',
		label: '´Ataq, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Mahwit',
		label: 'Mahwit, Yemen',
		type: 'city',
		flagClass: 'fi fi-ye',
		isPopular: false,
	},
	{
		value: 'Zambia',
		label: 'Zambia',
		type: 'country',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chambishi',
		label: 'Chambishi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kitwe',
		label: 'Kitwe, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kafue',
		label: 'Kafue, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Ndola',
		label: 'Ndola, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Livingstone',
		label: 'Livingstone, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chilanga',
		label: 'Chilanga, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chingola',
		label: 'Chingola, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kalulushi',
		label: 'Kalulushi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kabwe',
		label: 'Kabwe, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Theunissen',
		label: 'Theunissen, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mansa',
		label: 'Mansa, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chililabombwe',
		label: 'Chililabombwe, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Monze',
		label: 'Monze, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kasama',
		label: 'Kasama, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Zambezi',
		label: 'Zambezi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Itezhi-Tezhi',
		label: 'Itezhi-Tezhi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kalengwa',
		label: 'Kalengwa, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Solwezi',
		label: 'Solwezi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mufulira',
		label: 'Mufulira, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Choma',
		label: 'Choma, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mazabuka',
		label: 'Mazabuka, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kapiri Mposhi',
		label: 'Kapiri Mposhi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mbala',
		label: 'Mbala, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Petauke',
		label: 'Petauke, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Senanga',
		label: 'Senanga, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Lundazi',
		label: 'Lundazi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Luanshya',
		label: 'Luanshya, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chipata',
		label: 'Chipata, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mongu',
		label: 'Mongu, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kansanshi',
		label: 'Kansanshi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mpika',
		label: 'Mpika, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Nchelenge',
		label: 'Nchelenge, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Samfya',
		label: 'Samfya, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mumbwa',
		label: 'Mumbwa, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Isoka',
		label: 'Isoka, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kalomo',
		label: 'Kalomo, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Maamba',
		label: 'Maamba, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kaoma',
		label: 'Kaoma, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Serenje',
		label: 'Serenje, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Katete',
		label: 'Katete, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Chinsali',
		label: 'Chinsali, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mkushi',
		label: 'Mkushi, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Nakambala',
		label: 'Nakambala, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Kalabo',
		label: 'Kalabo, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mwinilunga',
		label: 'Mwinilunga, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Mpongwe',
		label: 'Mpongwe, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Siavonga',
		label: 'Siavonga, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Limulunga',
		label: 'Limulunga, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Sesheke',
		label: 'Sesheke, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Lusaka',
		label: 'Lusaka, Zambia',
		type: 'city',
		flagClass: 'fi fi-zm',
		isPopular: false,
	},
	{
		value: 'Zimbabwe',
		label: 'Zimbabwe',
		type: 'country',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Harare',
		label: 'Harare, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Beitbridge',
		label: 'Beitbridge, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Bulawayo',
		label: 'Bulawayo, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Mutare',
		label: 'Mutare, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chitungwiza',
		label: 'Chitungwiza, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Zvishavane',
		label: 'Zvishavane, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Gweru',
		label: 'Gweru, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Karoi',
		label: 'Karoi, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Cape Town',
		label: 'Cape Town, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Masvingo',
		label: 'Masvingo, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Marondera',
		label: 'Marondera, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Redcliffe',
		label: 'Redcliffe, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Bindura',
		label: 'Bindura, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Kwekwe',
		label: 'Kwekwe, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chinhoyi',
		label: 'Chinhoyi, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Victoria Falls',
		label: 'Victoria Falls, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Tuli',
		label: 'Tuli, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chimanimani',
		label: 'Chimanimani, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Mvuma',
		label: 'Mvuma, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Hwange',
		label: 'Hwange, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chegutu',
		label: 'Chegutu, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Sakubva',
		label: 'Sakubva, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Rusape',
		label: 'Rusape, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Shurugwi',
		label: 'Shurugwi, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chipinge',
		label: 'Chipinge, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Gwanda',
		label: 'Gwanda, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Mutoko',
		label: 'Mutoko, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Gaths',
		label: 'Gaths, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Kadoma',
		label: 'Kadoma, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Kariba',
		label: 'Kariba, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Norton',
		label: 'Norton, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chiredzi',
		label: 'Chiredzi, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Plumtree',
		label: 'Plumtree, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Mount Darwin',
		label: 'Mount Darwin, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'Chivhu',
		label: 'Chivhu, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'West Nicholson',
		label: 'West Nicholson, Zimbabwe',
		type: 'city',
		flagClass: 'fi fi-zw',
		isPopular: false,
	},
	{
		value: 'United States',
		label: 'United States',
		type: 'country',
		flagClass: 'fi fi-us',
		isPopular: true,
	},
	{
		value: 'Japan',
		label: 'Japan',
		type: 'country',
		flagClass: 'fi fi-jp',
		isPopular: true,
	},
	{
		value: 'United Arab Emirates',
		label: 'United Arab Emirates',
		type: 'country',
		flagClass: 'fi fi-ae',
		isPopular: true,
	},
	{
		value: 'Australia',
		label: 'Australia',
		type: 'country',
		flagClass: 'fi fi-au',
		isPopular: false,
	},
	{
		value: 'Netherlands',
		label: 'Netherlands',
		type: 'country',
		flagClass: 'fi fi-nl',
		isPopular: true,
	},
	{
		value: 'Spain',
		label: 'Spain',
		type: 'country',
		flagClass: 'fi fi-es',
		isPopular: true,
	},
	{
		value: 'Austria',
		label: 'Austria',
		type: 'country',
		flagClass: 'fi fi-at',
		isPopular: true,
	},
	{
		value: 'Czech Republic',
		label: 'Czech Republic',
		type: 'country',
		flagClass: 'fi fi-cz',
		isPopular: true,
	},
	{
		value: 'Greece',
		label: 'Greece',
		type: 'country',
		flagClass: 'fi fi-gr',
		isPopular: true,
	},
	{
		value: 'Sweden',
		label: 'Sweden',
		type: 'country',
		flagClass: 'fi fi-se',
		isPopular: false,
	},
	{
		value: 'Denmark',
		label: 'Denmark',
		type: 'country',
		flagClass: 'fi fi-dk',
		isPopular: false,
	},
	{
		value: 'Norway',
		label: 'Norway',
		type: 'country',
		flagClass: 'fi fi-no',
		isPopular: false,
	},
	{
		value: 'Portugal',
		label: 'Portugal',
		type: 'country',
		flagClass: 'fi fi-pt',
		isPopular: true,
	},
	{
		value: 'Poland',
		label: 'Poland',
		type: 'country',
		flagClass: 'fi fi-pl',
		isPopular: true,
	},
	{
		value: 'Belgium',
		label: 'Belgium',
		type: 'country',
		flagClass: 'fi fi-be',
		isPopular: true,
	},
	{
		value: 'Switzerland',
		label: 'Switzerland',
		type: 'country',
		flagClass: 'fi fi-ch',
		isPopular: true,
	},
	{
		value: 'Thailand',
		label: 'Thailand',
		type: 'country',
		flagClass: 'fi fi-th',
		isPopular: true,
	},
	{
		value: 'Mexico',
		label: 'Mexico',
		type: 'country',
		flagClass: 'fi fi-mx',
		isPopular: true,
	},
];

export default countriesAndCities;
